/* tslint:disable */
/* eslint-disable */
/**
 * PressOne API
 * PressOne API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface ActivateDeveloperBusinessInSchema
 */
export interface ActivateDeveloperBusinessInSchema {
    /**
     * 
     * @type {string}
     * @memberof ActivateDeveloperBusinessInSchema
     */
    'business_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivateDeveloperBusinessInSchema
     */
    'team_size'?: string | null;
}
/**
 * 
 * @export
 * @interface AddScriptItemSchema
 */
export interface AddScriptItemSchema {
    /**
     * 
     * @type {string}
     * @memberof AddScriptItemSchema
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof AddScriptItemSchema
     */
    'text': string;
}
/**
 * 
 * @export
 * @interface AddTagsToCampaignSchema
 */
export interface AddTagsToCampaignSchema {
    /**
     * 
     * @type {Array<number>}
     * @memberof AddTagsToCampaignSchema
     */
    'tag_ids': Array<number>;
}
/**
 * 
 * @export
 * @interface AdditionalAddonPurchaseInSchema
 */
export interface AdditionalAddonPurchaseInSchema {
    /**
     * 
     * @type {number}
     * @memberof AdditionalAddonPurchaseInSchema
     */
    'plan_id': number;
    /**
     * 
     * @type {PaymentMode}
     * @memberof AdditionalAddonPurchaseInSchema
     */
    'payment_mode'?: PaymentMode | null;
    /**
     * 
     * @type {number}
     * @memberof AdditionalAddonPurchaseInSchema
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdditionalAddonPurchaseInSchema
     */
    'coupon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdditionalAddonPurchaseInSchema
     */
    'promotion_code'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdditionalAddonPurchaseInSchema
     */
    'business_id'?: number | null;
    /**
     * 
     * @type {BusinessDataInSchema}
     * @memberof AdditionalAddonPurchaseInSchema
     */
    'business'?: BusinessDataInSchema | null;
    /**
     * 
     * @type {Array<AddressProviderInSchema>}
     * @memberof AdditionalAddonPurchaseInSchema
     */
    'addon': Array<AddressProviderInSchema>;
}


/**
 * 
 * @export
 * @interface AdditionalInternationalNumberPurchaseInSchema
 */
export interface AdditionalInternationalNumberPurchaseInSchema {
    /**
     * 
     * @type {number}
     * @memberof AdditionalInternationalNumberPurchaseInSchema
     */
    'plan_id': number;
    /**
     * 
     * @type {PaymentMode}
     * @memberof AdditionalInternationalNumberPurchaseInSchema
     */
    'payment_mode'?: PaymentMode | null;
    /**
     * 
     * @type {number}
     * @memberof AdditionalInternationalNumberPurchaseInSchema
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdditionalInternationalNumberPurchaseInSchema
     */
    'coupon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdditionalInternationalNumberPurchaseInSchema
     */
    'promotion_code'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdditionalInternationalNumberPurchaseInSchema
     */
    'business_id'?: number | null;
    /**
     * 
     * @type {Array<NumberProviderInSchema>}
     * @memberof AdditionalInternationalNumberPurchaseInSchema
     */
    'numbers': Array<NumberProviderInSchema>;
    /**
     * 
     * @type {BusinessDataInSchema}
     * @memberof AdditionalInternationalNumberPurchaseInSchema
     */
    'business'?: BusinessDataInSchema | null;
}


/**
 * 
 * @export
 * @interface AdditionalNumberPurchaseInSchema
 */
export interface AdditionalNumberPurchaseInSchema {
    /**
     * 
     * @type {number}
     * @memberof AdditionalNumberPurchaseInSchema
     */
    'plan_id': number;
    /**
     * 
     * @type {PaymentMode}
     * @memberof AdditionalNumberPurchaseInSchema
     */
    'payment_mode'?: PaymentMode | null;
    /**
     * 
     * @type {number}
     * @memberof AdditionalNumberPurchaseInSchema
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdditionalNumberPurchaseInSchema
     */
    'coupon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdditionalNumberPurchaseInSchema
     */
    'promotion_code'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdditionalNumberPurchaseInSchema
     */
    'business_id'?: number | null;
}


/**
 * 
 * @export
 * @interface AddonData
 */
export interface AddonData {
}
/**
 * 
 * @export
 * @interface AddonPurchaseInSchema
 */
export interface AddonPurchaseInSchema {
    /**
     * 
     * @type {number}
     * @memberof AddonPurchaseInSchema
     */
    'plan_id': number;
    /**
     * 
     * @type {string}
     * @memberof AddonPurchaseInSchema
     */
    'payment_mode'?: AddonPurchaseInSchemaPaymentModeEnum;
    /**
     * 
     * @type {string}
     * @memberof AddonPurchaseInSchema
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddonPurchaseInSchema
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddonPurchaseInSchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AddonPurchaseInSchema
     */
    'phone_number': string;
    /**
     * 
     * @type {number}
     * @memberof AddonPurchaseInSchema
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddonPurchaseInSchema
     */
    'coupon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddonPurchaseInSchema
     */
    'promotion_code'?: string | null;
    /**
     * 
     * @type {Array<AddressProviderInSchema>}
     * @memberof AddonPurchaseInSchema
     */
    'addon': Array<AddressProviderInSchema>;
    /**
     * 
     * @type {BusinessDataInSchema}
     * @memberof AddonPurchaseInSchema
     */
    'business': BusinessDataInSchema;
}

export const AddonPurchaseInSchemaPaymentModeEnum = {
    Card: 'CARD'
} as const;

export type AddonPurchaseInSchemaPaymentModeEnum = typeof AddonPurchaseInSchemaPaymentModeEnum[keyof typeof AddonPurchaseInSchemaPaymentModeEnum];

/**
 * 
 * @export
 * @interface AddonPurchaseInSchemaV2
 */
export interface AddonPurchaseInSchemaV2 {
    /**
     * 
     * @type {number}
     * @memberof AddonPurchaseInSchemaV2
     */
    'plan_id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AddonPurchaseInSchemaV2
     */
    'payment_mode'?: AddonPurchaseInSchemaV2PaymentModeEnum;
    /**
     * 
     * @type {string}
     * @memberof AddonPurchaseInSchemaV2
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddonPurchaseInSchemaV2
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddonPurchaseInSchemaV2
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AddonPurchaseInSchemaV2
     */
    'phone_number': string;
    /**
     * 
     * @type {number}
     * @memberof AddonPurchaseInSchemaV2
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddonPurchaseInSchemaV2
     */
    'coupon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddonPurchaseInSchemaV2
     */
    'promotion_code'?: string | null;
    /**
     * 
     * @type {BusinessDataInSchema}
     * @memberof AddonPurchaseInSchemaV2
     */
    'business': BusinessDataInSchema;
    /**
     * 
     * @type {Array<AddonsPurchaseDataInSchema>}
     * @memberof AddonPurchaseInSchemaV2
     */
    'addons': Array<AddonsPurchaseDataInSchema>;
}

export const AddonPurchaseInSchemaV2PaymentModeEnum = {
    Card: 'CARD'
} as const;

export type AddonPurchaseInSchemaV2PaymentModeEnum = typeof AddonPurchaseInSchemaV2PaymentModeEnum[keyof typeof AddonPurchaseInSchemaV2PaymentModeEnum];

/**
 * 
 * @export
 * @interface AddonSubscriptionInSchema
 */
export interface AddonSubscriptionInSchema {
    /**
     * 
     * @type {number}
     * @memberof AddonSubscriptionInSchema
     */
    'addon_plan_id': number;
    /**
     * 
     * @type {number}
     * @memberof AddonSubscriptionInSchema
     */
    'business_number_id'?: number | null;
    /**
     * 
     * @type {AddonData}
     * @memberof AddonSubscriptionInSchema
     */
    'addon_data'?: AddonData | null;
}
/**
 * 
 * @export
 * @interface AddonSubscriptionOutSchema
 */
export interface AddonSubscriptionOutSchema {
    /**
     * 
     * @type {string}
     * @memberof AddonSubscriptionOutSchema
     */
    'addon_class': string | null;
    /**
     * 
     * @type {BusinessNumberMinimalOutSchema}
     * @memberof AddonSubscriptionOutSchema
     */
    'business_number'?: BusinessNumberMinimalOutSchema | null;
    /**
     * 
     * @type {SubscriptionPlanOutSchema}
     * @memberof AddonSubscriptionOutSchema
     */
    'subscription_plan': SubscriptionPlanOutSchema;
    /**
     * 
     * @type {number}
     * @memberof AddonSubscriptionOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AddonSubscriptionOutSchema
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AddonSubscriptionOutSchema
     */
    'date_created': string;
}
/**
 * 
 * @export
 * @interface AddonsPurchaseDataInSchema
 */
export interface AddonsPurchaseDataInSchema {
    /**
     * 
     * @type {number}
     * @memberof AddonsPurchaseDataInSchema
     */
    'plan_id': number;
    /**
     * 
     * @type {number}
     * @memberof AddonsPurchaseDataInSchema
     */
    'quantity'?: number;
    /**
     * 
     * @type {Array<AddressProviderInSchema>}
     * @memberof AddonsPurchaseDataInSchema
     */
    'addon': Array<AddressProviderInSchema>;
}
/**
 * 
 * @export
 * @interface AddressFilterSchema
 */
export interface AddressFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof AddressFilterSchema
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressFilterSchema
     */
    'country'?: string | null;
}
/**
 * 
 * @export
 * @interface AddressOutSchema
 */
export interface AddressOutSchema {
    /**
     * 
     * @type {AvailableAddressOutSchema}
     * @memberof AddressOutSchema
     */
    'available_address': AvailableAddressOutSchema;
    /**
     * 
     * @type {number}
     * @memberof AddressOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AddressOutSchema
     */
    'business': number;
    /**
     * 
     * @type {string}
     * @memberof AddressOutSchema
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressOutSchema
     */
    'date_created': string;
    /**
     * 
     * @type {string}
     * @memberof AddressOutSchema
     */
    'scheduled_cancellation_date'?: string | null;
}
/**
 * 
 * @export
 * @interface AddressProviderInSchema
 */
export interface AddressProviderInSchema {
    /**
     * 
     * @type {string}
     * @memberof AddressProviderInSchema
     */
    'address_identifier': string;
    /**
     * 
     * @type {string}
     * @memberof AddressProviderInSchema
     */
    'provider': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AddressStatus = {
    Pending: 'pending',
    Active: 'active',
    Deactivated: 'deactivated'
} as const;

export type AddressStatus = typeof AddressStatus[keyof typeof AddressStatus];


/**
 * 
 * @export
 * @interface AddressStatusUpdateSchema
 */
export interface AddressStatusUpdateSchema {
    /**
     * 
     * @type {AddressStatus}
     * @memberof AddressStatusUpdateSchema
     */
    'status': AddressStatus;
}


/**
 * 
 * @export
 * @interface AdminAddressFilterSchema
 */
export interface AdminAddressFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof AdminAddressFilterSchema
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminAddressFilterSchema
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminAddressFilterSchema
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminAddressFilterSchema
     */
    'business_name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAddressFilterSchema
     */
    'available_address_id'?: number | null;
}
/**
 * 
 * @export
 * @interface AdminAddressOutSchema
 */
export interface AdminAddressOutSchema {
    /**
     * 
     * @type {BusinessMinimalOutSchema}
     * @memberof AdminAddressOutSchema
     */
    'business': BusinessMinimalOutSchema;
    /**
     * 
     * @type {MinimalUserModelOutSchema}
     * @memberof AdminAddressOutSchema
     */
    'user': MinimalUserModelOutSchema;
    /**
     * 
     * @type {AvailableAddressOutSchema}
     * @memberof AdminAddressOutSchema
     */
    'available_address': AvailableAddressOutSchema;
    /**
     * 
     * @type {number}
     * @memberof AdminAddressOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AdminAddressOutSchema
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAddressOutSchema
     */
    'date_created': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAddressOutSchema
     */
    'scheduled_cancellation_date'?: string | null;
}
/**
 * 
 * @export
 * @interface AdminAirtimeTopUpInSchema
 */
export interface AdminAirtimeTopUpInSchema {
    /**
     * 
     * @type {string}
     * @memberof AdminAirtimeTopUpInSchema
     */
    'tenant_id': string;
    /**
     * 
     * @type {number}
     * @memberof AdminAirtimeTopUpInSchema
     */
    'amount': number;
}
/**
 * 
 * @export
 * @interface AdminAvailableAddressFilterSchema
 */
export interface AdminAvailableAddressFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof AdminAvailableAddressFilterSchema
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminAvailableAddressFilterSchema
     */
    'country'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAvailableAddressFilterSchema
     */
    'available_address_id'?: number | null;
}
/**
 * 
 * @export
 * @interface AdminAvailableAddressOutSchema
 */
export interface AdminAvailableAddressOutSchema {
    /**
     * 
     * @type {string}
     * @memberof AdminAvailableAddressOutSchema
     */
    'country': string;
    /**
     * 
     * @type {number}
     * @memberof AdminAvailableAddressOutSchema
     */
    'recipient_count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminAvailableAddressOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AdminAvailableAddressOutSchema
     */
    'provider': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAvailableAddressOutSchema
     */
    'address_identifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAvailableAddressOutSchema
     */
    'address_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminAvailableAddressOutSchema
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAvailableAddressOutSchema
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminAvailableAddressOutSchema
     */
    'line1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminAvailableAddressOutSchema
     */
    'line2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminAvailableAddressOutSchema
     */
    'postal_code'?: string | null;
}
/**
 * 
 * @export
 * @interface AdminListVerificationDocumentOutSchema
 */
export interface AdminListVerificationDocumentOutSchema {
    /**
     * 
     * @type {Array<VerificationDocumentOutSchema>}
     * @memberof AdminListVerificationDocumentOutSchema
     */
    'documents': Array<VerificationDocumentOutSchema>;
    /**
     * 
     * @type {number}
     * @memberof AdminListVerificationDocumentOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AdminListVerificationDocumentOutSchema
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminListVerificationDocumentOutSchema
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminListVerificationDocumentOutSchema
     */
    'personal_email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminListVerificationDocumentOutSchema
     */
    'mobile'?: string | null;
}
/**
 * 
 * @export
 * @interface AdminProvisionNumberInSchema
 */
export interface AdminProvisionNumberInSchema {
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminProvisionNumberInSchema
     */
    'numbers'?: Array<string>;
    /**
     * 
     * @type {BusinessInputSchema}
     * @memberof AdminProvisionNumberInSchema
     */
    'business'?: BusinessInputSchema | null;
    /**
     * 
     * @type {number}
     * @memberof AdminProvisionNumberInSchema
     */
    'business_id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AdminProvisionNumberInSchema
     */
    'payment_reference'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminProvisionNumberInSchema
     */
    'parent_id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminProvisionNumberInSchema
     */
    'recipient_user_id'?: number | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof AdminProvisionNumberInSchema
     */
    'labels'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {string}
     * @memberof AdminProvisionNumberInSchema
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProvisionNumberInSchema
     */
    'provider'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminProvisionNumberInSchema
     */
    'provision_wallet'?: boolean;
    /**
     * 
     * @type {Array<NumberProviderInSchema>}
     * @memberof AdminProvisionNumberInSchema
     */
    'numbers_data': Array<NumberProviderInSchema>;
    /**
     * 
     * @type {number}
     * @memberof AdminProvisionNumberInSchema
     */
    'amount'?: number | null;
}
/**
 * 
 * @export
 * @interface AdminReplacePhoneNumberInSchema
 */
export interface AdminReplacePhoneNumberInSchema {
    /**
     * 
     * @type {string}
     * @memberof AdminReplacePhoneNumberInSchema
     */
    'new_number': string;
}
/**
 * 
 * @export
 * @interface AdminUpdateBalanceInSchema
 */
export interface AdminUpdateBalanceInSchema {
    /**
     * 
     * @type {ChargeAction}
     * @memberof AdminUpdateBalanceInSchema
     */
    'action': ChargeAction;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateBalanceInSchema
     */
    'amount': number;
}


/**
 * 
 * @export
 * @interface AdminUpdateVerificationStatusSchema
 */
export interface AdminUpdateVerificationStatusSchema {
    /**
     * 
     * @type {VerificationDocumentStatus}
     * @memberof AdminUpdateVerificationStatusSchema
     */
    'status': VerificationDocumentStatus;
}


/**
 * 
 * @export
 * @interface AdminVerificationDocumentFilterSchema
 */
export interface AdminVerificationDocumentFilterSchema {
    /**
     * 
     * @type {boolean}
     * @memberof AdminVerificationDocumentFilterSchema
     */
    'verified'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVerificationDocumentFilterSchema
     */
    'is_go_global'?: boolean | null;
}
/**
 * 
 * @export
 * @interface AdminVerificationDocumentOutSchema
 */
export interface AdminVerificationDocumentOutSchema {
    /**
     * 
     * @type {MinimalUserVerificationOutSchema}
     * @memberof AdminVerificationDocumentOutSchema
     */
    'user': MinimalUserVerificationOutSchema;
    /**
     * 
     * @type {number}
     * @memberof AdminVerificationDocumentOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AdminVerificationDocumentOutSchema
     */
    'identity_type': string;
    /**
     * 
     * @type {string}
     * @memberof AdminVerificationDocumentOutSchema
     */
    'document': string;
    /**
     * 
     * @type {string}
     * @memberof AdminVerificationDocumentOutSchema
     */
    'id_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminVerificationDocumentOutSchema
     */
    'issue_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminVerificationDocumentOutSchema
     */
    'expiry_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminVerificationDocumentOutSchema
     */
    'status'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminVerificationDocumentOutSchema
     */
    'is_delegated'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminVerificationDocumentOutSchema
     */
    'file_name'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentCampaignMinimalSchema
 */
export interface AgentCampaignMinimalSchema {
    /**
     * 
     * @type {number}
     * @memberof AgentCampaignMinimalSchema
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AgentCampaignMinimalSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentCampaignMinimalSchema
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof AgentCampaignMinimalSchema
     */
    'start_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentCampaignMinimalSchema
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AgentCampaignMinimalSchema
     */
    'total_calls': number;
    /**
     * 
     * @type {number}
     * @memberof AgentCampaignMinimalSchema
     */
    'total_contacts': number;
    /**
     * 
     * @type {number}
     * @memberof AgentCampaignMinimalSchema
     */
    'answered_calls': number;
}
/**
 * 
 * @export
 * @interface AgentContactCountSchema
 */
export interface AgentContactCountSchema {
    /**
     * 
     * @type {number}
     * @memberof AgentContactCountSchema
     */
    'agent_id': number;
    /**
     * 
     * @type {number}
     * @memberof AgentContactCountSchema
     */
    'contact_count': number;
}
/**
 * Schema for distributing contacts to agents in a campaign.  Attributes:     agent_id (int): The ID of the agent.     contact_count (int): The number of contacts assigned to the agent.
 * @export
 * @interface AgentContactDistributionSchema
 */
export interface AgentContactDistributionSchema {
    /**
     * 
     * @type {number}
     * @memberof AgentContactDistributionSchema
     */
    'agent_id': number;
    /**
     * 
     * @type {number}
     * @memberof AgentContactDistributionSchema
     */
    'contact_count': number;
}
/**
 * 
 * @export
 * @interface AgentRankingOutSchema
 */
export interface AgentRankingOutSchema {
    /**
     * 
     * @type {number}
     * @memberof AgentRankingOutSchema
     */
    'agent_id': number;
    /**
     * 
     * @type {string}
     * @memberof AgentRankingOutSchema
     */
    'agent_name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentRankingOutSchema
     */
    'agent_role': string;
    /**
     * 
     * @type {number}
     * @memberof AgentRankingOutSchema
     */
    'total_contacts': number;
    /**
     * 
     * @type {number}
     * @memberof AgentRankingOutSchema
     */
    'total_calls': number;
    /**
     * 
     * @type {number}
     * @memberof AgentRankingOutSchema
     */
    'answered_calls': number;
    /**
     * 
     * @type {number}
     * @memberof AgentRankingOutSchema
     */
    'time_on_calls': number;
    /**
     * 
     * @type {number}
     * @memberof AgentRankingOutSchema
     */
    'conversion_rate': number;
    /**
     * 
     * @type {number}
     * @memberof AgentRankingOutSchema
     */
    'converted': number;
}
/**
 * 
 * @export
 * @interface AllCampaignsSummaryReport
 */
export interface AllCampaignsSummaryReport {
    /**
     * 
     * @type {number}
     * @memberof AllCampaignsSummaryReport
     */
    'total_contacts': number;
    /**
     * 
     * @type {number}
     * @memberof AllCampaignsSummaryReport
     */
    'total_calls_made': number;
    /**
     * 
     * @type {number}
     * @memberof AllCampaignsSummaryReport
     */
    'answered_calls': number;
    /**
     * 
     * @type {number}
     * @memberof AllCampaignsSummaryReport
     */
    'success_rate': number;
}
/**
 * 
 * @export
 * @interface ApiKeysInSchema
 */
export interface ApiKeysInSchema {
    /**
     * 
     * @type {string}
     * @memberof ApiKeysInSchema
     */
    'otp'?: string | null;
    /**
     * 
     * @type {ApiKeysType}
     * @memberof ApiKeysInSchema
     */
    'type'?: ApiKeysType;
}


/**
 * 
 * @export
 * @interface ApiKeysOutSchema
 */
export interface ApiKeysOutSchema {
    /**
     * 
     * @type {string}
     * @memberof ApiKeysOutSchema
     */
    'secret_key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiKeysOutSchema
     */
    'public_key'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiKeysOutSchema
     */
    'is_active'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ApiKeysType = {
    PublicKey: 'public_key',
    SecretKey: 'secret_key'
} as const;

export type ApiKeysType = typeof ApiKeysType[keyof typeof ApiKeysType];


/**
 * Schema for assigning agents to a campaign.  Attributes:     agent_ids (list[int]): list of IDs representing     the agents to be assigned to the campaign.
 * @export
 * @interface AssignAgentsToCampaignSchema
 */
export interface AssignAgentsToCampaignSchema {
    /**
     * 
     * @type {Array<number>}
     * @memberof AssignAgentsToCampaignSchema
     */
    'agent_ids': Array<number>;
}
/**
 * Schema for assigning contacts to agents within a campaign.  Attributes:     distributions (list[AgentContactDistributionSchema]):     list of distributions defining the allocation of contacts to agents.
 * @export
 * @interface AssignContactsToAgentsSchema
 */
export interface AssignContactsToAgentsSchema {
    /**
     * 
     * @type {Array<AgentContactDistributionSchema>}
     * @memberof AssignContactsToAgentsSchema
     */
    'distributions': Array<AgentContactDistributionSchema>;
}
/**
 * 
 * @export
 * @interface AuditLogFilterSchema
 */
export interface AuditLogFilterSchema {
    /**
     * 
     * @type {RequestAction}
     * @memberof AuditLogFilterSchema
     */
    'action'?: RequestAction | null;
    /**
     * 
     * @type {string}
     * @memberof AuditLogFilterSchema
     */
    'tenant_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AuditLogFilterSchema
     */
    'staff_id'?: number | null;
}


/**
 * 
 * @export
 * @interface AuditLogMinimalOutSchema
 */
export interface AuditLogMinimalOutSchema {
    /**
     * 
     * @type {number}
     * @memberof AuditLogMinimalOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AuditLogMinimalOutSchema
     */
    'summary': string;
}
/**
 * 
 * @export
 * @interface AuditLogOutSchema
 */
export interface AuditLogOutSchema {
    /**
     * 
     * @type {string}
     * @memberof AuditLogOutSchema
     */
    'business_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditLogOutSchema
     */
    'staff_full_name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AuditLogOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {object}
     * @memberof AuditLogOutSchema
     */
    'data': object;
    /**
     * 
     * @type {number}
     * @memberof AuditLogOutSchema
     */
    'staff'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AuditLogOutSchema
     */
    'action': string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogOutSchema
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditLogOutSchema
     */
    'summary': string;
}
/**
 * 
 * @export
 * @interface AvailableAddressFilterSchema
 */
export interface AvailableAddressFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof AvailableAddressFilterSchema
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableAddressFilterSchema
     */
    'country'?: string | null;
}
/**
 * 
 * @export
 * @interface AvailableAddressInSchema
 */
export interface AvailableAddressInSchema {
    /**
     * 
     * @type {string}
     * @memberof AvailableAddressInSchema
     */
    'provider': string;
    /**
     * 
     * @type {string}
     * @memberof AvailableAddressInSchema
     */
    'address_identifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableAddressInSchema
     */
    'address_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableAddressInSchema
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof AvailableAddressInSchema
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof AvailableAddressInSchema
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof AvailableAddressInSchema
     */
    'line1': string;
    /**
     * 
     * @type {string}
     * @memberof AvailableAddressInSchema
     */
    'line2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableAddressInSchema
     */
    'postal_code'?: string | null;
}
/**
 * 
 * @export
 * @interface AvailableAddressOutSchema
 */
export interface AvailableAddressOutSchema {
    /**
     * 
     * @type {string}
     * @memberof AvailableAddressOutSchema
     */
    'country': string;
    /**
     * 
     * @type {number}
     * @memberof AvailableAddressOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableAddressOutSchema
     */
    'provider': string;
    /**
     * 
     * @type {string}
     * @memberof AvailableAddressOutSchema
     */
    'address_identifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableAddressOutSchema
     */
    'address_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableAddressOutSchema
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof AvailableAddressOutSchema
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableAddressOutSchema
     */
    'line1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableAddressOutSchema
     */
    'line2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableAddressOutSchema
     */
    'postal_code'?: string | null;
}
/**
 * 
 * @export
 * @interface AvailableCountryFilterSchema
 */
export interface AvailableCountryFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof AvailableCountryFilterSchema
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableCountryFilterSchema
     */
    'requirements'?: string | null;
}
/**
 * 
 * @export
 * @interface AvailableCountryOutSchema
 */
export interface AvailableCountryOutSchema {
    /**
     * 
     * @type {string}
     * @memberof AvailableCountryOutSchema
     */
    'country_number_code': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AvailableCountryOutSchema
     */
    'requirements'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof AvailableCountryOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableCountryOutSchema
     */
    'country'?: string;
}
/**
 * NOTE   To fully support a Country, update this list,  create AvailableCountry, update SUPPORTED_INTERNATIONAL_COUNTRIES  & SUPPORTED_INTERNATIONAL_COUNTRY_CODES  Create SubscriptionPlans for that country
 * @export
 * @enum {string}
 */

export const AvailableNumberCountryCode = {
    Ng: 'NG',
    Gb: 'GB',
    Us: 'US',
    Ca: 'CA',
    Ke: 'KE',
    Gh: 'GH',
    Pr: 'PR',
    Za: 'ZA',
    Cn: 'CN',
    Jp: 'JP',
    Th: 'TH',
    Cz: 'CZ',
    Fi: 'FI',
    Nl: 'NL',
    Pl: 'PL',
    Br: 'BR',
    Au: 'AU',
    Be: 'BE',
    Se: 'SE',
    Ie: 'IE',
    Mx: 'MX'
} as const;

export type AvailableNumberCountryCode = typeof AvailableNumberCountryCode[keyof typeof AvailableNumberCountryCode];


/**
 * 
 * @export
 * @interface AvailableNumberFilterSchema
 */
export interface AvailableNumberFilterSchema {
    /**
     * NOTE   To fully support a Country, update this list,  create AvailableCountry, update SUPPORTED_INTERNATIONAL_COUNTRIES  & SUPPORTED_INTERNATIONAL_COUNTRY_CODES  Create SubscriptionPlans for that country
     * @type {string}
     * @memberof AvailableNumberFilterSchema
     */
    'country_code'?: AvailableNumberFilterSchemaCountryCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof AvailableNumberFilterSchema
     */
    'number_type'?: AvailableNumberFilterSchemaNumberTypeEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof AvailableNumberFilterSchema
     */
    'is_special_number'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AvailableNumberFilterSchema
     */
    'is_toll_free'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableNumberFilterSchema
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableNumberFilterSchema
     */
    'provider'?: string | null;
}

export const AvailableNumberFilterSchemaCountryCodeEnum = {
    Ng: 'NG',
    Gb: 'GB',
    Us: 'US',
    Ca: 'CA',
    Ke: 'KE',
    Gh: 'GH',
    Pr: 'PR',
    Za: 'ZA',
    Cn: 'CN',
    Jp: 'JP',
    Th: 'TH',
    Cz: 'CZ',
    Fi: 'FI',
    Nl: 'NL',
    Pl: 'PL',
    Br: 'BR',
    Au: 'AU',
    Be: 'BE',
    Se: 'SE',
    Ie: 'IE',
    Mx: 'MX'
} as const;

export type AvailableNumberFilterSchemaCountryCodeEnum = typeof AvailableNumberFilterSchemaCountryCodeEnum[keyof typeof AvailableNumberFilterSchemaCountryCodeEnum];
export const AvailableNumberFilterSchemaNumberTypeEnum = {
    Mobile: 'mobile',
    Landline: 'landline'
} as const;

export type AvailableNumberFilterSchemaNumberTypeEnum = typeof AvailableNumberFilterSchemaNumberTypeEnum[keyof typeof AvailableNumberFilterSchemaNumberTypeEnum];

/**
 * 
 * @export
 * @interface AvailableNumberOutSchema
 */
export interface AvailableNumberOutSchema {
    /**
     * 
     * @type {string}
     * @memberof AvailableNumberOutSchema
     */
    'country_code': string;
    /**
     * 
     * @type {string}
     * @memberof AvailableNumberOutSchema
     */
    'phone_number': string;
    /**
     * 
     * @type {string}
     * @memberof AvailableNumberOutSchema
     */
    'provider': string;
    /**
     * 
     * @type {string}
     * @memberof AvailableNumberOutSchema
     */
    'state'?: string | null;
}
/**
 * 
 * @export
 * @interface BasePartnerUserInSchema
 */
export interface BasePartnerUserInSchema {
    /**
     * 
     * @type {string}
     * @memberof BasePartnerUserInSchema
     */
    'mobile': string;
}
/**
 * 
 * @export
 * @interface BaseSubscriptionPlanFilterSchema
 */
export interface BaseSubscriptionPlanFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof BaseSubscriptionPlanFilterSchema
     */
    'search'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const BlobType = {
    VoiceScript: 'voice_script',
    Document: 'document',
    TextToSpeech: 'text_to_speech'
} as const;

export type BlobType = typeof BlobType[keyof typeof BlobType];


/**
 * 
 * @export
 * @interface BlogFilterSchema
 */
export interface BlogFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof BlogFilterSchema
     */
    'title'?: string | null;
}
/**
 * 
 * @export
 * @interface BlogInSchema
 */
export interface BlogInSchema {
    /**
     * 
     * @type {string}
     * @memberof BlogInSchema
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof BlogInSchema
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof BlogInSchema
     */
    'image_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BlogInSchema
     */
    'link': string;
}
/**
 * 
 * @export
 * @interface BlogOutSchema
 */
export interface BlogOutSchema {
    /**
     * 
     * @type {string}
     * @memberof BlogOutSchema
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof BlogOutSchema
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BlogOutSchema
     */
    'image_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BlogOutSchema
     */
    'link': string;
    /**
     * 
     * @type {string}
     * @memberof BlogOutSchema
     */
    'date_created': string;
}
/**
 * 
 * @export
 * @interface BulkAvailableAddressInSchema
 */
export interface BulkAvailableAddressInSchema {
    /**
     * 
     * @type {Array<AvailableAddressInSchema>}
     * @memberof BulkAvailableAddressInSchema
     */
    'addresses': Array<AvailableAddressInSchema>;
}
/**
 * 
 * @export
 * @interface BulkDeleteContactSchema
 */
export interface BulkDeleteContactSchema {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkDeleteContactSchema
     */
    'contact_ids'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDeleteContactSchema
     */
    'delete_all'?: boolean;
}
/**
 * 
 * @export
 * @interface BulkTeamMemberInSchema
 */
export interface BulkTeamMemberInSchema {
    /**
     * 
     * @type {Array<MinimalTeamMemberSchema>}
     * @memberof BulkTeamMemberInSchema
     */
    'data': Array<MinimalTeamMemberSchema>;
}
/**
 * 
 * @export
 * @interface BulkUploadContactSchema
 */
export interface BulkUploadContactSchema {
    /**
     * 
     * @type {Array<UserContactInSchema>}
     * @memberof BulkUploadContactSchema
     */
    'contacts': Array<UserContactInSchema>;
    /**
     * 
     * @type {SingleMatchAction}
     * @memberof BulkUploadContactSchema
     */
    'single_match_action'?: SingleMatchAction;
    /**
     * 
     * @type {MultiMatchResolutionStrategy}
     * @memberof BulkUploadContactSchema
     */
    'multiple_match_resolution_strategy'?: MultiMatchResolutionStrategy;
}


/**
 * 
 * @export
 * @interface BusinessBalanceOutSchema
 */
export interface BusinessBalanceOutSchema {
    /**
     * 
     * @type {number}
     * @memberof BusinessBalanceOutSchema
     */
    'balance': number;
}
/**
 * 
 * @export
 * @interface BusinessCallLogDetailedOutSchema
 */
export interface BusinessCallLogDetailedOutSchema {
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogDetailedOutSchema
     */
    'caller_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogDetailedOutSchema
     */
    'recording_url'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessCallLogDetailedOutSchema
     */
    'has_call_note'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogDetailedOutSchema
     */
    'date_created': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogDetailedOutSchema
     */
    'last_modified': string;
    /**
     * 
     * @type {number}
     * @memberof BusinessCallLogDetailedOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogDetailedOutSchema
     */
    'caller_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BusinessCallLogDetailedOutSchema
     */
    'duration_secs': number;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogDetailedOutSchema
     */
    'start_time': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogDetailedOutSchema
     */
    'sip_call_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessCallLogDetailedOutSchema
     */
    'is_missed_call'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessCallLogDetailedOutSchema
     */
    'has_voice_mail'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessCallLogDetailedOutSchema
     */
    'is_forwarded_call'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessCallLogDetailedOutSchema
     */
    'is_answered'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BusinessCallLogDetailedOutSchema
     */
    'user'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogDetailedOutSchema
     */
    'contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogDetailedOutSchema
     */
    'end_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogDetailedOutSchema
     */
    'answer_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogDetailedOutSchema
     */
    'recipient_number'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessCallLogDetailedOutSchema
     */
    'is_dialed'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BusinessCallLogDetailedOutSchema
     */
    'cost': number;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogDetailedOutSchema
     */
    'receiver_name': string;
}
/**
 * 
 * @export
 * @interface BusinessCallLogFilterSchema
 */
export interface BusinessCallLogFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogFilterSchema
     */
    'start_time_range'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogFilterSchema
     */
    'date_created_range'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogFilterSchema
     */
    'phone_number'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessCallLogFilterSchema
     */
    'with_note'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessCallLogFilterSchema
     */
    'is_answered'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof BusinessCallLogFilterSchema
     */
    'user_id'?: number | null;
    /**
     * 
     * @type {CallType}
     * @memberof BusinessCallLogFilterSchema
     */
    'kind'?: CallType | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogFilterSchema
     */
    'call_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogFilterSchema
     */
    'duration_range'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BusinessCallLogFilterSchema
     */
    'business_number_id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogFilterSchema
     */
    'caller_id'?: string | null;
}


/**
 * 
 * @export
 * @interface BusinessCallLogOutSchema
 */
export interface BusinessCallLogOutSchema {
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogOutSchema
     */
    'caller_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogOutSchema
     */
    'recording_url'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessCallLogOutSchema
     */
    'has_call_note'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogOutSchema
     */
    'date_created': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogOutSchema
     */
    'last_modified': string;
    /**
     * 
     * @type {number}
     * @memberof BusinessCallLogOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogOutSchema
     */
    'caller_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BusinessCallLogOutSchema
     */
    'duration_secs': number;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogOutSchema
     */
    'start_time': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogOutSchema
     */
    'sip_call_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessCallLogOutSchema
     */
    'is_missed_call'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessCallLogOutSchema
     */
    'has_voice_mail'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessCallLogOutSchema
     */
    'is_forwarded_call'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessCallLogOutSchema
     */
    'is_answered'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BusinessCallLogOutSchema
     */
    'user'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogOutSchema
     */
    'contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogOutSchema
     */
    'end_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogOutSchema
     */
    'answer_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessCallLogOutSchema
     */
    'recipient_number'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessCallLogOutSchema
     */
    'is_dialed'?: boolean;
}
/**
 * 
 * @export
 * @interface BusinessDataInSchema
 */
export interface BusinessDataInSchema {
    /**
     * 
     * @type {string}
     * @memberof BusinessDataInSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessDataInSchema
     */
    'business_use_case'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessDataInSchema
     */
    'is_go_global'?: boolean | null;
}
/**
 * 
 * @export
 * @interface BusinessFilterSchema
 */
export interface BusinessFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof BusinessFilterSchema
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface BusinessInputSchema
 */
export interface BusinessInputSchema {
    /**
     * 
     * @type {string}
     * @memberof BusinessInputSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessInputSchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessInputSchema
     */
    'size': string;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessInputSchema
     */
    'is_go_global'?: boolean | null;
}
/**
 * 
 * @export
 * @interface BusinessMinimalOutSchema
 */
export interface BusinessMinimalOutSchema {
    /**
     * 
     * @type {string}
     * @memberof BusinessMinimalOutSchema
     */
    'global_id': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessMinimalOutSchema
     */
    'invitation_id': string;
    /**
     * 
     * @type {number}
     * @memberof BusinessMinimalOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessMinimalOutSchema
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof BusinessMinimalOutSchema
     */
    'owner': number;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessMinimalOutSchema
     */
    'verified'?: boolean;
}
/**
 * 
 * @export
 * @interface BusinessNumberBusinessOutSchema
 */
export interface BusinessNumberBusinessOutSchema {
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberBusinessOutSchema
     */
    'country_code': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberBusinessOutSchema
     */
    'label'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BusinessNumberBusinessOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberBusinessOutSchema
     */
    'phone_number': string;
    /**
     * 
     * @type {number}
     * @memberof BusinessNumberBusinessOutSchema
     */
    'plan'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberBusinessOutSchema
     */
    'reclaim_date'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessNumberBusinessOutSchema
     */
    'is_retained'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberBusinessOutSchema
     */
    'date_created': string;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessNumberBusinessOutSchema
     */
    'has_disabled_incoming_call'?: boolean;
    /**
     * 
     * @type {BusinessMinimalOutSchema}
     * @memberof BusinessNumberBusinessOutSchema
     */
    'business': BusinessMinimalOutSchema;
}
/**
 * 
 * @export
 * @interface BusinessNumberExtensionLimitOutSchema
 */
export interface BusinessNumberExtensionLimitOutSchema {
    /**
     * 
     * @type {number}
     * @memberof BusinessNumberExtensionLimitOutSchema
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberExtensionLimitOutSchema
     */
    'phone_number': string;
    /**
     * 
     * @type {number}
     * @memberof BusinessNumberExtensionLimitOutSchema
     */
    'assigned_extensions': number;
    /**
     * 
     * @type {number}
     * @memberof BusinessNumberExtensionLimitOutSchema
     */
    'extension_limit': number;
}
/**
 * 
 * @export
 * @interface BusinessNumberExtensionPaymentLinkFilterSchema
 */
export interface BusinessNumberExtensionPaymentLinkFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberExtensionPaymentLinkFilterSchema
     */
    'business_number': string;
    /**
     * 
     * @type {number}
     * @memberof BusinessNumberExtensionPaymentLinkFilterSchema
     */
    'quantity'?: number;
}
/**
 * 
 * @export
 * @interface BusinessNumberMinimalOutSchema
 */
export interface BusinessNumberMinimalOutSchema {
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberMinimalOutSchema
     */
    'country_code': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberMinimalOutSchema
     */
    'label'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BusinessNumberMinimalOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberMinimalOutSchema
     */
    'phone_number': string;
    /**
     * 
     * @type {number}
     * @memberof BusinessNumberMinimalOutSchema
     */
    'plan'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberMinimalOutSchema
     */
    'reclaim_date'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessNumberMinimalOutSchema
     */
    'is_retained'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberMinimalOutSchema
     */
    'date_created': string;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessNumberMinimalOutSchema
     */
    'has_disabled_incoming_call'?: boolean;
}
/**
 * 
 * @export
 * @interface BusinessNumberOutSchema
 */
export interface BusinessNumberOutSchema {
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberOutSchema
     */
    'verification_status': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberOutSchema
     */
    'label'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberOutSchema
     */
    'country_code': string;
    /**
     * 
     * @type {number}
     * @memberof BusinessNumberOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberOutSchema
     */
    'phone_number': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberOutSchema
     */
    'forward_calls_to_number'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessNumberOutSchema
     */
    'verified'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BusinessNumberOutSchema
     */
    'parent_number'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BusinessNumberOutSchema
     */
    'max_receivers'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessNumberOutSchema
     */
    'is_primary'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessNumberOutSchema
     */
    'has_greetings_added'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BusinessNumberOutSchema
     */
    'plan'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberOutSchema
     */
    'reclaim_date'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessNumberOutSchema
     */
    'is_retained'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberOutSchema
     */
    'date_created': string;
}
/**
 * Schema for business number information in customer detail out schema
 * @export
 * @interface BusinessNumberSchema
 */
export interface BusinessNumberSchema {
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberSchema
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberSchema
     */
    'business': string;
    /**
     * 
     * @type {ProfileRole}
     * @memberof BusinessNumberSchema
     */
    'role'?: ProfileRole | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberSchema
     */
    'date_created': string;
}


/**
 * 
 * @export
 * @interface BusinessNumberSubscription
 */
export interface BusinessNumberSubscription {
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberSubscription
     */
    'number_type': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberSubscription
     */
    'country_code': string;
    /**
     * 
     * @type {number}
     * @memberof BusinessNumberSubscription
     */
    'receivers_count': number;
    /**
     * 
     * @type {SubscriptionPlanOutSchema}
     * @memberof BusinessNumberSubscription
     */
    'plan'?: SubscriptionPlanOutSchema | null;
    /**
     * 
     * @type {number}
     * @memberof BusinessNumberSubscription
     */
    'id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BusinessNumberSubscription
     */
    'max_receivers'?: number;
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberSubscription
     */
    'reclaim_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberSubscription
     */
    'phone_number': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessNumberSubscription
     */
    'label'?: string | null;
}
/**
 * 
 * @export
 * @interface BusinessOutSchema
 */
export interface BusinessOutSchema {
    /**
     * 
     * @type {number}
     * @memberof BusinessOutSchema
     */
    'balance': number;
    /**
     * 
     * @type {object}
     * @memberof BusinessOutSchema
     */
    'free_trial_data'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessOutSchema
     */
    'is_partner_customer'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessOutSchema
     */
    'has_filled_engagement_form'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BusinessOutSchema
     */
    'global_id': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessOutSchema
     */
    'invitation_id': string;
    /**
     * 
     * @type {number}
     * @memberof BusinessOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessOutSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessOutSchema
     */
    'business_timezone'?: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessOutSchema
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessOutSchema
     */
    'address': string;
    /**
     * 
     * @type {number}
     * @memberof BusinessOutSchema
     */
    'owner': number;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessOutSchema
     */
    'verified'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessOutSchema
     */
    'is_go_global'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessOutSchema
     */
    'billing_requires_attention'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessOutSchema
     */
    'has_requirement_info_pending'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessOutSchema
     */
    'has_provisioned_first_number'?: boolean;
}
/**
 * 
 * @export
 * @interface BusinessSubscriptionOutSchema
 */
export interface BusinessSubscriptionOutSchema {
    /**
     * 
     * @type {string}
     * @memberof BusinessSubscriptionOutSchema
     */
    'term'?: string | null;
    /**
     * 
     * @type {Array<BusinessNumberSubscription>}
     * @memberof BusinessSubscriptionOutSchema
     */
    'numbers'?: Array<BusinessNumberSubscription>;
    /**
     * 
     * @type {string}
     * @memberof BusinessSubscriptionOutSchema
     */
    'subscription_status': string;
    /**
     * 
     * @type {string}
     * @memberof BusinessSubscriptionOutSchema
     */
    'status_expiration_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BusinessSubscriptionOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BusinessSubscriptionOutSchema
     */
    'business': number;
    /**
     * 
     * @type {number}
     * @memberof BusinessSubscriptionOutSchema
     */
    'billing_day'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessSubscriptionOutSchema
     */
    'auto_charge_on_invoice_create'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BusinessSubscriptionOutSchema
     */
    'quantity'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessSubscriptionOutSchema
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BusinessSubscriptionOutSchema
     */
    'next_billing_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessSubscriptionOutSchema
     */
    'scheduled_cancellation_date'?: string | null;
}
/**
 * Enum representing the status of a business subscription.  Attributes:     ACTIVE: The business has no pending invoice.     UPCOMING: An invoice is about to be issued for the business.     PENDING: The invoice is issued but not yet past due (less than 21 days).     PAST_DUE: The invoice has been issued for the business but not                  paid for 21 days.     PAUSED: The business decided to stop the subscription but pay a packing                 fee for their number.     INACTIVE: The business subscription is cancelled.
 * @export
 * @enum {string}
 */

export const BusinessSubscriptionStatus = {
    Active: 'active',
    UpcomingRenewal: 'upcoming_renewal',
    Pending: 'pending',
    PastDue: 'past_due',
    Inactive: 'inactive',
    Paused: 'paused',
    GracePeriod: 'grace_period',
    RecoveryMode: 'recovery_mode',
    DataAccessMode: 'data_access_mode',
    Expired: 'expired'
} as const;

export type BusinessSubscriptionStatus = typeof BusinessSubscriptionStatus[keyof typeof BusinessSubscriptionStatus];


/**
 * 
 * @export
 * @interface BusinessUpdateSchema
 */
export interface BusinessUpdateSchema {
    /**
     * 
     * @type {string}
     * @memberof BusinessUpdateSchema
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessUpdateSchema
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessUpdateSchema
     */
    'address'?: string | null;
}
/**
 * 
 * @export
 * @interface CallCenterConfigurationInSchema
 */
export interface CallCenterConfigurationInSchema {
    /**
     * 
     * @type {string}
     * @memberof CallCenterConfigurationInSchema
     */
    'id': string;
    /**
     * 
     * @type {CallCenterStrategy}
     * @memberof CallCenterConfigurationInSchema
     */
    'strategy'?: CallCenterStrategy;
    /**
     * 
     * @type {Array<number>}
     * @memberof CallCenterConfigurationInSchema
     */
    'call_center_users': Array<number>;
}


/**
 * 
 * @export
 * @interface CallCenterOutSchema
 */
export interface CallCenterOutSchema {
    /**
     * 
     * @type {Array<number>}
     * @memberof CallCenterOutSchema
     */
    'call_center_users': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof CallCenterOutSchema
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CallCenterOutSchema
     */
    'strategy'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CallCenterStrategy = {
    RingAll: 'ring-all',
    LongestIdleAgent: 'longest-idle-agent',
    RoundRobin: 'round-robin',
    TopDown: 'top-down',
    AgentWithLeastTalkTime: 'agent-with-least-talk-time',
    AgentWithFewestCalls: 'agent-with-fewest-calls',
    SequentiallyByAgentOrder: 'sequentially-by-agent-order',
    Random: 'random',
    RingProgressively: 'ring-progressively'
} as const;

export type CallCenterStrategy = typeof CallCenterStrategy[keyof typeof CallCenterStrategy];


/**
 * 
 * @export
 * @enum {string}
 */

export const CallDestinationKind = {
    Ivr: 'ivr',
    RingGroup: 'ring_group',
    CallCenter: 'call_center'
} as const;

export type CallDestinationKind = typeof CallDestinationKind[keyof typeof CallDestinationKind];


/**
 * 
 * @export
 * @interface CallLogFilterSchema
 */
export interface CallLogFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof CallLogFilterSchema
     */
    'start_time_range'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CallLogFilterSchema
     */
    'date_created_range'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CallLogFilterSchema
     */
    'phone_number'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CallLogFilterSchema
     */
    'with_note'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CallLogFilterSchema
     */
    'is_answered'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof CallLogFilterSchema
     */
    'user_id'?: number | null;
    /**
     * 
     * @type {CallType}
     * @memberof CallLogFilterSchema
     */
    'kind'?: CallType | null;
    /**
     * 
     * @type {string}
     * @memberof CallLogFilterSchema
     */
    'call_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CallLogFilterSchema
     */
    'duration_range'?: string | null;
}


/**
 * 
 * @export
 * @interface CallLogMinimalOutSchema
 */
export interface CallLogMinimalOutSchema {
    /**
     * 
     * @type {number}
     * @memberof CallLogMinimalOutSchema
     */
    'cost': number;
    /**
     * 
     * @type {number}
     * @memberof CallLogMinimalOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CallLogMinimalOutSchema
     */
    'caller_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CallLogMinimalOutSchema
     */
    'duration_secs': number;
    /**
     * 
     * @type {string}
     * @memberof CallLogMinimalOutSchema
     */
    'start_time': string;
    /**
     * 
     * @type {string}
     * @memberof CallLogMinimalOutSchema
     */
    'end_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CallLogMinimalOutSchema
     */
    'context'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CallLogMinimalOutSchema
     */
    'receiver'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CallLogMinimalOutSchema
     */
    'recipient_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CallLogMinimalOutSchema
     */
    'date_created': string;
    /**
     * 
     * @type {string}
     * @memberof CallLogMinimalOutSchema
     */
    'recording'?: string | null;
}
/**
 * 
 * @export
 * @interface CallLogMinimalOutV2Schema
 */
export interface CallLogMinimalOutV2Schema {
    /**
     * 
     * @type {number}
     * @memberof CallLogMinimalOutV2Schema
     */
    'cost': number;
    /**
     * 
     * @type {string}
     * @memberof CallLogMinimalOutV2Schema
     */
    'date_created': string;
    /**
     * 
     * @type {string}
     * @memberof CallLogMinimalOutV2Schema
     */
    'last_modified': string;
    /**
     * 
     * @type {string}
     * @memberof CallLogMinimalOutV2Schema
     */
    'start_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CallLogMinimalOutV2Schema
     */
    'caller_name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CallLogMinimalOutV2Schema
     */
    'has_call_note'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CallLogMinimalOutV2Schema
     */
    'has_recording'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CallLogMinimalOutV2Schema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CallLogMinimalOutV2Schema
     */
    'caller_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CallLogMinimalOutV2Schema
     */
    'duration_secs': number;
    /**
     * 
     * @type {string}
     * @memberof CallLogMinimalOutV2Schema
     */
    'end_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CallLogMinimalOutV2Schema
     */
    'answer_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CallLogMinimalOutV2Schema
     */
    'hangup_cause'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CallLogMinimalOutV2Schema
     */
    'context'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CallLogMinimalOutV2Schema
     */
    'is_missed_call'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CallLogMinimalOutV2Schema
     */
    'sip_call_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CallLogMinimalOutV2Schema
     */
    'has_voice_mail'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CallLogMinimalOutV2Schema
     */
    'is_forwarded_call'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CallLogMinimalOutV2Schema
     */
    'is_dialed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CallLogMinimalOutV2Schema
     */
    'recipient_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CallLogMinimalOutV2Schema
     */
    'direction'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CallLogMinimalOutV2Schema
     */
    'user'?: number | null;
}
/**
 * 
 * @export
 * @interface CallLogOutSchema
 */
export interface CallLogOutSchema {
    /**
     * 
     * @type {number}
     * @memberof CallLogOutSchema
     */
    'cost': number;
    /**
     * 
     * @type {string}
     * @memberof CallLogOutSchema
     */
    'user': string;
    /**
     * 
     * @type {string}
     * @memberof CallLogOutSchema
     */
    'date_created': string;
    /**
     * 
     * @type {string}
     * @memberof CallLogOutSchema
     */
    'last_modified': string;
    /**
     * 
     * @type {string}
     * @memberof CallLogOutSchema
     */
    'caller_name'?: string | null;
    /**
     * 
     * @type {MinimalUserContactSchema}
     * @memberof CallLogOutSchema
     */
    'contact'?: MinimalUserContactSchema | null;
    /**
     * 
     * @type {string}
     * @memberof CallLogOutSchema
     */
    'recording'?: string | null;
    /**
     * 
     * @type {CallNoteOutSchema}
     * @memberof CallLogOutSchema
     */
    'note'?: CallNoteOutSchema | null;
    /**
     * 
     * @type {PressoneAIOutSchema}
     * @memberof CallLogOutSchema
     */
    'pressone_ai'?: PressoneAIOutSchema | null;
    /**
     * 
     * @type {number}
     * @memberof CallLogOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CallLogOutSchema
     */
    'caller_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CallLogOutSchema
     */
    'duration_secs': number;
    /**
     * 
     * @type {string}
     * @memberof CallLogOutSchema
     */
    'cost_currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof CallLogOutSchema
     */
    'start_time': string;
    /**
     * 
     * @type {string}
     * @memberof CallLogOutSchema
     */
    'end_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CallLogOutSchema
     */
    'answer_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CallLogOutSchema
     */
    'hangup_cause'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CallLogOutSchema
     */
    'context'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CallLogOutSchema
     */
    'is_missed_call'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CallLogOutSchema
     */
    'has_voice_mail'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CallLogOutSchema
     */
    'is_forwarded_call'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CallLogOutSchema
     */
    'is_dialed'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CallLogOutSchema
     */
    'receiver'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CallLogOutSchema
     */
    'voicemail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CallLogOutSchema
     */
    'sip_call_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CallLogOutSchema
     */
    'recipient_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CallLogOutSchema
     */
    'recipient_name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CallLogOutSchema
     */
    'is_answered'?: boolean;
}
/**
 * Schema for call log information
 * @export
 * @interface CallLogSchema
 */
export interface CallLogSchema {
    /**
     * 
     * @type {string}
     * @memberof CallLogSchema
     */
    'direction': string;
    /**
     * 
     * @type {number}
     * @memberof CallLogSchema
     */
    'duration': number;
    /**
     * 
     * @type {string}
     * @memberof CallLogSchema
     */
    'start_time': string;
    /**
     * 
     * @type {string}
     * @memberof CallLogSchema
     */
    'recipient_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CallLogSchema
     */
    'caller_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof CallLogSchema
     */
    'is_missed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CallLogSchema
     */
    'is_forwarded': boolean;
    /**
     * 
     * @type {string}
     * @memberof CallLogSchema
     */
    'recording'?: string | null;
}
/**
 * 
 * @export
 * @interface CallLogSummaryOutSchema
 */
export interface CallLogSummaryOutSchema {
    /**
     * 
     * @type {number}
     * @memberof CallLogSummaryOutSchema
     */
    'total_call_count': number;
    /**
     * 
     * @type {number}
     * @memberof CallLogSummaryOutSchema
     */
    'dialed_call_count': number;
    /**
     * 
     * @type {number}
     * @memberof CallLogSummaryOutSchema
     */
    'missed_call_count': number;
    /**
     * 
     * @type {number}
     * @memberof CallLogSummaryOutSchema
     */
    'received_call_count': number;
}
/**
 * 
 * @export
 * @interface CallLogSummaryReportFilterSchema
 */
export interface CallLogSummaryReportFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof CallLogSummaryReportFilterSchema
     */
    'start_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CallLogSummaryReportFilterSchema
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {Period}
     * @memberof CallLogSummaryReportFilterSchema
     */
    'period': Period;
    /**
     * 
     * @type {number}
     * @memberof CallLogSummaryReportFilterSchema
     */
    'user_id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CallLogSummaryReportFilterSchema
     */
    'number_id'?: number | null;
}


/**
 * 
 * @export
 * @interface CallLogSummaryReportOutSchema
 */
export interface CallLogSummaryReportOutSchema {
    /**
     * 
     * @type {number}
     * @memberof CallLogSummaryReportOutSchema
     */
    'total_call'?: number;
    /**
     * 
     * @type {number}
     * @memberof CallLogSummaryReportOutSchema
     */
    'missed_call'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CallLogSummaryReportOutSchema
     */
    'dialled_call'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CallLogSummaryReportOutSchema
     */
    'received_call'?: number | null;
}
/**
 * 
 * @export
 * @interface CallNoteInSchema
 */
export interface CallNoteInSchema {
    /**
     * 
     * @type {number}
     * @memberof CallNoteInSchema
     */
    'call_log_id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CallNoteInSchema
     */
    'contact_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CallNoteInSchema
     */
    'note': string;
}
/**
 * 
 * @export
 * @interface CallNoteOutSchema
 */
export interface CallNoteOutSchema {
    /**
     * 
     * @type {string}
     * @memberof CallNoteOutSchema
     */
    'note_created_by'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CallNoteOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CallNoteOutSchema
     */
    'last_modified': string;
    /**
     * 
     * @type {string}
     * @memberof CallNoteOutSchema
     */
    'date_created': string;
    /**
     * 
     * @type {number}
     * @memberof CallNoteOutSchema
     */
    'user'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CallNoteOutSchema
     */
    'contact_number': string;
    /**
     * 
     * @type {number}
     * @memberof CallNoteOutSchema
     */
    'call_log'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CallNoteOutSchema
     */
    'note': string;
    /**
     * 
     * @type {string}
     * @memberof CallNoteOutSchema
     */
    'call_id'?: string | null;
}
/**
 * 
 * @export
 * @interface CallQueueContactDistributionInSchema
 */
export interface CallQueueContactDistributionInSchema {
    /**
     * 
     * @type {Array<AgentContactCountSchema>}
     * @memberof CallQueueContactDistributionInSchema
     */
    'distribution': Array<AgentContactCountSchema>;
    /**
     * 
     * @type {boolean}
     * @memberof CallQueueContactDistributionInSchema
     */
    'all_contacts'?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CallQueueContactDistributionInSchema
     */
    'contacts'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface CallQueueContactInSchema
 */
export interface CallQueueContactInSchema {
    /**
     * 
     * @type {Array<string>}
     * @memberof CallQueueContactInSchema
     */
    'contacts': Array<string>;
}
/**
 * 
 * @export
 * @interface CallQueueContactOutSchema
 */
export interface CallQueueContactOutSchema {
    /**
     * 
     * @type {string}
     * @memberof CallQueueContactOutSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CallQueueContactOutSchema
     */
    'number': string;
    /**
     * 
     * @type {string}
     * @memberof CallQueueContactOutSchema
     */
    'contact_id': string;
    /**
     * 
     * @type {string}
     * @memberof CallQueueContactOutSchema
     */
    'rank': string;
}
/**
 * 
 * @export
 * @interface CallQueueContactOutSchema2
 */
export interface CallQueueContactOutSchema2 {
    /**
     * 
     * @type {string}
     * @memberof CallQueueContactOutSchema2
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CallQueueContactOutSchema2
     */
    'number': string;
    /**
     * 
     * @type {string}
     * @memberof CallQueueContactOutSchema2
     */
    'contact_id': string;
    /**
     * 
     * @type {string}
     * @memberof CallQueueContactOutSchema2
     */
    'company_name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CallQueueContactOutSchema2
     */
    'id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CallQueueContactOutSchema2
     */
    'campaign': number;
    /**
     * 
     * @type {number}
     * @memberof CallQueueContactOutSchema2
     */
    'queue': number;
    /**
     * 
     * @type {string}
     * @memberof CallQueueContactOutSchema2
     */
    'rank': string;
}
/**
 * 
 * @export
 * @interface CallQueueFilterSchema
 */
export interface CallQueueFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof CallQueueFilterSchema
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CallQueueFilterSchema
     */
    'created_by'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CallQueueFilterSchema
     */
    'assigned'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CallQueueFilterSchema
     */
    'business'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CallQueueFilterSchema
     */
    'campaign_id'?: number | null;
}
/**
 * 
 * @export
 * @interface CallQueueInCampaignOutSchema
 */
export interface CallQueueInCampaignOutSchema {
    /**
     * 
     * @type {string}
     * @memberof CallQueueInCampaignOutSchema
     */
    'campaign_name': string;
    /**
     * 
     * @type {number}
     * @memberof CallQueueInCampaignOutSchema
     */
    'campaign_id': number;
    /**
     * 
     * @type {string}
     * @memberof CallQueueInCampaignOutSchema
     */
    'business_name': string;
    /**
     * 
     * @type {string}
     * @memberof CallQueueInCampaignOutSchema
     */
    'agent_first_name': string;
    /**
     * 
     * @type {string}
     * @memberof CallQueueInCampaignOutSchema
     */
    'agent_last_name': string;
    /**
     * 
     * @type {number}
     * @memberof CallQueueInCampaignOutSchema
     */
    'total_calls': number;
    /**
     * 
     * @type {number}
     * @memberof CallQueueInCampaignOutSchema
     */
    'avg_time_on_calls': number;
    /**
     * 
     * @type {number}
     * @memberof CallQueueInCampaignOutSchema
     */
    'conversion_rate': number;
    /**
     * 
     * @type {number}
     * @memberof CallQueueInCampaignOutSchema
     */
    'talk_time': number;
    /**
     * 
     * @type {number}
     * @memberof CallQueueInCampaignOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CallQueueInCampaignOutSchema
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface CallQueueInSchema
 */
export interface CallQueueInSchema {
    /**
     * 
     * @type {number}
     * @memberof CallQueueInSchema
     */
    'created_by_id': number;
    /**
     * 
     * @type {number}
     * @memberof CallQueueInSchema
     */
    'limit': number;
    /**
     * 
     * @type {string}
     * @memberof CallQueueInSchema
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CallQueueInSchema
     */
    'agent_id': number;
}
/**
 * 
 * @export
 * @interface CallQueueOutSchema
 */
export interface CallQueueOutSchema {
    /**
     * 
     * @type {number}
     * @memberof CallQueueOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CallQueueOutSchema
     */
    'limit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CallQueueOutSchema
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CallQueueOutSchema
     */
    'agent'?: number | null;
}
/**
 * 
 * @export
 * @interface CallScriptFilterSchema
 */
export interface CallScriptFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof CallScriptFilterSchema
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CallScriptFilterSchema
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface CallScriptInSchema
 */
export interface CallScriptInSchema {
    /**
     * 
     * @type {string}
     * @memberof CallScriptInSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CallScriptInSchema
     */
    'description': string | null;
    /**
     * 
     * @type {Array<CallScriptItemInSchema>}
     * @memberof CallScriptInSchema
     */
    'items': Array<CallScriptItemInSchema>;
}
/**
 * 
 * @export
 * @interface CallScriptItemInSchema
 */
export interface CallScriptItemInSchema {
    /**
     * 
     * @type {string}
     * @memberof CallScriptItemInSchema
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CallScriptItemInSchema
     */
    'text': string;
}
/**
 * 
 * @export
 * @interface CallScriptItemOutSchema
 */
export interface CallScriptItemOutSchema {
    /**
     * 
     * @type {number}
     * @memberof CallScriptItemOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CallScriptItemOutSchema
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CallScriptItemOutSchema
     */
    'text': string;
}
/**
 * 
 * @export
 * @interface CallScriptOutSchema
 */
export interface CallScriptOutSchema {
    /**
     * 
     * @type {Array<CallScriptItemOutSchema>}
     * @memberof CallScriptOutSchema
     */
    'items': Array<CallScriptItemOutSchema>;
    /**
     * 
     * @type {number}
     * @memberof CallScriptOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CallScriptOutSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CallScriptOutSchema
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface CallStatsReportOutSchema
 */
export interface CallStatsReportOutSchema {
    /**
     * 
     * @type {string}
     * @memberof CallStatsReportOutSchema
     */
    'start_interval': string;
    /**
     * 
     * @type {string}
     * @memberof CallStatsReportOutSchema
     */
    'end_interval': string;
    /**
     * 
     * @type {number}
     * @memberof CallStatsReportOutSchema
     */
    'contact_engaged'?: number;
    /**
     * 
     * @type {number}
     * @memberof CallStatsReportOutSchema
     */
    'duration'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CallType = {
    Missed: 'missed',
    Inbound: 'inbound',
    Outbound: 'outbound',
    Voicemail: 'voicemail'
} as const;

export type CallType = typeof CallType[keyof typeof CallType];


/**
 * 
 * @export
 * @interface CampaignCallScriptItemInSchema
 */
export interface CampaignCallScriptItemInSchema {
    /**
     * 
     * @type {number}
     * @memberof CampaignCallScriptItemInSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignCallScriptItemInSchema
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignCallScriptItemInSchema
     */
    'text': string;
}
/**
 * 
 * @export
 * @interface CampaignCallScriptOutSchema
 */
export interface CampaignCallScriptOutSchema {
    /**
     * 
     * @type {Array<CallScriptItemOutSchema>}
     * @memberof CampaignCallScriptOutSchema
     */
    'items': Array<CallScriptItemOutSchema>;
    /**
     * 
     * @type {string}
     * @memberof CampaignCallScriptOutSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignCallScriptOutSchema
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface CampaignCallScriptUpdateSchema
 */
export interface CampaignCallScriptUpdateSchema {
    /**
     * 
     * @type {string}
     * @memberof CampaignCallScriptUpdateSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignCallScriptUpdateSchema
     */
    'description': string | null;
    /**
     * 
     * @type {Array<CampaignCallScriptItemInSchema>}
     * @memberof CampaignCallScriptUpdateSchema
     */
    'items': Array<CampaignCallScriptItemInSchema>;
}
/**
 * 
 * @export
 * @interface CampaignContactFilterSchema
 */
export interface CampaignContactFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof CampaignContactFilterSchema
     */
    'search'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignContactFilterSchema
     */
    'tags'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignContactFilterSchema
     */
    'is_private'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignContactFilterSchema
     */
    'call_type'?: string | null;
}
/**
 * 
 * @export
 * @interface CampaignContactOutSchema
 */
export interface CampaignContactOutSchema {
    /**
     * 
     * @type {string}
     * @memberof CampaignContactOutSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignContactOutSchema
     */
    'contact_name': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignContactOutSchema
     */
    'contact_number': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignContactOutSchema
     */
    'contact_email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignContactOutSchema
     */
    'assigned_agent_name'?: string | null;
    /**
     * 
     * @type {Array<{ [key: string]: string; }>}
     * @memberof CampaignContactOutSchema
     */
    'tags_list'?: Array<{ [key: string]: string; }>;
    /**
     * 
     * @type {string}
     * @memberof CampaignContactOutSchema
     */
    'date_created'?: string | null;
}
/**
 * 
 * @export
 * @interface CampaignDateRangeFilterSchema
 */
export interface CampaignDateRangeFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof CampaignDateRangeFilterSchema
     */
    'start_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignDateRangeFilterSchema
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {Period}
     * @memberof CampaignDateRangeFilterSchema
     */
    'period'?: Period | null;
    /**
     * 
     * @type {number}
     * @memberof CampaignDateRangeFilterSchema
     */
    'agent_id'?: number | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CampaignGoal = {
    Winback: 'Winback',
    LeadGeneration: 'Lead Generation',
    MarketResearch: 'Market Research',
    Payment: 'Payment',
    AppointmentBooking: 'Appointment Booking'
} as const;

export type CampaignGoal = typeof CampaignGoal[keyof typeof CampaignGoal];


/**
 * 
 * @export
 * @interface CampaignInSchema
 */
export interface CampaignInSchema {
    /**
     * 
     * @type {Array<number>}
     * @memberof CampaignInSchema
     */
    'business_number_ids'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignInSchema
     */
    'name': string;
    /**
     * 
     * @type {CampaignGoal}
     * @memberof CampaignInSchema
     */
    'goal'?: CampaignGoal;
    /**
     * 
     * @type {CampaignStatus}
     * @memberof CampaignInSchema
     */
    'status': CampaignStatus;
    /**
     * 
     * @type {string}
     * @memberof CampaignInSchema
     */
    'start_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignInSchema
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CampaignInSchema
     */
    'expected_conversion_rate'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CampaignInSchema
     */
    'expected_revenue_per_customer'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CampaignInSchema
     */
    'max_followup_calls'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignInSchema
     */
    'start_on_schedule'?: boolean;
    /**
     * 
     * @type {ReminderType}
     * @memberof CampaignInSchema
     */
    'reminder_type'?: ReminderType | null;
    /**
     * 
     * @type {BulkUploadContactSchema}
     * @memberof CampaignInSchema
     */
    'contacts': BulkUploadContactSchema | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CampaignInSchema
     */
    'tags'?: Array<number> | null;
}


/**
 * 
 * @export
 * @interface CampaignListSchema
 */
export interface CampaignListSchema {
    /**
     * 
     * @type {number}
     * @memberof CampaignListSchema
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof CampaignListSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignListSchema
     */
    'start_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignListSchema
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignListSchema
     */
    'goal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignListSchema
     */
    'status'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignListSchema
     */
    'start_on_schedule': boolean;
    /**
     * 
     * @type {string}
     * @memberof CampaignListSchema
     */
    'date_created': string;
    /**
     * 
     * @type {number}
     * @memberof CampaignListSchema
     */
    'total_contacts': number;
    /**
     * 
     * @type {number}
     * @memberof CampaignListSchema
     */
    'total_calls': number;
    /**
     * 
     * @type {number}
     * @memberof CampaignListSchema
     */
    'answered_calls': number;
}
/**
 * 
 * @export
 * @interface CampaignNumberPurchaseInSchema
 */
export interface CampaignNumberPurchaseInSchema {
    /**
     * 
     * @type {number}
     * @memberof CampaignNumberPurchaseInSchema
     */
    'plan_id': number;
}
/**
 * 
 * @export
 * @interface CampaignOutSchema
 */
export interface CampaignOutSchema {
    /**
     * 
     * @type {Array<BusinessNumberMinimalOutSchema>}
     * @memberof CampaignOutSchema
     */
    'business_numbers': Array<BusinessNumberMinimalOutSchema>;
    /**
     * 
     * @type {number}
     * @memberof CampaignOutSchema
     */
    'total_contacts'?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignOutSchema
     */
    'total_agents'?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignOutSchema
     */
    'unassigned_contacts'?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignOutSchema
     */
    'archived'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignOutSchema
     */
    'last_modified'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignOutSchema
     */
    'date_created'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CampaignOutSchema
     */
    'business'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CampaignOutSchema
     */
    'created_by'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignOutSchema
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignOutSchema
     */
    'goal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignOutSchema
     */
    'start_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignOutSchema
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CampaignOutSchema
     */
    'expected_conversion_rate'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CampaignOutSchema
     */
    'expected_revenue_per_customer'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CampaignOutSchema
     */
    'max_followup_calls'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignOutSchema
     */
    'status'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignOutSchema
     */
    'start_on_schedule'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignOutSchema
     */
    'reminder_type'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CampaignOutSchema
     */
    'call_scripts'?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CampaignOutSchema
     */
    'contacts'?: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CampaignOutSchema
     */
    'tags'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CampaignOutSchema
     */
    'agents'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CampaignOutSchema
     */
    'call_queues'?: Array<number> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CampaignStatus = {
    Draft: 'Draft',
    Active: 'Active',
    Completed: 'Completed'
} as const;

export type CampaignStatus = typeof CampaignStatus[keyof typeof CampaignStatus];


/**
 * 
 * @export
 * @interface CampaignTagsOutSchema
 */
export interface CampaignTagsOutSchema {
    /**
     * 
     * @type {Array<TagOutSchema>}
     * @memberof CampaignTagsOutSchema
     */
    'tags': Array<TagOutSchema>;
}
/**
 * 
 * @export
 * @interface CampaignUpdateSchema
 */
export interface CampaignUpdateSchema {
    /**
     * 
     * @type {Array<number>}
     * @memberof CampaignUpdateSchema
     */
    'business_number_ids'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignUpdateSchema
     */
    'name'?: string | null;
    /**
     * 
     * @type {CampaignGoal}
     * @memberof CampaignUpdateSchema
     */
    'goal'?: CampaignGoal | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignUpdateSchema
     */
    'start_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignUpdateSchema
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CampaignUpdateSchema
     */
    'expected_conversion_rate'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CampaignUpdateSchema
     */
    'expected_revenue_per_customer'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CampaignUpdateSchema
     */
    'max_followup_calls'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CampaignUpdateSchema
     */
    'call_script_ids'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignUpdateSchema
     */
    'start_on_schedule'?: boolean | null;
    /**
     * 
     * @type {ReminderType}
     * @memberof CampaignUpdateSchema
     */
    'reminder_type'?: ReminderType | null;
}


/**
 * 
 * @export
 * @interface CancelSubscriptionInSchema
 */
export interface CancelSubscriptionInSchema {
    /**
     * 
     * @type {number}
     * @memberof CancelSubscriptionInSchema
     */
    'business_id': number;
    /**
     * 
     * @type {string}
     * @memberof CancelSubscriptionInSchema
     */
    'submitted_by': string;
}
/**
 * 
 * @export
 * @interface ChangeEmailInSchema
 */
export interface ChangeEmailInSchema {
    /**
     * 
     * @type {string}
     * @memberof ChangeEmailInSchema
     */
    'current_email': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeEmailInSchema
     */
    'new_email': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeEmailInSchema
     */
    'submitted_by': string;
}
/**
 * 
 * @export
 * @interface ChangePhoneNumberInSchema
 */
export interface ChangePhoneNumberInSchema {
    /**
     * 
     * @type {string}
     * @memberof ChangePhoneNumberInSchema
     */
    'old_phone_number': string;
    /**
     * 
     * @type {string}
     * @memberof ChangePhoneNumberInSchema
     */
    'new_phone_number': string;
    /**
     * 
     * @type {string}
     * @memberof ChangePhoneNumberInSchema
     */
    'submitted_by': string;
}
/**
 * 
 * @export
 * @interface ChannelTokenOutSchema
 */
export interface ChannelTokenOutSchema {
    /**
     * 
     * @type {string}
     * @memberof ChannelTokenOutSchema
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof ChannelTokenOutSchema
     */
    'channel': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ChargeAction = {
    Credit: 'credit',
    Debit: 'debit'
} as const;

export type ChargeAction = typeof ChargeAction[keyof typeof ChargeAction];


/**
 * 
 * @export
 * @interface ChargeAuthorizationLogOutSchema
 */
export interface ChargeAuthorizationLogOutSchema {
    /**
     * 
     * @type {string}
     * @memberof ChargeAuthorizationLogOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChargeAuthorizationLogOutSchema
     */
    'date_created': string;
}
/**
 * 
 * @export
 * @interface ChatterWaveConfigOutSchema
 */
export interface ChatterWaveConfigOutSchema {
    /**
     * 
     * @type {BusinessNumberMinimalOutSchema}
     * @memberof ChatterWaveConfigOutSchema
     */
    'voice_otp_number': BusinessNumberMinimalOutSchema | null;
    /**
     * 
     * @type {BusinessNumberMinimalOutSchema}
     * @memberof ChatterWaveConfigOutSchema
     */
    'text_to_speech_number': BusinessNumberMinimalOutSchema | null;
    /**
     * 
     * @type {string}
     * @memberof ChatterWaveConfigOutSchema
     */
    'callback_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatterWaveConfigOutSchema
     */
    'voice_otp_message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatterWaveConfigOutSchema
     */
    'text_to_speech_voice'?: string;
}
/**
 * 
 * @export
 * @interface ChatterWaveConfigUpdateSchema
 */
export interface ChatterWaveConfigUpdateSchema {
    /**
     * 
     * @type {number}
     * @memberof ChatterWaveConfigUpdateSchema
     */
    'voice_otp_number_id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ChatterWaveConfigUpdateSchema
     */
    'text_to_speech_number_id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ChatterWaveConfigUpdateSchema
     */
    'callback_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatterWaveConfigUpdateSchema
     */
    'voice_otp_message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatterWaveConfigUpdateSchema
     */
    'text_to_speech_voice'?: string | null;
}
/**
 * 
 * @export
 * @interface ChatterWaveFilterSchema
 */
export interface ChatterWaveFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof ChatterWaveFilterSchema
     */
    'search'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ChatterWaveFilterSchema
     */
    'business_number_id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ChatterWaveFilterSchema
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatterWaveFilterSchema
     */
    'date_created_before'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatterWaveFilterSchema
     */
    'date_created_after'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatterWaveFilterSchema
     */
    'session_id'?: string | null;
}
/**
 * 
 * @export
 * @interface ChatterWaveOutSchema
 */
export interface ChatterWaveOutSchema {
    /**
     * 
     * @type {string}
     * @memberof ChatterWaveOutSchema
     */
    'business_number': string;
    /**
     * 
     * @type {string}
     * @memberof ChatterWaveOutSchema
     */
    'start_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatterWaveOutSchema
     */
    'end_time'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ChatterWaveOutSchema
     */
    'duration_secs'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ChatterWaveOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ChatterWaveOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatterWaveOutSchema
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof ChatterWaveOutSchema
     */
    'call_status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatterWaveOutSchema
     */
    'number': string;
    /**
     * 
     * @type {string}
     * @memberof ChatterWaveOutSchema
     */
    'date_created': string;
    /**
     * 
     * @type {string}
     * @memberof ChatterWaveOutSchema
     */
    'session_id': string;
}
/**
 * 
 * @export
 * @interface ChatterWaveOverviewOutSchema
 */
export interface ChatterWaveOverviewOutSchema {
    /**
     * 
     * @type {number}
     * @memberof ChatterWaveOverviewOutSchema
     */
    'total_count': number;
    /**
     * 
     * @type {number}
     * @memberof ChatterWaveOverviewOutSchema
     */
    'pending_count': number;
    /**
     * 
     * @type {number}
     * @memberof ChatterWaveOverviewOutSchema
     */
    'delivered_count': number;
    /**
     * 
     * @type {number}
     * @memberof ChatterWaveOverviewOutSchema
     */
    'failed_count': number;
    /**
     * 
     * @type {number}
     * @memberof ChatterWaveOverviewOutSchema
     */
    'missed_count': number;
    /**
     * 
     * @type {number}
     * @memberof ChatterWaveOverviewOutSchema
     */
    'success_rate_percentage': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ChatterWaveType = {
    Otp: 'otp',
    Tts: 'tts'
} as const;

export type ChatterWaveType = typeof ChatterWaveType[keyof typeof ChatterWaveType];


/**
 * 
 * @export
 * @interface CheckTeamMemberByEmailInSchema
 */
export interface CheckTeamMemberByEmailInSchema {
    /**
     * 
     * @type {Array<string>}
     * @memberof CheckTeamMemberByEmailInSchema
     */
    'emails': Array<string>;
}
/**
 * 
 * @export
 * @interface CheckTeamMemberByEmailOutSchema
 */
export interface CheckTeamMemberByEmailOutSchema {
    /**
     * 
     * @type {Array<string>}
     * @memberof CheckTeamMemberByEmailOutSchema
     */
    'existing_emails'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CloudDefenderEventInSchema
 */
export interface CloudDefenderEventInSchema {
    /**
     * 
     * @type {string}
     * @memberof CloudDefenderEventInSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CloudDefenderEventInSchema
     */
    'subject': string;
    /**
     * 
     * @type {Data1}
     * @memberof CloudDefenderEventInSchema
     */
    'data': Data1;
    /**
     * 
     * @type {string}
     * @memberof CloudDefenderEventInSchema
     */
    'eventType': string;
    /**
     * 
     * @type {string}
     * @memberof CloudDefenderEventInSchema
     */
    'dataVersion': string;
    /**
     * 
     * @type {string}
     * @memberof CloudDefenderEventInSchema
     */
    'metadataVersion': string;
    /**
     * 
     * @type {string}
     * @memberof CloudDefenderEventInSchema
     */
    'eventTime': string;
    /**
     * 
     * @type {string}
     * @memberof CloudDefenderEventInSchema
     */
    'topic': string;
}
/**
 * 
 * @export
 * @interface CloudDefenderResultDataInSchema
 */
export interface CloudDefenderResultDataInSchema {
    /**
     * 
     * @type {string}
     * @memberof CloudDefenderResultDataInSchema
     */
    'blobUri': string;
    /**
     * 
     * @type {string}
     * @memberof CloudDefenderResultDataInSchema
     */
    'correlationId': string;
    /**
     * 
     * @type {string}
     * @memberof CloudDefenderResultDataInSchema
     */
    'eTag': string;
    /**
     * 
     * @type {string}
     * @memberof CloudDefenderResultDataInSchema
     */
    'scanFinishedTimeUtc': string;
    /**
     * 
     * @type {string}
     * @memberof CloudDefenderResultDataInSchema
     */
    'scanResultType': string;
    /**
     * 
     * @type {object}
     * @memberof CloudDefenderResultDataInSchema
     */
    'scanResultDetails': object | null;
}
/**
 * 
 * @export
 * @interface CloudDefenderValidationCodeInSchema
 */
export interface CloudDefenderValidationCodeInSchema {
    /**
     * 
     * @type {string}
     * @memberof CloudDefenderValidationCodeInSchema
     */
    'validationCode': string;
    /**
     * 
     * @type {string}
     * @memberof CloudDefenderValidationCodeInSchema
     */
    'validationUrl': string;
}
/**
 * 
 * @export
 * @interface CompleteVerificationInSchema
 */
export interface CompleteVerificationInSchema {
    /**
     * 
     * @type {string}
     * @memberof CompleteVerificationInSchema
     */
    'firstname': string;
    /**
     * 
     * @type {string}
     * @memberof CompleteVerificationInSchema
     */
    'lastname': string;
    /**
     * 
     * @type {string}
     * @memberof CompleteVerificationInSchema
     */
    'government_id_number': string;
    /**
     * 
     * @type {string}
     * @memberof CompleteVerificationInSchema
     */
    'dob': string;
    /**
     * 
     * @type {string}
     * @memberof CompleteVerificationInSchema
     */
    'token': string;
}
/**
 * Schema for representing the interest level of contacts in a campaign.  Attributes:     label (str): The label describing the interest level.     count (int): The count of contacts that fall under this interest level.
 * @export
 * @interface ContactInterestLevelSchema
 */
export interface ContactInterestLevelSchema {
    /**
     * 
     * @type {string}
     * @memberof ContactInterestLevelSchema
     */
    'label': string;
    /**
     * 
     * @type {number}
     * @memberof ContactInterestLevelSchema
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ContactTagDistributionOutSchema
 */
export interface ContactTagDistributionOutSchema {
    /**
     * 
     * @type {string}
     * @memberof ContactTagDistributionOutSchema
     */
    'tag_name': string;
    /**
     * 
     * @type {number}
     * @memberof ContactTagDistributionOutSchema
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ConversartionFilterSchema
 */
export interface ConversartionFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof ConversartionFilterSchema
     */
    'search'?: string | null;
    /**
     * 
     * @type {ConversationStatus}
     * @memberof ConversartionFilterSchema
     */
    'status'?: ConversationStatus | null;
    /**
     * 
     * @type {ConversationType}
     * @memberof ConversartionFilterSchema
     */
    'type'?: ConversationType | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ConversartionFilterSchema
     */
    'created_by'?: Array<number> | null;
}


/**
 * 
 * @export
 * @interface ConversartionUpdateSchema
 */
export interface ConversartionUpdateSchema {
    /**
     * 
     * @type {ConversationStatus}
     * @memberof ConversartionUpdateSchema
     */
    'status'?: ConversationStatus | null;
    /**
     * 
     * @type {string}
     * @memberof ConversartionUpdateSchema
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversartionUpdateSchema
     */
    'deadline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversartionUpdateSchema
     */
    'customer_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversartionUpdateSchema
     */
    'customer_mobile'?: string | null;
}


/**
 * 
 * @export
 * @interface ConversationAttachmentOutSchema
 */
export interface ConversationAttachmentOutSchema {
    /**
     * 
     * @type {number}
     * @memberof ConversationAttachmentOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationAttachmentOutSchema
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationAttachmentOutSchema
     */
    'caption'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationAttachmentOutSchema
     */
    'size': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationAttachmentOutSchema
     */
    'file_type': string;
}
/**
 * 
 * @export
 * @interface ConversationCallLogOutSchema
 */
export interface ConversationCallLogOutSchema {
    /**
     * 
     * @type {CallLogMinimalOutSchema}
     * @memberof ConversationCallLogOutSchema
     */
    'call_log'?: CallLogMinimalOutSchema | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationCallLogOutSchema
     */
    'call_id': string;
}
/**
 * 
 * @export
 * @interface ConversationInSchema
 */
export interface ConversationInSchema {
    /**
     * 
     * @type {string}
     * @memberof ConversationInSchema
     */
    'title': string;
    /**
     * 
     * @type {ConversationType}
     * @memberof ConversationInSchema
     */
    'type'?: ConversationType | null;
}


/**
 * 
 * @export
 * @interface ConversationInvitationContactDictSchema
 */
export interface ConversationInvitationContactDictSchema {
    /**
     * 
     * @type {string}
     * @memberof ConversationInvitationContactDictSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationInvitationContactDictSchema
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface ConversationInvitationConversationSchema
 */
export interface ConversationInvitationConversationSchema {
    /**
     * 
     * @type {string}
     * @memberof ConversationInvitationConversationSchema
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationInvitationConversationSchema
     */
    'status': string;
    /**
     * 
     * @type {number}
     * @memberof ConversationInvitationConversationSchema
     */
    'all_participants_count': number;
    /**
     * 
     * @type {string}
     * @memberof ConversationInvitationConversationSchema
     */
    'date_started': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationInvitationConversationSchema
     */
    'date_closed'?: string | null;
}
/**
 * 
 * @export
 * @interface ConversationInvitationInvitedBySchema
 */
export interface ConversationInvitationInvitedBySchema {
    /**
     * 
     * @type {string}
     * @memberof ConversationInvitationInvitedBySchema
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationInvitationInvitedBySchema
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationInvitationInvitedBySchema
     */
    'profile_picture'?: string | null;
}
/**
 * 
 * @export
 * @interface ConversationInvitationOutSchema
 */
export interface ConversationInvitationOutSchema {
    /**
     * 
     * @type {ConversationInvitationInvitedBySchema}
     * @memberof ConversationInvitationOutSchema
     */
    'invited_by'?: ConversationInvitationInvitedBySchema | null;
    /**
     * 
     * @type {ConversationInvitationParticipantSchema}
     * @memberof ConversationInvitationOutSchema
     */
    'participant'?: ConversationInvitationParticipantSchema | null;
    /**
     * 
     * @type {ConversationInvitationContactDictSchema}
     * @memberof ConversationInvitationOutSchema
     */
    'contact'?: ConversationInvitationContactDictSchema | null;
    /**
     * 
     * @type {ConversationInvitationConversationSchema}
     * @memberof ConversationInvitationOutSchema
     */
    'conversation': ConversationInvitationConversationSchema;
    /**
     * 
     * @type {string}
     * @memberof ConversationInvitationOutSchema
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationInvitationOutSchema
     */
    'conversation_activity': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationInvitationOutSchema
     */
    'date_created': string;
}
/**
 * 
 * @export
 * @interface ConversationInvitationParticipantSchema
 */
export interface ConversationInvitationParticipantSchema {
    /**
     * 
     * @type {number}
     * @memberof ConversationInvitationParticipantSchema
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ConversationInvitationParticipantSchema
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface ConversationItemInSchema
 */
export interface ConversationItemInSchema {
    /**
     * 
     * @type {ConversationItemType}
     * @memberof ConversationItemInSchema
     */
    'type': ConversationItemType;
    /**
     * 
     * @type {string}
     * @memberof ConversationItemInSchema
     */
    'content'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ConversationItemInSchema
     */
    'call_log_id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationItemInSchema
     */
    'call_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationItemInSchema
     */
    'url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationItemInSchema
     */
    'caption'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationItemInSchema
     */
    'size'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationItemInSchema
     */
    'file_type'?: string | null;
}


/**
 * 
 * @export
 * @interface ConversationItemOutSchema
 */
export interface ConversationItemOutSchema {
    /**
     * 
     * @type {ConversationOutSchema}
     * @memberof ConversationItemOutSchema
     */
    'conversation': ConversationOutSchema;
    /**
     * 
     * @type {Item}
     * @memberof ConversationItemOutSchema
     */
    'item': Item;
    /**
     * 
     * @type {string}
     * @memberof ConversationItemOutSchema
     */
    'name': string | null;
    /**
     * 
     * @type {number}
     * @memberof ConversationItemOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationItemOutSchema
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof ConversationItemOutSchema
     */
    'internal_sender'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationItemOutSchema
     */
    'external_sender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationItemOutSchema
     */
    'date_created': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ConversationItemType = {
    Text: 'text',
    CallLog: 'call_log',
    Attachment: 'attachment'
} as const;

export type ConversationItemType = typeof ConversationItemType[keyof typeof ConversationItemType];


/**
 * 
 * @export
 * @interface ConversationNoteInSchema
 */
export interface ConversationNoteInSchema {
    /**
     * 
     * @type {string}
     * @memberof ConversationNoteInSchema
     */
    'note': string;
}
/**
 * 
 * @export
 * @interface ConversationNoteOutSchema
 */
export interface ConversationNoteOutSchema {
    /**
     * 
     * @type {ConversationOutSchema}
     * @memberof ConversationNoteOutSchema
     */
    'conversation': ConversationOutSchema;
    /**
     * 
     * @type {TeamMemberMinimalOutSchema2}
     * @memberof ConversationNoteOutSchema
     */
    'participant'?: TeamMemberMinimalOutSchema2 | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationNoteOutSchema
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationNoteOutSchema
     */
    'note': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationNoteOutSchema
     */
    'date_created': string;
}
/**
 * 
 * @export
 * @interface ConversationOutSchema
 */
export interface ConversationOutSchema {
    /**
     * 
     * @type {BusinessOutSchema}
     * @memberof ConversationOutSchema
     */
    'business': BusinessOutSchema;
    /**
     * 
     * @type {ProfileMinimalOutSchema}
     * @memberof ConversationOutSchema
     */
    'created_by'?: ProfileMinimalOutSchema | null;
    /**
     * 
     * @type {Array<TeamMemberMinimalOutSchema2>}
     * @memberof ConversationOutSchema
     */
    'participants': Array<TeamMemberMinimalOutSchema2>;
    /**
     * 
     * @type {Array<MinimalUserContactSchema>}
     * @memberof ConversationOutSchema
     */
    'contacts': Array<MinimalUserContactSchema>;
    /**
     * 
     * @type {string}
     * @memberof ConversationOutSchema
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationOutSchema
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationOutSchema
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationOutSchema
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationOutSchema
     */
    'customer_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationOutSchema
     */
    'customer_mobile'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ConversationOutSchema
     */
    'rating'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationOutSchema
     */
    'deadline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationOutSchema
     */
    'date_created': string;
}
/**
 * 
 * @export
 * @interface ConversationParticipantsInSchema
 */
export interface ConversationParticipantsInSchema {
    /**
     * 
     * @type {Array<number | null>}
     * @memberof ConversationParticipantsInSchema
     */
    'user_ids'?: Array<number | null>;
    /**
     * 
     * @type {Array<string | null>}
     * @memberof ConversationParticipantsInSchema
     */
    'contact_ids'?: Array<string | null>;
}
/**
 * 
 * @export
 * @interface ConversationParticipantsOutSchema
 */
export interface ConversationParticipantsOutSchema {
    /**
     * 
     * @type {Array<number>}
     * @memberof ConversationParticipantsOutSchema
     */
    'missing_user_ids'?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConversationParticipantsOutSchema
     */
    'missing_contact_ids'?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ConversationParticipantsOutSchema
     */
    'valid_user_ids'?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConversationParticipantsOutSchema
     */
    'valid_contact_ids'?: Array<string>;
    /**
     * 
     * @type {object}
     * @memberof ConversationParticipantsOutSchema
     */
    'valid_user_data'?: object;
    /**
     * 
     * @type {object}
     * @memberof ConversationParticipantsOutSchema
     */
    'valid_contact_data'?: object;
    /**
     * 
     * @type {ConversationOutSchema}
     * @memberof ConversationParticipantsOutSchema
     */
    'conversation'?: ConversationOutSchema | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ConversationStatus = {
    Open: 'open',
    Closed: 'closed',
    OnHold: 'on_hold'
} as const;

export type ConversationStatus = typeof ConversationStatus[keyof typeof ConversationStatus];


/**
 * 
 * @export
 * @interface ConversationTextOutSchema
 */
export interface ConversationTextOutSchema {
    /**
     * 
     * @type {string}
     * @memberof ConversationTextOutSchema
     */
    'content': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ConversationType = {
    Customer: 'customer',
    Candidate: 'candidate',
    Vendor: 'vendor',
    Internal: 'internal'
} as const;

export type ConversationType = typeof ConversationType[keyof typeof ConversationType];


/**
 * Schema for representing conversion targets in a campaign.  Attributes:     date (datetime): The date for which the conversion target is set.     converted (int): The number of contacts converted on that date.     target (float): The target number of conversions for that date.
 * @export
 * @interface ConversionTargetSchema
 */
export interface ConversionTargetSchema {
    /**
     * 
     * @type {string}
     * @memberof ConversionTargetSchema
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof ConversionTargetSchema
     */
    'converted': number;
    /**
     * 
     * @type {number}
     * @memberof ConversionTargetSchema
     */
    'target': number;
}
/**
 * 
 * @export
 * @interface CreatePaymentInvoiceInSchema
 */
export interface CreatePaymentInvoiceInSchema {
    /**
     * 
     * @type {Data}
     * @memberof CreatePaymentInvoiceInSchema
     */
    'data': Data;
    /**
     * 
     * @type {string}
     * @memberof CreatePaymentInvoiceInSchema
     */
    'bill_to': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePaymentInvoiceInSchema
     */
    'bill_to_email': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePaymentInvoiceInSchema
     */
    'bill_to_phone_number': string;
}
/**
 * 
 * @export
 * @interface CreateWalletInSchema
 */
export interface CreateWalletInSchema {
    /**
     * 
     * @type {number}
     * @memberof CreateWalletInSchema
     */
    'business_id': number;
}
/**
 * 
 * @export
 * @interface CreatedBySchema
 */
export interface CreatedBySchema {
    /**
     * 
     * @type {string}
     * @memberof CreatedBySchema
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CreatedBySchema
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface CreditAirtimeInSchema
 */
export interface CreditAirtimeInSchema {
    /**
     * 
     * @type {number}
     * @memberof CreditAirtimeInSchema
     */
    'business_id': number;
    /**
     * 
     * @type {number}
     * @memberof CreditAirtimeInSchema
     */
    'airtime_amount': number;
    /**
     * 
     * @type {string}
     * @memberof CreditAirtimeInSchema
     */
    'payment_reference'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreditAirtimeInSchema
     */
    'submitted_by': string;
}
/**
 * 
 * @export
 * @interface CreditCardOutSchema
 */
export interface CreditCardOutSchema {
    /**
     * 
     * @type {number}
     * @memberof CreditCardOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreditCardOutSchema
     */
    'card_num': string;
    /**
     * 
     * @type {string}
     * @memberof CreditCardOutSchema
     */
    'account_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreditCardOutSchema
     */
    'brand'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreditCardOutSchema
     */
    'bank'?: string | null;
}
/**
 * Schema for business number status response used in ai agent
 * @export
 * @interface CustomerBusinessNumberOutSchema
 */
export interface CustomerBusinessNumberOutSchema {
    /**
     * 
     * @type {boolean}
     * @memberof CustomerBusinessNumberOutSchema
     */
    'found'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerBusinessNumberOutSchema
     */
    'nin_verified'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerBusinessNumberOutSchema
     */
    'greetings_updated'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerBusinessNumberOutSchema
     */
    'owner_email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerBusinessNumberOutSchema
     */
    'owner_phone'?: string | null;
    /**
     * 
     * @type {BusinessSubscriptionStatus}
     * @memberof CustomerBusinessNumberOutSchema
     */
    'subscription_status'?: BusinessSubscriptionStatus | null;
    /**
     * List of receivers for the business number
     * @type {Array<PersonSchema>}
     * @memberof CustomerBusinessNumberOutSchema
     */
    'receivers'?: Array<PersonSchema>;
    /**
     * 
     * @type {number}
     * @memberof CustomerBusinessNumberOutSchema
     */
    'outbound_calls'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerBusinessNumberOutSchema
     */
    'inbound_calls'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerBusinessNumberOutSchema
     */
    'last_call'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerBusinessNumberOutSchema
     */
    'date_created'?: string | null;
}


/**
 * Schema for business details response used in ai agent
 * @export
 * @interface CustomerBusinessOutSchema
 */
export interface CustomerBusinessOutSchema {
    /**
     * 
     * @type {boolean}
     * @memberof CustomerBusinessOutSchema
     */
    'found'?: boolean;
    /**
     * 
     * @type {PersonSchema}
     * @memberof CustomerBusinessOutSchema
     */
    'owner'?: PersonSchema | null;
    /**
     * 
     * @type {Array<PaymentSchema>}
     * @memberof CustomerBusinessOutSchema
     */
    'last_payments'?: Array<PaymentSchema>;
    /**
     * 
     * @type {Array<CallLogSchema>}
     * @memberof CustomerBusinessOutSchema
     */
    'recent_calls'?: Array<CallLogSchema>;
    /**
     * 
     * @type {Array<TeamMemberSchema>}
     * @memberof CustomerBusinessOutSchema
     */
    'team_members'?: Array<TeamMemberSchema>;
    /**
     * 
     * @type {number}
     * @memberof CustomerBusinessOutSchema
     */
    'balance'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerBusinessOutSchema
     */
    'currency'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerBusinessOutSchema
     */
    'nin_verified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerBusinessOutSchema
     */
    'date_created'?: string | null;
}
/**
 * Schema for customer (user) detail out schema used in ai agent
 * @export
 * @interface CustomerDetailOutSchema
 */
export interface CustomerDetailOutSchema {
    /**
     * Whether the customer was found
     * @type {boolean}
     * @memberof CustomerDetailOutSchema
     */
    'found'?: boolean;
    /**
     * Whether a number purchase was found
     * @type {boolean}
     * @memberof CustomerDetailOutSchema
     */
    'is_customer'?: boolean;
    /**
     * Pre-sale Information exists
     * @type {boolean}
     * @memberof CustomerDetailOutSchema
     */
    'is_prospect'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailOutSchema
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailOutSchema
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailOutSchema
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailOutSchema
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailOutSchema
     */
    'business_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailOutSchema
     */
    'industry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailOutSchema
     */
    'use_case'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailOutSchema
     */
    'job_title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDetailOutSchema
     */
    'date_created'?: string | null;
    /**
     * 
     * @type {Array<BusinessNumberSchema>}
     * @memberof CustomerDetailOutSchema
     */
    'business_numbers'?: Array<BusinessNumberSchema>;
}
/**
 * 
 * @export
 * @interface Data
 */
export interface Data {
    /**
     * 
     * @type {number}
     * @memberof Data
     */
    'plan_id': number;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'payment_mode'?: DataPaymentModeEnum;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'phone_number': string;
    /**
     * 
     * @type {number}
     * @memberof Data
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'coupon'?: string;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'promotion_code'?: string;
    /**
     * 
     * @type {Array<NumberProviderInSchema>}
     * @memberof Data
     */
    'numbers': Array<NumberProviderInSchema>;
    /**
     * 
     * @type {BusinessDataInSchema}
     * @memberof Data
     */
    'business': BusinessDataInSchema;
}

export const DataPaymentModeEnum = {
    Card: 'CARD'
} as const;

export type DataPaymentModeEnum = typeof DataPaymentModeEnum[keyof typeof DataPaymentModeEnum];

/**
 * 
 * @export
 * @interface Data1
 */
export interface Data1 {
    /**
     * 
     * @type {string}
     * @memberof Data1
     */
    'blobUri': string;
    /**
     * 
     * @type {string}
     * @memberof Data1
     */
    'correlationId': string;
    /**
     * 
     * @type {string}
     * @memberof Data1
     */
    'eTag': string;
    /**
     * 
     * @type {string}
     * @memberof Data1
     */
    'scanFinishedTimeUtc': string;
    /**
     * 
     * @type {string}
     * @memberof Data1
     */
    'scanResultType': string;
    /**
     * 
     * @type {object}
     * @memberof Data1
     */
    'scanResultDetails': object;
    /**
     * 
     * @type {string}
     * @memberof Data1
     */
    'validationCode': string;
    /**
     * 
     * @type {string}
     * @memberof Data1
     */
    'validationUrl': string;
}
/**
 * 
 * @export
 * @interface DelegateVerificationInSchema
 */
export interface DelegateVerificationInSchema {
    /**
     * 
     * @type {string}
     * @memberof DelegateVerificationInSchema
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof DelegateVerificationInSchema
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof DelegateVerificationInSchema
     */
    'mobile': string;
    /**
     * 
     * @type {string}
     * @memberof DelegateVerificationInSchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof DelegateVerificationInSchema
     */
    'business_name': string;
}
/**
 * 
 * @export
 * @interface DemoVideoFilterSchema
 */
export interface DemoVideoFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof DemoVideoFilterSchema
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoVideoFilterSchema
     */
    'visibility'?: string | null;
}
/**
 * 
 * @export
 * @interface DemoVideoOutSchema
 */
export interface DemoVideoOutSchema {
    /**
     * 
     * @type {number}
     * @memberof DemoVideoOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DemoVideoOutSchema
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof DemoVideoOutSchema
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemoVideoOutSchema
     */
    'demo_video_url': string;
    /**
     * 
     * @type {number}
     * @memberof DemoVideoOutSchema
     */
    'demo_video_duration'?: number;
    /**
     * 
     * @type {string}
     * @memberof DemoVideoOutSchema
     */
    'date_created': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DeveloperExperienceLevel = {
    Expert: 'expert',
    Lead: 'lead',
    Senior: 'senior',
    Intermediate: 'intermediate',
    Junior: 'junior',
    Beginner: 'beginner'
} as const;

export type DeveloperExperienceLevel = typeof DeveloperExperienceLevel[keyof typeof DeveloperExperienceLevel];


/**
 * 
 * @export
 * @interface DeveloperInSchema
 */
export interface DeveloperInSchema {
    /**
     * 
     * @type {string}
     * @memberof DeveloperInSchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof DeveloperInSchema
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof DeveloperInSchema
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof DeveloperInSchema
     */
    'mobile': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeveloperInSchema
     */
    'stack': Array<string>;
    /**
     * 
     * @type {DeveloperExperienceLevel}
     * @memberof DeveloperInSchema
     */
    'experience_level': DeveloperExperienceLevel;
    /**
     * 
     * @type {string}
     * @memberof DeveloperInSchema
     */
    'invitation_code'?: string | null;
}


/**
 * 
 * @export
 * @interface DeveloperOutSchema
 */
export interface DeveloperOutSchema {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeveloperOutSchema
     */
    'stack'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof DeveloperOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DeveloperOutSchema
     */
    'experience_level': string;
}
/**
 * 
 * @export
 * @interface DeveloperUpdateSchema
 */
export interface DeveloperUpdateSchema {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeveloperUpdateSchema
     */
    'stack': Array<string>;
    /**
     * 
     * @type {DeveloperExperienceLevel}
     * @memberof DeveloperUpdateSchema
     */
    'experience_level': DeveloperExperienceLevel;
}


/**
 * 
 * @export
 * @interface DialGroupDuplicateOutSchema
 */
export interface DialGroupDuplicateOutSchema {
    /**
     * 
     * @type {VoiceScriptOutSchema}
     * @memberof DialGroupDuplicateOutSchema
     */
    'welcome_prompt'?: VoiceScriptOutSchema | null;
    /**
     * 
     * @type {VoiceScriptOutSchema}
     * @memberof DialGroupDuplicateOutSchema
     */
    'unavailable_prompt'?: VoiceScriptOutSchema | null;
    /**
     * 
     * @type {VoiceScriptOutSchema}
     * @memberof DialGroupDuplicateOutSchema
     */
    'out_of_office_prompt'?: VoiceScriptOutSchema | null;
    /**
     * 
     * @type {string}
     * @memberof DialGroupDuplicateOutSchema
     */
    'call_forwarding_line'?: string | null;
    /**
     * 
     * @type {Array<IVRMenuOutSchema>}
     * @memberof DialGroupDuplicateOutSchema
     */
    'ivrs'?: Array<IVRMenuOutSchema>;
    /**
     * 
     * @type {Array<CallCenterOutSchema>}
     * @memberof DialGroupDuplicateOutSchema
     */
    'call_centers'?: Array<CallCenterOutSchema>;
    /**
     * 
     * @type {Array<RingGroupOutSchema>}
     * @memberof DialGroupDuplicateOutSchema
     */
    'ring_groups'?: Array<RingGroupOutSchema>;
    /**
     * 
     * @type {TimeAccessSchema2}
     * @memberof DialGroupDuplicateOutSchema
     */
    'time_access': TimeAccessSchema2;
    /**
     * 
     * @type {Array<number>}
     * @memberof DialGroupDuplicateOutSchema
     */
    'business_numbers'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof DialGroupDuplicateOutSchema
     */
    'id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DialGroupDuplicateOutSchema
     */
    'user'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DialGroupDuplicateOutSchema
     */
    'call_destination_application'?: string;
    /**
     * 
     * @type {string}
     * @memberof DialGroupDuplicateOutSchema
     */
    'date_created': string;
    /**
     * 
     * @type {string}
     * @memberof DialGroupDuplicateOutSchema
     */
    'failover_kind'?: string;
    /**
     * 
     * @type {string}
     * @memberof DialGroupDuplicateOutSchema
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface DialGroupFilterSchema
 */
export interface DialGroupFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof DialGroupFilterSchema
     */
    'id'?: string | null;
}
/**
 * 
 * @export
 * @interface DialGroupInAssignNumber
 */
export interface DialGroupInAssignNumber {
    /**
     * 
     * @type {Array<number>}
     * @memberof DialGroupInAssignNumber
     */
    'business_numbers'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface DialGroupInSchema
 */
export interface DialGroupInSchema {
    /**
     * 
     * @type {string}
     * @memberof DialGroupInSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DialGroupInSchema
     */
    'call_forwarding_line': string | null;
    /**
     * 
     * @type {number}
     * @memberof DialGroupInSchema
     */
    'user_id': number;
    /**
     * 
     * @type {CallDestinationKind}
     * @memberof DialGroupInSchema
     */
    'call_destination_application'?: CallDestinationKind;
    /**
     * 
     * @type {number}
     * @memberof DialGroupInSchema
     */
    'unavailable_prompt_id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DialGroupInSchema
     */
    'welcome_prompt_id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DialGroupInSchema
     */
    'out_of_office_prompt_id'?: number | null;
    /**
     * 
     * @type {FailOverKind}
     * @memberof DialGroupInSchema
     */
    'failover_kind'?: FailOverKind;
    /**
     * 
     * @type {FailOverKind}
     * @memberof DialGroupInSchema
     */
    'fallback_kind'?: FailOverKind;
    /**
     * 
     * @type {string}
     * @memberof DialGroupInSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DialGroupInSchema
     */
    'timezone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DialGroupInSchema
     */
    'sunday'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DialGroupInSchema
     */
    'monday'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DialGroupInSchema
     */
    'tuesday'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DialGroupInSchema
     */
    'wednesday'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DialGroupInSchema
     */
    'thursday'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DialGroupInSchema
     */
    'friday'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DialGroupInSchema
     */
    'saturday'?: string | null;
    /**
     * 
     * @type {Payload}
     * @memberof DialGroupInSchema
     */
    'payload': Payload;
}


/**
 * 
 * @export
 * @interface DialGroupOutSchema
 */
export interface DialGroupOutSchema {
    /**
     * 
     * @type {VoiceScriptOutSchema}
     * @memberof DialGroupOutSchema
     */
    'welcome_prompt'?: VoiceScriptOutSchema | null;
    /**
     * 
     * @type {VoiceScriptOutSchema}
     * @memberof DialGroupOutSchema
     */
    'unavailable_prompt'?: VoiceScriptOutSchema | null;
    /**
     * 
     * @type {VoiceScriptOutSchema}
     * @memberof DialGroupOutSchema
     */
    'out_of_office_prompt'?: VoiceScriptOutSchema | null;
    /**
     * 
     * @type {string}
     * @memberof DialGroupOutSchema
     */
    'call_forwarding_line'?: string | null;
    /**
     * 
     * @type {Array<IVRMenuOutSchema>}
     * @memberof DialGroupOutSchema
     */
    'ivrs'?: Array<IVRMenuOutSchema>;
    /**
     * 
     * @type {Array<CallCenterOutSchema>}
     * @memberof DialGroupOutSchema
     */
    'call_centers'?: Array<CallCenterOutSchema>;
    /**
     * 
     * @type {Array<RingGroupOutSchema>}
     * @memberof DialGroupOutSchema
     */
    'ring_groups'?: Array<RingGroupOutSchema>;
    /**
     * 
     * @type {TimeAccessSchema2}
     * @memberof DialGroupOutSchema
     */
    'time_access': TimeAccessSchema2;
    /**
     * 
     * @type {Array<number>}
     * @memberof DialGroupOutSchema
     */
    'business_numbers'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof DialGroupOutSchema
     */
    'id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DialGroupOutSchema
     */
    'user'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DialGroupOutSchema
     */
    'call_destination_application'?: string;
    /**
     * 
     * @type {string}
     * @memberof DialGroupOutSchema
     */
    'date_created': string;
    /**
     * 
     * @type {string}
     * @memberof DialGroupOutSchema
     */
    'failover_kind'?: string;
    /**
     * 
     * @type {string}
     * @memberof DialGroupOutSchema
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface DisableWelcomeGreetingInSchema
 */
export interface DisableWelcomeGreetingInSchema {
    /**
     * 
     * @type {string}
     * @memberof DisableWelcomeGreetingInSchema
     */
    'business_number': string;
    /**
     * 
     * @type {string}
     * @memberof DisableWelcomeGreetingInSchema
     */
    'submitted_by': string;
}
/**
 * 
 * @export
 * @interface DistributeBulkUploadContactSchema
 */
export interface DistributeBulkUploadContactSchema {
    /**
     * 
     * @type {Array<AgentContactCountSchema>}
     * @memberof DistributeBulkUploadContactSchema
     */
    'distribution': Array<AgentContactCountSchema>;
    /**
     * 
     * @type {BulkUploadContactSchema}
     * @memberof DistributeBulkUploadContactSchema
     */
    'bulk_contact_data': BulkUploadContactSchema;
}
/**
 * 
 * @export
 * @interface EmailInputSchema
 */
export interface EmailInputSchema {
    /**
     * 
     * @type {string}
     * @memberof EmailInputSchema
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface EmailIssueEventOutSchema
 */
export interface EmailIssueEventOutSchema {
    /**
     * 
     * @type {string}
     * @memberof EmailIssueEventOutSchema
     */
    'recipient': string;
    /**
     * 
     * @type {string}
     * @memberof EmailIssueEventOutSchema
     */
    'reason'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EmailIssueEventOutSchema
     */
    'timestamp'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EmailIssueEventOutSchema
     */
    'event_type': string;
}
/**
 * 
 * @export
 * @interface EmailWebhookEventSchema
 */
export interface EmailWebhookEventSchema {
    /**
     * 
     * @type {string}
     * @memberof EmailWebhookEventSchema
     */
    'email': string;
    /**
     * 
     * @type {number}
     * @memberof EmailWebhookEventSchema
     */
    'timestamp'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EmailWebhookEventSchema
     */
    'event': string;
    /**
     * 
     * @type {string}
     * @memberof EmailWebhookEventSchema
     */
    'sg_message_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailWebhookEventSchema
     */
    'reason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailWebhookEventSchema
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailWebhookEventSchema
     */
    'response'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailWebhookEventSchema
     */
    'category'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ErrorCode = {
    _4001: '4001',
    _4002: '4002',
    _4003: '4003',
    _4004: '4004',
    _4005: '4005',
    _4006: '4006',
    _4007: '4007',
    _4008: '4008',
    _4009: '4009',
    _4010: '4010',
    _4011: '4011',
    _4012: '4012',
    _4013: '4013',
    _4014: '4014',
    _4015: '4015',
    _5001: '5001'
} as const;

export type ErrorCode = typeof ErrorCode[keyof typeof ErrorCode];


/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ErrorResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {ErrorCode}
     * @memberof ErrorResponse
     */
    'code': ErrorCode;
}


/**
 * 
 * @export
 * @interface EventInSchema
 */
export interface EventInSchema {
    /**
     * 
     * @type {string}
     * @memberof EventInSchema
     */
    'identifier_type': string;
    /**
     * 
     * @type {string}
     * @memberof EventInSchema
     */
    'identifier_value': string;
    /**
     * 
     * @type {string}
     * @memberof EventInSchema
     */
    'event_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventInSchema
     */
    'event_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventInSchema
     */
    'ip_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventInSchema
     */
    'event_name': string;
    /**
     * 
     * @type {string}
     * @memberof EventInSchema
     */
    'device_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventInSchema
     */
    'device_version'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventInSchema
     */
    'user_agent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventInSchema
     */
    'source': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EventInSchema
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {object}
     * @memberof EventInSchema
     */
    'properties'?: object;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ExportFormat = {
    Csv: 'csv',
    Xlsx: 'xlsx'
} as const;

export type ExportFormat = typeof ExportFormat[keyof typeof ExportFormat];


/**
 * 
 * @export
 * @enum {string}
 */

export const ExtensionOperationType = {
    Add: 'add',
    Remove: 'remove'
} as const;

export type ExtensionOperationType = typeof ExtensionOperationType[keyof typeof ExtensionOperationType];


/**
 * 
 * @export
 * @enum {string}
 */

export const FailOverKind = {
    Mobile: 'mobile',
    Voicemail: 'voicemail',
    Prompt: 'prompt'
} as const;

export type FailOverKind = typeof FailOverKind[keyof typeof FailOverKind];


/**
 * 
 * @export
 * @interface FreeTrialDataOutSchema
 */
export interface FreeTrialDataOutSchema {
    /**
     * 
     * @type {boolean}
     * @memberof FreeTrialDataOutSchema
     */
    'is_free_trial_user': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FreeTrialDataOutSchema
     */
    'is_developer': boolean;
}
/**
 * 
 * @export
 * @interface FreeTrialUserCreateOutSchema
 */
export interface FreeTrialUserCreateOutSchema {
    /**
     * 
     * @type {MinimalUserOutSchema}
     * @memberof FreeTrialUserCreateOutSchema
     */
    'data': MinimalUserOutSchema;
    /**
     * 
     * @type {object}
     * @memberof FreeTrialUserCreateOutSchema
     */
    'tokens': object;
}
/**
 * Schema for OTP generation request
 * @export
 * @interface GenerateOtpInSchema
 */
export interface GenerateOtpInSchema {
    /**
     * Business number to generate OTP for
     * @type {string}
     * @memberof GenerateOtpInSchema
     */
    'business_number': string;
}
/**
 * Schema for OTP generation response
 * @export
 * @interface GenerateOtpOutSchema
 */
export interface GenerateOtpOutSchema {
    /**
     * 
     * @type {boolean}
     * @memberof GenerateOtpOutSchema
     */
    'otp_sent': boolean;
    /**
     * 
     * @type {string}
     * @memberof GenerateOtpOutSchema
     */
    'otp': string;
    /**
     * 
     * @type {number}
     * @memberof GenerateOtpOutSchema
     */
    'expires_in': number;
    /**
     * 
     * @type {string}
     * @memberof GenerateOtpOutSchema
     */
    'otp_sent_to'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const GreetingType = {
    WelcomePrompt: 'WELCOME_PROMPT',
    VoicemailPrompt: 'VOICEMAIL_PROMPT',
    OutOfOfficePrompt: 'OUT_OF_OFFICE_PROMPT',
    UnavailablePrompt: 'UNAVAILABLE_PROMPT',
    IvrPrompt: 'IVR_PROMPT',
    MusicOnHoldPrompt: 'MUSIC_ON_HOLD_PROMPT',
    RingGroupWelcomePrompt: 'RING_GROUP_WELCOME_PROMPT'
} as const;

export type GreetingType = typeof GreetingType[keyof typeof GreetingType];


/**
 * 
 * @export
 * @interface HermesReceiverOutSchema
 */
export interface HermesReceiverOutSchema {
    /**
     * 
     * @type {string}
     * @memberof HermesReceiverOutSchema
     */
    'domain': string;
    /**
     * 
     * @type {string}
     * @memberof HermesReceiverOutSchema
     */
    'port'?: string;
    /**
     * 
     * @type {string}
     * @memberof HermesReceiverOutSchema
     */
    'protocol'?: string;
    /**
     * 
     * @type {number}
     * @memberof HermesReceiverOutSchema
     */
    'username': number;
    /**
     * 
     * @type {string}
     * @memberof HermesReceiverOutSchema
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof HermesReceiverOutSchema
     */
    'nonce': string;
}
/**
 * 
 * @export
 * @interface IVRConfigurationInSchema
 */
export interface IVRConfigurationInSchema {
    /**
     * 
     * @type {Array<IVRMenuConfigurationInSchema>}
     * @memberof IVRConfigurationInSchema
     */
    'menus': Array<IVRMenuConfigurationInSchema>;
    /**
     * 
     * @type {Array<CallCenterConfigurationInSchema>}
     * @memberof IVRConfigurationInSchema
     */
    'call_centers'?: Array<CallCenterConfigurationInSchema>;
    /**
     * 
     * @type {Array<RingGroupConfigurationInSchema>}
     * @memberof IVRConfigurationInSchema
     */
    'ring_groups'?: Array<RingGroupConfigurationInSchema>;
    /**
     * 
     * @type {Array<IVREntryConfigurationInSchema>}
     * @memberof IVRConfigurationInSchema
     */
    'entries': Array<IVREntryConfigurationInSchema>;
}
/**
 * 
 * @export
 * @interface IVREntryConfigurationInSchema
 */
export interface IVREntryConfigurationInSchema {
    /**
     * 
     * @type {string}
     * @memberof IVREntryConfigurationInSchema
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof IVREntryConfigurationInSchema
     */
    'digit': number;
    /**
     * 
     * @type {string}
     * @memberof IVREntryConfigurationInSchema
     */
    'parent_menu_id': string;
    /**
     * 
     * @type {IVREntryKind}
     * @memberof IVREntryConfigurationInSchema
     */
    'kind': IVREntryKind;
    /**
     * 
     * @type {string}
     * @memberof IVREntryConfigurationInSchema
     */
    'param': string | null;
    /**
     * 
     * @type {string}
     * @memberof IVREntryConfigurationInSchema
     */
    'label'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const IVREntryKind = {
    Top: 'top',
    Bye: 'bye',
    Dial: 'dial',
    Submenu: 'submenu',
    RingGroup: 'ring_group',
    CallCenter: 'call_center'
} as const;

export type IVREntryKind = typeof IVREntryKind[keyof typeof IVREntryKind];


/**
 * 
 * @export
 * @interface IVREntryOutSchema
 */
export interface IVREntryOutSchema {
    /**
     * 
     * @type {Param}
     * @memberof IVREntryOutSchema
     */
    'param'?: Param | null;
    /**
     * 
     * @type {string}
     * @memberof IVREntryOutSchema
     */
    'parent_menu_id': string;
    /**
     * 
     * @type {string}
     * @memberof IVREntryOutSchema
     */
    'label'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IVREntryOutSchema
     */
    'id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IVREntryOutSchema
     */
    'digit': number;
    /**
     * 
     * @type {string}
     * @memberof IVREntryOutSchema
     */
    'kind'?: string;
}
/**
 * 
 * @export
 * @interface IVRMenuConfigurationInSchema
 */
export interface IVRMenuConfigurationInSchema {
    /**
     * 
     * @type {string}
     * @memberof IVRMenuConfigurationInSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof IVRMenuConfigurationInSchema
     */
    'prompt_url': string;
    /**
     * 
     * @type {boolean}
     * @memberof IVRMenuConfigurationInSchema
     */
    'is_primary': boolean;
    /**
     * 
     * @type {string}
     * @memberof IVRMenuConfigurationInSchema
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface IVRMenuOutSchema
 */
export interface IVRMenuOutSchema {
    /**
     * 
     * @type {Array<IVREntryOutSchema>}
     * @memberof IVRMenuOutSchema
     */
    'entries': Array<IVREntryOutSchema>;
    /**
     * 
     * @type {string}
     * @memberof IVRMenuOutSchema
     */
    'id'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IVRMenuOutSchema
     */
    'is_primary'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IVRMenuOutSchema
     */
    'prompt_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IVRMenuOutSchema
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface IncreaseNinAttemptsInSchema
 */
export interface IncreaseNinAttemptsInSchema {
    /**
     * 
     * @type {string}
     * @memberof IncreaseNinAttemptsInSchema
     */
    'user_email': string;
    /**
     * 
     * @type {number}
     * @memberof IncreaseNinAttemptsInSchema
     */
    'attempts_to_add': number;
    /**
     * 
     * @type {string}
     * @memberof IncreaseNinAttemptsInSchema
     */
    'submitted_by': string;
}
/**
 * 
 * @export
 * @interface Input
 */
export interface Input {
    /**
     * 
     * @type {number}
     * @memberof Input
     */
    'page_index'?: number;
    /**
     * 
     * @type {number}
     * @memberof Input
     */
    'page_size'?: number;
    /**
     * 
     * @type {string}
     * @memberof Input
     */
    'ordering'?: string | null;
}
/**
 * 
 * @export
 * @interface InvitationFilterSchema
 */
export interface InvitationFilterSchema {
    /**
     * 
     * @type {ProfileInvitationStatus}
     * @memberof InvitationFilterSchema
     */
    'invitation_status'?: ProfileInvitationStatus | null;
    /**
     * 
     * @type {number}
     * @memberof InvitationFilterSchema
     */
    'business_id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InvitationFilterSchema
     */
    'business_number_id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InvitationFilterSchema
     */
    'user_id'?: number | null;
}


/**
 * 
 * @export
 * @interface InvitationOutSchema
 */
export interface InvitationOutSchema {
    /**
     * 
     * @type {number}
     * @memberof InvitationOutSchema
     */
    'id': number;
    /**
     * 
     * @type {ProfileInvitationStatus}
     * @memberof InvitationOutSchema
     */
    'invitation_status': ProfileInvitationStatus;
    /**
     * 
     * @type {string}
     * @memberof InvitationOutSchema
     */
    'business_name': string;
    /**
     * 
     * @type {string}
     * @memberof InvitationOutSchema
     */
    'phone_number': string;
    /**
     * 
     * @type {string}
     * @memberof InvitationOutSchema
     */
    'inviter_email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvitationOutSchema
     */
    'inviter_first_name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InvitationOutSchema
     */
    'business_id': number;
    /**
     * 
     * @type {number}
     * @memberof InvitationOutSchema
     */
    'user_id': number;
    /**
     * 
     * @type {string}
     * @memberof InvitationOutSchema
     */
    'date_created': string;
    /**
     * 
     * @type {string}
     * @memberof InvitationOutSchema
     */
    'last_modified': string;
    /**
     * 
     * @type {string}
     * @memberof InvitationOutSchema
     */
    'invitation_id': string;
}


/**
 * 
 * @export
 * @interface InvoiceFilterSchema
 */
export interface InvoiceFilterSchema {
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceFilterSchema
     */
    'paid'?: boolean;
}
/**
 * 
 * @export
 * @interface InvoiceOutSchema
 */
export interface InvoiceOutSchema {
    /**
     * 
     * @type {number}
     * @memberof InvoiceOutSchema
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceOutSchema
     */
    'invoice_number'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceOutSchema
     */
    'paid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvoiceOutSchema
     */
    'date_created': string;
}
/**
 * 
 * @export
 * @interface Item
 */
export interface Item {
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'content': string;
    /**
     * 
     * @type {CallLogMinimalOutSchema}
     * @memberof Item
     */
    'call_log'?: CallLogMinimalOutSchema;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'call_id': string;
    /**
     * 
     * @type {number}
     * @memberof Item
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'caption'?: string;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'size': string;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'file_type': string;
}
/**
 * 
 * @export
 * @interface KnowledgeBaseSubTopicInSchema
 */
export interface KnowledgeBaseSubTopicInSchema {
    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseSubTopicInSchema
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseSubTopicInSchema
     */
    'content': string;
}
/**
 * 
 * @export
 * @interface KnowledgeBaseSubTopicOutSchema
 */
export interface KnowledgeBaseSubTopicOutSchema {
    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseSubTopicOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseSubTopicOutSchema
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseSubTopicOutSchema
     */
    'content'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseSubTopicOutSchema
     */
    'topic': number;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseSubTopicOutSchema
     */
    'date_created': string;
}
/**
 * 
 * @export
 * @interface KnowledgeBaseTopicFilterSchema
 */
export interface KnowledgeBaseTopicFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseTopicFilterSchema
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface KnowledgeBaseTopicInSchema
 */
export interface KnowledgeBaseTopicInSchema {
    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseTopicInSchema
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseTopicInSchema
     */
    'description': string | null;
}
/**
 * 
 * @export
 * @interface KnowledgeBaseTopicOutSchema
 */
export interface KnowledgeBaseTopicOutSchema {
    /**
     * 
     * @type {CreatedBySchema}
     * @memberof KnowledgeBaseTopicOutSchema
     */
    'created_by': CreatedBySchema;
    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseTopicOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseTopicOutSchema
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseTopicOutSchema
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseTopicOutSchema
     */
    'date_created': string;
}
/**
 * 
 * @export
 * @interface LeadCampaignInSchema
 */
export interface LeadCampaignInSchema {
    /**
     * 
     * @type {string}
     * @memberof LeadCampaignInSchema
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof LeadCampaignInSchema
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof LeadCampaignInSchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof LeadCampaignInSchema
     */
    'mobile': string;
    /**
     * 
     * @type {string}
     * @memberof LeadCampaignInSchema
     */
    'campaign': string;
    /**
     * 
     * @type {string}
     * @memberof LeadCampaignInSchema
     */
    'medium': string;
    /**
     * 
     * @type {string}
     * @memberof LeadCampaignInSchema
     */
    'lead_source': string;
}
/**
 * 
 * @export
 * @interface LeadCustomerioInSchemaV2
 */
export interface LeadCustomerioInSchemaV2 {
    /**
     * 
     * @type {string}
     * @memberof LeadCustomerioInSchemaV2
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadCustomerioInSchemaV2
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadCustomerioInSchemaV2
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof LeadCustomerioInSchemaV2
     */
    'mobile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadCustomerioInSchemaV2
     */
    'created_time': string;
    /**
     * 
     * @type {string}
     * @memberof LeadCustomerioInSchemaV2
     */
    'record_id': string;
}
/**
 * 
 * @export
 * @interface LeadInSchema
 */
export interface LeadInSchema {
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'record_id': string;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'lead_owner_id': string;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'lead_owner': string;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'company': string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'first_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'last_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'mobile': string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'website': string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'lead_source': string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'lead_status': string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'industry': string | null;
    /**
     * 
     * @type {number}
     * @memberof LeadInSchema
     */
    'number_of_employees': number | null;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'created_time': string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'modified_time': string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'street': string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'city': string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'state': string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'country': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LeadInSchema
     */
    'email_opt_out': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'secondary_email': string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'last_activity_time': string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'tag'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LeadInSchema
     */
    'is_converted'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof LeadInSchema
     */
    'locked'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'most_recent_visit': string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'first_page_visited': string | null;
    /**
     * 
     * @type {number}
     * @memberof LeadInSchema
     */
    'average_time_spent': number | null;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'referrer': string | null;
    /**
     * 
     * @type {number}
     * @memberof LeadInSchema
     */
    'visitor_score': number | null;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'first_visit': string | null;
    /**
     * 
     * @type {number}
     * @memberof LeadInSchema
     */
    'days_visited': number | null;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'first_page_source': string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'selected_country_go_global': string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadInSchema
     */
    'selected_product_go_global': string | null;
}
/**
 * 
 * @export
 * @interface LeaderBoardReportOutSchema
 */
export interface LeaderBoardReportOutSchema {
    /**
     * 
     * @type {number}
     * @memberof LeaderBoardReportOutSchema
     */
    'user_id': number;
    /**
     * 
     * @type {ProfileRole}
     * @memberof LeaderBoardReportOutSchema
     */
    'role': ProfileRole;
    /**
     * 
     * @type {string}
     * @memberof LeaderBoardReportOutSchema
     */
    'full_name': string;
    /**
     * 
     * @type {number}
     * @memberof LeaderBoardReportOutSchema
     */
    'total_call': number;
    /**
     * 
     * @type {number}
     * @memberof LeaderBoardReportOutSchema
     */
    'dialled_call': number;
    /**
     * 
     * @type {number}
     * @memberof LeaderBoardReportOutSchema
     */
    'missed_call': number;
    /**
     * 
     * @type {number}
     * @memberof LeaderBoardReportOutSchema
     */
    'received_call': number;
    /**
     * 
     * @type {number}
     * @memberof LeaderBoardReportOutSchema
     */
    'time_spent_on_call': number;
}


/**
 * 
 * @export
 * @interface LeaderboardReportFilterSchema
 */
export interface LeaderboardReportFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof LeaderboardReportFilterSchema
     */
    'start_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardReportFilterSchema
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {Period}
     * @memberof LeaderboardReportFilterSchema
     */
    'period': Period;
    /**
     * 
     * @type {ReportOrderBy}
     * @memberof LeaderboardReportFilterSchema
     */
    'order_by': ReportOrderBy;
}


/**
 * 
 * @export
 * @interface LiveCallWidgetOutSchema
 */
export interface LiveCallWidgetOutSchema {
    /**
     * 
     * @type {object}
     * @memberof LiveCallWidgetOutSchema
     */
    'business': object;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetOutSchema
     */
    'business_number'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LiveCallWidgetOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetOutSchema
     */
    'date_created': string;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetOutSchema
     */
    'logo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetOutSchema
     */
    'page_message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetOutSchema
     */
    'jumbotron'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetOutSchema
     */
    'tool_tip_message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetOutSchema
     */
    'button_message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetOutSchema
     */
    'secondary_text_color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetOutSchema
     */
    'primary_text_color'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LiveCallWidgetOutSchema
     */
    'bottom_position'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LiveCallWidgetOutSchema
     */
    'right_position'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetOutSchema
     */
    'primary_bg_color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetOutSchema
     */
    'secondary_bg_color'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LiveCallWidgetOutSchema
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetOutSchema
     */
    'webhook_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetOutSchema
     */
    'widget_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetOutSchema
     */
    'website_type'?: string | null;
}
/**
 * 
 * @export
 * @interface LiveCallWidgetUpdateSchema
 */
export interface LiveCallWidgetUpdateSchema {
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetUpdateSchema
     */
    'website'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetUpdateSchema
     */
    'logo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetUpdateSchema
     */
    'page_message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetUpdateSchema
     */
    'jumbotron'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetUpdateSchema
     */
    'tool_tip_message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetUpdateSchema
     */
    'button_message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetUpdateSchema
     */
    'secondary_text_color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetUpdateSchema
     */
    'primary_text_color'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LiveCallWidgetUpdateSchema
     */
    'bottom_position'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LiveCallWidgetUpdateSchema
     */
    'right_position'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetUpdateSchema
     */
    'primary_bg_color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetUpdateSchema
     */
    'secondary_bg_color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetUpdateSchema
     */
    'webhook_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveCallWidgetUpdateSchema
     */
    'website_type'?: string | null;
}
/**
 * 
 * @export
 * @interface LiveWidgetFeedbackSchema
 */
export interface LiveWidgetFeedbackSchema {
    /**
     * 
     * @type {string}
     * @memberof LiveWidgetFeedbackSchema
     */
    'category'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveWidgetFeedbackSchema
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveWidgetFeedbackSchema
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveWidgetFeedbackSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LiveWidgetFeedbackSchema
     */
    'rating'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LiveWidgetFeedbackSchema
     */
    'mobile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveWidgetFeedbackSchema
     */
    'call_id'?: string | null;
}
/**
 * 
 * @export
 * @interface LoginInputSchema
 */
export interface LoginInputSchema {
    /**
     * 
     * @type {string}
     * @memberof LoginInputSchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof LoginInputSchema
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface MOHOutSchema
 */
export interface MOHOutSchema {
    /**
     * 
     * @type {string}
     * @memberof MOHOutSchema
     */
    'phone_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MOHOutSchema
     */
    'greeting_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MOHOutSchema
     */
    'recording_url'?: string | null;
    /**
     * 
     * @type {VoiceScriptStatus}
     * @memberof MOHOutSchema
     */
    'status'?: VoiceScriptStatus | null;
    /**
     * 
     * @type {string}
     * @memberof MOHOutSchema
     */
    'created_by'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MOHOutSchema
     */
    'created_at'?: string | null;
}


/**
 * 
 * @export
 * @interface ManageExtensionsInSchema
 */
export interface ManageExtensionsInSchema {
    /**
     * 
     * @type {string}
     * @memberof ManageExtensionsInSchema
     */
    'business_number': string;
    /**
     * 
     * @type {ExtensionOperationType}
     * @memberof ManageExtensionsInSchema
     */
    'operation_type': ExtensionOperationType;
    /**
     * 
     * @type {number}
     * @memberof ManageExtensionsInSchema
     */
    'new_max_receivers': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ManageExtensionsInSchema
     */
    'profile_emails'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ManageExtensionsInSchema
     */
    'submitted_by': string;
}


/**
 * 
 * @export
 * @interface MediaBlobFilterSchema
 */
export interface MediaBlobFilterSchema {
    /**
     * 
     * @type {MediaBlobStatus}
     * @memberof MediaBlobFilterSchema
     */
    'status'?: MediaBlobStatus | null;
}


/**
 * 
 * @export
 * @interface MediaBlobMetadataSchema
 */
export interface MediaBlobMetadataSchema {
    /**
     * 
     * @type {GreetingType}
     * @memberof MediaBlobMetadataSchema
     */
    'greeting_type'?: GreetingType | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MediaBlobMetadataSchema
     */
    'phone_numbers'?: Array<string>;
}


/**
 * 
 * @export
 * @interface MediaBlobOutSchema
 */
export interface MediaBlobOutSchema {
    /**
     * 
     * @type {string}
     * @memberof MediaBlobOutSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MediaBlobOutSchema
     */
    'original_name': string;
    /**
     * 
     * @type {string}
     * @memberof MediaBlobOutSchema
     */
    'url': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MediaBlobStatus = {
    Pending: 'pending',
    Scanning: 'scanning',
    Failed: 'failed',
    Ready: 'ready'
} as const;

export type MediaBlobStatus = typeof MediaBlobStatus[keyof typeof MediaBlobStatus];


/**
 * 
 * @export
 * @interface MediaBlobUploadRequestInSchema
 */
export interface MediaBlobUploadRequestInSchema {
    /**
     * 
     * @type {MediaType}
     * @memberof MediaBlobUploadRequestInSchema
     */
    'media_type': MediaType;
    /**
     * 
     * @type {string}
     * @memberof MediaBlobUploadRequestInSchema
     */
    'file_name': string;
    /**
     * 
     * @type {BlobType}
     * @memberof MediaBlobUploadRequestInSchema
     */
    'blob_type': BlobType;
    /**
     * 
     * @type {MediaBlobMetadataSchema}
     * @memberof MediaBlobUploadRequestInSchema
     */
    'metadata'?: MediaBlobMetadataSchema;
}


/**
 * 
 * @export
 * @interface MediaBlobUploadRequestOutSchema
 */
export interface MediaBlobUploadRequestOutSchema {
    /**
     * 
     * @type {string}
     * @memberof MediaBlobUploadRequestOutSchema
     */
    'upload_url': string;
    /**
     * 
     * @type {string}
     * @memberof MediaBlobUploadRequestOutSchema
     */
    'expires': string;
    /**
     * 
     * @type {string}
     * @memberof MediaBlobUploadRequestOutSchema
     */
    'resource_id': string;
    /**
     * 
     * @type {BlobType}
     * @memberof MediaBlobUploadRequestOutSchema
     */
    'blob_type': BlobType;
}


/**
 * 
 * @export
 * @interface MediaBlobsOutSchema
 */
export interface MediaBlobsOutSchema {
    /**
     * 
     * @type {string}
     * @memberof MediaBlobsOutSchema
     */
    'url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MediaBlobsOutSchema
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MediaBlobsOutSchema
     */
    'original_name': string;
    /**
     * 
     * @type {string}
     * @memberof MediaBlobsOutSchema
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaBlobsOutSchema
     */
    'date_created': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MediaType = {
    AudioWav: 'audio/wav',
    AudioOgg: 'audio/ogg',
    AudioMp3: 'audio/mp3',
    AudioFlac: 'audio/flac'
} as const;

export type MediaType = typeof MediaType[keyof typeof MediaType];


/**
 * 
 * @export
 * @interface MinimalTeamMemberSchema
 */
export interface MinimalTeamMemberSchema {
    /**
     * 
     * @type {string}
     * @memberof MinimalTeamMemberSchema
     */
    'email': string;
    /**
     * 
     * @type {ProfileRole}
     * @memberof MinimalTeamMemberSchema
     */
    'role': ProfileRole;
    /**
     * 
     * @type {PermissionInSchema}
     * @memberof MinimalTeamMemberSchema
     */
    'permissions': PermissionInSchema;
    /**
     * 
     * @type {boolean}
     * @memberof MinimalTeamMemberSchema
     */
    'can_make_calls'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MinimalTeamMemberSchema
     */
    'country'?: string;
}


/**
 * 
 * @export
 * @interface MinimalUserContactSchema
 */
export interface MinimalUserContactSchema {
    /**
     * 
     * @type {string}
     * @memberof MinimalUserContactSchema
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MinimalUserContactSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalUserContactSchema
     */
    'number': string;
    /**
     * 
     * @type {boolean}
     * @memberof MinimalUserContactSchema
     */
    'is_private'?: boolean;
}
/**
 * 
 * @export
 * @interface MinimalUserModelOutSchema
 */
export interface MinimalUserModelOutSchema {
    /**
     * 
     * @type {number}
     * @memberof MinimalUserModelOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MinimalUserModelOutSchema
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MinimalUserModelOutSchema
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MinimalUserModelOutSchema
     */
    'mobile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MinimalUserModelOutSchema
     */
    'personal_email': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalUserModelOutSchema
     */
    'profile_picture'?: string | null;
}
/**
 * 
 * @export
 * @interface MinimalUserOutSchema
 */
export interface MinimalUserOutSchema {
    /**
     * 
     * @type {number}
     * @memberof MinimalUserOutSchema
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof MinimalUserOutSchema
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalUserOutSchema
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalUserOutSchema
     */
    'personal_email': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalUserOutSchema
     */
    'mobile'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MinimalUserOutSchema
     */
    'has_business_number': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MinimalUserOutSchema
     */
    'is_team_member': boolean;
    /**
     * 
     * @type {number}
     * @memberof MinimalUserOutSchema
     */
    'recommended_plan'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MinimalUserOutSchema
     */
    'has_pending_number_provisioning': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MinimalUserOutSchema
     */
    'newly_created'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MinimalUserOutSchema
     */
    'global_id'?: string | null;
}
/**
 * 
 * @export
 * @interface MinimalUserVerificationOutSchema
 */
export interface MinimalUserVerificationOutSchema {
    /**
     * 
     * @type {number}
     * @memberof MinimalUserVerificationOutSchema
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof MinimalUserVerificationOutSchema
     */
    'first_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof MinimalUserVerificationOutSchema
     */
    'last_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof MinimalUserVerificationOutSchema
     */
    'personal_email': string | null;
    /**
     * 
     * @type {string}
     * @memberof MinimalUserVerificationOutSchema
     */
    'mobile': string | null;
}
/**
 * Enum for defining the strategy to resolve multiple matches for a contact.  Attributes:     USE_RECENTLY_CREATED (str): Use the most recently created contact.     USE_FIRST_CREATED (str): Use the first created contact.     USE_RECENTLY_EDITED (str): Use the most recently edited contact.
 * @export
 * @enum {string}
 */

export const MultiMatchResolutionStrategy = {
    UseRecentlyCreated: 'USE_RECENTLY_CREATED',
    UseFirstCreated: 'USE_FIRST_CREATED',
    UseRecentlyEdited: 'USE_RECENTLY_EDITED'
} as const;

export type MultiMatchResolutionStrategy = typeof MultiMatchResolutionStrategy[keyof typeof MultiMatchResolutionStrategy];


/**
 * 
 * @export
 * @enum {string}
 */

export const NotificationAction = {
    Read: 'READ',
    Delete: 'DELETE'
} as const;

export type NotificationAction = typeof NotificationAction[keyof typeof NotificationAction];


/**
 * 
 * @export
 * @interface NotificationFilterSchema
 */
export interface NotificationFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof NotificationFilterSchema
     */
    'description'?: string | null;
    /**
     * 
     * @type {NotificationType}
     * @memberof NotificationFilterSchema
     */
    'type'?: NotificationType | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationFilterSchema
     */
    'date_created_range'?: string | null;
}


/**
 * 
 * @export
 * @interface NotificationOutSchema
 */
export interface NotificationOutSchema {
    /**
     * 
     * @type {VoiceMailNotificationOutSchema}
     * @memberof NotificationOutSchema
     */
    'data'?: VoiceMailNotificationOutSchema | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationOutSchema
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationOutSchema
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationOutSchema
     */
    'subtype'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationOutSchema
     */
    'actor_object_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationOutSchema
     */
    'target_object_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationOutSchema
     */
    'verb': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationOutSchema
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationOutSchema
     */
    'timestamp'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const NotificationType = {
    Nps: 'nps',
    Voicemail: 'voicemail'
} as const;

export type NotificationType = typeof NotificationType[keyof typeof NotificationType];


/**
 * 
 * @export
 * @interface NumberAndAddonsPurchaseInSchema
 */
export interface NumberAndAddonsPurchaseInSchema {
    /**
     * 
     * @type {number}
     * @memberof NumberAndAddonsPurchaseInSchema
     */
    'plan_id': number;
    /**
     * 
     * @type {string}
     * @memberof NumberAndAddonsPurchaseInSchema
     */
    'payment_mode'?: NumberAndAddonsPurchaseInSchemaPaymentModeEnum;
    /**
     * 
     * @type {string}
     * @memberof NumberAndAddonsPurchaseInSchema
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NumberAndAddonsPurchaseInSchema
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NumberAndAddonsPurchaseInSchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof NumberAndAddonsPurchaseInSchema
     */
    'phone_number': string;
    /**
     * 
     * @type {number}
     * @memberof NumberAndAddonsPurchaseInSchema
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof NumberAndAddonsPurchaseInSchema
     */
    'coupon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NumberAndAddonsPurchaseInSchema
     */
    'promotion_code'?: string | null;
    /**
     * 
     * @type {Array<NumberProviderInSchema>}
     * @memberof NumberAndAddonsPurchaseInSchema
     */
    'numbers': Array<NumberProviderInSchema>;
    /**
     * 
     * @type {BusinessDataInSchema}
     * @memberof NumberAndAddonsPurchaseInSchema
     */
    'business': BusinessDataInSchema;
    /**
     * 
     * @type {Array<AddonsPurchaseDataInSchema>}
     * @memberof NumberAndAddonsPurchaseInSchema
     */
    'addons': Array<AddonsPurchaseDataInSchema>;
}

export const NumberAndAddonsPurchaseInSchemaPaymentModeEnum = {
    Card: 'CARD'
} as const;

export type NumberAndAddonsPurchaseInSchemaPaymentModeEnum = typeof NumberAndAddonsPurchaseInSchemaPaymentModeEnum[keyof typeof NumberAndAddonsPurchaseInSchemaPaymentModeEnum];

/**
 * 
 * @export
 * @interface NumberProviderInSchema
 */
export interface NumberProviderInSchema {
    /**
     * 
     * @type {string}
     * @memberof NumberProviderInSchema
     */
    'phone_number': string;
    /**
     * 
     * @type {string}
     * @memberof NumberProviderInSchema
     */
    'provider': string;
    /**
     * 
     * @type {AvailableNumberCountryCode}
     * @memberof NumberProviderInSchema
     */
    'country': AvailableNumberCountryCode;
    /**
     * 
     * @type {string}
     * @memberof NumberProviderInSchema
     */
    'label'?: string | null;
}


/**
 * 
 * @export
 * @interface NumberPurchaseInSchema
 */
export interface NumberPurchaseInSchema {
    /**
     * 
     * @type {number}
     * @memberof NumberPurchaseInSchema
     */
    'plan_id': number;
    /**
     * 
     * @type {string}
     * @memberof NumberPurchaseInSchema
     */
    'payment_mode'?: NumberPurchaseInSchemaPaymentModeEnum;
    /**
     * 
     * @type {string}
     * @memberof NumberPurchaseInSchema
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NumberPurchaseInSchema
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NumberPurchaseInSchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof NumberPurchaseInSchema
     */
    'phone_number': string;
    /**
     * 
     * @type {number}
     * @memberof NumberPurchaseInSchema
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof NumberPurchaseInSchema
     */
    'coupon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NumberPurchaseInSchema
     */
    'promotion_code'?: string | null;
    /**
     * 
     * @type {Array<NumberProviderInSchema>}
     * @memberof NumberPurchaseInSchema
     */
    'numbers': Array<NumberProviderInSchema>;
    /**
     * 
     * @type {BusinessDataInSchema}
     * @memberof NumberPurchaseInSchema
     */
    'business': BusinessDataInSchema;
}

export const NumberPurchaseInSchemaPaymentModeEnum = {
    Card: 'CARD'
} as const;

export type NumberPurchaseInSchemaPaymentModeEnum = typeof NumberPurchaseInSchemaPaymentModeEnum[keyof typeof NumberPurchaseInSchemaPaymentModeEnum];

/**
 * 
 * @export
 * @interface OnboardPartnerUserInSchema
 */
export interface OnboardPartnerUserInSchema {
    /**
     * 
     * @type {string}
     * @memberof OnboardPartnerUserInSchema
     */
    'mobile': string;
    /**
     * 
     * @type {string}
     * @memberof OnboardPartnerUserInSchema
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof OnboardPartnerUserInSchema
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof OnboardPartnerUserInSchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof OnboardPartnerUserInSchema
     */
    'coupon'?: string | null;
    /**
     * 
     * @type {SubscriptionPlanTerm}
     * @memberof OnboardPartnerUserInSchema
     */
    'term'?: SubscriptionPlanTerm;
}


/**
 * 
 * @export
 * @interface OnboardingInSchema
 */
export interface OnboardingInSchema {
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingInSchema
     */
    'has_watched_tour'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingInSchema
     */
    'has_set_incoming_call_flow'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingInSchema
     */
    'has_provisioned_number'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingInSchema
     */
    'has_completed_verification'?: boolean | null;
}
/**
 * 
 * @export
 * @interface OnboardingOutSchema
 */
export interface OnboardingOutSchema {
    /**
     * 
     * @type {number}
     * @memberof OnboardingOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingOutSchema
     */
    'has_watched_tour'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingOutSchema
     */
    'has_made_call'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingOutSchema
     */
    'has_invited_team_member'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingOutSchema
     */
    'has_set_incoming_call_flow'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingOutSchema
     */
    'has_provisioned_number'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingOutSchema
     */
    'has_completed_verification'?: boolean;
    /**
     * has completed typeform
     * @type {boolean}
     * @memberof OnboardingOutSchema
     */
    'has_completed_onboarding_form'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingOutSchema
     */
    'has_received_welcome_call'?: boolean;
}
/**
 * 
 * @export
 * @interface PagedAddonSubscriptionOutSchema
 */
export interface PagedAddonSubscriptionOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedAddonSubscriptionOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedAddonSubscriptionOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedAddonSubscriptionOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAddonSubscriptionOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAddonSubscriptionOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAddonSubscriptionOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedAddonSubscriptionOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedAddonSubscriptionOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<AddonSubscriptionOutSchema>}
     * @memberof PagedAddonSubscriptionOutSchema
     */
    'data': Array<AddonSubscriptionOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedAddressOutSchema
 */
export interface PagedAddressOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedAddressOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedAddressOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedAddressOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAddressOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAddressOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAddressOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedAddressOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedAddressOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<AddressOutSchema>}
     * @memberof PagedAddressOutSchema
     */
    'data': Array<AddressOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedAdminAddressOutSchema
 */
export interface PagedAdminAddressOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedAdminAddressOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedAdminAddressOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedAdminAddressOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAdminAddressOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAdminAddressOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAdminAddressOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedAdminAddressOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedAdminAddressOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<AdminAddressOutSchema>}
     * @memberof PagedAdminAddressOutSchema
     */
    'data': Array<AdminAddressOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedAdminAvailableAddressOutSchema
 */
export interface PagedAdminAvailableAddressOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedAdminAvailableAddressOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedAdminAvailableAddressOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedAdminAvailableAddressOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAdminAvailableAddressOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAdminAvailableAddressOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAdminAvailableAddressOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedAdminAvailableAddressOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedAdminAvailableAddressOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<AdminAvailableAddressOutSchema>}
     * @memberof PagedAdminAvailableAddressOutSchema
     */
    'data': Array<AdminAvailableAddressOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedAdminListVerificationDocumentOutSchema
 */
export interface PagedAdminListVerificationDocumentOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedAdminListVerificationDocumentOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedAdminListVerificationDocumentOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedAdminListVerificationDocumentOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAdminListVerificationDocumentOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAdminListVerificationDocumentOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAdminListVerificationDocumentOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedAdminListVerificationDocumentOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedAdminListVerificationDocumentOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<AdminListVerificationDocumentOutSchema>}
     * @memberof PagedAdminListVerificationDocumentOutSchema
     */
    'data': Array<AdminListVerificationDocumentOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedAdminVerificationDocumentOutSchema
 */
export interface PagedAdminVerificationDocumentOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedAdminVerificationDocumentOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedAdminVerificationDocumentOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedAdminVerificationDocumentOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAdminVerificationDocumentOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAdminVerificationDocumentOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAdminVerificationDocumentOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedAdminVerificationDocumentOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedAdminVerificationDocumentOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<AdminVerificationDocumentOutSchema>}
     * @memberof PagedAdminVerificationDocumentOutSchema
     */
    'data': Array<AdminVerificationDocumentOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedAgentCampaignMinimalSchema
 */
export interface PagedAgentCampaignMinimalSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedAgentCampaignMinimalSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedAgentCampaignMinimalSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedAgentCampaignMinimalSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAgentCampaignMinimalSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAgentCampaignMinimalSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAgentCampaignMinimalSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedAgentCampaignMinimalSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedAgentCampaignMinimalSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<AgentCampaignMinimalSchema>}
     * @memberof PagedAgentCampaignMinimalSchema
     */
    'data': Array<AgentCampaignMinimalSchema>;
}
/**
 * 
 * @export
 * @interface PagedAuditLogMinimalOutSchema
 */
export interface PagedAuditLogMinimalOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedAuditLogMinimalOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedAuditLogMinimalOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedAuditLogMinimalOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAuditLogMinimalOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAuditLogMinimalOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAuditLogMinimalOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedAuditLogMinimalOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedAuditLogMinimalOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<AuditLogMinimalOutSchema>}
     * @memberof PagedAuditLogMinimalOutSchema
     */
    'data': Array<AuditLogMinimalOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedAvailableAddressOutSchema
 */
export interface PagedAvailableAddressOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedAvailableAddressOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedAvailableAddressOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedAvailableAddressOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAvailableAddressOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAvailableAddressOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAvailableAddressOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedAvailableAddressOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedAvailableAddressOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<AvailableAddressOutSchema>}
     * @memberof PagedAvailableAddressOutSchema
     */
    'data': Array<AvailableAddressOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedAvailableCountryOutSchema
 */
export interface PagedAvailableCountryOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedAvailableCountryOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedAvailableCountryOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedAvailableCountryOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAvailableCountryOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAvailableCountryOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAvailableCountryOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedAvailableCountryOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedAvailableCountryOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<AvailableCountryOutSchema>}
     * @memberof PagedAvailableCountryOutSchema
     */
    'data': Array<AvailableCountryOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedAvailableNumberOutSchema
 */
export interface PagedAvailableNumberOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedAvailableNumberOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedAvailableNumberOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedAvailableNumberOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAvailableNumberOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAvailableNumberOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedAvailableNumberOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedAvailableNumberOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedAvailableNumberOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<AvailableNumberOutSchema>}
     * @memberof PagedAvailableNumberOutSchema
     */
    'data': Array<AvailableNumberOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedBlogOutSchema
 */
export interface PagedBlogOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedBlogOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedBlogOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedBlogOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedBlogOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedBlogOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedBlogOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedBlogOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedBlogOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<BlogOutSchema>}
     * @memberof PagedBlogOutSchema
     */
    'data': Array<BlogOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedBusinessCallLogOutSchema
 */
export interface PagedBusinessCallLogOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedBusinessCallLogOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedBusinessCallLogOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedBusinessCallLogOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedBusinessCallLogOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedBusinessCallLogOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedBusinessCallLogOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedBusinessCallLogOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedBusinessCallLogOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<BusinessCallLogOutSchema>}
     * @memberof PagedBusinessCallLogOutSchema
     */
    'data': Array<BusinessCallLogOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedBusinessMinimalOutSchema
 */
export interface PagedBusinessMinimalOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedBusinessMinimalOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedBusinessMinimalOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedBusinessMinimalOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedBusinessMinimalOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedBusinessMinimalOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedBusinessMinimalOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedBusinessMinimalOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedBusinessMinimalOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<BusinessMinimalOutSchema>}
     * @memberof PagedBusinessMinimalOutSchema
     */
    'data': Array<BusinessMinimalOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedBusinessNumberBusinessOutSchema
 */
export interface PagedBusinessNumberBusinessOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedBusinessNumberBusinessOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedBusinessNumberBusinessOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedBusinessNumberBusinessOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedBusinessNumberBusinessOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedBusinessNumberBusinessOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedBusinessNumberBusinessOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedBusinessNumberBusinessOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedBusinessNumberBusinessOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<BusinessNumberBusinessOutSchema>}
     * @memberof PagedBusinessNumberBusinessOutSchema
     */
    'data': Array<BusinessNumberBusinessOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedCallLogMinimalOutV2Schema
 */
export interface PagedCallLogMinimalOutV2Schema {
    /**
     * 
     * @type {string}
     * @memberof PagedCallLogMinimalOutV2Schema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedCallLogMinimalOutV2Schema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedCallLogMinimalOutV2Schema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedCallLogMinimalOutV2Schema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedCallLogMinimalOutV2Schema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedCallLogMinimalOutV2Schema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedCallLogMinimalOutV2Schema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedCallLogMinimalOutV2Schema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<CallLogMinimalOutV2Schema>}
     * @memberof PagedCallLogMinimalOutV2Schema
     */
    'data': Array<CallLogMinimalOutV2Schema>;
}
/**
 * 
 * @export
 * @interface PagedCallLogOutSchema
 */
export interface PagedCallLogOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedCallLogOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedCallLogOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedCallLogOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedCallLogOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedCallLogOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedCallLogOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedCallLogOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedCallLogOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<CallLogOutSchema>}
     * @memberof PagedCallLogOutSchema
     */
    'data': Array<CallLogOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedCallQueueContactOutSchema
 */
export interface PagedCallQueueContactOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedCallQueueContactOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedCallQueueContactOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedCallQueueContactOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedCallQueueContactOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedCallQueueContactOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedCallQueueContactOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedCallQueueContactOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedCallQueueContactOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<CallQueueContactOutSchema>}
     * @memberof PagedCallQueueContactOutSchema
     */
    'data': Array<CallQueueContactOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedCallQueueContactOutSchema2
 */
export interface PagedCallQueueContactOutSchema2 {
    /**
     * 
     * @type {string}
     * @memberof PagedCallQueueContactOutSchema2
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedCallQueueContactOutSchema2
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedCallQueueContactOutSchema2
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedCallQueueContactOutSchema2
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedCallQueueContactOutSchema2
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedCallQueueContactOutSchema2
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedCallQueueContactOutSchema2
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedCallQueueContactOutSchema2
     */
    'next': string | null;
    /**
     * 
     * @type {Array<CallQueueContactOutSchema2>}
     * @memberof PagedCallQueueContactOutSchema2
     */
    'data': Array<CallQueueContactOutSchema2>;
}
/**
 * 
 * @export
 * @interface PagedCallQueueOutSchema
 */
export interface PagedCallQueueOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedCallQueueOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedCallQueueOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedCallQueueOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedCallQueueOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedCallQueueOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedCallQueueOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedCallQueueOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedCallQueueOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<CallQueueOutSchema>}
     * @memberof PagedCallQueueOutSchema
     */
    'data': Array<CallQueueOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedCallScriptOutSchema
 */
export interface PagedCallScriptOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedCallScriptOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedCallScriptOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedCallScriptOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedCallScriptOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedCallScriptOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedCallScriptOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedCallScriptOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedCallScriptOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<CallScriptOutSchema>}
     * @memberof PagedCallScriptOutSchema
     */
    'data': Array<CallScriptOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedCampaignContactOutSchema
 */
export interface PagedCampaignContactOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedCampaignContactOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedCampaignContactOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedCampaignContactOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedCampaignContactOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedCampaignContactOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedCampaignContactOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedCampaignContactOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedCampaignContactOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<CampaignContactOutSchema>}
     * @memberof PagedCampaignContactOutSchema
     */
    'data': Array<CampaignContactOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedCampaignListSchema
 */
export interface PagedCampaignListSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedCampaignListSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedCampaignListSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedCampaignListSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedCampaignListSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedCampaignListSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedCampaignListSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedCampaignListSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedCampaignListSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<CampaignListSchema>}
     * @memberof PagedCampaignListSchema
     */
    'data': Array<CampaignListSchema>;
}
/**
 * 
 * @export
 * @interface PagedChatterWaveOutSchema
 */
export interface PagedChatterWaveOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedChatterWaveOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedChatterWaveOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedChatterWaveOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedChatterWaveOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedChatterWaveOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedChatterWaveOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedChatterWaveOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedChatterWaveOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<ChatterWaveOutSchema>}
     * @memberof PagedChatterWaveOutSchema
     */
    'data': Array<ChatterWaveOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedConversationItemOutSchema
 */
export interface PagedConversationItemOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedConversationItemOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedConversationItemOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedConversationItemOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedConversationItemOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedConversationItemOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedConversationItemOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedConversationItemOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedConversationItemOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<ConversationItemOutSchema>}
     * @memberof PagedConversationItemOutSchema
     */
    'data': Array<ConversationItemOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedConversationNoteOutSchema
 */
export interface PagedConversationNoteOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedConversationNoteOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedConversationNoteOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedConversationNoteOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedConversationNoteOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedConversationNoteOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedConversationNoteOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedConversationNoteOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedConversationNoteOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<ConversationNoteOutSchema>}
     * @memberof PagedConversationNoteOutSchema
     */
    'data': Array<ConversationNoteOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedConversationOutSchema
 */
export interface PagedConversationOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedConversationOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedConversationOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedConversationOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedConversationOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedConversationOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedConversationOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedConversationOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedConversationOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<ConversationOutSchema>}
     * @memberof PagedConversationOutSchema
     */
    'data': Array<ConversationOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedDemoVideoOutSchema
 */
export interface PagedDemoVideoOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedDemoVideoOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedDemoVideoOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedDemoVideoOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedDemoVideoOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedDemoVideoOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedDemoVideoOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedDemoVideoOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedDemoVideoOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<DemoVideoOutSchema>}
     * @memberof PagedDemoVideoOutSchema
     */
    'data': Array<DemoVideoOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedDialGroupOutSchema
 */
export interface PagedDialGroupOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedDialGroupOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedDialGroupOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedDialGroupOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedDialGroupOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedDialGroupOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedDialGroupOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedDialGroupOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedDialGroupOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<DialGroupOutSchema>}
     * @memberof PagedDialGroupOutSchema
     */
    'data': Array<DialGroupOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedInvitationOutSchema
 */
export interface PagedInvitationOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedInvitationOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedInvitationOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedInvitationOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedInvitationOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedInvitationOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedInvitationOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedInvitationOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedInvitationOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<InvitationOutSchema>}
     * @memberof PagedInvitationOutSchema
     */
    'data': Array<InvitationOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedInvoiceOutSchema
 */
export interface PagedInvoiceOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedInvoiceOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedInvoiceOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedInvoiceOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedInvoiceOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedInvoiceOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedInvoiceOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedInvoiceOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedInvoiceOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<InvoiceOutSchema>}
     * @memberof PagedInvoiceOutSchema
     */
    'data': Array<InvoiceOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedKnowledgeBaseSubTopicOutSchema
 */
export interface PagedKnowledgeBaseSubTopicOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedKnowledgeBaseSubTopicOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedKnowledgeBaseSubTopicOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedKnowledgeBaseSubTopicOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedKnowledgeBaseSubTopicOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedKnowledgeBaseSubTopicOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedKnowledgeBaseSubTopicOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedKnowledgeBaseSubTopicOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedKnowledgeBaseSubTopicOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<KnowledgeBaseSubTopicOutSchema>}
     * @memberof PagedKnowledgeBaseSubTopicOutSchema
     */
    'data': Array<KnowledgeBaseSubTopicOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedKnowledgeBaseTopicOutSchema
 */
export interface PagedKnowledgeBaseTopicOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedKnowledgeBaseTopicOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedKnowledgeBaseTopicOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedKnowledgeBaseTopicOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedKnowledgeBaseTopicOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedKnowledgeBaseTopicOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedKnowledgeBaseTopicOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedKnowledgeBaseTopicOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedKnowledgeBaseTopicOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<KnowledgeBaseTopicOutSchema>}
     * @memberof PagedKnowledgeBaseTopicOutSchema
     */
    'data': Array<KnowledgeBaseTopicOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedLeaderBoardReportOutSchema
 */
export interface PagedLeaderBoardReportOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedLeaderBoardReportOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedLeaderBoardReportOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedLeaderBoardReportOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedLeaderBoardReportOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedLeaderBoardReportOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedLeaderBoardReportOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedLeaderBoardReportOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedLeaderBoardReportOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<LeaderBoardReportOutSchema>}
     * @memberof PagedLeaderBoardReportOutSchema
     */
    'data': Array<LeaderBoardReportOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedMOHOutSchema
 */
export interface PagedMOHOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedMOHOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedMOHOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedMOHOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedMOHOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedMOHOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedMOHOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedMOHOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedMOHOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<MOHOutSchema>}
     * @memberof PagedMOHOutSchema
     */
    'data': Array<MOHOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedMediaBlobsOutSchema
 */
export interface PagedMediaBlobsOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedMediaBlobsOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedMediaBlobsOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedMediaBlobsOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedMediaBlobsOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedMediaBlobsOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedMediaBlobsOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedMediaBlobsOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedMediaBlobsOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<MediaBlobsOutSchema>}
     * @memberof PagedMediaBlobsOutSchema
     */
    'data': Array<MediaBlobsOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedMinimalUserContactSchema
 */
export interface PagedMinimalUserContactSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedMinimalUserContactSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedMinimalUserContactSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedMinimalUserContactSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedMinimalUserContactSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedMinimalUserContactSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedMinimalUserContactSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedMinimalUserContactSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedMinimalUserContactSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<MinimalUserContactSchema>}
     * @memberof PagedMinimalUserContactSchema
     */
    'data': Array<MinimalUserContactSchema>;
}
/**
 * 
 * @export
 * @interface PagedNotificationOutSchema
 */
export interface PagedNotificationOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedNotificationOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedNotificationOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedNotificationOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedNotificationOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedNotificationOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedNotificationOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedNotificationOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedNotificationOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<NotificationOutSchema>}
     * @memberof PagedNotificationOutSchema
     */
    'data': Array<NotificationOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedPartnerUserOutSchema
 */
export interface PagedPartnerUserOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedPartnerUserOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedPartnerUserOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedPartnerUserOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedPartnerUserOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedPartnerUserOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedPartnerUserOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedPartnerUserOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedPartnerUserOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<PartnerUserOutSchema>}
     * @memberof PagedPartnerUserOutSchema
     */
    'data': Array<PartnerUserOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedPaymentHistoryOutSchema
 */
export interface PagedPaymentHistoryOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedPaymentHistoryOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedPaymentHistoryOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedPaymentHistoryOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedPaymentHistoryOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedPaymentHistoryOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedPaymentHistoryOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedPaymentHistoryOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedPaymentHistoryOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<PaymentHistoryOutSchema>}
     * @memberof PagedPaymentHistoryOutSchema
     */
    'data': Array<PaymentHistoryOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedPendingPaymentOutSchema
 */
export interface PagedPendingPaymentOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedPendingPaymentOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedPendingPaymentOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedPendingPaymentOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedPendingPaymentOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedPendingPaymentOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedPendingPaymentOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedPendingPaymentOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedPendingPaymentOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<PendingPaymentOutSchema>}
     * @memberof PagedPendingPaymentOutSchema
     */
    'data': Array<PendingPaymentOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedPreSaleBusinessInformationOutSchema
 */
export interface PagedPreSaleBusinessInformationOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedPreSaleBusinessInformationOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedPreSaleBusinessInformationOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedPreSaleBusinessInformationOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedPreSaleBusinessInformationOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedPreSaleBusinessInformationOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedPreSaleBusinessInformationOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedPreSaleBusinessInformationOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedPreSaleBusinessInformationOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<PreSaleBusinessInformationOutSchema>}
     * @memberof PagedPreSaleBusinessInformationOutSchema
     */
    'data': Array<PreSaleBusinessInformationOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedProfileMinimalOutSchemaV2
 */
export interface PagedProfileMinimalOutSchemaV2 {
    /**
     * 
     * @type {string}
     * @memberof PagedProfileMinimalOutSchemaV2
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedProfileMinimalOutSchemaV2
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedProfileMinimalOutSchemaV2
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedProfileMinimalOutSchemaV2
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedProfileMinimalOutSchemaV2
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedProfileMinimalOutSchemaV2
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedProfileMinimalOutSchemaV2
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedProfileMinimalOutSchemaV2
     */
    'next': string | null;
    /**
     * 
     * @type {Array<ProfileMinimalOutSchemaV2>}
     * @memberof PagedProfileMinimalOutSchemaV2
     */
    'data': Array<ProfileMinimalOutSchemaV2>;
}
/**
 * 
 * @export
 * @interface PagedReceiverExtensionOutSchema
 */
export interface PagedReceiverExtensionOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedReceiverExtensionOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedReceiverExtensionOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedReceiverExtensionOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedReceiverExtensionOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedReceiverExtensionOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedReceiverExtensionOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedReceiverExtensionOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedReceiverExtensionOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<ReceiverExtensionOutSchema>}
     * @memberof PagedReceiverExtensionOutSchema
     */
    'data': Array<ReceiverExtensionOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedRequestAssistanceOutSchema
 */
export interface PagedRequestAssistanceOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedRequestAssistanceOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedRequestAssistanceOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedRequestAssistanceOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedRequestAssistanceOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedRequestAssistanceOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedRequestAssistanceOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedRequestAssistanceOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedRequestAssistanceOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<RequestAssistanceOutSchema>}
     * @memberof PagedRequestAssistanceOutSchema
     */
    'data': Array<RequestAssistanceOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedStandardizedApiKeyOutSchema
 */
export interface PagedStandardizedApiKeyOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedStandardizedApiKeyOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedStandardizedApiKeyOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedStandardizedApiKeyOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedStandardizedApiKeyOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedStandardizedApiKeyOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedStandardizedApiKeyOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedStandardizedApiKeyOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedStandardizedApiKeyOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<StandardizedApiKeyOutSchema>}
     * @memberof PagedStandardizedApiKeyOutSchema
     */
    'data': Array<StandardizedApiKeyOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedSubscriptionPlanOutSchema
 */
export interface PagedSubscriptionPlanOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedSubscriptionPlanOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedSubscriptionPlanOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedSubscriptionPlanOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedSubscriptionPlanOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedSubscriptionPlanOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedSubscriptionPlanOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedSubscriptionPlanOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedSubscriptionPlanOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<SubscriptionPlanOutSchema>}
     * @memberof PagedSubscriptionPlanOutSchema
     */
    'data': Array<SubscriptionPlanOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedTagOutSchema
 */
export interface PagedTagOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedTagOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedTagOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedTagOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedTagOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedTagOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedTagOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedTagOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedTagOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<TagOutSchema>}
     * @memberof PagedTagOutSchema
     */
    'data': Array<TagOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedTeamMemberMinimalOutSchema
 */
export interface PagedTeamMemberMinimalOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedTeamMemberMinimalOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedTeamMemberMinimalOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedTeamMemberMinimalOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedTeamMemberMinimalOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedTeamMemberMinimalOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedTeamMemberMinimalOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedTeamMemberMinimalOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedTeamMemberMinimalOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<TeamMemberMinimalOutSchema>}
     * @memberof PagedTeamMemberMinimalOutSchema
     */
    'data': Array<TeamMemberMinimalOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedVerificationDocumentOutSchema
 */
export interface PagedVerificationDocumentOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedVerificationDocumentOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedVerificationDocumentOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedVerificationDocumentOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedVerificationDocumentOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedVerificationDocumentOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedVerificationDocumentOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedVerificationDocumentOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedVerificationDocumentOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<VerificationDocumentOutSchema>}
     * @memberof PagedVerificationDocumentOutSchema
     */
    'data': Array<VerificationDocumentOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedVoiceScriptOutSchema
 */
export interface PagedVoiceScriptOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedVoiceScriptOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedVoiceScriptOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedVoiceScriptOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedVoiceScriptOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedVoiceScriptOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedVoiceScriptOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedVoiceScriptOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedVoiceScriptOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<VoiceScriptOutSchema>}
     * @memberof PagedVoiceScriptOutSchema
     */
    'data': Array<VoiceScriptOutSchema>;
}
/**
 * 
 * @export
 * @interface PagedVoicemailMessageOutSchema
 */
export interface PagedVoicemailMessageOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PagedVoicemailMessageOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PagedVoicemailMessageOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedVoicemailMessageOutSchema
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PagedVoicemailMessageOutSchema
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PagedVoicemailMessageOutSchema
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PagedVoicemailMessageOutSchema
     */
    'nb_pages': number;
    /**
     * 
     * @type {string}
     * @memberof PagedVoicemailMessageOutSchema
     */
    'previous': string | null;
    /**
     * 
     * @type {string}
     * @memberof PagedVoicemailMessageOutSchema
     */
    'next': string | null;
    /**
     * 
     * @type {Array<VoicemailMessageOutSchema>}
     * @memberof PagedVoicemailMessageOutSchema
     */
    'data': Array<VoicemailMessageOutSchema>;
}
/**
 * 
 * @export
 * @interface Param
 */
export interface Param {
}
/**
 * 
 * @export
 * @interface PartnerBusinessSubscriptionOutSchema
 */
export interface PartnerBusinessSubscriptionOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PartnerBusinessSubscriptionOutSchema
     */
    'plan': string;
    /**
     * 
     * @type {string}
     * @memberof PartnerBusinessSubscriptionOutSchema
     */
    'term': string;
    /**
     * 
     * @type {number}
     * @memberof PartnerBusinessSubscriptionOutSchema
     */
    'standard_cost': number;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerBusinessSubscriptionOutSchema
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PartnerBusinessSubscriptionOutSchema
     */
    'date_created': string;
    /**
     * 
     * @type {number}
     * @memberof PartnerBusinessSubscriptionOutSchema
     */
    'billing_day'?: number | null;
}
/**
 * 
 * @export
 * @interface PartnerUserFilterSchema
 */
export interface PartnerUserFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof PartnerUserFilterSchema
     */
    'mobile'?: string | null;
}
/**
 * 
 * @export
 * @interface PartnerUserOutSchema
 */
export interface PartnerUserOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PartnerUserOutSchema
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerUserOutSchema
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerUserOutSchema
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerUserOutSchema
     */
    'mobile'?: string | null;
    /**
     * 
     * @type {PartnerBusinessSubscriptionOutSchema}
     * @memberof PartnerUserOutSchema
     */
    'subscription'?: PartnerBusinessSubscriptionOutSchema | null;
    /**
     * 
     * @type {string}
     * @memberof PartnerUserOutSchema
     */
    'date_created': string;
}
/**
 * 
 * @export
 * @interface PasswordChangeInSchema
 */
export interface PasswordChangeInSchema {
    /**
     * 
     * @type {string}
     * @memberof PasswordChangeInSchema
     */
    'new_password': string;
    /**
     * 
     * @type {string}
     * @memberof PasswordChangeInSchema
     */
    'old_password': string;
}
/**
 * 
 * @export
 * @interface PasswordResetConfirmInSchema
 */
export interface PasswordResetConfirmInSchema {
    /**
     * 
     * @type {string}
     * @memberof PasswordResetConfirmInSchema
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof PasswordResetConfirmInSchema
     */
    'uid': string;
    /**
     * 
     * @type {boolean}
     * @memberof PasswordResetConfirmInSchema
     */
    'is_email_verification'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PasswordResetConfirmInSchema
     */
    'new_password': string;
}
/**
 * 
 * @export
 * @interface PauseSubscriptionInSchema
 */
export interface PauseSubscriptionInSchema {
    /**
     * 
     * @type {number}
     * @memberof PauseSubscriptionInSchema
     */
    'business_id': number;
    /**
     * 
     * @type {number}
     * @memberof PauseSubscriptionInSchema
     */
    'pause_duration_months': number;
    /**
     * 
     * @type {string}
     * @memberof PauseSubscriptionInSchema
     */
    'submitted_by': string;
}
/**
 * 
 * @export
 * @interface Payload
 */
export interface Payload {
    /**
     * 
     * @type {Array<IVRMenuConfigurationInSchema>}
     * @memberof Payload
     */
    'menus': Array<IVRMenuConfigurationInSchema>;
    /**
     * 
     * @type {Array<CallCenterConfigurationInSchema>}
     * @memberof Payload
     */
    'call_centers'?: Array<CallCenterConfigurationInSchema>;
    /**
     * 
     * @type {Array<RingGroupConfigurationInSchema>}
     * @memberof Payload
     */
    'ring_groups'?: Array<RingGroupConfigurationInSchema>;
    /**
     * 
     * @type {Array<IVREntryConfigurationInSchema>}
     * @memberof Payload
     */
    'entries': Array<IVREntryConfigurationInSchema>;
    /**
     * 
     * @type {string}
     * @memberof Payload
     */
    'id': string;
    /**
     * 
     * @type {RingGroupInStrategy}
     * @memberof Payload
     */
    'ring_strategy'?: RingGroupInStrategy;
    /**
     * 
     * @type {Array<number>}
     * @memberof Payload
     */
    'ring_group_users': Array<number>;
    /**
     * 
     * @type {CallCenterStrategy}
     * @memberof Payload
     */
    'strategy'?: CallCenterStrategy;
    /**
     * 
     * @type {Array<number>}
     * @memberof Payload
     */
    'call_center_users': Array<number>;
}


/**
 * 
 * @export
 * @interface PaymentHistoryFilterSchema
 */
export interface PaymentHistoryFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof PaymentHistoryFilterSchema
     */
    'date_created_before'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentHistoryFilterSchema
     */
    'date_created_after'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentHistoryFilterSchema
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentHistoryFilterSchema
     */
    'amount_paid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentHistoryFilterSchema
     */
    'ref'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentHistoryFilterSchema
     */
    'source'?: string | null;
}
/**
 * 
 * @export
 * @interface PaymentHistoryOutSchema
 */
export interface PaymentHistoryOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PaymentHistoryOutSchema
     */
    'date_created': string;
    /**
     * 
     * @type {number}
     * @memberof PaymentHistoryOutSchema
     */
    'amount_paid': number;
    /**
     * 
     * @type {string}
     * @memberof PaymentHistoryOutSchema
     */
    'payment_type': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentHistoryOutSchema
     */
    'status': string;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentHistoryOutSchema
     */
    'payment_successful': boolean;
    /**
     * 
     * @type {string}
     * @memberof PaymentHistoryOutSchema
     */
    'source': string;
    /**
     * 
     * @type {number}
     * @memberof PaymentHistoryOutSchema
     */
    'user_id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentHistoryOutSchema
     */
    'ref'?: string | null;
}
/**
 * Wallet mode will debit from user\'s wallet   Charge authorization mode will use existing card authorization to debit user   Card mode will take them to paystack\'s payment page Airtime mode will debit from business\'s balance
 * @export
 * @enum {string}
 */

export const PaymentMode = {
    Wallet: 'WALLET',
    ChargeAuthorization: 'CHARGE_AUTHORIZATION',
    Card: 'CARD'
} as const;

export type PaymentMode = typeof PaymentMode[keyof typeof PaymentMode];


/**
 * 
 * @export
 * @interface PaymentPageDiscountSchema
 */
export interface PaymentPageDiscountSchema {
    /**
     * 
     * @type {number}
     * @memberof PaymentPageDiscountSchema
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof PaymentPageDiscountSchema
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface PaymentPageInSchema
 */
export interface PaymentPageInSchema {
    /**
     * 
     * @type {number}
     * @memberof PaymentPageInSchema
     */
    'plan_id': number;
    /**
     * 
     * @type {string}
     * @memberof PaymentPageInSchema
     */
    'payment_mode'?: PaymentPageInSchemaPaymentModeEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentPageInSchema
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentPageInSchema
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentPageInSchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentPageInSchema
     */
    'phone_number': string;
    /**
     * 
     * @type {number}
     * @memberof PaymentPageInSchema
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentPageInSchema
     */
    'coupon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentPageInSchema
     */
    'promotion_code'?: string | null;
}

export const PaymentPageInSchemaPaymentModeEnum = {
    Card: 'CARD'
} as const;

export type PaymentPageInSchemaPaymentModeEnum = typeof PaymentPageInSchemaPaymentModeEnum[keyof typeof PaymentPageInSchemaPaymentModeEnum];

/**
 * 
 * @export
 * @interface PaymentPageOutSchema
 */
export interface PaymentPageOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PaymentPageOutSchema
     */
    'access_code': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentPageOutSchema
     */
    'ref': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentPageOutSchema
     */
    'temp_authorization_url': string;
    /**
     * 
     * @type {PaymentPageDiscountSchema}
     * @memberof PaymentPageOutSchema
     */
    'discount'?: PaymentPageDiscountSchema | null;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentPageOutSchema
     */
    'newly_created'?: boolean | null;
}
/**
 * Schema for payment information
 * @export
 * @interface PaymentSchema
 */
export interface PaymentSchema {
    /**
     * 
     * @type {number}
     * @memberof PaymentSchema
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof PaymentSchema
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentSchema
     */
    'payment_type': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentSchema
     */
    'payment_status': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentSchema
     */
    'date_created': string;
}
/**
 * 
 * @export
 * @interface PendingPaymentOutSchema
 */
export interface PendingPaymentOutSchema {
    /**
     * 
     * @type {SubscriptionPlanOutSchema}
     * @memberof PendingPaymentOutSchema
     */
    'subscription_plan': SubscriptionPlanOutSchema;
    /**
     * 
     * @type {string}
     * @memberof PendingPaymentOutSchema
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingPaymentOutSchema
     */
    'ref'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PendingPaymentOutSchema
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof PendingPaymentOutSchema
     */
    'business'?: number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Period = {
    ThisWeek: 'this_week',
    ThisMonth: 'this_month',
    ThisYear: 'this_year',
    LastThirtyDays: 'last_thirty_days',
    LastNinetyDays: 'last_ninety_days',
    Today: 'today',
    Custom: 'custom'
} as const;

export type Period = typeof Period[keyof typeof Period];


/**
 * 
 * @export
 * @interface PermissionInSchema
 */
export interface PermissionInSchema {
    /**
     * 
     * @type {boolean}
     * @memberof PermissionInSchema
     */
    'can_export_call_logs'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionInSchema
     */
    'can_view_all_call_logs'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionInSchema
     */
    'can_export_contact'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionInSchema
     */
    'can_export_report'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionInSchema
     */
    'can_manage_billing'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionInSchema
     */
    'can_manage_team'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionInSchema
     */
    'can_manage_permissions'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionInSchema
     */
    'can_manage_personalization'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionInSchema
     */
    'can_access_call_recordings'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionInSchema
     */
    'can_download_call_recordings'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionInSchema
     */
    'can_view_performance_report'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionInSchema
     */
    'can_view_activity_report'?: boolean | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof PermissionInSchema
     */
    'business_numbers': Array<number>;
    /**
     * 
     * @type {ProfileRole}
     * @memberof PermissionInSchema
     */
    'role'?: ProfileRole | null;
}


/**
 * 
 * @export
 * @interface PermissionOutSchema
 */
export interface PermissionOutSchema {
    /**
     * 
     * @type {boolean}
     * @memberof PermissionOutSchema
     */
    'can_export_call_logs'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionOutSchema
     */
    'can_view_all_call_logs'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionOutSchema
     */
    'can_export_contact'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionOutSchema
     */
    'can_export_report'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionOutSchema
     */
    'can_manage_billing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionOutSchema
     */
    'can_manage_team'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionOutSchema
     */
    'can_manage_permissions'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionOutSchema
     */
    'can_manage_personalization'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionOutSchema
     */
    'can_access_call_recordings'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionOutSchema
     */
    'can_download_call_recordings'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionOutSchema
     */
    'can_view_performance_report'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionOutSchema
     */
    'can_view_activity_report'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof PermissionOutSchema
     */
    'business_numbers': Array<number>;
}
/**
 * Schema for person information
 * @export
 * @interface PersonSchema
 */
export interface PersonSchema {
    /**
     * 
     * @type {string}
     * @memberof PersonSchema
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PersonSchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PersonSchema
     */
    'date_created': string;
}
/**
 * 
 * @export
 * @interface PlanFilterSchema
 */
export interface PlanFilterSchema {
    /**
     * 
     * @type {Array<number>}
     * @memberof PlanFilterSchema
     */
    'plan_id': Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PlanFilterSchema
     */
    'quantity'?: Array<number> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PositionChoice = {
    Before: 'before',
    After: 'after'
} as const;

export type PositionChoice = typeof PositionChoice[keyof typeof PositionChoice];


/**
 * 
 * @export
 * @interface PostOnboardingFormInSchema
 */
export interface PostOnboardingFormInSchema {
    /**
     * 
     * @type {Array<PostOnboardingFormMinInSchema>}
     * @memberof PostOnboardingFormInSchema
     */
    'data': Array<PostOnboardingFormMinInSchema>;
    /**
     * 
     * @type {boolean}
     * @memberof PostOnboardingFormInSchema
     */
    'is_for_new_business'?: boolean;
    /**
     * 
     * @type {PostOnboardingFormType}
     * @memberof PostOnboardingFormInSchema
     */
    'form_type': PostOnboardingFormType;
}


/**
 * 
 * @export
 * @interface PostOnboardingFormMinInSchema
 */
export interface PostOnboardingFormMinInSchema {
    /**
     * 
     * @type {string}
     * @memberof PostOnboardingFormMinInSchema
     */
    'question': string;
    /**
     * 
     * @type {string}
     * @memberof PostOnboardingFormMinInSchema
     */
    'answer': string;
}
/**
 * 
 * @export
 * @interface PostOnboardingFormOutSchema
 */
export interface PostOnboardingFormOutSchema {
    /**
     * 
     * @type {number}
     * @memberof PostOnboardingFormOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PostOnboardingFormOutSchema
     */
    'business'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PostOnboardingFormOutSchema
     */
    'form_type'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PostOnboardingFormOutSchema
     */
    'is_for_new_business'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PostOnboardingFormOutSchema
     */
    'record_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostOnboardingFormOutSchema
     */
    'question': string;
    /**
     * 
     * @type {string}
     * @memberof PostOnboardingFormOutSchema
     */
    'answer': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PostOnboardingFormType = {
    Admin: 'admin',
    Agent: 'agent'
} as const;

export type PostOnboardingFormType = typeof PostOnboardingFormType[keyof typeof PostOnboardingFormType];


/**
 * 
 * @export
 * @interface PreSaleBusinessInformationInSchema
 */
export interface PreSaleBusinessInformationInSchema {
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationInSchema
     */
    'mobile': string;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationInSchema
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationInSchema
     */
    'last_name': string;
    /**
     * 
     * @type {number}
     * @memberof PreSaleBusinessInformationInSchema
     */
    'team_size': number;
    /**
     * 
     * @type {boolean}
     * @memberof PreSaleBusinessInformationInSchema
     */
    'makes_international_calls': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PreSaleBusinessInformationInSchema
     */
    'requires_usa_number': boolean;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationInSchema
     */
    'email': string;
    /**
     * 
     * @type {number}
     * @memberof PreSaleBusinessInformationInSchema
     */
    'plan_id': number;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationInSchema
     */
    'sector': string;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationInSchema
     */
    'business_name': string;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationInSchema
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationInSchema
     */
    'referral_source'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationInSchema
     */
    'promotion_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationInSchema
     */
    'job_title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PreSaleBusinessInformationInSchema
     */
    'user_id'?: number | null;
    /**
     * 
     * @type {SignUpFlow}
     * @memberof PreSaleBusinessInformationInSchema
     */
    'signup_flow'?: SignUpFlow | null;
}


/**
 * 
 * @export
 * @interface PreSaleBusinessInformationOutSchema
 */
export interface PreSaleBusinessInformationOutSchema {
    /**
     * 
     * @type {number}
     * @memberof PreSaleBusinessInformationOutSchema
     */
    'team_size'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PreSaleBusinessInformationOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationOutSchema
     */
    'business_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationOutSchema
     */
    'job_title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationOutSchema
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationOutSchema
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationOutSchema
     */
    'mobile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationOutSchema
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationOutSchema
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationOutSchema
     */
    'sector'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PreSaleBusinessInformationOutSchema
     */
    'number_of_calls_per_day'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationOutSchema
     */
    'number_of_calls_per_week'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PreSaleBusinessInformationOutSchema
     */
    'makes_international_calls'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PreSaleBusinessInformationOutSchema
     */
    'requires_usa_number'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PreSaleBusinessInformationOutSchema
     */
    'plan'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationOutSchema
     */
    'referral_source'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationOutSchema
     */
    'signup_flow'?: string | null;
}
/**
 * 
 * @export
 * @interface PreSaleBusinessInformationUpdateSchema
 */
export interface PreSaleBusinessInformationUpdateSchema {
    /**
     * 
     * @type {number}
     * @memberof PreSaleBusinessInformationUpdateSchema
     */
    'team_size'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PreSaleBusinessInformationUpdateSchema
     */
    'makes_international_calls'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PreSaleBusinessInformationUpdateSchema
     */
    'requires_usa_number'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationUpdateSchema
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationUpdateSchema
     */
    'sector'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationUpdateSchema
     */
    'business_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationUpdateSchema
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationUpdateSchema
     */
    'referral_source'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationUpdateSchema
     */
    'job_title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreSaleBusinessInformationUpdateSchema
     */
    'available_number'?: string | null;
    /**
     * 
     * @type {SignUpFlow}
     * @memberof PreSaleBusinessInformationUpdateSchema
     */
    'signup_flow'?: SignUpFlow | null;
}


/**
 * 
 * @export
 * @interface PresignedURLInSchema
 */
export interface PresignedURLInSchema {
    /**
     * 
     * @type {string}
     * @memberof PresignedURLInSchema
     */
    'file_name': string;
}
/**
 * 
 * @export
 * @interface PressoneAIOutSchema
 */
export interface PressoneAIOutSchema {
    /**
     * 
     * @type {Array<{ [key: string]: string; }>}
     * @memberof PressoneAIOutSchema
     */
    'transcribed_text'?: Array<{ [key: string]: string; }> | null;
    /**
     * 
     * @type {boolean}
     * @memberof PressoneAIOutSchema
     */
    'is_happy_customer'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PressoneAIOutSchema
     */
    'is_unhappy_agent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PressoneAIOutSchema
     */
    'is_unhappy_customer'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PressoneAIOutSchema
     */
    'agent_interrupted_customer'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PressoneAIOutSchema
     */
    'unhappy_to_happy'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PressoneAIOutSchema
     */
    'has_bad_words'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PressoneAIOutSchema
     */
    'call_too_quiet'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PressoneAIOutSchema
     */
    'talking_too_fast'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PressoneAIOutSchema
     */
    'talk_speed'?: string | null;
}
/**
 * 
 * @export
 * @interface ProfileInSchema
 */
export interface ProfileInSchema {
    /**
     * 
     * @type {string}
     * @memberof ProfileInSchema
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof ProfileInSchema
     */
    'last_name': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ProfileInvitationStatus = {
    Pending: 'pending',
    Accepted: 'accepted',
    AwaitingPayment: 'awaiting_payment',
    Expired: 'expired'
} as const;

export type ProfileInvitationStatus = typeof ProfileInvitationStatus[keyof typeof ProfileInvitationStatus];


/**
 * 
 * @export
 * @interface ProfileMinimalOutSchema
 */
export interface ProfileMinimalOutSchema {
    /**
     * 
     * @type {string}
     * @memberof ProfileMinimalOutSchema
     */
    'full_name': string;
    /**
     * 
     * @type {number}
     * @memberof ProfileMinimalOutSchema
     */
    'user_id': number;
    /**
     * 
     * @type {string}
     * @memberof ProfileMinimalOutSchema
     */
    'mobile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileMinimalOutSchema
     */
    'profile_picture'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileMinimalOutSchema
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof ProfileMinimalOutSchema
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileMinimalOutSchema
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface ProfileMinimalOutSchemaV2
 */
export interface ProfileMinimalOutSchemaV2 {
    /**
     * 
     * @type {string}
     * @memberof ProfileMinimalOutSchemaV2
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof ProfileMinimalOutSchemaV2
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileMinimalOutSchemaV2
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ProfileMinimalOutSchemaV2
     */
    'role'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProfileMinimalOutSchemaV2
     */
    'business': number;
    /**
     * 
     * @type {number}
     * @memberof ProfileMinimalOutSchemaV2
     */
    'user': number;
    /**
     * 
     * @type {string}
     * @memberof ProfileMinimalOutSchemaV2
     */
    'date_created': string;
}
/**
 * 
 * @export
 * @interface ProfileOutSchema
 */
export interface ProfileOutSchema {
    /**
     * 
     * @type {BusinessOutSchema}
     * @memberof ProfileOutSchema
     */
    'business': BusinessOutSchema;
    /**
     * 
     * @type {string}
     * @memberof ProfileOutSchema
     */
    'last_active'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileOutSchema
     */
    'mobile'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileOutSchema
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileOutSchema
     */
    'has_filled_engagement_form': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileOutSchema
     */
    'has_submitted_weekly_survey': boolean;
    /**
     * 
     * @type {string}
     * @memberof ProfileOutSchema
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof ProfileOutSchema
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileOutSchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ProfileOutSchema
     */
    'role'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProfileOutSchema
     */
    'user': number;
    /**
     * 
     * @type {string}
     * @memberof ProfileOutSchema
     */
    'date_created': string;
}
/**
 * 
 * @export
 * @interface ProfileOutSchemaV2
 */
export interface ProfileOutSchemaV2 {
    /**
     * 
     * @type {boolean}
     * @memberof ProfileOutSchemaV2
     */
    'has_filled_engagement_form': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileOutSchemaV2
     */
    'has_submitted_weekly_survey': boolean;
    /**
     * 
     * @type {string}
     * @memberof ProfileOutSchemaV2
     */
    'mobile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileOutSchemaV2
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof ProfileOutSchemaV2
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileOutSchemaV2
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ProfileOutSchemaV2
     */
    'role'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProfileOutSchemaV2
     */
    'business': number;
    /**
     * 
     * @type {number}
     * @memberof ProfileOutSchemaV2
     */
    'user': number;
    /**
     * 
     * @type {string}
     * @memberof ProfileOutSchemaV2
     */
    'date_created': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ProfileRole = {
    Owner: 'owner',
    Manager: 'manager',
    Agent: 'agent',
    Specialist: 'specialist'
} as const;

export type ProfileRole = typeof ProfileRole[keyof typeof ProfileRole];


/**
 * 
 * @export
 * @interface ProvisionNumberInSchemaV2
 */
export interface ProvisionNumberInSchemaV2 {
    /**
     * 
     * @type {Array<string>}
     * @memberof ProvisionNumberInSchemaV2
     */
    'numbers'?: Array<string>;
    /**
     * 
     * @type {BusinessInputSchema}
     * @memberof ProvisionNumberInSchemaV2
     */
    'business'?: BusinessInputSchema | null;
    /**
     * 
     * @type {number}
     * @memberof ProvisionNumberInSchemaV2
     */
    'business_id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProvisionNumberInSchemaV2
     */
    'payment_reference': string;
    /**
     * 
     * @type {number}
     * @memberof ProvisionNumberInSchemaV2
     */
    'parent_id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProvisionNumberInSchemaV2
     */
    'recipient_user_id'?: number | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ProvisionNumberInSchemaV2
     */
    'labels'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {string}
     * @memberof ProvisionNumberInSchemaV2
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProvisionNumberInSchemaV2
     */
    'provider'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProvisionNumberInSchemaV2
     */
    'provision_wallet'?: boolean;
    /**
     * 
     * @type {Array<NumberProviderInSchema>}
     * @memberof ProvisionNumberInSchemaV2
     */
    'numbers_data'?: Array<NumberProviderInSchema> | null;
}
/**
 * 
 * @export
 * @interface PusherAuthOutSchema
 */
export interface PusherAuthOutSchema {
    /**
     * 
     * @type {string}
     * @memberof PusherAuthOutSchema
     */
    'auth': string;
}
/**
 * 
 * @export
 * @interface QueueReorderSchema
 */
export interface QueueReorderSchema {
    /**
     * 
     * @type {string}
     * @memberof QueueReorderSchema
     */
    'moved_contact_id': string;
    /**
     * 
     * @type {string}
     * @memberof QueueReorderSchema
     */
    'cursor_contact_id': string;
    /**
     * 
     * @type {PositionChoice}
     * @memberof QueueReorderSchema
     */
    'action': PositionChoice;
}


/**
 * 
 * @export
 * @interface ReActivateSubscriptionInSchema
 */
export interface ReActivateSubscriptionInSchema {
    /**
     * 
     * @type {Array<number>}
     * @memberof ReActivateSubscriptionInSchema
     */
    'business_number_ids'?: Array<number>;
}
/**
 * 
 * @export
 * @interface ReactivateAccountInSchema
 */
export interface ReactivateAccountInSchema {
    /**
     * 
     * @type {number}
     * @memberof ReactivateAccountInSchema
     */
    'business_id': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReactivateAccountInSchema
     */
    'business_numbers'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ReactivateAccountInSchema
     */
    'submitted_by': string;
}
/**
 * 
 * @export
 * @interface ReceiverExtensionOutSchema
 */
export interface ReceiverExtensionOutSchema {
    /**
     * 
     * @type {number}
     * @memberof ReceiverExtensionOutSchema
     */
    'user_id': number;
    /**
     * 
     * @type {number}
     * @memberof ReceiverExtensionOutSchema
     */
    'extension': number;
}
/**
 * 
 * @export
 * @interface ReceiverLineInSchema
 */
export interface ReceiverLineInSchema {
    /**
     * 
     * @type {number}
     * @memberof ReceiverLineInSchema
     */
    'business_number_id'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReceiverLineInSchema
     */
    'is_no_trunk_team'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReceiverLineInSchema
     */
    'public_key': string;
}
/**
 * 
 * @export
 * @interface ReceiverLineOutSchema
 */
export interface ReceiverLineOutSchema {
    /**
     * 
     * @type {string}
     * @memberof ReceiverLineOutSchema
     */
    'password': string;
    /**
     * 
     * @type {number}
     * @memberof ReceiverLineOutSchema
     */
    'extension': number;
    /**
     * 
     * @type {number}
     * @memberof ReceiverLineOutSchema
     */
    'username': number;
    /**
     * 
     * @type {string}
     * @memberof ReceiverLineOutSchema
     */
    'host': string | null;
    /**
     * 
     * @type {string}
     * @memberof ReceiverLineOutSchema
     */
    'domain': string | null;
    /**
     * 
     * @type {number}
     * @memberof ReceiverLineOutSchema
     */
    'port': number;
    /**
     * 
     * @type {string}
     * @memberof ReceiverLineOutSchema
     */
    'protocol': string;
    /**
     * 
     * @type {number}
     * @memberof ReceiverLineOutSchema
     */
    'business_number_id'?: number | null;
}
/**
 * 
 * @export
 * @interface ReceiverNumberMinimalOutSchema
 */
export interface ReceiverNumberMinimalOutSchema {
    /**
     * 
     * @type {number}
     * @memberof ReceiverNumberMinimalOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReceiverNumberMinimalOutSchema
     */
    'extension_code': number;
    /**
     * 
     * @type {number}
     * @memberof ReceiverNumberMinimalOutSchema
     */
    'business_number': number;
}
/**
 * 
 * @export
 * @interface ReceiverNumberOutSchema
 */
export interface ReceiverNumberOutSchema {
    /**
     * 
     * @type {HermesReceiverOutSchema}
     * @memberof ReceiverNumberOutSchema
     */
    'line'?: HermesReceiverOutSchema | null;
    /**
     * 
     * @type {BusinessNumberMinimalOutSchema}
     * @memberof ReceiverNumberOutSchema
     */
    'business_number': BusinessNumberMinimalOutSchema;
    /**
     * 
     * @type {number}
     * @memberof ReceiverNumberOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReceiverNumberOutSchema
     */
    'extension_code': number;
    /**
     * 
     * @type {number}
     * @memberof ReceiverNumberOutSchema
     */
    'min_call_duration_limit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReceiverNumberOutSchema
     */
    'max_call_duration_limit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReceiverNumberOutSchema
     */
    'date_invited'?: string | null;
}
/**
 * 
 * @export
 * @interface RedirectURLResponse
 */
export interface RedirectURLResponse {
    /**
     * 
     * @type {string}
     * @memberof RedirectURLResponse
     */
    'redirect_url': string;
}
/**
 * 
 * @export
 * @interface ReduceRingTimeInSchema
 */
export interface ReduceRingTimeInSchema {
    /**
     * 
     * @type {number}
     * @memberof ReduceRingTimeInSchema
     */
    'business_id': number;
    /**
     * 
     * @type {number}
     * @memberof ReduceRingTimeInSchema
     */
    'ring_time_seconds': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReduceRingTimeInSchema
     */
    'business_numbers'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ReduceRingTimeInSchema
     */
    'submitted_by': string;
}
/**
 * 
 * @export
 * @interface RegisterUserOutSchema
 */
export interface RegisterUserOutSchema {
    /**
     * 
     * @type {number}
     * @memberof RegisterUserOutSchema
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserOutSchema
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserOutSchema
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserOutSchema
     */
    'personal_email': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserOutSchema
     */
    'mobile'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RegisterUserOutSchema
     */
    'has_business_number': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RegisterUserOutSchema
     */
    'is_team_member': boolean;
    /**
     * 
     * @type {number}
     * @memberof RegisterUserOutSchema
     */
    'recommended_plan'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof RegisterUserOutSchema
     */
    'has_pending_number_provisioning': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RegisterUserOutSchema
     */
    'newly_created'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserOutSchema
     */
    'global_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserOutSchema
     */
    'token': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ReminderType = {
    DayBefore: 'day_before',
    WeekBefore: 'week_before'
} as const;

export type ReminderType = typeof ReminderType[keyof typeof ReminderType];


/**
 * 
 * @export
 * @interface RemoveContactsFromCampaignSchema
 */
export interface RemoveContactsFromCampaignSchema {
    /**
     * 
     * @type {Array<string>}
     * @memberof RemoveContactsFromCampaignSchema
     */
    'contact_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface ReplaceCampaignBusinessNumberSchema
 */
export interface ReplaceCampaignBusinessNumberSchema {
    /**
     * 
     * @type {number}
     * @memberof ReplaceCampaignBusinessNumberSchema
     */
    'old_number_id': number;
    /**
     * 
     * @type {number}
     * @memberof ReplaceCampaignBusinessNumberSchema
     */
    'new_number_id': number;
}
/**
 * 
 * @export
 * @interface ReportFilterSchema
 */
export interface ReportFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof ReportFilterSchema
     */
    'start_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportFilterSchema
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {Period}
     * @memberof ReportFilterSchema
     */
    'period': Period;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ReportOrderBy = {
    TotalCall: 'total_call',
    DialledCall: 'dialled_call',
    ReceivedCall: 'received_call',
    TimeSpentOnCall: 'time_spent_on_call',
    FullName: 'full_name',
    Role: 'role',
    Role2: '-role',
    TotalCall2: '-total_call',
    DialledCall2: '-dialled_call',
    ReceivedCall2: '-received_call',
    TimeSpentOnCall2: '-time_spent_on_call',
    FullName2: '-full_name'
} as const;

export type ReportOrderBy = typeof ReportOrderBy[keyof typeof ReportOrderBy];


/**
 * 
 * @export
 * @enum {string}
 */

export const RequestAction = {
    UpdatedBalance: 'updated_balance',
    ProvisionedNumber: 'provisioned_number',
    ReclaimedNumber: 'reclaimed_number',
    ReplacedNumber: 'replaced_number',
    CreatedUser: 'created_user',
    CreatedTeamMember: 'created_team_member',
    RemovedTeamMember: 'removed_team_member',
    CreatedVoiceScript: 'created_voice_script',
    CreatedDialGroup: 'created_dial_group',
    UpdatedDialGroup: 'updated_dial_group',
    DuplicatedDialGroup: 'duplicated_dial_group',
    CreatedAvailableAddress: 'created_available_address',
    UpdatedAddressStatus: 'updated_address_status',
    UpdatedVerificationDocumentStatus: 'updated_verification_document_status',
    RemovedVerificationDocument: 'removed_verification_document',
    ChangedEmail: 'changed_email',
    IncreasedNinAttempts: 'increased_nin_attempts',
    ChangedPhoneNumber: 'changed_phone_number',
    DisabledWelcomeGreeting: 'disabled_welcome_greeting',
    ReactivatedAccount: 'reactivated_account',
    CancelledSubscription: 'cancelled_subscription',
    ManagedExtensions: 'managed_extensions',
    CreditedAirtime: 'credited_airtime',
    PausedSubscription: 'paused_subscription',
    ReducedRingTime: 'reduced_ring_time',
    TriggeredPasswordReset: 'triggered_password_reset'
} as const;

export type RequestAction = typeof RequestAction[keyof typeof RequestAction];


/**
 * 
 * @export
 * @interface RequestAssistanceInSchema
 */
export interface RequestAssistanceInSchema {
    /**
     * 
     * @type {number}
     * @memberof RequestAssistanceInSchema
     */
    'business_number_id': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof RequestAssistanceInSchema
     */
    'user_ids': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof RequestAssistanceInSchema
     */
    'session_id': string;
}
/**
 * 
 * @export
 * @interface RequestAssistanceMinimalOutSchema
 */
export interface RequestAssistanceMinimalOutSchema {
    /**
     * 
     * @type {number}
     * @memberof RequestAssistanceMinimalOutSchema
     */
    'target_user_id': number;
    /**
     * 
     * @type {string}
     * @memberof RequestAssistanceMinimalOutSchema
     */
    'unique_link': string;
}
/**
 * 
 * @export
 * @interface RequestAssistanceOutSchema
 */
export interface RequestAssistanceOutSchema {
    /**
     * 
     * @type {Array<string>}
     * @memberof RequestAssistanceOutSchema
     */
    'channels_sent'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof RequestAssistanceOutSchema
     */
    'unique_id': string;
    /**
     * 
     * @type {number}
     * @memberof RequestAssistanceOutSchema
     */
    'target_user'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RequestAssistanceOutSchema
     */
    'requesting_user'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RequestAssistanceOutSchema
     */
    'session_id': string;
}
/**
 * 
 * @export
 * @interface RequestGreetingsInSchema
 */
export interface RequestGreetingsInSchema {
    /**
     * 
     * @type {string}
     * @memberof RequestGreetingsInSchema
     */
    'text': string;
    /**
     * 
     * @type {GreetingType}
     * @memberof RequestGreetingsInSchema
     */
    'greeting_type': GreetingType;
    /**
     * 
     * @type {string}
     * @memberof RequestGreetingsInSchema
     */
    'voice_accent': string;
}


/**
 * 
 * @export
 * @interface RequestGreetingsOutSchema
 */
export interface RequestGreetingsOutSchema {
    /**
     * 
     * @type {string}
     * @memberof RequestGreetingsOutSchema
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestGreetingsOutSchema
     */
    'greeting_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestGreetingsOutSchema
     */
    'voice_accent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestGreetingsOutSchema
     */
    'greeting_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestGreetingsOutSchema
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface RequestVerificationInSchema
 */
export interface RequestVerificationInSchema {
    /**
     * 
     * @type {string}
     * @memberof RequestVerificationInSchema
     */
    'firstname': string;
    /**
     * 
     * @type {string}
     * @memberof RequestVerificationInSchema
     */
    'lastname': string;
    /**
     * 
     * @type {string}
     * @memberof RequestVerificationInSchema
     */
    'government_id_number': string;
    /**
     * 
     * @type {string}
     * @memberof RequestVerificationInSchema
     */
    'dob': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RequiredDocumentType = {
    ProofOfAddress: 'Proof of Address',
    CompanyRegistrationCertificate: 'Company Registration Certificate',
    PinVetCertificate: 'PIN/VET certificate',
    Passport: 'Passport',
    PassportHoldingPhoto: 'Passport Holding Photo',
    SignedKycDocument: 'Signed KYC Document',
    CurrentCr12: 'Current CR12',
    CertificateLetterFromBank: 'Certificate/Letter from Bank',
    LetterOfIntent: 'Letter of Intent',
    ScriptOfExpectedDialogue: 'Script of Expected Dialogue',
    UtilityBill: 'Utility Bill',
    NationalId: 'National ID',
    VotersCard: 'Voter\'s Card',
    DriversLicense: 'Driver\'s License'
} as const;

export type RequiredDocumentType = typeof RequiredDocumentType[keyof typeof RequiredDocumentType];


/**
 * 
 * @export
 * @interface Response
 */
export interface Response {
    /**
     * 
     * @type {string}
     * @memberof Response
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof Response
     */
    'data': any;
}
/**
 * 
 * @export
 * @interface ResponseAddonSubscriptionOutSchema
 */
export interface ResponseAddonSubscriptionOutSchema {
    /**
     * 
     * @type {string}
     * @memberof ResponseAddonSubscriptionOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseAddonSubscriptionOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {AddonSubscriptionOutSchema}
     * @memberof ResponseAddonSubscriptionOutSchema
     */
    'data': AddonSubscriptionOutSchema;
}
/**
 * 
 * @export
 * @interface ResponseAuditLogOutSchema
 */
export interface ResponseAuditLogOutSchema {
    /**
     * 
     * @type {string}
     * @memberof ResponseAuditLogOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseAuditLogOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {AuditLogOutSchema}
     * @memberof ResponseAuditLogOutSchema
     */
    'data': AuditLogOutSchema;
}
/**
 * 
 * @export
 * @interface ResponseBusinessSubscriptionOutSchema
 */
export interface ResponseBusinessSubscriptionOutSchema {
    /**
     * 
     * @type {string}
     * @memberof ResponseBusinessSubscriptionOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseBusinessSubscriptionOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {BusinessSubscriptionOutSchema}
     * @memberof ResponseBusinessSubscriptionOutSchema
     */
    'data': BusinessSubscriptionOutSchema;
}
/**
 * 
 * @export
 * @interface ResponseCallLogOutSchema
 */
export interface ResponseCallLogOutSchema {
    /**
     * 
     * @type {string}
     * @memberof ResponseCallLogOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseCallLogOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {CallLogOutSchema}
     * @memberof ResponseCallLogOutSchema
     */
    'data': CallLogOutSchema;
}
/**
 * 
 * @export
 * @interface ResponseChargeAuthorizationLogOutSchema
 */
export interface ResponseChargeAuthorizationLogOutSchema {
    /**
     * 
     * @type {string}
     * @memberof ResponseChargeAuthorizationLogOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseChargeAuthorizationLogOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {ChargeAuthorizationLogOutSchema}
     * @memberof ResponseChargeAuthorizationLogOutSchema
     */
    'data': ChargeAuthorizationLogOutSchema;
}
/**
 * 
 * @export
 * @interface ResponseCreditCardOutSchema
 */
export interface ResponseCreditCardOutSchema {
    /**
     * 
     * @type {string}
     * @memberof ResponseCreditCardOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseCreditCardOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {CreditCardOutSchema}
     * @memberof ResponseCreditCardOutSchema
     */
    'data': CreditCardOutSchema;
}
/**
 * 
 * @export
 * @interface ResponseListProfileMinimalOutSchema
 */
export interface ResponseListProfileMinimalOutSchema {
    /**
     * 
     * @type {string}
     * @memberof ResponseListProfileMinimalOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseListProfileMinimalOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {Array<ProfileMinimalOutSchema>}
     * @memberof ResponseListProfileMinimalOutSchema
     */
    'data': Array<ProfileMinimalOutSchema>;
}
/**
 * 
 * @export
 * @interface ResponseListWalletOutSchema
 */
export interface ResponseListWalletOutSchema {
    /**
     * 
     * @type {string}
     * @memberof ResponseListWalletOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseListWalletOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {Array<WalletOutSchema>}
     * @memberof ResponseListWalletOutSchema
     */
    'data': Array<WalletOutSchema>;
}
/**
 * 
 * @export
 * @interface ResponsePaymentPageOutSchema
 */
export interface ResponsePaymentPageOutSchema {
    /**
     * 
     * @type {string}
     * @memberof ResponsePaymentPageOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsePaymentPageOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {PaymentPageOutSchema}
     * @memberof ResponsePaymentPageOutSchema
     */
    'data': PaymentPageOutSchema;
}
/**
 * 
 * @export
 * @interface ResponsePreSaleBusinessInformationOutSchema
 */
export interface ResponsePreSaleBusinessInformationOutSchema {
    /**
     * 
     * @type {string}
     * @memberof ResponsePreSaleBusinessInformationOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsePreSaleBusinessInformationOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {PreSaleBusinessInformationOutSchema}
     * @memberof ResponsePreSaleBusinessInformationOutSchema
     */
    'data': PreSaleBusinessInformationOutSchema;
}
/**
 * 
 * @export
 * @interface ResponseSignupStageOutSchema
 */
export interface ResponseSignupStageOutSchema {
    /**
     * 
     * @type {string}
     * @memberof ResponseSignupStageOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseSignupStageOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {SignupStageOutSchema}
     * @memberof ResponseSignupStageOutSchema
     */
    'data': SignupStageOutSchema;
}
/**
 * 
 * @export
 * @interface ResponseSubscriptionBillingOutSchema
 */
export interface ResponseSubscriptionBillingOutSchema {
    /**
     * 
     * @type {string}
     * @memberof ResponseSubscriptionBillingOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseSubscriptionBillingOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {SubscriptionBillingOutSchema}
     * @memberof ResponseSubscriptionBillingOutSchema
     */
    'data': SubscriptionBillingOutSchema;
}
/**
 * 
 * @export
 * @interface ResponseTeamReportDistributionOutSchema
 */
export interface ResponseTeamReportDistributionOutSchema {
    /**
     * 
     * @type {string}
     * @memberof ResponseTeamReportDistributionOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseTeamReportDistributionOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {TeamReportDistributionOutSchema}
     * @memberof ResponseTeamReportDistributionOutSchema
     */
    'data': TeamReportDistributionOutSchema;
}
/**
 * 
 * @export
 * @interface ResponseTeamReportOutSchema
 */
export interface ResponseTeamReportOutSchema {
    /**
     * 
     * @type {string}
     * @memberof ResponseTeamReportOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseTeamReportOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {TeamReportOutSchema}
     * @memberof ResponseTeamReportOutSchema
     */
    'data': TeamReportOutSchema;
}
/**
 * 
 * @export
 * @interface ResponseWalletOutSchema
 */
export interface ResponseWalletOutSchema {
    /**
     * 
     * @type {string}
     * @memberof ResponseWalletOutSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseWalletOutSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {WalletOutSchema}
     * @memberof ResponseWalletOutSchema
     */
    'data': WalletOutSchema;
}
/**
 * Schema for representing revenue targets in a campaign.  Attributes:     date (datetime): The date for which the revenue target is set.     potential_revenue (float): The potential revenue generated on that date.     target_revenue (float): The target revenue for that date.
 * @export
 * @interface RevenueTargetSchema
 */
export interface RevenueTargetSchema {
    /**
     * 
     * @type {string}
     * @memberof RevenueTargetSchema
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof RevenueTargetSchema
     */
    'potential_revenue': number;
    /**
     * 
     * @type {number}
     * @memberof RevenueTargetSchema
     */
    'target_revenue': number;
}
/**
 * 
 * @export
 * @interface RingGroupConfigurationInSchema
 */
export interface RingGroupConfigurationInSchema {
    /**
     * 
     * @type {string}
     * @memberof RingGroupConfigurationInSchema
     */
    'id': string;
    /**
     * 
     * @type {RingGroupInStrategy}
     * @memberof RingGroupConfigurationInSchema
     */
    'ring_strategy'?: RingGroupInStrategy;
    /**
     * 
     * @type {Array<number>}
     * @memberof RingGroupConfigurationInSchema
     */
    'ring_group_users': Array<number>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const RingGroupInStrategy = {
    Linear: 'linear',
    Simultaneous: 'simultaneous'
} as const;

export type RingGroupInStrategy = typeof RingGroupInStrategy[keyof typeof RingGroupInStrategy];


/**
 * 
 * @export
 * @interface RingGroupOutSchema
 */
export interface RingGroupOutSchema {
    /**
     * 
     * @type {Array<number>}
     * @memberof RingGroupOutSchema
     */
    'ring_group_users': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof RingGroupOutSchema
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RingGroupOutSchema
     */
    'ring_strategy'?: string;
}
/**
 * 
 * @export
 * @interface RoleBasedPermissionsOutSchema
 */
export interface RoleBasedPermissionsOutSchema {
    /**
     * 
     * @type {ProfileRole}
     * @memberof RoleBasedPermissionsOutSchema
     */
    'role': ProfileRole;
    /**
     * 
     * @type {RolePermissionOutSchema}
     * @memberof RoleBasedPermissionsOutSchema
     */
    'permission': RolePermissionOutSchema;
}


/**
 * 
 * @export
 * @interface RolePermissionOutSchema
 */
export interface RolePermissionOutSchema {
    /**
     * 
     * @type {boolean}
     * @memberof RolePermissionOutSchema
     */
    'can_export_call_logs'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RolePermissionOutSchema
     */
    'can_view_all_call_logs'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RolePermissionOutSchema
     */
    'can_export_contact'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RolePermissionOutSchema
     */
    'can_export_report'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RolePermissionOutSchema
     */
    'can_manage_billing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RolePermissionOutSchema
     */
    'can_manage_team'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RolePermissionOutSchema
     */
    'can_manage_permissions'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RolePermissionOutSchema
     */
    'can_manage_personalization'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RolePermissionOutSchema
     */
    'can_access_call_recordings'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RolePermissionOutSchema
     */
    'can_download_call_recordings'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RolePermissionOutSchema
     */
    'can_view_performance_report'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RolePermissionOutSchema
     */
    'can_view_activity_report'?: boolean;
}
/**
 * 
 * @export
 * @interface SDKTeamMemberTokenInSchema
 */
export interface SDKTeamMemberTokenInSchema {
    /**
     * 
     * @type {number}
     * @memberof SDKTeamMemberTokenInSchema
     */
    'user_id': number;
}
/**
 * 
 * @export
 * @interface SDKTeamMemberTokenOutSchema
 */
export interface SDKTeamMemberTokenOutSchema {
    /**
     * 
     * @type {string}
     * @memberof SDKTeamMemberTokenOutSchema
     */
    'refresh': string;
    /**
     * 
     * @type {string}
     * @memberof SDKTeamMemberTokenOutSchema
     */
    'access': string;
    /**
     * 
     * @type {number}
     * @memberof SDKTeamMemberTokenOutSchema
     */
    'expiry': number;
}
/**
 * 
 * @export
 * @interface SalesCampaignCallLogInSchema
 */
export interface SalesCampaignCallLogInSchema {
    /**
     * 
     * @type {string}
     * @memberof SalesCampaignCallLogInSchema
     */
    'call_id': string;
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignCallLogInSchema
     */
    'queue_id': number;
}
/**
 * Schema for filtering sales campaigns in reports.  Attributes:     name (Optional[str]): The name of the campaign to filter by.     status (Optional[CampaignStatus]): The status of the campaign to filter by.
 * @export
 * @interface SalesCampaignFilterSchema
 */
export interface SalesCampaignFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof SalesCampaignFilterSchema
     */
    'start_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesCampaignFilterSchema
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {Period}
     * @memberof SalesCampaignFilterSchema
     */
    'period'?: Period | null;
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignFilterSchema
     */
    'agent_id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SalesCampaignFilterSchema
     */
    'name'?: string | null;
    /**
     * 
     * @type {CampaignStatus}
     * @memberof SalesCampaignFilterSchema
     */
    'status'?: CampaignStatus | null;
}


/**
 * 
 * @export
 * @interface SalesCampaignStatusChangeSchema
 */
export interface SalesCampaignStatusChangeSchema {
    /**
     * 
     * @type {CampaignStatus}
     * @memberof SalesCampaignStatusChangeSchema
     */
    'status': CampaignStatus;
}


/**
 * 
 * @export
 * @interface SelectNotificationInSchema
 */
export interface SelectNotificationInSchema {
    /**
     * 
     * @type {Array<string>}
     * @memberof SelectNotificationInSchema
     */
    'notification_ids': Array<string>;
    /**
     * 
     * @type {NotificationAction}
     * @memberof SelectNotificationInSchema
     */
    'action': NotificationAction;
}


/**
 *     Flow A: Standard Flow ######################## Flow A: Standard Flow ################################ 1. Register Contact Information → POST /register/ • Collects basic user details. 2. Business Information → POST /recommendation-form/ • Saves business details. 3. Number Selection → PATCH /recommendation-form/{presale_id}/ • Updates the presale business info with the selected number. 4. Complete Signup Check → GET /complete-signup/{global_id}/ • Returns the signup stage and selected number (if any). 5. Payment & Provisioning → POST /number-purchase/web/v2/ • Generates the payment link. The number is provisioned after a successful payment.  ######################## Flow B: Direct Purchase Flow #############################   1. Register Contact Information → POST /register/ 2. Business Information → POST /recommendation-form/ • Should include the chosen signup flow (sent to Customer.io for tracking). 3. Immediate Number Purchase → POST /number-purchase/web/ • Instead of selecting a number first, the user goes straight to payment. 4. Check for Pending Provisioning → GET /user/me/ • If has_pending_number_provisioning == True, proceed to the next step. 5. Fetch Unprovisioned Payment Details → GET /unprovisioned-payment/ • Returns the plan and payment details. • If no business is associated, it’s the first number purchase for the business. 6. Provision Number → POST /provision-number/ • Prefill name, email, size using GET /recommendation-form/. • Once provisioned, necessary flags are updated to streamline the process.
 * @export
 * @enum {string}
 */

export const SignUpFlow = {
    A: 'A',
    B: 'B'
} as const;

export type SignUpFlow = typeof SignUpFlow[keyof typeof SignUpFlow];


/**
 * 
 * @export
 * @enum {string}
 */

export const SignupStage = {
    ContactInformation: 'contact_information',
    BusinessInformation: 'business_information',
    NumberSelection: 'number_selection',
    InvoicePreview: 'invoice_preview',
    Completed: 'completed'
} as const;

export type SignupStage = typeof SignupStage[keyof typeof SignupStage];


/**
 * 
 * @export
 * @interface SignupStageOutSchema
 */
export interface SignupStageOutSchema {
    /**
     * 
     * @type {SignupStage}
     * @memberof SignupStageOutSchema
     */
    'stage'?: SignupStage | null;
    /**
     * 
     * @type {string}
     * @memberof SignupStageOutSchema
     */
    'email': string;
    /**
     * 
     * @type {number}
     * @memberof SignupStageOutSchema
     */
    'user_id': number;
    /**
     * 
     * @type {string}
     * @memberof SignupStageOutSchema
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof SignupStageOutSchema
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof SignupStageOutSchema
     */
    'mobile'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SignupStageOutSchema
     */
    'pre_sale_id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SignupStageOutSchema
     */
    'business_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SignupStageOutSchema
     */
    'job_title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SignupStageOutSchema
     */
    'sector'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SignupStageOutSchema
     */
    'team_size'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SignupStageOutSchema
     */
    'makes_international_calls'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SignupStageOutSchema
     */
    'requires_usa_number'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SignupStageOutSchema
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SignupStageOutSchema
     */
    'referral_source'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SignupStageOutSchema
     */
    'plan'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SignupStageOutSchema
     */
    'number_of_calls_per_day'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SignupStageOutSchema
     */
    'number_of_calls_per_week'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SignupStageOutSchema
     */
    'available_number'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SignupStageOutSchema
     */
    'is_available_number_changed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SignupStageOutSchema
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SignupStageOutSchema
     */
    'provider'?: string | null;
    /**
     * 
     * @type {SignUpFlow}
     * @memberof SignupStageOutSchema
     */
    'signup_flow'?: SignUpFlow | null;
}


/**
 * Enum for defining the action to take when a single contact match is found.  Attributes:     NO_ACTION (str): Do nothing, keep the existing contact unchanged.     PRESERVE_AND_UPDATE (str): Preserve existing fields but     update empty fields from the new contact data.     REPLACE_EXISTING (str): Replace existing contact fields     with the new contact data.
 * @export
 * @enum {string}
 */

export const SingleMatchAction = {
    NoAction: 'NO_ACTION',
    PreserveAndUpdate: 'PRESERVE_AND_UPDATE',
    ReplaceExisting: 'REPLACE_EXISTING'
} as const;

export type SingleMatchAction = typeof SingleMatchAction[keyof typeof SingleMatchAction];


/**
 * 
 * @export
 * @interface StandardizedApiKeyInSchema
 */
export interface StandardizedApiKeyInSchema {
    /**
     * 
     * @type {string}
     * @memberof StandardizedApiKeyInSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof StandardizedApiKeyInSchema
     */
    'expiry': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StandardizedApiKeyInSchema
     */
    'scope': Array<string>;
}
/**
 * 
 * @export
 * @interface StandardizedApiKeyOutSchema
 */
export interface StandardizedApiKeyOutSchema {
    /**
     * 
     * @type {string}
     * @memberof StandardizedApiKeyOutSchema
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof StandardizedApiKeyOutSchema
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof StandardizedApiKeyOutSchema
     */
    'disabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StandardizedApiKeyOutSchema
     */
    'expiry'?: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof StandardizedApiKeyOutSchema
     */
    'scope'?: Array<any> | null;
    /**
     * 
     * @type {string}
     * @memberof StandardizedApiKeyOutSchema
     */
    'last_used'?: string;
}
/**
 * 
 * @export
 * @interface StandardizedApiKeyUpdateOutSchema
 */
export interface StandardizedApiKeyUpdateOutSchema {
    /**
     * 
     * @type {string}
     * @memberof StandardizedApiKeyUpdateOutSchema
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof StandardizedApiKeyUpdateOutSchema
     */
    'disabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StandardizedApiKeyUpdateOutSchema
     */
    'expiry'?: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof StandardizedApiKeyUpdateOutSchema
     */
    'scope'?: Array<any> | null;
    /**
     * 
     * @type {string}
     * @memberof StandardizedApiKeyUpdateOutSchema
     */
    'last_used'?: string;
}
/**
 * 
 * @export
 * @interface StandardizedApiKeyUpdateSchema
 */
export interface StandardizedApiKeyUpdateSchema {
    /**
     * 
     * @type {string}
     * @memberof StandardizedApiKeyUpdateSchema
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof StandardizedApiKeyUpdateSchema
     */
    'disabled': boolean;
}
/**
 * 
 * @export
 * @interface SubscriptionBillingInSchema
 */
export interface SubscriptionBillingInSchema {
    /**
     * 
     * @type {PaymentMode}
     * @memberof SubscriptionBillingInSchema
     */
    'payment_mode'?: PaymentMode | null;
}


/**
 * 
 * @export
 * @interface SubscriptionBillingOutSchema
 */
export interface SubscriptionBillingOutSchema {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionBillingOutSchema
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionBillingOutSchema
     */
    'access_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionBillingOutSchema
     */
    'ref'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionBillingOutSchema
     */
    'temp_authorization_url'?: string | null;
}
/**
 * 
 * @export
 * @interface SubscriptionPlanFilterSchema
 */
export interface SubscriptionPlanFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanFilterSchema
     */
    'search'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanFilterSchema
     */
    'number_region'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanFilterSchema
     */
    'currency'?: SubscriptionPlanFilterSchemaCurrencyEnum | null;
    /**
     * 
     * @type {SubscriptionTerm}
     * @memberof SubscriptionPlanFilterSchema
     */
    'term'?: SubscriptionTerm | null;
    /**
     * 
     * @type {SubscriptionPlanType}
     * @memberof SubscriptionPlanFilterSchema
     */
    'plan_type'?: SubscriptionPlanType | null;
}

export const SubscriptionPlanFilterSchemaCurrencyEnum = {
    Aed: 'AED',
    Afn: 'AFN',
    All: 'ALL',
    Amd: 'AMD',
    Ang: 'ANG',
    Aoa: 'AOA',
    Ars: 'ARS',
    Aud: 'AUD',
    Awg: 'AWG',
    Azn: 'AZN',
    Bam: 'BAM',
    Bbd: 'BBD',
    Bdt: 'BDT',
    Bgn: 'BGN',
    Bhd: 'BHD',
    Bif: 'BIF',
    Bmd: 'BMD',
    Bnd: 'BND',
    Bob: 'BOB',
    Bov: 'BOV',
    Brl: 'BRL',
    Bsd: 'BSD',
    Btn: 'BTN',
    Bwp: 'BWP',
    Byn: 'BYN',
    Bzd: 'BZD',
    Cad: 'CAD',
    Cdf: 'CDF',
    Che: 'CHE',
    Chf: 'CHF',
    Chw: 'CHW',
    Clf: 'CLF',
    Clp: 'CLP',
    Cny: 'CNY',
    Cop: 'COP',
    Cou: 'COU',
    Crc: 'CRC',
    Cuc: 'CUC',
    Cup: 'CUP',
    Cve: 'CVE',
    Czk: 'CZK',
    Djf: 'DJF',
    Dkk: 'DKK',
    Dop: 'DOP',
    Dzd: 'DZD',
    Egp: 'EGP',
    Ern: 'ERN',
    Etb: 'ETB',
    Eur: 'EUR',
    Fjd: 'FJD',
    Fkp: 'FKP',
    Gbp: 'GBP',
    Gel: 'GEL',
    Ghs: 'GHS',
    Gip: 'GIP',
    Gmd: 'GMD',
    Gnf: 'GNF',
    Gtq: 'GTQ',
    Gyd: 'GYD',
    Hkd: 'HKD',
    Hnl: 'HNL',
    Hrk: 'HRK',
    Htg: 'HTG',
    Huf: 'HUF',
    Idr: 'IDR',
    Ils: 'ILS',
    Inr: 'INR',
    Iqd: 'IQD',
    Irr: 'IRR',
    Isk: 'ISK',
    Jmd: 'JMD',
    Jod: 'JOD',
    Jpy: 'JPY',
    Kes: 'KES',
    Kgs: 'KGS',
    Khr: 'KHR',
    Kmf: 'KMF',
    Kpw: 'KPW',
    Krw: 'KRW',
    Kwd: 'KWD',
    Kyd: 'KYD',
    Kzt: 'KZT',
    Lak: 'LAK',
    Lbp: 'LBP',
    Lkr: 'LKR',
    Lrd: 'LRD',
    Lsl: 'LSL',
    Lyd: 'LYD',
    Mad: 'MAD',
    Mdl: 'MDL',
    Mga: 'MGA',
    Mkd: 'MKD',
    Mmk: 'MMK',
    Mnt: 'MNT',
    Mop: 'MOP',
    Mru: 'MRU',
    Mur: 'MUR',
    Mvr: 'MVR',
    Mwk: 'MWK',
    Mxn: 'MXN',
    Mxv: 'MXV',
    Myr: 'MYR',
    Mzn: 'MZN',
    Nad: 'NAD',
    Ngn: 'NGN',
    Nio: 'NIO',
    Nok: 'NOK',
    Npr: 'NPR',
    Nzd: 'NZD',
    Omr: 'OMR',
    Pab: 'PAB',
    Pen: 'PEN',
    Pgk: 'PGK',
    Php: 'PHP',
    Pkr: 'PKR',
    Pln: 'PLN',
    Pyg: 'PYG',
    Qar: 'QAR',
    Ron: 'RON',
    Rsd: 'RSD',
    Rub: 'RUB',
    Rwf: 'RWF',
    Sar: 'SAR',
    Sbd: 'SBD',
    Scr: 'SCR',
    Sdg: 'SDG',
    Sek: 'SEK',
    Sgd: 'SGD',
    Shp: 'SHP',
    Sle: 'SLE',
    Sll: 'SLL',
    Sos: 'SOS',
    Srd: 'SRD',
    Ssp: 'SSP',
    Stn: 'STN',
    Svc: 'SVC',
    Syp: 'SYP',
    Szl: 'SZL',
    Thb: 'THB',
    Tjs: 'TJS',
    Tmt: 'TMT',
    Tnd: 'TND',
    Top: 'TOP',
    Try: 'TRY',
    Ttd: 'TTD',
    Twd: 'TWD',
    Tzs: 'TZS',
    Uah: 'UAH',
    Ugx: 'UGX',
    Usd: 'USD',
    Usn: 'USN',
    Uyi: 'UYI',
    Uyu: 'UYU',
    Uyw: 'UYW',
    Uzs: 'UZS',
    Ved: 'VED',
    Ves: 'VES',
    Vnd: 'VND',
    Vuv: 'VUV',
    Wst: 'WST',
    Xaf: 'XAF',
    Xcd: 'XCD',
    Xof: 'XOF',
    Xpf: 'XPF',
    Xsu: 'XSU',
    Xua: 'XUA',
    Yer: 'YER',
    Zar: 'ZAR',
    Zmw: 'ZMW',
    Zwl: 'ZWL'
} as const;

export type SubscriptionPlanFilterSchemaCurrencyEnum = typeof SubscriptionPlanFilterSchemaCurrencyEnum[keyof typeof SubscriptionPlanFilterSchemaCurrencyEnum];

/**
 * 
 * @export
 * @interface SubscriptionPlanOutSchema
 */
export interface SubscriptionPlanOutSchema {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlanOutSchema
     */
    'standard_cost': number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanOutSchema
     */
    'number_region': string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlanOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanOutSchema
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanOutSchema
     */
    'standard_cost_currency'?: string;
    /**
     * The term of the plan
     * @type {string}
     * @memberof SubscriptionPlanOutSchema
     */
    'term'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPlanOutSchema
     */
    'international_number_enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPlanOutSchema
     */
    'extensions_enabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlanOutSchema
     */
    'extensions_limit'?: number;
    /**
     * The type of plan
     * @type {string}
     * @memberof SubscriptionPlanOutSchema
     */
    'plan_type'?: string;
    /**
     * The payment type of plan
     * @type {string}
     * @memberof SubscriptionPlanOutSchema
     */
    'payment_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanOutSchema
     */
    'description'?: string | null;
    /**
     * The addon type of plan
     * @type {string}
     * @memberof SubscriptionPlanOutSchema
     */
    'addon_type'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SubscriptionPlanTerm = {
    Monthly: 'monthly',
    Quarterly: 'quarterly',
    Yearly: 'yearly'
} as const;

export type SubscriptionPlanTerm = typeof SubscriptionPlanTerm[keyof typeof SubscriptionPlanTerm];


/**
 * 
 * @export
 * @interface SubscriptionPlanTermFilterSchema
 */
export interface SubscriptionPlanTermFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlanTermFilterSchema
     */
    'search'?: string | null;
    /**
     * 
     * @type {SubscriptionTerm}
     * @memberof SubscriptionPlanTermFilterSchema
     */
    'term': SubscriptionTerm;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SubscriptionPlanType = {
    Number: 'number',
    Addon: 'addon',
    Extension: 'extension'
} as const;

export type SubscriptionPlanType = typeof SubscriptionPlanType[keyof typeof SubscriptionPlanType];


/**
 * 
 * @export
 * @enum {string}
 */

export const SubscriptionTerm = {
    Monthly: 'monthly',
    Quarterly: 'quarterly',
    Yearly: 'yearly'
} as const;

export type SubscriptionTerm = typeof SubscriptionTerm[keyof typeof SubscriptionTerm];


/**
 * 
 * @export
 * @enum {string}
 */

export const SurveyEvent = {
    ProfessionalGreeting: 'professional_greeting',
    WeeklyReview: 'weekly_review',
    NetPromoterScore: 'net_promoter_score'
} as const;

export type SurveyEvent = typeof SurveyEvent[keyof typeof SurveyEvent];


/**
 * 
 * @export
 * @interface SurveyInSchema
 */
export interface SurveyInSchema {
    /**
     * 
     * @type {number}
     * @memberof SurveyInSchema
     */
    'rating': number;
    /**
     * 
     * @type {string}
     * @memberof SurveyInSchema
     */
    'feedback': string | null;
    /**
     * 
     * @type {SurveyEvent}
     * @memberof SurveyInSchema
     */
    'event'?: SurveyEvent;
    /**
     * 
     * @type {object}
     * @memberof SurveyInSchema
     */
    'data'?: object | null;
}


/**
 * 
 * @export
 * @interface SurveyOutSchema
 */
export interface SurveyOutSchema {
    /**
     * 
     * @type {MinimalUserModelOutSchema}
     * @memberof SurveyOutSchema
     */
    'user': MinimalUserModelOutSchema;
    /**
     * 
     * @type {BusinessOutSchema}
     * @memberof SurveyOutSchema
     */
    'business': BusinessOutSchema;
    /**
     * 
     * @type {number}
     * @memberof SurveyOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SurveyOutSchema
     */
    'rating': number;
    /**
     * 
     * @type {string}
     * @memberof SurveyOutSchema
     */
    'feedback'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveyOutSchema
     */
    'date_created': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyOutSchema
     */
    'event'?: string;
}
/**
 * 
 * @export
 * @interface TagContactSchema
 */
export interface TagContactSchema {
    /**
     * 
     * @type {number}
     * @memberof TagContactSchema
     */
    'tag_id': number;
    /**
     * 
     * @type {string}
     * @memberof TagContactSchema
     */
    'followup_date'?: string | null;
}
/**
 * 
 * @export
 * @interface TagInSchema
 */
export interface TagInSchema {
    /**
     * 
     * @type {string}
     * @memberof TagInSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TagInSchema
     */
    'color'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof TagInSchema
     */
    'attribute'?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof TagInSchema
     */
    'is_conversion_tag'?: boolean;
    /**
     * 
     * @type {TagType}
     * @memberof TagInSchema
     */
    'type'?: TagType;
}


/**
 * 
 * @export
 * @interface TagOutSchema
 */
export interface TagOutSchema {
    /**
     * 
     * @type {number}
     * @memberof TagOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TagOutSchema
     */
    'name': string;
    /**
     * 
     * @type {object}
     * @memberof TagOutSchema
     */
    'attribute'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof TagOutSchema
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TagOutSchema
     */
    'type'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TagOutSchema
     */
    'is_custom'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TagOutSchema
     */
    'is_conversion_tag'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TagType = {
    Attribute: 'attribute',
    CallStatus: 'call_status',
    FollowUp: 'follow_up',
    Interest: 'interest',
    Payment: 'payment'
} as const;

export type TagType = typeof TagType[keyof typeof TagType];


/**
 * 
 * @export
 * @interface TagUpdateSchema
 */
export interface TagUpdateSchema {
    /**
     * 
     * @type {string}
     * @memberof TagUpdateSchema
     */
    'name'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof TagUpdateSchema
     */
    'attribute'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof TagUpdateSchema
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TagUpdateSchema
     */
    'type'?: string | null;
}
/**
 * 
 * @export
 * @interface TeamMemberInSchema
 */
export interface TeamMemberInSchema {
    /**
     * 
     * @type {string}
     * @memberof TeamMemberInSchema
     */
    'email': string;
    /**
     * 
     * @type {ProfileRole}
     * @memberof TeamMemberInSchema
     */
    'role': ProfileRole;
    /**
     * 
     * @type {PermissionInSchema}
     * @memberof TeamMemberInSchema
     */
    'permissions': PermissionInSchema;
    /**
     * 
     * @type {boolean}
     * @memberof TeamMemberInSchema
     */
    'can_make_calls'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberInSchema
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberInSchema
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberInSchema
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberInSchema
     */
    'mobile': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberInSchema
     */
    'note': string | null;
}


/**
 * 
 * @export
 * @interface TeamMemberInvitationAcceptanceInSchema
 */
export interface TeamMemberInvitationAcceptanceInSchema {
    /**
     * 
     * @type {string}
     * @memberof TeamMemberInvitationAcceptanceInSchema
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberInvitationAcceptanceInSchema
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberInvitationAcceptanceInSchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberInvitationAcceptanceInSchema
     */
    'mobile': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberInvitationAcceptanceInSchema
     */
    'password': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TeamMemberInvitationAcceptanceInSchema
     */
    'business_numbers'?: Array<string>;
}
/**
 * 
 * @export
 * @interface TeamMemberMinimalOutSchema
 */
export interface TeamMemberMinimalOutSchema {
    /**
     * 
     * @type {BusinessOutSchema}
     * @memberof TeamMemberMinimalOutSchema
     */
    'business': BusinessOutSchema;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberMinimalOutSchema
     */
    'last_active'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberMinimalOutSchema
     */
    'mobile'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TeamMemberMinimalOutSchema
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeamMemberMinimalOutSchema
     */
    'has_filled_engagement_form': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeamMemberMinimalOutSchema
     */
    'has_submitted_weekly_survey': boolean;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberMinimalOutSchema
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberMinimalOutSchema
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberMinimalOutSchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberMinimalOutSchema
     */
    'role'?: string;
    /**
     * 
     * @type {number}
     * @memberof TeamMemberMinimalOutSchema
     */
    'user': number;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberMinimalOutSchema
     */
    'date_created': string;
    /**
     * 
     * @type {Array<ReceiverNumberMinimalOutSchema>}
     * @memberof TeamMemberMinimalOutSchema
     */
    'receivers'?: Array<ReceiverNumberMinimalOutSchema>;
}
/**
 * 
 * @export
 * @interface TeamMemberMinimalOutSchema2
 */
export interface TeamMemberMinimalOutSchema2 {
    /**
     * 
     * @type {string}
     * @memberof TeamMemberMinimalOutSchema2
     */
    'full_name': string;
    /**
     * 
     * @type {number}
     * @memberof TeamMemberMinimalOutSchema2
     */
    'user_id': number;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberMinimalOutSchema2
     */
    'mobile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberMinimalOutSchema2
     */
    'profile_picture'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberMinimalOutSchema2
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberMinimalOutSchema2
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberMinimalOutSchema2
     */
    'email': string;
    /**
     * 
     * @type {Array<ReceiverNumberMinimalOutSchema>}
     * @memberof TeamMemberMinimalOutSchema2
     */
    'receivers'?: Array<ReceiverNumberMinimalOutSchema>;
}
/**
 * 
 * @export
 * @interface TeamMemberOnboardingInSchema
 */
export interface TeamMemberOnboardingInSchema {
    /**
     * 
     * @type {string}
     * @memberof TeamMemberOnboardingInSchema
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberOnboardingInSchema
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberOnboardingInSchema
     */
    'mobile': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberOnboardingInSchema
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberOnboardingInSchema
     */
    'uid': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberOnboardingInSchema
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface TeamMemberOutSchema
 */
export interface TeamMemberOutSchema {
    /**
     * 
     * @type {ProfileOutSchema}
     * @memberof TeamMemberOutSchema
     */
    'profile': ProfileOutSchema;
    /**
     * 
     * @type {PermissionOutSchema}
     * @memberof TeamMemberOutSchema
     */
    'permission': PermissionOutSchema;
    /**
     * 
     * @type {Array<ReceiverNumberOutSchema>}
     * @memberof TeamMemberOutSchema
     */
    'receivers'?: Array<ReceiverNumberOutSchema>;
}
/**
 * 
 * @export
 * @interface TeamMemberOutSchemaV2
 */
export interface TeamMemberOutSchemaV2 {
    /**
     * 
     * @type {ProfileOutSchemaV2}
     * @memberof TeamMemberOutSchemaV2
     */
    'profile': ProfileOutSchemaV2;
    /**
     * 
     * @type {PermissionOutSchema}
     * @memberof TeamMemberOutSchemaV2
     */
    'permission': PermissionOutSchema;
}
/**
 * Schema for team member information
 * @export
 * @interface TeamMemberSchema
 */
export interface TeamMemberSchema {
    /**
     * 
     * @type {string}
     * @memberof TeamMemberSchema
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberSchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberSchema
     */
    'date_created': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberSchema
     */
    'role': string;
}
/**
 * 
 * @export
 * @interface TeamReportDistributionOutSchema
 */
export interface TeamReportDistributionOutSchema {
    /**
     * 
     * @type {Array<CallStatsReportOutSchema>}
     * @memberof TeamReportDistributionOutSchema
     */
    'call_stats_distribution'?: Array<CallStatsReportOutSchema>;
    /**
     * 
     * @type {Array<ContactTagDistributionOutSchema>}
     * @memberof TeamReportDistributionOutSchema
     */
    'contact_tag_distribution'?: Array<ContactTagDistributionOutSchema>;
}
/**
 * 
 * @export
 * @interface TeamReportOutSchema
 */
export interface TeamReportOutSchema {
    /**
     * 
     * @type {number}
     * @memberof TeamReportOutSchema
     */
    'total_call'?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamReportOutSchema
     */
    'missed_call'?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamReportOutSchema
     */
    'dialled_call'?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamReportOutSchema
     */
    'received_call'?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamReportOutSchema
     */
    'contact_engaged'?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamReportOutSchema
     */
    'average_minutes_per_call'?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamReportOutSchema
     */
    'average_duration_per_call'?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamReportOutSchema
     */
    'average_calls_per_contact'?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamReportOutSchema
     */
    'duration'?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamReportOutSchema
     */
    'total_contact_added'?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamReportOutSchema
     */
    'total_contact_tagged'?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamReportOutSchema
     */
    'conversion_rate'?: number;
    /**
     * 
     * @type {number}
     * @memberof TeamReportOutSchema
     */
    'total_note'?: number;
}
/**
 * 
 * @export
 * @interface TextToSpeechInSchema
 */
export interface TextToSpeechInSchema {
    /**
     * 
     * @type {string}
     * @memberof TextToSpeechInSchema
     */
    'did'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TextToSpeechInSchema
     */
    'session_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TextToSpeechInSchema
     */
    'repeats': number;
    /**
     * 
     * @type {string}
     * @memberof TextToSpeechInSchema
     */
    'callback_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TextToSpeechInSchema
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TextToSpeechInSchema
     */
    'resource_id'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TextToSpeechInSchema
     */
    'numbers': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TextToSpeechInSchema
     */
    'voice_accent'?: string | null;
}
/**
 * 
 * @export
 * @interface TimeAccessSchema2
 */
export interface TimeAccessSchema2 {
    /**
     * 
     * @type {string}
     * @memberof TimeAccessSchema2
     */
    'fallback_kind'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimeAccessSchema2
     */
    'timezone'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimeAccessSchema2
     */
    'sunday'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimeAccessSchema2
     */
    'monday'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimeAccessSchema2
     */
    'tuesday'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimeAccessSchema2
     */
    'wednesday'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimeAccessSchema2
     */
    'thursday'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimeAccessSchema2
     */
    'friday'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimeAccessSchema2
     */
    'saturday'?: string;
}
/**
 * 
 * @export
 * @interface TokenValidateInSchema
 */
export interface TokenValidateInSchema {
    /**
     * 
     * @type {string}
     * @memberof TokenValidateInSchema
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof TokenValidateInSchema
     */
    'uid': string;
    /**
     * 
     * @type {boolean}
     * @memberof TokenValidateInSchema
     */
    'is_email_verification'?: boolean;
}
/**
 * 
 * @export
 * @interface TransationIntentTxRefInSchema
 */
export interface TransationIntentTxRefInSchema {
    /**
     * 
     * @type {string}
     * @memberof TransationIntentTxRefInSchema
     */
    'txref'?: string | null;
}
/**
 * 
 * @export
 * @interface TriggerPasswordResetInSchema
 */
export interface TriggerPasswordResetInSchema {
    /**
     * 
     * @type {string}
     * @memberof TriggerPasswordResetInSchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TriggerPasswordResetInSchema
     */
    'submitted_by': string;
}
/**
 * 
 * @export
 * @interface UpdateCallScriptSchema
 */
export interface UpdateCallScriptSchema {
    /**
     * 
     * @type {string}
     * @memberof UpdateCallScriptSchema
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCallScriptSchema
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<UpdateScriptItemSchema>}
     * @memberof UpdateCallScriptSchema
     */
    'items'?: Array<UpdateScriptItemSchema>;
}
/**
 * 
 * @export
 * @interface UpdateKnowledgeBaseTopicSchema
 */
export interface UpdateKnowledgeBaseTopicSchema {
    /**
     * 
     * @type {string}
     * @memberof UpdateKnowledgeBaseTopicSchema
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateKnowledgeBaseTopicSchema
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateQueueSchema
 */
export interface UpdateQueueSchema {
    /**
     * 
     * @type {number}
     * @memberof UpdateQueueSchema
     */
    'limit': number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateQueueSchema
     */
    'name': string | null;
}
/**
 * 
 * @export
 * @interface UpdateScriptItemSchema
 */
export interface UpdateScriptItemSchema {
    /**
     * 
     * @type {number}
     * @memberof UpdateScriptItemSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateScriptItemSchema
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateScriptItemSchema
     */
    'text'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateSubscriptionInSchema
 */
export interface UpdateSubscriptionInSchema {
    /**
     * 
     * @type {PaymentMode}
     * @memberof UpdateSubscriptionInSchema
     */
    'payment_mode'?: PaymentMode | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateSubscriptionInSchema
     */
    'plan_id': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateSubscriptionInSchema
     */
    'business_number_id': number;
}


/**
 * 
 * @export
 * @interface UserContactInSchema
 */
export interface UserContactInSchema {
    /**
     * 
     * @type {string}
     * @memberof UserContactInSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UserContactInSchema
     */
    'number': string;
    /**
     * 
     * @type {string}
     * @memberof UserContactInSchema
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserContactInSchema
     */
    'company'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserContactInSchema
     */
    'job_title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserContactInSchema
     */
    'address'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserContactInSchema
     */
    'is_private'?: boolean | null;
}
/**
 * 
 * @export
 * @interface UserContactOutSchema
 */
export interface UserContactOutSchema {
    /**
     * 
     * @type {string}
     * @memberof UserContactOutSchema
     */
    'user_fullname'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserContactOutSchema
     */
    'last_contacted'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserContactOutSchema
     */
    'first_contacted'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserContactOutSchema
     */
    'call_time': number;
    /**
     * 
     * @type {Array<TagOutSchema>}
     * @memberof UserContactOutSchema
     */
    'tags'?: Array<TagOutSchema>;
    /**
     * 
     * @type {string}
     * @memberof UserContactOutSchema
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserContactOutSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UserContactOutSchema
     */
    'number': string;
    /**
     * 
     * @type {string}
     * @memberof UserContactOutSchema
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserContactOutSchema
     */
    'company'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserContactOutSchema
     */
    'user': number;
    /**
     * 
     * @type {string}
     * @memberof UserContactOutSchema
     */
    'job_title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserContactOutSchema
     */
    'address'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserContactOutSchema
     */
    'assigned_agent'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserContactOutSchema
     */
    'is_added_by_agent'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserContactOutSchema
     */
    'date_created': string;
    /**
     * 
     * @type {string}
     * @memberof UserContactOutSchema
     */
    'followup_date'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserContactOutSchema
     */
    'is_private'?: boolean;
}
/**
 * 
 * @export
 * @interface UserContactUpdateSchema
 */
export interface UserContactUpdateSchema {
    /**
     * 
     * @type {string}
     * @memberof UserContactUpdateSchema
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserContactUpdateSchema
     */
    'number': string;
    /**
     * 
     * @type {string}
     * @memberof UserContactUpdateSchema
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserContactUpdateSchema
     */
    'company'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserContactUpdateSchema
     */
    'job_title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserContactUpdateSchema
     */
    'address'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserContactUpdateSchema
     */
    'is_private'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UserContactUpdateSchema
     */
    'assigned_agent'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserContactUpdateSchema
     */
    'is_added_by_agent'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UserContactUpdateSchema
     */
    'followup_date'?: string | null;
}
/**
 * 
 * @export
 * @interface UserContactsFilterSchema
 */
export interface UserContactsFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof UserContactsFilterSchema
     */
    'search'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserContactsFilterSchema
     */
    'tags'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserContactsFilterSchema
     */
    'is_private'?: boolean | null;
}
/**
 * 
 * @export
 * @interface UserInSchema
 */
export interface UserInSchema {
    /**
     * 
     * @type {string}
     * @memberof UserInSchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserInSchema
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof UserInSchema
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof UserInSchema
     */
    'mobile': string;
    /**
     * 
     * @type {string}
     * @memberof UserInSchema
     */
    'username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserInSchema
     */
    'invitation_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserInSchema
     */
    'business_use_case'?: string | null;
}
/**
 * 
 * @export
 * @interface UserOutSchema
 */
export interface UserOutSchema {
    /**
     * 
     * @type {number}
     * @memberof UserOutSchema
     */
    'number_of_invites': number;
    /**
     * 
     * @type {number}
     * @memberof UserOutSchema
     */
    'total_calls': number;
    /**
     * 
     * @type {VerificationOutSchema}
     * @memberof UserOutSchema
     */
    'verification': VerificationOutSchema;
    /**
     * 
     * @type {Array<ProfileOutSchema>}
     * @memberof UserOutSchema
     */
    'profiles': Array<ProfileOutSchema>;
    /**
     * 
     * @type {string}
     * @memberof UserOutSchema
     */
    'country': string;
    /**
     * 
     * @type {Array<BusinessOutSchema>}
     * @memberof UserOutSchema
     */
    'business': Array<BusinessOutSchema>;
    /**
     * 
     * @type {string}
     * @memberof UserOutSchema
     */
    'last_active'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserOutSchema
     */
    'global_id': string;
    /**
     * 
     * @type {FreeTrialDataOutSchema}
     * @memberof UserOutSchema
     */
    'free_trial_data': FreeTrialDataOutSchema;
    /**
     * 
     * @type {number}
     * @memberof UserOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserOutSchema
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserOutSchema
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserOutSchema
     */
    'mobile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserOutSchema
     */
    'personal_email': string;
    /**
     * 
     * @type {string}
     * @memberof UserOutSchema
     */
    'profile_picture'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserOutSchema
     */
    'invitation_code'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserOutSchema
     */
    'verified'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserOutSchema
     */
    'mobile_verified'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserOutSchema
     */
    'email_verified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserOutSchema
     */
    'next_two_factor_verification'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserOutSchema
     */
    'has_completed_signup'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserOutSchema
     */
    'has_completed_number_flow'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserOutSchema
     */
    'has_topped_up'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserOutSchema
     */
    'has_received_app_install_reward'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserOutSchema
     */
    'has_completed_feedback'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserOutSchema
     */
    'onboarding_stage'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserOutSchema
     */
    'has_filled_engagement_form'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserOutSchema
     */
    'home_address'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserOutSchema
     */
    'has_done_walkthrough'?: boolean;
}
/**
 * 
 * @export
 * @interface UserOutSchemaV2
 */
export interface UserOutSchemaV2 {
    /**
     * 
     * @type {string}
     * @memberof UserOutSchemaV2
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof UserOutSchemaV2
     */
    'global_id': string;
    /**
     * 
     * @type {number}
     * @memberof UserOutSchemaV2
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserOutSchemaV2
     */
    'mobile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserOutSchemaV2
     */
    'invitation_code'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserOutSchemaV2
     */
    'verified'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserOutSchemaV2
     */
    'mobile_verified'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserOutSchemaV2
     */
    'email_verified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserOutSchemaV2
     */
    'next_two_factor_verification'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserOutSchemaV2
     */
    'has_completed_signup'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserOutSchemaV2
     */
    'has_completed_number_flow'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserOutSchemaV2
     */
    'has_topped_up'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserOutSchemaV2
     */
    'has_received_app_install_reward'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserOutSchemaV2
     */
    'has_completed_feedback'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserOutSchemaV2
     */
    'onboarding_stage'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserOutSchemaV2
     */
    'has_filled_engagement_form'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserOutSchemaV2
     */
    'home_address'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserOutSchemaV2
     */
    'has_done_walkthrough'?: boolean;
}
/**
 * 
 * @export
 * @interface UserUpdateSchema
 */
export interface UserUpdateSchema {
    /**
     * 
     * @type {string}
     * @memberof UserUpdateSchema
     */
    'home_address'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdateSchema
     */
    'has_done_walkthrough'?: boolean | null;
}
/**
 * 
 * @export
 * @interface UserWithPasswordInSchema
 */
export interface UserWithPasswordInSchema {
    /**
     * 
     * @type {string}
     * @memberof UserWithPasswordInSchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserWithPasswordInSchema
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof UserWithPasswordInSchema
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof UserWithPasswordInSchema
     */
    'mobile': string;
    /**
     * 
     * @type {string}
     * @memberof UserWithPasswordInSchema
     */
    'username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserWithPasswordInSchema
     */
    'invitation_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserWithPasswordInSchema
     */
    'business_use_case'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserWithPasswordInSchema
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserWithPasswordInSchema
     */
    'recaptcha_token': string;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ValidationError
     */
    'loc': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorResponse
 */
export interface ValidationErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof ValidationErrorResponse
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ValidationErrorResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {ErrorCode}
     * @memberof ValidationErrorResponse
     */
    'code': ErrorCode;
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof ValidationErrorResponse
     */
    'data': Array<ValidationError>;
}


/**
 * 
 * @export
 * @interface VerificationDocumentFilterSchema
 */
export interface VerificationDocumentFilterSchema {
    /**
     * 
     * @type {boolean}
     * @memberof VerificationDocumentFilterSchema
     */
    'verified'?: boolean | null;
    /**
     * 
     * @type {VerificationDocumentStatus}
     * @memberof VerificationDocumentFilterSchema
     */
    'status'?: VerificationDocumentStatus | null;
}


/**
 * 
 * @export
 * @interface VerificationDocumentInSchema
 */
export interface VerificationDocumentInSchema {
    /**
     * 
     * @type {RequiredDocumentType}
     * @memberof VerificationDocumentInSchema
     */
    'identity_type': RequiredDocumentType;
    /**
     * 
     * @type {string}
     * @memberof VerificationDocumentInSchema
     */
    'id_number': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationDocumentInSchema
     */
    'document': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationDocumentInSchema
     */
    'file_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VerificationDocumentInSchema
     */
    'issue_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VerificationDocumentInSchema
     */
    'expiry_date'?: string | null;
}


/**
 * 
 * @export
 * @interface VerificationDocumentOutSchema
 */
export interface VerificationDocumentOutSchema {
    /**
     * 
     * @type {number}
     * @memberof VerificationDocumentOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VerificationDocumentOutSchema
     */
    'user': number;
    /**
     * 
     * @type {string}
     * @memberof VerificationDocumentOutSchema
     */
    'identity_type': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationDocumentOutSchema
     */
    'document': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationDocumentOutSchema
     */
    'id_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VerificationDocumentOutSchema
     */
    'issue_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VerificationDocumentOutSchema
     */
    'expiry_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VerificationDocumentOutSchema
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerificationDocumentOutSchema
     */
    'file_name'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const VerificationDocumentStatus = {
    Accepted: 'accepted',
    Rejected: 'rejected',
    Pending: 'pending'
} as const;

export type VerificationDocumentStatus = typeof VerificationDocumentStatus[keyof typeof VerificationDocumentStatus];


/**
 * 
 * @export
 * @interface VerificationDocumentThirdPartyInSchema
 */
export interface VerificationDocumentThirdPartyInSchema {
    /**
     * 
     * @type {RequiredDocumentType}
     * @memberof VerificationDocumentThirdPartyInSchema
     */
    'identity_type': RequiredDocumentType;
    /**
     * 
     * @type {string}
     * @memberof VerificationDocumentThirdPartyInSchema
     */
    'id_number': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationDocumentThirdPartyInSchema
     */
    'document': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationDocumentThirdPartyInSchema
     */
    'file_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VerificationDocumentThirdPartyInSchema
     */
    'issue_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VerificationDocumentThirdPartyInSchema
     */
    'expiry_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VerificationDocumentThirdPartyInSchema
     */
    'token': string;
}


/**
 * 
 * @export
 * @interface VerificationOTPInSchema
 */
export interface VerificationOTPInSchema {
    /**
     * 
     * @type {string}
     * @memberof VerificationOTPInSchema
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationOTPInSchema
     */
    'otp': string;
}
/**
 * 
 * @export
 * @interface VerificationOutSchema
 */
export interface VerificationOutSchema {
    /**
     * 
     * @type {string}
     * @memberof VerificationOutSchema
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationOutSchema
     */
    'verification_deadline': string | null;
    /**
     * 
     * @type {number}
     * @memberof VerificationOutSchema
     */
    'attempts_left': number;
}
/**
 * 
 * @export
 * @interface VoiceAccentOutSchema
 */
export interface VoiceAccentOutSchema {
    /**
     * 
     * @type {string}
     * @memberof VoiceAccentOutSchema
     */
    'voice_id': string;
    /**
     * 
     * @type {string}
     * @memberof VoiceAccentOutSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof VoiceAccentOutSchema
     */
    'description'?: string | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof VoiceAccentOutSchema
     */
    'labels'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {string}
     * @memberof VoiceAccentOutSchema
     */
    'preview_url': string;
}
/**
 * 
 * @export
 * @interface VoiceMailNotificationOutSchema
 */
export interface VoiceMailNotificationOutSchema {
    /**
     * 
     * @type {number}
     * @memberof VoiceMailNotificationOutSchema
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof VoiceMailNotificationOutSchema
     */
    'recording_url': string;
}
/**
 * 
 * @export
 * @interface VoiceOtpInSchema
 */
export interface VoiceOtpInSchema {
    /**
     * 
     * @type {string}
     * @memberof VoiceOtpInSchema
     */
    'did'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VoiceOtpInSchema
     */
    'session_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VoiceOtpInSchema
     */
    'repeats': number;
    /**
     * 
     * @type {string}
     * @memberof VoiceOtpInSchema
     */
    'callback_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VoiceOtpInSchema
     */
    'otp': string;
    /**
     * 
     * @type {string}
     * @memberof VoiceOtpInSchema
     */
    'mobile': string;
}
/**
 * 
 * @export
 * @interface VoiceScriptFilterSchema
 */
export interface VoiceScriptFilterSchema {
    /**
     * 
     * @type {GreetingType}
     * @memberof VoiceScriptFilterSchema
     */
    'type'?: GreetingType | null;
    /**
     * 
     * @type {string}
     * @memberof VoiceScriptFilterSchema
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VoiceScriptFilterSchema
     */
    'user_id'?: number | null;
}


/**
 * 
 * @export
 * @interface VoiceScriptOutSchema
 */
export interface VoiceScriptOutSchema {
    /**
     * 
     * @type {string}
     * @memberof VoiceScriptOutSchema
     */
    'script'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VoiceScriptOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VoiceScriptOutSchema
     */
    'business'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VoiceScriptOutSchema
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VoiceScriptOutSchema
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VoiceScriptOutSchema
     */
    'recording_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VoiceScriptOutSchema
     */
    'greeting_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VoiceScriptOutSchema
     */
    'voice_accent'?: string;
    /**
     * 
     * @type {number}
     * @memberof VoiceScriptOutSchema
     */
    'user': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const VoiceScriptStatus = {
    Pending: 'pending',
    Failed: 'failed',
    Ready: 'ready'
} as const;

export type VoiceScriptStatus = typeof VoiceScriptStatus[keyof typeof VoiceScriptStatus];


/**
 * 
 * @export
 * @interface VoicemailMessageFilterSchema
 */
export interface VoicemailMessageFilterSchema {
    /**
     * 
     * @type {string}
     * @memberof VoicemailMessageFilterSchema
     */
    'date_created_range'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VoicemailMessageFilterSchema
     */
    'phone_number'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VoicemailMessageFilterSchema
     */
    'is_played'?: boolean | null;
}
/**
 * 
 * @export
 * @interface VoicemailMessageOutSchema
 */
export interface VoicemailMessageOutSchema {
    /**
     * 
     * @type {string}
     * @memberof VoicemailMessageOutSchema
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VoicemailMessageOutSchema
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VoicemailMessageOutSchema
     */
    'date_created': string;
    /**
     * 
     * @type {number}
     * @memberof VoicemailMessageOutSchema
     */
    'business_number'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VoicemailMessageOutSchema
     */
    'caller_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VoicemailMessageOutSchema
     */
    'recording_url'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VoicemailMessageOutSchema
     */
    'is_played'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VoicemailMessageOutSchema
     */
    'call_log'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VoicemailMessageOutSchema
     */
    'duration_secs': number;
}
/**
 * 
 * @export
 * @interface WalletOutSchema
 */
export interface WalletOutSchema {
    /**
     * 
     * @type {number}
     * @memberof WalletOutSchema
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof WalletOutSchema
     */
    'balance': number;
    /**
     * 
     * @type {string}
     * @memberof WalletOutSchema
     */
    'nuban': string;
    /**
     * 
     * @type {string}
     * @memberof WalletOutSchema
     */
    'bank': string;
    /**
     * 
     * @type {string}
     * @memberof WalletOutSchema
     */
    'account_name': string;
}

/**
 * AddonsApi - axios parameter creator
 * @export
 */
export const AddonsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a list of all Addons.
         * @summary Get All Addon Plans
         * @param {number} businessId 
         * @param {AddonsViewsNinjaAddonGetAllAddonPlansTermEnum} term 
         * @param {string | null} [search] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        addonsViewsNinjaAddonGetAllAddonPlans: async (businessId: number, term: AddonsViewsNinjaAddonGetAllAddonPlansTermEnum, search?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaAddonGetAllAddonPlans', 'businessId', businessId)
            // verify required parameter 'term' is not null or undefined
            assertParamExists('addonsViewsNinjaAddonGetAllAddonPlans', 'term', term)
            const localVarPath = `/api/business/{business_id}/addons/plans/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of all subscribed Addons.
         * @summary Get All Subscribed Addons
         * @param {number} businessId 
         * @param {string | null} [search] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaAddonGetAllSubscribedAddons: async (businessId: number, search?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaAddonGetAllSubscribedAddons', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/addons/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Purchases a new addon subscription based on the provided data.
         * @summary Purchase Addon
         * @param {number} businessId 
         * @param {AddonSubscriptionInSchema} addonSubscriptionInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaAddonPurchaseAddon: async (businessId: number, addonSubscriptionInSchema: AddonSubscriptionInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaAddonPurchaseAddon', 'businessId', businessId)
            // verify required parameter 'addonSubscriptionInSchema' is not null or undefined
            assertParamExists('addonsViewsNinjaAddonPurchaseAddon', 'addonSubscriptionInSchema', addonSubscriptionInSchema)
            const localVarPath = `/api/business/{business_id}/addons/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addonSubscriptionInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes an Addon from a BusinessNumber.  Raises a 404 if either the BusinessNumber or Addon is not found.
         * @summary Remove Addon
         * @param {number} businessId 
         * @param {number} addonSubId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaAddonRemoveAddon: async (businessId: number, addonSubId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaAddonRemoveAddon', 'businessId', businessId)
            // verify required parameter 'addonSubId' is not null or undefined
            assertParamExists('addonsViewsNinjaAddonRemoveAddon', 'addonSubId', addonSubId)
            const localVarPath = `/api/business/{business_id}/addons/{addon_sub_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"addon_sub_id"}}`, encodeURIComponent(String(addonSubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddonsApi - functional programming interface
 * @export
 */
export const AddonsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AddonsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a list of all Addons.
         * @summary Get All Addon Plans
         * @param {number} businessId 
         * @param {AddonsViewsNinjaAddonGetAllAddonPlansTermEnum} term 
         * @param {string | null} [search] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async addonsViewsNinjaAddonGetAllAddonPlans(businessId: number, term: AddonsViewsNinjaAddonGetAllAddonPlansTermEnum, search?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedSubscriptionPlanOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaAddonGetAllAddonPlans(businessId, term, search, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddonsApi.addonsViewsNinjaAddonGetAllAddonPlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a list of all subscribed Addons.
         * @summary Get All Subscribed Addons
         * @param {number} businessId 
         * @param {string | null} [search] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaAddonGetAllSubscribedAddons(businessId: number, search?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedAddonSubscriptionOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaAddonGetAllSubscribedAddons(businessId, search, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddonsApi.addonsViewsNinjaAddonGetAllSubscribedAddons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Purchases a new addon subscription based on the provided data.
         * @summary Purchase Addon
         * @param {number} businessId 
         * @param {AddonSubscriptionInSchema} addonSubscriptionInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaAddonPurchaseAddon(businessId: number, addonSubscriptionInSchema: AddonSubscriptionInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAddonSubscriptionOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaAddonPurchaseAddon(businessId, addonSubscriptionInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddonsApi.addonsViewsNinjaAddonPurchaseAddon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes an Addon from a BusinessNumber.  Raises a 404 if either the BusinessNumber or Addon is not found.
         * @summary Remove Addon
         * @param {number} businessId 
         * @param {number} addonSubId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaAddonRemoveAddon(businessId: number, addonSubId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaAddonRemoveAddon(businessId, addonSubId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddonsApi.addonsViewsNinjaAddonRemoveAddon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AddonsApi - factory interface
 * @export
 */
export const AddonsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AddonsApiFp(configuration)
    return {
        /**
         * Retrieves a list of all Addons.
         * @summary Get All Addon Plans
         * @param {AddonsApiAddonsViewsNinjaAddonGetAllAddonPlansRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        addonsViewsNinjaAddonGetAllAddonPlans(requestParameters: AddonsApiAddonsViewsNinjaAddonGetAllAddonPlansRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedSubscriptionPlanOutSchema> {
            return localVarFp.addonsViewsNinjaAddonGetAllAddonPlans(requestParameters.businessId, requestParameters.term, requestParameters.search, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of all subscribed Addons.
         * @summary Get All Subscribed Addons
         * @param {AddonsApiAddonsViewsNinjaAddonGetAllSubscribedAddonsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaAddonGetAllSubscribedAddons(requestParameters: AddonsApiAddonsViewsNinjaAddonGetAllSubscribedAddonsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedAddonSubscriptionOutSchema> {
            return localVarFp.addonsViewsNinjaAddonGetAllSubscribedAddons(requestParameters.businessId, requestParameters.search, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * Purchases a new addon subscription based on the provided data.
         * @summary Purchase Addon
         * @param {AddonsApiAddonsViewsNinjaAddonPurchaseAddonRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaAddonPurchaseAddon(requestParameters: AddonsApiAddonsViewsNinjaAddonPurchaseAddonRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAddonSubscriptionOutSchema> {
            return localVarFp.addonsViewsNinjaAddonPurchaseAddon(requestParameters.businessId, requestParameters.addonSubscriptionInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes an Addon from a BusinessNumber.  Raises a 404 if either the BusinessNumber or Addon is not found.
         * @summary Remove Addon
         * @param {AddonsApiAddonsViewsNinjaAddonRemoveAddonRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaAddonRemoveAddon(requestParameters: AddonsApiAddonsViewsNinjaAddonRemoveAddonRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addonsViewsNinjaAddonRemoveAddon(requestParameters.businessId, requestParameters.addonSubId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addonsViewsNinjaAddonGetAllAddonPlans operation in AddonsApi.
 * @export
 * @interface AddonsApiAddonsViewsNinjaAddonGetAllAddonPlansRequest
 */
export interface AddonsApiAddonsViewsNinjaAddonGetAllAddonPlansRequest {
    /**
     * 
     * @type {number}
     * @memberof AddonsApiAddonsViewsNinjaAddonGetAllAddonPlans
     */
    readonly businessId: number

    /**
     * 
     * @type {'monthly' | 'quarterly' | 'yearly'}
     * @memberof AddonsApiAddonsViewsNinjaAddonGetAllAddonPlans
     */
    readonly term: AddonsViewsNinjaAddonGetAllAddonPlansTermEnum

    /**
     * 
     * @type {string}
     * @memberof AddonsApiAddonsViewsNinjaAddonGetAllAddonPlans
     */
    readonly search?: string | null

    /**
     * 
     * @type {number}
     * @memberof AddonsApiAddonsViewsNinjaAddonGetAllAddonPlans
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof AddonsApiAddonsViewsNinjaAddonGetAllAddonPlans
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof AddonsApiAddonsViewsNinjaAddonGetAllAddonPlans
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for addonsViewsNinjaAddonGetAllSubscribedAddons operation in AddonsApi.
 * @export
 * @interface AddonsApiAddonsViewsNinjaAddonGetAllSubscribedAddonsRequest
 */
export interface AddonsApiAddonsViewsNinjaAddonGetAllSubscribedAddonsRequest {
    /**
     * 
     * @type {number}
     * @memberof AddonsApiAddonsViewsNinjaAddonGetAllSubscribedAddons
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof AddonsApiAddonsViewsNinjaAddonGetAllSubscribedAddons
     */
    readonly search?: string | null

    /**
     * 
     * @type {number}
     * @memberof AddonsApiAddonsViewsNinjaAddonGetAllSubscribedAddons
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof AddonsApiAddonsViewsNinjaAddonGetAllSubscribedAddons
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof AddonsApiAddonsViewsNinjaAddonGetAllSubscribedAddons
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for addonsViewsNinjaAddonPurchaseAddon operation in AddonsApi.
 * @export
 * @interface AddonsApiAddonsViewsNinjaAddonPurchaseAddonRequest
 */
export interface AddonsApiAddonsViewsNinjaAddonPurchaseAddonRequest {
    /**
     * 
     * @type {number}
     * @memberof AddonsApiAddonsViewsNinjaAddonPurchaseAddon
     */
    readonly businessId: number

    /**
     * 
     * @type {AddonSubscriptionInSchema}
     * @memberof AddonsApiAddonsViewsNinjaAddonPurchaseAddon
     */
    readonly addonSubscriptionInSchema: AddonSubscriptionInSchema
}

/**
 * Request parameters for addonsViewsNinjaAddonRemoveAddon operation in AddonsApi.
 * @export
 * @interface AddonsApiAddonsViewsNinjaAddonRemoveAddonRequest
 */
export interface AddonsApiAddonsViewsNinjaAddonRemoveAddonRequest {
    /**
     * 
     * @type {number}
     * @memberof AddonsApiAddonsViewsNinjaAddonRemoveAddon
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof AddonsApiAddonsViewsNinjaAddonRemoveAddon
     */
    readonly addonSubId: number
}

/**
 * AddonsApi - object-oriented interface
 * @export
 * @class AddonsApi
 * @extends {BaseAPI}
 */
export class AddonsApi extends BaseAPI {
    /**
     * Retrieves a list of all Addons.
     * @summary Get All Addon Plans
     * @param {AddonsApiAddonsViewsNinjaAddonGetAllAddonPlansRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AddonsApi
     */
    public addonsViewsNinjaAddonGetAllAddonPlans(requestParameters: AddonsApiAddonsViewsNinjaAddonGetAllAddonPlansRequest, options?: RawAxiosRequestConfig) {
        return AddonsApiFp(this.configuration).addonsViewsNinjaAddonGetAllAddonPlans(requestParameters.businessId, requestParameters.term, requestParameters.search, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of all subscribed Addons.
     * @summary Get All Subscribed Addons
     * @param {AddonsApiAddonsViewsNinjaAddonGetAllSubscribedAddonsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddonsApi
     */
    public addonsViewsNinjaAddonGetAllSubscribedAddons(requestParameters: AddonsApiAddonsViewsNinjaAddonGetAllSubscribedAddonsRequest, options?: RawAxiosRequestConfig) {
        return AddonsApiFp(this.configuration).addonsViewsNinjaAddonGetAllSubscribedAddons(requestParameters.businessId, requestParameters.search, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Purchases a new addon subscription based on the provided data.
     * @summary Purchase Addon
     * @param {AddonsApiAddonsViewsNinjaAddonPurchaseAddonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddonsApi
     */
    public addonsViewsNinjaAddonPurchaseAddon(requestParameters: AddonsApiAddonsViewsNinjaAddonPurchaseAddonRequest, options?: RawAxiosRequestConfig) {
        return AddonsApiFp(this.configuration).addonsViewsNinjaAddonPurchaseAddon(requestParameters.businessId, requestParameters.addonSubscriptionInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes an Addon from a BusinessNumber.  Raises a 404 if either the BusinessNumber or Addon is not found.
     * @summary Remove Addon
     * @param {AddonsApiAddonsViewsNinjaAddonRemoveAddonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddonsApi
     */
    public addonsViewsNinjaAddonRemoveAddon(requestParameters: AddonsApiAddonsViewsNinjaAddonRemoveAddonRequest, options?: RawAxiosRequestConfig) {
        return AddonsApiFp(this.configuration).addonsViewsNinjaAddonRemoveAddon(requestParameters.businessId, requestParameters.addonSubId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AddonsViewsNinjaAddonGetAllAddonPlansTermEnum = {
    Monthly: 'monthly',
    Quarterly: 'quarterly',
    Yearly: 'yearly'
} as const;
export type AddonsViewsNinjaAddonGetAllAddonPlansTermEnum = typeof AddonsViewsNinjaAddonGetAllAddonPlansTermEnum[keyof typeof AddonsViewsNinjaAddonGetAllAddonPlansTermEnum];


/**
 * AddressApi - axios parameter creator
 * @export
 */
export const AddressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List Available Address
         * @param {string | null} [state] 
         * @param {string | null} [country] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaAddressListAvailableAddress: async (state?: string | null, country?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/available-address/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddressApi - functional programming interface
 * @export
 */
export const AddressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AddressApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List Available Address
         * @param {string | null} [state] 
         * @param {string | null} [country] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaAddressListAvailableAddress(state?: string | null, country?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedAvailableAddressOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaAddressListAvailableAddress(state, country, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddressApi.addonsViewsNinjaAddressListAvailableAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AddressApi - factory interface
 * @export
 */
export const AddressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AddressApiFp(configuration)
    return {
        /**
         * 
         * @summary List Available Address
         * @param {AddressApiAddonsViewsNinjaAddressListAvailableAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaAddressListAvailableAddress(requestParameters: AddressApiAddonsViewsNinjaAddressListAvailableAddressRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PagedAvailableAddressOutSchema> {
            return localVarFp.addonsViewsNinjaAddressListAvailableAddress(requestParameters.state, requestParameters.country, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addonsViewsNinjaAddressListAvailableAddress operation in AddressApi.
 * @export
 * @interface AddressApiAddonsViewsNinjaAddressListAvailableAddressRequest
 */
export interface AddressApiAddonsViewsNinjaAddressListAvailableAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof AddressApiAddonsViewsNinjaAddressListAvailableAddress
     */
    readonly state?: string | null

    /**
     * 
     * @type {string}
     * @memberof AddressApiAddonsViewsNinjaAddressListAvailableAddress
     */
    readonly country?: string | null

    /**
     * 
     * @type {number}
     * @memberof AddressApiAddonsViewsNinjaAddressListAvailableAddress
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof AddressApiAddonsViewsNinjaAddressListAvailableAddress
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof AddressApiAddonsViewsNinjaAddressListAvailableAddress
     */
    readonly ordering?: string | null
}

/**
 * AddressApi - object-oriented interface
 * @export
 * @class AddressApi
 * @extends {BaseAPI}
 */
export class AddressApi extends BaseAPI {
    /**
     * 
     * @summary List Available Address
     * @param {AddressApiAddonsViewsNinjaAddressListAvailableAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    public addonsViewsNinjaAddressListAvailableAddress(requestParameters: AddressApiAddonsViewsNinjaAddressListAvailableAddressRequest = {}, options?: RawAxiosRequestConfig) {
        return AddressApiFp(this.configuration).addonsViewsNinjaAddressListAvailableAddress(requestParameters.state, requestParameters.country, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AddressAddonApi - axios parameter creator
 * @export
 */
export const AddressAddonApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel Renewal For Address
         * @param {number} businessId 
         * @param {number} addressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaAddressCancelRenewalForAddress: async (businessId: number, addressId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaAddressCancelRenewalForAddress', 'businessId', businessId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('addonsViewsNinjaAddressCancelRenewalForAddress', 'addressId', addressId)
            const localVarPath = `/api/business/{business_id}/addons/address/{address_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"address_id"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Address For Business
         * @param {number} businessId 
         * @param {string | null} [state] 
         * @param {string | null} [country] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaAddressListAddressForBusiness: async (businessId: number, state?: string | null, country?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaAddressListAddressForBusiness', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/addons/address/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddressAddonApi - functional programming interface
 * @export
 */
export const AddressAddonApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AddressAddonApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cancel Renewal For Address
         * @param {number} businessId 
         * @param {number} addressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaAddressCancelRenewalForAddress(businessId: number, addressId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddressOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaAddressCancelRenewalForAddress(businessId, addressId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddressAddonApi.addonsViewsNinjaAddressCancelRenewalForAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Address For Business
         * @param {number} businessId 
         * @param {string | null} [state] 
         * @param {string | null} [country] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaAddressListAddressForBusiness(businessId: number, state?: string | null, country?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedAddressOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaAddressListAddressForBusiness(businessId, state, country, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddressAddonApi.addonsViewsNinjaAddressListAddressForBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AddressAddonApi - factory interface
 * @export
 */
export const AddressAddonApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AddressAddonApiFp(configuration)
    return {
        /**
         * 
         * @summary Cancel Renewal For Address
         * @param {AddressAddonApiAddonsViewsNinjaAddressCancelRenewalForAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaAddressCancelRenewalForAddress(requestParameters: AddressAddonApiAddonsViewsNinjaAddressCancelRenewalForAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddressOutSchema> {
            return localVarFp.addonsViewsNinjaAddressCancelRenewalForAddress(requestParameters.businessId, requestParameters.addressId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Address For Business
         * @param {AddressAddonApiAddonsViewsNinjaAddressListAddressForBusinessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaAddressListAddressForBusiness(requestParameters: AddressAddonApiAddonsViewsNinjaAddressListAddressForBusinessRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedAddressOutSchema> {
            return localVarFp.addonsViewsNinjaAddressListAddressForBusiness(requestParameters.businessId, requestParameters.state, requestParameters.country, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addonsViewsNinjaAddressCancelRenewalForAddress operation in AddressAddonApi.
 * @export
 * @interface AddressAddonApiAddonsViewsNinjaAddressCancelRenewalForAddressRequest
 */
export interface AddressAddonApiAddonsViewsNinjaAddressCancelRenewalForAddressRequest {
    /**
     * 
     * @type {number}
     * @memberof AddressAddonApiAddonsViewsNinjaAddressCancelRenewalForAddress
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof AddressAddonApiAddonsViewsNinjaAddressCancelRenewalForAddress
     */
    readonly addressId: number
}

/**
 * Request parameters for addonsViewsNinjaAddressListAddressForBusiness operation in AddressAddonApi.
 * @export
 * @interface AddressAddonApiAddonsViewsNinjaAddressListAddressForBusinessRequest
 */
export interface AddressAddonApiAddonsViewsNinjaAddressListAddressForBusinessRequest {
    /**
     * 
     * @type {number}
     * @memberof AddressAddonApiAddonsViewsNinjaAddressListAddressForBusiness
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof AddressAddonApiAddonsViewsNinjaAddressListAddressForBusiness
     */
    readonly state?: string | null

    /**
     * 
     * @type {string}
     * @memberof AddressAddonApiAddonsViewsNinjaAddressListAddressForBusiness
     */
    readonly country?: string | null

    /**
     * 
     * @type {number}
     * @memberof AddressAddonApiAddonsViewsNinjaAddressListAddressForBusiness
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof AddressAddonApiAddonsViewsNinjaAddressListAddressForBusiness
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof AddressAddonApiAddonsViewsNinjaAddressListAddressForBusiness
     */
    readonly ordering?: string | null
}

/**
 * AddressAddonApi - object-oriented interface
 * @export
 * @class AddressAddonApi
 * @extends {BaseAPI}
 */
export class AddressAddonApi extends BaseAPI {
    /**
     * 
     * @summary Cancel Renewal For Address
     * @param {AddressAddonApiAddonsViewsNinjaAddressCancelRenewalForAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressAddonApi
     */
    public addonsViewsNinjaAddressCancelRenewalForAddress(requestParameters: AddressAddonApiAddonsViewsNinjaAddressCancelRenewalForAddressRequest, options?: RawAxiosRequestConfig) {
        return AddressAddonApiFp(this.configuration).addonsViewsNinjaAddressCancelRenewalForAddress(requestParameters.businessId, requestParameters.addressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Address For Business
     * @param {AddressAddonApiAddonsViewsNinjaAddressListAddressForBusinessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressAddonApi
     */
    public addonsViewsNinjaAddressListAddressForBusiness(requestParameters: AddressAddonApiAddonsViewsNinjaAddressListAddressForBusinessRequest, options?: RawAxiosRequestConfig) {
        return AddressAddonApiFp(this.configuration).addonsViewsNinjaAddressListAddressForBusiness(requestParameters.businessId, requestParameters.state, requestParameters.country, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminAddressApi - axios parameter creator
 * @export
 */
export const AdminAddressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Admin List Addresses
         * @param {string | null} [state] 
         * @param {string | null} [country] 
         * @param {string | null} [status] 
         * @param {string | null} [businessName] 
         * @param {number | null} [availableAddressId] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsAddressAdminListAddresses: async (state?: string | null, country?: string | null, status?: string | null, businessName?: string | null, availableAddressId?: number | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/address/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (businessName !== undefined) {
                localVarQueryParameter['business_name'] = businessName;
            }

            if (availableAddressId !== undefined) {
                localVarQueryParameter['available_address_id'] = availableAddressId;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin List Available Address
         * @param {string | null} [state] 
         * @param {string | null} [country] 
         * @param {number | null} [availableAddressId] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsAddressAdminListAvailableAddress: async (state?: string | null, country?: string | null, availableAddressId?: number | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/available-address/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (availableAddressId !== undefined) {
                localVarQueryParameter['available_address_id'] = availableAddressId;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Update Address Status
         * @param {number} addressId 
         * @param {AddressStatusUpdateSchema} addressStatusUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsAddressAdminUpdateAddressStatus: async (addressId: number, addressStatusUpdateSchema: AddressStatusUpdateSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('managementViewsAddressAdminUpdateAddressStatus', 'addressId', addressId)
            // verify required parameter 'addressStatusUpdateSchema' is not null or undefined
            assertParamExists('managementViewsAddressAdminUpdateAddressStatus', 'addressStatusUpdateSchema', addressStatusUpdateSchema)
            const localVarPath = `/api/admin/address/{address_id}/`
                .replace(`{${"address_id"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addressStatusUpdateSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk Create Available Address
         * @param {BulkAvailableAddressInSchema} bulkAvailableAddressInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsAddressBulkCreateAvailableAddress: async (bulkAvailableAddressInSchema: BulkAvailableAddressInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkAvailableAddressInSchema' is not null or undefined
            assertParamExists('managementViewsAddressBulkCreateAvailableAddress', 'bulkAvailableAddressInSchema', bulkAvailableAddressInSchema)
            const localVarPath = `/api/admin/available-address/bulk/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkAvailableAddressInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Available Address
         * @param {AvailableAddressInSchema} availableAddressInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsAddressCreateAvailableAddress: async (availableAddressInSchema: AvailableAddressInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'availableAddressInSchema' is not null or undefined
            assertParamExists('managementViewsAddressCreateAvailableAddress', 'availableAddressInSchema', availableAddressInSchema)
            const localVarPath = `/api/admin/available-address/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(availableAddressInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminAddressApi - functional programming interface
 * @export
 */
export const AdminAddressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminAddressApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Admin List Addresses
         * @param {string | null} [state] 
         * @param {string | null} [country] 
         * @param {string | null} [status] 
         * @param {string | null} [businessName] 
         * @param {number | null} [availableAddressId] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementViewsAddressAdminListAddresses(state?: string | null, country?: string | null, status?: string | null, businessName?: string | null, availableAddressId?: number | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedAdminAddressOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementViewsAddressAdminListAddresses(state, country, status, businessName, availableAddressId, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAddressApi.managementViewsAddressAdminListAddresses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin List Available Address
         * @param {string | null} [state] 
         * @param {string | null} [country] 
         * @param {number | null} [availableAddressId] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementViewsAddressAdminListAvailableAddress(state?: string | null, country?: string | null, availableAddressId?: number | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedAdminAvailableAddressOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementViewsAddressAdminListAvailableAddress(state, country, availableAddressId, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAddressApi.managementViewsAddressAdminListAvailableAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Update Address Status
         * @param {number} addressId 
         * @param {AddressStatusUpdateSchema} addressStatusUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementViewsAddressAdminUpdateAddressStatus(addressId: number, addressStatusUpdateSchema: AddressStatusUpdateSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAddressOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementViewsAddressAdminUpdateAddressStatus(addressId, addressStatusUpdateSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAddressApi.managementViewsAddressAdminUpdateAddressStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Bulk Create Available Address
         * @param {BulkAvailableAddressInSchema} bulkAvailableAddressInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementViewsAddressBulkCreateAvailableAddress(bulkAvailableAddressInSchema: BulkAvailableAddressInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementViewsAddressBulkCreateAvailableAddress(bulkAvailableAddressInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAddressApi.managementViewsAddressBulkCreateAvailableAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Available Address
         * @param {AvailableAddressInSchema} availableAddressInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementViewsAddressCreateAvailableAddress(availableAddressInSchema: AvailableAddressInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailableAddressOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementViewsAddressCreateAvailableAddress(availableAddressInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAddressApi.managementViewsAddressCreateAvailableAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminAddressApi - factory interface
 * @export
 */
export const AdminAddressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminAddressApiFp(configuration)
    return {
        /**
         * 
         * @summary Admin List Addresses
         * @param {AdminAddressApiManagementViewsAddressAdminListAddressesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsAddressAdminListAddresses(requestParameters: AdminAddressApiManagementViewsAddressAdminListAddressesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PagedAdminAddressOutSchema> {
            return localVarFp.managementViewsAddressAdminListAddresses(requestParameters.state, requestParameters.country, requestParameters.status, requestParameters.businessName, requestParameters.availableAddressId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin List Available Address
         * @param {AdminAddressApiManagementViewsAddressAdminListAvailableAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsAddressAdminListAvailableAddress(requestParameters: AdminAddressApiManagementViewsAddressAdminListAvailableAddressRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PagedAdminAvailableAddressOutSchema> {
            return localVarFp.managementViewsAddressAdminListAvailableAddress(requestParameters.state, requestParameters.country, requestParameters.availableAddressId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Update Address Status
         * @param {AdminAddressApiManagementViewsAddressAdminUpdateAddressStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsAddressAdminUpdateAddressStatus(requestParameters: AdminAddressApiManagementViewsAddressAdminUpdateAddressStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminAddressOutSchema> {
            return localVarFp.managementViewsAddressAdminUpdateAddressStatus(requestParameters.addressId, requestParameters.addressStatusUpdateSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk Create Available Address
         * @param {AdminAddressApiManagementViewsAddressBulkCreateAvailableAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsAddressBulkCreateAvailableAddress(requestParameters: AdminAddressApiManagementViewsAddressBulkCreateAvailableAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.managementViewsAddressBulkCreateAvailableAddress(requestParameters.bulkAvailableAddressInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Available Address
         * @param {AdminAddressApiManagementViewsAddressCreateAvailableAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsAddressCreateAvailableAddress(requestParameters: AdminAddressApiManagementViewsAddressCreateAvailableAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<AvailableAddressOutSchema> {
            return localVarFp.managementViewsAddressCreateAvailableAddress(requestParameters.availableAddressInSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for managementViewsAddressAdminListAddresses operation in AdminAddressApi.
 * @export
 * @interface AdminAddressApiManagementViewsAddressAdminListAddressesRequest
 */
export interface AdminAddressApiManagementViewsAddressAdminListAddressesRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminAddressApiManagementViewsAddressAdminListAddresses
     */
    readonly state?: string | null

    /**
     * 
     * @type {string}
     * @memberof AdminAddressApiManagementViewsAddressAdminListAddresses
     */
    readonly country?: string | null

    /**
     * 
     * @type {string}
     * @memberof AdminAddressApiManagementViewsAddressAdminListAddresses
     */
    readonly status?: string | null

    /**
     * 
     * @type {string}
     * @memberof AdminAddressApiManagementViewsAddressAdminListAddresses
     */
    readonly businessName?: string | null

    /**
     * 
     * @type {number}
     * @memberof AdminAddressApiManagementViewsAddressAdminListAddresses
     */
    readonly availableAddressId?: number | null

    /**
     * 
     * @type {number}
     * @memberof AdminAddressApiManagementViewsAddressAdminListAddresses
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof AdminAddressApiManagementViewsAddressAdminListAddresses
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof AdminAddressApiManagementViewsAddressAdminListAddresses
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for managementViewsAddressAdminListAvailableAddress operation in AdminAddressApi.
 * @export
 * @interface AdminAddressApiManagementViewsAddressAdminListAvailableAddressRequest
 */
export interface AdminAddressApiManagementViewsAddressAdminListAvailableAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminAddressApiManagementViewsAddressAdminListAvailableAddress
     */
    readonly state?: string | null

    /**
     * 
     * @type {string}
     * @memberof AdminAddressApiManagementViewsAddressAdminListAvailableAddress
     */
    readonly country?: string | null

    /**
     * 
     * @type {number}
     * @memberof AdminAddressApiManagementViewsAddressAdminListAvailableAddress
     */
    readonly availableAddressId?: number | null

    /**
     * 
     * @type {number}
     * @memberof AdminAddressApiManagementViewsAddressAdminListAvailableAddress
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof AdminAddressApiManagementViewsAddressAdminListAvailableAddress
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof AdminAddressApiManagementViewsAddressAdminListAvailableAddress
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for managementViewsAddressAdminUpdateAddressStatus operation in AdminAddressApi.
 * @export
 * @interface AdminAddressApiManagementViewsAddressAdminUpdateAddressStatusRequest
 */
export interface AdminAddressApiManagementViewsAddressAdminUpdateAddressStatusRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminAddressApiManagementViewsAddressAdminUpdateAddressStatus
     */
    readonly addressId: number

    /**
     * 
     * @type {AddressStatusUpdateSchema}
     * @memberof AdminAddressApiManagementViewsAddressAdminUpdateAddressStatus
     */
    readonly addressStatusUpdateSchema: AddressStatusUpdateSchema
}

/**
 * Request parameters for managementViewsAddressBulkCreateAvailableAddress operation in AdminAddressApi.
 * @export
 * @interface AdminAddressApiManagementViewsAddressBulkCreateAvailableAddressRequest
 */
export interface AdminAddressApiManagementViewsAddressBulkCreateAvailableAddressRequest {
    /**
     * 
     * @type {BulkAvailableAddressInSchema}
     * @memberof AdminAddressApiManagementViewsAddressBulkCreateAvailableAddress
     */
    readonly bulkAvailableAddressInSchema: BulkAvailableAddressInSchema
}

/**
 * Request parameters for managementViewsAddressCreateAvailableAddress operation in AdminAddressApi.
 * @export
 * @interface AdminAddressApiManagementViewsAddressCreateAvailableAddressRequest
 */
export interface AdminAddressApiManagementViewsAddressCreateAvailableAddressRequest {
    /**
     * 
     * @type {AvailableAddressInSchema}
     * @memberof AdminAddressApiManagementViewsAddressCreateAvailableAddress
     */
    readonly availableAddressInSchema: AvailableAddressInSchema
}

/**
 * AdminAddressApi - object-oriented interface
 * @export
 * @class AdminAddressApi
 * @extends {BaseAPI}
 */
export class AdminAddressApi extends BaseAPI {
    /**
     * 
     * @summary Admin List Addresses
     * @param {AdminAddressApiManagementViewsAddressAdminListAddressesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAddressApi
     */
    public managementViewsAddressAdminListAddresses(requestParameters: AdminAddressApiManagementViewsAddressAdminListAddressesRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminAddressApiFp(this.configuration).managementViewsAddressAdminListAddresses(requestParameters.state, requestParameters.country, requestParameters.status, requestParameters.businessName, requestParameters.availableAddressId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin List Available Address
     * @param {AdminAddressApiManagementViewsAddressAdminListAvailableAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAddressApi
     */
    public managementViewsAddressAdminListAvailableAddress(requestParameters: AdminAddressApiManagementViewsAddressAdminListAvailableAddressRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminAddressApiFp(this.configuration).managementViewsAddressAdminListAvailableAddress(requestParameters.state, requestParameters.country, requestParameters.availableAddressId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Update Address Status
     * @param {AdminAddressApiManagementViewsAddressAdminUpdateAddressStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAddressApi
     */
    public managementViewsAddressAdminUpdateAddressStatus(requestParameters: AdminAddressApiManagementViewsAddressAdminUpdateAddressStatusRequest, options?: RawAxiosRequestConfig) {
        return AdminAddressApiFp(this.configuration).managementViewsAddressAdminUpdateAddressStatus(requestParameters.addressId, requestParameters.addressStatusUpdateSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk Create Available Address
     * @param {AdminAddressApiManagementViewsAddressBulkCreateAvailableAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAddressApi
     */
    public managementViewsAddressBulkCreateAvailableAddress(requestParameters: AdminAddressApiManagementViewsAddressBulkCreateAvailableAddressRequest, options?: RawAxiosRequestConfig) {
        return AdminAddressApiFp(this.configuration).managementViewsAddressBulkCreateAvailableAddress(requestParameters.bulkAvailableAddressInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Available Address
     * @param {AdminAddressApiManagementViewsAddressCreateAvailableAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAddressApi
     */
    public managementViewsAddressCreateAvailableAddress(requestParameters: AdminAddressApiManagementViewsAddressCreateAvailableAddressRequest, options?: RawAxiosRequestConfig) {
        return AdminAddressApiFp(this.configuration).managementViewsAddressCreateAvailableAddress(requestParameters.availableAddressInSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminVerificationApi - axios parameter creator
 * @export
 */
export const AdminVerificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Admin List Submitted Verification Documents
         * @param {boolean | null} [verified] 
         * @param {VerificationDocumentStatus | null} [status] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        usersViewsNinjaVerificationAdminListSubmittedVerificationDocuments: async (verified?: boolean | null, status?: VerificationDocumentStatus | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/verification/documents/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (verified !== undefined) {
                localVarQueryParameter['verified'] = verified;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin List Submitted Verification Documents New
         * @param {boolean | null} [verified] 
         * @param {boolean | null} [isGoGlobal] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsNew: async (verified?: boolean | null, isGoGlobal?: boolean | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/verification/documents/new/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (verified !== undefined) {
                localVarQueryParameter['verified'] = verified;
            }

            if (isGoGlobal !== undefined) {
                localVarQueryParameter['is_go_global'] = isGoGlobal;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Remove Verification Document
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaVerificationAdminRemoveVerificationDocument: async (documentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('usersViewsNinjaVerificationAdminRemoveVerificationDocument', 'documentId', documentId)
            const localVarPath = `/api/admin/verification/document/{document_id}/remove/`
                .replace(`{${"document_id"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Update Verification Document Status
         * @param {number} documentId 
         * @param {AdminUpdateVerificationStatusSchema} adminUpdateVerificationStatusSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaVerificationAdminUpdateVerificationDocumentStatus: async (documentId: number, adminUpdateVerificationStatusSchema: AdminUpdateVerificationStatusSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('usersViewsNinjaVerificationAdminUpdateVerificationDocumentStatus', 'documentId', documentId)
            // verify required parameter 'adminUpdateVerificationStatusSchema' is not null or undefined
            assertParamExists('usersViewsNinjaVerificationAdminUpdateVerificationDocumentStatus', 'adminUpdateVerificationStatusSchema', adminUpdateVerificationStatusSchema)
            const localVarPath = `/api/admin/verification/document/{document_id}/status/`
                .replace(`{${"document_id"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateVerificationStatusSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Upload Verification Document For User
         * @param {number} userId 
         * @param {VerificationDocumentInSchema} verificationDocumentInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaVerificationAdminUploadVerificationDocumentForUser: async (userId: number, verificationDocumentInSchema: VerificationDocumentInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('usersViewsNinjaVerificationAdminUploadVerificationDocumentForUser', 'userId', userId)
            // verify required parameter 'verificationDocumentInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaVerificationAdminUploadVerificationDocumentForUser', 'verificationDocumentInSchema', verificationDocumentInSchema)
            const localVarPath = `/api/admin/verification/document/{user_id}/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verificationDocumentInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify User
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaVerificationVerifyUser: async (userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('usersViewsNinjaVerificationVerifyUser', 'userId', userId)
            const localVarPath = `/api/admin/verification/{user_id}/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminVerificationApi - functional programming interface
 * @export
 */
export const AdminVerificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminVerificationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Admin List Submitted Verification Documents
         * @param {boolean | null} [verified] 
         * @param {VerificationDocumentStatus | null} [status] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async usersViewsNinjaVerificationAdminListSubmittedVerificationDocuments(verified?: boolean | null, status?: VerificationDocumentStatus | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedAdminVerificationDocumentOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaVerificationAdminListSubmittedVerificationDocuments(verified, status, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminVerificationApi.usersViewsNinjaVerificationAdminListSubmittedVerificationDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin List Submitted Verification Documents New
         * @param {boolean | null} [verified] 
         * @param {boolean | null} [isGoGlobal] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsNew(verified?: boolean | null, isGoGlobal?: boolean | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedAdminListVerificationDocumentOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsNew(verified, isGoGlobal, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminVerificationApi.usersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsNew']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Remove Verification Document
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaVerificationAdminRemoveVerificationDocument(documentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaVerificationAdminRemoveVerificationDocument(documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminVerificationApi.usersViewsNinjaVerificationAdminRemoveVerificationDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Update Verification Document Status
         * @param {number} documentId 
         * @param {AdminUpdateVerificationStatusSchema} adminUpdateVerificationStatusSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaVerificationAdminUpdateVerificationDocumentStatus(documentId: number, adminUpdateVerificationStatusSchema: AdminUpdateVerificationStatusSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVerificationDocumentOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaVerificationAdminUpdateVerificationDocumentStatus(documentId, adminUpdateVerificationStatusSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminVerificationApi.usersViewsNinjaVerificationAdminUpdateVerificationDocumentStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Upload Verification Document For User
         * @param {number} userId 
         * @param {VerificationDocumentInSchema} verificationDocumentInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaVerificationAdminUploadVerificationDocumentForUser(userId: number, verificationDocumentInSchema: VerificationDocumentInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminVerificationDocumentOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaVerificationAdminUploadVerificationDocumentForUser(userId, verificationDocumentInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminVerificationApi.usersViewsNinjaVerificationAdminUploadVerificationDocumentForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify User
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaVerificationVerifyUser(userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaVerificationVerifyUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminVerificationApi.usersViewsNinjaVerificationVerifyUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminVerificationApi - factory interface
 * @export
 */
export const AdminVerificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminVerificationApiFp(configuration)
    return {
        /**
         * 
         * @summary Admin List Submitted Verification Documents
         * @param {AdminVerificationApiUsersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        usersViewsNinjaVerificationAdminListSubmittedVerificationDocuments(requestParameters: AdminVerificationApiUsersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PagedAdminVerificationDocumentOutSchema> {
            return localVarFp.usersViewsNinjaVerificationAdminListSubmittedVerificationDocuments(requestParameters.verified, requestParameters.status, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin List Submitted Verification Documents New
         * @param {AdminVerificationApiUsersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsNewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsNew(requestParameters: AdminVerificationApiUsersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsNewRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PagedAdminListVerificationDocumentOutSchema> {
            return localVarFp.usersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsNew(requestParameters.verified, requestParameters.isGoGlobal, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Remove Verification Document
         * @param {AdminVerificationApiUsersViewsNinjaVerificationAdminRemoveVerificationDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaVerificationAdminRemoveVerificationDocument(requestParameters: AdminVerificationApiUsersViewsNinjaVerificationAdminRemoveVerificationDocumentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.usersViewsNinjaVerificationAdminRemoveVerificationDocument(requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Update Verification Document Status
         * @param {AdminVerificationApiUsersViewsNinjaVerificationAdminUpdateVerificationDocumentStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaVerificationAdminUpdateVerificationDocumentStatus(requestParameters: AdminVerificationApiUsersViewsNinjaVerificationAdminUpdateVerificationDocumentStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminVerificationDocumentOutSchema> {
            return localVarFp.usersViewsNinjaVerificationAdminUpdateVerificationDocumentStatus(requestParameters.documentId, requestParameters.adminUpdateVerificationStatusSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Upload Verification Document For User
         * @param {AdminVerificationApiUsersViewsNinjaVerificationAdminUploadVerificationDocumentForUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaVerificationAdminUploadVerificationDocumentForUser(requestParameters: AdminVerificationApiUsersViewsNinjaVerificationAdminUploadVerificationDocumentForUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminVerificationDocumentOutSchema> {
            return localVarFp.usersViewsNinjaVerificationAdminUploadVerificationDocumentForUser(requestParameters.userId, requestParameters.verificationDocumentInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify User
         * @param {AdminVerificationApiUsersViewsNinjaVerificationVerifyUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaVerificationVerifyUser(requestParameters: AdminVerificationApiUsersViewsNinjaVerificationVerifyUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaVerificationVerifyUser(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for usersViewsNinjaVerificationAdminListSubmittedVerificationDocuments operation in AdminVerificationApi.
 * @export
 * @interface AdminVerificationApiUsersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsRequest
 */
export interface AdminVerificationApiUsersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof AdminVerificationApiUsersViewsNinjaVerificationAdminListSubmittedVerificationDocuments
     */
    readonly verified?: boolean | null

    /**
     * 
     * @type {VerificationDocumentStatus}
     * @memberof AdminVerificationApiUsersViewsNinjaVerificationAdminListSubmittedVerificationDocuments
     */
    readonly status?: VerificationDocumentStatus | null

    /**
     * 
     * @type {number}
     * @memberof AdminVerificationApiUsersViewsNinjaVerificationAdminListSubmittedVerificationDocuments
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof AdminVerificationApiUsersViewsNinjaVerificationAdminListSubmittedVerificationDocuments
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof AdminVerificationApiUsersViewsNinjaVerificationAdminListSubmittedVerificationDocuments
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for usersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsNew operation in AdminVerificationApi.
 * @export
 * @interface AdminVerificationApiUsersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsNewRequest
 */
export interface AdminVerificationApiUsersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsNewRequest {
    /**
     * 
     * @type {boolean}
     * @memberof AdminVerificationApiUsersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsNew
     */
    readonly verified?: boolean | null

    /**
     * 
     * @type {boolean}
     * @memberof AdminVerificationApiUsersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsNew
     */
    readonly isGoGlobal?: boolean | null

    /**
     * 
     * @type {number}
     * @memberof AdminVerificationApiUsersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsNew
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof AdminVerificationApiUsersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsNew
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof AdminVerificationApiUsersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsNew
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for usersViewsNinjaVerificationAdminRemoveVerificationDocument operation in AdminVerificationApi.
 * @export
 * @interface AdminVerificationApiUsersViewsNinjaVerificationAdminRemoveVerificationDocumentRequest
 */
export interface AdminVerificationApiUsersViewsNinjaVerificationAdminRemoveVerificationDocumentRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminVerificationApiUsersViewsNinjaVerificationAdminRemoveVerificationDocument
     */
    readonly documentId: number
}

/**
 * Request parameters for usersViewsNinjaVerificationAdminUpdateVerificationDocumentStatus operation in AdminVerificationApi.
 * @export
 * @interface AdminVerificationApiUsersViewsNinjaVerificationAdminUpdateVerificationDocumentStatusRequest
 */
export interface AdminVerificationApiUsersViewsNinjaVerificationAdminUpdateVerificationDocumentStatusRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminVerificationApiUsersViewsNinjaVerificationAdminUpdateVerificationDocumentStatus
     */
    readonly documentId: number

    /**
     * 
     * @type {AdminUpdateVerificationStatusSchema}
     * @memberof AdminVerificationApiUsersViewsNinjaVerificationAdminUpdateVerificationDocumentStatus
     */
    readonly adminUpdateVerificationStatusSchema: AdminUpdateVerificationStatusSchema
}

/**
 * Request parameters for usersViewsNinjaVerificationAdminUploadVerificationDocumentForUser operation in AdminVerificationApi.
 * @export
 * @interface AdminVerificationApiUsersViewsNinjaVerificationAdminUploadVerificationDocumentForUserRequest
 */
export interface AdminVerificationApiUsersViewsNinjaVerificationAdminUploadVerificationDocumentForUserRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminVerificationApiUsersViewsNinjaVerificationAdminUploadVerificationDocumentForUser
     */
    readonly userId: number

    /**
     * 
     * @type {VerificationDocumentInSchema}
     * @memberof AdminVerificationApiUsersViewsNinjaVerificationAdminUploadVerificationDocumentForUser
     */
    readonly verificationDocumentInSchema: VerificationDocumentInSchema
}

/**
 * Request parameters for usersViewsNinjaVerificationVerifyUser operation in AdminVerificationApi.
 * @export
 * @interface AdminVerificationApiUsersViewsNinjaVerificationVerifyUserRequest
 */
export interface AdminVerificationApiUsersViewsNinjaVerificationVerifyUserRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminVerificationApiUsersViewsNinjaVerificationVerifyUser
     */
    readonly userId: number
}

/**
 * AdminVerificationApi - object-oriented interface
 * @export
 * @class AdminVerificationApi
 * @extends {BaseAPI}
 */
export class AdminVerificationApi extends BaseAPI {
    /**
     * 
     * @summary Admin List Submitted Verification Documents
     * @param {AdminVerificationApiUsersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdminVerificationApi
     */
    public usersViewsNinjaVerificationAdminListSubmittedVerificationDocuments(requestParameters: AdminVerificationApiUsersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminVerificationApiFp(this.configuration).usersViewsNinjaVerificationAdminListSubmittedVerificationDocuments(requestParameters.verified, requestParameters.status, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin List Submitted Verification Documents New
     * @param {AdminVerificationApiUsersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsNewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminVerificationApi
     */
    public usersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsNew(requestParameters: AdminVerificationApiUsersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsNewRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminVerificationApiFp(this.configuration).usersViewsNinjaVerificationAdminListSubmittedVerificationDocumentsNew(requestParameters.verified, requestParameters.isGoGlobal, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Remove Verification Document
     * @param {AdminVerificationApiUsersViewsNinjaVerificationAdminRemoveVerificationDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminVerificationApi
     */
    public usersViewsNinjaVerificationAdminRemoveVerificationDocument(requestParameters: AdminVerificationApiUsersViewsNinjaVerificationAdminRemoveVerificationDocumentRequest, options?: RawAxiosRequestConfig) {
        return AdminVerificationApiFp(this.configuration).usersViewsNinjaVerificationAdminRemoveVerificationDocument(requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Update Verification Document Status
     * @param {AdminVerificationApiUsersViewsNinjaVerificationAdminUpdateVerificationDocumentStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminVerificationApi
     */
    public usersViewsNinjaVerificationAdminUpdateVerificationDocumentStatus(requestParameters: AdminVerificationApiUsersViewsNinjaVerificationAdminUpdateVerificationDocumentStatusRequest, options?: RawAxiosRequestConfig) {
        return AdminVerificationApiFp(this.configuration).usersViewsNinjaVerificationAdminUpdateVerificationDocumentStatus(requestParameters.documentId, requestParameters.adminUpdateVerificationStatusSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Upload Verification Document For User
     * @param {AdminVerificationApiUsersViewsNinjaVerificationAdminUploadVerificationDocumentForUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminVerificationApi
     */
    public usersViewsNinjaVerificationAdminUploadVerificationDocumentForUser(requestParameters: AdminVerificationApiUsersViewsNinjaVerificationAdminUploadVerificationDocumentForUserRequest, options?: RawAxiosRequestConfig) {
        return AdminVerificationApiFp(this.configuration).usersViewsNinjaVerificationAdminUploadVerificationDocumentForUser(requestParameters.userId, requestParameters.verificationDocumentInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify User
     * @param {AdminVerificationApiUsersViewsNinjaVerificationVerifyUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminVerificationApi
     */
    public usersViewsNinjaVerificationVerifyUser(requestParameters: AdminVerificationApiUsersViewsNinjaVerificationVerifyUserRequest, options?: RawAxiosRequestConfig) {
        return AdminVerificationApiFp(this.configuration).usersViewsNinjaVerificationVerifyUser(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ApiKeysApi - axios parameter creator
 * @export
 */
export const ApiKeysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete Api Key
         * @param {number} businessId 
         * @param {string} apikey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaApiKeysDeleteApiKey: async (businessId: number, apikey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaApiKeysDeleteApiKey', 'businessId', businessId)
            // verify required parameter 'apikey' is not null or undefined
            assertParamExists('usersViewsNinjaApiKeysDeleteApiKey', 'apikey', apikey)
            const localVarPath = `/api/business/{business_id}/api-keys/v2/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apikey !== undefined) {
                localVarQueryParameter['apikey'] = apikey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate Api Key
         * @param {number} businessId 
         * @param {StandardizedApiKeyInSchema} standardizedApiKeyInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaApiKeysGenerateApiKey: async (businessId: number, standardizedApiKeyInSchema: StandardizedApiKeyInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaApiKeysGenerateApiKey', 'businessId', businessId)
            // verify required parameter 'standardizedApiKeyInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaApiKeysGenerateApiKey', 'standardizedApiKeyInSchema', standardizedApiKeyInSchema)
            const localVarPath = `/api/business/{business_id}/api-keys/v2/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(standardizedApiKeyInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate Api Keys
         * @param {number} businessId 
         * @param {ApiKeysInSchema} apiKeysInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaApiKeysGenerateApiKeys: async (businessId: number, apiKeysInSchema: ApiKeysInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaApiKeysGenerateApiKeys', 'businessId', businessId)
            // verify required parameter 'apiKeysInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaApiKeysGenerateApiKeys', 'apiKeysInSchema', apiKeysInSchema)
            const localVarPath = `/api/business/{business_id}/api-keys/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiKeysInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Public Key
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaApiKeysGetPublicKey: async (businessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaApiKeysGetPublicKey', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/api-keys/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Api Keys
         * @param {number} businessId 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaApiKeysListApiKeys: async (businessId: number, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaApiKeysListApiKeys', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/api-keys/v2/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Api Key
         * @param {number} businessId 
         * @param {string} apikey 
         * @param {StandardizedApiKeyUpdateSchema} standardizedApiKeyUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaApiKeysUpdateApiKey: async (businessId: number, apikey: string, standardizedApiKeyUpdateSchema: StandardizedApiKeyUpdateSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaApiKeysUpdateApiKey', 'businessId', businessId)
            // verify required parameter 'apikey' is not null or undefined
            assertParamExists('usersViewsNinjaApiKeysUpdateApiKey', 'apikey', apikey)
            // verify required parameter 'standardizedApiKeyUpdateSchema' is not null or undefined
            assertParamExists('usersViewsNinjaApiKeysUpdateApiKey', 'standardizedApiKeyUpdateSchema', standardizedApiKeyUpdateSchema)
            const localVarPath = `/api/business/{business_id}/api-keys/v2/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (apikey !== undefined) {
                localVarQueryParameter['apikey'] = apikey;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(standardizedApiKeyUpdateSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiKeysApi - functional programming interface
 * @export
 */
export const ApiKeysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiKeysApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete Api Key
         * @param {number} businessId 
         * @param {string} apikey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaApiKeysDeleteApiKey(businessId: number, apikey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaApiKeysDeleteApiKey(businessId, apikey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiKeysApi.usersViewsNinjaApiKeysDeleteApiKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generate Api Key
         * @param {number} businessId 
         * @param {StandardizedApiKeyInSchema} standardizedApiKeyInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaApiKeysGenerateApiKey(businessId: number, standardizedApiKeyInSchema: StandardizedApiKeyInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StandardizedApiKeyOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaApiKeysGenerateApiKey(businessId, standardizedApiKeyInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiKeysApi.usersViewsNinjaApiKeysGenerateApiKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generate Api Keys
         * @param {number} businessId 
         * @param {ApiKeysInSchema} apiKeysInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaApiKeysGenerateApiKeys(businessId: number, apiKeysInSchema: ApiKeysInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiKeysOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaApiKeysGenerateApiKeys(businessId, apiKeysInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiKeysApi.usersViewsNinjaApiKeysGenerateApiKeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Public Key
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaApiKeysGetPublicKey(businessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiKeysOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaApiKeysGetPublicKey(businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiKeysApi.usersViewsNinjaApiKeysGetPublicKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Api Keys
         * @param {number} businessId 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaApiKeysListApiKeys(businessId: number, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedStandardizedApiKeyOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaApiKeysListApiKeys(businessId, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiKeysApi.usersViewsNinjaApiKeysListApiKeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Api Key
         * @param {number} businessId 
         * @param {string} apikey 
         * @param {StandardizedApiKeyUpdateSchema} standardizedApiKeyUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaApiKeysUpdateApiKey(businessId: number, apikey: string, standardizedApiKeyUpdateSchema: StandardizedApiKeyUpdateSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StandardizedApiKeyUpdateOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaApiKeysUpdateApiKey(businessId, apikey, standardizedApiKeyUpdateSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiKeysApi.usersViewsNinjaApiKeysUpdateApiKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ApiKeysApi - factory interface
 * @export
 */
export const ApiKeysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiKeysApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete Api Key
         * @param {ApiKeysApiUsersViewsNinjaApiKeysDeleteApiKeyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaApiKeysDeleteApiKey(requestParameters: ApiKeysApiUsersViewsNinjaApiKeysDeleteApiKeyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.usersViewsNinjaApiKeysDeleteApiKey(requestParameters.businessId, requestParameters.apikey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate Api Key
         * @param {ApiKeysApiUsersViewsNinjaApiKeysGenerateApiKeyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaApiKeysGenerateApiKey(requestParameters: ApiKeysApiUsersViewsNinjaApiKeysGenerateApiKeyRequest, options?: RawAxiosRequestConfig): AxiosPromise<StandardizedApiKeyOutSchema> {
            return localVarFp.usersViewsNinjaApiKeysGenerateApiKey(requestParameters.businessId, requestParameters.standardizedApiKeyInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate Api Keys
         * @param {ApiKeysApiUsersViewsNinjaApiKeysGenerateApiKeysRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaApiKeysGenerateApiKeys(requestParameters: ApiKeysApiUsersViewsNinjaApiKeysGenerateApiKeysRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiKeysOutSchema> {
            return localVarFp.usersViewsNinjaApiKeysGenerateApiKeys(requestParameters.businessId, requestParameters.apiKeysInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Public Key
         * @param {ApiKeysApiUsersViewsNinjaApiKeysGetPublicKeyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaApiKeysGetPublicKey(requestParameters: ApiKeysApiUsersViewsNinjaApiKeysGetPublicKeyRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiKeysOutSchema> {
            return localVarFp.usersViewsNinjaApiKeysGetPublicKey(requestParameters.businessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Api Keys
         * @param {ApiKeysApiUsersViewsNinjaApiKeysListApiKeysRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaApiKeysListApiKeys(requestParameters: ApiKeysApiUsersViewsNinjaApiKeysListApiKeysRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedStandardizedApiKeyOutSchema> {
            return localVarFp.usersViewsNinjaApiKeysListApiKeys(requestParameters.businessId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Api Key
         * @param {ApiKeysApiUsersViewsNinjaApiKeysUpdateApiKeyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaApiKeysUpdateApiKey(requestParameters: ApiKeysApiUsersViewsNinjaApiKeysUpdateApiKeyRequest, options?: RawAxiosRequestConfig): AxiosPromise<StandardizedApiKeyUpdateOutSchema> {
            return localVarFp.usersViewsNinjaApiKeysUpdateApiKey(requestParameters.businessId, requestParameters.apikey, requestParameters.standardizedApiKeyUpdateSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for usersViewsNinjaApiKeysDeleteApiKey operation in ApiKeysApi.
 * @export
 * @interface ApiKeysApiUsersViewsNinjaApiKeysDeleteApiKeyRequest
 */
export interface ApiKeysApiUsersViewsNinjaApiKeysDeleteApiKeyRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiKeysApiUsersViewsNinjaApiKeysDeleteApiKey
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof ApiKeysApiUsersViewsNinjaApiKeysDeleteApiKey
     */
    readonly apikey: string
}

/**
 * Request parameters for usersViewsNinjaApiKeysGenerateApiKey operation in ApiKeysApi.
 * @export
 * @interface ApiKeysApiUsersViewsNinjaApiKeysGenerateApiKeyRequest
 */
export interface ApiKeysApiUsersViewsNinjaApiKeysGenerateApiKeyRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiKeysApiUsersViewsNinjaApiKeysGenerateApiKey
     */
    readonly businessId: number

    /**
     * 
     * @type {StandardizedApiKeyInSchema}
     * @memberof ApiKeysApiUsersViewsNinjaApiKeysGenerateApiKey
     */
    readonly standardizedApiKeyInSchema: StandardizedApiKeyInSchema
}

/**
 * Request parameters for usersViewsNinjaApiKeysGenerateApiKeys operation in ApiKeysApi.
 * @export
 * @interface ApiKeysApiUsersViewsNinjaApiKeysGenerateApiKeysRequest
 */
export interface ApiKeysApiUsersViewsNinjaApiKeysGenerateApiKeysRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiKeysApiUsersViewsNinjaApiKeysGenerateApiKeys
     */
    readonly businessId: number

    /**
     * 
     * @type {ApiKeysInSchema}
     * @memberof ApiKeysApiUsersViewsNinjaApiKeysGenerateApiKeys
     */
    readonly apiKeysInSchema: ApiKeysInSchema
}

/**
 * Request parameters for usersViewsNinjaApiKeysGetPublicKey operation in ApiKeysApi.
 * @export
 * @interface ApiKeysApiUsersViewsNinjaApiKeysGetPublicKeyRequest
 */
export interface ApiKeysApiUsersViewsNinjaApiKeysGetPublicKeyRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiKeysApiUsersViewsNinjaApiKeysGetPublicKey
     */
    readonly businessId: number
}

/**
 * Request parameters for usersViewsNinjaApiKeysListApiKeys operation in ApiKeysApi.
 * @export
 * @interface ApiKeysApiUsersViewsNinjaApiKeysListApiKeysRequest
 */
export interface ApiKeysApiUsersViewsNinjaApiKeysListApiKeysRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiKeysApiUsersViewsNinjaApiKeysListApiKeys
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof ApiKeysApiUsersViewsNinjaApiKeysListApiKeys
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof ApiKeysApiUsersViewsNinjaApiKeysListApiKeys
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof ApiKeysApiUsersViewsNinjaApiKeysListApiKeys
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for usersViewsNinjaApiKeysUpdateApiKey operation in ApiKeysApi.
 * @export
 * @interface ApiKeysApiUsersViewsNinjaApiKeysUpdateApiKeyRequest
 */
export interface ApiKeysApiUsersViewsNinjaApiKeysUpdateApiKeyRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiKeysApiUsersViewsNinjaApiKeysUpdateApiKey
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof ApiKeysApiUsersViewsNinjaApiKeysUpdateApiKey
     */
    readonly apikey: string

    /**
     * 
     * @type {StandardizedApiKeyUpdateSchema}
     * @memberof ApiKeysApiUsersViewsNinjaApiKeysUpdateApiKey
     */
    readonly standardizedApiKeyUpdateSchema: StandardizedApiKeyUpdateSchema
}

/**
 * ApiKeysApi - object-oriented interface
 * @export
 * @class ApiKeysApi
 * @extends {BaseAPI}
 */
export class ApiKeysApi extends BaseAPI {
    /**
     * 
     * @summary Delete Api Key
     * @param {ApiKeysApiUsersViewsNinjaApiKeysDeleteApiKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApi
     */
    public usersViewsNinjaApiKeysDeleteApiKey(requestParameters: ApiKeysApiUsersViewsNinjaApiKeysDeleteApiKeyRequest, options?: RawAxiosRequestConfig) {
        return ApiKeysApiFp(this.configuration).usersViewsNinjaApiKeysDeleteApiKey(requestParameters.businessId, requestParameters.apikey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate Api Key
     * @param {ApiKeysApiUsersViewsNinjaApiKeysGenerateApiKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApi
     */
    public usersViewsNinjaApiKeysGenerateApiKey(requestParameters: ApiKeysApiUsersViewsNinjaApiKeysGenerateApiKeyRequest, options?: RawAxiosRequestConfig) {
        return ApiKeysApiFp(this.configuration).usersViewsNinjaApiKeysGenerateApiKey(requestParameters.businessId, requestParameters.standardizedApiKeyInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate Api Keys
     * @param {ApiKeysApiUsersViewsNinjaApiKeysGenerateApiKeysRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApi
     */
    public usersViewsNinjaApiKeysGenerateApiKeys(requestParameters: ApiKeysApiUsersViewsNinjaApiKeysGenerateApiKeysRequest, options?: RawAxiosRequestConfig) {
        return ApiKeysApiFp(this.configuration).usersViewsNinjaApiKeysGenerateApiKeys(requestParameters.businessId, requestParameters.apiKeysInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Public Key
     * @param {ApiKeysApiUsersViewsNinjaApiKeysGetPublicKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApi
     */
    public usersViewsNinjaApiKeysGetPublicKey(requestParameters: ApiKeysApiUsersViewsNinjaApiKeysGetPublicKeyRequest, options?: RawAxiosRequestConfig) {
        return ApiKeysApiFp(this.configuration).usersViewsNinjaApiKeysGetPublicKey(requestParameters.businessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Api Keys
     * @param {ApiKeysApiUsersViewsNinjaApiKeysListApiKeysRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApi
     */
    public usersViewsNinjaApiKeysListApiKeys(requestParameters: ApiKeysApiUsersViewsNinjaApiKeysListApiKeysRequest, options?: RawAxiosRequestConfig) {
        return ApiKeysApiFp(this.configuration).usersViewsNinjaApiKeysListApiKeys(requestParameters.businessId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Api Key
     * @param {ApiKeysApiUsersViewsNinjaApiKeysUpdateApiKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiKeysApi
     */
    public usersViewsNinjaApiKeysUpdateApiKey(requestParameters: ApiKeysApiUsersViewsNinjaApiKeysUpdateApiKeyRequest, options?: RawAxiosRequestConfig) {
        return ApiKeysApiFp(this.configuration).usersViewsNinjaApiKeysUpdateApiKey(requestParameters.businessId, requestParameters.apikey, requestParameters.standardizedApiKeyUpdateSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Email Login
         * @param {LoginInputSchema} loginInputSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaAuthEmailLogin: async (loginInputSchema: LoginInputSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginInputSchema' is not null or undefined
            assertParamExists('usersViewsNinjaAuthEmailLogin', 'loginInputSchema', loginInputSchema)
            const localVarPath = `/api/auth/login/email/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginInputSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Magic Link Login
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaAuthMagicLinkLogin: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('usersViewsNinjaAuthMagicLinkLogin', 'token', token)
            const localVarPath = `/api/auth/login/magic-link/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Password Change
         * @param {PasswordChangeInSchema} passwordChangeInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaAuthPasswordChange: async (passwordChangeInSchema: PasswordChangeInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordChangeInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaAuthPasswordChange', 'passwordChangeInSchema', passwordChangeInSchema)
            const localVarPath = `/api/auth/password/change/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordChangeInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Password Reset Confirm
         * @param {PasswordResetConfirmInSchema} passwordResetConfirmInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaAuthPasswordResetConfirm: async (passwordResetConfirmInSchema: PasswordResetConfirmInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordResetConfirmInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaAuthPasswordResetConfirm', 'passwordResetConfirmInSchema', passwordResetConfirmInSchema)
            const localVarPath = `/api/auth/password/reset/confirm/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordResetConfirmInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Password Reset Request
         * @param {EmailInputSchema} emailInputSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaAuthPasswordResetRequest: async (emailInputSchema: EmailInputSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailInputSchema' is not null or undefined
            assertParamExists('usersViewsNinjaAuthPasswordResetRequest', 'emailInputSchema', emailInputSchema)
            const localVarPath = `/api/auth/password/reset/request/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailInputSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register User
         * @param {UserWithPasswordInSchema} userWithPasswordInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaAuthRegisterUser: async (userWithPasswordInSchema: UserWithPasswordInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userWithPasswordInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaAuthRegisterUser', 'userWithPasswordInSchema', userWithPasswordInSchema)
            const localVarPath = `/api/auth/register/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userWithPasswordInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send Magic Login Link
         * @param {EmailInputSchema} emailInputSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaAuthSendMagicLoginLink: async (emailInputSchema: EmailInputSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailInputSchema' is not null or undefined
            assertParamExists('usersViewsNinjaAuthSendMagicLoginLink', 'emailInputSchema', emailInputSchema)
            const localVarPath = `/api/auth/send-magic-login-link/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailInputSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send Verification Email
         * @param {EmailInputSchema} emailInputSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaAuthSendVerificationEmail: async (emailInputSchema: EmailInputSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailInputSchema' is not null or undefined
            assertParamExists('usersViewsNinjaAuthSendVerificationEmail', 'emailInputSchema', emailInputSchema)
            const localVarPath = `/api/auth/verification-email/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailInputSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate Token
         * @param {TokenValidateInSchema} tokenValidateInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaAuthValidateToken: async (tokenValidateInSchema: TokenValidateInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenValidateInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaAuthValidateToken', 'tokenValidateInSchema', tokenValidateInSchema)
            const localVarPath = `/api/auth/token/validate/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenValidateInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Email Login
         * @param {LoginInputSchema} loginInputSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaAuthEmailLogin(loginInputSchema: LoginInputSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaAuthEmailLogin(loginInputSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.usersViewsNinjaAuthEmailLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Magic Link Login
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaAuthMagicLinkLogin(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaAuthMagicLinkLogin(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.usersViewsNinjaAuthMagicLinkLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Password Change
         * @param {PasswordChangeInSchema} passwordChangeInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaAuthPasswordChange(passwordChangeInSchema: PasswordChangeInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaAuthPasswordChange(passwordChangeInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.usersViewsNinjaAuthPasswordChange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Password Reset Confirm
         * @param {PasswordResetConfirmInSchema} passwordResetConfirmInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaAuthPasswordResetConfirm(passwordResetConfirmInSchema: PasswordResetConfirmInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaAuthPasswordResetConfirm(passwordResetConfirmInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.usersViewsNinjaAuthPasswordResetConfirm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Password Reset Request
         * @param {EmailInputSchema} emailInputSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaAuthPasswordResetRequest(emailInputSchema: EmailInputSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaAuthPasswordResetRequest(emailInputSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.usersViewsNinjaAuthPasswordResetRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Register User
         * @param {UserWithPasswordInSchema} userWithPasswordInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaAuthRegisterUser(userWithPasswordInSchema: UserWithPasswordInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterUserOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaAuthRegisterUser(userWithPasswordInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.usersViewsNinjaAuthRegisterUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send Magic Login Link
         * @param {EmailInputSchema} emailInputSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaAuthSendMagicLoginLink(emailInputSchema: EmailInputSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaAuthSendMagicLoginLink(emailInputSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.usersViewsNinjaAuthSendMagicLoginLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send Verification Email
         * @param {EmailInputSchema} emailInputSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaAuthSendVerificationEmail(emailInputSchema: EmailInputSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaAuthSendVerificationEmail(emailInputSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.usersViewsNinjaAuthSendVerificationEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Validate Token
         * @param {TokenValidateInSchema} tokenValidateInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaAuthValidateToken(tokenValidateInSchema: TokenValidateInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaAuthValidateToken(tokenValidateInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.usersViewsNinjaAuthValidateToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @summary Email Login
         * @param {AuthApiUsersViewsNinjaAuthEmailLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaAuthEmailLogin(requestParameters: AuthApiUsersViewsNinjaAuthEmailLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.usersViewsNinjaAuthEmailLogin(requestParameters.loginInputSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Magic Link Login
         * @param {AuthApiUsersViewsNinjaAuthMagicLinkLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaAuthMagicLinkLogin(requestParameters: AuthApiUsersViewsNinjaAuthMagicLinkLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.usersViewsNinjaAuthMagicLinkLogin(requestParameters.token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Password Change
         * @param {AuthApiUsersViewsNinjaAuthPasswordChangeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaAuthPasswordChange(requestParameters: AuthApiUsersViewsNinjaAuthPasswordChangeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaAuthPasswordChange(requestParameters.passwordChangeInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Password Reset Confirm
         * @param {AuthApiUsersViewsNinjaAuthPasswordResetConfirmRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaAuthPasswordResetConfirm(requestParameters: AuthApiUsersViewsNinjaAuthPasswordResetConfirmRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaAuthPasswordResetConfirm(requestParameters.passwordResetConfirmInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Password Reset Request
         * @param {AuthApiUsersViewsNinjaAuthPasswordResetRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaAuthPasswordResetRequest(requestParameters: AuthApiUsersViewsNinjaAuthPasswordResetRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaAuthPasswordResetRequest(requestParameters.emailInputSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register User
         * @param {AuthApiUsersViewsNinjaAuthRegisterUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaAuthRegisterUser(requestParameters: AuthApiUsersViewsNinjaAuthRegisterUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<RegisterUserOutSchema> {
            return localVarFp.usersViewsNinjaAuthRegisterUser(requestParameters.userWithPasswordInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send Magic Login Link
         * @param {AuthApiUsersViewsNinjaAuthSendMagicLoginLinkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaAuthSendMagicLoginLink(requestParameters: AuthApiUsersViewsNinjaAuthSendMagicLoginLinkRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaAuthSendMagicLoginLink(requestParameters.emailInputSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send Verification Email
         * @param {AuthApiUsersViewsNinjaAuthSendVerificationEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaAuthSendVerificationEmail(requestParameters: AuthApiUsersViewsNinjaAuthSendVerificationEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaAuthSendVerificationEmail(requestParameters.emailInputSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate Token
         * @param {AuthApiUsersViewsNinjaAuthValidateTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaAuthValidateToken(requestParameters: AuthApiUsersViewsNinjaAuthValidateTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaAuthValidateToken(requestParameters.tokenValidateInSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for usersViewsNinjaAuthEmailLogin operation in AuthApi.
 * @export
 * @interface AuthApiUsersViewsNinjaAuthEmailLoginRequest
 */
export interface AuthApiUsersViewsNinjaAuthEmailLoginRequest {
    /**
     * 
     * @type {LoginInputSchema}
     * @memberof AuthApiUsersViewsNinjaAuthEmailLogin
     */
    readonly loginInputSchema: LoginInputSchema
}

/**
 * Request parameters for usersViewsNinjaAuthMagicLinkLogin operation in AuthApi.
 * @export
 * @interface AuthApiUsersViewsNinjaAuthMagicLinkLoginRequest
 */
export interface AuthApiUsersViewsNinjaAuthMagicLinkLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthApiUsersViewsNinjaAuthMagicLinkLogin
     */
    readonly token: string
}

/**
 * Request parameters for usersViewsNinjaAuthPasswordChange operation in AuthApi.
 * @export
 * @interface AuthApiUsersViewsNinjaAuthPasswordChangeRequest
 */
export interface AuthApiUsersViewsNinjaAuthPasswordChangeRequest {
    /**
     * 
     * @type {PasswordChangeInSchema}
     * @memberof AuthApiUsersViewsNinjaAuthPasswordChange
     */
    readonly passwordChangeInSchema: PasswordChangeInSchema
}

/**
 * Request parameters for usersViewsNinjaAuthPasswordResetConfirm operation in AuthApi.
 * @export
 * @interface AuthApiUsersViewsNinjaAuthPasswordResetConfirmRequest
 */
export interface AuthApiUsersViewsNinjaAuthPasswordResetConfirmRequest {
    /**
     * 
     * @type {PasswordResetConfirmInSchema}
     * @memberof AuthApiUsersViewsNinjaAuthPasswordResetConfirm
     */
    readonly passwordResetConfirmInSchema: PasswordResetConfirmInSchema
}

/**
 * Request parameters for usersViewsNinjaAuthPasswordResetRequest operation in AuthApi.
 * @export
 * @interface AuthApiUsersViewsNinjaAuthPasswordResetRequestRequest
 */
export interface AuthApiUsersViewsNinjaAuthPasswordResetRequestRequest {
    /**
     * 
     * @type {EmailInputSchema}
     * @memberof AuthApiUsersViewsNinjaAuthPasswordResetRequest
     */
    readonly emailInputSchema: EmailInputSchema
}

/**
 * Request parameters for usersViewsNinjaAuthRegisterUser operation in AuthApi.
 * @export
 * @interface AuthApiUsersViewsNinjaAuthRegisterUserRequest
 */
export interface AuthApiUsersViewsNinjaAuthRegisterUserRequest {
    /**
     * 
     * @type {UserWithPasswordInSchema}
     * @memberof AuthApiUsersViewsNinjaAuthRegisterUser
     */
    readonly userWithPasswordInSchema: UserWithPasswordInSchema
}

/**
 * Request parameters for usersViewsNinjaAuthSendMagicLoginLink operation in AuthApi.
 * @export
 * @interface AuthApiUsersViewsNinjaAuthSendMagicLoginLinkRequest
 */
export interface AuthApiUsersViewsNinjaAuthSendMagicLoginLinkRequest {
    /**
     * 
     * @type {EmailInputSchema}
     * @memberof AuthApiUsersViewsNinjaAuthSendMagicLoginLink
     */
    readonly emailInputSchema: EmailInputSchema
}

/**
 * Request parameters for usersViewsNinjaAuthSendVerificationEmail operation in AuthApi.
 * @export
 * @interface AuthApiUsersViewsNinjaAuthSendVerificationEmailRequest
 */
export interface AuthApiUsersViewsNinjaAuthSendVerificationEmailRequest {
    /**
     * 
     * @type {EmailInputSchema}
     * @memberof AuthApiUsersViewsNinjaAuthSendVerificationEmail
     */
    readonly emailInputSchema: EmailInputSchema
}

/**
 * Request parameters for usersViewsNinjaAuthValidateToken operation in AuthApi.
 * @export
 * @interface AuthApiUsersViewsNinjaAuthValidateTokenRequest
 */
export interface AuthApiUsersViewsNinjaAuthValidateTokenRequest {
    /**
     * 
     * @type {TokenValidateInSchema}
     * @memberof AuthApiUsersViewsNinjaAuthValidateToken
     */
    readonly tokenValidateInSchema: TokenValidateInSchema
}

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @summary Email Login
     * @param {AuthApiUsersViewsNinjaAuthEmailLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public usersViewsNinjaAuthEmailLogin(requestParameters: AuthApiUsersViewsNinjaAuthEmailLoginRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).usersViewsNinjaAuthEmailLogin(requestParameters.loginInputSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Magic Link Login
     * @param {AuthApiUsersViewsNinjaAuthMagicLinkLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public usersViewsNinjaAuthMagicLinkLogin(requestParameters: AuthApiUsersViewsNinjaAuthMagicLinkLoginRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).usersViewsNinjaAuthMagicLinkLogin(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Password Change
     * @param {AuthApiUsersViewsNinjaAuthPasswordChangeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public usersViewsNinjaAuthPasswordChange(requestParameters: AuthApiUsersViewsNinjaAuthPasswordChangeRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).usersViewsNinjaAuthPasswordChange(requestParameters.passwordChangeInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Password Reset Confirm
     * @param {AuthApiUsersViewsNinjaAuthPasswordResetConfirmRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public usersViewsNinjaAuthPasswordResetConfirm(requestParameters: AuthApiUsersViewsNinjaAuthPasswordResetConfirmRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).usersViewsNinjaAuthPasswordResetConfirm(requestParameters.passwordResetConfirmInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Password Reset Request
     * @param {AuthApiUsersViewsNinjaAuthPasswordResetRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public usersViewsNinjaAuthPasswordResetRequest(requestParameters: AuthApiUsersViewsNinjaAuthPasswordResetRequestRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).usersViewsNinjaAuthPasswordResetRequest(requestParameters.emailInputSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register User
     * @param {AuthApiUsersViewsNinjaAuthRegisterUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public usersViewsNinjaAuthRegisterUser(requestParameters: AuthApiUsersViewsNinjaAuthRegisterUserRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).usersViewsNinjaAuthRegisterUser(requestParameters.userWithPasswordInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send Magic Login Link
     * @param {AuthApiUsersViewsNinjaAuthSendMagicLoginLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public usersViewsNinjaAuthSendMagicLoginLink(requestParameters: AuthApiUsersViewsNinjaAuthSendMagicLoginLinkRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).usersViewsNinjaAuthSendMagicLoginLink(requestParameters.emailInputSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send Verification Email
     * @param {AuthApiUsersViewsNinjaAuthSendVerificationEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public usersViewsNinjaAuthSendVerificationEmail(requestParameters: AuthApiUsersViewsNinjaAuthSendVerificationEmailRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).usersViewsNinjaAuthSendVerificationEmail(requestParameters.emailInputSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate Token
     * @param {AuthApiUsersViewsNinjaAuthValidateTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public usersViewsNinjaAuthValidateToken(requestParameters: AuthApiUsersViewsNinjaAuthValidateTokenRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).usersViewsNinjaAuthValidateToken(requestParameters.tokenValidateInSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AvailableCountryApi - axios parameter creator
 * @export
 */
export const AvailableCountryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Available Countries
         * @param {string | null} [country] 
         * @param {string | null} [requirements] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaAvailableCountryGetAvailableCountries: async (country?: string | null, requirements?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/available_country/countries/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (requirements !== undefined) {
                localVarQueryParameter['requirements'] = requirements;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AvailableCountryApi - functional programming interface
 * @export
 */
export const AvailableCountryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AvailableCountryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Available Countries
         * @param {string | null} [country] 
         * @param {string | null} [requirements] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaAvailableCountryGetAvailableCountries(country?: string | null, requirements?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedAvailableCountryOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaAvailableCountryGetAvailableCountries(country, requirements, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvailableCountryApi.telephonyViewsNinjaAvailableCountryGetAvailableCountries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AvailableCountryApi - factory interface
 * @export
 */
export const AvailableCountryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AvailableCountryApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Available Countries
         * @param {AvailableCountryApiTelephonyViewsNinjaAvailableCountryGetAvailableCountriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaAvailableCountryGetAvailableCountries(requestParameters: AvailableCountryApiTelephonyViewsNinjaAvailableCountryGetAvailableCountriesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PagedAvailableCountryOutSchema> {
            return localVarFp.telephonyViewsNinjaAvailableCountryGetAvailableCountries(requestParameters.country, requestParameters.requirements, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for telephonyViewsNinjaAvailableCountryGetAvailableCountries operation in AvailableCountryApi.
 * @export
 * @interface AvailableCountryApiTelephonyViewsNinjaAvailableCountryGetAvailableCountriesRequest
 */
export interface AvailableCountryApiTelephonyViewsNinjaAvailableCountryGetAvailableCountriesRequest {
    /**
     * 
     * @type {string}
     * @memberof AvailableCountryApiTelephonyViewsNinjaAvailableCountryGetAvailableCountries
     */
    readonly country?: string | null

    /**
     * 
     * @type {string}
     * @memberof AvailableCountryApiTelephonyViewsNinjaAvailableCountryGetAvailableCountries
     */
    readonly requirements?: string | null

    /**
     * 
     * @type {number}
     * @memberof AvailableCountryApiTelephonyViewsNinjaAvailableCountryGetAvailableCountries
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof AvailableCountryApiTelephonyViewsNinjaAvailableCountryGetAvailableCountries
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof AvailableCountryApiTelephonyViewsNinjaAvailableCountryGetAvailableCountries
     */
    readonly ordering?: string | null
}

/**
 * AvailableCountryApi - object-oriented interface
 * @export
 * @class AvailableCountryApi
 * @extends {BaseAPI}
 */
export class AvailableCountryApi extends BaseAPI {
    /**
     * 
     * @summary Get Available Countries
     * @param {AvailableCountryApiTelephonyViewsNinjaAvailableCountryGetAvailableCountriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailableCountryApi
     */
    public telephonyViewsNinjaAvailableCountryGetAvailableCountries(requestParameters: AvailableCountryApiTelephonyViewsNinjaAvailableCountryGetAvailableCountriesRequest = {}, options?: RawAxiosRequestConfig) {
        return AvailableCountryApiFp(this.configuration).telephonyViewsNinjaAvailableCountryGetAvailableCountries(requestParameters.country, requestParameters.requirements, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AvailableNumberApi - axios parameter creator
 * @export
 */
export const AvailableNumberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List Available Numbers
         * @param {TelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersCountryCodeEnum} [countryCode] 
         * @param {TelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersNumberTypeEnum} [numberType] 
         * @param {boolean | null} [isSpecialNumber] 
         * @param {boolean | null} [isTollFree] 
         * @param {string | null} [state] 
         * @param {string | null} [provider] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberAvailableNumberListAvailableNumbers: async (countryCode?: TelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersCountryCodeEnum, numberType?: TelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersNumberTypeEnum, isSpecialNumber?: boolean | null, isTollFree?: boolean | null, state?: string | null, provider?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/available_number/numbers/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (countryCode !== undefined) {
                localVarQueryParameter['country_code'] = countryCode;
            }

            if (numberType !== undefined) {
                localVarQueryParameter['number_type'] = numberType;
            }

            if (isSpecialNumber !== undefined) {
                localVarQueryParameter['is_special_number'] = isSpecialNumber;
            }

            if (isTollFree !== undefined) {
                localVarQueryParameter['is_toll_free'] = isTollFree;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AvailableNumberApi - functional programming interface
 * @export
 */
export const AvailableNumberApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AvailableNumberApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List Available Numbers
         * @param {TelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersCountryCodeEnum} [countryCode] 
         * @param {TelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersNumberTypeEnum} [numberType] 
         * @param {boolean | null} [isSpecialNumber] 
         * @param {boolean | null} [isTollFree] 
         * @param {string | null} [state] 
         * @param {string | null} [provider] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaNumberAvailableNumberListAvailableNumbers(countryCode?: TelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersCountryCodeEnum, numberType?: TelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersNumberTypeEnum, isSpecialNumber?: boolean | null, isTollFree?: boolean | null, state?: string | null, provider?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedAvailableNumberOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaNumberAvailableNumberListAvailableNumbers(countryCode, numberType, isSpecialNumber, isTollFree, state, provider, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AvailableNumberApi.telephonyViewsNinjaNumberAvailableNumberListAvailableNumbers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AvailableNumberApi - factory interface
 * @export
 */
export const AvailableNumberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AvailableNumberApiFp(configuration)
    return {
        /**
         * 
         * @summary List Available Numbers
         * @param {AvailableNumberApiTelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberAvailableNumberListAvailableNumbers(requestParameters: AvailableNumberApiTelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PagedAvailableNumberOutSchema> {
            return localVarFp.telephonyViewsNinjaNumberAvailableNumberListAvailableNumbers(requestParameters.countryCode, requestParameters.numberType, requestParameters.isSpecialNumber, requestParameters.isTollFree, requestParameters.state, requestParameters.provider, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for telephonyViewsNinjaNumberAvailableNumberListAvailableNumbers operation in AvailableNumberApi.
 * @export
 * @interface AvailableNumberApiTelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersRequest
 */
export interface AvailableNumberApiTelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersRequest {
    /**
     * 
     * @type {string}
     * @memberof AvailableNumberApiTelephonyViewsNinjaNumberAvailableNumberListAvailableNumbers
     */
    readonly countryCode?: TelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersCountryCodeEnum

    /**
     * 
     * @type {'mobile' | 'landline'}
     * @memberof AvailableNumberApiTelephonyViewsNinjaNumberAvailableNumberListAvailableNumbers
     */
    readonly numberType?: TelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersNumberTypeEnum

    /**
     * 
     * @type {boolean}
     * @memberof AvailableNumberApiTelephonyViewsNinjaNumberAvailableNumberListAvailableNumbers
     */
    readonly isSpecialNumber?: boolean | null

    /**
     * 
     * @type {boolean}
     * @memberof AvailableNumberApiTelephonyViewsNinjaNumberAvailableNumberListAvailableNumbers
     */
    readonly isTollFree?: boolean | null

    /**
     * 
     * @type {string}
     * @memberof AvailableNumberApiTelephonyViewsNinjaNumberAvailableNumberListAvailableNumbers
     */
    readonly state?: string | null

    /**
     * 
     * @type {string}
     * @memberof AvailableNumberApiTelephonyViewsNinjaNumberAvailableNumberListAvailableNumbers
     */
    readonly provider?: string | null

    /**
     * 
     * @type {number}
     * @memberof AvailableNumberApiTelephonyViewsNinjaNumberAvailableNumberListAvailableNumbers
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof AvailableNumberApiTelephonyViewsNinjaNumberAvailableNumberListAvailableNumbers
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof AvailableNumberApiTelephonyViewsNinjaNumberAvailableNumberListAvailableNumbers
     */
    readonly ordering?: string | null
}

/**
 * AvailableNumberApi - object-oriented interface
 * @export
 * @class AvailableNumberApi
 * @extends {BaseAPI}
 */
export class AvailableNumberApi extends BaseAPI {
    /**
     * 
     * @summary List Available Numbers
     * @param {AvailableNumberApiTelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailableNumberApi
     */
    public telephonyViewsNinjaNumberAvailableNumberListAvailableNumbers(requestParameters: AvailableNumberApiTelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersRequest = {}, options?: RawAxiosRequestConfig) {
        return AvailableNumberApiFp(this.configuration).telephonyViewsNinjaNumberAvailableNumberListAvailableNumbers(requestParameters.countryCode, requestParameters.numberType, requestParameters.isSpecialNumber, requestParameters.isTollFree, requestParameters.state, requestParameters.provider, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const TelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersCountryCodeEnum = {
    Ng: 'NG',
    Gb: 'GB',
    Us: 'US',
    Ca: 'CA',
    Ke: 'KE',
    Gh: 'GH',
    Pr: 'PR',
    Za: 'ZA',
    Cn: 'CN',
    Jp: 'JP',
    Th: 'TH',
    Cz: 'CZ',
    Fi: 'FI',
    Nl: 'NL',
    Pl: 'PL',
    Br: 'BR',
    Au: 'AU',
    Be: 'BE',
    Se: 'SE',
    Ie: 'IE',
    Mx: 'MX'
} as const;
export type TelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersCountryCodeEnum = typeof TelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersCountryCodeEnum[keyof typeof TelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersCountryCodeEnum];
/**
 * @export
 */
export const TelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersNumberTypeEnum = {
    Mobile: 'mobile',
    Landline: 'landline'
} as const;
export type TelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersNumberTypeEnum = typeof TelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersNumberTypeEnum[keyof typeof TelephonyViewsNinjaNumberAvailableNumberListAvailableNumbersNumberTypeEnum];


/**
 * BlogApi - axios parameter creator
 * @export
 */
export const BlogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Blog
         * @param {BlogInSchema} blogInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsBlogCreateBlog: async (blogInSchema: BlogInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blogInSchema' is not null or undefined
            assertParamExists('messagingViewsBlogCreateBlog', 'blogInSchema', blogInSchema)
            const localVarPath = `/api/blog/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(blogInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Blogs
         * @param {string | null} [title] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsBlogGetBlogs: async (title?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/blog/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BlogApi - functional programming interface
 * @export
 */
export const BlogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BlogApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Blog
         * @param {BlogInSchema} blogInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingViewsBlogCreateBlog(blogInSchema: BlogInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlogOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingViewsBlogCreateBlog(blogInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BlogApi.messagingViewsBlogCreateBlog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Blogs
         * @param {string | null} [title] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingViewsBlogGetBlogs(title?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedBlogOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingViewsBlogGetBlogs(title, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BlogApi.messagingViewsBlogGetBlogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BlogApi - factory interface
 * @export
 */
export const BlogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BlogApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Blog
         * @param {BlogApiMessagingViewsBlogCreateBlogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsBlogCreateBlog(requestParameters: BlogApiMessagingViewsBlogCreateBlogRequest, options?: RawAxiosRequestConfig): AxiosPromise<BlogOutSchema> {
            return localVarFp.messagingViewsBlogCreateBlog(requestParameters.blogInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Blogs
         * @param {BlogApiMessagingViewsBlogGetBlogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsBlogGetBlogs(requestParameters: BlogApiMessagingViewsBlogGetBlogsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PagedBlogOutSchema> {
            return localVarFp.messagingViewsBlogGetBlogs(requestParameters.title, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for messagingViewsBlogCreateBlog operation in BlogApi.
 * @export
 * @interface BlogApiMessagingViewsBlogCreateBlogRequest
 */
export interface BlogApiMessagingViewsBlogCreateBlogRequest {
    /**
     * 
     * @type {BlogInSchema}
     * @memberof BlogApiMessagingViewsBlogCreateBlog
     */
    readonly blogInSchema: BlogInSchema
}

/**
 * Request parameters for messagingViewsBlogGetBlogs operation in BlogApi.
 * @export
 * @interface BlogApiMessagingViewsBlogGetBlogsRequest
 */
export interface BlogApiMessagingViewsBlogGetBlogsRequest {
    /**
     * 
     * @type {string}
     * @memberof BlogApiMessagingViewsBlogGetBlogs
     */
    readonly title?: string | null

    /**
     * 
     * @type {number}
     * @memberof BlogApiMessagingViewsBlogGetBlogs
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof BlogApiMessagingViewsBlogGetBlogs
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof BlogApiMessagingViewsBlogGetBlogs
     */
    readonly ordering?: string | null
}

/**
 * BlogApi - object-oriented interface
 * @export
 * @class BlogApi
 * @extends {BaseAPI}
 */
export class BlogApi extends BaseAPI {
    /**
     * 
     * @summary Create Blog
     * @param {BlogApiMessagingViewsBlogCreateBlogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlogApi
     */
    public messagingViewsBlogCreateBlog(requestParameters: BlogApiMessagingViewsBlogCreateBlogRequest, options?: RawAxiosRequestConfig) {
        return BlogApiFp(this.configuration).messagingViewsBlogCreateBlog(requestParameters.blogInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Blogs
     * @param {BlogApiMessagingViewsBlogGetBlogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlogApi
     */
    public messagingViewsBlogGetBlogs(requestParameters: BlogApiMessagingViewsBlogGetBlogsRequest = {}, options?: RawAxiosRequestConfig) {
        return BlogApiFp(this.configuration).messagingViewsBlogGetBlogs(requestParameters.title, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BusinessApi - axios parameter creator
 * @export
 */
export const BusinessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Fill Engagement Form
         * @param {number} businessId 
         * @param {PostOnboardingFormInSchema} postOnboardingFormInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaBusinessFillEngagementForm: async (businessId: number, postOnboardingFormInSchema: PostOnboardingFormInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaBusinessFillEngagementForm', 'businessId', businessId)
            // verify required parameter 'postOnboardingFormInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaBusinessFillEngagementForm', 'postOnboardingFormInSchema', postOnboardingFormInSchema)
            const localVarPath = `/api/business/{business_id}/engagement-form/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postOnboardingFormInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Business
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaBusinessGetBusiness: async (businessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaBusinessGetBusiness', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Business Balance
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaBusinessGetBusinessBalance: async (businessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaBusinessGetBusinessBalance', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/balance/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Channel Token
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaBusinessGetChannelToken: async (businessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaBusinessGetChannelToken', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/token/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit Survey
         * @param {number} businessId 
         * @param {SurveyInSchema} surveyInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaBusinessSubmitSurvey: async (businessId: number, surveyInSchema: SurveyInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaBusinessSubmitSurvey', 'businessId', businessId)
            // verify required parameter 'surveyInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaBusinessSubmitSurvey', 'surveyInSchema', surveyInSchema)
            const localVarPath = `/api/business/{business_id}/survey/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Survey Snooze
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaBusinessSurveySnooze: async (businessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaBusinessSurveySnooze', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/survey/snooze/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Business
         * @param {number} businessId 
         * @param {BusinessUpdateSchema} businessUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaBusinessUpdateBusiness: async (businessId: number, businessUpdateSchema: BusinessUpdateSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaBusinessUpdateBusiness', 'businessId', businessId)
            // verify required parameter 'businessUpdateSchema' is not null or undefined
            assertParamExists('usersViewsNinjaBusinessUpdateBusiness', 'businessUpdateSchema', businessUpdateSchema)
            const localVarPath = `/api/business/{business_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(businessUpdateSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BusinessApi - functional programming interface
 * @export
 */
export const BusinessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BusinessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Fill Engagement Form
         * @param {number} businessId 
         * @param {PostOnboardingFormInSchema} postOnboardingFormInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaBusinessFillEngagementForm(businessId: number, postOnboardingFormInSchema: PostOnboardingFormInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PostOnboardingFormOutSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaBusinessFillEngagementForm(businessId, postOnboardingFormInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessApi.usersViewsNinjaBusinessFillEngagementForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Business
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaBusinessGetBusiness(businessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BusinessOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaBusinessGetBusiness(businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessApi.usersViewsNinjaBusinessGetBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Business Balance
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaBusinessGetBusinessBalance(businessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BusinessBalanceOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaBusinessGetBusinessBalance(businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessApi.usersViewsNinjaBusinessGetBusinessBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Channel Token
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaBusinessGetChannelToken(businessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChannelTokenOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaBusinessGetChannelToken(businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessApi.usersViewsNinjaBusinessGetChannelToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Submit Survey
         * @param {number} businessId 
         * @param {SurveyInSchema} surveyInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaBusinessSubmitSurvey(businessId: number, surveyInSchema: SurveyInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaBusinessSubmitSurvey(businessId, surveyInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessApi.usersViewsNinjaBusinessSubmitSurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Survey Snooze
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaBusinessSurveySnooze(businessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaBusinessSurveySnooze(businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessApi.usersViewsNinjaBusinessSurveySnooze']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Business
         * @param {number} businessId 
         * @param {BusinessUpdateSchema} businessUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaBusinessUpdateBusiness(businessId: number, businessUpdateSchema: BusinessUpdateSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BusinessOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaBusinessUpdateBusiness(businessId, businessUpdateSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BusinessApi.usersViewsNinjaBusinessUpdateBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BusinessApi - factory interface
 * @export
 */
export const BusinessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BusinessApiFp(configuration)
    return {
        /**
         * 
         * @summary Fill Engagement Form
         * @param {BusinessApiUsersViewsNinjaBusinessFillEngagementFormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaBusinessFillEngagementForm(requestParameters: BusinessApiUsersViewsNinjaBusinessFillEngagementFormRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PostOnboardingFormOutSchema>> {
            return localVarFp.usersViewsNinjaBusinessFillEngagementForm(requestParameters.businessId, requestParameters.postOnboardingFormInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Business
         * @param {BusinessApiUsersViewsNinjaBusinessGetBusinessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaBusinessGetBusiness(requestParameters: BusinessApiUsersViewsNinjaBusinessGetBusinessRequest, options?: RawAxiosRequestConfig): AxiosPromise<BusinessOutSchema> {
            return localVarFp.usersViewsNinjaBusinessGetBusiness(requestParameters.businessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Business Balance
         * @param {BusinessApiUsersViewsNinjaBusinessGetBusinessBalanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaBusinessGetBusinessBalance(requestParameters: BusinessApiUsersViewsNinjaBusinessGetBusinessBalanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<BusinessBalanceOutSchema> {
            return localVarFp.usersViewsNinjaBusinessGetBusinessBalance(requestParameters.businessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Channel Token
         * @param {BusinessApiUsersViewsNinjaBusinessGetChannelTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaBusinessGetChannelToken(requestParameters: BusinessApiUsersViewsNinjaBusinessGetChannelTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChannelTokenOutSchema> {
            return localVarFp.usersViewsNinjaBusinessGetChannelToken(requestParameters.businessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit Survey
         * @param {BusinessApiUsersViewsNinjaBusinessSubmitSurveyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaBusinessSubmitSurvey(requestParameters: BusinessApiUsersViewsNinjaBusinessSubmitSurveyRequest, options?: RawAxiosRequestConfig): AxiosPromise<SurveyOutSchema> {
            return localVarFp.usersViewsNinjaBusinessSubmitSurvey(requestParameters.businessId, requestParameters.surveyInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Survey Snooze
         * @param {BusinessApiUsersViewsNinjaBusinessSurveySnoozeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaBusinessSurveySnooze(requestParameters: BusinessApiUsersViewsNinjaBusinessSurveySnoozeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaBusinessSurveySnooze(requestParameters.businessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Business
         * @param {BusinessApiUsersViewsNinjaBusinessUpdateBusinessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaBusinessUpdateBusiness(requestParameters: BusinessApiUsersViewsNinjaBusinessUpdateBusinessRequest, options?: RawAxiosRequestConfig): AxiosPromise<BusinessOutSchema> {
            return localVarFp.usersViewsNinjaBusinessUpdateBusiness(requestParameters.businessId, requestParameters.businessUpdateSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for usersViewsNinjaBusinessFillEngagementForm operation in BusinessApi.
 * @export
 * @interface BusinessApiUsersViewsNinjaBusinessFillEngagementFormRequest
 */
export interface BusinessApiUsersViewsNinjaBusinessFillEngagementFormRequest {
    /**
     * 
     * @type {number}
     * @memberof BusinessApiUsersViewsNinjaBusinessFillEngagementForm
     */
    readonly businessId: number

    /**
     * 
     * @type {PostOnboardingFormInSchema}
     * @memberof BusinessApiUsersViewsNinjaBusinessFillEngagementForm
     */
    readonly postOnboardingFormInSchema: PostOnboardingFormInSchema
}

/**
 * Request parameters for usersViewsNinjaBusinessGetBusiness operation in BusinessApi.
 * @export
 * @interface BusinessApiUsersViewsNinjaBusinessGetBusinessRequest
 */
export interface BusinessApiUsersViewsNinjaBusinessGetBusinessRequest {
    /**
     * 
     * @type {number}
     * @memberof BusinessApiUsersViewsNinjaBusinessGetBusiness
     */
    readonly businessId: number
}

/**
 * Request parameters for usersViewsNinjaBusinessGetBusinessBalance operation in BusinessApi.
 * @export
 * @interface BusinessApiUsersViewsNinjaBusinessGetBusinessBalanceRequest
 */
export interface BusinessApiUsersViewsNinjaBusinessGetBusinessBalanceRequest {
    /**
     * 
     * @type {number}
     * @memberof BusinessApiUsersViewsNinjaBusinessGetBusinessBalance
     */
    readonly businessId: number
}

/**
 * Request parameters for usersViewsNinjaBusinessGetChannelToken operation in BusinessApi.
 * @export
 * @interface BusinessApiUsersViewsNinjaBusinessGetChannelTokenRequest
 */
export interface BusinessApiUsersViewsNinjaBusinessGetChannelTokenRequest {
    /**
     * 
     * @type {number}
     * @memberof BusinessApiUsersViewsNinjaBusinessGetChannelToken
     */
    readonly businessId: number
}

/**
 * Request parameters for usersViewsNinjaBusinessSubmitSurvey operation in BusinessApi.
 * @export
 * @interface BusinessApiUsersViewsNinjaBusinessSubmitSurveyRequest
 */
export interface BusinessApiUsersViewsNinjaBusinessSubmitSurveyRequest {
    /**
     * 
     * @type {number}
     * @memberof BusinessApiUsersViewsNinjaBusinessSubmitSurvey
     */
    readonly businessId: number

    /**
     * 
     * @type {SurveyInSchema}
     * @memberof BusinessApiUsersViewsNinjaBusinessSubmitSurvey
     */
    readonly surveyInSchema: SurveyInSchema
}

/**
 * Request parameters for usersViewsNinjaBusinessSurveySnooze operation in BusinessApi.
 * @export
 * @interface BusinessApiUsersViewsNinjaBusinessSurveySnoozeRequest
 */
export interface BusinessApiUsersViewsNinjaBusinessSurveySnoozeRequest {
    /**
     * 
     * @type {number}
     * @memberof BusinessApiUsersViewsNinjaBusinessSurveySnooze
     */
    readonly businessId: number
}

/**
 * Request parameters for usersViewsNinjaBusinessUpdateBusiness operation in BusinessApi.
 * @export
 * @interface BusinessApiUsersViewsNinjaBusinessUpdateBusinessRequest
 */
export interface BusinessApiUsersViewsNinjaBusinessUpdateBusinessRequest {
    /**
     * 
     * @type {number}
     * @memberof BusinessApiUsersViewsNinjaBusinessUpdateBusiness
     */
    readonly businessId: number

    /**
     * 
     * @type {BusinessUpdateSchema}
     * @memberof BusinessApiUsersViewsNinjaBusinessUpdateBusiness
     */
    readonly businessUpdateSchema: BusinessUpdateSchema
}

/**
 * BusinessApi - object-oriented interface
 * @export
 * @class BusinessApi
 * @extends {BaseAPI}
 */
export class BusinessApi extends BaseAPI {
    /**
     * 
     * @summary Fill Engagement Form
     * @param {BusinessApiUsersViewsNinjaBusinessFillEngagementFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessApi
     */
    public usersViewsNinjaBusinessFillEngagementForm(requestParameters: BusinessApiUsersViewsNinjaBusinessFillEngagementFormRequest, options?: RawAxiosRequestConfig) {
        return BusinessApiFp(this.configuration).usersViewsNinjaBusinessFillEngagementForm(requestParameters.businessId, requestParameters.postOnboardingFormInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Business
     * @param {BusinessApiUsersViewsNinjaBusinessGetBusinessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessApi
     */
    public usersViewsNinjaBusinessGetBusiness(requestParameters: BusinessApiUsersViewsNinjaBusinessGetBusinessRequest, options?: RawAxiosRequestConfig) {
        return BusinessApiFp(this.configuration).usersViewsNinjaBusinessGetBusiness(requestParameters.businessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Business Balance
     * @param {BusinessApiUsersViewsNinjaBusinessGetBusinessBalanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessApi
     */
    public usersViewsNinjaBusinessGetBusinessBalance(requestParameters: BusinessApiUsersViewsNinjaBusinessGetBusinessBalanceRequest, options?: RawAxiosRequestConfig) {
        return BusinessApiFp(this.configuration).usersViewsNinjaBusinessGetBusinessBalance(requestParameters.businessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Channel Token
     * @param {BusinessApiUsersViewsNinjaBusinessGetChannelTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessApi
     */
    public usersViewsNinjaBusinessGetChannelToken(requestParameters: BusinessApiUsersViewsNinjaBusinessGetChannelTokenRequest, options?: RawAxiosRequestConfig) {
        return BusinessApiFp(this.configuration).usersViewsNinjaBusinessGetChannelToken(requestParameters.businessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit Survey
     * @param {BusinessApiUsersViewsNinjaBusinessSubmitSurveyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessApi
     */
    public usersViewsNinjaBusinessSubmitSurvey(requestParameters: BusinessApiUsersViewsNinjaBusinessSubmitSurveyRequest, options?: RawAxiosRequestConfig) {
        return BusinessApiFp(this.configuration).usersViewsNinjaBusinessSubmitSurvey(requestParameters.businessId, requestParameters.surveyInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Survey Snooze
     * @param {BusinessApiUsersViewsNinjaBusinessSurveySnoozeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessApi
     */
    public usersViewsNinjaBusinessSurveySnooze(requestParameters: BusinessApiUsersViewsNinjaBusinessSurveySnoozeRequest, options?: RawAxiosRequestConfig) {
        return BusinessApiFp(this.configuration).usersViewsNinjaBusinessSurveySnooze(requestParameters.businessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Business
     * @param {BusinessApiUsersViewsNinjaBusinessUpdateBusinessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessApi
     */
    public usersViewsNinjaBusinessUpdateBusiness(requestParameters: BusinessApiUsersViewsNinjaBusinessUpdateBusinessRequest, options?: RawAxiosRequestConfig) {
        return BusinessApiFp(this.configuration).usersViewsNinjaBusinessUpdateBusiness(requestParameters.businessId, requestParameters.businessUpdateSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CallLogsApi - axios parameter creator
 * @export
 */
export const CallLogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Export Business Call Logs
         * @param {number} businessId 
         * @param {string | null} [startTimeRange] 
         * @param {string | null} [dateCreatedRange] 
         * @param {string | null} [phoneNumber] 
         * @param {boolean | null} [withNote] 
         * @param {boolean | null} [isAnswered] 
         * @param {number | null} [userId] 
         * @param {CallType | null} [kind] 
         * @param {string | null} [callId] 
         * @param {string | null} [durationRange] Filter by duration range, format: \&#39;min,max\&#39; (in seconds)
         * @param {number | null} [businessNumberId] 
         * @param {string | null} [callerId] 
         * @param {ExportFormat | null} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogs: async (businessId: number, startTimeRange?: string | null, dateCreatedRange?: string | null, phoneNumber?: string | null, withNote?: boolean | null, isAnswered?: boolean | null, userId?: number | null, kind?: CallType | null, callId?: string | null, durationRange?: string | null, businessNumberId?: number | null, callerId?: string | null, format?: ExportFormat | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogs', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/call-log/export/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTimeRange !== undefined) {
                localVarQueryParameter['start_time_range'] = startTimeRange;
            }

            if (dateCreatedRange !== undefined) {
                localVarQueryParameter['date_created_range'] = dateCreatedRange;
            }

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phone_number'] = phoneNumber;
            }

            if (withNote !== undefined) {
                localVarQueryParameter['with_note'] = withNote;
            }

            if (isAnswered !== undefined) {
                localVarQueryParameter['is_answered'] = isAnswered;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (callId !== undefined) {
                localVarQueryParameter['call_id'] = callId;
            }

            if (durationRange !== undefined) {
                localVarQueryParameter['duration_range'] = durationRange;
            }

            if (businessNumberId !== undefined) {
                localVarQueryParameter['business_number_id'] = businessNumberId;
            }

            if (callerId !== undefined) {
                localVarQueryParameter['caller_id'] = callerId;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Business Call Logs Via Email
         * @param {number} businessId 
         * @param {string} recipients 
         * @param {string | null} [startTimeRange] 
         * @param {string | null} [dateCreatedRange] 
         * @param {string | null} [phoneNumber] 
         * @param {boolean | null} [withNote] 
         * @param {boolean | null} [isAnswered] 
         * @param {number | null} [userId] 
         * @param {CallType | null} [kind] 
         * @param {string | null} [callId] 
         * @param {string | null} [durationRange] Filter by duration range, format: \&#39;min,max\&#39; (in seconds)
         * @param {number | null} [businessNumberId] 
         * @param {string | null} [callerId] 
         * @param {ExportFormat | null} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail: async (businessId: number, recipients: string, startTimeRange?: string | null, dateCreatedRange?: string | null, phoneNumber?: string | null, withNote?: boolean | null, isAnswered?: boolean | null, userId?: number | null, kind?: CallType | null, callId?: string | null, durationRange?: string | null, businessNumberId?: number | null, callerId?: string | null, format?: ExportFormat | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail', 'businessId', businessId)
            // verify required parameter 'recipients' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail', 'recipients', recipients)
            const localVarPath = `/api/business/{business_id}/call-log/email/export/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTimeRange !== undefined) {
                localVarQueryParameter['start_time_range'] = startTimeRange;
            }

            if (dateCreatedRange !== undefined) {
                localVarQueryParameter['date_created_range'] = dateCreatedRange;
            }

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phone_number'] = phoneNumber;
            }

            if (withNote !== undefined) {
                localVarQueryParameter['with_note'] = withNote;
            }

            if (isAnswered !== undefined) {
                localVarQueryParameter['is_answered'] = isAnswered;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (callId !== undefined) {
                localVarQueryParameter['call_id'] = callId;
            }

            if (durationRange !== undefined) {
                localVarQueryParameter['duration_range'] = durationRange;
            }

            if (businessNumberId !== undefined) {
                localVarQueryParameter['business_number_id'] = businessNumberId;
            }

            if (callerId !== undefined) {
                localVarQueryParameter['caller_id'] = callerId;
            }

            if (recipients !== undefined) {
                localVarQueryParameter['recipients'] = recipients;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Business Call Log Detail
         * @param {number} businessId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogDetail: async (businessId: number, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogDetail', 'businessId', businessId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogDetail', 'id', id)
            const localVarPath = `/api/business/{business_id}/call-log/{id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Business Call Logs
         * @param {number} businessId 
         * @param {string | null} [startTimeRange] 
         * @param {string | null} [dateCreatedRange] 
         * @param {string | null} [phoneNumber] 
         * @param {boolean | null} [withNote] 
         * @param {boolean | null} [isAnswered] 
         * @param {number | null} [userId] 
         * @param {CallType | null} [kind] 
         * @param {string | null} [callId] 
         * @param {string | null} [durationRange] Filter by duration range, format: \&#39;min,max\&#39; (in seconds)
         * @param {number | null} [businessNumberId] 
         * @param {string | null} [callerId] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs: async (businessId: number, startTimeRange?: string | null, dateCreatedRange?: string | null, phoneNumber?: string | null, withNote?: boolean | null, isAnswered?: boolean | null, userId?: number | null, kind?: CallType | null, callId?: string | null, durationRange?: string | null, businessNumberId?: number | null, callerId?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/call-log/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTimeRange !== undefined) {
                localVarQueryParameter['start_time_range'] = startTimeRange;
            }

            if (dateCreatedRange !== undefined) {
                localVarQueryParameter['date_created_range'] = dateCreatedRange;
            }

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phone_number'] = phoneNumber;
            }

            if (withNote !== undefined) {
                localVarQueryParameter['with_note'] = withNote;
            }

            if (isAnswered !== undefined) {
                localVarQueryParameter['is_answered'] = isAnswered;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (callId !== undefined) {
                localVarQueryParameter['call_id'] = callId;
            }

            if (durationRange !== undefined) {
                localVarQueryParameter['duration_range'] = durationRange;
            }

            if (businessNumberId !== undefined) {
                localVarQueryParameter['business_number_id'] = businessNumberId;
            }

            if (callerId !== undefined) {
                localVarQueryParameter['caller_id'] = callerId;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Call Logs
         * @param {number} numberId 
         * @param {string | null} [startTimeRange] 
         * @param {string | null} [dateCreatedRange] 
         * @param {string | null} [phoneNumber] 
         * @param {boolean | null} [withNote] 
         * @param {boolean | null} [isAnswered] 
         * @param {number | null} [userId] 
         * @param {CallType | null} [kind] 
         * @param {string | null} [callId] 
         * @param {string | null} [durationRange] Filter by duration range, format: \&#39;min,max\&#39; (in seconds)
         * @param {ExportFormat | null} [format] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallLogNumberExportCallLogs: async (numberId: number, startTimeRange?: string | null, dateCreatedRange?: string | null, phoneNumber?: string | null, withNote?: boolean | null, isAnswered?: boolean | null, userId?: number | null, kind?: CallType | null, callId?: string | null, durationRange?: string | null, format?: ExportFormat | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'numberId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallLogNumberExportCallLogs', 'numberId', numberId)
            const localVarPath = `/api/number/{number_id}/call-log/export-csv/`
                .replace(`{${"number_id"}}`, encodeURIComponent(String(numberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTimeRange !== undefined) {
                localVarQueryParameter['start_time_range'] = startTimeRange;
            }

            if (dateCreatedRange !== undefined) {
                localVarQueryParameter['date_created_range'] = dateCreatedRange;
            }

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phone_number'] = phoneNumber;
            }

            if (withNote !== undefined) {
                localVarQueryParameter['with_note'] = withNote;
            }

            if (isAnswered !== undefined) {
                localVarQueryParameter['is_answered'] = isAnswered;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (callId !== undefined) {
                localVarQueryParameter['call_id'] = callId;
            }

            if (durationRange !== undefined) {
                localVarQueryParameter['duration_range'] = durationRange;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Call Logs
         * @param {number} numberId 
         * @param {string | null} [startTimeRange] 
         * @param {string | null} [dateCreatedRange] 
         * @param {string | null} [phoneNumber] 
         * @param {boolean | null} [withNote] 
         * @param {boolean | null} [isAnswered] 
         * @param {number | null} [userId] 
         * @param {CallType | null} [kind] 
         * @param {string | null} [callId] 
         * @param {string | null} [durationRange] Filter by duration range, format: \&#39;min,max\&#39; (in seconds)
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallLogNumberGetCallLogs: async (numberId: number, startTimeRange?: string | null, dateCreatedRange?: string | null, phoneNumber?: string | null, withNote?: boolean | null, isAnswered?: boolean | null, userId?: number | null, kind?: CallType | null, callId?: string | null, durationRange?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'numberId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallLogNumberGetCallLogs', 'numberId', numberId)
            const localVarPath = `/api/number/{number_id}/call-log/`
                .replace(`{${"number_id"}}`, encodeURIComponent(String(numberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTimeRange !== undefined) {
                localVarQueryParameter['start_time_range'] = startTimeRange;
            }

            if (dateCreatedRange !== undefined) {
                localVarQueryParameter['date_created_range'] = dateCreatedRange;
            }

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phone_number'] = phoneNumber;
            }

            if (withNote !== undefined) {
                localVarQueryParameter['with_note'] = withNote;
            }

            if (isAnswered !== undefined) {
                localVarQueryParameter['is_answered'] = isAnswered;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (callId !== undefined) {
                localVarQueryParameter['call_id'] = callId;
            }

            if (durationRange !== undefined) {
                localVarQueryParameter['duration_range'] = durationRange;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallLogsApi - functional programming interface
 * @export
 */
export const CallLogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CallLogsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Export Business Call Logs
         * @param {number} businessId 
         * @param {string | null} [startTimeRange] 
         * @param {string | null} [dateCreatedRange] 
         * @param {string | null} [phoneNumber] 
         * @param {boolean | null} [withNote] 
         * @param {boolean | null} [isAnswered] 
         * @param {number | null} [userId] 
         * @param {CallType | null} [kind] 
         * @param {string | null} [callId] 
         * @param {string | null} [durationRange] Filter by duration range, format: \&#39;min,max\&#39; (in seconds)
         * @param {number | null} [businessNumberId] 
         * @param {string | null} [callerId] 
         * @param {ExportFormat | null} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogs(businessId: number, startTimeRange?: string | null, dateCreatedRange?: string | null, phoneNumber?: string | null, withNote?: boolean | null, isAnswered?: boolean | null, userId?: number | null, kind?: CallType | null, callId?: string | null, durationRange?: string | null, businessNumberId?: number | null, callerId?: string | null, format?: ExportFormat | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogs(businessId, startTimeRange, dateCreatedRange, phoneNumber, withNote, isAnswered, userId, kind, callId, durationRange, businessNumberId, callerId, format, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.telephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Business Call Logs Via Email
         * @param {number} businessId 
         * @param {string} recipients 
         * @param {string | null} [startTimeRange] 
         * @param {string | null} [dateCreatedRange] 
         * @param {string | null} [phoneNumber] 
         * @param {boolean | null} [withNote] 
         * @param {boolean | null} [isAnswered] 
         * @param {number | null} [userId] 
         * @param {CallType | null} [kind] 
         * @param {string | null} [callId] 
         * @param {string | null} [durationRange] Filter by duration range, format: \&#39;min,max\&#39; (in seconds)
         * @param {number | null} [businessNumberId] 
         * @param {string | null} [callerId] 
         * @param {ExportFormat | null} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail(businessId: number, recipients: string, startTimeRange?: string | null, dateCreatedRange?: string | null, phoneNumber?: string | null, withNote?: boolean | null, isAnswered?: boolean | null, userId?: number | null, kind?: CallType | null, callId?: string | null, durationRange?: string | null, businessNumberId?: number | null, callerId?: string | null, format?: ExportFormat | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail(businessId, recipients, startTimeRange, dateCreatedRange, phoneNumber, withNote, isAnswered, userId, kind, callId, durationRange, businessNumberId, callerId, format, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.telephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Business Call Log Detail
         * @param {number} businessId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogDetail(businessId: number, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BusinessCallLogDetailedOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogDetail(businessId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.telephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Business Call Logs
         * @param {number} businessId 
         * @param {string | null} [startTimeRange] 
         * @param {string | null} [dateCreatedRange] 
         * @param {string | null} [phoneNumber] 
         * @param {boolean | null} [withNote] 
         * @param {boolean | null} [isAnswered] 
         * @param {number | null} [userId] 
         * @param {CallType | null} [kind] 
         * @param {string | null} [callId] 
         * @param {string | null} [durationRange] Filter by duration range, format: \&#39;min,max\&#39; (in seconds)
         * @param {number | null} [businessNumberId] 
         * @param {string | null} [callerId] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs(businessId: number, startTimeRange?: string | null, dateCreatedRange?: string | null, phoneNumber?: string | null, withNote?: boolean | null, isAnswered?: boolean | null, userId?: number | null, kind?: CallType | null, callId?: string | null, durationRange?: string | null, businessNumberId?: number | null, callerId?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedBusinessCallLogOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs(businessId, startTimeRange, dateCreatedRange, phoneNumber, withNote, isAnswered, userId, kind, callId, durationRange, businessNumberId, callerId, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.telephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Call Logs
         * @param {number} numberId 
         * @param {string | null} [startTimeRange] 
         * @param {string | null} [dateCreatedRange] 
         * @param {string | null} [phoneNumber] 
         * @param {boolean | null} [withNote] 
         * @param {boolean | null} [isAnswered] 
         * @param {number | null} [userId] 
         * @param {CallType | null} [kind] 
         * @param {string | null} [callId] 
         * @param {string | null} [durationRange] Filter by duration range, format: \&#39;min,max\&#39; (in seconds)
         * @param {ExportFormat | null} [format] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallLogNumberExportCallLogs(numberId: number, startTimeRange?: string | null, dateCreatedRange?: string | null, phoneNumber?: string | null, withNote?: boolean | null, isAnswered?: boolean | null, userId?: number | null, kind?: CallType | null, callId?: string | null, durationRange?: string | null, format?: ExportFormat | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallLogNumberExportCallLogs(numberId, startTimeRange, dateCreatedRange, phoneNumber, withNote, isAnswered, userId, kind, callId, durationRange, format, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.telephonyViewsNinjaCallCallLogNumberExportCallLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Call Logs
         * @param {number} numberId 
         * @param {string | null} [startTimeRange] 
         * @param {string | null} [dateCreatedRange] 
         * @param {string | null} [phoneNumber] 
         * @param {boolean | null} [withNote] 
         * @param {boolean | null} [isAnswered] 
         * @param {number | null} [userId] 
         * @param {CallType | null} [kind] 
         * @param {string | null} [callId] 
         * @param {string | null} [durationRange] Filter by duration range, format: \&#39;min,max\&#39; (in seconds)
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallLogNumberGetCallLogs(numberId: number, startTimeRange?: string | null, dateCreatedRange?: string | null, phoneNumber?: string | null, withNote?: boolean | null, isAnswered?: boolean | null, userId?: number | null, kind?: CallType | null, callId?: string | null, durationRange?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedCallLogOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallLogNumberGetCallLogs(numberId, startTimeRange, dateCreatedRange, phoneNumber, withNote, isAnswered, userId, kind, callId, durationRange, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallLogsApi.telephonyViewsNinjaCallCallLogNumberGetCallLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CallLogsApi - factory interface
 * @export
 */
export const CallLogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CallLogsApiFp(configuration)
    return {
        /**
         * 
         * @summary Export Business Call Logs
         * @param {CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogs(requestParameters: CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.telephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogs(requestParameters.businessId, requestParameters.startTimeRange, requestParameters.dateCreatedRange, requestParameters.phoneNumber, requestParameters.withNote, requestParameters.isAnswered, requestParameters.userId, requestParameters.kind, requestParameters.callId, requestParameters.durationRange, requestParameters.businessNumberId, requestParameters.callerId, requestParameters.format, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Business Call Logs Via Email
         * @param {CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail(requestParameters: CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.telephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail(requestParameters.businessId, requestParameters.recipients, requestParameters.startTimeRange, requestParameters.dateCreatedRange, requestParameters.phoneNumber, requestParameters.withNote, requestParameters.isAnswered, requestParameters.userId, requestParameters.kind, requestParameters.callId, requestParameters.durationRange, requestParameters.businessNumberId, requestParameters.callerId, requestParameters.format, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Business Call Log Detail
         * @param {CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogDetail(requestParameters: CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<BusinessCallLogDetailedOutSchema> {
            return localVarFp.telephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogDetail(requestParameters.businessId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Business Call Logs
         * @param {CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs(requestParameters: CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedBusinessCallLogOutSchema> {
            return localVarFp.telephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs(requestParameters.businessId, requestParameters.startTimeRange, requestParameters.dateCreatedRange, requestParameters.phoneNumber, requestParameters.withNote, requestParameters.isAnswered, requestParameters.userId, requestParameters.kind, requestParameters.callId, requestParameters.durationRange, requestParameters.businessNumberId, requestParameters.callerId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Call Logs
         * @param {CallLogsApiTelephonyViewsNinjaCallCallLogNumberExportCallLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallLogNumberExportCallLogs(requestParameters: CallLogsApiTelephonyViewsNinjaCallCallLogNumberExportCallLogsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.telephonyViewsNinjaCallCallLogNumberExportCallLogs(requestParameters.numberId, requestParameters.startTimeRange, requestParameters.dateCreatedRange, requestParameters.phoneNumber, requestParameters.withNote, requestParameters.isAnswered, requestParameters.userId, requestParameters.kind, requestParameters.callId, requestParameters.durationRange, requestParameters.format, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Call Logs
         * @param {CallLogsApiTelephonyViewsNinjaCallCallLogNumberGetCallLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallLogNumberGetCallLogs(requestParameters: CallLogsApiTelephonyViewsNinjaCallCallLogNumberGetCallLogsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedCallLogOutSchema> {
            return localVarFp.telephonyViewsNinjaCallCallLogNumberGetCallLogs(requestParameters.numberId, requestParameters.startTimeRange, requestParameters.dateCreatedRange, requestParameters.phoneNumber, requestParameters.withNote, requestParameters.isAnswered, requestParameters.userId, requestParameters.kind, requestParameters.callId, requestParameters.durationRange, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for telephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogs operation in CallLogsApi.
 * @export
 * @interface CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsRequest
 */
export interface CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsRequest {
    /**
     * 
     * @type {number}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogs
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogs
     */
    readonly startTimeRange?: string | null

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogs
     */
    readonly dateCreatedRange?: string | null

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogs
     */
    readonly phoneNumber?: string | null

    /**
     * 
     * @type {boolean}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogs
     */
    readonly withNote?: boolean | null

    /**
     * 
     * @type {boolean}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogs
     */
    readonly isAnswered?: boolean | null

    /**
     * 
     * @type {number}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogs
     */
    readonly userId?: number | null

    /**
     * 
     * @type {CallType}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogs
     */
    readonly kind?: CallType | null

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogs
     */
    readonly callId?: string | null

    /**
     * Filter by duration range, format: \&#39;min,max\&#39; (in seconds)
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogs
     */
    readonly durationRange?: string | null

    /**
     * 
     * @type {number}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogs
     */
    readonly businessNumberId?: number | null

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogs
     */
    readonly callerId?: string | null

    /**
     * 
     * @type {ExportFormat}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogs
     */
    readonly format?: ExportFormat | null
}

/**
 * Request parameters for telephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail operation in CallLogsApi.
 * @export
 * @interface CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmailRequest
 */
export interface CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmailRequest {
    /**
     * 
     * @type {number}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail
     */
    readonly recipients: string

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail
     */
    readonly startTimeRange?: string | null

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail
     */
    readonly dateCreatedRange?: string | null

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail
     */
    readonly phoneNumber?: string | null

    /**
     * 
     * @type {boolean}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail
     */
    readonly withNote?: boolean | null

    /**
     * 
     * @type {boolean}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail
     */
    readonly isAnswered?: boolean | null

    /**
     * 
     * @type {number}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail
     */
    readonly userId?: number | null

    /**
     * 
     * @type {CallType}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail
     */
    readonly kind?: CallType | null

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail
     */
    readonly callId?: string | null

    /**
     * Filter by duration range, format: \&#39;min,max\&#39; (in seconds)
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail
     */
    readonly durationRange?: string | null

    /**
     * 
     * @type {number}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail
     */
    readonly businessNumberId?: number | null

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail
     */
    readonly callerId?: string | null

    /**
     * 
     * @type {ExportFormat}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail
     */
    readonly format?: ExportFormat | null
}

/**
 * Request parameters for telephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogDetail operation in CallLogsApi.
 * @export
 * @interface CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogDetailRequest
 */
export interface CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogDetail
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogDetail
     */
    readonly id: string
}

/**
 * Request parameters for telephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs operation in CallLogsApi.
 * @export
 * @interface CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogsRequest
 */
export interface CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogsRequest {
    /**
     * 
     * @type {number}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs
     */
    readonly startTimeRange?: string | null

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs
     */
    readonly dateCreatedRange?: string | null

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs
     */
    readonly phoneNumber?: string | null

    /**
     * 
     * @type {boolean}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs
     */
    readonly withNote?: boolean | null

    /**
     * 
     * @type {boolean}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs
     */
    readonly isAnswered?: boolean | null

    /**
     * 
     * @type {number}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs
     */
    readonly userId?: number | null

    /**
     * 
     * @type {CallType}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs
     */
    readonly kind?: CallType | null

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs
     */
    readonly callId?: string | null

    /**
     * Filter by duration range, format: \&#39;min,max\&#39; (in seconds)
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs
     */
    readonly durationRange?: string | null

    /**
     * 
     * @type {number}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs
     */
    readonly businessNumberId?: number | null

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs
     */
    readonly callerId?: string | null

    /**
     * 
     * @type {number}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for telephonyViewsNinjaCallCallLogNumberExportCallLogs operation in CallLogsApi.
 * @export
 * @interface CallLogsApiTelephonyViewsNinjaCallCallLogNumberExportCallLogsRequest
 */
export interface CallLogsApiTelephonyViewsNinjaCallCallLogNumberExportCallLogsRequest {
    /**
     * 
     * @type {number}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogNumberExportCallLogs
     */
    readonly numberId: number

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogNumberExportCallLogs
     */
    readonly startTimeRange?: string | null

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogNumberExportCallLogs
     */
    readonly dateCreatedRange?: string | null

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogNumberExportCallLogs
     */
    readonly phoneNumber?: string | null

    /**
     * 
     * @type {boolean}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogNumberExportCallLogs
     */
    readonly withNote?: boolean | null

    /**
     * 
     * @type {boolean}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogNumberExportCallLogs
     */
    readonly isAnswered?: boolean | null

    /**
     * 
     * @type {number}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogNumberExportCallLogs
     */
    readonly userId?: number | null

    /**
     * 
     * @type {CallType}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogNumberExportCallLogs
     */
    readonly kind?: CallType | null

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogNumberExportCallLogs
     */
    readonly callId?: string | null

    /**
     * Filter by duration range, format: \&#39;min,max\&#39; (in seconds)
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogNumberExportCallLogs
     */
    readonly durationRange?: string | null

    /**
     * 
     * @type {ExportFormat}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogNumberExportCallLogs
     */
    readonly format?: ExportFormat | null
}

/**
 * Request parameters for telephonyViewsNinjaCallCallLogNumberGetCallLogs operation in CallLogsApi.
 * @export
 * @interface CallLogsApiTelephonyViewsNinjaCallCallLogNumberGetCallLogsRequest
 */
export interface CallLogsApiTelephonyViewsNinjaCallCallLogNumberGetCallLogsRequest {
    /**
     * 
     * @type {number}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogNumberGetCallLogs
     */
    readonly numberId: number

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogNumberGetCallLogs
     */
    readonly startTimeRange?: string | null

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogNumberGetCallLogs
     */
    readonly dateCreatedRange?: string | null

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogNumberGetCallLogs
     */
    readonly phoneNumber?: string | null

    /**
     * 
     * @type {boolean}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogNumberGetCallLogs
     */
    readonly withNote?: boolean | null

    /**
     * 
     * @type {boolean}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogNumberGetCallLogs
     */
    readonly isAnswered?: boolean | null

    /**
     * 
     * @type {number}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogNumberGetCallLogs
     */
    readonly userId?: number | null

    /**
     * 
     * @type {CallType}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogNumberGetCallLogs
     */
    readonly kind?: CallType | null

    /**
     * 
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogNumberGetCallLogs
     */
    readonly callId?: string | null

    /**
     * Filter by duration range, format: \&#39;min,max\&#39; (in seconds)
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogNumberGetCallLogs
     */
    readonly durationRange?: string | null

    /**
     * 
     * @type {number}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogNumberGetCallLogs
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogNumberGetCallLogs
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof CallLogsApiTelephonyViewsNinjaCallCallLogNumberGetCallLogs
     */
    readonly ordering?: string | null
}

/**
 * CallLogsApi - object-oriented interface
 * @export
 * @class CallLogsApi
 * @extends {BaseAPI}
 */
export class CallLogsApi extends BaseAPI {
    /**
     * 
     * @summary Export Business Call Logs
     * @param {CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public telephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogs(requestParameters: CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsRequest, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).telephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogs(requestParameters.businessId, requestParameters.startTimeRange, requestParameters.dateCreatedRange, requestParameters.phoneNumber, requestParameters.withNote, requestParameters.isAnswered, requestParameters.userId, requestParameters.kind, requestParameters.callId, requestParameters.durationRange, requestParameters.businessNumberId, requestParameters.callerId, requestParameters.format, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Business Call Logs Via Email
     * @param {CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public telephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail(requestParameters: CallLogsApiTelephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmailRequest, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).telephonyViewsNinjaCallCallLogBusinessExportBusinessCallLogsViaEmail(requestParameters.businessId, requestParameters.recipients, requestParameters.startTimeRange, requestParameters.dateCreatedRange, requestParameters.phoneNumber, requestParameters.withNote, requestParameters.isAnswered, requestParameters.userId, requestParameters.kind, requestParameters.callId, requestParameters.durationRange, requestParameters.businessNumberId, requestParameters.callerId, requestParameters.format, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Business Call Log Detail
     * @param {CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public telephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogDetail(requestParameters: CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogDetailRequest, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).telephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogDetail(requestParameters.businessId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Business Call Logs
     * @param {CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public telephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs(requestParameters: CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogsRequest, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).telephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs(requestParameters.businessId, requestParameters.startTimeRange, requestParameters.dateCreatedRange, requestParameters.phoneNumber, requestParameters.withNote, requestParameters.isAnswered, requestParameters.userId, requestParameters.kind, requestParameters.callId, requestParameters.durationRange, requestParameters.businessNumberId, requestParameters.callerId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Call Logs
     * @param {CallLogsApiTelephonyViewsNinjaCallCallLogNumberExportCallLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public telephonyViewsNinjaCallCallLogNumberExportCallLogs(requestParameters: CallLogsApiTelephonyViewsNinjaCallCallLogNumberExportCallLogsRequest, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).telephonyViewsNinjaCallCallLogNumberExportCallLogs(requestParameters.numberId, requestParameters.startTimeRange, requestParameters.dateCreatedRange, requestParameters.phoneNumber, requestParameters.withNote, requestParameters.isAnswered, requestParameters.userId, requestParameters.kind, requestParameters.callId, requestParameters.durationRange, requestParameters.format, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Call Logs
     * @param {CallLogsApiTelephonyViewsNinjaCallCallLogNumberGetCallLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallLogsApi
     */
    public telephonyViewsNinjaCallCallLogNumberGetCallLogs(requestParameters: CallLogsApiTelephonyViewsNinjaCallCallLogNumberGetCallLogsRequest, options?: RawAxiosRequestConfig) {
        return CallLogsApiFp(this.configuration).telephonyViewsNinjaCallCallLogNumberGetCallLogs(requestParameters.numberId, requestParameters.startTimeRange, requestParameters.dateCreatedRange, requestParameters.phoneNumber, requestParameters.withNote, requestParameters.isAnswered, requestParameters.userId, requestParameters.kind, requestParameters.callId, requestParameters.durationRange, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CallNotesApi - axios parameter creator
 * @export
 */
export const CallNotesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Call Note
         * @param {number} businessId 
         * @param {CallNoteInSchema} callNoteInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallNoteCreateCallNote: async (businessId: number, callNoteInSchema: CallNoteInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallNoteCreateCallNote', 'businessId', businessId)
            // verify required parameter 'callNoteInSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallNoteCreateCallNote', 'callNoteInSchema', callNoteInSchema)
            const localVarPath = `/api/business/{business_id}/call-note/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(callNoteInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Call Note
         * @param {number} businessId 
         * @param {number} callNoteId 
         * @param {number} callLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallNoteDeleteCallNote: async (businessId: number, callNoteId: number, callLogId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallNoteDeleteCallNote', 'businessId', businessId)
            // verify required parameter 'callNoteId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallNoteDeleteCallNote', 'callNoteId', callNoteId)
            // verify required parameter 'callLogId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallNoteDeleteCallNote', 'callLogId', callLogId)
            const localVarPath = `/api/business/{business_id}/call-note/{call_note_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"call_note_id"}}`, encodeURIComponent(String(callNoteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (callLogId !== undefined) {
                localVarQueryParameter['call_log_id'] = callLogId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Call Notes
         * @param {number} businessId 
         * @param {number} callLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallNoteListCallNotes: async (businessId: number, callLogId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallNoteListCallNotes', 'businessId', businessId)
            // verify required parameter 'callLogId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallNoteListCallNotes', 'callLogId', callLogId)
            const localVarPath = `/api/business/{business_id}/call-note/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (callLogId !== undefined) {
                localVarQueryParameter['call_log_id'] = callLogId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve Call Note
         * @param {number} businessId 
         * @param {number} callNoteId 
         * @param {number} callLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallNoteRetrieveCallNote: async (businessId: number, callNoteId: number, callLogId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallNoteRetrieveCallNote', 'businessId', businessId)
            // verify required parameter 'callNoteId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallNoteRetrieveCallNote', 'callNoteId', callNoteId)
            // verify required parameter 'callLogId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallNoteRetrieveCallNote', 'callLogId', callLogId)
            const localVarPath = `/api/business/{business_id}/call-note/{call_note_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"call_note_id"}}`, encodeURIComponent(String(callNoteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (callLogId !== undefined) {
                localVarQueryParameter['call_log_id'] = callLogId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Call Note
         * @param {number} businessId 
         * @param {number} callNoteId 
         * @param {CallNoteInSchema} callNoteInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallNoteUpdateCallNote: async (businessId: number, callNoteId: number, callNoteInSchema: CallNoteInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallNoteUpdateCallNote', 'businessId', businessId)
            // verify required parameter 'callNoteId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallNoteUpdateCallNote', 'callNoteId', callNoteId)
            // verify required parameter 'callNoteInSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallNoteUpdateCallNote', 'callNoteInSchema', callNoteInSchema)
            const localVarPath = `/api/business/{business_id}/call-note/{call_note_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"call_note_id"}}`, encodeURIComponent(String(callNoteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(callNoteInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallNotesApi - functional programming interface
 * @export
 */
export const CallNotesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CallNotesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Call Note
         * @param {number} businessId 
         * @param {CallNoteInSchema} callNoteInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallNoteCreateCallNote(businessId: number, callNoteInSchema: CallNoteInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallNoteOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallNoteCreateCallNote(businessId, callNoteInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallNotesApi.telephonyViewsNinjaCallCallNoteCreateCallNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Call Note
         * @param {number} businessId 
         * @param {number} callNoteId 
         * @param {number} callLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallNoteDeleteCallNote(businessId: number, callNoteId: number, callLogId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallNoteDeleteCallNote(businessId, callNoteId, callLogId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallNotesApi.telephonyViewsNinjaCallCallNoteDeleteCallNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Call Notes
         * @param {number} businessId 
         * @param {number} callLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallNoteListCallNotes(businessId: number, callLogId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CallNoteOutSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallNoteListCallNotes(businessId, callLogId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallNotesApi.telephonyViewsNinjaCallCallNoteListCallNotes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve Call Note
         * @param {number} businessId 
         * @param {number} callNoteId 
         * @param {number} callLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallNoteRetrieveCallNote(businessId: number, callNoteId: number, callLogId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallNoteOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallNoteRetrieveCallNote(businessId, callNoteId, callLogId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallNotesApi.telephonyViewsNinjaCallCallNoteRetrieveCallNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Call Note
         * @param {number} businessId 
         * @param {number} callNoteId 
         * @param {CallNoteInSchema} callNoteInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallNoteUpdateCallNote(businessId: number, callNoteId: number, callNoteInSchema: CallNoteInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallNoteOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallNoteUpdateCallNote(businessId, callNoteId, callNoteInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallNotesApi.telephonyViewsNinjaCallCallNoteUpdateCallNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CallNotesApi - factory interface
 * @export
 */
export const CallNotesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CallNotesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Call Note
         * @param {CallNotesApiTelephonyViewsNinjaCallCallNoteCreateCallNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallNoteCreateCallNote(requestParameters: CallNotesApiTelephonyViewsNinjaCallCallNoteCreateCallNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<CallNoteOutSchema> {
            return localVarFp.telephonyViewsNinjaCallCallNoteCreateCallNote(requestParameters.businessId, requestParameters.callNoteInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Call Note
         * @param {CallNotesApiTelephonyViewsNinjaCallCallNoteDeleteCallNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallNoteDeleteCallNote(requestParameters: CallNotesApiTelephonyViewsNinjaCallCallNoteDeleteCallNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.telephonyViewsNinjaCallCallNoteDeleteCallNote(requestParameters.businessId, requestParameters.callNoteId, requestParameters.callLogId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Call Notes
         * @param {CallNotesApiTelephonyViewsNinjaCallCallNoteListCallNotesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallNoteListCallNotes(requestParameters: CallNotesApiTelephonyViewsNinjaCallCallNoteListCallNotesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CallNoteOutSchema>> {
            return localVarFp.telephonyViewsNinjaCallCallNoteListCallNotes(requestParameters.businessId, requestParameters.callLogId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve Call Note
         * @param {CallNotesApiTelephonyViewsNinjaCallCallNoteRetrieveCallNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallNoteRetrieveCallNote(requestParameters: CallNotesApiTelephonyViewsNinjaCallCallNoteRetrieveCallNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<CallNoteOutSchema> {
            return localVarFp.telephonyViewsNinjaCallCallNoteRetrieveCallNote(requestParameters.businessId, requestParameters.callNoteId, requestParameters.callLogId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Call Note
         * @param {CallNotesApiTelephonyViewsNinjaCallCallNoteUpdateCallNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallNoteUpdateCallNote(requestParameters: CallNotesApiTelephonyViewsNinjaCallCallNoteUpdateCallNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<CallNoteOutSchema> {
            return localVarFp.telephonyViewsNinjaCallCallNoteUpdateCallNote(requestParameters.businessId, requestParameters.callNoteId, requestParameters.callNoteInSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for telephonyViewsNinjaCallCallNoteCreateCallNote operation in CallNotesApi.
 * @export
 * @interface CallNotesApiTelephonyViewsNinjaCallCallNoteCreateCallNoteRequest
 */
export interface CallNotesApiTelephonyViewsNinjaCallCallNoteCreateCallNoteRequest {
    /**
     * 
     * @type {number}
     * @memberof CallNotesApiTelephonyViewsNinjaCallCallNoteCreateCallNote
     */
    readonly businessId: number

    /**
     * 
     * @type {CallNoteInSchema}
     * @memberof CallNotesApiTelephonyViewsNinjaCallCallNoteCreateCallNote
     */
    readonly callNoteInSchema: CallNoteInSchema
}

/**
 * Request parameters for telephonyViewsNinjaCallCallNoteDeleteCallNote operation in CallNotesApi.
 * @export
 * @interface CallNotesApiTelephonyViewsNinjaCallCallNoteDeleteCallNoteRequest
 */
export interface CallNotesApiTelephonyViewsNinjaCallCallNoteDeleteCallNoteRequest {
    /**
     * 
     * @type {number}
     * @memberof CallNotesApiTelephonyViewsNinjaCallCallNoteDeleteCallNote
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CallNotesApiTelephonyViewsNinjaCallCallNoteDeleteCallNote
     */
    readonly callNoteId: number

    /**
     * 
     * @type {number}
     * @memberof CallNotesApiTelephonyViewsNinjaCallCallNoteDeleteCallNote
     */
    readonly callLogId: number
}

/**
 * Request parameters for telephonyViewsNinjaCallCallNoteListCallNotes operation in CallNotesApi.
 * @export
 * @interface CallNotesApiTelephonyViewsNinjaCallCallNoteListCallNotesRequest
 */
export interface CallNotesApiTelephonyViewsNinjaCallCallNoteListCallNotesRequest {
    /**
     * 
     * @type {number}
     * @memberof CallNotesApiTelephonyViewsNinjaCallCallNoteListCallNotes
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CallNotesApiTelephonyViewsNinjaCallCallNoteListCallNotes
     */
    readonly callLogId: number
}

/**
 * Request parameters for telephonyViewsNinjaCallCallNoteRetrieveCallNote operation in CallNotesApi.
 * @export
 * @interface CallNotesApiTelephonyViewsNinjaCallCallNoteRetrieveCallNoteRequest
 */
export interface CallNotesApiTelephonyViewsNinjaCallCallNoteRetrieveCallNoteRequest {
    /**
     * 
     * @type {number}
     * @memberof CallNotesApiTelephonyViewsNinjaCallCallNoteRetrieveCallNote
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CallNotesApiTelephonyViewsNinjaCallCallNoteRetrieveCallNote
     */
    readonly callNoteId: number

    /**
     * 
     * @type {number}
     * @memberof CallNotesApiTelephonyViewsNinjaCallCallNoteRetrieveCallNote
     */
    readonly callLogId: number
}

/**
 * Request parameters for telephonyViewsNinjaCallCallNoteUpdateCallNote operation in CallNotesApi.
 * @export
 * @interface CallNotesApiTelephonyViewsNinjaCallCallNoteUpdateCallNoteRequest
 */
export interface CallNotesApiTelephonyViewsNinjaCallCallNoteUpdateCallNoteRequest {
    /**
     * 
     * @type {number}
     * @memberof CallNotesApiTelephonyViewsNinjaCallCallNoteUpdateCallNote
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CallNotesApiTelephonyViewsNinjaCallCallNoteUpdateCallNote
     */
    readonly callNoteId: number

    /**
     * 
     * @type {CallNoteInSchema}
     * @memberof CallNotesApiTelephonyViewsNinjaCallCallNoteUpdateCallNote
     */
    readonly callNoteInSchema: CallNoteInSchema
}

/**
 * CallNotesApi - object-oriented interface
 * @export
 * @class CallNotesApi
 * @extends {BaseAPI}
 */
export class CallNotesApi extends BaseAPI {
    /**
     * 
     * @summary Create Call Note
     * @param {CallNotesApiTelephonyViewsNinjaCallCallNoteCreateCallNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallNotesApi
     */
    public telephonyViewsNinjaCallCallNoteCreateCallNote(requestParameters: CallNotesApiTelephonyViewsNinjaCallCallNoteCreateCallNoteRequest, options?: RawAxiosRequestConfig) {
        return CallNotesApiFp(this.configuration).telephonyViewsNinjaCallCallNoteCreateCallNote(requestParameters.businessId, requestParameters.callNoteInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Call Note
     * @param {CallNotesApiTelephonyViewsNinjaCallCallNoteDeleteCallNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallNotesApi
     */
    public telephonyViewsNinjaCallCallNoteDeleteCallNote(requestParameters: CallNotesApiTelephonyViewsNinjaCallCallNoteDeleteCallNoteRequest, options?: RawAxiosRequestConfig) {
        return CallNotesApiFp(this.configuration).telephonyViewsNinjaCallCallNoteDeleteCallNote(requestParameters.businessId, requestParameters.callNoteId, requestParameters.callLogId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Call Notes
     * @param {CallNotesApiTelephonyViewsNinjaCallCallNoteListCallNotesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallNotesApi
     */
    public telephonyViewsNinjaCallCallNoteListCallNotes(requestParameters: CallNotesApiTelephonyViewsNinjaCallCallNoteListCallNotesRequest, options?: RawAxiosRequestConfig) {
        return CallNotesApiFp(this.configuration).telephonyViewsNinjaCallCallNoteListCallNotes(requestParameters.businessId, requestParameters.callLogId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve Call Note
     * @param {CallNotesApiTelephonyViewsNinjaCallCallNoteRetrieveCallNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallNotesApi
     */
    public telephonyViewsNinjaCallCallNoteRetrieveCallNote(requestParameters: CallNotesApiTelephonyViewsNinjaCallCallNoteRetrieveCallNoteRequest, options?: RawAxiosRequestConfig) {
        return CallNotesApiFp(this.configuration).telephonyViewsNinjaCallCallNoteRetrieveCallNote(requestParameters.businessId, requestParameters.callNoteId, requestParameters.callLogId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Call Note
     * @param {CallNotesApiTelephonyViewsNinjaCallCallNoteUpdateCallNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallNotesApi
     */
    public telephonyViewsNinjaCallCallNoteUpdateCallNote(requestParameters: CallNotesApiTelephonyViewsNinjaCallCallNoteUpdateCallNoteRequest, options?: RawAxiosRequestConfig) {
        return CallNotesApiFp(this.configuration).telephonyViewsNinjaCallCallNoteUpdateCallNote(requestParameters.businessId, requestParameters.callNoteId, requestParameters.callNoteInSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CallQueueApi - axios parameter creator
 * @export
 */
export const CallQueueApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add Contacts To Call Queue
         * @param {number} businessId 
         * @param {number} queueId 
         * @param {CallQueueContactInSchema} callQueueContactInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueAddContactsToCallQueue: async (businessId: number, queueId: number, callQueueContactInSchema: CallQueueContactInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueAddContactsToCallQueue', 'businessId', businessId)
            // verify required parameter 'queueId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueAddContactsToCallQueue', 'queueId', queueId)
            // verify required parameter 'callQueueContactInSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueAddContactsToCallQueue', 'callQueueContactInSchema', callQueueContactInSchema)
            const localVarPath = `/api/business/{business_id}/call-queue/{queue_id}/items/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"queue_id"}}`, encodeURIComponent(String(queueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(callQueueContactInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Agent Reorder Call Queue Item
         * @param {number} businessId 
         * @param {number} queueId 
         * @param {number} userId 
         * @param {QueueReorderSchema} queueReorderSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueAgentReorderCallQueueItem: async (businessId: number, queueId: number, userId: number, queueReorderSchema: QueueReorderSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueAgentReorderCallQueueItem', 'businessId', businessId)
            // verify required parameter 'queueId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueAgentReorderCallQueueItem', 'queueId', queueId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueAgentReorderCallQueueItem', 'userId', userId)
            // verify required parameter 'queueReorderSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueAgentReorderCallQueueItem', 'queueReorderSchema', queueReorderSchema)
            const localVarPath = `/api/business/{business_id}/call-queue/{queue_id}/agent/{user_id}/reorder/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"queue_id"}}`, encodeURIComponent(String(queueId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queueReorderSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Call Queue
         * @param {number} businessId 
         * @param {CallQueueInSchema} callQueueInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueCreateCallQueue: async (businessId: number, callQueueInSchema: CallQueueInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueCreateCallQueue', 'businessId', businessId)
            // verify required parameter 'callQueueInSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueCreateCallQueue', 'callQueueInSchema', callQueueInSchema)
            const localVarPath = `/api/business/{business_id}/call-queue/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(callQueueInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Agent Call Queue Contacts
         * @param {number} businessId 
         * @param {number} queueId 
         * @param {number} userId 
         * @param {CallQueueContactInSchema} callQueueContactInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueDeleteAgentCallQueueContacts: async (businessId: number, queueId: number, userId: number, callQueueContactInSchema: CallQueueContactInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueDeleteAgentCallQueueContacts', 'businessId', businessId)
            // verify required parameter 'queueId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueDeleteAgentCallQueueContacts', 'queueId', queueId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueDeleteAgentCallQueueContacts', 'userId', userId)
            // verify required parameter 'callQueueContactInSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueDeleteAgentCallQueueContacts', 'callQueueContactInSchema', callQueueContactInSchema)
            const localVarPath = `/api/business/{business_id}/call-queue/{queue_id}/agent/{user_id}/items/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"queue_id"}}`, encodeURIComponent(String(queueId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(callQueueContactInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Call Queue
         * @param {number} businessId 
         * @param {number} queueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueDeleteCallQueue: async (businessId: number, queueId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueDeleteCallQueue', 'businessId', businessId)
            // verify required parameter 'queueId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueDeleteCallQueue', 'queueId', queueId)
            const localVarPath = `/api/business/{business_id}/call-queue/{queue_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"queue_id"}}`, encodeURIComponent(String(queueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Call Queue Contacts
         * @param {number} businessId 
         * @param {number} queueId 
         * @param {CallQueueContactInSchema} callQueueContactInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueDeleteCallQueueContacts: async (businessId: number, queueId: number, callQueueContactInSchema: CallQueueContactInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueDeleteCallQueueContacts', 'businessId', businessId)
            // verify required parameter 'queueId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueDeleteCallQueueContacts', 'queueId', queueId)
            // verify required parameter 'callQueueContactInSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueDeleteCallQueueContacts', 'callQueueContactInSchema', callQueueContactInSchema)
            const localVarPath = `/api/business/{business_id}/call-queue/{queue_id}/items/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"queue_id"}}`, encodeURIComponent(String(queueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(callQueueContactInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Distribute Contacts To Call Queues
         * @param {number} businessId 
         * @param {CallQueueContactDistributionInSchema} callQueueContactDistributionInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueDistributeContactsToCallQueues: async (businessId: number, callQueueContactDistributionInSchema: CallQueueContactDistributionInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueDistributeContactsToCallQueues', 'businessId', businessId)
            // verify required parameter 'callQueueContactDistributionInSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueDistributeContactsToCallQueues', 'callQueueContactDistributionInSchema', callQueueContactDistributionInSchema)
            const localVarPath = `/api/business/{business_id}/call-queue/distribute-contacts/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(callQueueContactDistributionInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Agent Call Queue Items
         * @param {number} businessId 
         * @param {number} userId 
         * @param {number} queueId 
         * @param {string | null} [name] 
         * @param {number | null} [createdBy] 
         * @param {number | null} [assigned] 
         * @param {number | null} [business] 
         * @param {number | null} [campaignId] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueListAgentCallQueueItems: async (businessId: number, userId: number, queueId: number, name?: string | null, createdBy?: number | null, assigned?: number | null, business?: number | null, campaignId?: number | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueListAgentCallQueueItems', 'businessId', businessId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueListAgentCallQueueItems', 'userId', userId)
            // verify required parameter 'queueId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueListAgentCallQueueItems', 'queueId', queueId)
            const localVarPath = `/api/business/{business_id}/call-queue/{queue_id}/agent/{user_id}/items/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"queue_id"}}`, encodeURIComponent(String(queueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (createdBy !== undefined) {
                localVarQueryParameter['created_by'] = createdBy;
            }

            if (assigned !== undefined) {
                localVarQueryParameter['assigned'] = assigned;
            }

            if (business !== undefined) {
                localVarQueryParameter['business'] = business;
            }

            if (campaignId !== undefined) {
                localVarQueryParameter['campaign_id'] = campaignId;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Agent Call Queues
         * @param {number} businessId 
         * @param {number} userId 
         * @param {string | null} [name] 
         * @param {number | null} [createdBy] 
         * @param {number | null} [assigned] 
         * @param {number | null} [business] 
         * @param {number | null} [campaignId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueListAgentCallQueues: async (businessId: number, userId: number, name?: string | null, createdBy?: number | null, assigned?: number | null, business?: number | null, campaignId?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueListAgentCallQueues', 'businessId', businessId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueListAgentCallQueues', 'userId', userId)
            const localVarPath = `/api/business/{business_id}/call-queue/agent/{user_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (createdBy !== undefined) {
                localVarQueryParameter['created_by'] = createdBy;
            }

            if (assigned !== undefined) {
                localVarQueryParameter['assigned'] = assigned;
            }

            if (business !== undefined) {
                localVarQueryParameter['business'] = business;
            }

            if (campaignId !== undefined) {
                localVarQueryParameter['campaign_id'] = campaignId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Call Queue Items
         * @param {number} businessId 
         * @param {number} queueId 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueListCallQueueItems: async (businessId: number, queueId: number, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueListCallQueueItems', 'businessId', businessId)
            // verify required parameter 'queueId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueListCallQueueItems', 'queueId', queueId)
            const localVarPath = `/api/business/{business_id}/call-queue/{queue_id}/items/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"queue_id"}}`, encodeURIComponent(String(queueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Call Queues
         * @param {number} businessId 
         * @param {string | null} [name] 
         * @param {number | null} [createdBy] 
         * @param {number | null} [assigned] 
         * @param {number | null} [business] 
         * @param {number | null} [campaignId] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueListCallQueues: async (businessId: number, name?: string | null, createdBy?: number | null, assigned?: number | null, business?: number | null, campaignId?: number | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueListCallQueues', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/call-queue/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (createdBy !== undefined) {
                localVarQueryParameter['created_by'] = createdBy;
            }

            if (assigned !== undefined) {
                localVarQueryParameter['assigned'] = assigned;
            }

            if (business !== undefined) {
                localVarQueryParameter['business'] = business;
            }

            if (campaignId !== undefined) {
                localVarQueryParameter['campaign_id'] = campaignId;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reorder Call Queue Item
         * @param {number} businessId 
         * @param {number} queueId 
         * @param {QueueReorderSchema} queueReorderSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueReorderCallQueueItem: async (businessId: number, queueId: number, queueReorderSchema: QueueReorderSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueReorderCallQueueItem', 'businessId', businessId)
            // verify required parameter 'queueId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueReorderCallQueueItem', 'queueId', queueId)
            // verify required parameter 'queueReorderSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueReorderCallQueueItem', 'queueReorderSchema', queueReorderSchema)
            const localVarPath = `/api/business/{business_id}/call-queue/{queue_id}/reorder/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"queue_id"}}`, encodeURIComponent(String(queueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queueReorderSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve Agent Call Queue
         * @param {number} businessId 
         * @param {number} userId 
         * @param {number} queueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueRetrieveAgentCallQueue: async (businessId: number, userId: number, queueId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueRetrieveAgentCallQueue', 'businessId', businessId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueRetrieveAgentCallQueue', 'userId', userId)
            // verify required parameter 'queueId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueRetrieveAgentCallQueue', 'queueId', queueId)
            const localVarPath = `/api/business/{business_id}/call-queue/{queue_id}/agent/{user_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"queue_id"}}`, encodeURIComponent(String(queueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve Call Queue
         * @param {number} businessId 
         * @param {number} queueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueRetrieveCallQueue: async (businessId: number, queueId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueRetrieveCallQueue', 'businessId', businessId)
            // verify required parameter 'queueId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueRetrieveCallQueue', 'queueId', queueId)
            const localVarPath = `/api/business/{business_id}/call-queue/{queue_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"queue_id"}}`, encodeURIComponent(String(queueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Call Queue
         * @param {number} businessId 
         * @param {number} queueId 
         * @param {UpdateQueueSchema} updateQueueSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueUpdateCallQueue: async (businessId: number, queueId: number, updateQueueSchema: UpdateQueueSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueUpdateCallQueue', 'businessId', businessId)
            // verify required parameter 'queueId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueUpdateCallQueue', 'queueId', queueId)
            // verify required parameter 'updateQueueSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallQueueUpdateCallQueue', 'updateQueueSchema', updateQueueSchema)
            const localVarPath = `/api/business/{business_id}/call-queue/{queue_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"queue_id"}}`, encodeURIComponent(String(queueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateQueueSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallQueueApi - functional programming interface
 * @export
 */
export const CallQueueApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CallQueueApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add Contacts To Call Queue
         * @param {number} businessId 
         * @param {number} queueId 
         * @param {CallQueueContactInSchema} callQueueContactInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallQueueAddContactsToCallQueue(businessId: number, queueId: number, callQueueContactInSchema: CallQueueContactInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallQueueAddContactsToCallQueue(businessId, queueId, callQueueContactInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallQueueApi.telephonyViewsNinjaCallCallQueueAddContactsToCallQueue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Agent Reorder Call Queue Item
         * @param {number} businessId 
         * @param {number} queueId 
         * @param {number} userId 
         * @param {QueueReorderSchema} queueReorderSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallQueueAgentReorderCallQueueItem(businessId: number, queueId: number, userId: number, queueReorderSchema: QueueReorderSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallQueueAgentReorderCallQueueItem(businessId, queueId, userId, queueReorderSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallQueueApi.telephonyViewsNinjaCallCallQueueAgentReorderCallQueueItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Call Queue
         * @param {number} businessId 
         * @param {CallQueueInSchema} callQueueInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallQueueCreateCallQueue(businessId: number, callQueueInSchema: CallQueueInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallQueueOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallQueueCreateCallQueue(businessId, callQueueInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallQueueApi.telephonyViewsNinjaCallCallQueueCreateCallQueue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Agent Call Queue Contacts
         * @param {number} businessId 
         * @param {number} queueId 
         * @param {number} userId 
         * @param {CallQueueContactInSchema} callQueueContactInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallQueueDeleteAgentCallQueueContacts(businessId: number, queueId: number, userId: number, callQueueContactInSchema: CallQueueContactInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallQueueDeleteAgentCallQueueContacts(businessId, queueId, userId, callQueueContactInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallQueueApi.telephonyViewsNinjaCallCallQueueDeleteAgentCallQueueContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Call Queue
         * @param {number} businessId 
         * @param {number} queueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallQueueDeleteCallQueue(businessId: number, queueId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallQueueDeleteCallQueue(businessId, queueId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallQueueApi.telephonyViewsNinjaCallCallQueueDeleteCallQueue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Call Queue Contacts
         * @param {number} businessId 
         * @param {number} queueId 
         * @param {CallQueueContactInSchema} callQueueContactInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallQueueDeleteCallQueueContacts(businessId: number, queueId: number, callQueueContactInSchema: CallQueueContactInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallQueueDeleteCallQueueContacts(businessId, queueId, callQueueContactInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallQueueApi.telephonyViewsNinjaCallCallQueueDeleteCallQueueContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Distribute Contacts To Call Queues
         * @param {number} businessId 
         * @param {CallQueueContactDistributionInSchema} callQueueContactDistributionInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallQueueDistributeContactsToCallQueues(businessId: number, callQueueContactDistributionInSchema: CallQueueContactDistributionInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallQueueDistributeContactsToCallQueues(businessId, callQueueContactDistributionInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallQueueApi.telephonyViewsNinjaCallCallQueueDistributeContactsToCallQueues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Agent Call Queue Items
         * @param {number} businessId 
         * @param {number} userId 
         * @param {number} queueId 
         * @param {string | null} [name] 
         * @param {number | null} [createdBy] 
         * @param {number | null} [assigned] 
         * @param {number | null} [business] 
         * @param {number | null} [campaignId] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallQueueListAgentCallQueueItems(businessId: number, userId: number, queueId: number, name?: string | null, createdBy?: number | null, assigned?: number | null, business?: number | null, campaignId?: number | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedCallQueueContactOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallQueueListAgentCallQueueItems(businessId, userId, queueId, name, createdBy, assigned, business, campaignId, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallQueueApi.telephonyViewsNinjaCallCallQueueListAgentCallQueueItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Agent Call Queues
         * @param {number} businessId 
         * @param {number} userId 
         * @param {string | null} [name] 
         * @param {number | null} [createdBy] 
         * @param {number | null} [assigned] 
         * @param {number | null} [business] 
         * @param {number | null} [campaignId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallQueueListAgentCallQueues(businessId: number, userId: number, name?: string | null, createdBy?: number | null, assigned?: number | null, business?: number | null, campaignId?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CallQueueOutSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallQueueListAgentCallQueues(businessId, userId, name, createdBy, assigned, business, campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallQueueApi.telephonyViewsNinjaCallCallQueueListAgentCallQueues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Call Queue Items
         * @param {number} businessId 
         * @param {number} queueId 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallQueueListCallQueueItems(businessId: number, queueId: number, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedCallQueueContactOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallQueueListCallQueueItems(businessId, queueId, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallQueueApi.telephonyViewsNinjaCallCallQueueListCallQueueItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Call Queues
         * @param {number} businessId 
         * @param {string | null} [name] 
         * @param {number | null} [createdBy] 
         * @param {number | null} [assigned] 
         * @param {number | null} [business] 
         * @param {number | null} [campaignId] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallQueueListCallQueues(businessId: number, name?: string | null, createdBy?: number | null, assigned?: number | null, business?: number | null, campaignId?: number | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedCallQueueOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallQueueListCallQueues(businessId, name, createdBy, assigned, business, campaignId, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallQueueApi.telephonyViewsNinjaCallCallQueueListCallQueues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reorder Call Queue Item
         * @param {number} businessId 
         * @param {number} queueId 
         * @param {QueueReorderSchema} queueReorderSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallQueueReorderCallQueueItem(businessId: number, queueId: number, queueReorderSchema: QueueReorderSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallQueueReorderCallQueueItem(businessId, queueId, queueReorderSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallQueueApi.telephonyViewsNinjaCallCallQueueReorderCallQueueItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve Agent Call Queue
         * @param {number} businessId 
         * @param {number} userId 
         * @param {number} queueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallQueueRetrieveAgentCallQueue(businessId: number, userId: number, queueId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallQueueOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallQueueRetrieveAgentCallQueue(businessId, userId, queueId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallQueueApi.telephonyViewsNinjaCallCallQueueRetrieveAgentCallQueue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve Call Queue
         * @param {number} businessId 
         * @param {number} queueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallQueueRetrieveCallQueue(businessId: number, queueId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallQueueOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallQueueRetrieveCallQueue(businessId, queueId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallQueueApi.telephonyViewsNinjaCallCallQueueRetrieveCallQueue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Call Queue
         * @param {number} businessId 
         * @param {number} queueId 
         * @param {UpdateQueueSchema} updateQueueSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallQueueUpdateCallQueue(businessId: number, queueId: number, updateQueueSchema: UpdateQueueSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallQueueOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallQueueUpdateCallQueue(businessId, queueId, updateQueueSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallQueueApi.telephonyViewsNinjaCallCallQueueUpdateCallQueue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CallQueueApi - factory interface
 * @export
 */
export const CallQueueApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CallQueueApiFp(configuration)
    return {
        /**
         * 
         * @summary Add Contacts To Call Queue
         * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueAddContactsToCallQueueRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueAddContactsToCallQueue(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueAddContactsToCallQueueRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.telephonyViewsNinjaCallCallQueueAddContactsToCallQueue(requestParameters.businessId, requestParameters.queueId, requestParameters.callQueueContactInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Agent Reorder Call Queue Item
         * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueAgentReorderCallQueueItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueAgentReorderCallQueueItem(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueAgentReorderCallQueueItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.telephonyViewsNinjaCallCallQueueAgentReorderCallQueueItem(requestParameters.businessId, requestParameters.queueId, requestParameters.userId, requestParameters.queueReorderSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Call Queue
         * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueCreateCallQueueRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueCreateCallQueue(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueCreateCallQueueRequest, options?: RawAxiosRequestConfig): AxiosPromise<CallQueueOutSchema> {
            return localVarFp.telephonyViewsNinjaCallCallQueueCreateCallQueue(requestParameters.businessId, requestParameters.callQueueInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Agent Call Queue Contacts
         * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteAgentCallQueueContactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueDeleteAgentCallQueueContacts(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteAgentCallQueueContactsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.telephonyViewsNinjaCallCallQueueDeleteAgentCallQueueContacts(requestParameters.businessId, requestParameters.queueId, requestParameters.userId, requestParameters.callQueueContactInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Call Queue
         * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteCallQueueRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueDeleteCallQueue(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteCallQueueRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.telephonyViewsNinjaCallCallQueueDeleteCallQueue(requestParameters.businessId, requestParameters.queueId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Call Queue Contacts
         * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteCallQueueContactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueDeleteCallQueueContacts(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteCallQueueContactsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.telephonyViewsNinjaCallCallQueueDeleteCallQueueContacts(requestParameters.businessId, requestParameters.queueId, requestParameters.callQueueContactInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Distribute Contacts To Call Queues
         * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueDistributeContactsToCallQueuesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueDistributeContactsToCallQueues(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueDistributeContactsToCallQueuesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.telephonyViewsNinjaCallCallQueueDistributeContactsToCallQueues(requestParameters.businessId, requestParameters.callQueueContactDistributionInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Agent Call Queue Items
         * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueueItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueListAgentCallQueueItems(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueueItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedCallQueueContactOutSchema> {
            return localVarFp.telephonyViewsNinjaCallCallQueueListAgentCallQueueItems(requestParameters.businessId, requestParameters.userId, requestParameters.queueId, requestParameters.name, requestParameters.createdBy, requestParameters.assigned, requestParameters.business, requestParameters.campaignId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Agent Call Queues
         * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueuesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueListAgentCallQueues(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueuesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CallQueueOutSchema>> {
            return localVarFp.telephonyViewsNinjaCallCallQueueListAgentCallQueues(requestParameters.businessId, requestParameters.userId, requestParameters.name, requestParameters.createdBy, requestParameters.assigned, requestParameters.business, requestParameters.campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Call Queue Items
         * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueueItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueListCallQueueItems(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueueItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedCallQueueContactOutSchema> {
            return localVarFp.telephonyViewsNinjaCallCallQueueListCallQueueItems(requestParameters.businessId, requestParameters.queueId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Call Queues
         * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueuesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueListCallQueues(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueuesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedCallQueueOutSchema> {
            return localVarFp.telephonyViewsNinjaCallCallQueueListCallQueues(requestParameters.businessId, requestParameters.name, requestParameters.createdBy, requestParameters.assigned, requestParameters.business, requestParameters.campaignId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reorder Call Queue Item
         * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueReorderCallQueueItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueReorderCallQueueItem(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueReorderCallQueueItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.telephonyViewsNinjaCallCallQueueReorderCallQueueItem(requestParameters.businessId, requestParameters.queueId, requestParameters.queueReorderSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve Agent Call Queue
         * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueRetrieveAgentCallQueueRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueRetrieveAgentCallQueue(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueRetrieveAgentCallQueueRequest, options?: RawAxiosRequestConfig): AxiosPromise<CallQueueOutSchema> {
            return localVarFp.telephonyViewsNinjaCallCallQueueRetrieveAgentCallQueue(requestParameters.businessId, requestParameters.userId, requestParameters.queueId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve Call Queue
         * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueRetrieveCallQueueRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueRetrieveCallQueue(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueRetrieveCallQueueRequest, options?: RawAxiosRequestConfig): AxiosPromise<CallQueueOutSchema> {
            return localVarFp.telephonyViewsNinjaCallCallQueueRetrieveCallQueue(requestParameters.businessId, requestParameters.queueId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Call Queue
         * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueUpdateCallQueueRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallQueueUpdateCallQueue(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueUpdateCallQueueRequest, options?: RawAxiosRequestConfig): AxiosPromise<CallQueueOutSchema> {
            return localVarFp.telephonyViewsNinjaCallCallQueueUpdateCallQueue(requestParameters.businessId, requestParameters.queueId, requestParameters.updateQueueSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for telephonyViewsNinjaCallCallQueueAddContactsToCallQueue operation in CallQueueApi.
 * @export
 * @interface CallQueueApiTelephonyViewsNinjaCallCallQueueAddContactsToCallQueueRequest
 */
export interface CallQueueApiTelephonyViewsNinjaCallCallQueueAddContactsToCallQueueRequest {
    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueAddContactsToCallQueue
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueAddContactsToCallQueue
     */
    readonly queueId: number

    /**
     * 
     * @type {CallQueueContactInSchema}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueAddContactsToCallQueue
     */
    readonly callQueueContactInSchema: CallQueueContactInSchema
}

/**
 * Request parameters for telephonyViewsNinjaCallCallQueueAgentReorderCallQueueItem operation in CallQueueApi.
 * @export
 * @interface CallQueueApiTelephonyViewsNinjaCallCallQueueAgentReorderCallQueueItemRequest
 */
export interface CallQueueApiTelephonyViewsNinjaCallCallQueueAgentReorderCallQueueItemRequest {
    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueAgentReorderCallQueueItem
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueAgentReorderCallQueueItem
     */
    readonly queueId: number

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueAgentReorderCallQueueItem
     */
    readonly userId: number

    /**
     * 
     * @type {QueueReorderSchema}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueAgentReorderCallQueueItem
     */
    readonly queueReorderSchema: QueueReorderSchema
}

/**
 * Request parameters for telephonyViewsNinjaCallCallQueueCreateCallQueue operation in CallQueueApi.
 * @export
 * @interface CallQueueApiTelephonyViewsNinjaCallCallQueueCreateCallQueueRequest
 */
export interface CallQueueApiTelephonyViewsNinjaCallCallQueueCreateCallQueueRequest {
    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueCreateCallQueue
     */
    readonly businessId: number

    /**
     * 
     * @type {CallQueueInSchema}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueCreateCallQueue
     */
    readonly callQueueInSchema: CallQueueInSchema
}

/**
 * Request parameters for telephonyViewsNinjaCallCallQueueDeleteAgentCallQueueContacts operation in CallQueueApi.
 * @export
 * @interface CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteAgentCallQueueContactsRequest
 */
export interface CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteAgentCallQueueContactsRequest {
    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteAgentCallQueueContacts
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteAgentCallQueueContacts
     */
    readonly queueId: number

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteAgentCallQueueContacts
     */
    readonly userId: number

    /**
     * 
     * @type {CallQueueContactInSchema}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteAgentCallQueueContacts
     */
    readonly callQueueContactInSchema: CallQueueContactInSchema
}

/**
 * Request parameters for telephonyViewsNinjaCallCallQueueDeleteCallQueue operation in CallQueueApi.
 * @export
 * @interface CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteCallQueueRequest
 */
export interface CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteCallQueueRequest {
    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteCallQueue
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteCallQueue
     */
    readonly queueId: number
}

/**
 * Request parameters for telephonyViewsNinjaCallCallQueueDeleteCallQueueContacts operation in CallQueueApi.
 * @export
 * @interface CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteCallQueueContactsRequest
 */
export interface CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteCallQueueContactsRequest {
    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteCallQueueContacts
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteCallQueueContacts
     */
    readonly queueId: number

    /**
     * 
     * @type {CallQueueContactInSchema}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteCallQueueContacts
     */
    readonly callQueueContactInSchema: CallQueueContactInSchema
}

/**
 * Request parameters for telephonyViewsNinjaCallCallQueueDistributeContactsToCallQueues operation in CallQueueApi.
 * @export
 * @interface CallQueueApiTelephonyViewsNinjaCallCallQueueDistributeContactsToCallQueuesRequest
 */
export interface CallQueueApiTelephonyViewsNinjaCallCallQueueDistributeContactsToCallQueuesRequest {
    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueDistributeContactsToCallQueues
     */
    readonly businessId: number

    /**
     * 
     * @type {CallQueueContactDistributionInSchema}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueDistributeContactsToCallQueues
     */
    readonly callQueueContactDistributionInSchema: CallQueueContactDistributionInSchema
}

/**
 * Request parameters for telephonyViewsNinjaCallCallQueueListAgentCallQueueItems operation in CallQueueApi.
 * @export
 * @interface CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueueItemsRequest
 */
export interface CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueueItemsRequest {
    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueueItems
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueueItems
     */
    readonly userId: number

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueueItems
     */
    readonly queueId: number

    /**
     * 
     * @type {string}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueueItems
     */
    readonly name?: string | null

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueueItems
     */
    readonly createdBy?: number | null

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueueItems
     */
    readonly assigned?: number | null

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueueItems
     */
    readonly business?: number | null

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueueItems
     */
    readonly campaignId?: number | null

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueueItems
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueueItems
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueueItems
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for telephonyViewsNinjaCallCallQueueListAgentCallQueues operation in CallQueueApi.
 * @export
 * @interface CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueuesRequest
 */
export interface CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueuesRequest {
    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueues
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueues
     */
    readonly userId: number

    /**
     * 
     * @type {string}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueues
     */
    readonly name?: string | null

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueues
     */
    readonly createdBy?: number | null

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueues
     */
    readonly assigned?: number | null

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueues
     */
    readonly business?: number | null

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueues
     */
    readonly campaignId?: number | null
}

/**
 * Request parameters for telephonyViewsNinjaCallCallQueueListCallQueueItems operation in CallQueueApi.
 * @export
 * @interface CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueueItemsRequest
 */
export interface CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueueItemsRequest {
    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueueItems
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueueItems
     */
    readonly queueId: number

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueueItems
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueueItems
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueueItems
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for telephonyViewsNinjaCallCallQueueListCallQueues operation in CallQueueApi.
 * @export
 * @interface CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueuesRequest
 */
export interface CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueuesRequest {
    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueues
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueues
     */
    readonly name?: string | null

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueues
     */
    readonly createdBy?: number | null

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueues
     */
    readonly assigned?: number | null

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueues
     */
    readonly business?: number | null

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueues
     */
    readonly campaignId?: number | null

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueues
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueues
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueues
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for telephonyViewsNinjaCallCallQueueReorderCallQueueItem operation in CallQueueApi.
 * @export
 * @interface CallQueueApiTelephonyViewsNinjaCallCallQueueReorderCallQueueItemRequest
 */
export interface CallQueueApiTelephonyViewsNinjaCallCallQueueReorderCallQueueItemRequest {
    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueReorderCallQueueItem
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueReorderCallQueueItem
     */
    readonly queueId: number

    /**
     * 
     * @type {QueueReorderSchema}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueReorderCallQueueItem
     */
    readonly queueReorderSchema: QueueReorderSchema
}

/**
 * Request parameters for telephonyViewsNinjaCallCallQueueRetrieveAgentCallQueue operation in CallQueueApi.
 * @export
 * @interface CallQueueApiTelephonyViewsNinjaCallCallQueueRetrieveAgentCallQueueRequest
 */
export interface CallQueueApiTelephonyViewsNinjaCallCallQueueRetrieveAgentCallQueueRequest {
    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueRetrieveAgentCallQueue
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueRetrieveAgentCallQueue
     */
    readonly userId: number

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueRetrieveAgentCallQueue
     */
    readonly queueId: number
}

/**
 * Request parameters for telephonyViewsNinjaCallCallQueueRetrieveCallQueue operation in CallQueueApi.
 * @export
 * @interface CallQueueApiTelephonyViewsNinjaCallCallQueueRetrieveCallQueueRequest
 */
export interface CallQueueApiTelephonyViewsNinjaCallCallQueueRetrieveCallQueueRequest {
    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueRetrieveCallQueue
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueRetrieveCallQueue
     */
    readonly queueId: number
}

/**
 * Request parameters for telephonyViewsNinjaCallCallQueueUpdateCallQueue operation in CallQueueApi.
 * @export
 * @interface CallQueueApiTelephonyViewsNinjaCallCallQueueUpdateCallQueueRequest
 */
export interface CallQueueApiTelephonyViewsNinjaCallCallQueueUpdateCallQueueRequest {
    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueUpdateCallQueue
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueUpdateCallQueue
     */
    readonly queueId: number

    /**
     * 
     * @type {UpdateQueueSchema}
     * @memberof CallQueueApiTelephonyViewsNinjaCallCallQueueUpdateCallQueue
     */
    readonly updateQueueSchema: UpdateQueueSchema
}

/**
 * CallQueueApi - object-oriented interface
 * @export
 * @class CallQueueApi
 * @extends {BaseAPI}
 */
export class CallQueueApi extends BaseAPI {
    /**
     * 
     * @summary Add Contacts To Call Queue
     * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueAddContactsToCallQueueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallQueueApi
     */
    public telephonyViewsNinjaCallCallQueueAddContactsToCallQueue(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueAddContactsToCallQueueRequest, options?: RawAxiosRequestConfig) {
        return CallQueueApiFp(this.configuration).telephonyViewsNinjaCallCallQueueAddContactsToCallQueue(requestParameters.businessId, requestParameters.queueId, requestParameters.callQueueContactInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Agent Reorder Call Queue Item
     * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueAgentReorderCallQueueItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallQueueApi
     */
    public telephonyViewsNinjaCallCallQueueAgentReorderCallQueueItem(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueAgentReorderCallQueueItemRequest, options?: RawAxiosRequestConfig) {
        return CallQueueApiFp(this.configuration).telephonyViewsNinjaCallCallQueueAgentReorderCallQueueItem(requestParameters.businessId, requestParameters.queueId, requestParameters.userId, requestParameters.queueReorderSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Call Queue
     * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueCreateCallQueueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallQueueApi
     */
    public telephonyViewsNinjaCallCallQueueCreateCallQueue(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueCreateCallQueueRequest, options?: RawAxiosRequestConfig) {
        return CallQueueApiFp(this.configuration).telephonyViewsNinjaCallCallQueueCreateCallQueue(requestParameters.businessId, requestParameters.callQueueInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Agent Call Queue Contacts
     * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteAgentCallQueueContactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallQueueApi
     */
    public telephonyViewsNinjaCallCallQueueDeleteAgentCallQueueContacts(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteAgentCallQueueContactsRequest, options?: RawAxiosRequestConfig) {
        return CallQueueApiFp(this.configuration).telephonyViewsNinjaCallCallQueueDeleteAgentCallQueueContacts(requestParameters.businessId, requestParameters.queueId, requestParameters.userId, requestParameters.callQueueContactInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Call Queue
     * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteCallQueueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallQueueApi
     */
    public telephonyViewsNinjaCallCallQueueDeleteCallQueue(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteCallQueueRequest, options?: RawAxiosRequestConfig) {
        return CallQueueApiFp(this.configuration).telephonyViewsNinjaCallCallQueueDeleteCallQueue(requestParameters.businessId, requestParameters.queueId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Call Queue Contacts
     * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteCallQueueContactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallQueueApi
     */
    public telephonyViewsNinjaCallCallQueueDeleteCallQueueContacts(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueDeleteCallQueueContactsRequest, options?: RawAxiosRequestConfig) {
        return CallQueueApiFp(this.configuration).telephonyViewsNinjaCallCallQueueDeleteCallQueueContacts(requestParameters.businessId, requestParameters.queueId, requestParameters.callQueueContactInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Distribute Contacts To Call Queues
     * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueDistributeContactsToCallQueuesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallQueueApi
     */
    public telephonyViewsNinjaCallCallQueueDistributeContactsToCallQueues(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueDistributeContactsToCallQueuesRequest, options?: RawAxiosRequestConfig) {
        return CallQueueApiFp(this.configuration).telephonyViewsNinjaCallCallQueueDistributeContactsToCallQueues(requestParameters.businessId, requestParameters.callQueueContactDistributionInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Agent Call Queue Items
     * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueueItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallQueueApi
     */
    public telephonyViewsNinjaCallCallQueueListAgentCallQueueItems(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueueItemsRequest, options?: RawAxiosRequestConfig) {
        return CallQueueApiFp(this.configuration).telephonyViewsNinjaCallCallQueueListAgentCallQueueItems(requestParameters.businessId, requestParameters.userId, requestParameters.queueId, requestParameters.name, requestParameters.createdBy, requestParameters.assigned, requestParameters.business, requestParameters.campaignId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Agent Call Queues
     * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueuesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallQueueApi
     */
    public telephonyViewsNinjaCallCallQueueListAgentCallQueues(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueListAgentCallQueuesRequest, options?: RawAxiosRequestConfig) {
        return CallQueueApiFp(this.configuration).telephonyViewsNinjaCallCallQueueListAgentCallQueues(requestParameters.businessId, requestParameters.userId, requestParameters.name, requestParameters.createdBy, requestParameters.assigned, requestParameters.business, requestParameters.campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Call Queue Items
     * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueueItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallQueueApi
     */
    public telephonyViewsNinjaCallCallQueueListCallQueueItems(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueueItemsRequest, options?: RawAxiosRequestConfig) {
        return CallQueueApiFp(this.configuration).telephonyViewsNinjaCallCallQueueListCallQueueItems(requestParameters.businessId, requestParameters.queueId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Call Queues
     * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueuesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallQueueApi
     */
    public telephonyViewsNinjaCallCallQueueListCallQueues(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueListCallQueuesRequest, options?: RawAxiosRequestConfig) {
        return CallQueueApiFp(this.configuration).telephonyViewsNinjaCallCallQueueListCallQueues(requestParameters.businessId, requestParameters.name, requestParameters.createdBy, requestParameters.assigned, requestParameters.business, requestParameters.campaignId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reorder Call Queue Item
     * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueReorderCallQueueItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallQueueApi
     */
    public telephonyViewsNinjaCallCallQueueReorderCallQueueItem(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueReorderCallQueueItemRequest, options?: RawAxiosRequestConfig) {
        return CallQueueApiFp(this.configuration).telephonyViewsNinjaCallCallQueueReorderCallQueueItem(requestParameters.businessId, requestParameters.queueId, requestParameters.queueReorderSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve Agent Call Queue
     * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueRetrieveAgentCallQueueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallQueueApi
     */
    public telephonyViewsNinjaCallCallQueueRetrieveAgentCallQueue(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueRetrieveAgentCallQueueRequest, options?: RawAxiosRequestConfig) {
        return CallQueueApiFp(this.configuration).telephonyViewsNinjaCallCallQueueRetrieveAgentCallQueue(requestParameters.businessId, requestParameters.userId, requestParameters.queueId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve Call Queue
     * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueRetrieveCallQueueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallQueueApi
     */
    public telephonyViewsNinjaCallCallQueueRetrieveCallQueue(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueRetrieveCallQueueRequest, options?: RawAxiosRequestConfig) {
        return CallQueueApiFp(this.configuration).telephonyViewsNinjaCallCallQueueRetrieveCallQueue(requestParameters.businessId, requestParameters.queueId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Call Queue
     * @param {CallQueueApiTelephonyViewsNinjaCallCallQueueUpdateCallQueueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallQueueApi
     */
    public telephonyViewsNinjaCallCallQueueUpdateCallQueue(requestParameters: CallQueueApiTelephonyViewsNinjaCallCallQueueUpdateCallQueueRequest, options?: RawAxiosRequestConfig) {
        return CallQueueApiFp(this.configuration).telephonyViewsNinjaCallCallQueueUpdateCallQueue(requestParameters.businessId, requestParameters.queueId, requestParameters.updateQueueSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CallScriptsApi - axios parameter creator
 * @export
 */
export const CallScriptsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add Items To Call Script
         * @param {number} businessId 
         * @param {number} callScriptId 
         * @param {Array<AddScriptItemSchema>} addScriptItemSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallScriptsAddItemsToCallScript: async (businessId: number, callScriptId: number, addScriptItemSchema: Array<AddScriptItemSchema>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsAddItemsToCallScript', 'businessId', businessId)
            // verify required parameter 'callScriptId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsAddItemsToCallScript', 'callScriptId', callScriptId)
            // verify required parameter 'addScriptItemSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsAddItemsToCallScript', 'addScriptItemSchema', addScriptItemSchema)
            const localVarPath = `/api/business/{business_id}/call-scripts/{call_script_id}/add-items/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"call_script_id"}}`, encodeURIComponent(String(callScriptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addScriptItemSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Call Script
         * @param {number} businessId 
         * @param {CallScriptInSchema} callScriptInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallScriptsCreateCallScript: async (businessId: number, callScriptInSchema: CallScriptInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsCreateCallScript', 'businessId', businessId)
            // verify required parameter 'callScriptInSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsCreateCallScript', 'callScriptInSchema', callScriptInSchema)
            const localVarPath = `/api/business/{business_id}/call-scripts/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(callScriptInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Script Item
         * @param {number} businessId 
         * @param {number} callScriptId 
         * @param {CallScriptItemInSchema} callScriptItemInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallScriptsCreateScriptItem: async (businessId: number, callScriptId: number, callScriptItemInSchema: CallScriptItemInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsCreateScriptItem', 'businessId', businessId)
            // verify required parameter 'callScriptId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsCreateScriptItem', 'callScriptId', callScriptId)
            // verify required parameter 'callScriptItemInSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsCreateScriptItem', 'callScriptItemInSchema', callScriptItemInSchema)
            const localVarPath = `/api/business/{business_id}/call-scripts/{call_script_id}/items/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"call_script_id"}}`, encodeURIComponent(String(callScriptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(callScriptItemInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Call Script
         * @param {number} businessId 
         * @param {number} callScriptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallScriptsDeleteCallScript: async (businessId: number, callScriptId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsDeleteCallScript', 'businessId', businessId)
            // verify required parameter 'callScriptId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsDeleteCallScript', 'callScriptId', callScriptId)
            const localVarPath = `/api/business/{business_id}/call-scripts/{call_script_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"call_script_id"}}`, encodeURIComponent(String(callScriptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Call Script Items
         * @param {number} callScriptId 
         * @param {number} businessId 
         * @param {number} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallScriptsDeleteCallScriptItems: async (callScriptId: number, businessId: number, itemId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callScriptId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsDeleteCallScriptItems', 'callScriptId', callScriptId)
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsDeleteCallScriptItems', 'businessId', businessId)
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsDeleteCallScriptItems', 'itemId', itemId)
            const localVarPath = `/api/business/{business_id}/call-scripts/{call_script_id}/items/{item_id}/`
                .replace(`{${"call_script_id"}}`, encodeURIComponent(String(callScriptId)))
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"item_id"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Call Scripts
         * @param {number} businessId 
         * @param {string | null} [name] 
         * @param {string | null} [description] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallScriptsListCallScripts: async (businessId: number, name?: string | null, description?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsListCallScripts', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/call-scripts/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve Call Script
         * @param {number} businessId 
         * @param {number} callScriptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallScriptsRetrieveCallScript: async (businessId: number, callScriptId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsRetrieveCallScript', 'businessId', businessId)
            // verify required parameter 'callScriptId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsRetrieveCallScript', 'callScriptId', callScriptId)
            const localVarPath = `/api/business/{business_id}/call-scripts/{call_script_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"call_script_id"}}`, encodeURIComponent(String(callScriptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve Call Script Items
         * @param {number} businessId 
         * @param {number} callScriptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallScriptsRetrieveCallScriptItems: async (businessId: number, callScriptId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsRetrieveCallScriptItems', 'businessId', businessId)
            // verify required parameter 'callScriptId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsRetrieveCallScriptItems', 'callScriptId', callScriptId)
            const localVarPath = `/api/business/{business_id}/call-scripts/{call_script_id}/items/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"call_script_id"}}`, encodeURIComponent(String(callScriptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Call Script
         * @param {number} businessId 
         * @param {number} callScriptId 
         * @param {UpdateCallScriptSchema} updateCallScriptSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallScriptsUpdateCallScript: async (businessId: number, callScriptId: number, updateCallScriptSchema: UpdateCallScriptSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsUpdateCallScript', 'businessId', businessId)
            // verify required parameter 'callScriptId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsUpdateCallScript', 'callScriptId', callScriptId)
            // verify required parameter 'updateCallScriptSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsUpdateCallScript', 'updateCallScriptSchema', updateCallScriptSchema)
            const localVarPath = `/api/business/{business_id}/call-scripts/{call_script_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"call_script_id"}}`, encodeURIComponent(String(callScriptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCallScriptSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Script Item
         * @param {number} itemId 
         * @param {number} callScriptId 
         * @param {number} businessId 
         * @param {UpdateScriptItemSchema} updateScriptItemSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallScriptsUpdateScriptItem: async (itemId: number, callScriptId: number, businessId: number, updateScriptItemSchema: UpdateScriptItemSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsUpdateScriptItem', 'itemId', itemId)
            // verify required parameter 'callScriptId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsUpdateScriptItem', 'callScriptId', callScriptId)
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsUpdateScriptItem', 'businessId', businessId)
            // verify required parameter 'updateScriptItemSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCallScriptsUpdateScriptItem', 'updateScriptItemSchema', updateScriptItemSchema)
            const localVarPath = `/api/business/{business_id}/call-scripts/{call_script_id}/items/{item_id}/`
                .replace(`{${"item_id"}}`, encodeURIComponent(String(itemId)))
                .replace(`{${"call_script_id"}}`, encodeURIComponent(String(callScriptId)))
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateScriptItemSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallScriptsApi - functional programming interface
 * @export
 */
export const CallScriptsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CallScriptsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add Items To Call Script
         * @param {number} businessId 
         * @param {number} callScriptId 
         * @param {Array<AddScriptItemSchema>} addScriptItemSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallScriptsAddItemsToCallScript(businessId: number, callScriptId: number, addScriptItemSchema: Array<AddScriptItemSchema>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CallScriptItemOutSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallScriptsAddItemsToCallScript(businessId, callScriptId, addScriptItemSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallScriptsApi.telephonyViewsNinjaCallCallScriptsAddItemsToCallScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Call Script
         * @param {number} businessId 
         * @param {CallScriptInSchema} callScriptInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallScriptsCreateCallScript(businessId: number, callScriptInSchema: CallScriptInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallScriptOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallScriptsCreateCallScript(businessId, callScriptInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallScriptsApi.telephonyViewsNinjaCallCallScriptsCreateCallScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Script Item
         * @param {number} businessId 
         * @param {number} callScriptId 
         * @param {CallScriptItemInSchema} callScriptItemInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallScriptsCreateScriptItem(businessId: number, callScriptId: number, callScriptItemInSchema: CallScriptItemInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallScriptItemOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallScriptsCreateScriptItem(businessId, callScriptId, callScriptItemInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallScriptsApi.telephonyViewsNinjaCallCallScriptsCreateScriptItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Call Script
         * @param {number} businessId 
         * @param {number} callScriptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallScriptsDeleteCallScript(businessId: number, callScriptId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallScriptsDeleteCallScript(businessId, callScriptId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallScriptsApi.telephonyViewsNinjaCallCallScriptsDeleteCallScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Call Script Items
         * @param {number} callScriptId 
         * @param {number} businessId 
         * @param {number} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallScriptsDeleteCallScriptItems(callScriptId: number, businessId: number, itemId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallScriptsDeleteCallScriptItems(callScriptId, businessId, itemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallScriptsApi.telephonyViewsNinjaCallCallScriptsDeleteCallScriptItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Call Scripts
         * @param {number} businessId 
         * @param {string | null} [name] 
         * @param {string | null} [description] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallScriptsListCallScripts(businessId: number, name?: string | null, description?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedCallScriptOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallScriptsListCallScripts(businessId, name, description, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallScriptsApi.telephonyViewsNinjaCallCallScriptsListCallScripts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve Call Script
         * @param {number} businessId 
         * @param {number} callScriptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallScriptsRetrieveCallScript(businessId: number, callScriptId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallScriptOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallScriptsRetrieveCallScript(businessId, callScriptId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallScriptsApi.telephonyViewsNinjaCallCallScriptsRetrieveCallScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve Call Script Items
         * @param {number} businessId 
         * @param {number} callScriptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallScriptsRetrieveCallScriptItems(businessId: number, callScriptId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CallScriptItemOutSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallScriptsRetrieveCallScriptItems(businessId, callScriptId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallScriptsApi.telephonyViewsNinjaCallCallScriptsRetrieveCallScriptItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Call Script
         * @param {number} businessId 
         * @param {number} callScriptId 
         * @param {UpdateCallScriptSchema} updateCallScriptSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallScriptsUpdateCallScript(businessId: number, callScriptId: number, updateCallScriptSchema: UpdateCallScriptSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallScriptOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallScriptsUpdateCallScript(businessId, callScriptId, updateCallScriptSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallScriptsApi.telephonyViewsNinjaCallCallScriptsUpdateCallScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Script Item
         * @param {number} itemId 
         * @param {number} callScriptId 
         * @param {number} businessId 
         * @param {UpdateScriptItemSchema} updateScriptItemSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCallScriptsUpdateScriptItem(itemId: number, callScriptId: number, businessId: number, updateScriptItemSchema: UpdateScriptItemSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallScriptItemOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCallScriptsUpdateScriptItem(itemId, callScriptId, businessId, updateScriptItemSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallScriptsApi.telephonyViewsNinjaCallCallScriptsUpdateScriptItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CallScriptsApi - factory interface
 * @export
 */
export const CallScriptsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CallScriptsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add Items To Call Script
         * @param {CallScriptsApiTelephonyViewsNinjaCallCallScriptsAddItemsToCallScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallScriptsAddItemsToCallScript(requestParameters: CallScriptsApiTelephonyViewsNinjaCallCallScriptsAddItemsToCallScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CallScriptItemOutSchema>> {
            return localVarFp.telephonyViewsNinjaCallCallScriptsAddItemsToCallScript(requestParameters.businessId, requestParameters.callScriptId, requestParameters.addScriptItemSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Call Script
         * @param {CallScriptsApiTelephonyViewsNinjaCallCallScriptsCreateCallScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallScriptsCreateCallScript(requestParameters: CallScriptsApiTelephonyViewsNinjaCallCallScriptsCreateCallScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<CallScriptOutSchema> {
            return localVarFp.telephonyViewsNinjaCallCallScriptsCreateCallScript(requestParameters.businessId, requestParameters.callScriptInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Script Item
         * @param {CallScriptsApiTelephonyViewsNinjaCallCallScriptsCreateScriptItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallScriptsCreateScriptItem(requestParameters: CallScriptsApiTelephonyViewsNinjaCallCallScriptsCreateScriptItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<CallScriptItemOutSchema> {
            return localVarFp.telephonyViewsNinjaCallCallScriptsCreateScriptItem(requestParameters.businessId, requestParameters.callScriptId, requestParameters.callScriptItemInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Call Script
         * @param {CallScriptsApiTelephonyViewsNinjaCallCallScriptsDeleteCallScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallScriptsDeleteCallScript(requestParameters: CallScriptsApiTelephonyViewsNinjaCallCallScriptsDeleteCallScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.telephonyViewsNinjaCallCallScriptsDeleteCallScript(requestParameters.businessId, requestParameters.callScriptId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Call Script Items
         * @param {CallScriptsApiTelephonyViewsNinjaCallCallScriptsDeleteCallScriptItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallScriptsDeleteCallScriptItems(requestParameters: CallScriptsApiTelephonyViewsNinjaCallCallScriptsDeleteCallScriptItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.telephonyViewsNinjaCallCallScriptsDeleteCallScriptItems(requestParameters.callScriptId, requestParameters.businessId, requestParameters.itemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Call Scripts
         * @param {CallScriptsApiTelephonyViewsNinjaCallCallScriptsListCallScriptsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallScriptsListCallScripts(requestParameters: CallScriptsApiTelephonyViewsNinjaCallCallScriptsListCallScriptsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedCallScriptOutSchema> {
            return localVarFp.telephonyViewsNinjaCallCallScriptsListCallScripts(requestParameters.businessId, requestParameters.name, requestParameters.description, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve Call Script
         * @param {CallScriptsApiTelephonyViewsNinjaCallCallScriptsRetrieveCallScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallScriptsRetrieveCallScript(requestParameters: CallScriptsApiTelephonyViewsNinjaCallCallScriptsRetrieveCallScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<CallScriptOutSchema> {
            return localVarFp.telephonyViewsNinjaCallCallScriptsRetrieveCallScript(requestParameters.businessId, requestParameters.callScriptId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve Call Script Items
         * @param {CallScriptsApiTelephonyViewsNinjaCallCallScriptsRetrieveCallScriptItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallScriptsRetrieveCallScriptItems(requestParameters: CallScriptsApiTelephonyViewsNinjaCallCallScriptsRetrieveCallScriptItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CallScriptItemOutSchema>> {
            return localVarFp.telephonyViewsNinjaCallCallScriptsRetrieveCallScriptItems(requestParameters.businessId, requestParameters.callScriptId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Call Script
         * @param {CallScriptsApiTelephonyViewsNinjaCallCallScriptsUpdateCallScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallScriptsUpdateCallScript(requestParameters: CallScriptsApiTelephonyViewsNinjaCallCallScriptsUpdateCallScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<CallScriptOutSchema> {
            return localVarFp.telephonyViewsNinjaCallCallScriptsUpdateCallScript(requestParameters.businessId, requestParameters.callScriptId, requestParameters.updateCallScriptSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Script Item
         * @param {CallScriptsApiTelephonyViewsNinjaCallCallScriptsUpdateScriptItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCallScriptsUpdateScriptItem(requestParameters: CallScriptsApiTelephonyViewsNinjaCallCallScriptsUpdateScriptItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<CallScriptItemOutSchema> {
            return localVarFp.telephonyViewsNinjaCallCallScriptsUpdateScriptItem(requestParameters.itemId, requestParameters.callScriptId, requestParameters.businessId, requestParameters.updateScriptItemSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for telephonyViewsNinjaCallCallScriptsAddItemsToCallScript operation in CallScriptsApi.
 * @export
 * @interface CallScriptsApiTelephonyViewsNinjaCallCallScriptsAddItemsToCallScriptRequest
 */
export interface CallScriptsApiTelephonyViewsNinjaCallCallScriptsAddItemsToCallScriptRequest {
    /**
     * 
     * @type {number}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsAddItemsToCallScript
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsAddItemsToCallScript
     */
    readonly callScriptId: number

    /**
     * 
     * @type {Array<AddScriptItemSchema>}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsAddItemsToCallScript
     */
    readonly addScriptItemSchema: Array<AddScriptItemSchema>
}

/**
 * Request parameters for telephonyViewsNinjaCallCallScriptsCreateCallScript operation in CallScriptsApi.
 * @export
 * @interface CallScriptsApiTelephonyViewsNinjaCallCallScriptsCreateCallScriptRequest
 */
export interface CallScriptsApiTelephonyViewsNinjaCallCallScriptsCreateCallScriptRequest {
    /**
     * 
     * @type {number}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsCreateCallScript
     */
    readonly businessId: number

    /**
     * 
     * @type {CallScriptInSchema}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsCreateCallScript
     */
    readonly callScriptInSchema: CallScriptInSchema
}

/**
 * Request parameters for telephonyViewsNinjaCallCallScriptsCreateScriptItem operation in CallScriptsApi.
 * @export
 * @interface CallScriptsApiTelephonyViewsNinjaCallCallScriptsCreateScriptItemRequest
 */
export interface CallScriptsApiTelephonyViewsNinjaCallCallScriptsCreateScriptItemRequest {
    /**
     * 
     * @type {number}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsCreateScriptItem
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsCreateScriptItem
     */
    readonly callScriptId: number

    /**
     * 
     * @type {CallScriptItemInSchema}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsCreateScriptItem
     */
    readonly callScriptItemInSchema: CallScriptItemInSchema
}

/**
 * Request parameters for telephonyViewsNinjaCallCallScriptsDeleteCallScript operation in CallScriptsApi.
 * @export
 * @interface CallScriptsApiTelephonyViewsNinjaCallCallScriptsDeleteCallScriptRequest
 */
export interface CallScriptsApiTelephonyViewsNinjaCallCallScriptsDeleteCallScriptRequest {
    /**
     * 
     * @type {number}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsDeleteCallScript
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsDeleteCallScript
     */
    readonly callScriptId: number
}

/**
 * Request parameters for telephonyViewsNinjaCallCallScriptsDeleteCallScriptItems operation in CallScriptsApi.
 * @export
 * @interface CallScriptsApiTelephonyViewsNinjaCallCallScriptsDeleteCallScriptItemsRequest
 */
export interface CallScriptsApiTelephonyViewsNinjaCallCallScriptsDeleteCallScriptItemsRequest {
    /**
     * 
     * @type {number}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsDeleteCallScriptItems
     */
    readonly callScriptId: number

    /**
     * 
     * @type {number}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsDeleteCallScriptItems
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsDeleteCallScriptItems
     */
    readonly itemId: number
}

/**
 * Request parameters for telephonyViewsNinjaCallCallScriptsListCallScripts operation in CallScriptsApi.
 * @export
 * @interface CallScriptsApiTelephonyViewsNinjaCallCallScriptsListCallScriptsRequest
 */
export interface CallScriptsApiTelephonyViewsNinjaCallCallScriptsListCallScriptsRequest {
    /**
     * 
     * @type {number}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsListCallScripts
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsListCallScripts
     */
    readonly name?: string | null

    /**
     * 
     * @type {string}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsListCallScripts
     */
    readonly description?: string | null

    /**
     * 
     * @type {number}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsListCallScripts
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsListCallScripts
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsListCallScripts
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for telephonyViewsNinjaCallCallScriptsRetrieveCallScript operation in CallScriptsApi.
 * @export
 * @interface CallScriptsApiTelephonyViewsNinjaCallCallScriptsRetrieveCallScriptRequest
 */
export interface CallScriptsApiTelephonyViewsNinjaCallCallScriptsRetrieveCallScriptRequest {
    /**
     * 
     * @type {number}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsRetrieveCallScript
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsRetrieveCallScript
     */
    readonly callScriptId: number
}

/**
 * Request parameters for telephonyViewsNinjaCallCallScriptsRetrieveCallScriptItems operation in CallScriptsApi.
 * @export
 * @interface CallScriptsApiTelephonyViewsNinjaCallCallScriptsRetrieveCallScriptItemsRequest
 */
export interface CallScriptsApiTelephonyViewsNinjaCallCallScriptsRetrieveCallScriptItemsRequest {
    /**
     * 
     * @type {number}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsRetrieveCallScriptItems
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsRetrieveCallScriptItems
     */
    readonly callScriptId: number
}

/**
 * Request parameters for telephonyViewsNinjaCallCallScriptsUpdateCallScript operation in CallScriptsApi.
 * @export
 * @interface CallScriptsApiTelephonyViewsNinjaCallCallScriptsUpdateCallScriptRequest
 */
export interface CallScriptsApiTelephonyViewsNinjaCallCallScriptsUpdateCallScriptRequest {
    /**
     * 
     * @type {number}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsUpdateCallScript
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsUpdateCallScript
     */
    readonly callScriptId: number

    /**
     * 
     * @type {UpdateCallScriptSchema}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsUpdateCallScript
     */
    readonly updateCallScriptSchema: UpdateCallScriptSchema
}

/**
 * Request parameters for telephonyViewsNinjaCallCallScriptsUpdateScriptItem operation in CallScriptsApi.
 * @export
 * @interface CallScriptsApiTelephonyViewsNinjaCallCallScriptsUpdateScriptItemRequest
 */
export interface CallScriptsApiTelephonyViewsNinjaCallCallScriptsUpdateScriptItemRequest {
    /**
     * 
     * @type {number}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsUpdateScriptItem
     */
    readonly itemId: number

    /**
     * 
     * @type {number}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsUpdateScriptItem
     */
    readonly callScriptId: number

    /**
     * 
     * @type {number}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsUpdateScriptItem
     */
    readonly businessId: number

    /**
     * 
     * @type {UpdateScriptItemSchema}
     * @memberof CallScriptsApiTelephonyViewsNinjaCallCallScriptsUpdateScriptItem
     */
    readonly updateScriptItemSchema: UpdateScriptItemSchema
}

/**
 * CallScriptsApi - object-oriented interface
 * @export
 * @class CallScriptsApi
 * @extends {BaseAPI}
 */
export class CallScriptsApi extends BaseAPI {
    /**
     * 
     * @summary Add Items To Call Script
     * @param {CallScriptsApiTelephonyViewsNinjaCallCallScriptsAddItemsToCallScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallScriptsApi
     */
    public telephonyViewsNinjaCallCallScriptsAddItemsToCallScript(requestParameters: CallScriptsApiTelephonyViewsNinjaCallCallScriptsAddItemsToCallScriptRequest, options?: RawAxiosRequestConfig) {
        return CallScriptsApiFp(this.configuration).telephonyViewsNinjaCallCallScriptsAddItemsToCallScript(requestParameters.businessId, requestParameters.callScriptId, requestParameters.addScriptItemSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Call Script
     * @param {CallScriptsApiTelephonyViewsNinjaCallCallScriptsCreateCallScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallScriptsApi
     */
    public telephonyViewsNinjaCallCallScriptsCreateCallScript(requestParameters: CallScriptsApiTelephonyViewsNinjaCallCallScriptsCreateCallScriptRequest, options?: RawAxiosRequestConfig) {
        return CallScriptsApiFp(this.configuration).telephonyViewsNinjaCallCallScriptsCreateCallScript(requestParameters.businessId, requestParameters.callScriptInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Script Item
     * @param {CallScriptsApiTelephonyViewsNinjaCallCallScriptsCreateScriptItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallScriptsApi
     */
    public telephonyViewsNinjaCallCallScriptsCreateScriptItem(requestParameters: CallScriptsApiTelephonyViewsNinjaCallCallScriptsCreateScriptItemRequest, options?: RawAxiosRequestConfig) {
        return CallScriptsApiFp(this.configuration).telephonyViewsNinjaCallCallScriptsCreateScriptItem(requestParameters.businessId, requestParameters.callScriptId, requestParameters.callScriptItemInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Call Script
     * @param {CallScriptsApiTelephonyViewsNinjaCallCallScriptsDeleteCallScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallScriptsApi
     */
    public telephonyViewsNinjaCallCallScriptsDeleteCallScript(requestParameters: CallScriptsApiTelephonyViewsNinjaCallCallScriptsDeleteCallScriptRequest, options?: RawAxiosRequestConfig) {
        return CallScriptsApiFp(this.configuration).telephonyViewsNinjaCallCallScriptsDeleteCallScript(requestParameters.businessId, requestParameters.callScriptId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Call Script Items
     * @param {CallScriptsApiTelephonyViewsNinjaCallCallScriptsDeleteCallScriptItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallScriptsApi
     */
    public telephonyViewsNinjaCallCallScriptsDeleteCallScriptItems(requestParameters: CallScriptsApiTelephonyViewsNinjaCallCallScriptsDeleteCallScriptItemsRequest, options?: RawAxiosRequestConfig) {
        return CallScriptsApiFp(this.configuration).telephonyViewsNinjaCallCallScriptsDeleteCallScriptItems(requestParameters.callScriptId, requestParameters.businessId, requestParameters.itemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Call Scripts
     * @param {CallScriptsApiTelephonyViewsNinjaCallCallScriptsListCallScriptsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallScriptsApi
     */
    public telephonyViewsNinjaCallCallScriptsListCallScripts(requestParameters: CallScriptsApiTelephonyViewsNinjaCallCallScriptsListCallScriptsRequest, options?: RawAxiosRequestConfig) {
        return CallScriptsApiFp(this.configuration).telephonyViewsNinjaCallCallScriptsListCallScripts(requestParameters.businessId, requestParameters.name, requestParameters.description, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve Call Script
     * @param {CallScriptsApiTelephonyViewsNinjaCallCallScriptsRetrieveCallScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallScriptsApi
     */
    public telephonyViewsNinjaCallCallScriptsRetrieveCallScript(requestParameters: CallScriptsApiTelephonyViewsNinjaCallCallScriptsRetrieveCallScriptRequest, options?: RawAxiosRequestConfig) {
        return CallScriptsApiFp(this.configuration).telephonyViewsNinjaCallCallScriptsRetrieveCallScript(requestParameters.businessId, requestParameters.callScriptId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve Call Script Items
     * @param {CallScriptsApiTelephonyViewsNinjaCallCallScriptsRetrieveCallScriptItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallScriptsApi
     */
    public telephonyViewsNinjaCallCallScriptsRetrieveCallScriptItems(requestParameters: CallScriptsApiTelephonyViewsNinjaCallCallScriptsRetrieveCallScriptItemsRequest, options?: RawAxiosRequestConfig) {
        return CallScriptsApiFp(this.configuration).telephonyViewsNinjaCallCallScriptsRetrieveCallScriptItems(requestParameters.businessId, requestParameters.callScriptId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Call Script
     * @param {CallScriptsApiTelephonyViewsNinjaCallCallScriptsUpdateCallScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallScriptsApi
     */
    public telephonyViewsNinjaCallCallScriptsUpdateCallScript(requestParameters: CallScriptsApiTelephonyViewsNinjaCallCallScriptsUpdateCallScriptRequest, options?: RawAxiosRequestConfig) {
        return CallScriptsApiFp(this.configuration).telephonyViewsNinjaCallCallScriptsUpdateCallScript(requestParameters.businessId, requestParameters.callScriptId, requestParameters.updateCallScriptSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Script Item
     * @param {CallScriptsApiTelephonyViewsNinjaCallCallScriptsUpdateScriptItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallScriptsApi
     */
    public telephonyViewsNinjaCallCallScriptsUpdateScriptItem(requestParameters: CallScriptsApiTelephonyViewsNinjaCallCallScriptsUpdateScriptItemRequest, options?: RawAxiosRequestConfig) {
        return CallScriptsApiFp(this.configuration).telephonyViewsNinjaCallCallScriptsUpdateScriptItem(requestParameters.itemId, requestParameters.callScriptId, requestParameters.businessId, requestParameters.updateScriptItemSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CallbackApi - axios parameter creator
 * @export
 */
export const CallbackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Record Lead Callback
         * @param {LeadCustomerioInSchemaV2} leadCustomerioInSchemaV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaCallbacksRecordLeadCallback: async (leadCustomerioInSchemaV2: LeadCustomerioInSchemaV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leadCustomerioInSchemaV2' is not null or undefined
            assertParamExists('usersViewsNinjaCallbacksRecordLeadCallback', 'leadCustomerioInSchemaV2', leadCustomerioInSchemaV2)
            const localVarPath = `/api/callback/leads/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(leadCustomerioInSchemaV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Record Leads Callback
         * @param {LeadInSchema} leadInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaCallbacksRecordLeadsCallback: async (leadInSchema: LeadInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leadInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaCallbacksRecordLeadsCallback', 'leadInSchema', leadInSchema)
            const localVarPath = `/api/callback/zoho-actions-webhook/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ZohoWebhookAPIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "Pressone-X-Zoho-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(leadInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallbackApi - functional programming interface
 * @export
 */
export const CallbackApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CallbackApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Record Lead Callback
         * @param {LeadCustomerioInSchemaV2} leadCustomerioInSchemaV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaCallbacksRecordLeadCallback(leadCustomerioInSchemaV2: LeadCustomerioInSchemaV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaCallbacksRecordLeadCallback(leadCustomerioInSchemaV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallbackApi.usersViewsNinjaCallbacksRecordLeadCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Record Leads Callback
         * @param {LeadInSchema} leadInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaCallbacksRecordLeadsCallback(leadInSchema: LeadInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaCallbacksRecordLeadsCallback(leadInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CallbackApi.usersViewsNinjaCallbacksRecordLeadsCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CallbackApi - factory interface
 * @export
 */
export const CallbackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CallbackApiFp(configuration)
    return {
        /**
         * 
         * @summary Record Lead Callback
         * @param {CallbackApiUsersViewsNinjaCallbacksRecordLeadCallbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaCallbacksRecordLeadCallback(requestParameters: CallbackApiUsersViewsNinjaCallbacksRecordLeadCallbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaCallbacksRecordLeadCallback(requestParameters.leadCustomerioInSchemaV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Record Leads Callback
         * @param {CallbackApiUsersViewsNinjaCallbacksRecordLeadsCallbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaCallbacksRecordLeadsCallback(requestParameters: CallbackApiUsersViewsNinjaCallbacksRecordLeadsCallbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaCallbacksRecordLeadsCallback(requestParameters.leadInSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for usersViewsNinjaCallbacksRecordLeadCallback operation in CallbackApi.
 * @export
 * @interface CallbackApiUsersViewsNinjaCallbacksRecordLeadCallbackRequest
 */
export interface CallbackApiUsersViewsNinjaCallbacksRecordLeadCallbackRequest {
    /**
     * 
     * @type {LeadCustomerioInSchemaV2}
     * @memberof CallbackApiUsersViewsNinjaCallbacksRecordLeadCallback
     */
    readonly leadCustomerioInSchemaV2: LeadCustomerioInSchemaV2
}

/**
 * Request parameters for usersViewsNinjaCallbacksRecordLeadsCallback operation in CallbackApi.
 * @export
 * @interface CallbackApiUsersViewsNinjaCallbacksRecordLeadsCallbackRequest
 */
export interface CallbackApiUsersViewsNinjaCallbacksRecordLeadsCallbackRequest {
    /**
     * 
     * @type {LeadInSchema}
     * @memberof CallbackApiUsersViewsNinjaCallbacksRecordLeadsCallback
     */
    readonly leadInSchema: LeadInSchema
}

/**
 * CallbackApi - object-oriented interface
 * @export
 * @class CallbackApi
 * @extends {BaseAPI}
 */
export class CallbackApi extends BaseAPI {
    /**
     * 
     * @summary Record Lead Callback
     * @param {CallbackApiUsersViewsNinjaCallbacksRecordLeadCallbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbackApi
     */
    public usersViewsNinjaCallbacksRecordLeadCallback(requestParameters: CallbackApiUsersViewsNinjaCallbacksRecordLeadCallbackRequest, options?: RawAxiosRequestConfig) {
        return CallbackApiFp(this.configuration).usersViewsNinjaCallbacksRecordLeadCallback(requestParameters.leadCustomerioInSchemaV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Record Leads Callback
     * @param {CallbackApiUsersViewsNinjaCallbacksRecordLeadsCallbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallbackApi
     */
    public usersViewsNinjaCallbacksRecordLeadsCallback(requestParameters: CallbackApiUsersViewsNinjaCallbacksRecordLeadsCallbackRequest, options?: RawAxiosRequestConfig) {
        return CallbackApiFp(this.configuration).usersViewsNinjaCallbacksRecordLeadsCallback(requestParameters.leadInSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CdrApi - axios parameter creator
 * @export
 */
export const CdrApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Export Call Logs
         * @param {number} businessId 
         * @param {number} numberId 
         * @param {string | null} [startTimeRange] 
         * @param {string | null} [dateCreatedRange] 
         * @param {string | null} [phoneNumber] 
         * @param {boolean | null} [withNote] 
         * @param {boolean | null} [isAnswered] 
         * @param {number | null} [userId] 
         * @param {CallType | null} [kind] 
         * @param {string | null} [callId] 
         * @param {string | null} [durationRange] Filter by duration range, format: \&#39;min,max\&#39; (in seconds)
         * @param {ExportFormat | null} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCdrExportCallLogs: async (businessId: number, numberId: number, startTimeRange?: string | null, dateCreatedRange?: string | null, phoneNumber?: string | null, withNote?: boolean | null, isAnswered?: boolean | null, userId?: number | null, kind?: CallType | null, callId?: string | null, durationRange?: string | null, format?: ExportFormat | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCdrExportCallLogs', 'businessId', businessId)
            // verify required parameter 'numberId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCdrExportCallLogs', 'numberId', numberId)
            const localVarPath = `/api/business/{business_id}/number/{number_id}/call_log/export/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"number_id"}}`, encodeURIComponent(String(numberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTimeRange !== undefined) {
                localVarQueryParameter['start_time_range'] = startTimeRange;
            }

            if (dateCreatedRange !== undefined) {
                localVarQueryParameter['date_created_range'] = dateCreatedRange;
            }

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phone_number'] = phoneNumber;
            }

            if (withNote !== undefined) {
                localVarQueryParameter['with_note'] = withNote;
            }

            if (isAnswered !== undefined) {
                localVarQueryParameter['is_answered'] = isAnswered;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (callId !== undefined) {
                localVarQueryParameter['call_id'] = callId;
            }

            if (durationRange !== undefined) {
                localVarQueryParameter['duration_range'] = durationRange;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Call Logs Via Email
         * @param {number} businessId 
         * @param {number} numberId 
         * @param {string} recipients 
         * @param {string | null} [startTimeRange] 
         * @param {string | null} [dateCreatedRange] 
         * @param {string | null} [phoneNumber] 
         * @param {boolean | null} [withNote] 
         * @param {boolean | null} [isAnswered] 
         * @param {number | null} [userId] 
         * @param {CallType | null} [kind] 
         * @param {string | null} [callId] 
         * @param {string | null} [durationRange] Filter by duration range, format: \&#39;min,max\&#39; (in seconds)
         * @param {ExportFormat | null} [format] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCdrExportCallLogsViaEmail: async (businessId: number, numberId: number, recipients: string, startTimeRange?: string | null, dateCreatedRange?: string | null, phoneNumber?: string | null, withNote?: boolean | null, isAnswered?: boolean | null, userId?: number | null, kind?: CallType | null, callId?: string | null, durationRange?: string | null, format?: ExportFormat | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCdrExportCallLogsViaEmail', 'businessId', businessId)
            // verify required parameter 'numberId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCdrExportCallLogsViaEmail', 'numberId', numberId)
            // verify required parameter 'recipients' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCdrExportCallLogsViaEmail', 'recipients', recipients)
            const localVarPath = `/api/business/{business_id}/number/{number_id}/call_log/email-export/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"number_id"}}`, encodeURIComponent(String(numberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTimeRange !== undefined) {
                localVarQueryParameter['start_time_range'] = startTimeRange;
            }

            if (dateCreatedRange !== undefined) {
                localVarQueryParameter['date_created_range'] = dateCreatedRange;
            }

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phone_number'] = phoneNumber;
            }

            if (withNote !== undefined) {
                localVarQueryParameter['with_note'] = withNote;
            }

            if (isAnswered !== undefined) {
                localVarQueryParameter['is_answered'] = isAnswered;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (callId !== undefined) {
                localVarQueryParameter['call_id'] = callId;
            }

            if (durationRange !== undefined) {
                localVarQueryParameter['duration_range'] = durationRange;
            }

            if (recipients !== undefined) {
                localVarQueryParameter['recipients'] = recipients;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Call Logs
         * @param {number} businessId 
         * @param {number} numberId 
         * @param {string} callId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCdrGetCallLogs: async (businessId: number, numberId: number, callId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCdrGetCallLogs', 'businessId', businessId)
            // verify required parameter 'numberId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCdrGetCallLogs', 'numberId', numberId)
            // verify required parameter 'callId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCdrGetCallLogs', 'callId', callId)
            const localVarPath = `/api/business/{business_id}/number/{number_id}/call_log/{call_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"number_id"}}`, encodeURIComponent(String(numberId)))
                .replace(`{${"call_id"}}`, encodeURIComponent(String(callId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Call Logs
         * @param {number} businessId 
         * @param {number} numberId 
         * @param {string | null} [startTimeRange] 
         * @param {string | null} [dateCreatedRange] 
         * @param {string | null} [phoneNumber] 
         * @param {boolean | null} [withNote] 
         * @param {boolean | null} [isAnswered] 
         * @param {number | null} [userId] 
         * @param {CallType | null} [kind] 
         * @param {string | null} [callId] 
         * @param {string | null} [durationRange] Filter by duration range, format: \&#39;min,max\&#39; (in seconds)
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCdrListCallLogs: async (businessId: number, numberId: number, startTimeRange?: string | null, dateCreatedRange?: string | null, phoneNumber?: string | null, withNote?: boolean | null, isAnswered?: boolean | null, userId?: number | null, kind?: CallType | null, callId?: string | null, durationRange?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCdrListCallLogs', 'businessId', businessId)
            // verify required parameter 'numberId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallCdrListCallLogs', 'numberId', numberId)
            const localVarPath = `/api/business/{business_id}/number/{number_id}/call_log/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"number_id"}}`, encodeURIComponent(String(numberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTimeRange !== undefined) {
                localVarQueryParameter['start_time_range'] = startTimeRange;
            }

            if (dateCreatedRange !== undefined) {
                localVarQueryParameter['date_created_range'] = dateCreatedRange;
            }

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phone_number'] = phoneNumber;
            }

            if (withNote !== undefined) {
                localVarQueryParameter['with_note'] = withNote;
            }

            if (isAnswered !== undefined) {
                localVarQueryParameter['is_answered'] = isAnswered;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (callId !== undefined) {
                localVarQueryParameter['call_id'] = callId;
            }

            if (durationRange !== undefined) {
                localVarQueryParameter['duration_range'] = durationRange;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CdrApi - functional programming interface
 * @export
 */
export const CdrApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CdrApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Export Call Logs
         * @param {number} businessId 
         * @param {number} numberId 
         * @param {string | null} [startTimeRange] 
         * @param {string | null} [dateCreatedRange] 
         * @param {string | null} [phoneNumber] 
         * @param {boolean | null} [withNote] 
         * @param {boolean | null} [isAnswered] 
         * @param {number | null} [userId] 
         * @param {CallType | null} [kind] 
         * @param {string | null} [callId] 
         * @param {string | null} [durationRange] Filter by duration range, format: \&#39;min,max\&#39; (in seconds)
         * @param {ExportFormat | null} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCdrExportCallLogs(businessId: number, numberId: number, startTimeRange?: string | null, dateCreatedRange?: string | null, phoneNumber?: string | null, withNote?: boolean | null, isAnswered?: boolean | null, userId?: number | null, kind?: CallType | null, callId?: string | null, durationRange?: string | null, format?: ExportFormat | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCdrExportCallLogs(businessId, numberId, startTimeRange, dateCreatedRange, phoneNumber, withNote, isAnswered, userId, kind, callId, durationRange, format, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CdrApi.telephonyViewsNinjaCallCdrExportCallLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Call Logs Via Email
         * @param {number} businessId 
         * @param {number} numberId 
         * @param {string} recipients 
         * @param {string | null} [startTimeRange] 
         * @param {string | null} [dateCreatedRange] 
         * @param {string | null} [phoneNumber] 
         * @param {boolean | null} [withNote] 
         * @param {boolean | null} [isAnswered] 
         * @param {number | null} [userId] 
         * @param {CallType | null} [kind] 
         * @param {string | null} [callId] 
         * @param {string | null} [durationRange] Filter by duration range, format: \&#39;min,max\&#39; (in seconds)
         * @param {ExportFormat | null} [format] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCdrExportCallLogsViaEmail(businessId: number, numberId: number, recipients: string, startTimeRange?: string | null, dateCreatedRange?: string | null, phoneNumber?: string | null, withNote?: boolean | null, isAnswered?: boolean | null, userId?: number | null, kind?: CallType | null, callId?: string | null, durationRange?: string | null, format?: ExportFormat | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCdrExportCallLogsViaEmail(businessId, numberId, recipients, startTimeRange, dateCreatedRange, phoneNumber, withNote, isAnswered, userId, kind, callId, durationRange, format, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CdrApi.telephonyViewsNinjaCallCdrExportCallLogsViaEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Call Logs
         * @param {number} businessId 
         * @param {number} numberId 
         * @param {string} callId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCdrGetCallLogs(businessId: number, numberId: number, callId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCallLogOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCdrGetCallLogs(businessId, numberId, callId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CdrApi.telephonyViewsNinjaCallCdrGetCallLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Call Logs
         * @param {number} businessId 
         * @param {number} numberId 
         * @param {string | null} [startTimeRange] 
         * @param {string | null} [dateCreatedRange] 
         * @param {string | null} [phoneNumber] 
         * @param {boolean | null} [withNote] 
         * @param {boolean | null} [isAnswered] 
         * @param {number | null} [userId] 
         * @param {CallType | null} [kind] 
         * @param {string | null} [callId] 
         * @param {string | null} [durationRange] Filter by duration range, format: \&#39;min,max\&#39; (in seconds)
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallCdrListCallLogs(businessId: number, numberId: number, startTimeRange?: string | null, dateCreatedRange?: string | null, phoneNumber?: string | null, withNote?: boolean | null, isAnswered?: boolean | null, userId?: number | null, kind?: CallType | null, callId?: string | null, durationRange?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedCallLogMinimalOutV2Schema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallCdrListCallLogs(businessId, numberId, startTimeRange, dateCreatedRange, phoneNumber, withNote, isAnswered, userId, kind, callId, durationRange, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CdrApi.telephonyViewsNinjaCallCdrListCallLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CdrApi - factory interface
 * @export
 */
export const CdrApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CdrApiFp(configuration)
    return {
        /**
         * 
         * @summary Export Call Logs
         * @param {CdrApiTelephonyViewsNinjaCallCdrExportCallLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCdrExportCallLogs(requestParameters: CdrApiTelephonyViewsNinjaCallCdrExportCallLogsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.telephonyViewsNinjaCallCdrExportCallLogs(requestParameters.businessId, requestParameters.numberId, requestParameters.startTimeRange, requestParameters.dateCreatedRange, requestParameters.phoneNumber, requestParameters.withNote, requestParameters.isAnswered, requestParameters.userId, requestParameters.kind, requestParameters.callId, requestParameters.durationRange, requestParameters.format, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Call Logs Via Email
         * @param {CdrApiTelephonyViewsNinjaCallCdrExportCallLogsViaEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCdrExportCallLogsViaEmail(requestParameters: CdrApiTelephonyViewsNinjaCallCdrExportCallLogsViaEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.telephonyViewsNinjaCallCdrExportCallLogsViaEmail(requestParameters.businessId, requestParameters.numberId, requestParameters.recipients, requestParameters.startTimeRange, requestParameters.dateCreatedRange, requestParameters.phoneNumber, requestParameters.withNote, requestParameters.isAnswered, requestParameters.userId, requestParameters.kind, requestParameters.callId, requestParameters.durationRange, requestParameters.format, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Call Logs
         * @param {CdrApiTelephonyViewsNinjaCallCdrGetCallLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCdrGetCallLogs(requestParameters: CdrApiTelephonyViewsNinjaCallCdrGetCallLogsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCallLogOutSchema> {
            return localVarFp.telephonyViewsNinjaCallCdrGetCallLogs(requestParameters.businessId, requestParameters.numberId, requestParameters.callId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Call Logs
         * @param {CdrApiTelephonyViewsNinjaCallCdrListCallLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallCdrListCallLogs(requestParameters: CdrApiTelephonyViewsNinjaCallCdrListCallLogsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedCallLogMinimalOutV2Schema> {
            return localVarFp.telephonyViewsNinjaCallCdrListCallLogs(requestParameters.businessId, requestParameters.numberId, requestParameters.startTimeRange, requestParameters.dateCreatedRange, requestParameters.phoneNumber, requestParameters.withNote, requestParameters.isAnswered, requestParameters.userId, requestParameters.kind, requestParameters.callId, requestParameters.durationRange, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for telephonyViewsNinjaCallCdrExportCallLogs operation in CdrApi.
 * @export
 * @interface CdrApiTelephonyViewsNinjaCallCdrExportCallLogsRequest
 */
export interface CdrApiTelephonyViewsNinjaCallCdrExportCallLogsRequest {
    /**
     * 
     * @type {number}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogs
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogs
     */
    readonly numberId: number

    /**
     * 
     * @type {string}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogs
     */
    readonly startTimeRange?: string | null

    /**
     * 
     * @type {string}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogs
     */
    readonly dateCreatedRange?: string | null

    /**
     * 
     * @type {string}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogs
     */
    readonly phoneNumber?: string | null

    /**
     * 
     * @type {boolean}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogs
     */
    readonly withNote?: boolean | null

    /**
     * 
     * @type {boolean}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogs
     */
    readonly isAnswered?: boolean | null

    /**
     * 
     * @type {number}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogs
     */
    readonly userId?: number | null

    /**
     * 
     * @type {CallType}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogs
     */
    readonly kind?: CallType | null

    /**
     * 
     * @type {string}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogs
     */
    readonly callId?: string | null

    /**
     * Filter by duration range, format: \&#39;min,max\&#39; (in seconds)
     * @type {string}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogs
     */
    readonly durationRange?: string | null

    /**
     * 
     * @type {ExportFormat}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogs
     */
    readonly format?: ExportFormat | null
}

/**
 * Request parameters for telephonyViewsNinjaCallCdrExportCallLogsViaEmail operation in CdrApi.
 * @export
 * @interface CdrApiTelephonyViewsNinjaCallCdrExportCallLogsViaEmailRequest
 */
export interface CdrApiTelephonyViewsNinjaCallCdrExportCallLogsViaEmailRequest {
    /**
     * 
     * @type {number}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogsViaEmail
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogsViaEmail
     */
    readonly numberId: number

    /**
     * 
     * @type {string}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogsViaEmail
     */
    readonly recipients: string

    /**
     * 
     * @type {string}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogsViaEmail
     */
    readonly startTimeRange?: string | null

    /**
     * 
     * @type {string}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogsViaEmail
     */
    readonly dateCreatedRange?: string | null

    /**
     * 
     * @type {string}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogsViaEmail
     */
    readonly phoneNumber?: string | null

    /**
     * 
     * @type {boolean}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogsViaEmail
     */
    readonly withNote?: boolean | null

    /**
     * 
     * @type {boolean}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogsViaEmail
     */
    readonly isAnswered?: boolean | null

    /**
     * 
     * @type {number}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogsViaEmail
     */
    readonly userId?: number | null

    /**
     * 
     * @type {CallType}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogsViaEmail
     */
    readonly kind?: CallType | null

    /**
     * 
     * @type {string}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogsViaEmail
     */
    readonly callId?: string | null

    /**
     * Filter by duration range, format: \&#39;min,max\&#39; (in seconds)
     * @type {string}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogsViaEmail
     */
    readonly durationRange?: string | null

    /**
     * 
     * @type {ExportFormat}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrExportCallLogsViaEmail
     */
    readonly format?: ExportFormat | null
}

/**
 * Request parameters for telephonyViewsNinjaCallCdrGetCallLogs operation in CdrApi.
 * @export
 * @interface CdrApiTelephonyViewsNinjaCallCdrGetCallLogsRequest
 */
export interface CdrApiTelephonyViewsNinjaCallCdrGetCallLogsRequest {
    /**
     * 
     * @type {number}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrGetCallLogs
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrGetCallLogs
     */
    readonly numberId: number

    /**
     * 
     * @type {string}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrGetCallLogs
     */
    readonly callId: string
}

/**
 * Request parameters for telephonyViewsNinjaCallCdrListCallLogs operation in CdrApi.
 * @export
 * @interface CdrApiTelephonyViewsNinjaCallCdrListCallLogsRequest
 */
export interface CdrApiTelephonyViewsNinjaCallCdrListCallLogsRequest {
    /**
     * 
     * @type {number}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrListCallLogs
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrListCallLogs
     */
    readonly numberId: number

    /**
     * 
     * @type {string}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrListCallLogs
     */
    readonly startTimeRange?: string | null

    /**
     * 
     * @type {string}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrListCallLogs
     */
    readonly dateCreatedRange?: string | null

    /**
     * 
     * @type {string}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrListCallLogs
     */
    readonly phoneNumber?: string | null

    /**
     * 
     * @type {boolean}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrListCallLogs
     */
    readonly withNote?: boolean | null

    /**
     * 
     * @type {boolean}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrListCallLogs
     */
    readonly isAnswered?: boolean | null

    /**
     * 
     * @type {number}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrListCallLogs
     */
    readonly userId?: number | null

    /**
     * 
     * @type {CallType}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrListCallLogs
     */
    readonly kind?: CallType | null

    /**
     * 
     * @type {string}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrListCallLogs
     */
    readonly callId?: string | null

    /**
     * Filter by duration range, format: \&#39;min,max\&#39; (in seconds)
     * @type {string}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrListCallLogs
     */
    readonly durationRange?: string | null

    /**
     * 
     * @type {number}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrListCallLogs
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrListCallLogs
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof CdrApiTelephonyViewsNinjaCallCdrListCallLogs
     */
    readonly ordering?: string | null
}

/**
 * CdrApi - object-oriented interface
 * @export
 * @class CdrApi
 * @extends {BaseAPI}
 */
export class CdrApi extends BaseAPI {
    /**
     * 
     * @summary Export Call Logs
     * @param {CdrApiTelephonyViewsNinjaCallCdrExportCallLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CdrApi
     */
    public telephonyViewsNinjaCallCdrExportCallLogs(requestParameters: CdrApiTelephonyViewsNinjaCallCdrExportCallLogsRequest, options?: RawAxiosRequestConfig) {
        return CdrApiFp(this.configuration).telephonyViewsNinjaCallCdrExportCallLogs(requestParameters.businessId, requestParameters.numberId, requestParameters.startTimeRange, requestParameters.dateCreatedRange, requestParameters.phoneNumber, requestParameters.withNote, requestParameters.isAnswered, requestParameters.userId, requestParameters.kind, requestParameters.callId, requestParameters.durationRange, requestParameters.format, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Call Logs Via Email
     * @param {CdrApiTelephonyViewsNinjaCallCdrExportCallLogsViaEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CdrApi
     */
    public telephonyViewsNinjaCallCdrExportCallLogsViaEmail(requestParameters: CdrApiTelephonyViewsNinjaCallCdrExportCallLogsViaEmailRequest, options?: RawAxiosRequestConfig) {
        return CdrApiFp(this.configuration).telephonyViewsNinjaCallCdrExportCallLogsViaEmail(requestParameters.businessId, requestParameters.numberId, requestParameters.recipients, requestParameters.startTimeRange, requestParameters.dateCreatedRange, requestParameters.phoneNumber, requestParameters.withNote, requestParameters.isAnswered, requestParameters.userId, requestParameters.kind, requestParameters.callId, requestParameters.durationRange, requestParameters.format, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Call Logs
     * @param {CdrApiTelephonyViewsNinjaCallCdrGetCallLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CdrApi
     */
    public telephonyViewsNinjaCallCdrGetCallLogs(requestParameters: CdrApiTelephonyViewsNinjaCallCdrGetCallLogsRequest, options?: RawAxiosRequestConfig) {
        return CdrApiFp(this.configuration).telephonyViewsNinjaCallCdrGetCallLogs(requestParameters.businessId, requestParameters.numberId, requestParameters.callId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Call Logs
     * @param {CdrApiTelephonyViewsNinjaCallCdrListCallLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CdrApi
     */
    public telephonyViewsNinjaCallCdrListCallLogs(requestParameters: CdrApiTelephonyViewsNinjaCallCdrListCallLogsRequest, options?: RawAxiosRequestConfig) {
        return CdrApiFp(this.configuration).telephonyViewsNinjaCallCdrListCallLogs(requestParameters.businessId, requestParameters.numberId, requestParameters.startTimeRange, requestParameters.dateCreatedRange, requestParameters.phoneNumber, requestParameters.withNote, requestParameters.isAnswered, requestParameters.userId, requestParameters.kind, requestParameters.callId, requestParameters.durationRange, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChatterwaveApi - axios parameter creator
 * @export
 */
export const ChatterwaveApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Chatterwave Overview
         * @param {number} businessId 
         * @param {AddonsViewsNinjaChatterwaveChatterwaveOverviewChatterwaveTypeEnum} chatterwaveType 
         * @param {string | null} [search] 
         * @param {number | null} [businessNumberId] 
         * @param {string | null} [status] 
         * @param {string | null} [dateCreatedBefore] 
         * @param {string | null} [dateCreatedAfter] 
         * @param {string | null} [sessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaChatterwaveChatterwaveOverview: async (businessId: number, chatterwaveType: AddonsViewsNinjaChatterwaveChatterwaveOverviewChatterwaveTypeEnum, search?: string | null, businessNumberId?: number | null, status?: string | null, dateCreatedBefore?: string | null, dateCreatedAfter?: string | null, sessionId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaChatterwaveChatterwaveOverview', 'businessId', businessId)
            // verify required parameter 'chatterwaveType' is not null or undefined
            assertParamExists('addonsViewsNinjaChatterwaveChatterwaveOverview', 'chatterwaveType', chatterwaveType)
            const localVarPath = `/api/business/{business_id}/addons/chatterwave/overview/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (businessNumberId !== undefined) {
                localVarQueryParameter['business_number_id'] = businessNumberId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (dateCreatedBefore !== undefined) {
                localVarQueryParameter['date_created_before'] = dateCreatedBefore;
            }

            if (dateCreatedAfter !== undefined) {
                localVarQueryParameter['date_created_after'] = dateCreatedAfter;
            }

            if (sessionId !== undefined) {
                localVarQueryParameter['session_id'] = sessionId;
            }

            if (chatterwaveType !== undefined) {
                localVarQueryParameter['chatterwave_type'] = chatterwaveType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Chatterwave To Csv
         * @param {number} businessId 
         * @param {AddonsViewsNinjaChatterwaveExportChatterwaveToCsvChatterwaveTypeEnum} chatterwaveType 
         * @param {string | null} [search] 
         * @param {number | null} [businessNumberId] 
         * @param {string | null} [status] 
         * @param {string | null} [dateCreatedBefore] 
         * @param {string | null} [dateCreatedAfter] 
         * @param {string | null} [sessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaChatterwaveExportChatterwaveToCsv: async (businessId: number, chatterwaveType: AddonsViewsNinjaChatterwaveExportChatterwaveToCsvChatterwaveTypeEnum, search?: string | null, businessNumberId?: number | null, status?: string | null, dateCreatedBefore?: string | null, dateCreatedAfter?: string | null, sessionId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaChatterwaveExportChatterwaveToCsv', 'businessId', businessId)
            // verify required parameter 'chatterwaveType' is not null or undefined
            assertParamExists('addonsViewsNinjaChatterwaveExportChatterwaveToCsv', 'chatterwaveType', chatterwaveType)
            const localVarPath = `/api/business/{business_id}/addons/chatterwave/export-csv/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (businessNumberId !== undefined) {
                localVarQueryParameter['business_number_id'] = businessNumberId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (dateCreatedBefore !== undefined) {
                localVarQueryParameter['date_created_before'] = dateCreatedBefore;
            }

            if (dateCreatedAfter !== undefined) {
                localVarQueryParameter['date_created_after'] = dateCreatedAfter;
            }

            if (sessionId !== undefined) {
                localVarQueryParameter['session_id'] = sessionId;
            }

            if (chatterwaveType !== undefined) {
                localVarQueryParameter['chatterwave_type'] = chatterwaveType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Chatterwave
         * @param {number} businessId 
         * @param {AddonsViewsNinjaChatterwaveListChatterwaveChatterwaveTypeEnum} chatterwaveType 
         * @param {string | null} [search] 
         * @param {number | null} [businessNumberId] 
         * @param {string | null} [status] 
         * @param {string | null} [dateCreatedBefore] 
         * @param {string | null} [dateCreatedAfter] 
         * @param {string | null} [sessionId] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaChatterwaveListChatterwave: async (businessId: number, chatterwaveType: AddonsViewsNinjaChatterwaveListChatterwaveChatterwaveTypeEnum, search?: string | null, businessNumberId?: number | null, status?: string | null, dateCreatedBefore?: string | null, dateCreatedAfter?: string | null, sessionId?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaChatterwaveListChatterwave', 'businessId', businessId)
            // verify required parameter 'chatterwaveType' is not null or undefined
            assertParamExists('addonsViewsNinjaChatterwaveListChatterwave', 'chatterwaveType', chatterwaveType)
            const localVarPath = `/api/business/{business_id}/addons/chatterwave/list/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (businessNumberId !== undefined) {
                localVarQueryParameter['business_number_id'] = businessNumberId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (dateCreatedBefore !== undefined) {
                localVarQueryParameter['date_created_before'] = dateCreatedBefore;
            }

            if (dateCreatedAfter !== undefined) {
                localVarQueryParameter['date_created_after'] = dateCreatedAfter;
            }

            if (sessionId !== undefined) {
                localVarQueryParameter['session_id'] = sessionId;
            }

            if (chatterwaveType !== undefined) {
                localVarQueryParameter['chatterwave_type'] = chatterwaveType;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve Chatterwave Config
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaChatterwaveRetrieveChatterwaveConfig: async (businessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaChatterwaveRetrieveChatterwaveConfig', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/addons/chatterwave/config/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send Test Voice Otp
         * @param {number} businessId 
         * @param {VoiceOtpInSchema} voiceOtpInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaChatterwaveSendTestVoiceOtp: async (businessId: number, voiceOtpInSchema: VoiceOtpInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaChatterwaveSendTestVoiceOtp', 'businessId', businessId)
            // verify required parameter 'voiceOtpInSchema' is not null or undefined
            assertParamExists('addonsViewsNinjaChatterwaveSendTestVoiceOtp', 'voiceOtpInSchema', voiceOtpInSchema)
            const localVarPath = `/api/business/{business_id}/addons/chatterwave/voice-otp/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voiceOtpInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send Text To Speech
         * @param {number} businessId 
         * @param {TextToSpeechInSchema} textToSpeechInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaChatterwaveSendTextToSpeech: async (businessId: number, textToSpeechInSchema: TextToSpeechInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaChatterwaveSendTextToSpeech', 'businessId', businessId)
            // verify required parameter 'textToSpeechInSchema' is not null or undefined
            assertParamExists('addonsViewsNinjaChatterwaveSendTextToSpeech', 'textToSpeechInSchema', textToSpeechInSchema)
            const localVarPath = `/api/business/{business_id}/addons/chatterwave/text-to-speech/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(textToSpeechInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Chatterwave Config
         * @param {number} businessId 
         * @param {ChatterWaveConfigUpdateSchema} chatterWaveConfigUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaChatterwaveUpdateChatterwaveConfig: async (businessId: number, chatterWaveConfigUpdateSchema: ChatterWaveConfigUpdateSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaChatterwaveUpdateChatterwaveConfig', 'businessId', businessId)
            // verify required parameter 'chatterWaveConfigUpdateSchema' is not null or undefined
            assertParamExists('addonsViewsNinjaChatterwaveUpdateChatterwaveConfig', 'chatterWaveConfigUpdateSchema', chatterWaveConfigUpdateSchema)
            const localVarPath = `/api/business/{business_id}/addons/chatterwave/config/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatterWaveConfigUpdateSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatterwaveApi - functional programming interface
 * @export
 */
export const ChatterwaveApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatterwaveApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Chatterwave Overview
         * @param {number} businessId 
         * @param {AddonsViewsNinjaChatterwaveChatterwaveOverviewChatterwaveTypeEnum} chatterwaveType 
         * @param {string | null} [search] 
         * @param {number | null} [businessNumberId] 
         * @param {string | null} [status] 
         * @param {string | null} [dateCreatedBefore] 
         * @param {string | null} [dateCreatedAfter] 
         * @param {string | null} [sessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaChatterwaveChatterwaveOverview(businessId: number, chatterwaveType: AddonsViewsNinjaChatterwaveChatterwaveOverviewChatterwaveTypeEnum, search?: string | null, businessNumberId?: number | null, status?: string | null, dateCreatedBefore?: string | null, dateCreatedAfter?: string | null, sessionId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatterWaveOverviewOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaChatterwaveChatterwaveOverview(businessId, chatterwaveType, search, businessNumberId, status, dateCreatedBefore, dateCreatedAfter, sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatterwaveApi.addonsViewsNinjaChatterwaveChatterwaveOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Chatterwave To Csv
         * @param {number} businessId 
         * @param {AddonsViewsNinjaChatterwaveExportChatterwaveToCsvChatterwaveTypeEnum} chatterwaveType 
         * @param {string | null} [search] 
         * @param {number | null} [businessNumberId] 
         * @param {string | null} [status] 
         * @param {string | null} [dateCreatedBefore] 
         * @param {string | null} [dateCreatedAfter] 
         * @param {string | null} [sessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaChatterwaveExportChatterwaveToCsv(businessId: number, chatterwaveType: AddonsViewsNinjaChatterwaveExportChatterwaveToCsvChatterwaveTypeEnum, search?: string | null, businessNumberId?: number | null, status?: string | null, dateCreatedBefore?: string | null, dateCreatedAfter?: string | null, sessionId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaChatterwaveExportChatterwaveToCsv(businessId, chatterwaveType, search, businessNumberId, status, dateCreatedBefore, dateCreatedAfter, sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatterwaveApi.addonsViewsNinjaChatterwaveExportChatterwaveToCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Chatterwave
         * @param {number} businessId 
         * @param {AddonsViewsNinjaChatterwaveListChatterwaveChatterwaveTypeEnum} chatterwaveType 
         * @param {string | null} [search] 
         * @param {number | null} [businessNumberId] 
         * @param {string | null} [status] 
         * @param {string | null} [dateCreatedBefore] 
         * @param {string | null} [dateCreatedAfter] 
         * @param {string | null} [sessionId] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaChatterwaveListChatterwave(businessId: number, chatterwaveType: AddonsViewsNinjaChatterwaveListChatterwaveChatterwaveTypeEnum, search?: string | null, businessNumberId?: number | null, status?: string | null, dateCreatedBefore?: string | null, dateCreatedAfter?: string | null, sessionId?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedChatterWaveOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaChatterwaveListChatterwave(businessId, chatterwaveType, search, businessNumberId, status, dateCreatedBefore, dateCreatedAfter, sessionId, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatterwaveApi.addonsViewsNinjaChatterwaveListChatterwave']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve Chatterwave Config
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaChatterwaveRetrieveChatterwaveConfig(businessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatterWaveConfigOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaChatterwaveRetrieveChatterwaveConfig(businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatterwaveApi.addonsViewsNinjaChatterwaveRetrieveChatterwaveConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send Test Voice Otp
         * @param {number} businessId 
         * @param {VoiceOtpInSchema} voiceOtpInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaChatterwaveSendTestVoiceOtp(businessId: number, voiceOtpInSchema: VoiceOtpInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaChatterwaveSendTestVoiceOtp(businessId, voiceOtpInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatterwaveApi.addonsViewsNinjaChatterwaveSendTestVoiceOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send Text To Speech
         * @param {number} businessId 
         * @param {TextToSpeechInSchema} textToSpeechInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaChatterwaveSendTextToSpeech(businessId: number, textToSpeechInSchema: TextToSpeechInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaChatterwaveSendTextToSpeech(businessId, textToSpeechInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatterwaveApi.addonsViewsNinjaChatterwaveSendTextToSpeech']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Chatterwave Config
         * @param {number} businessId 
         * @param {ChatterWaveConfigUpdateSchema} chatterWaveConfigUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaChatterwaveUpdateChatterwaveConfig(businessId: number, chatterWaveConfigUpdateSchema: ChatterWaveConfigUpdateSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatterWaveConfigOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaChatterwaveUpdateChatterwaveConfig(businessId, chatterWaveConfigUpdateSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatterwaveApi.addonsViewsNinjaChatterwaveUpdateChatterwaveConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatterwaveApi - factory interface
 * @export
 */
export const ChatterwaveApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatterwaveApiFp(configuration)
    return {
        /**
         * 
         * @summary Chatterwave Overview
         * @param {ChatterwaveApiAddonsViewsNinjaChatterwaveChatterwaveOverviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaChatterwaveChatterwaveOverview(requestParameters: ChatterwaveApiAddonsViewsNinjaChatterwaveChatterwaveOverviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatterWaveOverviewOutSchema> {
            return localVarFp.addonsViewsNinjaChatterwaveChatterwaveOverview(requestParameters.businessId, requestParameters.chatterwaveType, requestParameters.search, requestParameters.businessNumberId, requestParameters.status, requestParameters.dateCreatedBefore, requestParameters.dateCreatedAfter, requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Chatterwave To Csv
         * @param {ChatterwaveApiAddonsViewsNinjaChatterwaveExportChatterwaveToCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaChatterwaveExportChatterwaveToCsv(requestParameters: ChatterwaveApiAddonsViewsNinjaChatterwaveExportChatterwaveToCsvRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addonsViewsNinjaChatterwaveExportChatterwaveToCsv(requestParameters.businessId, requestParameters.chatterwaveType, requestParameters.search, requestParameters.businessNumberId, requestParameters.status, requestParameters.dateCreatedBefore, requestParameters.dateCreatedAfter, requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Chatterwave
         * @param {ChatterwaveApiAddonsViewsNinjaChatterwaveListChatterwaveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaChatterwaveListChatterwave(requestParameters: ChatterwaveApiAddonsViewsNinjaChatterwaveListChatterwaveRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedChatterWaveOutSchema> {
            return localVarFp.addonsViewsNinjaChatterwaveListChatterwave(requestParameters.businessId, requestParameters.chatterwaveType, requestParameters.search, requestParameters.businessNumberId, requestParameters.status, requestParameters.dateCreatedBefore, requestParameters.dateCreatedAfter, requestParameters.sessionId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve Chatterwave Config
         * @param {ChatterwaveApiAddonsViewsNinjaChatterwaveRetrieveChatterwaveConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaChatterwaveRetrieveChatterwaveConfig(requestParameters: ChatterwaveApiAddonsViewsNinjaChatterwaveRetrieveChatterwaveConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatterWaveConfigOutSchema> {
            return localVarFp.addonsViewsNinjaChatterwaveRetrieveChatterwaveConfig(requestParameters.businessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send Test Voice Otp
         * @param {ChatterwaveApiAddonsViewsNinjaChatterwaveSendTestVoiceOtpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaChatterwaveSendTestVoiceOtp(requestParameters: ChatterwaveApiAddonsViewsNinjaChatterwaveSendTestVoiceOtpRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.addonsViewsNinjaChatterwaveSendTestVoiceOtp(requestParameters.businessId, requestParameters.voiceOtpInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send Text To Speech
         * @param {ChatterwaveApiAddonsViewsNinjaChatterwaveSendTextToSpeechRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaChatterwaveSendTextToSpeech(requestParameters: ChatterwaveApiAddonsViewsNinjaChatterwaveSendTextToSpeechRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.addonsViewsNinjaChatterwaveSendTextToSpeech(requestParameters.businessId, requestParameters.textToSpeechInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Chatterwave Config
         * @param {ChatterwaveApiAddonsViewsNinjaChatterwaveUpdateChatterwaveConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaChatterwaveUpdateChatterwaveConfig(requestParameters: ChatterwaveApiAddonsViewsNinjaChatterwaveUpdateChatterwaveConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatterWaveConfigOutSchema> {
            return localVarFp.addonsViewsNinjaChatterwaveUpdateChatterwaveConfig(requestParameters.businessId, requestParameters.chatterWaveConfigUpdateSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addonsViewsNinjaChatterwaveChatterwaveOverview operation in ChatterwaveApi.
 * @export
 * @interface ChatterwaveApiAddonsViewsNinjaChatterwaveChatterwaveOverviewRequest
 */
export interface ChatterwaveApiAddonsViewsNinjaChatterwaveChatterwaveOverviewRequest {
    /**
     * 
     * @type {number}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveChatterwaveOverview
     */
    readonly businessId: number

    /**
     * 
     * @type {'otp' | 'tts'}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveChatterwaveOverview
     */
    readonly chatterwaveType: AddonsViewsNinjaChatterwaveChatterwaveOverviewChatterwaveTypeEnum

    /**
     * 
     * @type {string}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveChatterwaveOverview
     */
    readonly search?: string | null

    /**
     * 
     * @type {number}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveChatterwaveOverview
     */
    readonly businessNumberId?: number | null

    /**
     * 
     * @type {string}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveChatterwaveOverview
     */
    readonly status?: string | null

    /**
     * 
     * @type {string}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveChatterwaveOverview
     */
    readonly dateCreatedBefore?: string | null

    /**
     * 
     * @type {string}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveChatterwaveOverview
     */
    readonly dateCreatedAfter?: string | null

    /**
     * 
     * @type {string}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveChatterwaveOverview
     */
    readonly sessionId?: string | null
}

/**
 * Request parameters for addonsViewsNinjaChatterwaveExportChatterwaveToCsv operation in ChatterwaveApi.
 * @export
 * @interface ChatterwaveApiAddonsViewsNinjaChatterwaveExportChatterwaveToCsvRequest
 */
export interface ChatterwaveApiAddonsViewsNinjaChatterwaveExportChatterwaveToCsvRequest {
    /**
     * 
     * @type {number}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveExportChatterwaveToCsv
     */
    readonly businessId: number

    /**
     * 
     * @type {'otp' | 'tts'}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveExportChatterwaveToCsv
     */
    readonly chatterwaveType: AddonsViewsNinjaChatterwaveExportChatterwaveToCsvChatterwaveTypeEnum

    /**
     * 
     * @type {string}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveExportChatterwaveToCsv
     */
    readonly search?: string | null

    /**
     * 
     * @type {number}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveExportChatterwaveToCsv
     */
    readonly businessNumberId?: number | null

    /**
     * 
     * @type {string}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveExportChatterwaveToCsv
     */
    readonly status?: string | null

    /**
     * 
     * @type {string}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveExportChatterwaveToCsv
     */
    readonly dateCreatedBefore?: string | null

    /**
     * 
     * @type {string}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveExportChatterwaveToCsv
     */
    readonly dateCreatedAfter?: string | null

    /**
     * 
     * @type {string}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveExportChatterwaveToCsv
     */
    readonly sessionId?: string | null
}

/**
 * Request parameters for addonsViewsNinjaChatterwaveListChatterwave operation in ChatterwaveApi.
 * @export
 * @interface ChatterwaveApiAddonsViewsNinjaChatterwaveListChatterwaveRequest
 */
export interface ChatterwaveApiAddonsViewsNinjaChatterwaveListChatterwaveRequest {
    /**
     * 
     * @type {number}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveListChatterwave
     */
    readonly businessId: number

    /**
     * 
     * @type {'otp' | 'tts'}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveListChatterwave
     */
    readonly chatterwaveType: AddonsViewsNinjaChatterwaveListChatterwaveChatterwaveTypeEnum

    /**
     * 
     * @type {string}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveListChatterwave
     */
    readonly search?: string | null

    /**
     * 
     * @type {number}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveListChatterwave
     */
    readonly businessNumberId?: number | null

    /**
     * 
     * @type {string}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveListChatterwave
     */
    readonly status?: string | null

    /**
     * 
     * @type {string}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveListChatterwave
     */
    readonly dateCreatedBefore?: string | null

    /**
     * 
     * @type {string}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveListChatterwave
     */
    readonly dateCreatedAfter?: string | null

    /**
     * 
     * @type {string}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveListChatterwave
     */
    readonly sessionId?: string | null

    /**
     * 
     * @type {number}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveListChatterwave
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveListChatterwave
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveListChatterwave
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for addonsViewsNinjaChatterwaveRetrieveChatterwaveConfig operation in ChatterwaveApi.
 * @export
 * @interface ChatterwaveApiAddonsViewsNinjaChatterwaveRetrieveChatterwaveConfigRequest
 */
export interface ChatterwaveApiAddonsViewsNinjaChatterwaveRetrieveChatterwaveConfigRequest {
    /**
     * 
     * @type {number}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveRetrieveChatterwaveConfig
     */
    readonly businessId: number
}

/**
 * Request parameters for addonsViewsNinjaChatterwaveSendTestVoiceOtp operation in ChatterwaveApi.
 * @export
 * @interface ChatterwaveApiAddonsViewsNinjaChatterwaveSendTestVoiceOtpRequest
 */
export interface ChatterwaveApiAddonsViewsNinjaChatterwaveSendTestVoiceOtpRequest {
    /**
     * 
     * @type {number}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveSendTestVoiceOtp
     */
    readonly businessId: number

    /**
     * 
     * @type {VoiceOtpInSchema}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveSendTestVoiceOtp
     */
    readonly voiceOtpInSchema: VoiceOtpInSchema
}

/**
 * Request parameters for addonsViewsNinjaChatterwaveSendTextToSpeech operation in ChatterwaveApi.
 * @export
 * @interface ChatterwaveApiAddonsViewsNinjaChatterwaveSendTextToSpeechRequest
 */
export interface ChatterwaveApiAddonsViewsNinjaChatterwaveSendTextToSpeechRequest {
    /**
     * 
     * @type {number}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveSendTextToSpeech
     */
    readonly businessId: number

    /**
     * 
     * @type {TextToSpeechInSchema}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveSendTextToSpeech
     */
    readonly textToSpeechInSchema: TextToSpeechInSchema
}

/**
 * Request parameters for addonsViewsNinjaChatterwaveUpdateChatterwaveConfig operation in ChatterwaveApi.
 * @export
 * @interface ChatterwaveApiAddonsViewsNinjaChatterwaveUpdateChatterwaveConfigRequest
 */
export interface ChatterwaveApiAddonsViewsNinjaChatterwaveUpdateChatterwaveConfigRequest {
    /**
     * 
     * @type {number}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveUpdateChatterwaveConfig
     */
    readonly businessId: number

    /**
     * 
     * @type {ChatterWaveConfigUpdateSchema}
     * @memberof ChatterwaveApiAddonsViewsNinjaChatterwaveUpdateChatterwaveConfig
     */
    readonly chatterWaveConfigUpdateSchema: ChatterWaveConfigUpdateSchema
}

/**
 * ChatterwaveApi - object-oriented interface
 * @export
 * @class ChatterwaveApi
 * @extends {BaseAPI}
 */
export class ChatterwaveApi extends BaseAPI {
    /**
     * 
     * @summary Chatterwave Overview
     * @param {ChatterwaveApiAddonsViewsNinjaChatterwaveChatterwaveOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatterwaveApi
     */
    public addonsViewsNinjaChatterwaveChatterwaveOverview(requestParameters: ChatterwaveApiAddonsViewsNinjaChatterwaveChatterwaveOverviewRequest, options?: RawAxiosRequestConfig) {
        return ChatterwaveApiFp(this.configuration).addonsViewsNinjaChatterwaveChatterwaveOverview(requestParameters.businessId, requestParameters.chatterwaveType, requestParameters.search, requestParameters.businessNumberId, requestParameters.status, requestParameters.dateCreatedBefore, requestParameters.dateCreatedAfter, requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Chatterwave To Csv
     * @param {ChatterwaveApiAddonsViewsNinjaChatterwaveExportChatterwaveToCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatterwaveApi
     */
    public addonsViewsNinjaChatterwaveExportChatterwaveToCsv(requestParameters: ChatterwaveApiAddonsViewsNinjaChatterwaveExportChatterwaveToCsvRequest, options?: RawAxiosRequestConfig) {
        return ChatterwaveApiFp(this.configuration).addonsViewsNinjaChatterwaveExportChatterwaveToCsv(requestParameters.businessId, requestParameters.chatterwaveType, requestParameters.search, requestParameters.businessNumberId, requestParameters.status, requestParameters.dateCreatedBefore, requestParameters.dateCreatedAfter, requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Chatterwave
     * @param {ChatterwaveApiAddonsViewsNinjaChatterwaveListChatterwaveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatterwaveApi
     */
    public addonsViewsNinjaChatterwaveListChatterwave(requestParameters: ChatterwaveApiAddonsViewsNinjaChatterwaveListChatterwaveRequest, options?: RawAxiosRequestConfig) {
        return ChatterwaveApiFp(this.configuration).addonsViewsNinjaChatterwaveListChatterwave(requestParameters.businessId, requestParameters.chatterwaveType, requestParameters.search, requestParameters.businessNumberId, requestParameters.status, requestParameters.dateCreatedBefore, requestParameters.dateCreatedAfter, requestParameters.sessionId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve Chatterwave Config
     * @param {ChatterwaveApiAddonsViewsNinjaChatterwaveRetrieveChatterwaveConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatterwaveApi
     */
    public addonsViewsNinjaChatterwaveRetrieveChatterwaveConfig(requestParameters: ChatterwaveApiAddonsViewsNinjaChatterwaveRetrieveChatterwaveConfigRequest, options?: RawAxiosRequestConfig) {
        return ChatterwaveApiFp(this.configuration).addonsViewsNinjaChatterwaveRetrieveChatterwaveConfig(requestParameters.businessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send Test Voice Otp
     * @param {ChatterwaveApiAddonsViewsNinjaChatterwaveSendTestVoiceOtpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatterwaveApi
     */
    public addonsViewsNinjaChatterwaveSendTestVoiceOtp(requestParameters: ChatterwaveApiAddonsViewsNinjaChatterwaveSendTestVoiceOtpRequest, options?: RawAxiosRequestConfig) {
        return ChatterwaveApiFp(this.configuration).addonsViewsNinjaChatterwaveSendTestVoiceOtp(requestParameters.businessId, requestParameters.voiceOtpInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send Text To Speech
     * @param {ChatterwaveApiAddonsViewsNinjaChatterwaveSendTextToSpeechRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatterwaveApi
     */
    public addonsViewsNinjaChatterwaveSendTextToSpeech(requestParameters: ChatterwaveApiAddonsViewsNinjaChatterwaveSendTextToSpeechRequest, options?: RawAxiosRequestConfig) {
        return ChatterwaveApiFp(this.configuration).addonsViewsNinjaChatterwaveSendTextToSpeech(requestParameters.businessId, requestParameters.textToSpeechInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Chatterwave Config
     * @param {ChatterwaveApiAddonsViewsNinjaChatterwaveUpdateChatterwaveConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatterwaveApi
     */
    public addonsViewsNinjaChatterwaveUpdateChatterwaveConfig(requestParameters: ChatterwaveApiAddonsViewsNinjaChatterwaveUpdateChatterwaveConfigRequest, options?: RawAxiosRequestConfig) {
        return ChatterwaveApiFp(this.configuration).addonsViewsNinjaChatterwaveUpdateChatterwaveConfig(requestParameters.businessId, requestParameters.chatterWaveConfigUpdateSchema, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AddonsViewsNinjaChatterwaveChatterwaveOverviewChatterwaveTypeEnum = {
    Otp: 'otp',
    Tts: 'tts'
} as const;
export type AddonsViewsNinjaChatterwaveChatterwaveOverviewChatterwaveTypeEnum = typeof AddonsViewsNinjaChatterwaveChatterwaveOverviewChatterwaveTypeEnum[keyof typeof AddonsViewsNinjaChatterwaveChatterwaveOverviewChatterwaveTypeEnum];
/**
 * @export
 */
export const AddonsViewsNinjaChatterwaveExportChatterwaveToCsvChatterwaveTypeEnum = {
    Otp: 'otp',
    Tts: 'tts'
} as const;
export type AddonsViewsNinjaChatterwaveExportChatterwaveToCsvChatterwaveTypeEnum = typeof AddonsViewsNinjaChatterwaveExportChatterwaveToCsvChatterwaveTypeEnum[keyof typeof AddonsViewsNinjaChatterwaveExportChatterwaveToCsvChatterwaveTypeEnum];
/**
 * @export
 */
export const AddonsViewsNinjaChatterwaveListChatterwaveChatterwaveTypeEnum = {
    Otp: 'otp',
    Tts: 'tts'
} as const;
export type AddonsViewsNinjaChatterwaveListChatterwaveChatterwaveTypeEnum = typeof AddonsViewsNinjaChatterwaveListChatterwaveChatterwaveTypeEnum[keyof typeof AddonsViewsNinjaChatterwaveListChatterwaveChatterwaveTypeEnum];


/**
 * ContactsApi - axios parameter creator
 * @export
 */
export const ContactsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Bulk Contacts
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaContactsCreateBulkContacts: async (businessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaContactsCreateBulkContacts', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/contacts/bulk-create/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Bulk Contacts And Distribute To Queues
         * @param {number} businessId 
         * @param {DistributeBulkUploadContactSchema} distributeBulkUploadContactSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaContactsCreateBulkContactsAndDistributeToQueues: async (businessId: number, distributeBulkUploadContactSchema: DistributeBulkUploadContactSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaContactsCreateBulkContactsAndDistributeToQueues', 'businessId', businessId)
            // verify required parameter 'distributeBulkUploadContactSchema' is not null or undefined
            assertParamExists('usersViewsNinjaContactsCreateBulkContactsAndDistributeToQueues', 'distributeBulkUploadContactSchema', distributeBulkUploadContactSchema)
            const localVarPath = `/api/business/{business_id}/contacts/bulk-create/distribute/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(distributeBulkUploadContactSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Contact
         * @param {number} businessId 
         * @param {UserContactInSchema} userContactInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaContactsCreateContact: async (businessId: number, userContactInSchema: UserContactInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaContactsCreateContact', 'businessId', businessId)
            // verify required parameter 'userContactInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaContactsCreateContact', 'userContactInSchema', userContactInSchema)
            const localVarPath = `/api/business/{business_id}/contacts/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userContactInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Bulk Contacts
         * @param {number} businessId 
         * @param {BulkDeleteContactSchema} bulkDeleteContactSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaContactsDeleteBulkContacts: async (businessId: number, bulkDeleteContactSchema: BulkDeleteContactSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaContactsDeleteBulkContacts', 'businessId', businessId)
            // verify required parameter 'bulkDeleteContactSchema' is not null or undefined
            assertParamExists('usersViewsNinjaContactsDeleteBulkContacts', 'bulkDeleteContactSchema', bulkDeleteContactSchema)
            const localVarPath = `/api/business/{business_id}/contacts/bulk-delete/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkDeleteContactSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Contact
         * @param {number} businessId 
         * @param {string} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaContactsDeleteContact: async (businessId: number, contactId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaContactsDeleteContact', 'businessId', businessId)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('usersViewsNinjaContactsDeleteContact', 'contactId', contactId)
            const localVarPath = `/api/business/{business_id}/contacts/{contact_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Contact To Csv
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaContactsExportContactToCsv: async (businessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaContactsExportContactToCsv', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/contacts/export-csv/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Contacts
         * @param {number} businessId 
         * @param {string | null} [search] 
         * @param {string | null} [tags] 
         * @param {boolean | null} [isPrivate] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaContactsListContacts: async (businessId: number, search?: string | null, tags?: string | null, isPrivate?: boolean | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaContactsListContacts', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/contacts/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (tags !== undefined) {
                localVarQueryParameter['tags'] = tags;
            }

            if (isPrivate !== undefined) {
                localVarQueryParameter['is_private'] = isPrivate;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove Followup Date
         * @param {number} businessId 
         * @param {string} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaContactsRemoveFollowupDate: async (businessId: number, contactId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaContactsRemoveFollowupDate', 'businessId', businessId)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('usersViewsNinjaContactsRemoveFollowupDate', 'contactId', contactId)
            const localVarPath = `/api/business/{business_id}/contacts/{contact_id}/remove-followup-date/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove Tag From Contact
         * @param {number} businessId 
         * @param {string} contactId 
         * @param {TagContactSchema} tagContactSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaContactsRemoveTagFromContact: async (businessId: number, contactId: string, tagContactSchema: TagContactSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaContactsRemoveTagFromContact', 'businessId', businessId)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('usersViewsNinjaContactsRemoveTagFromContact', 'contactId', contactId)
            // verify required parameter 'tagContactSchema' is not null or undefined
            assertParamExists('usersViewsNinjaContactsRemoveTagFromContact', 'tagContactSchema', tagContactSchema)
            const localVarPath = `/api/business/{business_id}/contacts/{contact_id}/untag/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tagContactSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve Contact
         * @param {number} businessId 
         * @param {string} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaContactsRetrieveContact: async (businessId: number, contactId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaContactsRetrieveContact', 'businessId', businessId)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('usersViewsNinjaContactsRetrieveContact', 'contactId', contactId)
            const localVarPath = `/api/business/{business_id}/contacts/{contact_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Tag Contact
         * @param {number} businessId 
         * @param {string} contactId 
         * @param {TagContactSchema} tagContactSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaContactsTagContact: async (businessId: number, contactId: string, tagContactSchema: TagContactSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaContactsTagContact', 'businessId', businessId)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('usersViewsNinjaContactsTagContact', 'contactId', contactId)
            // verify required parameter 'tagContactSchema' is not null or undefined
            assertParamExists('usersViewsNinjaContactsTagContact', 'tagContactSchema', tagContactSchema)
            const localVarPath = `/api/business/{business_id}/contacts/{contact_id}/tag/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tagContactSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Contact
         * @param {number} businessId 
         * @param {string} contactId 
         * @param {UserContactUpdateSchema} userContactUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaContactsUpdateContact: async (businessId: number, contactId: string, userContactUpdateSchema: UserContactUpdateSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaContactsUpdateContact', 'businessId', businessId)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('usersViewsNinjaContactsUpdateContact', 'contactId', contactId)
            // verify required parameter 'userContactUpdateSchema' is not null or undefined
            assertParamExists('usersViewsNinjaContactsUpdateContact', 'userContactUpdateSchema', userContactUpdateSchema)
            const localVarPath = `/api/business/{business_id}/contacts/{contact_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userContactUpdateSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactsApi - functional programming interface
 * @export
 */
export const ContactsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Bulk Contacts
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaContactsCreateBulkContacts(businessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaContactsCreateBulkContacts(businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.usersViewsNinjaContactsCreateBulkContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Bulk Contacts And Distribute To Queues
         * @param {number} businessId 
         * @param {DistributeBulkUploadContactSchema} distributeBulkUploadContactSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaContactsCreateBulkContactsAndDistributeToQueues(businessId: number, distributeBulkUploadContactSchema: DistributeBulkUploadContactSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaContactsCreateBulkContactsAndDistributeToQueues(businessId, distributeBulkUploadContactSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.usersViewsNinjaContactsCreateBulkContactsAndDistributeToQueues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Contact
         * @param {number} businessId 
         * @param {UserContactInSchema} userContactInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaContactsCreateContact(businessId: number, userContactInSchema: UserContactInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserContactOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaContactsCreateContact(businessId, userContactInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.usersViewsNinjaContactsCreateContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Bulk Contacts
         * @param {number} businessId 
         * @param {BulkDeleteContactSchema} bulkDeleteContactSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaContactsDeleteBulkContacts(businessId: number, bulkDeleteContactSchema: BulkDeleteContactSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaContactsDeleteBulkContacts(businessId, bulkDeleteContactSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.usersViewsNinjaContactsDeleteBulkContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Contact
         * @param {number} businessId 
         * @param {string} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaContactsDeleteContact(businessId: number, contactId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaContactsDeleteContact(businessId, contactId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.usersViewsNinjaContactsDeleteContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Contact To Csv
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaContactsExportContactToCsv(businessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaContactsExportContactToCsv(businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.usersViewsNinjaContactsExportContactToCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Contacts
         * @param {number} businessId 
         * @param {string | null} [search] 
         * @param {string | null} [tags] 
         * @param {boolean | null} [isPrivate] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaContactsListContacts(businessId: number, search?: string | null, tags?: string | null, isPrivate?: boolean | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedMinimalUserContactSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaContactsListContacts(businessId, search, tags, isPrivate, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.usersViewsNinjaContactsListContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove Followup Date
         * @param {number} businessId 
         * @param {string} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaContactsRemoveFollowupDate(businessId: number, contactId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserContactOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaContactsRemoveFollowupDate(businessId, contactId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.usersViewsNinjaContactsRemoveFollowupDate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove Tag From Contact
         * @param {number} businessId 
         * @param {string} contactId 
         * @param {TagContactSchema} tagContactSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaContactsRemoveTagFromContact(businessId: number, contactId: string, tagContactSchema: TagContactSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserContactOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaContactsRemoveTagFromContact(businessId, contactId, tagContactSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.usersViewsNinjaContactsRemoveTagFromContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve Contact
         * @param {number} businessId 
         * @param {string} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaContactsRetrieveContact(businessId: number, contactId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserContactOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaContactsRetrieveContact(businessId, contactId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.usersViewsNinjaContactsRetrieveContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Tag Contact
         * @param {number} businessId 
         * @param {string} contactId 
         * @param {TagContactSchema} tagContactSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaContactsTagContact(businessId: number, contactId: string, tagContactSchema: TagContactSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserContactOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaContactsTagContact(businessId, contactId, tagContactSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.usersViewsNinjaContactsTagContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Contact
         * @param {number} businessId 
         * @param {string} contactId 
         * @param {UserContactUpdateSchema} userContactUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaContactsUpdateContact(businessId: number, contactId: string, userContactUpdateSchema: UserContactUpdateSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserContactOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaContactsUpdateContact(businessId, contactId, userContactUpdateSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.usersViewsNinjaContactsUpdateContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContactsApi - factory interface
 * @export
 */
export const ContactsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Bulk Contacts
         * @param {ContactsApiUsersViewsNinjaContactsCreateBulkContactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaContactsCreateBulkContacts(requestParameters: ContactsApiUsersViewsNinjaContactsCreateBulkContactsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaContactsCreateBulkContacts(requestParameters.businessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Bulk Contacts And Distribute To Queues
         * @param {ContactsApiUsersViewsNinjaContactsCreateBulkContactsAndDistributeToQueuesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaContactsCreateBulkContactsAndDistributeToQueues(requestParameters: ContactsApiUsersViewsNinjaContactsCreateBulkContactsAndDistributeToQueuesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaContactsCreateBulkContactsAndDistributeToQueues(requestParameters.businessId, requestParameters.distributeBulkUploadContactSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Contact
         * @param {ContactsApiUsersViewsNinjaContactsCreateContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaContactsCreateContact(requestParameters: ContactsApiUsersViewsNinjaContactsCreateContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserContactOutSchema> {
            return localVarFp.usersViewsNinjaContactsCreateContact(requestParameters.businessId, requestParameters.userContactInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Bulk Contacts
         * @param {ContactsApiUsersViewsNinjaContactsDeleteBulkContactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaContactsDeleteBulkContacts(requestParameters: ContactsApiUsersViewsNinjaContactsDeleteBulkContactsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaContactsDeleteBulkContacts(requestParameters.businessId, requestParameters.bulkDeleteContactSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Contact
         * @param {ContactsApiUsersViewsNinjaContactsDeleteContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaContactsDeleteContact(requestParameters: ContactsApiUsersViewsNinjaContactsDeleteContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.usersViewsNinjaContactsDeleteContact(requestParameters.businessId, requestParameters.contactId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Contact To Csv
         * @param {ContactsApiUsersViewsNinjaContactsExportContactToCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaContactsExportContactToCsv(requestParameters: ContactsApiUsersViewsNinjaContactsExportContactToCsvRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.usersViewsNinjaContactsExportContactToCsv(requestParameters.businessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Contacts
         * @param {ContactsApiUsersViewsNinjaContactsListContactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaContactsListContacts(requestParameters: ContactsApiUsersViewsNinjaContactsListContactsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedMinimalUserContactSchema> {
            return localVarFp.usersViewsNinjaContactsListContacts(requestParameters.businessId, requestParameters.search, requestParameters.tags, requestParameters.isPrivate, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove Followup Date
         * @param {ContactsApiUsersViewsNinjaContactsRemoveFollowupDateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaContactsRemoveFollowupDate(requestParameters: ContactsApiUsersViewsNinjaContactsRemoveFollowupDateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserContactOutSchema> {
            return localVarFp.usersViewsNinjaContactsRemoveFollowupDate(requestParameters.businessId, requestParameters.contactId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove Tag From Contact
         * @param {ContactsApiUsersViewsNinjaContactsRemoveTagFromContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaContactsRemoveTagFromContact(requestParameters: ContactsApiUsersViewsNinjaContactsRemoveTagFromContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserContactOutSchema> {
            return localVarFp.usersViewsNinjaContactsRemoveTagFromContact(requestParameters.businessId, requestParameters.contactId, requestParameters.tagContactSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve Contact
         * @param {ContactsApiUsersViewsNinjaContactsRetrieveContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaContactsRetrieveContact(requestParameters: ContactsApiUsersViewsNinjaContactsRetrieveContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserContactOutSchema> {
            return localVarFp.usersViewsNinjaContactsRetrieveContact(requestParameters.businessId, requestParameters.contactId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Tag Contact
         * @param {ContactsApiUsersViewsNinjaContactsTagContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaContactsTagContact(requestParameters: ContactsApiUsersViewsNinjaContactsTagContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserContactOutSchema> {
            return localVarFp.usersViewsNinjaContactsTagContact(requestParameters.businessId, requestParameters.contactId, requestParameters.tagContactSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Contact
         * @param {ContactsApiUsersViewsNinjaContactsUpdateContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaContactsUpdateContact(requestParameters: ContactsApiUsersViewsNinjaContactsUpdateContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserContactOutSchema> {
            return localVarFp.usersViewsNinjaContactsUpdateContact(requestParameters.businessId, requestParameters.contactId, requestParameters.userContactUpdateSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for usersViewsNinjaContactsCreateBulkContacts operation in ContactsApi.
 * @export
 * @interface ContactsApiUsersViewsNinjaContactsCreateBulkContactsRequest
 */
export interface ContactsApiUsersViewsNinjaContactsCreateBulkContactsRequest {
    /**
     * 
     * @type {number}
     * @memberof ContactsApiUsersViewsNinjaContactsCreateBulkContacts
     */
    readonly businessId: number
}

/**
 * Request parameters for usersViewsNinjaContactsCreateBulkContactsAndDistributeToQueues operation in ContactsApi.
 * @export
 * @interface ContactsApiUsersViewsNinjaContactsCreateBulkContactsAndDistributeToQueuesRequest
 */
export interface ContactsApiUsersViewsNinjaContactsCreateBulkContactsAndDistributeToQueuesRequest {
    /**
     * 
     * @type {number}
     * @memberof ContactsApiUsersViewsNinjaContactsCreateBulkContactsAndDistributeToQueues
     */
    readonly businessId: number

    /**
     * 
     * @type {DistributeBulkUploadContactSchema}
     * @memberof ContactsApiUsersViewsNinjaContactsCreateBulkContactsAndDistributeToQueues
     */
    readonly distributeBulkUploadContactSchema: DistributeBulkUploadContactSchema
}

/**
 * Request parameters for usersViewsNinjaContactsCreateContact operation in ContactsApi.
 * @export
 * @interface ContactsApiUsersViewsNinjaContactsCreateContactRequest
 */
export interface ContactsApiUsersViewsNinjaContactsCreateContactRequest {
    /**
     * 
     * @type {number}
     * @memberof ContactsApiUsersViewsNinjaContactsCreateContact
     */
    readonly businessId: number

    /**
     * 
     * @type {UserContactInSchema}
     * @memberof ContactsApiUsersViewsNinjaContactsCreateContact
     */
    readonly userContactInSchema: UserContactInSchema
}

/**
 * Request parameters for usersViewsNinjaContactsDeleteBulkContacts operation in ContactsApi.
 * @export
 * @interface ContactsApiUsersViewsNinjaContactsDeleteBulkContactsRequest
 */
export interface ContactsApiUsersViewsNinjaContactsDeleteBulkContactsRequest {
    /**
     * 
     * @type {number}
     * @memberof ContactsApiUsersViewsNinjaContactsDeleteBulkContacts
     */
    readonly businessId: number

    /**
     * 
     * @type {BulkDeleteContactSchema}
     * @memberof ContactsApiUsersViewsNinjaContactsDeleteBulkContacts
     */
    readonly bulkDeleteContactSchema: BulkDeleteContactSchema
}

/**
 * Request parameters for usersViewsNinjaContactsDeleteContact operation in ContactsApi.
 * @export
 * @interface ContactsApiUsersViewsNinjaContactsDeleteContactRequest
 */
export interface ContactsApiUsersViewsNinjaContactsDeleteContactRequest {
    /**
     * 
     * @type {number}
     * @memberof ContactsApiUsersViewsNinjaContactsDeleteContact
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof ContactsApiUsersViewsNinjaContactsDeleteContact
     */
    readonly contactId: string
}

/**
 * Request parameters for usersViewsNinjaContactsExportContactToCsv operation in ContactsApi.
 * @export
 * @interface ContactsApiUsersViewsNinjaContactsExportContactToCsvRequest
 */
export interface ContactsApiUsersViewsNinjaContactsExportContactToCsvRequest {
    /**
     * 
     * @type {number}
     * @memberof ContactsApiUsersViewsNinjaContactsExportContactToCsv
     */
    readonly businessId: number
}

/**
 * Request parameters for usersViewsNinjaContactsListContacts operation in ContactsApi.
 * @export
 * @interface ContactsApiUsersViewsNinjaContactsListContactsRequest
 */
export interface ContactsApiUsersViewsNinjaContactsListContactsRequest {
    /**
     * 
     * @type {number}
     * @memberof ContactsApiUsersViewsNinjaContactsListContacts
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof ContactsApiUsersViewsNinjaContactsListContacts
     */
    readonly search?: string | null

    /**
     * 
     * @type {string}
     * @memberof ContactsApiUsersViewsNinjaContactsListContacts
     */
    readonly tags?: string | null

    /**
     * 
     * @type {boolean}
     * @memberof ContactsApiUsersViewsNinjaContactsListContacts
     */
    readonly isPrivate?: boolean | null

    /**
     * 
     * @type {number}
     * @memberof ContactsApiUsersViewsNinjaContactsListContacts
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof ContactsApiUsersViewsNinjaContactsListContacts
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof ContactsApiUsersViewsNinjaContactsListContacts
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for usersViewsNinjaContactsRemoveFollowupDate operation in ContactsApi.
 * @export
 * @interface ContactsApiUsersViewsNinjaContactsRemoveFollowupDateRequest
 */
export interface ContactsApiUsersViewsNinjaContactsRemoveFollowupDateRequest {
    /**
     * 
     * @type {number}
     * @memberof ContactsApiUsersViewsNinjaContactsRemoveFollowupDate
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof ContactsApiUsersViewsNinjaContactsRemoveFollowupDate
     */
    readonly contactId: string
}

/**
 * Request parameters for usersViewsNinjaContactsRemoveTagFromContact operation in ContactsApi.
 * @export
 * @interface ContactsApiUsersViewsNinjaContactsRemoveTagFromContactRequest
 */
export interface ContactsApiUsersViewsNinjaContactsRemoveTagFromContactRequest {
    /**
     * 
     * @type {number}
     * @memberof ContactsApiUsersViewsNinjaContactsRemoveTagFromContact
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof ContactsApiUsersViewsNinjaContactsRemoveTagFromContact
     */
    readonly contactId: string

    /**
     * 
     * @type {TagContactSchema}
     * @memberof ContactsApiUsersViewsNinjaContactsRemoveTagFromContact
     */
    readonly tagContactSchema: TagContactSchema
}

/**
 * Request parameters for usersViewsNinjaContactsRetrieveContact operation in ContactsApi.
 * @export
 * @interface ContactsApiUsersViewsNinjaContactsRetrieveContactRequest
 */
export interface ContactsApiUsersViewsNinjaContactsRetrieveContactRequest {
    /**
     * 
     * @type {number}
     * @memberof ContactsApiUsersViewsNinjaContactsRetrieveContact
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof ContactsApiUsersViewsNinjaContactsRetrieveContact
     */
    readonly contactId: string
}

/**
 * Request parameters for usersViewsNinjaContactsTagContact operation in ContactsApi.
 * @export
 * @interface ContactsApiUsersViewsNinjaContactsTagContactRequest
 */
export interface ContactsApiUsersViewsNinjaContactsTagContactRequest {
    /**
     * 
     * @type {number}
     * @memberof ContactsApiUsersViewsNinjaContactsTagContact
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof ContactsApiUsersViewsNinjaContactsTagContact
     */
    readonly contactId: string

    /**
     * 
     * @type {TagContactSchema}
     * @memberof ContactsApiUsersViewsNinjaContactsTagContact
     */
    readonly tagContactSchema: TagContactSchema
}

/**
 * Request parameters for usersViewsNinjaContactsUpdateContact operation in ContactsApi.
 * @export
 * @interface ContactsApiUsersViewsNinjaContactsUpdateContactRequest
 */
export interface ContactsApiUsersViewsNinjaContactsUpdateContactRequest {
    /**
     * 
     * @type {number}
     * @memberof ContactsApiUsersViewsNinjaContactsUpdateContact
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof ContactsApiUsersViewsNinjaContactsUpdateContact
     */
    readonly contactId: string

    /**
     * 
     * @type {UserContactUpdateSchema}
     * @memberof ContactsApiUsersViewsNinjaContactsUpdateContact
     */
    readonly userContactUpdateSchema: UserContactUpdateSchema
}

/**
 * ContactsApi - object-oriented interface
 * @export
 * @class ContactsApi
 * @extends {BaseAPI}
 */
export class ContactsApi extends BaseAPI {
    /**
     * 
     * @summary Create Bulk Contacts
     * @param {ContactsApiUsersViewsNinjaContactsCreateBulkContactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public usersViewsNinjaContactsCreateBulkContacts(requestParameters: ContactsApiUsersViewsNinjaContactsCreateBulkContactsRequest, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).usersViewsNinjaContactsCreateBulkContacts(requestParameters.businessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Bulk Contacts And Distribute To Queues
     * @param {ContactsApiUsersViewsNinjaContactsCreateBulkContactsAndDistributeToQueuesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public usersViewsNinjaContactsCreateBulkContactsAndDistributeToQueues(requestParameters: ContactsApiUsersViewsNinjaContactsCreateBulkContactsAndDistributeToQueuesRequest, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).usersViewsNinjaContactsCreateBulkContactsAndDistributeToQueues(requestParameters.businessId, requestParameters.distributeBulkUploadContactSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Contact
     * @param {ContactsApiUsersViewsNinjaContactsCreateContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public usersViewsNinjaContactsCreateContact(requestParameters: ContactsApiUsersViewsNinjaContactsCreateContactRequest, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).usersViewsNinjaContactsCreateContact(requestParameters.businessId, requestParameters.userContactInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Bulk Contacts
     * @param {ContactsApiUsersViewsNinjaContactsDeleteBulkContactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public usersViewsNinjaContactsDeleteBulkContacts(requestParameters: ContactsApiUsersViewsNinjaContactsDeleteBulkContactsRequest, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).usersViewsNinjaContactsDeleteBulkContacts(requestParameters.businessId, requestParameters.bulkDeleteContactSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Contact
     * @param {ContactsApiUsersViewsNinjaContactsDeleteContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public usersViewsNinjaContactsDeleteContact(requestParameters: ContactsApiUsersViewsNinjaContactsDeleteContactRequest, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).usersViewsNinjaContactsDeleteContact(requestParameters.businessId, requestParameters.contactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Contact To Csv
     * @param {ContactsApiUsersViewsNinjaContactsExportContactToCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public usersViewsNinjaContactsExportContactToCsv(requestParameters: ContactsApiUsersViewsNinjaContactsExportContactToCsvRequest, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).usersViewsNinjaContactsExportContactToCsv(requestParameters.businessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Contacts
     * @param {ContactsApiUsersViewsNinjaContactsListContactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public usersViewsNinjaContactsListContacts(requestParameters: ContactsApiUsersViewsNinjaContactsListContactsRequest, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).usersViewsNinjaContactsListContacts(requestParameters.businessId, requestParameters.search, requestParameters.tags, requestParameters.isPrivate, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove Followup Date
     * @param {ContactsApiUsersViewsNinjaContactsRemoveFollowupDateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public usersViewsNinjaContactsRemoveFollowupDate(requestParameters: ContactsApiUsersViewsNinjaContactsRemoveFollowupDateRequest, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).usersViewsNinjaContactsRemoveFollowupDate(requestParameters.businessId, requestParameters.contactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove Tag From Contact
     * @param {ContactsApiUsersViewsNinjaContactsRemoveTagFromContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public usersViewsNinjaContactsRemoveTagFromContact(requestParameters: ContactsApiUsersViewsNinjaContactsRemoveTagFromContactRequest, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).usersViewsNinjaContactsRemoveTagFromContact(requestParameters.businessId, requestParameters.contactId, requestParameters.tagContactSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve Contact
     * @param {ContactsApiUsersViewsNinjaContactsRetrieveContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public usersViewsNinjaContactsRetrieveContact(requestParameters: ContactsApiUsersViewsNinjaContactsRetrieveContactRequest, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).usersViewsNinjaContactsRetrieveContact(requestParameters.businessId, requestParameters.contactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Tag Contact
     * @param {ContactsApiUsersViewsNinjaContactsTagContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public usersViewsNinjaContactsTagContact(requestParameters: ContactsApiUsersViewsNinjaContactsTagContactRequest, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).usersViewsNinjaContactsTagContact(requestParameters.businessId, requestParameters.contactId, requestParameters.tagContactSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Contact
     * @param {ContactsApiUsersViewsNinjaContactsUpdateContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public usersViewsNinjaContactsUpdateContact(requestParameters: ContactsApiUsersViewsNinjaContactsUpdateContactRequest, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).usersViewsNinjaContactsUpdateContact(requestParameters.businessId, requestParameters.contactId, requestParameters.userContactUpdateSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ConversationsApi - axios parameter creator
 * @export
 */
export const ConversationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Conversation Pusher Auth
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationConversationPusherAuth: async (conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('messagingViewsConversationConversationPusherAuth', 'conversationId', conversationId)
            const localVarPath = `/api/business/conversations/{conversation_id}/pusher/auth/`
                .replace(`{${"conversation_id"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ConversationGuestAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Conversation
         * @param {number} businessId 
         * @param {ConversationInSchema} conversationInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationCreateConversation: async (businessId: number, conversationInSchema: ConversationInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('messagingViewsConversationCreateConversation', 'businessId', businessId)
            // verify required parameter 'conversationInSchema' is not null or undefined
            assertParamExists('messagingViewsConversationCreateConversation', 'conversationInSchema', conversationInSchema)
            const localVarPath = `/api/business/{business_id}/conversations/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversationInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Conversation From Item
         * @param {number} businessId 
         * @param {string} contactId 
         * @param {ConversationItemInSchema} conversationItemInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationCreateConversationFromItem: async (businessId: number, contactId: string, conversationItemInSchema: ConversationItemInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('messagingViewsConversationCreateConversationFromItem', 'businessId', businessId)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('messagingViewsConversationCreateConversationFromItem', 'contactId', contactId)
            // verify required parameter 'conversationItemInSchema' is not null or undefined
            assertParamExists('messagingViewsConversationCreateConversationFromItem', 'conversationItemInSchema', conversationItemInSchema)
            const localVarPath = `/api/business/{business_id}/conversations/item-conversation/{contact_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversationItemInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Conversation Item
         * @param {number} businessId 
         * @param {string} conversationId 
         * @param {ConversationItemInSchema} conversationItemInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationCreateConversationItem: async (businessId: number, conversationId: string, conversationItemInSchema: ConversationItemInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('messagingViewsConversationCreateConversationItem', 'businessId', businessId)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('messagingViewsConversationCreateConversationItem', 'conversationId', conversationId)
            // verify required parameter 'conversationItemInSchema' is not null or undefined
            assertParamExists('messagingViewsConversationCreateConversationItem', 'conversationItemInSchema', conversationItemInSchema)
            const localVarPath = `/api/business/{business_id}/conversations/{conversation_id}/items/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"conversation_id"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversationItemInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Conversation Item As Guest
         * @param {string} conversationId 
         * @param {string} invitationId 
         * @param {ConversationItemInSchema} conversationItemInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationCreateConversationItemAsGuest: async (conversationId: string, invitationId: string, conversationItemInSchema: ConversationItemInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('messagingViewsConversationCreateConversationItemAsGuest', 'conversationId', conversationId)
            // verify required parameter 'invitationId' is not null or undefined
            assertParamExists('messagingViewsConversationCreateConversationItemAsGuest', 'invitationId', invitationId)
            // verify required parameter 'conversationItemInSchema' is not null or undefined
            assertParamExists('messagingViewsConversationCreateConversationItemAsGuest', 'conversationItemInSchema', conversationItemInSchema)
            const localVarPath = `/api/business/conversations/{conversation_id}/invitation/{invitation_id}/guest/items/`
                .replace(`{${"conversation_id"}}`, encodeURIComponent(String(conversationId)))
                .replace(`{${"invitation_id"}}`, encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ConversationGuestAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversationItemInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Conversation Note
         * @param {number} businessId 
         * @param {string} conversationId 
         * @param {ConversationNoteInSchema} conversationNoteInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationCreateConversationNote: async (businessId: number, conversationId: string, conversationNoteInSchema: ConversationNoteInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('messagingViewsConversationCreateConversationNote', 'businessId', businessId)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('messagingViewsConversationCreateConversationNote', 'conversationId', conversationId)
            // verify required parameter 'conversationNoteInSchema' is not null or undefined
            assertParamExists('messagingViewsConversationCreateConversationNote', 'conversationNoteInSchema', conversationNoteInSchema)
            const localVarPath = `/api/business/{business_id}/conversations/{conversation_id}/notes/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"conversation_id"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversationNoteInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Conversation Invitation
         * @param {string} conversationId 
         * @param {string} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationGetConversationInvitation: async (conversationId: string, invitationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('messagingViewsConversationGetConversationInvitation', 'conversationId', conversationId)
            // verify required parameter 'invitationId' is not null or undefined
            assertParamExists('messagingViewsConversationGetConversationInvitation', 'invitationId', invitationId)
            const localVarPath = `/api/business/conversations/{conversation_id}/invitation/{invitation_id}/`
                .replace(`{${"conversation_id"}}`, encodeURIComponent(String(conversationId)))
                .replace(`{${"invitation_id"}}`, encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ConversationGuestAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Exisiting Contact Conversation
         * @param {number} businessId 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationGetExisitingContactConversation: async (businessId: number, customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('messagingViewsConversationGetExisitingContactConversation', 'businessId', businessId)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('messagingViewsConversationGetExisitingContactConversation', 'customerId', customerId)
            const localVarPath = `/api/business/{business_id}/conversations/existing-conversations/{customer_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"customer_id"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Presigned Upload Url
         * @param {number} businessId 
         * @param {string} conversationId 
         * @param {PresignedURLInSchema} presignedURLInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationGetPresignedUploadUrl: async (businessId: number, conversationId: string, presignedURLInSchema: PresignedURLInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('messagingViewsConversationGetPresignedUploadUrl', 'businessId', businessId)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('messagingViewsConversationGetPresignedUploadUrl', 'conversationId', conversationId)
            // verify required parameter 'presignedURLInSchema' is not null or undefined
            assertParamExists('messagingViewsConversationGetPresignedUploadUrl', 'presignedURLInSchema', presignedURLInSchema)
            const localVarPath = `/api/business/{business_id}/conversations/{conversation_id}/presigned-url/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"conversation_id"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(presignedURLInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Guest Get Presigned Upload Url
         * @param {string} invitationId 
         * @param {string} conversationId 
         * @param {PresignedURLInSchema} presignedURLInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationGuestGetPresignedUploadUrl: async (invitationId: string, conversationId: string, presignedURLInSchema: PresignedURLInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitationId' is not null or undefined
            assertParamExists('messagingViewsConversationGuestGetPresignedUploadUrl', 'invitationId', invitationId)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('messagingViewsConversationGuestGetPresignedUploadUrl', 'conversationId', conversationId)
            // verify required parameter 'presignedURLInSchema' is not null or undefined
            assertParamExists('messagingViewsConversationGuestGetPresignedUploadUrl', 'presignedURLInSchema', presignedURLInSchema)
            const localVarPath = `/api/business/conversations/{conversation_id}/invitation/{invitation_id}/guest/presigned-url/`
                .replace(`{${"invitation_id"}}`, encodeURIComponent(String(invitationId)))
                .replace(`{${"conversation_id"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ConversationGuestAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(presignedURLInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Invite Conversation Participants
         * @param {number} businessId 
         * @param {string} conversationId 
         * @param {ConversationParticipantsInSchema} conversationParticipantsInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationInviteConversationParticipants: async (businessId: number, conversationId: string, conversationParticipantsInSchema: ConversationParticipantsInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('messagingViewsConversationInviteConversationParticipants', 'businessId', businessId)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('messagingViewsConversationInviteConversationParticipants', 'conversationId', conversationId)
            // verify required parameter 'conversationParticipantsInSchema' is not null or undefined
            assertParamExists('messagingViewsConversationInviteConversationParticipants', 'conversationParticipantsInSchema', conversationParticipantsInSchema)
            const localVarPath = `/api/business/{business_id}/conversations/{conversation_id}/participants/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"conversation_id"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversationParticipantsInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Leave Conversation
         * @param {number} businessId 
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationLeaveConversation: async (businessId: number, conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('messagingViewsConversationLeaveConversation', 'businessId', businessId)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('messagingViewsConversationLeaveConversation', 'conversationId', conversationId)
            const localVarPath = `/api/business/{business_id}/conversations/{conversation_id}/leave/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"conversation_id"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Conversation Item
         * @param {number} businessId 
         * @param {string} conversationId 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationListConversationItem: async (businessId: number, conversationId: string, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('messagingViewsConversationListConversationItem', 'businessId', businessId)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('messagingViewsConversationListConversationItem', 'conversationId', conversationId)
            const localVarPath = `/api/business/{business_id}/conversations/{conversation_id}/items/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"conversation_id"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Conversation Item As Guest
         * @param {string} conversationId 
         * @param {string} invitationId 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationListConversationItemAsGuest: async (conversationId: string, invitationId: string, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('messagingViewsConversationListConversationItemAsGuest', 'conversationId', conversationId)
            // verify required parameter 'invitationId' is not null or undefined
            assertParamExists('messagingViewsConversationListConversationItemAsGuest', 'invitationId', invitationId)
            const localVarPath = `/api/business/conversations/{conversation_id}/invitation/{invitation_id}/guest/items/`
                .replace(`{${"conversation_id"}}`, encodeURIComponent(String(conversationId)))
                .replace(`{${"invitation_id"}}`, encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ConversationGuestAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Conversation Note
         * @param {number} businessId 
         * @param {string} conversationId 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationListConversationNote: async (businessId: number, conversationId: string, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('messagingViewsConversationListConversationNote', 'businessId', businessId)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('messagingViewsConversationListConversationNote', 'conversationId', conversationId)
            const localVarPath = `/api/business/{business_id}/conversations/{conversation_id}/notes/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"conversation_id"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Conversations
         * @param {number} businessId 
         * @param {string | null} [search] 
         * @param {ConversationStatus | null} [status] 
         * @param {ConversationType | null} [type] 
         * @param {Array<number> | null} [createdBy] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationListConversations: async (businessId: number, search?: string | null, status?: ConversationStatus | null, type?: ConversationType | null, createdBy?: Array<number> | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('messagingViewsConversationListConversations', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/conversations/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (createdBy) {
                localVarQueryParameter['created_by'] = createdBy;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Conversation
         * @param {number} businessId 
         * @param {string} conversationId 
         * @param {ConversartionUpdateSchema} conversartionUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationUpdateConversation: async (businessId: number, conversationId: string, conversartionUpdateSchema: ConversartionUpdateSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('messagingViewsConversationUpdateConversation', 'businessId', businessId)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('messagingViewsConversationUpdateConversation', 'conversationId', conversationId)
            // verify required parameter 'conversartionUpdateSchema' is not null or undefined
            assertParamExists('messagingViewsConversationUpdateConversation', 'conversartionUpdateSchema', conversartionUpdateSchema)
            const localVarPath = `/api/business/{business_id}/conversations/{conversation_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"conversation_id"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversartionUpdateSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConversationsApi - functional programming interface
 * @export
 */
export const ConversationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConversationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Conversation Pusher Auth
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingViewsConversationConversationPusherAuth(conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PusherAuthOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingViewsConversationConversationPusherAuth(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsApi.messagingViewsConversationConversationPusherAuth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Conversation
         * @param {number} businessId 
         * @param {ConversationInSchema} conversationInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingViewsConversationCreateConversation(businessId: number, conversationInSchema: ConversationInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingViewsConversationCreateConversation(businessId, conversationInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsApi.messagingViewsConversationCreateConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Conversation From Item
         * @param {number} businessId 
         * @param {string} contactId 
         * @param {ConversationItemInSchema} conversationItemInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingViewsConversationCreateConversationFromItem(businessId: number, contactId: string, conversationItemInSchema: ConversationItemInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationItemOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingViewsConversationCreateConversationFromItem(businessId, contactId, conversationItemInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsApi.messagingViewsConversationCreateConversationFromItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Conversation Item
         * @param {number} businessId 
         * @param {string} conversationId 
         * @param {ConversationItemInSchema} conversationItemInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingViewsConversationCreateConversationItem(businessId: number, conversationId: string, conversationItemInSchema: ConversationItemInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationItemOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingViewsConversationCreateConversationItem(businessId, conversationId, conversationItemInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsApi.messagingViewsConversationCreateConversationItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Conversation Item As Guest
         * @param {string} conversationId 
         * @param {string} invitationId 
         * @param {ConversationItemInSchema} conversationItemInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingViewsConversationCreateConversationItemAsGuest(conversationId: string, invitationId: string, conversationItemInSchema: ConversationItemInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationItemOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingViewsConversationCreateConversationItemAsGuest(conversationId, invitationId, conversationItemInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsApi.messagingViewsConversationCreateConversationItemAsGuest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Conversation Note
         * @param {number} businessId 
         * @param {string} conversationId 
         * @param {ConversationNoteInSchema} conversationNoteInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingViewsConversationCreateConversationNote(businessId: number, conversationId: string, conversationNoteInSchema: ConversationNoteInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationNoteOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingViewsConversationCreateConversationNote(businessId, conversationId, conversationNoteInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsApi.messagingViewsConversationCreateConversationNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Conversation Invitation
         * @param {string} conversationId 
         * @param {string} invitationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingViewsConversationGetConversationInvitation(conversationId: string, invitationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationInvitationOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingViewsConversationGetConversationInvitation(conversationId, invitationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsApi.messagingViewsConversationGetConversationInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Exisiting Contact Conversation
         * @param {number} businessId 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingViewsConversationGetExisitingContactConversation(businessId: number, customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingViewsConversationGetExisitingContactConversation(businessId, customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsApi.messagingViewsConversationGetExisitingContactConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Presigned Upload Url
         * @param {number} businessId 
         * @param {string} conversationId 
         * @param {PresignedURLInSchema} presignedURLInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingViewsConversationGetPresignedUploadUrl(businessId: number, conversationId: string, presignedURLInSchema: PresignedURLInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingViewsConversationGetPresignedUploadUrl(businessId, conversationId, presignedURLInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsApi.messagingViewsConversationGetPresignedUploadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Guest Get Presigned Upload Url
         * @param {string} invitationId 
         * @param {string} conversationId 
         * @param {PresignedURLInSchema} presignedURLInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingViewsConversationGuestGetPresignedUploadUrl(invitationId: string, conversationId: string, presignedURLInSchema: PresignedURLInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingViewsConversationGuestGetPresignedUploadUrl(invitationId, conversationId, presignedURLInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsApi.messagingViewsConversationGuestGetPresignedUploadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Invite Conversation Participants
         * @param {number} businessId 
         * @param {string} conversationId 
         * @param {ConversationParticipantsInSchema} conversationParticipantsInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingViewsConversationInviteConversationParticipants(businessId: number, conversationId: string, conversationParticipantsInSchema: ConversationParticipantsInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationParticipantsOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingViewsConversationInviteConversationParticipants(businessId, conversationId, conversationParticipantsInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsApi.messagingViewsConversationInviteConversationParticipants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Leave Conversation
         * @param {number} businessId 
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingViewsConversationLeaveConversation(businessId: number, conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingViewsConversationLeaveConversation(businessId, conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsApi.messagingViewsConversationLeaveConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Conversation Item
         * @param {number} businessId 
         * @param {string} conversationId 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingViewsConversationListConversationItem(businessId: number, conversationId: string, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedConversationItemOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingViewsConversationListConversationItem(businessId, conversationId, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsApi.messagingViewsConversationListConversationItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Conversation Item As Guest
         * @param {string} conversationId 
         * @param {string} invitationId 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingViewsConversationListConversationItemAsGuest(conversationId: string, invitationId: string, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedConversationItemOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingViewsConversationListConversationItemAsGuest(conversationId, invitationId, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsApi.messagingViewsConversationListConversationItemAsGuest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Conversation Note
         * @param {number} businessId 
         * @param {string} conversationId 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingViewsConversationListConversationNote(businessId: number, conversationId: string, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedConversationNoteOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingViewsConversationListConversationNote(businessId, conversationId, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsApi.messagingViewsConversationListConversationNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Conversations
         * @param {number} businessId 
         * @param {string | null} [search] 
         * @param {ConversationStatus | null} [status] 
         * @param {ConversationType | null} [type] 
         * @param {Array<number> | null} [createdBy] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingViewsConversationListConversations(businessId: number, search?: string | null, status?: ConversationStatus | null, type?: ConversationType | null, createdBy?: Array<number> | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedConversationOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingViewsConversationListConversations(businessId, search, status, type, createdBy, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsApi.messagingViewsConversationListConversations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Conversation
         * @param {number} businessId 
         * @param {string} conversationId 
         * @param {ConversartionUpdateSchema} conversartionUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingViewsConversationUpdateConversation(businessId: number, conversationId: string, conversartionUpdateSchema: ConversartionUpdateSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingViewsConversationUpdateConversation(businessId, conversationId, conversartionUpdateSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsApi.messagingViewsConversationUpdateConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConversationsApi - factory interface
 * @export
 */
export const ConversationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConversationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Conversation Pusher Auth
         * @param {ConversationsApiMessagingViewsConversationConversationPusherAuthRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationConversationPusherAuth(requestParameters: ConversationsApiMessagingViewsConversationConversationPusherAuthRequest, options?: RawAxiosRequestConfig): AxiosPromise<PusherAuthOutSchema> {
            return localVarFp.messagingViewsConversationConversationPusherAuth(requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Conversation
         * @param {ConversationsApiMessagingViewsConversationCreateConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationCreateConversation(requestParameters: ConversationsApiMessagingViewsConversationCreateConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConversationOutSchema> {
            return localVarFp.messagingViewsConversationCreateConversation(requestParameters.businessId, requestParameters.conversationInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Conversation From Item
         * @param {ConversationsApiMessagingViewsConversationCreateConversationFromItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationCreateConversationFromItem(requestParameters: ConversationsApiMessagingViewsConversationCreateConversationFromItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConversationItemOutSchema> {
            return localVarFp.messagingViewsConversationCreateConversationFromItem(requestParameters.businessId, requestParameters.contactId, requestParameters.conversationItemInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Conversation Item
         * @param {ConversationsApiMessagingViewsConversationCreateConversationItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationCreateConversationItem(requestParameters: ConversationsApiMessagingViewsConversationCreateConversationItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConversationItemOutSchema> {
            return localVarFp.messagingViewsConversationCreateConversationItem(requestParameters.businessId, requestParameters.conversationId, requestParameters.conversationItemInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Conversation Item As Guest
         * @param {ConversationsApiMessagingViewsConversationCreateConversationItemAsGuestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationCreateConversationItemAsGuest(requestParameters: ConversationsApiMessagingViewsConversationCreateConversationItemAsGuestRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConversationItemOutSchema> {
            return localVarFp.messagingViewsConversationCreateConversationItemAsGuest(requestParameters.conversationId, requestParameters.invitationId, requestParameters.conversationItemInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Conversation Note
         * @param {ConversationsApiMessagingViewsConversationCreateConversationNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationCreateConversationNote(requestParameters: ConversationsApiMessagingViewsConversationCreateConversationNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConversationNoteOutSchema> {
            return localVarFp.messagingViewsConversationCreateConversationNote(requestParameters.businessId, requestParameters.conversationId, requestParameters.conversationNoteInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Conversation Invitation
         * @param {ConversationsApiMessagingViewsConversationGetConversationInvitationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationGetConversationInvitation(requestParameters: ConversationsApiMessagingViewsConversationGetConversationInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConversationInvitationOutSchema> {
            return localVarFp.messagingViewsConversationGetConversationInvitation(requestParameters.conversationId, requestParameters.invitationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Exisiting Contact Conversation
         * @param {ConversationsApiMessagingViewsConversationGetExisitingContactConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationGetExisitingContactConversation(requestParameters: ConversationsApiMessagingViewsConversationGetExisitingContactConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConversationOutSchema> {
            return localVarFp.messagingViewsConversationGetExisitingContactConversation(requestParameters.businessId, requestParameters.customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Presigned Upload Url
         * @param {ConversationsApiMessagingViewsConversationGetPresignedUploadUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationGetPresignedUploadUrl(requestParameters: ConversationsApiMessagingViewsConversationGetPresignedUploadUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.messagingViewsConversationGetPresignedUploadUrl(requestParameters.businessId, requestParameters.conversationId, requestParameters.presignedURLInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Guest Get Presigned Upload Url
         * @param {ConversationsApiMessagingViewsConversationGuestGetPresignedUploadUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationGuestGetPresignedUploadUrl(requestParameters: ConversationsApiMessagingViewsConversationGuestGetPresignedUploadUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.messagingViewsConversationGuestGetPresignedUploadUrl(requestParameters.invitationId, requestParameters.conversationId, requestParameters.presignedURLInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Invite Conversation Participants
         * @param {ConversationsApiMessagingViewsConversationInviteConversationParticipantsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationInviteConversationParticipants(requestParameters: ConversationsApiMessagingViewsConversationInviteConversationParticipantsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConversationParticipantsOutSchema> {
            return localVarFp.messagingViewsConversationInviteConversationParticipants(requestParameters.businessId, requestParameters.conversationId, requestParameters.conversationParticipantsInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Leave Conversation
         * @param {ConversationsApiMessagingViewsConversationLeaveConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationLeaveConversation(requestParameters: ConversationsApiMessagingViewsConversationLeaveConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.messagingViewsConversationLeaveConversation(requestParameters.businessId, requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Conversation Item
         * @param {ConversationsApiMessagingViewsConversationListConversationItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationListConversationItem(requestParameters: ConversationsApiMessagingViewsConversationListConversationItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedConversationItemOutSchema> {
            return localVarFp.messagingViewsConversationListConversationItem(requestParameters.businessId, requestParameters.conversationId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Conversation Item As Guest
         * @param {ConversationsApiMessagingViewsConversationListConversationItemAsGuestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationListConversationItemAsGuest(requestParameters: ConversationsApiMessagingViewsConversationListConversationItemAsGuestRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedConversationItemOutSchema> {
            return localVarFp.messagingViewsConversationListConversationItemAsGuest(requestParameters.conversationId, requestParameters.invitationId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Conversation Note
         * @param {ConversationsApiMessagingViewsConversationListConversationNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationListConversationNote(requestParameters: ConversationsApiMessagingViewsConversationListConversationNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedConversationNoteOutSchema> {
            return localVarFp.messagingViewsConversationListConversationNote(requestParameters.businessId, requestParameters.conversationId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Conversations
         * @param {ConversationsApiMessagingViewsConversationListConversationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationListConversations(requestParameters: ConversationsApiMessagingViewsConversationListConversationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedConversationOutSchema> {
            return localVarFp.messagingViewsConversationListConversations(requestParameters.businessId, requestParameters.search, requestParameters.status, requestParameters.type, requestParameters.createdBy, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Conversation
         * @param {ConversationsApiMessagingViewsConversationUpdateConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsConversationUpdateConversation(requestParameters: ConversationsApiMessagingViewsConversationUpdateConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConversationOutSchema> {
            return localVarFp.messagingViewsConversationUpdateConversation(requestParameters.businessId, requestParameters.conversationId, requestParameters.conversartionUpdateSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for messagingViewsConversationConversationPusherAuth operation in ConversationsApi.
 * @export
 * @interface ConversationsApiMessagingViewsConversationConversationPusherAuthRequest
 */
export interface ConversationsApiMessagingViewsConversationConversationPusherAuthRequest {
    /**
     * 
     * @type {string}
     * @memberof ConversationsApiMessagingViewsConversationConversationPusherAuth
     */
    readonly conversationId: string
}

/**
 * Request parameters for messagingViewsConversationCreateConversation operation in ConversationsApi.
 * @export
 * @interface ConversationsApiMessagingViewsConversationCreateConversationRequest
 */
export interface ConversationsApiMessagingViewsConversationCreateConversationRequest {
    /**
     * 
     * @type {number}
     * @memberof ConversationsApiMessagingViewsConversationCreateConversation
     */
    readonly businessId: number

    /**
     * 
     * @type {ConversationInSchema}
     * @memberof ConversationsApiMessagingViewsConversationCreateConversation
     */
    readonly conversationInSchema: ConversationInSchema
}

/**
 * Request parameters for messagingViewsConversationCreateConversationFromItem operation in ConversationsApi.
 * @export
 * @interface ConversationsApiMessagingViewsConversationCreateConversationFromItemRequest
 */
export interface ConversationsApiMessagingViewsConversationCreateConversationFromItemRequest {
    /**
     * 
     * @type {number}
     * @memberof ConversationsApiMessagingViewsConversationCreateConversationFromItem
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof ConversationsApiMessagingViewsConversationCreateConversationFromItem
     */
    readonly contactId: string

    /**
     * 
     * @type {ConversationItemInSchema}
     * @memberof ConversationsApiMessagingViewsConversationCreateConversationFromItem
     */
    readonly conversationItemInSchema: ConversationItemInSchema
}

/**
 * Request parameters for messagingViewsConversationCreateConversationItem operation in ConversationsApi.
 * @export
 * @interface ConversationsApiMessagingViewsConversationCreateConversationItemRequest
 */
export interface ConversationsApiMessagingViewsConversationCreateConversationItemRequest {
    /**
     * 
     * @type {number}
     * @memberof ConversationsApiMessagingViewsConversationCreateConversationItem
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof ConversationsApiMessagingViewsConversationCreateConversationItem
     */
    readonly conversationId: string

    /**
     * 
     * @type {ConversationItemInSchema}
     * @memberof ConversationsApiMessagingViewsConversationCreateConversationItem
     */
    readonly conversationItemInSchema: ConversationItemInSchema
}

/**
 * Request parameters for messagingViewsConversationCreateConversationItemAsGuest operation in ConversationsApi.
 * @export
 * @interface ConversationsApiMessagingViewsConversationCreateConversationItemAsGuestRequest
 */
export interface ConversationsApiMessagingViewsConversationCreateConversationItemAsGuestRequest {
    /**
     * 
     * @type {string}
     * @memberof ConversationsApiMessagingViewsConversationCreateConversationItemAsGuest
     */
    readonly conversationId: string

    /**
     * 
     * @type {string}
     * @memberof ConversationsApiMessagingViewsConversationCreateConversationItemAsGuest
     */
    readonly invitationId: string

    /**
     * 
     * @type {ConversationItemInSchema}
     * @memberof ConversationsApiMessagingViewsConversationCreateConversationItemAsGuest
     */
    readonly conversationItemInSchema: ConversationItemInSchema
}

/**
 * Request parameters for messagingViewsConversationCreateConversationNote operation in ConversationsApi.
 * @export
 * @interface ConversationsApiMessagingViewsConversationCreateConversationNoteRequest
 */
export interface ConversationsApiMessagingViewsConversationCreateConversationNoteRequest {
    /**
     * 
     * @type {number}
     * @memberof ConversationsApiMessagingViewsConversationCreateConversationNote
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof ConversationsApiMessagingViewsConversationCreateConversationNote
     */
    readonly conversationId: string

    /**
     * 
     * @type {ConversationNoteInSchema}
     * @memberof ConversationsApiMessagingViewsConversationCreateConversationNote
     */
    readonly conversationNoteInSchema: ConversationNoteInSchema
}

/**
 * Request parameters for messagingViewsConversationGetConversationInvitation operation in ConversationsApi.
 * @export
 * @interface ConversationsApiMessagingViewsConversationGetConversationInvitationRequest
 */
export interface ConversationsApiMessagingViewsConversationGetConversationInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof ConversationsApiMessagingViewsConversationGetConversationInvitation
     */
    readonly conversationId: string

    /**
     * 
     * @type {string}
     * @memberof ConversationsApiMessagingViewsConversationGetConversationInvitation
     */
    readonly invitationId: string
}

/**
 * Request parameters for messagingViewsConversationGetExisitingContactConversation operation in ConversationsApi.
 * @export
 * @interface ConversationsApiMessagingViewsConversationGetExisitingContactConversationRequest
 */
export interface ConversationsApiMessagingViewsConversationGetExisitingContactConversationRequest {
    /**
     * 
     * @type {number}
     * @memberof ConversationsApiMessagingViewsConversationGetExisitingContactConversation
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof ConversationsApiMessagingViewsConversationGetExisitingContactConversation
     */
    readonly customerId: string
}

/**
 * Request parameters for messagingViewsConversationGetPresignedUploadUrl operation in ConversationsApi.
 * @export
 * @interface ConversationsApiMessagingViewsConversationGetPresignedUploadUrlRequest
 */
export interface ConversationsApiMessagingViewsConversationGetPresignedUploadUrlRequest {
    /**
     * 
     * @type {number}
     * @memberof ConversationsApiMessagingViewsConversationGetPresignedUploadUrl
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof ConversationsApiMessagingViewsConversationGetPresignedUploadUrl
     */
    readonly conversationId: string

    /**
     * 
     * @type {PresignedURLInSchema}
     * @memberof ConversationsApiMessagingViewsConversationGetPresignedUploadUrl
     */
    readonly presignedURLInSchema: PresignedURLInSchema
}

/**
 * Request parameters for messagingViewsConversationGuestGetPresignedUploadUrl operation in ConversationsApi.
 * @export
 * @interface ConversationsApiMessagingViewsConversationGuestGetPresignedUploadUrlRequest
 */
export interface ConversationsApiMessagingViewsConversationGuestGetPresignedUploadUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof ConversationsApiMessagingViewsConversationGuestGetPresignedUploadUrl
     */
    readonly invitationId: string

    /**
     * 
     * @type {string}
     * @memberof ConversationsApiMessagingViewsConversationGuestGetPresignedUploadUrl
     */
    readonly conversationId: string

    /**
     * 
     * @type {PresignedURLInSchema}
     * @memberof ConversationsApiMessagingViewsConversationGuestGetPresignedUploadUrl
     */
    readonly presignedURLInSchema: PresignedURLInSchema
}

/**
 * Request parameters for messagingViewsConversationInviteConversationParticipants operation in ConversationsApi.
 * @export
 * @interface ConversationsApiMessagingViewsConversationInviteConversationParticipantsRequest
 */
export interface ConversationsApiMessagingViewsConversationInviteConversationParticipantsRequest {
    /**
     * 
     * @type {number}
     * @memberof ConversationsApiMessagingViewsConversationInviteConversationParticipants
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof ConversationsApiMessagingViewsConversationInviteConversationParticipants
     */
    readonly conversationId: string

    /**
     * 
     * @type {ConversationParticipantsInSchema}
     * @memberof ConversationsApiMessagingViewsConversationInviteConversationParticipants
     */
    readonly conversationParticipantsInSchema: ConversationParticipantsInSchema
}

/**
 * Request parameters for messagingViewsConversationLeaveConversation operation in ConversationsApi.
 * @export
 * @interface ConversationsApiMessagingViewsConversationLeaveConversationRequest
 */
export interface ConversationsApiMessagingViewsConversationLeaveConversationRequest {
    /**
     * 
     * @type {number}
     * @memberof ConversationsApiMessagingViewsConversationLeaveConversation
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof ConversationsApiMessagingViewsConversationLeaveConversation
     */
    readonly conversationId: string
}

/**
 * Request parameters for messagingViewsConversationListConversationItem operation in ConversationsApi.
 * @export
 * @interface ConversationsApiMessagingViewsConversationListConversationItemRequest
 */
export interface ConversationsApiMessagingViewsConversationListConversationItemRequest {
    /**
     * 
     * @type {number}
     * @memberof ConversationsApiMessagingViewsConversationListConversationItem
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof ConversationsApiMessagingViewsConversationListConversationItem
     */
    readonly conversationId: string

    /**
     * 
     * @type {number}
     * @memberof ConversationsApiMessagingViewsConversationListConversationItem
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof ConversationsApiMessagingViewsConversationListConversationItem
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof ConversationsApiMessagingViewsConversationListConversationItem
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for messagingViewsConversationListConversationItemAsGuest operation in ConversationsApi.
 * @export
 * @interface ConversationsApiMessagingViewsConversationListConversationItemAsGuestRequest
 */
export interface ConversationsApiMessagingViewsConversationListConversationItemAsGuestRequest {
    /**
     * 
     * @type {string}
     * @memberof ConversationsApiMessagingViewsConversationListConversationItemAsGuest
     */
    readonly conversationId: string

    /**
     * 
     * @type {string}
     * @memberof ConversationsApiMessagingViewsConversationListConversationItemAsGuest
     */
    readonly invitationId: string

    /**
     * 
     * @type {number}
     * @memberof ConversationsApiMessagingViewsConversationListConversationItemAsGuest
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof ConversationsApiMessagingViewsConversationListConversationItemAsGuest
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof ConversationsApiMessagingViewsConversationListConversationItemAsGuest
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for messagingViewsConversationListConversationNote operation in ConversationsApi.
 * @export
 * @interface ConversationsApiMessagingViewsConversationListConversationNoteRequest
 */
export interface ConversationsApiMessagingViewsConversationListConversationNoteRequest {
    /**
     * 
     * @type {number}
     * @memberof ConversationsApiMessagingViewsConversationListConversationNote
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof ConversationsApiMessagingViewsConversationListConversationNote
     */
    readonly conversationId: string

    /**
     * 
     * @type {number}
     * @memberof ConversationsApiMessagingViewsConversationListConversationNote
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof ConversationsApiMessagingViewsConversationListConversationNote
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof ConversationsApiMessagingViewsConversationListConversationNote
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for messagingViewsConversationListConversations operation in ConversationsApi.
 * @export
 * @interface ConversationsApiMessagingViewsConversationListConversationsRequest
 */
export interface ConversationsApiMessagingViewsConversationListConversationsRequest {
    /**
     * 
     * @type {number}
     * @memberof ConversationsApiMessagingViewsConversationListConversations
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof ConversationsApiMessagingViewsConversationListConversations
     */
    readonly search?: string | null

    /**
     * 
     * @type {ConversationStatus}
     * @memberof ConversationsApiMessagingViewsConversationListConversations
     */
    readonly status?: ConversationStatus | null

    /**
     * 
     * @type {ConversationType}
     * @memberof ConversationsApiMessagingViewsConversationListConversations
     */
    readonly type?: ConversationType | null

    /**
     * 
     * @type {Array<number>}
     * @memberof ConversationsApiMessagingViewsConversationListConversations
     */
    readonly createdBy?: Array<number> | null

    /**
     * 
     * @type {number}
     * @memberof ConversationsApiMessagingViewsConversationListConversations
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof ConversationsApiMessagingViewsConversationListConversations
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof ConversationsApiMessagingViewsConversationListConversations
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for messagingViewsConversationUpdateConversation operation in ConversationsApi.
 * @export
 * @interface ConversationsApiMessagingViewsConversationUpdateConversationRequest
 */
export interface ConversationsApiMessagingViewsConversationUpdateConversationRequest {
    /**
     * 
     * @type {number}
     * @memberof ConversationsApiMessagingViewsConversationUpdateConversation
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof ConversationsApiMessagingViewsConversationUpdateConversation
     */
    readonly conversationId: string

    /**
     * 
     * @type {ConversartionUpdateSchema}
     * @memberof ConversationsApiMessagingViewsConversationUpdateConversation
     */
    readonly conversartionUpdateSchema: ConversartionUpdateSchema
}

/**
 * ConversationsApi - object-oriented interface
 * @export
 * @class ConversationsApi
 * @extends {BaseAPI}
 */
export class ConversationsApi extends BaseAPI {
    /**
     * 
     * @summary Conversation Pusher Auth
     * @param {ConversationsApiMessagingViewsConversationConversationPusherAuthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    public messagingViewsConversationConversationPusherAuth(requestParameters: ConversationsApiMessagingViewsConversationConversationPusherAuthRequest, options?: RawAxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).messagingViewsConversationConversationPusherAuth(requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Conversation
     * @param {ConversationsApiMessagingViewsConversationCreateConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    public messagingViewsConversationCreateConversation(requestParameters: ConversationsApiMessagingViewsConversationCreateConversationRequest, options?: RawAxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).messagingViewsConversationCreateConversation(requestParameters.businessId, requestParameters.conversationInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Conversation From Item
     * @param {ConversationsApiMessagingViewsConversationCreateConversationFromItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    public messagingViewsConversationCreateConversationFromItem(requestParameters: ConversationsApiMessagingViewsConversationCreateConversationFromItemRequest, options?: RawAxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).messagingViewsConversationCreateConversationFromItem(requestParameters.businessId, requestParameters.contactId, requestParameters.conversationItemInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Conversation Item
     * @param {ConversationsApiMessagingViewsConversationCreateConversationItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    public messagingViewsConversationCreateConversationItem(requestParameters: ConversationsApiMessagingViewsConversationCreateConversationItemRequest, options?: RawAxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).messagingViewsConversationCreateConversationItem(requestParameters.businessId, requestParameters.conversationId, requestParameters.conversationItemInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Conversation Item As Guest
     * @param {ConversationsApiMessagingViewsConversationCreateConversationItemAsGuestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    public messagingViewsConversationCreateConversationItemAsGuest(requestParameters: ConversationsApiMessagingViewsConversationCreateConversationItemAsGuestRequest, options?: RawAxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).messagingViewsConversationCreateConversationItemAsGuest(requestParameters.conversationId, requestParameters.invitationId, requestParameters.conversationItemInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Conversation Note
     * @param {ConversationsApiMessagingViewsConversationCreateConversationNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    public messagingViewsConversationCreateConversationNote(requestParameters: ConversationsApiMessagingViewsConversationCreateConversationNoteRequest, options?: RawAxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).messagingViewsConversationCreateConversationNote(requestParameters.businessId, requestParameters.conversationId, requestParameters.conversationNoteInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Conversation Invitation
     * @param {ConversationsApiMessagingViewsConversationGetConversationInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    public messagingViewsConversationGetConversationInvitation(requestParameters: ConversationsApiMessagingViewsConversationGetConversationInvitationRequest, options?: RawAxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).messagingViewsConversationGetConversationInvitation(requestParameters.conversationId, requestParameters.invitationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Exisiting Contact Conversation
     * @param {ConversationsApiMessagingViewsConversationGetExisitingContactConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    public messagingViewsConversationGetExisitingContactConversation(requestParameters: ConversationsApiMessagingViewsConversationGetExisitingContactConversationRequest, options?: RawAxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).messagingViewsConversationGetExisitingContactConversation(requestParameters.businessId, requestParameters.customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Presigned Upload Url
     * @param {ConversationsApiMessagingViewsConversationGetPresignedUploadUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    public messagingViewsConversationGetPresignedUploadUrl(requestParameters: ConversationsApiMessagingViewsConversationGetPresignedUploadUrlRequest, options?: RawAxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).messagingViewsConversationGetPresignedUploadUrl(requestParameters.businessId, requestParameters.conversationId, requestParameters.presignedURLInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Guest Get Presigned Upload Url
     * @param {ConversationsApiMessagingViewsConversationGuestGetPresignedUploadUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    public messagingViewsConversationGuestGetPresignedUploadUrl(requestParameters: ConversationsApiMessagingViewsConversationGuestGetPresignedUploadUrlRequest, options?: RawAxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).messagingViewsConversationGuestGetPresignedUploadUrl(requestParameters.invitationId, requestParameters.conversationId, requestParameters.presignedURLInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Invite Conversation Participants
     * @param {ConversationsApiMessagingViewsConversationInviteConversationParticipantsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    public messagingViewsConversationInviteConversationParticipants(requestParameters: ConversationsApiMessagingViewsConversationInviteConversationParticipantsRequest, options?: RawAxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).messagingViewsConversationInviteConversationParticipants(requestParameters.businessId, requestParameters.conversationId, requestParameters.conversationParticipantsInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Leave Conversation
     * @param {ConversationsApiMessagingViewsConversationLeaveConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    public messagingViewsConversationLeaveConversation(requestParameters: ConversationsApiMessagingViewsConversationLeaveConversationRequest, options?: RawAxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).messagingViewsConversationLeaveConversation(requestParameters.businessId, requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Conversation Item
     * @param {ConversationsApiMessagingViewsConversationListConversationItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    public messagingViewsConversationListConversationItem(requestParameters: ConversationsApiMessagingViewsConversationListConversationItemRequest, options?: RawAxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).messagingViewsConversationListConversationItem(requestParameters.businessId, requestParameters.conversationId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Conversation Item As Guest
     * @param {ConversationsApiMessagingViewsConversationListConversationItemAsGuestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    public messagingViewsConversationListConversationItemAsGuest(requestParameters: ConversationsApiMessagingViewsConversationListConversationItemAsGuestRequest, options?: RawAxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).messagingViewsConversationListConversationItemAsGuest(requestParameters.conversationId, requestParameters.invitationId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Conversation Note
     * @param {ConversationsApiMessagingViewsConversationListConversationNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    public messagingViewsConversationListConversationNote(requestParameters: ConversationsApiMessagingViewsConversationListConversationNoteRequest, options?: RawAxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).messagingViewsConversationListConversationNote(requestParameters.businessId, requestParameters.conversationId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Conversations
     * @param {ConversationsApiMessagingViewsConversationListConversationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    public messagingViewsConversationListConversations(requestParameters: ConversationsApiMessagingViewsConversationListConversationsRequest, options?: RawAxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).messagingViewsConversationListConversations(requestParameters.businessId, requestParameters.search, requestParameters.status, requestParameters.type, requestParameters.createdBy, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Conversation
     * @param {ConversationsApiMessagingViewsConversationUpdateConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApi
     */
    public messagingViewsConversationUpdateConversation(requestParameters: ConversationsApiMessagingViewsConversationUpdateConversationRequest, options?: RawAxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).messagingViewsConversationUpdateConversation(requestParameters.businessId, requestParameters.conversationId, requestParameters.conversartionUpdateSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomerApi - axios parameter creator
 * @export
 */
export const CustomerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Generate OTP for ai agent to validate authentication
         * @summary Generate OTP
         * @param {GenerateOtpInSchema} generateOtpInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaCustomerDetailGenerateOtp: async (generateOtpInSchema: GenerateOtpInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateOtpInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaCustomerDetailGenerateOtp', 'generateOtpInSchema', generateOtpInSchema)
            const localVarPath = `/api/customer/otp/generate/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateOtpInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get business details by phone number for ai agent
         * @summary Get business details
         * @param {string} businessNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaCustomerDetailGetBusinessDetails: async (businessNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessNumber' is not null or undefined
            assertParamExists('usersViewsNinjaCustomerDetailGetBusinessDetails', 'businessNumber', businessNumber)
            const localVarPath = `/api/customer/business/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (businessNumber !== undefined) {
                localVarQueryParameter['business_number'] = businessNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get business number status by phone number for ai agent
         * @summary Get business number details
         * @param {string} businessNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaCustomerDetailGetBusinessNumberDetails: async (businessNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessNumber' is not null or undefined
            assertParamExists('usersViewsNinjaCustomerDetailGetBusinessNumberDetails', 'businessNumber', businessNumber)
            const localVarPath = `/api/customer/business-number/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (businessNumber !== undefined) {
                localVarQueryParameter['business_number'] = businessNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get customer details by phone or email for ai agent
         * @summary Get customer details by phone or email
         * @param {string | null} [phone] 
         * @param {string | null} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaCustomerDetailGetUserDetails: async (phone?: string | null, email?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customer/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerApi - functional programming interface
 * @export
 */
export const CustomerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerApiAxiosParamCreator(configuration)
    return {
        /**
         * Generate OTP for ai agent to validate authentication
         * @summary Generate OTP
         * @param {GenerateOtpInSchema} generateOtpInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaCustomerDetailGenerateOtp(generateOtpInSchema: GenerateOtpInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateOtpOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaCustomerDetailGenerateOtp(generateOtpInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.usersViewsNinjaCustomerDetailGenerateOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get business details by phone number for ai agent
         * @summary Get business details
         * @param {string} businessNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaCustomerDetailGetBusinessDetails(businessNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerBusinessOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaCustomerDetailGetBusinessDetails(businessNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.usersViewsNinjaCustomerDetailGetBusinessDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get business number status by phone number for ai agent
         * @summary Get business number details
         * @param {string} businessNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaCustomerDetailGetBusinessNumberDetails(businessNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerBusinessNumberOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaCustomerDetailGetBusinessNumberDetails(businessNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.usersViewsNinjaCustomerDetailGetBusinessNumberDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get customer details by phone or email for ai agent
         * @summary Get customer details by phone or email
         * @param {string | null} [phone] 
         * @param {string | null} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaCustomerDetailGetUserDetails(phone?: string | null, email?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDetailOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaCustomerDetailGetUserDetails(phone, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.usersViewsNinjaCustomerDetailGetUserDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerApi - factory interface
 * @export
 */
export const CustomerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerApiFp(configuration)
    return {
        /**
         * Generate OTP for ai agent to validate authentication
         * @summary Generate OTP
         * @param {CustomerApiUsersViewsNinjaCustomerDetailGenerateOtpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaCustomerDetailGenerateOtp(requestParameters: CustomerApiUsersViewsNinjaCustomerDetailGenerateOtpRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerateOtpOutSchema> {
            return localVarFp.usersViewsNinjaCustomerDetailGenerateOtp(requestParameters.generateOtpInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Get business details by phone number for ai agent
         * @summary Get business details
         * @param {CustomerApiUsersViewsNinjaCustomerDetailGetBusinessDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaCustomerDetailGetBusinessDetails(requestParameters: CustomerApiUsersViewsNinjaCustomerDetailGetBusinessDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerBusinessOutSchema> {
            return localVarFp.usersViewsNinjaCustomerDetailGetBusinessDetails(requestParameters.businessNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Get business number status by phone number for ai agent
         * @summary Get business number details
         * @param {CustomerApiUsersViewsNinjaCustomerDetailGetBusinessNumberDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaCustomerDetailGetBusinessNumberDetails(requestParameters: CustomerApiUsersViewsNinjaCustomerDetailGetBusinessNumberDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerBusinessNumberOutSchema> {
            return localVarFp.usersViewsNinjaCustomerDetailGetBusinessNumberDetails(requestParameters.businessNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Get customer details by phone or email for ai agent
         * @summary Get customer details by phone or email
         * @param {CustomerApiUsersViewsNinjaCustomerDetailGetUserDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaCustomerDetailGetUserDetails(requestParameters: CustomerApiUsersViewsNinjaCustomerDetailGetUserDetailsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CustomerDetailOutSchema> {
            return localVarFp.usersViewsNinjaCustomerDetailGetUserDetails(requestParameters.phone, requestParameters.email, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for usersViewsNinjaCustomerDetailGenerateOtp operation in CustomerApi.
 * @export
 * @interface CustomerApiUsersViewsNinjaCustomerDetailGenerateOtpRequest
 */
export interface CustomerApiUsersViewsNinjaCustomerDetailGenerateOtpRequest {
    /**
     * 
     * @type {GenerateOtpInSchema}
     * @memberof CustomerApiUsersViewsNinjaCustomerDetailGenerateOtp
     */
    readonly generateOtpInSchema: GenerateOtpInSchema
}

/**
 * Request parameters for usersViewsNinjaCustomerDetailGetBusinessDetails operation in CustomerApi.
 * @export
 * @interface CustomerApiUsersViewsNinjaCustomerDetailGetBusinessDetailsRequest
 */
export interface CustomerApiUsersViewsNinjaCustomerDetailGetBusinessDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerApiUsersViewsNinjaCustomerDetailGetBusinessDetails
     */
    readonly businessNumber: string
}

/**
 * Request parameters for usersViewsNinjaCustomerDetailGetBusinessNumberDetails operation in CustomerApi.
 * @export
 * @interface CustomerApiUsersViewsNinjaCustomerDetailGetBusinessNumberDetailsRequest
 */
export interface CustomerApiUsersViewsNinjaCustomerDetailGetBusinessNumberDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerApiUsersViewsNinjaCustomerDetailGetBusinessNumberDetails
     */
    readonly businessNumber: string
}

/**
 * Request parameters for usersViewsNinjaCustomerDetailGetUserDetails operation in CustomerApi.
 * @export
 * @interface CustomerApiUsersViewsNinjaCustomerDetailGetUserDetailsRequest
 */
export interface CustomerApiUsersViewsNinjaCustomerDetailGetUserDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerApiUsersViewsNinjaCustomerDetailGetUserDetails
     */
    readonly phone?: string | null

    /**
     * 
     * @type {string}
     * @memberof CustomerApiUsersViewsNinjaCustomerDetailGetUserDetails
     */
    readonly email?: string | null
}

/**
 * CustomerApi - object-oriented interface
 * @export
 * @class CustomerApi
 * @extends {BaseAPI}
 */
export class CustomerApi extends BaseAPI {
    /**
     * Generate OTP for ai agent to validate authentication
     * @summary Generate OTP
     * @param {CustomerApiUsersViewsNinjaCustomerDetailGenerateOtpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public usersViewsNinjaCustomerDetailGenerateOtp(requestParameters: CustomerApiUsersViewsNinjaCustomerDetailGenerateOtpRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).usersViewsNinjaCustomerDetailGenerateOtp(requestParameters.generateOtpInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get business details by phone number for ai agent
     * @summary Get business details
     * @param {CustomerApiUsersViewsNinjaCustomerDetailGetBusinessDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public usersViewsNinjaCustomerDetailGetBusinessDetails(requestParameters: CustomerApiUsersViewsNinjaCustomerDetailGetBusinessDetailsRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).usersViewsNinjaCustomerDetailGetBusinessDetails(requestParameters.businessNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get business number status by phone number for ai agent
     * @summary Get business number details
     * @param {CustomerApiUsersViewsNinjaCustomerDetailGetBusinessNumberDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public usersViewsNinjaCustomerDetailGetBusinessNumberDetails(requestParameters: CustomerApiUsersViewsNinjaCustomerDetailGetBusinessNumberDetailsRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).usersViewsNinjaCustomerDetailGetBusinessNumberDetails(requestParameters.businessNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get customer details by phone or email for ai agent
     * @summary Get customer details by phone or email
     * @param {CustomerApiUsersViewsNinjaCustomerDetailGetUserDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public usersViewsNinjaCustomerDetailGetUserDetails(requestParameters: CustomerApiUsersViewsNinjaCustomerDetailGetUserDetailsRequest = {}, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).usersViewsNinjaCustomerDetailGetUserDetails(requestParameters.phone, requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DeveloperApi - axios parameter creator
 * @export
 */
export const DeveloperApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Activate Business
         * @param {ActivateDeveloperBusinessInSchema} activateDeveloperBusinessInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartyDeveloperActivateBusiness: async (activateDeveloperBusinessInSchema: ActivateDeveloperBusinessInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activateDeveloperBusinessInSchema' is not null or undefined
            assertParamExists('developerViewsThirdPartyDeveloperActivateBusiness', 'activateDeveloperBusinessInSchema', activateDeveloperBusinessInSchema)
            const localVarPath = `/api/third-party/developer/activate-business/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activateDeveloperBusinessInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Developer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartyDeveloperGetDeveloper: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/third-party/developer/me/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register Developer
         * @param {DeveloperInSchema} developerInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartyDeveloperRegisterDeveloper: async (developerInSchema: DeveloperInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'developerInSchema' is not null or undefined
            assertParamExists('developerViewsThirdPartyDeveloperRegisterDeveloper', 'developerInSchema', developerInSchema)
            const localVarPath = `/api/third-party/developer/register/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(developerInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Developer Profile
         * @param {DeveloperUpdateSchema} developerUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartyDeveloperUpdateDeveloperProfile: async (developerUpdateSchema: DeveloperUpdateSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'developerUpdateSchema' is not null or undefined
            assertParamExists('developerViewsThirdPartyDeveloperUpdateDeveloperProfile', 'developerUpdateSchema', developerUpdateSchema)
            const localVarPath = `/api/third-party/developer/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(developerUpdateSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeveloperApi - functional programming interface
 * @export
 */
export const DeveloperApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeveloperApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Activate Business
         * @param {ActivateDeveloperBusinessInSchema} activateDeveloperBusinessInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerViewsThirdPartyDeveloperActivateBusiness(activateDeveloperBusinessInSchema: ActivateDeveloperBusinessInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BusinessOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerViewsThirdPartyDeveloperActivateBusiness(activateDeveloperBusinessInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeveloperApi.developerViewsThirdPartyDeveloperActivateBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Developer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerViewsThirdPartyDeveloperGetDeveloper(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeveloperOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerViewsThirdPartyDeveloperGetDeveloper(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeveloperApi.developerViewsThirdPartyDeveloperGetDeveloper']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Register Developer
         * @param {DeveloperInSchema} developerInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerViewsThirdPartyDeveloperRegisterDeveloper(developerInSchema: DeveloperInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FreeTrialUserCreateOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerViewsThirdPartyDeveloperRegisterDeveloper(developerInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeveloperApi.developerViewsThirdPartyDeveloperRegisterDeveloper']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Developer Profile
         * @param {DeveloperUpdateSchema} developerUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerViewsThirdPartyDeveloperUpdateDeveloperProfile(developerUpdateSchema: DeveloperUpdateSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeveloperOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerViewsThirdPartyDeveloperUpdateDeveloperProfile(developerUpdateSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeveloperApi.developerViewsThirdPartyDeveloperUpdateDeveloperProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeveloperApi - factory interface
 * @export
 */
export const DeveloperApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeveloperApiFp(configuration)
    return {
        /**
         * 
         * @summary Activate Business
         * @param {DeveloperApiDeveloperViewsThirdPartyDeveloperActivateBusinessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartyDeveloperActivateBusiness(requestParameters: DeveloperApiDeveloperViewsThirdPartyDeveloperActivateBusinessRequest, options?: RawAxiosRequestConfig): AxiosPromise<BusinessOutSchema> {
            return localVarFp.developerViewsThirdPartyDeveloperActivateBusiness(requestParameters.activateDeveloperBusinessInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Developer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartyDeveloperGetDeveloper(options?: RawAxiosRequestConfig): AxiosPromise<DeveloperOutSchema> {
            return localVarFp.developerViewsThirdPartyDeveloperGetDeveloper(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register Developer
         * @param {DeveloperApiDeveloperViewsThirdPartyDeveloperRegisterDeveloperRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartyDeveloperRegisterDeveloper(requestParameters: DeveloperApiDeveloperViewsThirdPartyDeveloperRegisterDeveloperRequest, options?: RawAxiosRequestConfig): AxiosPromise<FreeTrialUserCreateOutSchema> {
            return localVarFp.developerViewsThirdPartyDeveloperRegisterDeveloper(requestParameters.developerInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Developer Profile
         * @param {DeveloperApiDeveloperViewsThirdPartyDeveloperUpdateDeveloperProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartyDeveloperUpdateDeveloperProfile(requestParameters: DeveloperApiDeveloperViewsThirdPartyDeveloperUpdateDeveloperProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeveloperOutSchema> {
            return localVarFp.developerViewsThirdPartyDeveloperUpdateDeveloperProfile(requestParameters.developerUpdateSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for developerViewsThirdPartyDeveloperActivateBusiness operation in DeveloperApi.
 * @export
 * @interface DeveloperApiDeveloperViewsThirdPartyDeveloperActivateBusinessRequest
 */
export interface DeveloperApiDeveloperViewsThirdPartyDeveloperActivateBusinessRequest {
    /**
     * 
     * @type {ActivateDeveloperBusinessInSchema}
     * @memberof DeveloperApiDeveloperViewsThirdPartyDeveloperActivateBusiness
     */
    readonly activateDeveloperBusinessInSchema: ActivateDeveloperBusinessInSchema
}

/**
 * Request parameters for developerViewsThirdPartyDeveloperRegisterDeveloper operation in DeveloperApi.
 * @export
 * @interface DeveloperApiDeveloperViewsThirdPartyDeveloperRegisterDeveloperRequest
 */
export interface DeveloperApiDeveloperViewsThirdPartyDeveloperRegisterDeveloperRequest {
    /**
     * 
     * @type {DeveloperInSchema}
     * @memberof DeveloperApiDeveloperViewsThirdPartyDeveloperRegisterDeveloper
     */
    readonly developerInSchema: DeveloperInSchema
}

/**
 * Request parameters for developerViewsThirdPartyDeveloperUpdateDeveloperProfile operation in DeveloperApi.
 * @export
 * @interface DeveloperApiDeveloperViewsThirdPartyDeveloperUpdateDeveloperProfileRequest
 */
export interface DeveloperApiDeveloperViewsThirdPartyDeveloperUpdateDeveloperProfileRequest {
    /**
     * 
     * @type {DeveloperUpdateSchema}
     * @memberof DeveloperApiDeveloperViewsThirdPartyDeveloperUpdateDeveloperProfile
     */
    readonly developerUpdateSchema: DeveloperUpdateSchema
}

/**
 * DeveloperApi - object-oriented interface
 * @export
 * @class DeveloperApi
 * @extends {BaseAPI}
 */
export class DeveloperApi extends BaseAPI {
    /**
     * 
     * @summary Activate Business
     * @param {DeveloperApiDeveloperViewsThirdPartyDeveloperActivateBusinessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeveloperApi
     */
    public developerViewsThirdPartyDeveloperActivateBusiness(requestParameters: DeveloperApiDeveloperViewsThirdPartyDeveloperActivateBusinessRequest, options?: RawAxiosRequestConfig) {
        return DeveloperApiFp(this.configuration).developerViewsThirdPartyDeveloperActivateBusiness(requestParameters.activateDeveloperBusinessInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Developer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeveloperApi
     */
    public developerViewsThirdPartyDeveloperGetDeveloper(options?: RawAxiosRequestConfig) {
        return DeveloperApiFp(this.configuration).developerViewsThirdPartyDeveloperGetDeveloper(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register Developer
     * @param {DeveloperApiDeveloperViewsThirdPartyDeveloperRegisterDeveloperRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeveloperApi
     */
    public developerViewsThirdPartyDeveloperRegisterDeveloper(requestParameters: DeveloperApiDeveloperViewsThirdPartyDeveloperRegisterDeveloperRequest, options?: RawAxiosRequestConfig) {
        return DeveloperApiFp(this.configuration).developerViewsThirdPartyDeveloperRegisterDeveloper(requestParameters.developerInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Developer Profile
     * @param {DeveloperApiDeveloperViewsThirdPartyDeveloperUpdateDeveloperProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeveloperApi
     */
    public developerViewsThirdPartyDeveloperUpdateDeveloperProfile(requestParameters: DeveloperApiDeveloperViewsThirdPartyDeveloperUpdateDeveloperProfileRequest, options?: RawAxiosRequestConfig) {
        return DeveloperApiFp(this.configuration).developerViewsThirdPartyDeveloperUpdateDeveloperProfile(requestParameters.developerUpdateSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DialGroupApi - axios parameter creator
 * @export
 */
export const DialGroupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Assign Number To Dial Group
         * @param {number} businessId 
         * @param {string} dialGroupId 
         * @param {DialGroupInAssignNumber} dialGroupInAssignNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberCallConfigurationAssignNumberToDialGroup: async (businessId: number, dialGroupId: string, dialGroupInAssignNumber: DialGroupInAssignNumber, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberCallConfigurationAssignNumberToDialGroup', 'businessId', businessId)
            // verify required parameter 'dialGroupId' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberCallConfigurationAssignNumberToDialGroup', 'dialGroupId', dialGroupId)
            // verify required parameter 'dialGroupInAssignNumber' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberCallConfigurationAssignNumberToDialGroup', 'dialGroupInAssignNumber', dialGroupInAssignNumber)
            const localVarPath = `/api/business/{business_id}/dial-group/{dial_group_id}/assign-number/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"dial_group_id"}}`, encodeURIComponent(String(dialGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dialGroupInAssignNumber, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Automated Greeting
         * @param {number} businessId 
         * @param {RequestGreetingsInSchema} requestGreetingsInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberCallConfigurationCreateAutomatedGreeting: async (businessId: number, requestGreetingsInSchema: RequestGreetingsInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberCallConfigurationCreateAutomatedGreeting', 'businessId', businessId)
            // verify required parameter 'requestGreetingsInSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberCallConfigurationCreateAutomatedGreeting', 'requestGreetingsInSchema', requestGreetingsInSchema)
            const localVarPath = `/api/business/{business_id}/request-greeting/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestGreetingsInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Automated Voice Greetings
         * @param {number} businessId 
         * @param {Array<number | null>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberCallConfigurationDeleteAutomatedVoiceGreetings: async (businessId: number, requestBody: Array<number | null>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberCallConfigurationDeleteAutomatedVoiceGreetings', 'businessId', businessId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberCallConfigurationDeleteAutomatedVoiceGreetings', 'requestBody', requestBody)
            const localVarPath = `/api/business/{business_id}/voice-script/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Dial Group
         * @param {number} businessId 
         * @param {string} dialGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberCallConfigurationDeleteDialGroup: async (businessId: number, dialGroupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberCallConfigurationDeleteDialGroup', 'businessId', businessId)
            // verify required parameter 'dialGroupId' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberCallConfigurationDeleteDialGroup', 'dialGroupId', dialGroupId)
            const localVarPath = `/api/business/{business_id}/dial-group/{dial_group_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"dial_group_id"}}`, encodeURIComponent(String(dialGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Duplicate To Dial Group
         * @param {number} businessId 
         * @param {string} dialGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberCallConfigurationDuplicateToDialGroup: async (businessId: number, dialGroupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberCallConfigurationDuplicateToDialGroup', 'businessId', businessId)
            // verify required parameter 'dialGroupId' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberCallConfigurationDuplicateToDialGroup', 'dialGroupId', dialGroupId)
            const localVarPath = `/api/business/{business_id}/dial-group/{dial_group_id}/duplicate/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"dial_group_id"}}`, encodeURIComponent(String(dialGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Automated Voice Greetings
         * @param {number} businessId 
         * @param {GreetingType | null} [type] 
         * @param {string | null} [uuid] 
         * @param {number | null} [userId] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetings: async (businessId: number, type?: GreetingType | null, uuid?: string | null, userId?: number | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetings', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/voice-script/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (uuid !== undefined) {
                localVarQueryParameter['uuid'] = uuid;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Dial Group
         * @param {number} businessId 
         * @param {string | null} [id] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberCallConfigurationListDialGroup: async (businessId: number, id?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberCallConfigurationListDialGroup', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/dial-group/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Music On Hold
         * @param {number} businessId 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberCallConfigurationListMusicOnHold: async (businessId: number, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberCallConfigurationListMusicOnHold', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/media/moh/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Voice Accents
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberCallConfigurationListVoiceAccents: async (businessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberCallConfigurationListVoiceAccents', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/request-greeting/voice-accent/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Setup Dial Group
         * @param {number} businessId 
         * @param {DialGroupInSchema} dialGroupInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberCallConfigurationSetupDialGroup: async (businessId: number, dialGroupInSchema: DialGroupInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberCallConfigurationSetupDialGroup', 'businessId', businessId)
            // verify required parameter 'dialGroupInSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberCallConfigurationSetupDialGroup', 'dialGroupInSchema', dialGroupInSchema)
            const localVarPath = `/api/business/{business_id}/dial-group/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dialGroupInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DialGroupApi - functional programming interface
 * @export
 */
export const DialGroupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DialGroupApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Assign Number To Dial Group
         * @param {number} businessId 
         * @param {string} dialGroupId 
         * @param {DialGroupInAssignNumber} dialGroupInAssignNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaNumberCallConfigurationAssignNumberToDialGroup(businessId: number, dialGroupId: string, dialGroupInAssignNumber: DialGroupInAssignNumber, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DialGroupOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaNumberCallConfigurationAssignNumberToDialGroup(businessId, dialGroupId, dialGroupInAssignNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DialGroupApi.telephonyViewsNinjaNumberCallConfigurationAssignNumberToDialGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Automated Greeting
         * @param {number} businessId 
         * @param {RequestGreetingsInSchema} requestGreetingsInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaNumberCallConfigurationCreateAutomatedGreeting(businessId: number, requestGreetingsInSchema: RequestGreetingsInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RequestGreetingsOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaNumberCallConfigurationCreateAutomatedGreeting(businessId, requestGreetingsInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DialGroupApi.telephonyViewsNinjaNumberCallConfigurationCreateAutomatedGreeting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Automated Voice Greetings
         * @param {number} businessId 
         * @param {Array<number | null>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaNumberCallConfigurationDeleteAutomatedVoiceGreetings(businessId: number, requestBody: Array<number | null>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaNumberCallConfigurationDeleteAutomatedVoiceGreetings(businessId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DialGroupApi.telephonyViewsNinjaNumberCallConfigurationDeleteAutomatedVoiceGreetings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Dial Group
         * @param {number} businessId 
         * @param {string} dialGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaNumberCallConfigurationDeleteDialGroup(businessId: number, dialGroupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaNumberCallConfigurationDeleteDialGroup(businessId, dialGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DialGroupApi.telephonyViewsNinjaNumberCallConfigurationDeleteDialGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Duplicate To Dial Group
         * @param {number} businessId 
         * @param {string} dialGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaNumberCallConfigurationDuplicateToDialGroup(businessId: number, dialGroupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DialGroupDuplicateOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaNumberCallConfigurationDuplicateToDialGroup(businessId, dialGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DialGroupApi.telephonyViewsNinjaNumberCallConfigurationDuplicateToDialGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Automated Voice Greetings
         * @param {number} businessId 
         * @param {GreetingType | null} [type] 
         * @param {string | null} [uuid] 
         * @param {number | null} [userId] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetings(businessId: number, type?: GreetingType | null, uuid?: string | null, userId?: number | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedVoiceScriptOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetings(businessId, type, uuid, userId, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DialGroupApi.telephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Dial Group
         * @param {number} businessId 
         * @param {string | null} [id] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaNumberCallConfigurationListDialGroup(businessId: number, id?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedDialGroupOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaNumberCallConfigurationListDialGroup(businessId, id, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DialGroupApi.telephonyViewsNinjaNumberCallConfigurationListDialGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Music On Hold
         * @param {number} businessId 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaNumberCallConfigurationListMusicOnHold(businessId: number, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedMOHOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaNumberCallConfigurationListMusicOnHold(businessId, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DialGroupApi.telephonyViewsNinjaNumberCallConfigurationListMusicOnHold']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Voice Accents
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaNumberCallConfigurationListVoiceAccents(businessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VoiceAccentOutSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaNumberCallConfigurationListVoiceAccents(businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DialGroupApi.telephonyViewsNinjaNumberCallConfigurationListVoiceAccents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Setup Dial Group
         * @param {number} businessId 
         * @param {DialGroupInSchema} dialGroupInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaNumberCallConfigurationSetupDialGroup(businessId: number, dialGroupInSchema: DialGroupInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DialGroupOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaNumberCallConfigurationSetupDialGroup(businessId, dialGroupInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DialGroupApi.telephonyViewsNinjaNumberCallConfigurationSetupDialGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DialGroupApi - factory interface
 * @export
 */
export const DialGroupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DialGroupApiFp(configuration)
    return {
        /**
         * 
         * @summary Assign Number To Dial Group
         * @param {DialGroupApiTelephonyViewsNinjaNumberCallConfigurationAssignNumberToDialGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberCallConfigurationAssignNumberToDialGroup(requestParameters: DialGroupApiTelephonyViewsNinjaNumberCallConfigurationAssignNumberToDialGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<DialGroupOutSchema> {
            return localVarFp.telephonyViewsNinjaNumberCallConfigurationAssignNumberToDialGroup(requestParameters.businessId, requestParameters.dialGroupId, requestParameters.dialGroupInAssignNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Automated Greeting
         * @param {DialGroupApiTelephonyViewsNinjaNumberCallConfigurationCreateAutomatedGreetingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberCallConfigurationCreateAutomatedGreeting(requestParameters: DialGroupApiTelephonyViewsNinjaNumberCallConfigurationCreateAutomatedGreetingRequest, options?: RawAxiosRequestConfig): AxiosPromise<RequestGreetingsOutSchema> {
            return localVarFp.telephonyViewsNinjaNumberCallConfigurationCreateAutomatedGreeting(requestParameters.businessId, requestParameters.requestGreetingsInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Automated Voice Greetings
         * @param {DialGroupApiTelephonyViewsNinjaNumberCallConfigurationDeleteAutomatedVoiceGreetingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberCallConfigurationDeleteAutomatedVoiceGreetings(requestParameters: DialGroupApiTelephonyViewsNinjaNumberCallConfigurationDeleteAutomatedVoiceGreetingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.telephonyViewsNinjaNumberCallConfigurationDeleteAutomatedVoiceGreetings(requestParameters.businessId, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Dial Group
         * @param {DialGroupApiTelephonyViewsNinjaNumberCallConfigurationDeleteDialGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberCallConfigurationDeleteDialGroup(requestParameters: DialGroupApiTelephonyViewsNinjaNumberCallConfigurationDeleteDialGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.telephonyViewsNinjaNumberCallConfigurationDeleteDialGroup(requestParameters.businessId, requestParameters.dialGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Duplicate To Dial Group
         * @param {DialGroupApiTelephonyViewsNinjaNumberCallConfigurationDuplicateToDialGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberCallConfigurationDuplicateToDialGroup(requestParameters: DialGroupApiTelephonyViewsNinjaNumberCallConfigurationDuplicateToDialGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<DialGroupDuplicateOutSchema> {
            return localVarFp.telephonyViewsNinjaNumberCallConfigurationDuplicateToDialGroup(requestParameters.businessId, requestParameters.dialGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Automated Voice Greetings
         * @param {DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetings(requestParameters: DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedVoiceScriptOutSchema> {
            return localVarFp.telephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetings(requestParameters.businessId, requestParameters.type, requestParameters.uuid, requestParameters.userId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Dial Group
         * @param {DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListDialGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberCallConfigurationListDialGroup(requestParameters: DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListDialGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedDialGroupOutSchema> {
            return localVarFp.telephonyViewsNinjaNumberCallConfigurationListDialGroup(requestParameters.businessId, requestParameters.id, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Music On Hold
         * @param {DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListMusicOnHoldRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberCallConfigurationListMusicOnHold(requestParameters: DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListMusicOnHoldRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedMOHOutSchema> {
            return localVarFp.telephonyViewsNinjaNumberCallConfigurationListMusicOnHold(requestParameters.businessId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Voice Accents
         * @param {DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListVoiceAccentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberCallConfigurationListVoiceAccents(requestParameters: DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListVoiceAccentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<VoiceAccentOutSchema>> {
            return localVarFp.telephonyViewsNinjaNumberCallConfigurationListVoiceAccents(requestParameters.businessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Setup Dial Group
         * @param {DialGroupApiTelephonyViewsNinjaNumberCallConfigurationSetupDialGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberCallConfigurationSetupDialGroup(requestParameters: DialGroupApiTelephonyViewsNinjaNumberCallConfigurationSetupDialGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<DialGroupOutSchema> {
            return localVarFp.telephonyViewsNinjaNumberCallConfigurationSetupDialGroup(requestParameters.businessId, requestParameters.dialGroupInSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for telephonyViewsNinjaNumberCallConfigurationAssignNumberToDialGroup operation in DialGroupApi.
 * @export
 * @interface DialGroupApiTelephonyViewsNinjaNumberCallConfigurationAssignNumberToDialGroupRequest
 */
export interface DialGroupApiTelephonyViewsNinjaNumberCallConfigurationAssignNumberToDialGroupRequest {
    /**
     * 
     * @type {number}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationAssignNumberToDialGroup
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationAssignNumberToDialGroup
     */
    readonly dialGroupId: string

    /**
     * 
     * @type {DialGroupInAssignNumber}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationAssignNumberToDialGroup
     */
    readonly dialGroupInAssignNumber: DialGroupInAssignNumber
}

/**
 * Request parameters for telephonyViewsNinjaNumberCallConfigurationCreateAutomatedGreeting operation in DialGroupApi.
 * @export
 * @interface DialGroupApiTelephonyViewsNinjaNumberCallConfigurationCreateAutomatedGreetingRequest
 */
export interface DialGroupApiTelephonyViewsNinjaNumberCallConfigurationCreateAutomatedGreetingRequest {
    /**
     * 
     * @type {number}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationCreateAutomatedGreeting
     */
    readonly businessId: number

    /**
     * 
     * @type {RequestGreetingsInSchema}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationCreateAutomatedGreeting
     */
    readonly requestGreetingsInSchema: RequestGreetingsInSchema
}

/**
 * Request parameters for telephonyViewsNinjaNumberCallConfigurationDeleteAutomatedVoiceGreetings operation in DialGroupApi.
 * @export
 * @interface DialGroupApiTelephonyViewsNinjaNumberCallConfigurationDeleteAutomatedVoiceGreetingsRequest
 */
export interface DialGroupApiTelephonyViewsNinjaNumberCallConfigurationDeleteAutomatedVoiceGreetingsRequest {
    /**
     * 
     * @type {number}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationDeleteAutomatedVoiceGreetings
     */
    readonly businessId: number

    /**
     * 
     * @type {Array<number | null>}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationDeleteAutomatedVoiceGreetings
     */
    readonly requestBody: Array<number | null>
}

/**
 * Request parameters for telephonyViewsNinjaNumberCallConfigurationDeleteDialGroup operation in DialGroupApi.
 * @export
 * @interface DialGroupApiTelephonyViewsNinjaNumberCallConfigurationDeleteDialGroupRequest
 */
export interface DialGroupApiTelephonyViewsNinjaNumberCallConfigurationDeleteDialGroupRequest {
    /**
     * 
     * @type {number}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationDeleteDialGroup
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationDeleteDialGroup
     */
    readonly dialGroupId: string
}

/**
 * Request parameters for telephonyViewsNinjaNumberCallConfigurationDuplicateToDialGroup operation in DialGroupApi.
 * @export
 * @interface DialGroupApiTelephonyViewsNinjaNumberCallConfigurationDuplicateToDialGroupRequest
 */
export interface DialGroupApiTelephonyViewsNinjaNumberCallConfigurationDuplicateToDialGroupRequest {
    /**
     * 
     * @type {number}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationDuplicateToDialGroup
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationDuplicateToDialGroup
     */
    readonly dialGroupId: string
}

/**
 * Request parameters for telephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetings operation in DialGroupApi.
 * @export
 * @interface DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetingsRequest
 */
export interface DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetingsRequest {
    /**
     * 
     * @type {number}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetings
     */
    readonly businessId: number

    /**
     * 
     * @type {GreetingType}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetings
     */
    readonly type?: GreetingType | null

    /**
     * 
     * @type {string}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetings
     */
    readonly uuid?: string | null

    /**
     * 
     * @type {number}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetings
     */
    readonly userId?: number | null

    /**
     * 
     * @type {number}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetings
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetings
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetings
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for telephonyViewsNinjaNumberCallConfigurationListDialGroup operation in DialGroupApi.
 * @export
 * @interface DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListDialGroupRequest
 */
export interface DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListDialGroupRequest {
    /**
     * 
     * @type {number}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListDialGroup
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListDialGroup
     */
    readonly id?: string | null

    /**
     * 
     * @type {number}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListDialGroup
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListDialGroup
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListDialGroup
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for telephonyViewsNinjaNumberCallConfigurationListMusicOnHold operation in DialGroupApi.
 * @export
 * @interface DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListMusicOnHoldRequest
 */
export interface DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListMusicOnHoldRequest {
    /**
     * 
     * @type {number}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListMusicOnHold
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListMusicOnHold
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListMusicOnHold
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListMusicOnHold
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for telephonyViewsNinjaNumberCallConfigurationListVoiceAccents operation in DialGroupApi.
 * @export
 * @interface DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListVoiceAccentsRequest
 */
export interface DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListVoiceAccentsRequest {
    /**
     * 
     * @type {number}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListVoiceAccents
     */
    readonly businessId: number
}

/**
 * Request parameters for telephonyViewsNinjaNumberCallConfigurationSetupDialGroup operation in DialGroupApi.
 * @export
 * @interface DialGroupApiTelephonyViewsNinjaNumberCallConfigurationSetupDialGroupRequest
 */
export interface DialGroupApiTelephonyViewsNinjaNumberCallConfigurationSetupDialGroupRequest {
    /**
     * 
     * @type {number}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationSetupDialGroup
     */
    readonly businessId: number

    /**
     * 
     * @type {DialGroupInSchema}
     * @memberof DialGroupApiTelephonyViewsNinjaNumberCallConfigurationSetupDialGroup
     */
    readonly dialGroupInSchema: DialGroupInSchema
}

/**
 * DialGroupApi - object-oriented interface
 * @export
 * @class DialGroupApi
 * @extends {BaseAPI}
 */
export class DialGroupApi extends BaseAPI {
    /**
     * 
     * @summary Assign Number To Dial Group
     * @param {DialGroupApiTelephonyViewsNinjaNumberCallConfigurationAssignNumberToDialGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DialGroupApi
     */
    public telephonyViewsNinjaNumberCallConfigurationAssignNumberToDialGroup(requestParameters: DialGroupApiTelephonyViewsNinjaNumberCallConfigurationAssignNumberToDialGroupRequest, options?: RawAxiosRequestConfig) {
        return DialGroupApiFp(this.configuration).telephonyViewsNinjaNumberCallConfigurationAssignNumberToDialGroup(requestParameters.businessId, requestParameters.dialGroupId, requestParameters.dialGroupInAssignNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Automated Greeting
     * @param {DialGroupApiTelephonyViewsNinjaNumberCallConfigurationCreateAutomatedGreetingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DialGroupApi
     */
    public telephonyViewsNinjaNumberCallConfigurationCreateAutomatedGreeting(requestParameters: DialGroupApiTelephonyViewsNinjaNumberCallConfigurationCreateAutomatedGreetingRequest, options?: RawAxiosRequestConfig) {
        return DialGroupApiFp(this.configuration).telephonyViewsNinjaNumberCallConfigurationCreateAutomatedGreeting(requestParameters.businessId, requestParameters.requestGreetingsInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Automated Voice Greetings
     * @param {DialGroupApiTelephonyViewsNinjaNumberCallConfigurationDeleteAutomatedVoiceGreetingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DialGroupApi
     */
    public telephonyViewsNinjaNumberCallConfigurationDeleteAutomatedVoiceGreetings(requestParameters: DialGroupApiTelephonyViewsNinjaNumberCallConfigurationDeleteAutomatedVoiceGreetingsRequest, options?: RawAxiosRequestConfig) {
        return DialGroupApiFp(this.configuration).telephonyViewsNinjaNumberCallConfigurationDeleteAutomatedVoiceGreetings(requestParameters.businessId, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Dial Group
     * @param {DialGroupApiTelephonyViewsNinjaNumberCallConfigurationDeleteDialGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DialGroupApi
     */
    public telephonyViewsNinjaNumberCallConfigurationDeleteDialGroup(requestParameters: DialGroupApiTelephonyViewsNinjaNumberCallConfigurationDeleteDialGroupRequest, options?: RawAxiosRequestConfig) {
        return DialGroupApiFp(this.configuration).telephonyViewsNinjaNumberCallConfigurationDeleteDialGroup(requestParameters.businessId, requestParameters.dialGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Duplicate To Dial Group
     * @param {DialGroupApiTelephonyViewsNinjaNumberCallConfigurationDuplicateToDialGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DialGroupApi
     */
    public telephonyViewsNinjaNumberCallConfigurationDuplicateToDialGroup(requestParameters: DialGroupApiTelephonyViewsNinjaNumberCallConfigurationDuplicateToDialGroupRequest, options?: RawAxiosRequestConfig) {
        return DialGroupApiFp(this.configuration).telephonyViewsNinjaNumberCallConfigurationDuplicateToDialGroup(requestParameters.businessId, requestParameters.dialGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Automated Voice Greetings
     * @param {DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DialGroupApi
     */
    public telephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetings(requestParameters: DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetingsRequest, options?: RawAxiosRequestConfig) {
        return DialGroupApiFp(this.configuration).telephonyViewsNinjaNumberCallConfigurationListAutomatedVoiceGreetings(requestParameters.businessId, requestParameters.type, requestParameters.uuid, requestParameters.userId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Dial Group
     * @param {DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListDialGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DialGroupApi
     */
    public telephonyViewsNinjaNumberCallConfigurationListDialGroup(requestParameters: DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListDialGroupRequest, options?: RawAxiosRequestConfig) {
        return DialGroupApiFp(this.configuration).telephonyViewsNinjaNumberCallConfigurationListDialGroup(requestParameters.businessId, requestParameters.id, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Music On Hold
     * @param {DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListMusicOnHoldRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DialGroupApi
     */
    public telephonyViewsNinjaNumberCallConfigurationListMusicOnHold(requestParameters: DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListMusicOnHoldRequest, options?: RawAxiosRequestConfig) {
        return DialGroupApiFp(this.configuration).telephonyViewsNinjaNumberCallConfigurationListMusicOnHold(requestParameters.businessId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Voice Accents
     * @param {DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListVoiceAccentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DialGroupApi
     */
    public telephonyViewsNinjaNumberCallConfigurationListVoiceAccents(requestParameters: DialGroupApiTelephonyViewsNinjaNumberCallConfigurationListVoiceAccentsRequest, options?: RawAxiosRequestConfig) {
        return DialGroupApiFp(this.configuration).telephonyViewsNinjaNumberCallConfigurationListVoiceAccents(requestParameters.businessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Setup Dial Group
     * @param {DialGroupApiTelephonyViewsNinjaNumberCallConfigurationSetupDialGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DialGroupApi
     */
    public telephonyViewsNinjaNumberCallConfigurationSetupDialGroup(requestParameters: DialGroupApiTelephonyViewsNinjaNumberCallConfigurationSetupDialGroupRequest, options?: RawAxiosRequestConfig) {
        return DialGroupApiFp(this.configuration).telephonyViewsNinjaNumberCallConfigurationSetupDialGroup(requestParameters.businessId, requestParameters.dialGroupInSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EventApi - axios parameter creator
 * @export
 */
export const EventApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Temporary endpoint to record Event on Chronos DB
         * @summary Records Event
         * @param {EventInSchema} eventInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaEventRecordEvent: async (eventInSchema: EventInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaEventRecordEvent', 'eventInSchema', eventInSchema)
            const localVarPath = `/api/event/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventApi - functional programming interface
 * @export
 */
export const EventApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventApiAxiosParamCreator(configuration)
    return {
        /**
         * Temporary endpoint to record Event on Chronos DB
         * @summary Records Event
         * @param {EventInSchema} eventInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaEventRecordEvent(eventInSchema: EventInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaEventRecordEvent(eventInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventApi.usersViewsNinjaEventRecordEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EventApi - factory interface
 * @export
 */
export const EventApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventApiFp(configuration)
    return {
        /**
         * Temporary endpoint to record Event on Chronos DB
         * @summary Records Event
         * @param {EventApiUsersViewsNinjaEventRecordEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaEventRecordEvent(requestParameters: EventApiUsersViewsNinjaEventRecordEventRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaEventRecordEvent(requestParameters.eventInSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for usersViewsNinjaEventRecordEvent operation in EventApi.
 * @export
 * @interface EventApiUsersViewsNinjaEventRecordEventRequest
 */
export interface EventApiUsersViewsNinjaEventRecordEventRequest {
    /**
     * 
     * @type {EventInSchema}
     * @memberof EventApiUsersViewsNinjaEventRecordEvent
     */
    readonly eventInSchema: EventInSchema
}

/**
 * EventApi - object-oriented interface
 * @export
 * @class EventApi
 * @extends {BaseAPI}
 */
export class EventApi extends BaseAPI {
    /**
     * Temporary endpoint to record Event on Chronos DB
     * @summary Records Event
     * @param {EventApiUsersViewsNinjaEventRecordEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    public usersViewsNinjaEventRecordEvent(requestParameters: EventApiUsersViewsNinjaEventRecordEventRequest, options?: RawAxiosRequestConfig) {
        return EventApiFp(this.configuration).usersViewsNinjaEventRecordEvent(requestParameters.eventInSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FreeTrialApi - axios parameter creator
 * @export
 */
export const FreeTrialApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Free Trial Activate
         * @param {PreSaleBusinessInformationInSchema} preSaleBusinessInformationInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaFreeTrialFreeTrialActivate: async (preSaleBusinessInformationInSchema: PreSaleBusinessInformationInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preSaleBusinessInformationInSchema' is not null or undefined
            assertParamExists('paymentsViewsNinjaFreeTrialFreeTrialActivate', 'preSaleBusinessInformationInSchema', preSaleBusinessInformationInSchema)
            const localVarPath = `/api/payments/free-trial/activate/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(preSaleBusinessInformationInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register User
         * @param {UserInSchema} userInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaFreeTrialRegisterUser: async (userInSchema: UserInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaFreeTrialRegisterUser', 'userInSchema', userInSchema)
            const localVarPath = `/api/business/free-trial/register/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FreeTrialApi - functional programming interface
 * @export
 */
export const FreeTrialApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FreeTrialApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Free Trial Activate
         * @param {PreSaleBusinessInformationInSchema} preSaleBusinessInformationInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaFreeTrialFreeTrialActivate(preSaleBusinessInformationInSchema: PreSaleBusinessInformationInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BusinessOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaFreeTrialFreeTrialActivate(preSaleBusinessInformationInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FreeTrialApi.paymentsViewsNinjaFreeTrialFreeTrialActivate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Register User
         * @param {UserInSchema} userInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaFreeTrialRegisterUser(userInSchema: UserInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FreeTrialUserCreateOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaFreeTrialRegisterUser(userInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FreeTrialApi.usersViewsNinjaFreeTrialRegisterUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FreeTrialApi - factory interface
 * @export
 */
export const FreeTrialApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FreeTrialApiFp(configuration)
    return {
        /**
         * 
         * @summary Free Trial Activate
         * @param {FreeTrialApiPaymentsViewsNinjaFreeTrialFreeTrialActivateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaFreeTrialFreeTrialActivate(requestParameters: FreeTrialApiPaymentsViewsNinjaFreeTrialFreeTrialActivateRequest, options?: RawAxiosRequestConfig): AxiosPromise<BusinessOutSchema> {
            return localVarFp.paymentsViewsNinjaFreeTrialFreeTrialActivate(requestParameters.preSaleBusinessInformationInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register User
         * @param {FreeTrialApiUsersViewsNinjaFreeTrialRegisterUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaFreeTrialRegisterUser(requestParameters: FreeTrialApiUsersViewsNinjaFreeTrialRegisterUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<FreeTrialUserCreateOutSchema> {
            return localVarFp.usersViewsNinjaFreeTrialRegisterUser(requestParameters.userInSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for paymentsViewsNinjaFreeTrialFreeTrialActivate operation in FreeTrialApi.
 * @export
 * @interface FreeTrialApiPaymentsViewsNinjaFreeTrialFreeTrialActivateRequest
 */
export interface FreeTrialApiPaymentsViewsNinjaFreeTrialFreeTrialActivateRequest {
    /**
     * 
     * @type {PreSaleBusinessInformationInSchema}
     * @memberof FreeTrialApiPaymentsViewsNinjaFreeTrialFreeTrialActivate
     */
    readonly preSaleBusinessInformationInSchema: PreSaleBusinessInformationInSchema
}

/**
 * Request parameters for usersViewsNinjaFreeTrialRegisterUser operation in FreeTrialApi.
 * @export
 * @interface FreeTrialApiUsersViewsNinjaFreeTrialRegisterUserRequest
 */
export interface FreeTrialApiUsersViewsNinjaFreeTrialRegisterUserRequest {
    /**
     * 
     * @type {UserInSchema}
     * @memberof FreeTrialApiUsersViewsNinjaFreeTrialRegisterUser
     */
    readonly userInSchema: UserInSchema
}

/**
 * FreeTrialApi - object-oriented interface
 * @export
 * @class FreeTrialApi
 * @extends {BaseAPI}
 */
export class FreeTrialApi extends BaseAPI {
    /**
     * 
     * @summary Free Trial Activate
     * @param {FreeTrialApiPaymentsViewsNinjaFreeTrialFreeTrialActivateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FreeTrialApi
     */
    public paymentsViewsNinjaFreeTrialFreeTrialActivate(requestParameters: FreeTrialApiPaymentsViewsNinjaFreeTrialFreeTrialActivateRequest, options?: RawAxiosRequestConfig) {
        return FreeTrialApiFp(this.configuration).paymentsViewsNinjaFreeTrialFreeTrialActivate(requestParameters.preSaleBusinessInformationInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register User
     * @param {FreeTrialApiUsersViewsNinjaFreeTrialRegisterUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FreeTrialApi
     */
    public usersViewsNinjaFreeTrialRegisterUser(requestParameters: FreeTrialApiUsersViewsNinjaFreeTrialRegisterUserRequest, options?: RawAxiosRequestConfig) {
        return FreeTrialApiFp(this.configuration).usersViewsNinjaFreeTrialRegisterUser(requestParameters.userInSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InternationalPurchaseApi - axios parameter creator
 * @export
 */
export const InternationalPurchaseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Auth International Number Purchase
         * @param {AdditionalInternationalNumberPurchaseInSchema} additionalInternationalNumberPurchaseInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseAuthInternationalNumberPurchase: async (additionalInternationalNumberPurchaseInSchema: AdditionalInternationalNumberPurchaseInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'additionalInternationalNumberPurchaseInSchema' is not null or undefined
            assertParamExists('paymentsViewsNinjaPurchaseAuthInternationalNumberPurchase', 'additionalInternationalNumberPurchaseInSchema', additionalInternationalNumberPurchaseInSchema)
            const localVarPath = `/api/payments/number-purchase/international/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(additionalInternationalNumberPurchaseInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary International Number Purchase
         * @param {NumberPurchaseInSchema} numberPurchaseInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseInternationalNumberPurchase: async (numberPurchaseInSchema: NumberPurchaseInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'numberPurchaseInSchema' is not null or undefined
            assertParamExists('paymentsViewsNinjaPurchaseInternationalNumberPurchase', 'numberPurchaseInSchema', numberPurchaseInSchema)
            const localVarPath = `/api/payments/number-purchase/web/international/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(numberPurchaseInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternationalPurchaseApi - functional programming interface
 * @export
 */
export const InternationalPurchaseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InternationalPurchaseApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Auth International Number Purchase
         * @param {AdditionalInternationalNumberPurchaseInSchema} additionalInternationalNumberPurchaseInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaPurchaseAuthInternationalNumberPurchase(additionalInternationalNumberPurchaseInSchema: AdditionalInternationalNumberPurchaseInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentPageOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaPurchaseAuthInternationalNumberPurchase(additionalInternationalNumberPurchaseInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternationalPurchaseApi.paymentsViewsNinjaPurchaseAuthInternationalNumberPurchase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary International Number Purchase
         * @param {NumberPurchaseInSchema} numberPurchaseInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaPurchaseInternationalNumberPurchase(numberPurchaseInSchema: NumberPurchaseInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentPageOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaPurchaseInternationalNumberPurchase(numberPurchaseInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternationalPurchaseApi.paymentsViewsNinjaPurchaseInternationalNumberPurchase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InternationalPurchaseApi - factory interface
 * @export
 */
export const InternationalPurchaseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InternationalPurchaseApiFp(configuration)
    return {
        /**
         * 
         * @summary Auth International Number Purchase
         * @param {InternationalPurchaseApiPaymentsViewsNinjaPurchaseAuthInternationalNumberPurchaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseAuthInternationalNumberPurchase(requestParameters: InternationalPurchaseApiPaymentsViewsNinjaPurchaseAuthInternationalNumberPurchaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentPageOutSchema> {
            return localVarFp.paymentsViewsNinjaPurchaseAuthInternationalNumberPurchase(requestParameters.additionalInternationalNumberPurchaseInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary International Number Purchase
         * @param {InternationalPurchaseApiPaymentsViewsNinjaPurchaseInternationalNumberPurchaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseInternationalNumberPurchase(requestParameters: InternationalPurchaseApiPaymentsViewsNinjaPurchaseInternationalNumberPurchaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentPageOutSchema> {
            return localVarFp.paymentsViewsNinjaPurchaseInternationalNumberPurchase(requestParameters.numberPurchaseInSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for paymentsViewsNinjaPurchaseAuthInternationalNumberPurchase operation in InternationalPurchaseApi.
 * @export
 * @interface InternationalPurchaseApiPaymentsViewsNinjaPurchaseAuthInternationalNumberPurchaseRequest
 */
export interface InternationalPurchaseApiPaymentsViewsNinjaPurchaseAuthInternationalNumberPurchaseRequest {
    /**
     * 
     * @type {AdditionalInternationalNumberPurchaseInSchema}
     * @memberof InternationalPurchaseApiPaymentsViewsNinjaPurchaseAuthInternationalNumberPurchase
     */
    readonly additionalInternationalNumberPurchaseInSchema: AdditionalInternationalNumberPurchaseInSchema
}

/**
 * Request parameters for paymentsViewsNinjaPurchaseInternationalNumberPurchase operation in InternationalPurchaseApi.
 * @export
 * @interface InternationalPurchaseApiPaymentsViewsNinjaPurchaseInternationalNumberPurchaseRequest
 */
export interface InternationalPurchaseApiPaymentsViewsNinjaPurchaseInternationalNumberPurchaseRequest {
    /**
     * 
     * @type {NumberPurchaseInSchema}
     * @memberof InternationalPurchaseApiPaymentsViewsNinjaPurchaseInternationalNumberPurchase
     */
    readonly numberPurchaseInSchema: NumberPurchaseInSchema
}

/**
 * InternationalPurchaseApi - object-oriented interface
 * @export
 * @class InternationalPurchaseApi
 * @extends {BaseAPI}
 */
export class InternationalPurchaseApi extends BaseAPI {
    /**
     * 
     * @summary Auth International Number Purchase
     * @param {InternationalPurchaseApiPaymentsViewsNinjaPurchaseAuthInternationalNumberPurchaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternationalPurchaseApi
     */
    public paymentsViewsNinjaPurchaseAuthInternationalNumberPurchase(requestParameters: InternationalPurchaseApiPaymentsViewsNinjaPurchaseAuthInternationalNumberPurchaseRequest, options?: RawAxiosRequestConfig) {
        return InternationalPurchaseApiFp(this.configuration).paymentsViewsNinjaPurchaseAuthInternationalNumberPurchase(requestParameters.additionalInternationalNumberPurchaseInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary International Number Purchase
     * @param {InternationalPurchaseApiPaymentsViewsNinjaPurchaseInternationalNumberPurchaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternationalPurchaseApi
     */
    public paymentsViewsNinjaPurchaseInternationalNumberPurchase(requestParameters: InternationalPurchaseApiPaymentsViewsNinjaPurchaseInternationalNumberPurchaseRequest, options?: RawAxiosRequestConfig) {
        return InternationalPurchaseApiFp(this.configuration).paymentsViewsNinjaPurchaseInternationalNumberPurchase(requestParameters.numberPurchaseInSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * KnowledgeBaseApi - axios parameter creator
 * @export
 */
export const KnowledgeBaseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Knowledge Base Sub Topic
         * @param {number} businessId 
         * @param {number} topicId 
         * @param {number} addonSubId 
         * @param {Array<KnowledgeBaseSubTopicInSchema>} knowledgeBaseSubTopicInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseSubTopic: async (businessId: number, topicId: number, addonSubId: number, knowledgeBaseSubTopicInSchema: Array<KnowledgeBaseSubTopicInSchema>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseSubTopic', 'businessId', businessId)
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseSubTopic', 'topicId', topicId)
            // verify required parameter 'addonSubId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseSubTopic', 'addonSubId', addonSubId)
            // verify required parameter 'knowledgeBaseSubTopicInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseSubTopic', 'knowledgeBaseSubTopicInSchema', knowledgeBaseSubTopicInSchema)
            const localVarPath = `/api/business/{business_id}/addons/{addon_sub_id}/knowledge-base/topic/{topic_id}/sub-topic/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"topic_id"}}`, encodeURIComponent(String(topicId)))
                .replace(`{${"addon_sub_id"}}`, encodeURIComponent(String(addonSubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(knowledgeBaseSubTopicInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Knowledge Base Topic
         * @param {number} businessId 
         * @param {number} addonSubId 
         * @param {KnowledgeBaseTopicInSchema} knowledgeBaseTopicInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseTopic: async (businessId: number, addonSubId: number, knowledgeBaseTopicInSchema: KnowledgeBaseTopicInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseTopic', 'businessId', businessId)
            // verify required parameter 'addonSubId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseTopic', 'addonSubId', addonSubId)
            // verify required parameter 'knowledgeBaseTopicInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseTopic', 'knowledgeBaseTopicInSchema', knowledgeBaseTopicInSchema)
            const localVarPath = `/api/business/{business_id}/addons/{addon_sub_id}/knowledge-base/topic/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"addon_sub_id"}}`, encodeURIComponent(String(addonSubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(knowledgeBaseTopicInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Knowledge Base Sub Topic
         * @param {number} businessId 
         * @param {number} topicId 
         * @param {number} addonSubId 
         * @param {Array<number | null>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseSubTopic: async (businessId: number, topicId: number, addonSubId: number, requestBody: Array<number | null>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseSubTopic', 'businessId', businessId)
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseSubTopic', 'topicId', topicId)
            // verify required parameter 'addonSubId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseSubTopic', 'addonSubId', addonSubId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseSubTopic', 'requestBody', requestBody)
            const localVarPath = `/api/business/{business_id}/addons/{addon_sub_id}/knowledge-base/topic/{topic_id}/sub-topic/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"topic_id"}}`, encodeURIComponent(String(topicId)))
                .replace(`{${"addon_sub_id"}}`, encodeURIComponent(String(addonSubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Knowledge Base Topic
         * @param {number} businessId 
         * @param {number} addonSubId 
         * @param {Array<number | null>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseTopic: async (businessId: number, addonSubId: number, requestBody: Array<number | null>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseTopic', 'businessId', businessId)
            // verify required parameter 'addonSubId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseTopic', 'addonSubId', addonSubId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseTopic', 'requestBody', requestBody)
            const localVarPath = `/api/business/{business_id}/addons/{addon_sub_id}/knowledge-base/topics/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"addon_sub_id"}}`, encodeURIComponent(String(addonSubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Knowledge Base Sub Topic
         * @param {number} businessId 
         * @param {number} topicId 
         * @param {number} addonSubId 
         * @param {string} [title] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopic: async (businessId: number, topicId: number, addonSubId: number, title?: string, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopic', 'businessId', businessId)
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopic', 'topicId', topicId)
            // verify required parameter 'addonSubId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopic', 'addonSubId', addonSubId)
            const localVarPath = `/api/business/{business_id}/addons/{addon_sub_id}/knowledge-base/topic/{topic_id}/sub-topic/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"topic_id"}}`, encodeURIComponent(String(topicId)))
                .replace(`{${"addon_sub_id"}}`, encodeURIComponent(String(addonSubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Knowledge Base Topics
         * @param {number} businessId 
         * @param {number} addonSubId 
         * @param {string} [title] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaKnowledgeBaseListKnowledgeBaseTopics: async (businessId: number, addonSubId: number, title?: string, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseListKnowledgeBaseTopics', 'businessId', businessId)
            // verify required parameter 'addonSubId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseListKnowledgeBaseTopics', 'addonSubId', addonSubId)
            const localVarPath = `/api/business/{business_id}/addons/{addon_sub_id}/knowledge-base/topics/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"addon_sub_id"}}`, encodeURIComponent(String(addonSubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve Knowledge Base Topic
         * @param {number} businessId 
         * @param {number} addonSubId 
         * @param {number} topicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaKnowledgeBaseRetrieveKnowledgeBaseTopic: async (businessId: number, addonSubId: number, topicId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseRetrieveKnowledgeBaseTopic', 'businessId', businessId)
            // verify required parameter 'addonSubId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseRetrieveKnowledgeBaseTopic', 'addonSubId', addonSubId)
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseRetrieveKnowledgeBaseTopic', 'topicId', topicId)
            const localVarPath = `/api/business/{business_id}/addons/{addon_sub_id}/knowledge-base/topic/{topic_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"addon_sub_id"}}`, encodeURIComponent(String(addonSubId)))
                .replace(`{${"topic_id"}}`, encodeURIComponent(String(topicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Knowledge Base Sub Topic
         * @param {number} businessId 
         * @param {number} topicId 
         * @param {number} subTopicId 
         * @param {number} addonSubId 
         * @param {KnowledgeBaseSubTopicInSchema} knowledgeBaseSubTopicInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopic: async (businessId: number, topicId: number, subTopicId: number, addonSubId: number, knowledgeBaseSubTopicInSchema: KnowledgeBaseSubTopicInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopic', 'businessId', businessId)
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopic', 'topicId', topicId)
            // verify required parameter 'subTopicId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopic', 'subTopicId', subTopicId)
            // verify required parameter 'addonSubId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopic', 'addonSubId', addonSubId)
            // verify required parameter 'knowledgeBaseSubTopicInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopic', 'knowledgeBaseSubTopicInSchema', knowledgeBaseSubTopicInSchema)
            const localVarPath = `/api/business/{business_id}/addons/{addon_sub_id}/knowledge-base/topic/{topic_id}/sub-topic/{sub_topic_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"topic_id"}}`, encodeURIComponent(String(topicId)))
                .replace(`{${"sub_topic_id"}}`, encodeURIComponent(String(subTopicId)))
                .replace(`{${"addon_sub_id"}}`, encodeURIComponent(String(addonSubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(knowledgeBaseSubTopicInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Knowledge Base Topic
         * @param {number} businessId 
         * @param {number} addonSubId 
         * @param {number} topicId 
         * @param {UpdateKnowledgeBaseTopicSchema} updateKnowledgeBaseTopicSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseTopic: async (businessId: number, addonSubId: number, topicId: number, updateKnowledgeBaseTopicSchema: UpdateKnowledgeBaseTopicSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseTopic', 'businessId', businessId)
            // verify required parameter 'addonSubId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseTopic', 'addonSubId', addonSubId)
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseTopic', 'topicId', topicId)
            // verify required parameter 'updateKnowledgeBaseTopicSchema' is not null or undefined
            assertParamExists('usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseTopic', 'updateKnowledgeBaseTopicSchema', updateKnowledgeBaseTopicSchema)
            const localVarPath = `/api/business/{business_id}/addons/{addon_sub_id}/knowledge-base/topic/{topic_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"addon_sub_id"}}`, encodeURIComponent(String(addonSubId)))
                .replace(`{${"topic_id"}}`, encodeURIComponent(String(topicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateKnowledgeBaseTopicSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KnowledgeBaseApi - functional programming interface
 * @export
 */
export const KnowledgeBaseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KnowledgeBaseApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Knowledge Base Sub Topic
         * @param {number} businessId 
         * @param {number} topicId 
         * @param {number} addonSubId 
         * @param {Array<KnowledgeBaseSubTopicInSchema>} knowledgeBaseSubTopicInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseSubTopic(businessId: number, topicId: number, addonSubId: number, knowledgeBaseSubTopicInSchema: Array<KnowledgeBaseSubTopicInSchema>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<KnowledgeBaseSubTopicOutSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseSubTopic(businessId, topicId, addonSubId, knowledgeBaseSubTopicInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseSubTopic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Knowledge Base Topic
         * @param {number} businessId 
         * @param {number} addonSubId 
         * @param {KnowledgeBaseTopicInSchema} knowledgeBaseTopicInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseTopic(businessId: number, addonSubId: number, knowledgeBaseTopicInSchema: KnowledgeBaseTopicInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgeBaseTopicOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseTopic(businessId, addonSubId, knowledgeBaseTopicInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseTopic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Knowledge Base Sub Topic
         * @param {number} businessId 
         * @param {number} topicId 
         * @param {number} addonSubId 
         * @param {Array<number | null>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseSubTopic(businessId: number, topicId: number, addonSubId: number, requestBody: Array<number | null>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseSubTopic(businessId, topicId, addonSubId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseSubTopic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Knowledge Base Topic
         * @param {number} businessId 
         * @param {number} addonSubId 
         * @param {Array<number | null>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseTopic(businessId: number, addonSubId: number, requestBody: Array<number | null>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseTopic(businessId, addonSubId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseTopic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Knowledge Base Sub Topic
         * @param {number} businessId 
         * @param {number} topicId 
         * @param {number} addonSubId 
         * @param {string} [title] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopic(businessId: number, topicId: number, addonSubId: number, title?: string, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedKnowledgeBaseSubTopicOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopic(businessId, topicId, addonSubId, title, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.usersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Knowledge Base Topics
         * @param {number} businessId 
         * @param {number} addonSubId 
         * @param {string} [title] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaKnowledgeBaseListKnowledgeBaseTopics(businessId: number, addonSubId: number, title?: string, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedKnowledgeBaseTopicOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaKnowledgeBaseListKnowledgeBaseTopics(businessId, addonSubId, title, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.usersViewsNinjaKnowledgeBaseListKnowledgeBaseTopics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve Knowledge Base Topic
         * @param {number} businessId 
         * @param {number} addonSubId 
         * @param {number} topicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaKnowledgeBaseRetrieveKnowledgeBaseTopic(businessId: number, addonSubId: number, topicId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgeBaseTopicOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaKnowledgeBaseRetrieveKnowledgeBaseTopic(businessId, addonSubId, topicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.usersViewsNinjaKnowledgeBaseRetrieveKnowledgeBaseTopic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Knowledge Base Sub Topic
         * @param {number} businessId 
         * @param {number} topicId 
         * @param {number} subTopicId 
         * @param {number} addonSubId 
         * @param {KnowledgeBaseSubTopicInSchema} knowledgeBaseSubTopicInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopic(businessId: number, topicId: number, subTopicId: number, addonSubId: number, knowledgeBaseSubTopicInSchema: KnowledgeBaseSubTopicInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgeBaseSubTopicOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopic(businessId, topicId, subTopicId, addonSubId, knowledgeBaseSubTopicInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Knowledge Base Topic
         * @param {number} businessId 
         * @param {number} addonSubId 
         * @param {number} topicId 
         * @param {UpdateKnowledgeBaseTopicSchema} updateKnowledgeBaseTopicSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseTopic(businessId: number, addonSubId: number, topicId: number, updateKnowledgeBaseTopicSchema: UpdateKnowledgeBaseTopicSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgeBaseTopicOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseTopic(businessId, addonSubId, topicId, updateKnowledgeBaseTopicSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeBaseApi.usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseTopic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * KnowledgeBaseApi - factory interface
 * @export
 */
export const KnowledgeBaseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KnowledgeBaseApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Knowledge Base Sub Topic
         * @param {KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseCreateKnowledgeBaseSubTopicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseSubTopic(requestParameters: KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseCreateKnowledgeBaseSubTopicRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<KnowledgeBaseSubTopicOutSchema>> {
            return localVarFp.usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseSubTopic(requestParameters.businessId, requestParameters.topicId, requestParameters.addonSubId, requestParameters.knowledgeBaseSubTopicInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Knowledge Base Topic
         * @param {KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseCreateKnowledgeBaseTopicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseTopic(requestParameters: KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseCreateKnowledgeBaseTopicRequest, options?: RawAxiosRequestConfig): AxiosPromise<KnowledgeBaseTopicOutSchema> {
            return localVarFp.usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseTopic(requestParameters.businessId, requestParameters.addonSubId, requestParameters.knowledgeBaseTopicInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Knowledge Base Sub Topic
         * @param {KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseSubTopicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseSubTopic(requestParameters: KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseSubTopicRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseSubTopic(requestParameters.businessId, requestParameters.topicId, requestParameters.addonSubId, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Knowledge Base Topic
         * @param {KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseTopicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseTopic(requestParameters: KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseTopicRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseTopic(requestParameters.businessId, requestParameters.addonSubId, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Knowledge Base Sub Topic
         * @param {KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopic(requestParameters: KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopicRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedKnowledgeBaseSubTopicOutSchema> {
            return localVarFp.usersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopic(requestParameters.businessId, requestParameters.topicId, requestParameters.addonSubId, requestParameters.title, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Knowledge Base Topics
         * @param {KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseTopicsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaKnowledgeBaseListKnowledgeBaseTopics(requestParameters: KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseTopicsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedKnowledgeBaseTopicOutSchema> {
            return localVarFp.usersViewsNinjaKnowledgeBaseListKnowledgeBaseTopics(requestParameters.businessId, requestParameters.addonSubId, requestParameters.title, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve Knowledge Base Topic
         * @param {KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseRetrieveKnowledgeBaseTopicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaKnowledgeBaseRetrieveKnowledgeBaseTopic(requestParameters: KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseRetrieveKnowledgeBaseTopicRequest, options?: RawAxiosRequestConfig): AxiosPromise<KnowledgeBaseTopicOutSchema> {
            return localVarFp.usersViewsNinjaKnowledgeBaseRetrieveKnowledgeBaseTopic(requestParameters.businessId, requestParameters.addonSubId, requestParameters.topicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Knowledge Base Sub Topic
         * @param {KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopic(requestParameters: KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopicRequest, options?: RawAxiosRequestConfig): AxiosPromise<KnowledgeBaseSubTopicOutSchema> {
            return localVarFp.usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopic(requestParameters.businessId, requestParameters.topicId, requestParameters.subTopicId, requestParameters.addonSubId, requestParameters.knowledgeBaseSubTopicInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Knowledge Base Topic
         * @param {KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseTopicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseTopic(requestParameters: KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseTopicRequest, options?: RawAxiosRequestConfig): AxiosPromise<KnowledgeBaseTopicOutSchema> {
            return localVarFp.usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseTopic(requestParameters.businessId, requestParameters.addonSubId, requestParameters.topicId, requestParameters.updateKnowledgeBaseTopicSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseSubTopic operation in KnowledgeBaseApi.
 * @export
 * @interface KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseCreateKnowledgeBaseSubTopicRequest
 */
export interface KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseCreateKnowledgeBaseSubTopicRequest {
    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseCreateKnowledgeBaseSubTopic
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseCreateKnowledgeBaseSubTopic
     */
    readonly topicId: number

    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseCreateKnowledgeBaseSubTopic
     */
    readonly addonSubId: number

    /**
     * 
     * @type {Array<KnowledgeBaseSubTopicInSchema>}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseCreateKnowledgeBaseSubTopic
     */
    readonly knowledgeBaseSubTopicInSchema: Array<KnowledgeBaseSubTopicInSchema>
}

/**
 * Request parameters for usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseTopic operation in KnowledgeBaseApi.
 * @export
 * @interface KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseCreateKnowledgeBaseTopicRequest
 */
export interface KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseCreateKnowledgeBaseTopicRequest {
    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseCreateKnowledgeBaseTopic
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseCreateKnowledgeBaseTopic
     */
    readonly addonSubId: number

    /**
     * 
     * @type {KnowledgeBaseTopicInSchema}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseCreateKnowledgeBaseTopic
     */
    readonly knowledgeBaseTopicInSchema: KnowledgeBaseTopicInSchema
}

/**
 * Request parameters for usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseSubTopic operation in KnowledgeBaseApi.
 * @export
 * @interface KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseSubTopicRequest
 */
export interface KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseSubTopicRequest {
    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseSubTopic
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseSubTopic
     */
    readonly topicId: number

    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseSubTopic
     */
    readonly addonSubId: number

    /**
     * 
     * @type {Array<number | null>}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseSubTopic
     */
    readonly requestBody: Array<number | null>
}

/**
 * Request parameters for usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseTopic operation in KnowledgeBaseApi.
 * @export
 * @interface KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseTopicRequest
 */
export interface KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseTopicRequest {
    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseTopic
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseTopic
     */
    readonly addonSubId: number

    /**
     * 
     * @type {Array<number | null>}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseTopic
     */
    readonly requestBody: Array<number | null>
}

/**
 * Request parameters for usersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopic operation in KnowledgeBaseApi.
 * @export
 * @interface KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopicRequest
 */
export interface KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopicRequest {
    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopic
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopic
     */
    readonly topicId: number

    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopic
     */
    readonly addonSubId: number

    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopic
     */
    readonly title?: string

    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopic
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopic
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopic
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for usersViewsNinjaKnowledgeBaseListKnowledgeBaseTopics operation in KnowledgeBaseApi.
 * @export
 * @interface KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseTopicsRequest
 */
export interface KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseTopicsRequest {
    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseTopics
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseTopics
     */
    readonly addonSubId: number

    /**
     * 
     * @type {string}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseTopics
     */
    readonly title?: string

    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseTopics
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseTopics
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseTopics
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for usersViewsNinjaKnowledgeBaseRetrieveKnowledgeBaseTopic operation in KnowledgeBaseApi.
 * @export
 * @interface KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseRetrieveKnowledgeBaseTopicRequest
 */
export interface KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseRetrieveKnowledgeBaseTopicRequest {
    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseRetrieveKnowledgeBaseTopic
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseRetrieveKnowledgeBaseTopic
     */
    readonly addonSubId: number

    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseRetrieveKnowledgeBaseTopic
     */
    readonly topicId: number
}

/**
 * Request parameters for usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopic operation in KnowledgeBaseApi.
 * @export
 * @interface KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopicRequest
 */
export interface KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopicRequest {
    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopic
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopic
     */
    readonly topicId: number

    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopic
     */
    readonly subTopicId: number

    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopic
     */
    readonly addonSubId: number

    /**
     * 
     * @type {KnowledgeBaseSubTopicInSchema}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopic
     */
    readonly knowledgeBaseSubTopicInSchema: KnowledgeBaseSubTopicInSchema
}

/**
 * Request parameters for usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseTopic operation in KnowledgeBaseApi.
 * @export
 * @interface KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseTopicRequest
 */
export interface KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseTopicRequest {
    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseTopic
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseTopic
     */
    readonly addonSubId: number

    /**
     * 
     * @type {number}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseTopic
     */
    readonly topicId: number

    /**
     * 
     * @type {UpdateKnowledgeBaseTopicSchema}
     * @memberof KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseTopic
     */
    readonly updateKnowledgeBaseTopicSchema: UpdateKnowledgeBaseTopicSchema
}

/**
 * KnowledgeBaseApi - object-oriented interface
 * @export
 * @class KnowledgeBaseApi
 * @extends {BaseAPI}
 */
export class KnowledgeBaseApi extends BaseAPI {
    /**
     * 
     * @summary Create Knowledge Base Sub Topic
     * @param {KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseCreateKnowledgeBaseSubTopicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseSubTopic(requestParameters: KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseCreateKnowledgeBaseSubTopicRequest, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseSubTopic(requestParameters.businessId, requestParameters.topicId, requestParameters.addonSubId, requestParameters.knowledgeBaseSubTopicInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Knowledge Base Topic
     * @param {KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseCreateKnowledgeBaseTopicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseTopic(requestParameters: KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseCreateKnowledgeBaseTopicRequest, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).usersViewsNinjaKnowledgeBaseCreateKnowledgeBaseTopic(requestParameters.businessId, requestParameters.addonSubId, requestParameters.knowledgeBaseTopicInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Knowledge Base Sub Topic
     * @param {KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseSubTopicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseSubTopic(requestParameters: KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseSubTopicRequest, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseSubTopic(requestParameters.businessId, requestParameters.topicId, requestParameters.addonSubId, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Knowledge Base Topic
     * @param {KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseTopicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseTopic(requestParameters: KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseTopicRequest, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).usersViewsNinjaKnowledgeBaseDeleteKnowledgeBaseTopic(requestParameters.businessId, requestParameters.addonSubId, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Knowledge Base Sub Topic
     * @param {KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public usersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopic(requestParameters: KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopicRequest, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).usersViewsNinjaKnowledgeBaseListKnowledgeBaseSubTopic(requestParameters.businessId, requestParameters.topicId, requestParameters.addonSubId, requestParameters.title, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Knowledge Base Topics
     * @param {KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseTopicsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public usersViewsNinjaKnowledgeBaseListKnowledgeBaseTopics(requestParameters: KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseListKnowledgeBaseTopicsRequest, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).usersViewsNinjaKnowledgeBaseListKnowledgeBaseTopics(requestParameters.businessId, requestParameters.addonSubId, requestParameters.title, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve Knowledge Base Topic
     * @param {KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseRetrieveKnowledgeBaseTopicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public usersViewsNinjaKnowledgeBaseRetrieveKnowledgeBaseTopic(requestParameters: KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseRetrieveKnowledgeBaseTopicRequest, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).usersViewsNinjaKnowledgeBaseRetrieveKnowledgeBaseTopic(requestParameters.businessId, requestParameters.addonSubId, requestParameters.topicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Knowledge Base Sub Topic
     * @param {KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopic(requestParameters: KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopicRequest, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseSubTopic(requestParameters.businessId, requestParameters.topicId, requestParameters.subTopicId, requestParameters.addonSubId, requestParameters.knowledgeBaseSubTopicInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Knowledge Base Topic
     * @param {KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseTopicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnowledgeBaseApi
     */
    public usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseTopic(requestParameters: KnowledgeBaseApiUsersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseTopicRequest, options?: RawAxiosRequestConfig) {
        return KnowledgeBaseApiFp(this.configuration).usersViewsNinjaKnowledgeBaseUpdateKnowledgeBaseTopic(requestParameters.businessId, requestParameters.addonSubId, requestParameters.topicId, requestParameters.updateKnowledgeBaseTopicSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LiveWidgetApi - axios parameter creator
 * @export
 */
export const LiveWidgetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Widget Setting
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaLiveWidgetGetWidgetSetting: async (businessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaLiveWidgetGetWidgetSetting', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/addons/live-widget/setting/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Widget Settings
         * @param {number} businessId 
         * @param {LiveCallWidgetUpdateSchema} liveCallWidgetUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaLiveWidgetUpdateWidgetSettings: async (businessId: number, liveCallWidgetUpdateSchema: LiveCallWidgetUpdateSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaLiveWidgetUpdateWidgetSettings', 'businessId', businessId)
            // verify required parameter 'liveCallWidgetUpdateSchema' is not null or undefined
            assertParamExists('addonsViewsNinjaLiveWidgetUpdateWidgetSettings', 'liveCallWidgetUpdateSchema', liveCallWidgetUpdateSchema)
            const localVarPath = `/api/business/{business_id}/addons/live-widget/setting/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(liveCallWidgetUpdateSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Widget Call Summary
         * @param {number} businessId 
         * @param {AddonsViewsNinjaLiveWidgetWidgetCallSummaryPeriodEnum} period 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaLiveWidgetWidgetCallSummary: async (businessId: number, period: AddonsViewsNinjaLiveWidgetWidgetCallSummaryPeriodEnum, startDate?: string | null, endDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaLiveWidgetWidgetCallSummary', 'businessId', businessId)
            // verify required parameter 'period' is not null or undefined
            assertParamExists('addonsViewsNinjaLiveWidgetWidgetCallSummary', 'period', period)
            const localVarPath = `/api/business/{business_id}/addons/live-widget/call-summary/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LiveWidgetApi - functional programming interface
 * @export
 */
export const LiveWidgetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LiveWidgetApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Widget Setting
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaLiveWidgetGetWidgetSetting(businessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveCallWidgetOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaLiveWidgetGetWidgetSetting(businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LiveWidgetApi.addonsViewsNinjaLiveWidgetGetWidgetSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Widget Settings
         * @param {number} businessId 
         * @param {LiveCallWidgetUpdateSchema} liveCallWidgetUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaLiveWidgetUpdateWidgetSettings(businessId: number, liveCallWidgetUpdateSchema: LiveCallWidgetUpdateSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveCallWidgetOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaLiveWidgetUpdateWidgetSettings(businessId, liveCallWidgetUpdateSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LiveWidgetApi.addonsViewsNinjaLiveWidgetUpdateWidgetSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Widget Call Summary
         * @param {number} businessId 
         * @param {AddonsViewsNinjaLiveWidgetWidgetCallSummaryPeriodEnum} period 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaLiveWidgetWidgetCallSummary(businessId: number, period: AddonsViewsNinjaLiveWidgetWidgetCallSummaryPeriodEnum, startDate?: string | null, endDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallLogSummaryOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaLiveWidgetWidgetCallSummary(businessId, period, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LiveWidgetApi.addonsViewsNinjaLiveWidgetWidgetCallSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LiveWidgetApi - factory interface
 * @export
 */
export const LiveWidgetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LiveWidgetApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Widget Setting
         * @param {LiveWidgetApiAddonsViewsNinjaLiveWidgetGetWidgetSettingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaLiveWidgetGetWidgetSetting(requestParameters: LiveWidgetApiAddonsViewsNinjaLiveWidgetGetWidgetSettingRequest, options?: RawAxiosRequestConfig): AxiosPromise<LiveCallWidgetOutSchema> {
            return localVarFp.addonsViewsNinjaLiveWidgetGetWidgetSetting(requestParameters.businessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Widget Settings
         * @param {LiveWidgetApiAddonsViewsNinjaLiveWidgetUpdateWidgetSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaLiveWidgetUpdateWidgetSettings(requestParameters: LiveWidgetApiAddonsViewsNinjaLiveWidgetUpdateWidgetSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<LiveCallWidgetOutSchema> {
            return localVarFp.addonsViewsNinjaLiveWidgetUpdateWidgetSettings(requestParameters.businessId, requestParameters.liveCallWidgetUpdateSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Widget Call Summary
         * @param {LiveWidgetApiAddonsViewsNinjaLiveWidgetWidgetCallSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaLiveWidgetWidgetCallSummary(requestParameters: LiveWidgetApiAddonsViewsNinjaLiveWidgetWidgetCallSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<CallLogSummaryOutSchema> {
            return localVarFp.addonsViewsNinjaLiveWidgetWidgetCallSummary(requestParameters.businessId, requestParameters.period, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addonsViewsNinjaLiveWidgetGetWidgetSetting operation in LiveWidgetApi.
 * @export
 * @interface LiveWidgetApiAddonsViewsNinjaLiveWidgetGetWidgetSettingRequest
 */
export interface LiveWidgetApiAddonsViewsNinjaLiveWidgetGetWidgetSettingRequest {
    /**
     * 
     * @type {number}
     * @memberof LiveWidgetApiAddonsViewsNinjaLiveWidgetGetWidgetSetting
     */
    readonly businessId: number
}

/**
 * Request parameters for addonsViewsNinjaLiveWidgetUpdateWidgetSettings operation in LiveWidgetApi.
 * @export
 * @interface LiveWidgetApiAddonsViewsNinjaLiveWidgetUpdateWidgetSettingsRequest
 */
export interface LiveWidgetApiAddonsViewsNinjaLiveWidgetUpdateWidgetSettingsRequest {
    /**
     * 
     * @type {number}
     * @memberof LiveWidgetApiAddonsViewsNinjaLiveWidgetUpdateWidgetSettings
     */
    readonly businessId: number

    /**
     * 
     * @type {LiveCallWidgetUpdateSchema}
     * @memberof LiveWidgetApiAddonsViewsNinjaLiveWidgetUpdateWidgetSettings
     */
    readonly liveCallWidgetUpdateSchema: LiveCallWidgetUpdateSchema
}

/**
 * Request parameters for addonsViewsNinjaLiveWidgetWidgetCallSummary operation in LiveWidgetApi.
 * @export
 * @interface LiveWidgetApiAddonsViewsNinjaLiveWidgetWidgetCallSummaryRequest
 */
export interface LiveWidgetApiAddonsViewsNinjaLiveWidgetWidgetCallSummaryRequest {
    /**
     * 
     * @type {number}
     * @memberof LiveWidgetApiAddonsViewsNinjaLiveWidgetWidgetCallSummary
     */
    readonly businessId: number

    /**
     * 
     * @type {'this_week' | 'this_month' | 'this_year' | 'last_thirty_days' | 'last_ninety_days' | 'today' | 'custom'}
     * @memberof LiveWidgetApiAddonsViewsNinjaLiveWidgetWidgetCallSummary
     */
    readonly period: AddonsViewsNinjaLiveWidgetWidgetCallSummaryPeriodEnum

    /**
     * 
     * @type {string}
     * @memberof LiveWidgetApiAddonsViewsNinjaLiveWidgetWidgetCallSummary
     */
    readonly startDate?: string | null

    /**
     * 
     * @type {string}
     * @memberof LiveWidgetApiAddonsViewsNinjaLiveWidgetWidgetCallSummary
     */
    readonly endDate?: string | null
}

/**
 * LiveWidgetApi - object-oriented interface
 * @export
 * @class LiveWidgetApi
 * @extends {BaseAPI}
 */
export class LiveWidgetApi extends BaseAPI {
    /**
     * 
     * @summary Get Widget Setting
     * @param {LiveWidgetApiAddonsViewsNinjaLiveWidgetGetWidgetSettingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveWidgetApi
     */
    public addonsViewsNinjaLiveWidgetGetWidgetSetting(requestParameters: LiveWidgetApiAddonsViewsNinjaLiveWidgetGetWidgetSettingRequest, options?: RawAxiosRequestConfig) {
        return LiveWidgetApiFp(this.configuration).addonsViewsNinjaLiveWidgetGetWidgetSetting(requestParameters.businessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Widget Settings
     * @param {LiveWidgetApiAddonsViewsNinjaLiveWidgetUpdateWidgetSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveWidgetApi
     */
    public addonsViewsNinjaLiveWidgetUpdateWidgetSettings(requestParameters: LiveWidgetApiAddonsViewsNinjaLiveWidgetUpdateWidgetSettingsRequest, options?: RawAxiosRequestConfig) {
        return LiveWidgetApiFp(this.configuration).addonsViewsNinjaLiveWidgetUpdateWidgetSettings(requestParameters.businessId, requestParameters.liveCallWidgetUpdateSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Widget Call Summary
     * @param {LiveWidgetApiAddonsViewsNinjaLiveWidgetWidgetCallSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LiveWidgetApi
     */
    public addonsViewsNinjaLiveWidgetWidgetCallSummary(requestParameters: LiveWidgetApiAddonsViewsNinjaLiveWidgetWidgetCallSummaryRequest, options?: RawAxiosRequestConfig) {
        return LiveWidgetApiFp(this.configuration).addonsViewsNinjaLiveWidgetWidgetCallSummary(requestParameters.businessId, requestParameters.period, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AddonsViewsNinjaLiveWidgetWidgetCallSummaryPeriodEnum = {
    ThisWeek: 'this_week',
    ThisMonth: 'this_month',
    ThisYear: 'this_year',
    LastThirtyDays: 'last_thirty_days',
    LastNinetyDays: 'last_ninety_days',
    Today: 'today',
    Custom: 'custom'
} as const;
export type AddonsViewsNinjaLiveWidgetWidgetCallSummaryPeriodEnum = typeof AddonsViewsNinjaLiveWidgetWidgetCallSummaryPeriodEnum[keyof typeof AddonsViewsNinjaLiveWidgetWidgetCallSummaryPeriodEnum];


/**
 * LogsApi - axios parameter creator
 * @export
 */
export const LogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Email Events Webhook
         * @param {EmailWebhookEventSchema} emailWebhookEventSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logsViewsEmailEventsWebhook: async (emailWebhookEventSchema: EmailWebhookEventSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailWebhookEventSchema' is not null or undefined
            assertParamExists('logsViewsEmailEventsWebhook', 'emailWebhookEventSchema', emailWebhookEventSchema)
            const localVarPath = `/api/logs/email-events/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailWebhookEventSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Email Issue Events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logsViewsGetEmailIssueEvents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/logs/email-events/issues/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LogsApi - functional programming interface
 * @export
 */
export const LogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LogsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Email Events Webhook
         * @param {EmailWebhookEventSchema} emailWebhookEventSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logsViewsEmailEventsWebhook(emailWebhookEventSchema: EmailWebhookEventSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logsViewsEmailEventsWebhook(emailWebhookEventSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogsApi.logsViewsEmailEventsWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Email Issue Events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logsViewsGetEmailIssueEvents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmailIssueEventOutSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logsViewsGetEmailIssueEvents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogsApi.logsViewsGetEmailIssueEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LogsApi - factory interface
 * @export
 */
export const LogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LogsApiFp(configuration)
    return {
        /**
         * 
         * @summary Email Events Webhook
         * @param {LogsApiLogsViewsEmailEventsWebhookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logsViewsEmailEventsWebhook(requestParameters: LogsApiLogsViewsEmailEventsWebhookRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.logsViewsEmailEventsWebhook(requestParameters.emailWebhookEventSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Email Issue Events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logsViewsGetEmailIssueEvents(options?: RawAxiosRequestConfig): AxiosPromise<Array<EmailIssueEventOutSchema>> {
            return localVarFp.logsViewsGetEmailIssueEvents(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for logsViewsEmailEventsWebhook operation in LogsApi.
 * @export
 * @interface LogsApiLogsViewsEmailEventsWebhookRequest
 */
export interface LogsApiLogsViewsEmailEventsWebhookRequest {
    /**
     * 
     * @type {EmailWebhookEventSchema}
     * @memberof LogsApiLogsViewsEmailEventsWebhook
     */
    readonly emailWebhookEventSchema: EmailWebhookEventSchema
}

/**
 * LogsApi - object-oriented interface
 * @export
 * @class LogsApi
 * @extends {BaseAPI}
 */
export class LogsApi extends BaseAPI {
    /**
     * 
     * @summary Email Events Webhook
     * @param {LogsApiLogsViewsEmailEventsWebhookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogsApi
     */
    public logsViewsEmailEventsWebhook(requestParameters: LogsApiLogsViewsEmailEventsWebhookRequest, options?: RawAxiosRequestConfig) {
        return LogsApiFp(this.configuration).logsViewsEmailEventsWebhook(requestParameters.emailWebhookEventSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Email Issue Events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogsApi
     */
    public logsViewsGetEmailIssueEvents(options?: RawAxiosRequestConfig) {
        return LogsApiFp(this.configuration).logsViewsGetEmailIssueEvents(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ManagementConsoleApi - axios parameter creator
 * @export
 */
export const ManagementConsoleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List Audit Log
         * @param {RequestAction | null} [action] 
         * @param {string | null} [tenantId] 
         * @param {number | null} [staffId] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsManagementListAuditLog: async (action?: RequestAction | null, tenantId?: string | null, staffId?: number | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/audit-log/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }

            if (tenantId !== undefined) {
                localVarQueryParameter['tenant_id'] = tenantId;
            }

            if (staffId !== undefined) {
                localVarQueryParameter['staff_id'] = staffId;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Provision Number
         * @param {string} tenantId 
         * @param {AdminProvisionNumberInSchema} adminProvisionNumberInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsManagementProvisionNumber: async (tenantId: string, adminProvisionNumberInSchema: AdminProvisionNumberInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('managementViewsManagementProvisionNumber', 'tenantId', tenantId)
            // verify required parameter 'adminProvisionNumberInSchema' is not null or undefined
            assertParamExists('managementViewsManagementProvisionNumber', 'adminProvisionNumberInSchema', adminProvisionNumberInSchema)
            const localVarPath = `/api/admin/tenant/{tenant_id}/provision-number/`
                .replace(`{${"tenant_id"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminProvisionNumberInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace Did Caller Id
         * @param {string} tenantId 
         * @param {string} didId 
         * @param {AdminReplacePhoneNumberInSchema} adminReplacePhoneNumberInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsManagementReplaceDidCallerId: async (tenantId: string, didId: string, adminReplacePhoneNumberInSchema: AdminReplacePhoneNumberInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('managementViewsManagementReplaceDidCallerId', 'tenantId', tenantId)
            // verify required parameter 'didId' is not null or undefined
            assertParamExists('managementViewsManagementReplaceDidCallerId', 'didId', didId)
            // verify required parameter 'adminReplacePhoneNumberInSchema' is not null or undefined
            assertParamExists('managementViewsManagementReplaceDidCallerId', 'adminReplacePhoneNumberInSchema', adminReplacePhoneNumberInSchema)
            const localVarPath = `/api/admin/tenant/{tenant_id}/did/{did_id}/`
                .replace(`{${"tenant_id"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"did_id"}}`, encodeURIComponent(String(didId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminReplacePhoneNumberInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve Audit Log
         * @param {number} logId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsManagementRetrieveAuditLog: async (logId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logId' is not null or undefined
            assertParamExists('managementViewsManagementRetrieveAuditLog', 'logId', logId)
            const localVarPath = `/api/admin/audit-log/{log_id}/`
                .replace(`{${"log_id"}}`, encodeURIComponent(String(logId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Tenant Balance
         * @param {string} tenantId 
         * @param {AdminUpdateBalanceInSchema} adminUpdateBalanceInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsManagementUpdateTenantBalance: async (tenantId: string, adminUpdateBalanceInSchema: AdminUpdateBalanceInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('managementViewsManagementUpdateTenantBalance', 'tenantId', tenantId)
            // verify required parameter 'adminUpdateBalanceInSchema' is not null or undefined
            assertParamExists('managementViewsManagementUpdateTenantBalance', 'adminUpdateBalanceInSchema', adminUpdateBalanceInSchema)
            const localVarPath = `/api/admin/tenant/{tenant_id}/balance/`
                .replace(`{${"tenant_id"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateBalanceInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManagementConsoleApi - functional programming interface
 * @export
 */
export const ManagementConsoleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ManagementConsoleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List Audit Log
         * @param {RequestAction | null} [action] 
         * @param {string | null} [tenantId] 
         * @param {number | null} [staffId] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementViewsManagementListAuditLog(action?: RequestAction | null, tenantId?: string | null, staffId?: number | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedAuditLogMinimalOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementViewsManagementListAuditLog(action, tenantId, staffId, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementConsoleApi.managementViewsManagementListAuditLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Provision Number
         * @param {string} tenantId 
         * @param {AdminProvisionNumberInSchema} adminProvisionNumberInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementViewsManagementProvisionNumber(tenantId: string, adminProvisionNumberInSchema: AdminProvisionNumberInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementViewsManagementProvisionNumber(tenantId, adminProvisionNumberInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementConsoleApi.managementViewsManagementProvisionNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Replace Did Caller Id
         * @param {string} tenantId 
         * @param {string} didId 
         * @param {AdminReplacePhoneNumberInSchema} adminReplacePhoneNumberInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementViewsManagementReplaceDidCallerId(tenantId: string, didId: string, adminReplacePhoneNumberInSchema: AdminReplacePhoneNumberInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementViewsManagementReplaceDidCallerId(tenantId, didId, adminReplacePhoneNumberInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementConsoleApi.managementViewsManagementReplaceDidCallerId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve Audit Log
         * @param {number} logId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementViewsManagementRetrieveAuditLog(logId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAuditLogOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementViewsManagementRetrieveAuditLog(logId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementConsoleApi.managementViewsManagementRetrieveAuditLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Tenant Balance
         * @param {string} tenantId 
         * @param {AdminUpdateBalanceInSchema} adminUpdateBalanceInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementViewsManagementUpdateTenantBalance(tenantId: string, adminUpdateBalanceInSchema: AdminUpdateBalanceInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementViewsManagementUpdateTenantBalance(tenantId, adminUpdateBalanceInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementConsoleApi.managementViewsManagementUpdateTenantBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ManagementConsoleApi - factory interface
 * @export
 */
export const ManagementConsoleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ManagementConsoleApiFp(configuration)
    return {
        /**
         * 
         * @summary List Audit Log
         * @param {ManagementConsoleApiManagementViewsManagementListAuditLogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsManagementListAuditLog(requestParameters: ManagementConsoleApiManagementViewsManagementListAuditLogRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PagedAuditLogMinimalOutSchema> {
            return localVarFp.managementViewsManagementListAuditLog(requestParameters.action, requestParameters.tenantId, requestParameters.staffId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Provision Number
         * @param {ManagementConsoleApiManagementViewsManagementProvisionNumberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsManagementProvisionNumber(requestParameters: ManagementConsoleApiManagementViewsManagementProvisionNumberRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.managementViewsManagementProvisionNumber(requestParameters.tenantId, requestParameters.adminProvisionNumberInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace Did Caller Id
         * @param {ManagementConsoleApiManagementViewsManagementReplaceDidCallerIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsManagementReplaceDidCallerId(requestParameters: ManagementConsoleApiManagementViewsManagementReplaceDidCallerIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.managementViewsManagementReplaceDidCallerId(requestParameters.tenantId, requestParameters.didId, requestParameters.adminReplacePhoneNumberInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve Audit Log
         * @param {ManagementConsoleApiManagementViewsManagementRetrieveAuditLogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsManagementRetrieveAuditLog(requestParameters: ManagementConsoleApiManagementViewsManagementRetrieveAuditLogRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAuditLogOutSchema> {
            return localVarFp.managementViewsManagementRetrieveAuditLog(requestParameters.logId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Tenant Balance
         * @param {ManagementConsoleApiManagementViewsManagementUpdateTenantBalanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsManagementUpdateTenantBalance(requestParameters: ManagementConsoleApiManagementViewsManagementUpdateTenantBalanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.managementViewsManagementUpdateTenantBalance(requestParameters.tenantId, requestParameters.adminUpdateBalanceInSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for managementViewsManagementListAuditLog operation in ManagementConsoleApi.
 * @export
 * @interface ManagementConsoleApiManagementViewsManagementListAuditLogRequest
 */
export interface ManagementConsoleApiManagementViewsManagementListAuditLogRequest {
    /**
     * 
     * @type {RequestAction}
     * @memberof ManagementConsoleApiManagementViewsManagementListAuditLog
     */
    readonly action?: RequestAction | null

    /**
     * 
     * @type {string}
     * @memberof ManagementConsoleApiManagementViewsManagementListAuditLog
     */
    readonly tenantId?: string | null

    /**
     * 
     * @type {number}
     * @memberof ManagementConsoleApiManagementViewsManagementListAuditLog
     */
    readonly staffId?: number | null

    /**
     * 
     * @type {number}
     * @memberof ManagementConsoleApiManagementViewsManagementListAuditLog
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof ManagementConsoleApiManagementViewsManagementListAuditLog
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof ManagementConsoleApiManagementViewsManagementListAuditLog
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for managementViewsManagementProvisionNumber operation in ManagementConsoleApi.
 * @export
 * @interface ManagementConsoleApiManagementViewsManagementProvisionNumberRequest
 */
export interface ManagementConsoleApiManagementViewsManagementProvisionNumberRequest {
    /**
     * 
     * @type {string}
     * @memberof ManagementConsoleApiManagementViewsManagementProvisionNumber
     */
    readonly tenantId: string

    /**
     * 
     * @type {AdminProvisionNumberInSchema}
     * @memberof ManagementConsoleApiManagementViewsManagementProvisionNumber
     */
    readonly adminProvisionNumberInSchema: AdminProvisionNumberInSchema
}

/**
 * Request parameters for managementViewsManagementReplaceDidCallerId operation in ManagementConsoleApi.
 * @export
 * @interface ManagementConsoleApiManagementViewsManagementReplaceDidCallerIdRequest
 */
export interface ManagementConsoleApiManagementViewsManagementReplaceDidCallerIdRequest {
    /**
     * 
     * @type {string}
     * @memberof ManagementConsoleApiManagementViewsManagementReplaceDidCallerId
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof ManagementConsoleApiManagementViewsManagementReplaceDidCallerId
     */
    readonly didId: string

    /**
     * 
     * @type {AdminReplacePhoneNumberInSchema}
     * @memberof ManagementConsoleApiManagementViewsManagementReplaceDidCallerId
     */
    readonly adminReplacePhoneNumberInSchema: AdminReplacePhoneNumberInSchema
}

/**
 * Request parameters for managementViewsManagementRetrieveAuditLog operation in ManagementConsoleApi.
 * @export
 * @interface ManagementConsoleApiManagementViewsManagementRetrieveAuditLogRequest
 */
export interface ManagementConsoleApiManagementViewsManagementRetrieveAuditLogRequest {
    /**
     * 
     * @type {number}
     * @memberof ManagementConsoleApiManagementViewsManagementRetrieveAuditLog
     */
    readonly logId: number
}

/**
 * Request parameters for managementViewsManagementUpdateTenantBalance operation in ManagementConsoleApi.
 * @export
 * @interface ManagementConsoleApiManagementViewsManagementUpdateTenantBalanceRequest
 */
export interface ManagementConsoleApiManagementViewsManagementUpdateTenantBalanceRequest {
    /**
     * 
     * @type {string}
     * @memberof ManagementConsoleApiManagementViewsManagementUpdateTenantBalance
     */
    readonly tenantId: string

    /**
     * 
     * @type {AdminUpdateBalanceInSchema}
     * @memberof ManagementConsoleApiManagementViewsManagementUpdateTenantBalance
     */
    readonly adminUpdateBalanceInSchema: AdminUpdateBalanceInSchema
}

/**
 * ManagementConsoleApi - object-oriented interface
 * @export
 * @class ManagementConsoleApi
 * @extends {BaseAPI}
 */
export class ManagementConsoleApi extends BaseAPI {
    /**
     * 
     * @summary List Audit Log
     * @param {ManagementConsoleApiManagementViewsManagementListAuditLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementConsoleApi
     */
    public managementViewsManagementListAuditLog(requestParameters: ManagementConsoleApiManagementViewsManagementListAuditLogRequest = {}, options?: RawAxiosRequestConfig) {
        return ManagementConsoleApiFp(this.configuration).managementViewsManagementListAuditLog(requestParameters.action, requestParameters.tenantId, requestParameters.staffId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Provision Number
     * @param {ManagementConsoleApiManagementViewsManagementProvisionNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementConsoleApi
     */
    public managementViewsManagementProvisionNumber(requestParameters: ManagementConsoleApiManagementViewsManagementProvisionNumberRequest, options?: RawAxiosRequestConfig) {
        return ManagementConsoleApiFp(this.configuration).managementViewsManagementProvisionNumber(requestParameters.tenantId, requestParameters.adminProvisionNumberInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace Did Caller Id
     * @param {ManagementConsoleApiManagementViewsManagementReplaceDidCallerIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementConsoleApi
     */
    public managementViewsManagementReplaceDidCallerId(requestParameters: ManagementConsoleApiManagementViewsManagementReplaceDidCallerIdRequest, options?: RawAxiosRequestConfig) {
        return ManagementConsoleApiFp(this.configuration).managementViewsManagementReplaceDidCallerId(requestParameters.tenantId, requestParameters.didId, requestParameters.adminReplacePhoneNumberInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve Audit Log
     * @param {ManagementConsoleApiManagementViewsManagementRetrieveAuditLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementConsoleApi
     */
    public managementViewsManagementRetrieveAuditLog(requestParameters: ManagementConsoleApiManagementViewsManagementRetrieveAuditLogRequest, options?: RawAxiosRequestConfig) {
        return ManagementConsoleApiFp(this.configuration).managementViewsManagementRetrieveAuditLog(requestParameters.logId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Tenant Balance
     * @param {ManagementConsoleApiManagementViewsManagementUpdateTenantBalanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementConsoleApi
     */
    public managementViewsManagementUpdateTenantBalance(requestParameters: ManagementConsoleApiManagementViewsManagementUpdateTenantBalanceRequest, options?: RawAxiosRequestConfig) {
        return ManagementConsoleApiFp(this.configuration).managementViewsManagementUpdateTenantBalance(requestParameters.tenantId, requestParameters.adminUpdateBalanceInSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MediaApi - axios parameter creator
 * @export
 */
export const MediaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Request a signed URL to upload a media blob
         * @summary Create Media Blob Upload Request
         * @param {number} businessId 
         * @param {MediaBlobUploadRequestInSchema} mediaBlobUploadRequestInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaMediaCreateMediaBlobUploadRequest: async (businessId: number, mediaBlobUploadRequestInSchema: MediaBlobUploadRequestInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaMediaCreateMediaBlobUploadRequest', 'businessId', businessId)
            // verify required parameter 'mediaBlobUploadRequestInSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaMediaCreateMediaBlobUploadRequest', 'mediaBlobUploadRequestInSchema', mediaBlobUploadRequestInSchema)
            const localVarPath = `/api/media/{business_id}/blob-upload/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mediaBlobUploadRequestInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Media Blob
         * @param {number} businessId 
         * @param {MediaBlobStatus | null} [status] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaMediaListMediaBlob: async (businessId: number, status?: MediaBlobStatus | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaMediaListMediaBlob', 'businessId', businessId)
            const localVarPath = `/api/media/{business_id}/blobs/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Malware Scan Callback
         * @param {Array<CloudDefenderEventInSchema>} cloudDefenderEventInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaMediaMalwareScanCallback: async (cloudDefenderEventInSchema: Array<CloudDefenderEventInSchema>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cloudDefenderEventInSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaMediaMalwareScanCallback', 'cloudDefenderEventInSchema', cloudDefenderEventInSchema)
            const localVarPath = `/api/media/malware-scan-result/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cloudDefenderEventInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request a signed URL to upload a media blob
         * @summary Retrieve Media Blob
         * @param {number} businessId 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaMediaRetrieveMediaBlob: async (businessId: number, resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaMediaRetrieveMediaBlob', 'businessId', businessId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('telephonyViewsNinjaMediaRetrieveMediaBlob', 'resourceId', resourceId)
            const localVarPath = `/api/media/{business_id}/blobs/{resource_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MediaApi - functional programming interface
 * @export
 */
export const MediaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MediaApiAxiosParamCreator(configuration)
    return {
        /**
         * Request a signed URL to upload a media blob
         * @summary Create Media Blob Upload Request
         * @param {number} businessId 
         * @param {MediaBlobUploadRequestInSchema} mediaBlobUploadRequestInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaMediaCreateMediaBlobUploadRequest(businessId: number, mediaBlobUploadRequestInSchema: MediaBlobUploadRequestInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediaBlobUploadRequestOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaMediaCreateMediaBlobUploadRequest(businessId, mediaBlobUploadRequestInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.telephonyViewsNinjaMediaCreateMediaBlobUploadRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Media Blob
         * @param {number} businessId 
         * @param {MediaBlobStatus | null} [status] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaMediaListMediaBlob(businessId: number, status?: MediaBlobStatus | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedMediaBlobsOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaMediaListMediaBlob(businessId, status, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.telephonyViewsNinjaMediaListMediaBlob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Malware Scan Callback
         * @param {Array<CloudDefenderEventInSchema>} cloudDefenderEventInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaMediaMalwareScanCallback(cloudDefenderEventInSchema: Array<CloudDefenderEventInSchema>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaMediaMalwareScanCallback(cloudDefenderEventInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.telephonyViewsNinjaMediaMalwareScanCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Request a signed URL to upload a media blob
         * @summary Retrieve Media Blob
         * @param {number} businessId 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaMediaRetrieveMediaBlob(businessId: number, resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediaBlobOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaMediaRetrieveMediaBlob(businessId, resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.telephonyViewsNinjaMediaRetrieveMediaBlob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MediaApi - factory interface
 * @export
 */
export const MediaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MediaApiFp(configuration)
    return {
        /**
         * Request a signed URL to upload a media blob
         * @summary Create Media Blob Upload Request
         * @param {MediaApiTelephonyViewsNinjaMediaCreateMediaBlobUploadRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaMediaCreateMediaBlobUploadRequest(requestParameters: MediaApiTelephonyViewsNinjaMediaCreateMediaBlobUploadRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<MediaBlobUploadRequestOutSchema> {
            return localVarFp.telephonyViewsNinjaMediaCreateMediaBlobUploadRequest(requestParameters.businessId, requestParameters.mediaBlobUploadRequestInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Media Blob
         * @param {MediaApiTelephonyViewsNinjaMediaListMediaBlobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaMediaListMediaBlob(requestParameters: MediaApiTelephonyViewsNinjaMediaListMediaBlobRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedMediaBlobsOutSchema> {
            return localVarFp.telephonyViewsNinjaMediaListMediaBlob(requestParameters.businessId, requestParameters.status, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Malware Scan Callback
         * @param {MediaApiTelephonyViewsNinjaMediaMalwareScanCallbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaMediaMalwareScanCallback(requestParameters: MediaApiTelephonyViewsNinjaMediaMalwareScanCallbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.telephonyViewsNinjaMediaMalwareScanCallback(requestParameters.cloudDefenderEventInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Request a signed URL to upload a media blob
         * @summary Retrieve Media Blob
         * @param {MediaApiTelephonyViewsNinjaMediaRetrieveMediaBlobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaMediaRetrieveMediaBlob(requestParameters: MediaApiTelephonyViewsNinjaMediaRetrieveMediaBlobRequest, options?: RawAxiosRequestConfig): AxiosPromise<MediaBlobOutSchema> {
            return localVarFp.telephonyViewsNinjaMediaRetrieveMediaBlob(requestParameters.businessId, requestParameters.resourceId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for telephonyViewsNinjaMediaCreateMediaBlobUploadRequest operation in MediaApi.
 * @export
 * @interface MediaApiTelephonyViewsNinjaMediaCreateMediaBlobUploadRequestRequest
 */
export interface MediaApiTelephonyViewsNinjaMediaCreateMediaBlobUploadRequestRequest {
    /**
     * 
     * @type {number}
     * @memberof MediaApiTelephonyViewsNinjaMediaCreateMediaBlobUploadRequest
     */
    readonly businessId: number

    /**
     * 
     * @type {MediaBlobUploadRequestInSchema}
     * @memberof MediaApiTelephonyViewsNinjaMediaCreateMediaBlobUploadRequest
     */
    readonly mediaBlobUploadRequestInSchema: MediaBlobUploadRequestInSchema
}

/**
 * Request parameters for telephonyViewsNinjaMediaListMediaBlob operation in MediaApi.
 * @export
 * @interface MediaApiTelephonyViewsNinjaMediaListMediaBlobRequest
 */
export interface MediaApiTelephonyViewsNinjaMediaListMediaBlobRequest {
    /**
     * 
     * @type {number}
     * @memberof MediaApiTelephonyViewsNinjaMediaListMediaBlob
     */
    readonly businessId: number

    /**
     * 
     * @type {MediaBlobStatus}
     * @memberof MediaApiTelephonyViewsNinjaMediaListMediaBlob
     */
    readonly status?: MediaBlobStatus | null

    /**
     * 
     * @type {number}
     * @memberof MediaApiTelephonyViewsNinjaMediaListMediaBlob
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof MediaApiTelephonyViewsNinjaMediaListMediaBlob
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof MediaApiTelephonyViewsNinjaMediaListMediaBlob
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for telephonyViewsNinjaMediaMalwareScanCallback operation in MediaApi.
 * @export
 * @interface MediaApiTelephonyViewsNinjaMediaMalwareScanCallbackRequest
 */
export interface MediaApiTelephonyViewsNinjaMediaMalwareScanCallbackRequest {
    /**
     * 
     * @type {Array<CloudDefenderEventInSchema>}
     * @memberof MediaApiTelephonyViewsNinjaMediaMalwareScanCallback
     */
    readonly cloudDefenderEventInSchema: Array<CloudDefenderEventInSchema>
}

/**
 * Request parameters for telephonyViewsNinjaMediaRetrieveMediaBlob operation in MediaApi.
 * @export
 * @interface MediaApiTelephonyViewsNinjaMediaRetrieveMediaBlobRequest
 */
export interface MediaApiTelephonyViewsNinjaMediaRetrieveMediaBlobRequest {
    /**
     * 
     * @type {number}
     * @memberof MediaApiTelephonyViewsNinjaMediaRetrieveMediaBlob
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof MediaApiTelephonyViewsNinjaMediaRetrieveMediaBlob
     */
    readonly resourceId: string
}

/**
 * MediaApi - object-oriented interface
 * @export
 * @class MediaApi
 * @extends {BaseAPI}
 */
export class MediaApi extends BaseAPI {
    /**
     * Request a signed URL to upload a media blob
     * @summary Create Media Blob Upload Request
     * @param {MediaApiTelephonyViewsNinjaMediaCreateMediaBlobUploadRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public telephonyViewsNinjaMediaCreateMediaBlobUploadRequest(requestParameters: MediaApiTelephonyViewsNinjaMediaCreateMediaBlobUploadRequestRequest, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).telephonyViewsNinjaMediaCreateMediaBlobUploadRequest(requestParameters.businessId, requestParameters.mediaBlobUploadRequestInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Media Blob
     * @param {MediaApiTelephonyViewsNinjaMediaListMediaBlobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public telephonyViewsNinjaMediaListMediaBlob(requestParameters: MediaApiTelephonyViewsNinjaMediaListMediaBlobRequest, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).telephonyViewsNinjaMediaListMediaBlob(requestParameters.businessId, requestParameters.status, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Malware Scan Callback
     * @param {MediaApiTelephonyViewsNinjaMediaMalwareScanCallbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public telephonyViewsNinjaMediaMalwareScanCallback(requestParameters: MediaApiTelephonyViewsNinjaMediaMalwareScanCallbackRequest, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).telephonyViewsNinjaMediaMalwareScanCallback(requestParameters.cloudDefenderEventInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Request a signed URL to upload a media blob
     * @summary Retrieve Media Blob
     * @param {MediaApiTelephonyViewsNinjaMediaRetrieveMediaBlobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public telephonyViewsNinjaMediaRetrieveMediaBlob(requestParameters: MediaApiTelephonyViewsNinjaMediaRetrieveMediaBlobRequest, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).telephonyViewsNinjaMediaRetrieveMediaBlob(requestParameters.businessId, requestParameters.resourceId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Mark All Notifications As Read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsNotificationMarkAllNotificationsAsRead: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notification/mark-all-as-read/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark Selected Notifications As Read
         * @param {SelectNotificationInSchema} selectNotificationInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsNotificationMarkSelectedNotificationsAsRead: async (selectNotificationInSchema: SelectNotificationInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'selectNotificationInSchema' is not null or undefined
            assertParamExists('messagingViewsNotificationMarkSelectedNotificationsAsRead', 'selectNotificationInSchema', selectNotificationInSchema)
            const localVarPath = `/api/notification/mark-as-read/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(selectNotificationInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Mark All Notifications As Read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingViewsNotificationMarkAllNotificationsAsRead(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationOutSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingViewsNotificationMarkAllNotificationsAsRead(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.messagingViewsNotificationMarkAllNotificationsAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark Selected Notifications As Read
         * @param {SelectNotificationInSchema} selectNotificationInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagingViewsNotificationMarkSelectedNotificationsAsRead(selectNotificationInSchema: SelectNotificationInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationOutSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagingViewsNotificationMarkSelectedNotificationsAsRead(selectNotificationInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.messagingViewsNotificationMarkSelectedNotificationsAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Mark All Notifications As Read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsNotificationMarkAllNotificationsAsRead(options?: RawAxiosRequestConfig): AxiosPromise<Array<NotificationOutSchema>> {
            return localVarFp.messagingViewsNotificationMarkAllNotificationsAsRead(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark Selected Notifications As Read
         * @param {NotificationsApiMessagingViewsNotificationMarkSelectedNotificationsAsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagingViewsNotificationMarkSelectedNotificationsAsRead(requestParameters: NotificationsApiMessagingViewsNotificationMarkSelectedNotificationsAsReadRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<NotificationOutSchema>> {
            return localVarFp.messagingViewsNotificationMarkSelectedNotificationsAsRead(requestParameters.selectNotificationInSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for messagingViewsNotificationMarkSelectedNotificationsAsRead operation in NotificationsApi.
 * @export
 * @interface NotificationsApiMessagingViewsNotificationMarkSelectedNotificationsAsReadRequest
 */
export interface NotificationsApiMessagingViewsNotificationMarkSelectedNotificationsAsReadRequest {
    /**
     * 
     * @type {SelectNotificationInSchema}
     * @memberof NotificationsApiMessagingViewsNotificationMarkSelectedNotificationsAsRead
     */
    readonly selectNotificationInSchema: SelectNotificationInSchema
}

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * 
     * @summary Mark All Notifications As Read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public messagingViewsNotificationMarkAllNotificationsAsRead(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).messagingViewsNotificationMarkAllNotificationsAsRead(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark Selected Notifications As Read
     * @param {NotificationsApiMessagingViewsNotificationMarkSelectedNotificationsAsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public messagingViewsNotificationMarkSelectedNotificationsAsRead(requestParameters: NotificationsApiMessagingViewsNotificationMarkSelectedNotificationsAsReadRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).messagingViewsNotificationMarkSelectedNotificationsAsRead(requestParameters.selectNotificationInSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NumberApi - axios parameter creator
 * @export
 */
export const NumberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Disable Incoming Calls
         * @param {number} businessId 
         * @param {number} numberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberNumberDisableIncomingCalls: async (businessId: number, numberId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberNumberDisableIncomingCalls', 'businessId', businessId)
            // verify required parameter 'numberId' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberNumberDisableIncomingCalls', 'numberId', numberId)
            const localVarPath = `/api/business/{business_id}/number/{number_id}/disable-incoming/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"number_id"}}`, encodeURIComponent(String(numberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Business Numbers Extension Limit
         * @param {number} businessId 
         * @param {number | null} [numberId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberNumberGetBusinessNumbersExtensionLimit: async (businessId: number, numberId?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberNumberGetBusinessNumbersExtensionLimit', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/extension-limit/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (numberId !== undefined) {
                localVarQueryParameter['number_id'] = numberId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Business Number Users
         * @param {number} businessId 
         * @param {number} numberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberNumberListBusinessNumberUsers: async (businessId: number, numberId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberNumberListBusinessNumberUsers', 'businessId', businessId)
            // verify required parameter 'numberId' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberNumberListBusinessNumberUsers', 'numberId', numberId)
            const localVarPath = `/api/business/{business_id}/number/{number_id}/users/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"number_id"}}`, encodeURIComponent(String(numberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Business Numbers
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberNumberListBusinessNumbers: async (businessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberNumberListBusinessNumbers', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/number/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NumberApi - functional programming interface
 * @export
 */
export const NumberApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NumberApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Disable Incoming Calls
         * @param {number} businessId 
         * @param {number} numberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaNumberNumberDisableIncomingCalls(businessId: number, numberId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaNumberNumberDisableIncomingCalls(businessId, numberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NumberApi.telephonyViewsNinjaNumberNumberDisableIncomingCalls']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Business Numbers Extension Limit
         * @param {number} businessId 
         * @param {number | null} [numberId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaNumberNumberGetBusinessNumbersExtensionLimit(businessId: number, numberId?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BusinessNumberExtensionLimitOutSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaNumberNumberGetBusinessNumbersExtensionLimit(businessId, numberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NumberApi.telephonyViewsNinjaNumberNumberGetBusinessNumbersExtensionLimit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Business Number Users
         * @param {number} businessId 
         * @param {number} numberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaNumberNumberListBusinessNumberUsers(businessId: number, numberId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseListProfileMinimalOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaNumberNumberListBusinessNumberUsers(businessId, numberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NumberApi.telephonyViewsNinjaNumberNumberListBusinessNumberUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Business Numbers
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaNumberNumberListBusinessNumbers(businessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BusinessNumberOutSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaNumberNumberListBusinessNumbers(businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NumberApi.telephonyViewsNinjaNumberNumberListBusinessNumbers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NumberApi - factory interface
 * @export
 */
export const NumberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NumberApiFp(configuration)
    return {
        /**
         * 
         * @summary Disable Incoming Calls
         * @param {NumberApiTelephonyViewsNinjaNumberNumberDisableIncomingCallsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberNumberDisableIncomingCalls(requestParameters: NumberApiTelephonyViewsNinjaNumberNumberDisableIncomingCallsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.telephonyViewsNinjaNumberNumberDisableIncomingCalls(requestParameters.businessId, requestParameters.numberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Business Numbers Extension Limit
         * @param {NumberApiTelephonyViewsNinjaNumberNumberGetBusinessNumbersExtensionLimitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberNumberGetBusinessNumbersExtensionLimit(requestParameters: NumberApiTelephonyViewsNinjaNumberNumberGetBusinessNumbersExtensionLimitRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<BusinessNumberExtensionLimitOutSchema>> {
            return localVarFp.telephonyViewsNinjaNumberNumberGetBusinessNumbersExtensionLimit(requestParameters.businessId, requestParameters.numberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Business Number Users
         * @param {NumberApiTelephonyViewsNinjaNumberNumberListBusinessNumberUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberNumberListBusinessNumberUsers(requestParameters: NumberApiTelephonyViewsNinjaNumberNumberListBusinessNumberUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseListProfileMinimalOutSchema> {
            return localVarFp.telephonyViewsNinjaNumberNumberListBusinessNumberUsers(requestParameters.businessId, requestParameters.numberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Business Numbers
         * @param {NumberApiTelephonyViewsNinjaNumberNumberListBusinessNumbersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberNumberListBusinessNumbers(requestParameters: NumberApiTelephonyViewsNinjaNumberNumberListBusinessNumbersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<BusinessNumberOutSchema>> {
            return localVarFp.telephonyViewsNinjaNumberNumberListBusinessNumbers(requestParameters.businessId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for telephonyViewsNinjaNumberNumberDisableIncomingCalls operation in NumberApi.
 * @export
 * @interface NumberApiTelephonyViewsNinjaNumberNumberDisableIncomingCallsRequest
 */
export interface NumberApiTelephonyViewsNinjaNumberNumberDisableIncomingCallsRequest {
    /**
     * 
     * @type {number}
     * @memberof NumberApiTelephonyViewsNinjaNumberNumberDisableIncomingCalls
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof NumberApiTelephonyViewsNinjaNumberNumberDisableIncomingCalls
     */
    readonly numberId: number
}

/**
 * Request parameters for telephonyViewsNinjaNumberNumberGetBusinessNumbersExtensionLimit operation in NumberApi.
 * @export
 * @interface NumberApiTelephonyViewsNinjaNumberNumberGetBusinessNumbersExtensionLimitRequest
 */
export interface NumberApiTelephonyViewsNinjaNumberNumberGetBusinessNumbersExtensionLimitRequest {
    /**
     * 
     * @type {number}
     * @memberof NumberApiTelephonyViewsNinjaNumberNumberGetBusinessNumbersExtensionLimit
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof NumberApiTelephonyViewsNinjaNumberNumberGetBusinessNumbersExtensionLimit
     */
    readonly numberId?: number | null
}

/**
 * Request parameters for telephonyViewsNinjaNumberNumberListBusinessNumberUsers operation in NumberApi.
 * @export
 * @interface NumberApiTelephonyViewsNinjaNumberNumberListBusinessNumberUsersRequest
 */
export interface NumberApiTelephonyViewsNinjaNumberNumberListBusinessNumberUsersRequest {
    /**
     * 
     * @type {number}
     * @memberof NumberApiTelephonyViewsNinjaNumberNumberListBusinessNumberUsers
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof NumberApiTelephonyViewsNinjaNumberNumberListBusinessNumberUsers
     */
    readonly numberId: number
}

/**
 * Request parameters for telephonyViewsNinjaNumberNumberListBusinessNumbers operation in NumberApi.
 * @export
 * @interface NumberApiTelephonyViewsNinjaNumberNumberListBusinessNumbersRequest
 */
export interface NumberApiTelephonyViewsNinjaNumberNumberListBusinessNumbersRequest {
    /**
     * 
     * @type {number}
     * @memberof NumberApiTelephonyViewsNinjaNumberNumberListBusinessNumbers
     */
    readonly businessId: number
}

/**
 * NumberApi - object-oriented interface
 * @export
 * @class NumberApi
 * @extends {BaseAPI}
 */
export class NumberApi extends BaseAPI {
    /**
     * 
     * @summary Disable Incoming Calls
     * @param {NumberApiTelephonyViewsNinjaNumberNumberDisableIncomingCallsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NumberApi
     */
    public telephonyViewsNinjaNumberNumberDisableIncomingCalls(requestParameters: NumberApiTelephonyViewsNinjaNumberNumberDisableIncomingCallsRequest, options?: RawAxiosRequestConfig) {
        return NumberApiFp(this.configuration).telephonyViewsNinjaNumberNumberDisableIncomingCalls(requestParameters.businessId, requestParameters.numberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Business Numbers Extension Limit
     * @param {NumberApiTelephonyViewsNinjaNumberNumberGetBusinessNumbersExtensionLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NumberApi
     */
    public telephonyViewsNinjaNumberNumberGetBusinessNumbersExtensionLimit(requestParameters: NumberApiTelephonyViewsNinjaNumberNumberGetBusinessNumbersExtensionLimitRequest, options?: RawAxiosRequestConfig) {
        return NumberApiFp(this.configuration).telephonyViewsNinjaNumberNumberGetBusinessNumbersExtensionLimit(requestParameters.businessId, requestParameters.numberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Business Number Users
     * @param {NumberApiTelephonyViewsNinjaNumberNumberListBusinessNumberUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NumberApi
     */
    public telephonyViewsNinjaNumberNumberListBusinessNumberUsers(requestParameters: NumberApiTelephonyViewsNinjaNumberNumberListBusinessNumberUsersRequest, options?: RawAxiosRequestConfig) {
        return NumberApiFp(this.configuration).telephonyViewsNinjaNumberNumberListBusinessNumberUsers(requestParameters.businessId, requestParameters.numberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Business Numbers
     * @param {NumberApiTelephonyViewsNinjaNumberNumberListBusinessNumbersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NumberApi
     */
    public telephonyViewsNinjaNumberNumberListBusinessNumbers(requestParameters: NumberApiTelephonyViewsNinjaNumberNumberListBusinessNumbersRequest, options?: RawAxiosRequestConfig) {
        return NumberApiFp(this.configuration).telephonyViewsNinjaNumberNumberListBusinessNumbers(requestParameters.businessId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OnboardingApi - axios parameter creator
 * @export
 */
export const OnboardingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieve Business Onboarding Form
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaOnboardingRetrieveBusinessOnboardingForm: async (businessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaOnboardingRetrieveBusinessOnboardingForm', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/onboarding-form/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Trigger Business Welcome Call
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaOnboardingTriggerBusinessWelcomeCall: async (businessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaOnboardingTriggerBusinessWelcomeCall', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/welcome-call/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Business Onboarding Form
         * @param {number} businessId 
         * @param {OnboardingInSchema} onboardingInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaOnboardingUpdateBusinessOnboardingForm: async (businessId: number, onboardingInSchema: OnboardingInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaOnboardingUpdateBusinessOnboardingForm', 'businessId', businessId)
            // verify required parameter 'onboardingInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaOnboardingUpdateBusinessOnboardingForm', 'onboardingInSchema', onboardingInSchema)
            const localVarPath = `/api/business/{business_id}/onboarding-form/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(onboardingInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Campaign Leads
         * @param {LeadCampaignInSchema} leadCampaignInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaPreSaleBusinessInformationCreateCampaignLeads: async (leadCampaignInSchema: LeadCampaignInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leadCampaignInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaPreSaleBusinessInformationCreateCampaignLeads', 'leadCampaignInSchema', leadCampaignInSchema)
            const localVarPath = `/api/leads/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(leadCampaignInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Recommendation Form
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaPreSaleBusinessInformationGetRecommendationForm: async (pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/recommendation-form/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Recommendation Form By Email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaPreSaleBusinessInformationGetRecommendationFormByEmail: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('usersViewsNinjaPreSaleBusinessInformationGetRecommendationFormByEmail', 'email', email)
            const localVarPath = `/api/recommendation-form/by-email/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Signup Stage
         * @param {string} globalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaPreSaleBusinessInformationGetSignupStage: async (globalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'globalId' is not null or undefined
            assertParamExists('usersViewsNinjaPreSaleBusinessInformationGetSignupStage', 'globalId', globalId)
            const localVarPath = `/api/complete-signup/{global_id}/`
                .replace(`{${"global_id"}}`, encodeURIComponent(String(globalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit Recommendation Form
         * @param {PreSaleBusinessInformationInSchema} preSaleBusinessInformationInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaPreSaleBusinessInformationSubmitRecommendationForm: async (preSaleBusinessInformationInSchema: PreSaleBusinessInformationInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preSaleBusinessInformationInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaPreSaleBusinessInformationSubmitRecommendationForm', 'preSaleBusinessInformationInSchema', preSaleBusinessInformationInSchema)
            const localVarPath = `/api/recommendation-form/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(preSaleBusinessInformationInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Recommendation Form
         * @param {number} presaleId 
         * @param {PreSaleBusinessInformationUpdateSchema} preSaleBusinessInformationUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaPreSaleBusinessInformationUpdateRecommendationForm: async (presaleId: number, preSaleBusinessInformationUpdateSchema: PreSaleBusinessInformationUpdateSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'presaleId' is not null or undefined
            assertParamExists('usersViewsNinjaPreSaleBusinessInformationUpdateRecommendationForm', 'presaleId', presaleId)
            // verify required parameter 'preSaleBusinessInformationUpdateSchema' is not null or undefined
            assertParamExists('usersViewsNinjaPreSaleBusinessInformationUpdateRecommendationForm', 'preSaleBusinessInformationUpdateSchema', preSaleBusinessInformationUpdateSchema)
            const localVarPath = `/api/recommendation-form/{presale_id}/`
                .replace(`{${"presale_id"}}`, encodeURIComponent(String(presaleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GlobalIdAuthentication required
            await setApiKeyToObject(localVarHeaderParameter, "Pressone-X-Global-ID", configuration)

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(preSaleBusinessInformationUpdateSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OnboardingApi - functional programming interface
 * @export
 */
export const OnboardingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OnboardingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieve Business Onboarding Form
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaOnboardingRetrieveBusinessOnboardingForm(businessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaOnboardingRetrieveBusinessOnboardingForm(businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.usersViewsNinjaOnboardingRetrieveBusinessOnboardingForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Trigger Business Welcome Call
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaOnboardingTriggerBusinessWelcomeCall(businessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaOnboardingTriggerBusinessWelcomeCall(businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.usersViewsNinjaOnboardingTriggerBusinessWelcomeCall']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Business Onboarding Form
         * @param {number} businessId 
         * @param {OnboardingInSchema} onboardingInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaOnboardingUpdateBusinessOnboardingForm(businessId: number, onboardingInSchema: OnboardingInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaOnboardingUpdateBusinessOnboardingForm(businessId, onboardingInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.usersViewsNinjaOnboardingUpdateBusinessOnboardingForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Campaign Leads
         * @param {LeadCampaignInSchema} leadCampaignInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaPreSaleBusinessInformationCreateCampaignLeads(leadCampaignInSchema: LeadCampaignInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaPreSaleBusinessInformationCreateCampaignLeads(leadCampaignInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.usersViewsNinjaPreSaleBusinessInformationCreateCampaignLeads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Recommendation Form
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaPreSaleBusinessInformationGetRecommendationForm(pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedPreSaleBusinessInformationOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaPreSaleBusinessInformationGetRecommendationForm(pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.usersViewsNinjaPreSaleBusinessInformationGetRecommendationForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Recommendation Form By Email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaPreSaleBusinessInformationGetRecommendationFormByEmail(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePreSaleBusinessInformationOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaPreSaleBusinessInformationGetRecommendationFormByEmail(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.usersViewsNinjaPreSaleBusinessInformationGetRecommendationFormByEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Signup Stage
         * @param {string} globalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaPreSaleBusinessInformationGetSignupStage(globalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSignupStageOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaPreSaleBusinessInformationGetSignupStage(globalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.usersViewsNinjaPreSaleBusinessInformationGetSignupStage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Submit Recommendation Form
         * @param {PreSaleBusinessInformationInSchema} preSaleBusinessInformationInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaPreSaleBusinessInformationSubmitRecommendationForm(preSaleBusinessInformationInSchema: PreSaleBusinessInformationInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePreSaleBusinessInformationOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaPreSaleBusinessInformationSubmitRecommendationForm(preSaleBusinessInformationInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.usersViewsNinjaPreSaleBusinessInformationSubmitRecommendationForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Recommendation Form
         * @param {number} presaleId 
         * @param {PreSaleBusinessInformationUpdateSchema} preSaleBusinessInformationUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaPreSaleBusinessInformationUpdateRecommendationForm(presaleId: number, preSaleBusinessInformationUpdateSchema: PreSaleBusinessInformationUpdateSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreSaleBusinessInformationOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaPreSaleBusinessInformationUpdateRecommendationForm(presaleId, preSaleBusinessInformationUpdateSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.usersViewsNinjaPreSaleBusinessInformationUpdateRecommendationForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OnboardingApi - factory interface
 * @export
 */
export const OnboardingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OnboardingApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieve Business Onboarding Form
         * @param {OnboardingApiUsersViewsNinjaOnboardingRetrieveBusinessOnboardingFormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaOnboardingRetrieveBusinessOnboardingForm(requestParameters: OnboardingApiUsersViewsNinjaOnboardingRetrieveBusinessOnboardingFormRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardingOutSchema> {
            return localVarFp.usersViewsNinjaOnboardingRetrieveBusinessOnboardingForm(requestParameters.businessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Trigger Business Welcome Call
         * @param {OnboardingApiUsersViewsNinjaOnboardingTriggerBusinessWelcomeCallRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaOnboardingTriggerBusinessWelcomeCall(requestParameters: OnboardingApiUsersViewsNinjaOnboardingTriggerBusinessWelcomeCallRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaOnboardingTriggerBusinessWelcomeCall(requestParameters.businessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Business Onboarding Form
         * @param {OnboardingApiUsersViewsNinjaOnboardingUpdateBusinessOnboardingFormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaOnboardingUpdateBusinessOnboardingForm(requestParameters: OnboardingApiUsersViewsNinjaOnboardingUpdateBusinessOnboardingFormRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardingOutSchema> {
            return localVarFp.usersViewsNinjaOnboardingUpdateBusinessOnboardingForm(requestParameters.businessId, requestParameters.onboardingInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Campaign Leads
         * @param {OnboardingApiUsersViewsNinjaPreSaleBusinessInformationCreateCampaignLeadsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaPreSaleBusinessInformationCreateCampaignLeads(requestParameters: OnboardingApiUsersViewsNinjaPreSaleBusinessInformationCreateCampaignLeadsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaPreSaleBusinessInformationCreateCampaignLeads(requestParameters.leadCampaignInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Recommendation Form
         * @param {OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetRecommendationFormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaPreSaleBusinessInformationGetRecommendationForm(requestParameters: OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetRecommendationFormRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PagedPreSaleBusinessInformationOutSchema> {
            return localVarFp.usersViewsNinjaPreSaleBusinessInformationGetRecommendationForm(requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Recommendation Form By Email
         * @param {OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetRecommendationFormByEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaPreSaleBusinessInformationGetRecommendationFormByEmail(requestParameters: OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetRecommendationFormByEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponsePreSaleBusinessInformationOutSchema> {
            return localVarFp.usersViewsNinjaPreSaleBusinessInformationGetRecommendationFormByEmail(requestParameters.email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Signup Stage
         * @param {OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetSignupStageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaPreSaleBusinessInformationGetSignupStage(requestParameters: OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetSignupStageRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseSignupStageOutSchema> {
            return localVarFp.usersViewsNinjaPreSaleBusinessInformationGetSignupStage(requestParameters.globalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit Recommendation Form
         * @param {OnboardingApiUsersViewsNinjaPreSaleBusinessInformationSubmitRecommendationFormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaPreSaleBusinessInformationSubmitRecommendationForm(requestParameters: OnboardingApiUsersViewsNinjaPreSaleBusinessInformationSubmitRecommendationFormRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponsePreSaleBusinessInformationOutSchema> {
            return localVarFp.usersViewsNinjaPreSaleBusinessInformationSubmitRecommendationForm(requestParameters.preSaleBusinessInformationInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Recommendation Form
         * @param {OnboardingApiUsersViewsNinjaPreSaleBusinessInformationUpdateRecommendationFormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaPreSaleBusinessInformationUpdateRecommendationForm(requestParameters: OnboardingApiUsersViewsNinjaPreSaleBusinessInformationUpdateRecommendationFormRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreSaleBusinessInformationOutSchema> {
            return localVarFp.usersViewsNinjaPreSaleBusinessInformationUpdateRecommendationForm(requestParameters.presaleId, requestParameters.preSaleBusinessInformationUpdateSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for usersViewsNinjaOnboardingRetrieveBusinessOnboardingForm operation in OnboardingApi.
 * @export
 * @interface OnboardingApiUsersViewsNinjaOnboardingRetrieveBusinessOnboardingFormRequest
 */
export interface OnboardingApiUsersViewsNinjaOnboardingRetrieveBusinessOnboardingFormRequest {
    /**
     * 
     * @type {number}
     * @memberof OnboardingApiUsersViewsNinjaOnboardingRetrieveBusinessOnboardingForm
     */
    readonly businessId: number
}

/**
 * Request parameters for usersViewsNinjaOnboardingTriggerBusinessWelcomeCall operation in OnboardingApi.
 * @export
 * @interface OnboardingApiUsersViewsNinjaOnboardingTriggerBusinessWelcomeCallRequest
 */
export interface OnboardingApiUsersViewsNinjaOnboardingTriggerBusinessWelcomeCallRequest {
    /**
     * 
     * @type {number}
     * @memberof OnboardingApiUsersViewsNinjaOnboardingTriggerBusinessWelcomeCall
     */
    readonly businessId: number
}

/**
 * Request parameters for usersViewsNinjaOnboardingUpdateBusinessOnboardingForm operation in OnboardingApi.
 * @export
 * @interface OnboardingApiUsersViewsNinjaOnboardingUpdateBusinessOnboardingFormRequest
 */
export interface OnboardingApiUsersViewsNinjaOnboardingUpdateBusinessOnboardingFormRequest {
    /**
     * 
     * @type {number}
     * @memberof OnboardingApiUsersViewsNinjaOnboardingUpdateBusinessOnboardingForm
     */
    readonly businessId: number

    /**
     * 
     * @type {OnboardingInSchema}
     * @memberof OnboardingApiUsersViewsNinjaOnboardingUpdateBusinessOnboardingForm
     */
    readonly onboardingInSchema: OnboardingInSchema
}

/**
 * Request parameters for usersViewsNinjaPreSaleBusinessInformationCreateCampaignLeads operation in OnboardingApi.
 * @export
 * @interface OnboardingApiUsersViewsNinjaPreSaleBusinessInformationCreateCampaignLeadsRequest
 */
export interface OnboardingApiUsersViewsNinjaPreSaleBusinessInformationCreateCampaignLeadsRequest {
    /**
     * 
     * @type {LeadCampaignInSchema}
     * @memberof OnboardingApiUsersViewsNinjaPreSaleBusinessInformationCreateCampaignLeads
     */
    readonly leadCampaignInSchema: LeadCampaignInSchema
}

/**
 * Request parameters for usersViewsNinjaPreSaleBusinessInformationGetRecommendationForm operation in OnboardingApi.
 * @export
 * @interface OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetRecommendationFormRequest
 */
export interface OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetRecommendationFormRequest {
    /**
     * 
     * @type {number}
     * @memberof OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetRecommendationForm
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetRecommendationForm
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetRecommendationForm
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for usersViewsNinjaPreSaleBusinessInformationGetRecommendationFormByEmail operation in OnboardingApi.
 * @export
 * @interface OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetRecommendationFormByEmailRequest
 */
export interface OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetRecommendationFormByEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetRecommendationFormByEmail
     */
    readonly email: string
}

/**
 * Request parameters for usersViewsNinjaPreSaleBusinessInformationGetSignupStage operation in OnboardingApi.
 * @export
 * @interface OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetSignupStageRequest
 */
export interface OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetSignupStageRequest {
    /**
     * 
     * @type {string}
     * @memberof OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetSignupStage
     */
    readonly globalId: string
}

/**
 * Request parameters for usersViewsNinjaPreSaleBusinessInformationSubmitRecommendationForm operation in OnboardingApi.
 * @export
 * @interface OnboardingApiUsersViewsNinjaPreSaleBusinessInformationSubmitRecommendationFormRequest
 */
export interface OnboardingApiUsersViewsNinjaPreSaleBusinessInformationSubmitRecommendationFormRequest {
    /**
     * 
     * @type {PreSaleBusinessInformationInSchema}
     * @memberof OnboardingApiUsersViewsNinjaPreSaleBusinessInformationSubmitRecommendationForm
     */
    readonly preSaleBusinessInformationInSchema: PreSaleBusinessInformationInSchema
}

/**
 * Request parameters for usersViewsNinjaPreSaleBusinessInformationUpdateRecommendationForm operation in OnboardingApi.
 * @export
 * @interface OnboardingApiUsersViewsNinjaPreSaleBusinessInformationUpdateRecommendationFormRequest
 */
export interface OnboardingApiUsersViewsNinjaPreSaleBusinessInformationUpdateRecommendationFormRequest {
    /**
     * 
     * @type {number}
     * @memberof OnboardingApiUsersViewsNinjaPreSaleBusinessInformationUpdateRecommendationForm
     */
    readonly presaleId: number

    /**
     * 
     * @type {PreSaleBusinessInformationUpdateSchema}
     * @memberof OnboardingApiUsersViewsNinjaPreSaleBusinessInformationUpdateRecommendationForm
     */
    readonly preSaleBusinessInformationUpdateSchema: PreSaleBusinessInformationUpdateSchema
}

/**
 * OnboardingApi - object-oriented interface
 * @export
 * @class OnboardingApi
 * @extends {BaseAPI}
 */
export class OnboardingApi extends BaseAPI {
    /**
     * 
     * @summary Retrieve Business Onboarding Form
     * @param {OnboardingApiUsersViewsNinjaOnboardingRetrieveBusinessOnboardingFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public usersViewsNinjaOnboardingRetrieveBusinessOnboardingForm(requestParameters: OnboardingApiUsersViewsNinjaOnboardingRetrieveBusinessOnboardingFormRequest, options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).usersViewsNinjaOnboardingRetrieveBusinessOnboardingForm(requestParameters.businessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Trigger Business Welcome Call
     * @param {OnboardingApiUsersViewsNinjaOnboardingTriggerBusinessWelcomeCallRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public usersViewsNinjaOnboardingTriggerBusinessWelcomeCall(requestParameters: OnboardingApiUsersViewsNinjaOnboardingTriggerBusinessWelcomeCallRequest, options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).usersViewsNinjaOnboardingTriggerBusinessWelcomeCall(requestParameters.businessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Business Onboarding Form
     * @param {OnboardingApiUsersViewsNinjaOnboardingUpdateBusinessOnboardingFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public usersViewsNinjaOnboardingUpdateBusinessOnboardingForm(requestParameters: OnboardingApiUsersViewsNinjaOnboardingUpdateBusinessOnboardingFormRequest, options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).usersViewsNinjaOnboardingUpdateBusinessOnboardingForm(requestParameters.businessId, requestParameters.onboardingInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Campaign Leads
     * @param {OnboardingApiUsersViewsNinjaPreSaleBusinessInformationCreateCampaignLeadsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public usersViewsNinjaPreSaleBusinessInformationCreateCampaignLeads(requestParameters: OnboardingApiUsersViewsNinjaPreSaleBusinessInformationCreateCampaignLeadsRequest, options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).usersViewsNinjaPreSaleBusinessInformationCreateCampaignLeads(requestParameters.leadCampaignInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Recommendation Form
     * @param {OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetRecommendationFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public usersViewsNinjaPreSaleBusinessInformationGetRecommendationForm(requestParameters: OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetRecommendationFormRequest = {}, options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).usersViewsNinjaPreSaleBusinessInformationGetRecommendationForm(requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Recommendation Form By Email
     * @param {OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetRecommendationFormByEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public usersViewsNinjaPreSaleBusinessInformationGetRecommendationFormByEmail(requestParameters: OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetRecommendationFormByEmailRequest, options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).usersViewsNinjaPreSaleBusinessInformationGetRecommendationFormByEmail(requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Signup Stage
     * @param {OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetSignupStageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public usersViewsNinjaPreSaleBusinessInformationGetSignupStage(requestParameters: OnboardingApiUsersViewsNinjaPreSaleBusinessInformationGetSignupStageRequest, options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).usersViewsNinjaPreSaleBusinessInformationGetSignupStage(requestParameters.globalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit Recommendation Form
     * @param {OnboardingApiUsersViewsNinjaPreSaleBusinessInformationSubmitRecommendationFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public usersViewsNinjaPreSaleBusinessInformationSubmitRecommendationForm(requestParameters: OnboardingApiUsersViewsNinjaPreSaleBusinessInformationSubmitRecommendationFormRequest, options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).usersViewsNinjaPreSaleBusinessInformationSubmitRecommendationForm(requestParameters.preSaleBusinessInformationInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Recommendation Form
     * @param {OnboardingApiUsersViewsNinjaPreSaleBusinessInformationUpdateRecommendationFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public usersViewsNinjaPreSaleBusinessInformationUpdateRecommendationForm(requestParameters: OnboardingApiUsersViewsNinjaPreSaleBusinessInformationUpdateRecommendationFormRequest, options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).usersViewsNinjaPreSaleBusinessInformationUpdateRecommendationForm(requestParameters.presaleId, requestParameters.preSaleBusinessInformationUpdateSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PaymentsApi - axios parameter creator
 * @export
 */
export const PaymentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Export History
         * @param {string} businessId 
         * @param {string | null} [dateCreatedBefore] 
         * @param {string | null} [dateCreatedAfter] 
         * @param {string | null} [status] 
         * @param {string | null} [amountPaid] 
         * @param {string | null} [ref] 
         * @param {string | null} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaHistoryExportHistory: async (businessId: string, dateCreatedBefore?: string | null, dateCreatedAfter?: string | null, status?: string | null, amountPaid?: string | null, ref?: string | null, source?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('paymentsViewsNinjaHistoryExportHistory', 'businessId', businessId)
            const localVarPath = `/api/payments/history/export/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (businessId !== undefined) {
                localVarQueryParameter['business_id'] = businessId;
            }

            if (dateCreatedBefore !== undefined) {
                localVarQueryParameter['date_created_before'] = dateCreatedBefore;
            }

            if (dateCreatedAfter !== undefined) {
                localVarQueryParameter['date_created_after'] = dateCreatedAfter;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (amountPaid !== undefined) {
                localVarQueryParameter['amount_paid'] = amountPaid;
            }

            if (ref !== undefined) {
                localVarQueryParameter['ref'] = ref;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary History
         * @param {string} businessId 
         * @param {string | null} [dateCreatedBefore] 
         * @param {string | null} [dateCreatedAfter] 
         * @param {string | null} [status] 
         * @param {string | null} [amountPaid] 
         * @param {string | null} [ref] 
         * @param {string | null} [source] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaHistoryHistory: async (businessId: string, dateCreatedBefore?: string | null, dateCreatedAfter?: string | null, status?: string | null, amountPaid?: string | null, ref?: string | null, source?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('paymentsViewsNinjaHistoryHistory', 'businessId', businessId)
            const localVarPath = `/api/payments/history/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (businessId !== undefined) {
                localVarQueryParameter['business_id'] = businessId;
            }

            if (dateCreatedBefore !== undefined) {
                localVarQueryParameter['date_created_before'] = dateCreatedBefore;
            }

            if (dateCreatedAfter !== undefined) {
                localVarQueryParameter['date_created_after'] = dateCreatedAfter;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (amountPaid !== undefined) {
                localVarQueryParameter['amount_paid'] = amountPaid;
            }

            if (ref !== undefined) {
                localVarQueryParameter['ref'] = ref;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Transaction Intent Status
         * @param {TransationIntentTxRefInSchema} transationIntentTxRefInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseTransactionIntentStatus: async (transationIntentTxRefInSchema: TransationIntentTxRefInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transationIntentTxRefInSchema' is not null or undefined
            assertParamExists('paymentsViewsNinjaPurchaseTransactionIntentStatus', 'transationIntentTxRefInSchema', transationIntentTxRefInSchema)
            const localVarPath = `/api/payments/intent/status/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transationIntentTxRefInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unprovisioned Payments
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseUnprovisionedPayments: async (pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/payments/unprovisioned-payment/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentsApi - functional programming interface
 * @export
 */
export const PaymentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Export History
         * @param {string} businessId 
         * @param {string | null} [dateCreatedBefore] 
         * @param {string | null} [dateCreatedAfter] 
         * @param {string | null} [status] 
         * @param {string | null} [amountPaid] 
         * @param {string | null} [ref] 
         * @param {string | null} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaHistoryExportHistory(businessId: string, dateCreatedBefore?: string | null, dateCreatedAfter?: string | null, status?: string | null, amountPaid?: string | null, ref?: string | null, source?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaHistoryExportHistory(businessId, dateCreatedBefore, dateCreatedAfter, status, amountPaid, ref, source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsViewsNinjaHistoryExportHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary History
         * @param {string} businessId 
         * @param {string | null} [dateCreatedBefore] 
         * @param {string | null} [dateCreatedAfter] 
         * @param {string | null} [status] 
         * @param {string | null} [amountPaid] 
         * @param {string | null} [ref] 
         * @param {string | null} [source] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaHistoryHistory(businessId: string, dateCreatedBefore?: string | null, dateCreatedAfter?: string | null, status?: string | null, amountPaid?: string | null, ref?: string | null, source?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedPaymentHistoryOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaHistoryHistory(businessId, dateCreatedBefore, dateCreatedAfter, status, amountPaid, ref, source, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsViewsNinjaHistoryHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Transaction Intent Status
         * @param {TransationIntentTxRefInSchema} transationIntentTxRefInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaPurchaseTransactionIntentStatus(transationIntentTxRefInSchema: TransationIntentTxRefInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaPurchaseTransactionIntentStatus(transationIntentTxRefInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsViewsNinjaPurchaseTransactionIntentStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Unprovisioned Payments
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaPurchaseUnprovisionedPayments(pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedPendingPaymentOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaPurchaseUnprovisionedPayments(pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsViewsNinjaPurchaseUnprovisionedPayments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentsApi - factory interface
 * @export
 */
export const PaymentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Export History
         * @param {PaymentsApiPaymentsViewsNinjaHistoryExportHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaHistoryExportHistory(requestParameters: PaymentsApiPaymentsViewsNinjaHistoryExportHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.paymentsViewsNinjaHistoryExportHistory(requestParameters.businessId, requestParameters.dateCreatedBefore, requestParameters.dateCreatedAfter, requestParameters.status, requestParameters.amountPaid, requestParameters.ref, requestParameters.source, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary History
         * @param {PaymentsApiPaymentsViewsNinjaHistoryHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaHistoryHistory(requestParameters: PaymentsApiPaymentsViewsNinjaHistoryHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedPaymentHistoryOutSchema> {
            return localVarFp.paymentsViewsNinjaHistoryHistory(requestParameters.businessId, requestParameters.dateCreatedBefore, requestParameters.dateCreatedAfter, requestParameters.status, requestParameters.amountPaid, requestParameters.ref, requestParameters.source, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Transaction Intent Status
         * @param {PaymentsApiPaymentsViewsNinjaPurchaseTransactionIntentStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseTransactionIntentStatus(requestParameters: PaymentsApiPaymentsViewsNinjaPurchaseTransactionIntentStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.paymentsViewsNinjaPurchaseTransactionIntentStatus(requestParameters.transationIntentTxRefInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unprovisioned Payments
         * @param {PaymentsApiPaymentsViewsNinjaPurchaseUnprovisionedPaymentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseUnprovisionedPayments(requestParameters: PaymentsApiPaymentsViewsNinjaPurchaseUnprovisionedPaymentsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PagedPendingPaymentOutSchema> {
            return localVarFp.paymentsViewsNinjaPurchaseUnprovisionedPayments(requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for paymentsViewsNinjaHistoryExportHistory operation in PaymentsApi.
 * @export
 * @interface PaymentsApiPaymentsViewsNinjaHistoryExportHistoryRequest
 */
export interface PaymentsApiPaymentsViewsNinjaHistoryExportHistoryRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentsApiPaymentsViewsNinjaHistoryExportHistory
     */
    readonly businessId: string

    /**
     * 
     * @type {string}
     * @memberof PaymentsApiPaymentsViewsNinjaHistoryExportHistory
     */
    readonly dateCreatedBefore?: string | null

    /**
     * 
     * @type {string}
     * @memberof PaymentsApiPaymentsViewsNinjaHistoryExportHistory
     */
    readonly dateCreatedAfter?: string | null

    /**
     * 
     * @type {string}
     * @memberof PaymentsApiPaymentsViewsNinjaHistoryExportHistory
     */
    readonly status?: string | null

    /**
     * 
     * @type {string}
     * @memberof PaymentsApiPaymentsViewsNinjaHistoryExportHistory
     */
    readonly amountPaid?: string | null

    /**
     * 
     * @type {string}
     * @memberof PaymentsApiPaymentsViewsNinjaHistoryExportHistory
     */
    readonly ref?: string | null

    /**
     * 
     * @type {string}
     * @memberof PaymentsApiPaymentsViewsNinjaHistoryExportHistory
     */
    readonly source?: string | null
}

/**
 * Request parameters for paymentsViewsNinjaHistoryHistory operation in PaymentsApi.
 * @export
 * @interface PaymentsApiPaymentsViewsNinjaHistoryHistoryRequest
 */
export interface PaymentsApiPaymentsViewsNinjaHistoryHistoryRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentsApiPaymentsViewsNinjaHistoryHistory
     */
    readonly businessId: string

    /**
     * 
     * @type {string}
     * @memberof PaymentsApiPaymentsViewsNinjaHistoryHistory
     */
    readonly dateCreatedBefore?: string | null

    /**
     * 
     * @type {string}
     * @memberof PaymentsApiPaymentsViewsNinjaHistoryHistory
     */
    readonly dateCreatedAfter?: string | null

    /**
     * 
     * @type {string}
     * @memberof PaymentsApiPaymentsViewsNinjaHistoryHistory
     */
    readonly status?: string | null

    /**
     * 
     * @type {string}
     * @memberof PaymentsApiPaymentsViewsNinjaHistoryHistory
     */
    readonly amountPaid?: string | null

    /**
     * 
     * @type {string}
     * @memberof PaymentsApiPaymentsViewsNinjaHistoryHistory
     */
    readonly ref?: string | null

    /**
     * 
     * @type {string}
     * @memberof PaymentsApiPaymentsViewsNinjaHistoryHistory
     */
    readonly source?: string | null

    /**
     * 
     * @type {number}
     * @memberof PaymentsApiPaymentsViewsNinjaHistoryHistory
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof PaymentsApiPaymentsViewsNinjaHistoryHistory
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof PaymentsApiPaymentsViewsNinjaHistoryHistory
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for paymentsViewsNinjaPurchaseTransactionIntentStatus operation in PaymentsApi.
 * @export
 * @interface PaymentsApiPaymentsViewsNinjaPurchaseTransactionIntentStatusRequest
 */
export interface PaymentsApiPaymentsViewsNinjaPurchaseTransactionIntentStatusRequest {
    /**
     * 
     * @type {TransationIntentTxRefInSchema}
     * @memberof PaymentsApiPaymentsViewsNinjaPurchaseTransactionIntentStatus
     */
    readonly transationIntentTxRefInSchema: TransationIntentTxRefInSchema
}

/**
 * Request parameters for paymentsViewsNinjaPurchaseUnprovisionedPayments operation in PaymentsApi.
 * @export
 * @interface PaymentsApiPaymentsViewsNinjaPurchaseUnprovisionedPaymentsRequest
 */
export interface PaymentsApiPaymentsViewsNinjaPurchaseUnprovisionedPaymentsRequest {
    /**
     * 
     * @type {number}
     * @memberof PaymentsApiPaymentsViewsNinjaPurchaseUnprovisionedPayments
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof PaymentsApiPaymentsViewsNinjaPurchaseUnprovisionedPayments
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof PaymentsApiPaymentsViewsNinjaPurchaseUnprovisionedPayments
     */
    readonly ordering?: string | null
}

/**
 * PaymentsApi - object-oriented interface
 * @export
 * @class PaymentsApi
 * @extends {BaseAPI}
 */
export class PaymentsApi extends BaseAPI {
    /**
     * 
     * @summary Export History
     * @param {PaymentsApiPaymentsViewsNinjaHistoryExportHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsViewsNinjaHistoryExportHistory(requestParameters: PaymentsApiPaymentsViewsNinjaHistoryExportHistoryRequest, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsViewsNinjaHistoryExportHistory(requestParameters.businessId, requestParameters.dateCreatedBefore, requestParameters.dateCreatedAfter, requestParameters.status, requestParameters.amountPaid, requestParameters.ref, requestParameters.source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary History
     * @param {PaymentsApiPaymentsViewsNinjaHistoryHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsViewsNinjaHistoryHistory(requestParameters: PaymentsApiPaymentsViewsNinjaHistoryHistoryRequest, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsViewsNinjaHistoryHistory(requestParameters.businessId, requestParameters.dateCreatedBefore, requestParameters.dateCreatedAfter, requestParameters.status, requestParameters.amountPaid, requestParameters.ref, requestParameters.source, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Transaction Intent Status
     * @param {PaymentsApiPaymentsViewsNinjaPurchaseTransactionIntentStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsViewsNinjaPurchaseTransactionIntentStatus(requestParameters: PaymentsApiPaymentsViewsNinjaPurchaseTransactionIntentStatusRequest, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsViewsNinjaPurchaseTransactionIntentStatus(requestParameters.transationIntentTxRefInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unprovisioned Payments
     * @param {PaymentsApiPaymentsViewsNinjaPurchaseUnprovisionedPaymentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsViewsNinjaPurchaseUnprovisionedPayments(requestParameters: PaymentsApiPaymentsViewsNinjaPurchaseUnprovisionedPaymentsRequest = {}, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsViewsNinjaPurchaseUnprovisionedPayments(requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PurchaseApi - axios parameter creator
 * @export
 */
export const PurchaseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Addon Purchase Web
         * @param {AddonPurchaseInSchema} addonPurchaseInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseAddonPurchaseWeb: async (addonPurchaseInSchema: AddonPurchaseInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addonPurchaseInSchema' is not null or undefined
            assertParamExists('paymentsViewsNinjaPurchaseAddonPurchaseWeb', 'addonPurchaseInSchema', addonPurchaseInSchema)
            const localVarPath = `/api/payments/addon-purchase/web/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addonPurchaseInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Addon Purchase Web V2
         * @param {AddonPurchaseInSchemaV2} addonPurchaseInSchemaV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseAddonPurchaseWebV2: async (addonPurchaseInSchemaV2: AddonPurchaseInSchemaV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addonPurchaseInSchemaV2' is not null or undefined
            assertParamExists('paymentsViewsNinjaPurchaseAddonPurchaseWebV2', 'addonPurchaseInSchemaV2', addonPurchaseInSchemaV2)
            const localVarPath = `/api/payments/addon-purchase/web/v2/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addonPurchaseInSchemaV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Airtime Topup
         * @param {AdminAirtimeTopUpInSchema} adminAirtimeTopUpInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseAdminAirtimeTopup: async (adminAirtimeTopUpInSchema: AdminAirtimeTopUpInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminAirtimeTopUpInSchema' is not null or undefined
            assertParamExists('paymentsViewsNinjaPurchaseAdminAirtimeTopup', 'adminAirtimeTopUpInSchema', adminAirtimeTopUpInSchema)
            const localVarPath = `/api/payments/admin/top_up/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminAirtimeTopUpInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Auth Addon Purchase
         * @param {AdditionalAddonPurchaseInSchema} additionalAddonPurchaseInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseAuthAddonPurchase: async (additionalAddonPurchaseInSchema: AdditionalAddonPurchaseInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'additionalAddonPurchaseInSchema' is not null or undefined
            assertParamExists('paymentsViewsNinjaPurchaseAuthAddonPurchase', 'additionalAddonPurchaseInSchema', additionalAddonPurchaseInSchema)
            const localVarPath = `/api/payments/addon-purchase/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(additionalAddonPurchaseInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Auth Number Purchase
         * @param {AdditionalNumberPurchaseInSchema} additionalNumberPurchaseInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseAuthNumberPurchase: async (additionalNumberPurchaseInSchema: AdditionalNumberPurchaseInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'additionalNumberPurchaseInSchema' is not null or undefined
            assertParamExists('paymentsViewsNinjaPurchaseAuthNumberPurchase', 'additionalNumberPurchaseInSchema', additionalNumberPurchaseInSchema)
            const localVarPath = `/api/payments/number-purchase/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(additionalNumberPurchaseInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Campaign Number Purchase
         * @param {CampaignNumberPurchaseInSchema} campaignNumberPurchaseInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseCampaignNumberPurchase: async (campaignNumberPurchaseInSchema: CampaignNumberPurchaseInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignNumberPurchaseInSchema' is not null or undefined
            assertParamExists('paymentsViewsNinjaPurchaseCampaignNumberPurchase', 'campaignNumberPurchaseInSchema', campaignNumberPurchaseInSchema)
            const localVarPath = `/api/payments/number-purchase/campaign/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignNumberPurchaseInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate Business Number Extension Payment Link
         * @param {string} businessNumber 
         * @param {number} [quantity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseGenerateBusinessNumberExtensionPaymentLink: async (businessNumber: string, quantity?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessNumber' is not null or undefined
            assertParamExists('paymentsViewsNinjaPurchaseGenerateBusinessNumberExtensionPaymentLink', 'businessNumber', businessNumber)
            const localVarPath = `/api/payments/get-payment-link/business-number-extension/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (businessNumber !== undefined) {
                localVarQueryParameter['business_number'] = businessNumber;
            }

            if (quantity !== undefined) {
                localVarQueryParameter['quantity'] = quantity;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate Invoice Payment Link
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseGenerateInvoicePaymentLink: async (invoiceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('paymentsViewsNinjaPurchaseGenerateInvoicePaymentLink', 'invoiceId', invoiceId)
            const localVarPath = `/api/payments/number-purchase/invoice/pay/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (invoiceId !== undefined) {
                localVarQueryParameter['invoice_id'] = invoiceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate Payment Link
         * @param {string} identifier 
         * @param {Array<number>} planId 
         * @param {Array<number> | null} [quantity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseGeneratePaymentLink: async (identifier: string, planId: Array<number>, quantity?: Array<number> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identifier' is not null or undefined
            assertParamExists('paymentsViewsNinjaPurchaseGeneratePaymentLink', 'identifier', identifier)
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('paymentsViewsNinjaPurchaseGeneratePaymentLink', 'planId', planId)
            const localVarPath = `/api/payments/get-payment-link/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identifier !== undefined) {
                localVarQueryParameter['identifier'] = identifier;
            }

            if (planId) {
                localVarQueryParameter['plan_id'] = planId;
            }

            if (quantity) {
                localVarQueryParameter['quantity'] = quantity;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of all Addons.
         * @summary Get Addon Plans
         * @param {PaymentsViewsNinjaPurchaseGetAddonPlansTermEnum} term 
         * @param {string | null} [search] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseGetAddonPlans: async (term: PaymentsViewsNinjaPurchaseGetAddonPlansTermEnum, search?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'term' is not null or undefined
            assertParamExists('paymentsViewsNinjaPurchaseGetAddonPlans', 'term', term)
            const localVarPath = `/api/payments/addon-plan/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Subscription Plan
         * @param {string | null} [search] 
         * @param {string | null} [numberRegion] 
         * @param {PaymentsViewsNinjaPurchaseGetSubscriptionPlanCurrencyEnum} [currency] 
         * @param {SubscriptionTerm | null} [term] 
         * @param {SubscriptionPlanType | null} [planType] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseGetSubscriptionPlan: async (search?: string | null, numberRegion?: string | null, currency?: PaymentsViewsNinjaPurchaseGetSubscriptionPlanCurrencyEnum, term?: SubscriptionTerm | null, planType?: SubscriptionPlanType | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/payments/subscription-plan/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (numberRegion !== undefined) {
                localVarQueryParameter['number_region'] = numberRegion;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (planType !== undefined) {
                localVarQueryParameter['plan_type'] = planType;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary New Web Payment Page Purchase
         * @param {NumberPurchaseInSchema} numberPurchaseInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseNewWebPaymentPagePurchase: async (numberPurchaseInSchema: NumberPurchaseInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'numberPurchaseInSchema' is not null or undefined
            assertParamExists('paymentsViewsNinjaPurchaseNewWebPaymentPagePurchase', 'numberPurchaseInSchema', numberPurchaseInSchema)
            const localVarPath = `/api/payments/number-purchase/web/v2/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(numberPurchaseInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Number And Addon Purchase Web
         * @param {NumberAndAddonsPurchaseInSchema} numberAndAddonsPurchaseInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseNumberAndAddonPurchaseWeb: async (numberAndAddonsPurchaseInSchema: NumberAndAddonsPurchaseInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'numberAndAddonsPurchaseInSchema' is not null or undefined
            assertParamExists('paymentsViewsNinjaPurchaseNumberAndAddonPurchaseWeb', 'numberAndAddonsPurchaseInSchema', numberAndAddonsPurchaseInSchema)
            const localVarPath = `/api/payments/number-addon-purchase/web/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(numberAndAddonsPurchaseInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send Number Purchase Invoice
         * @param {CreatePaymentInvoiceInSchema} createPaymentInvoiceInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseSendNumberPurchaseInvoice: async (createPaymentInvoiceInSchema: CreatePaymentInvoiceInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPaymentInvoiceInSchema' is not null or undefined
            assertParamExists('paymentsViewsNinjaPurchaseSendNumberPurchaseInvoice', 'createPaymentInvoiceInSchema', createPaymentInvoiceInSchema)
            const localVarPath = `/api/payments/number-purchase/invoice/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPaymentInvoiceInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Web Payment Page Purchase
         * @param {PaymentPageInSchema} paymentPageInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseWebPaymentPagePurchase: async (paymentPageInSchema: PaymentPageInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentPageInSchema' is not null or undefined
            assertParamExists('paymentsViewsNinjaPurchaseWebPaymentPagePurchase', 'paymentPageInSchema', paymentPageInSchema)
            const localVarPath = `/api/payments/number-purchase/web/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentPageInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PurchaseApi - functional programming interface
 * @export
 */
export const PurchaseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PurchaseApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Addon Purchase Web
         * @param {AddonPurchaseInSchema} addonPurchaseInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaPurchaseAddonPurchaseWeb(addonPurchaseInSchema: AddonPurchaseInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentPageOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaPurchaseAddonPurchaseWeb(addonPurchaseInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseApi.paymentsViewsNinjaPurchaseAddonPurchaseWeb']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Addon Purchase Web V2
         * @param {AddonPurchaseInSchemaV2} addonPurchaseInSchemaV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaPurchaseAddonPurchaseWebV2(addonPurchaseInSchemaV2: AddonPurchaseInSchemaV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentPageOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaPurchaseAddonPurchaseWebV2(addonPurchaseInSchemaV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseApi.paymentsViewsNinjaPurchaseAddonPurchaseWebV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Airtime Topup
         * @param {AdminAirtimeTopUpInSchema} adminAirtimeTopUpInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaPurchaseAdminAirtimeTopup(adminAirtimeTopUpInSchema: AdminAirtimeTopUpInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaPurchaseAdminAirtimeTopup(adminAirtimeTopUpInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseApi.paymentsViewsNinjaPurchaseAdminAirtimeTopup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Auth Addon Purchase
         * @param {AdditionalAddonPurchaseInSchema} additionalAddonPurchaseInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaPurchaseAuthAddonPurchase(additionalAddonPurchaseInSchema: AdditionalAddonPurchaseInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentPageOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaPurchaseAuthAddonPurchase(additionalAddonPurchaseInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseApi.paymentsViewsNinjaPurchaseAuthAddonPurchase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Auth Number Purchase
         * @param {AdditionalNumberPurchaseInSchema} additionalNumberPurchaseInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaPurchaseAuthNumberPurchase(additionalNumberPurchaseInSchema: AdditionalNumberPurchaseInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentPageOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaPurchaseAuthNumberPurchase(additionalNumberPurchaseInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseApi.paymentsViewsNinjaPurchaseAuthNumberPurchase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Campaign Number Purchase
         * @param {CampaignNumberPurchaseInSchema} campaignNumberPurchaseInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaPurchaseCampaignNumberPurchase(campaignNumberPurchaseInSchema: CampaignNumberPurchaseInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaPurchaseCampaignNumberPurchase(campaignNumberPurchaseInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseApi.paymentsViewsNinjaPurchaseCampaignNumberPurchase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generate Business Number Extension Payment Link
         * @param {string} businessNumber 
         * @param {number} [quantity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaPurchaseGenerateBusinessNumberExtensionPaymentLink(businessNumber: string, quantity?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedirectURLResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaPurchaseGenerateBusinessNumberExtensionPaymentLink(businessNumber, quantity, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseApi.paymentsViewsNinjaPurchaseGenerateBusinessNumberExtensionPaymentLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generate Invoice Payment Link
         * @param {string} invoiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaPurchaseGenerateInvoicePaymentLink(invoiceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaPurchaseGenerateInvoicePaymentLink(invoiceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseApi.paymentsViewsNinjaPurchaseGenerateInvoicePaymentLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generate Payment Link
         * @param {string} identifier 
         * @param {Array<number>} planId 
         * @param {Array<number> | null} [quantity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaPurchaseGeneratePaymentLink(identifier: string, planId: Array<number>, quantity?: Array<number> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaPurchaseGeneratePaymentLink(identifier, planId, quantity, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseApi.paymentsViewsNinjaPurchaseGeneratePaymentLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a list of all Addons.
         * @summary Get Addon Plans
         * @param {PaymentsViewsNinjaPurchaseGetAddonPlansTermEnum} term 
         * @param {string | null} [search] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaPurchaseGetAddonPlans(term: PaymentsViewsNinjaPurchaseGetAddonPlansTermEnum, search?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedSubscriptionPlanOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaPurchaseGetAddonPlans(term, search, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseApi.paymentsViewsNinjaPurchaseGetAddonPlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Subscription Plan
         * @param {string | null} [search] 
         * @param {string | null} [numberRegion] 
         * @param {PaymentsViewsNinjaPurchaseGetSubscriptionPlanCurrencyEnum} [currency] 
         * @param {SubscriptionTerm | null} [term] 
         * @param {SubscriptionPlanType | null} [planType] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaPurchaseGetSubscriptionPlan(search?: string | null, numberRegion?: string | null, currency?: PaymentsViewsNinjaPurchaseGetSubscriptionPlanCurrencyEnum, term?: SubscriptionTerm | null, planType?: SubscriptionPlanType | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedSubscriptionPlanOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaPurchaseGetSubscriptionPlan(search, numberRegion, currency, term, planType, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseApi.paymentsViewsNinjaPurchaseGetSubscriptionPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary New Web Payment Page Purchase
         * @param {NumberPurchaseInSchema} numberPurchaseInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaPurchaseNewWebPaymentPagePurchase(numberPurchaseInSchema: NumberPurchaseInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentPageOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaPurchaseNewWebPaymentPagePurchase(numberPurchaseInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseApi.paymentsViewsNinjaPurchaseNewWebPaymentPagePurchase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Number And Addon Purchase Web
         * @param {NumberAndAddonsPurchaseInSchema} numberAndAddonsPurchaseInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaPurchaseNumberAndAddonPurchaseWeb(numberAndAddonsPurchaseInSchema: NumberAndAddonsPurchaseInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentPageOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaPurchaseNumberAndAddonPurchaseWeb(numberAndAddonsPurchaseInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseApi.paymentsViewsNinjaPurchaseNumberAndAddonPurchaseWeb']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send Number Purchase Invoice
         * @param {CreatePaymentInvoiceInSchema} createPaymentInvoiceInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaPurchaseSendNumberPurchaseInvoice(createPaymentInvoiceInSchema: CreatePaymentInvoiceInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaPurchaseSendNumberPurchaseInvoice(createPaymentInvoiceInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseApi.paymentsViewsNinjaPurchaseSendNumberPurchaseInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Web Payment Page Purchase
         * @param {PaymentPageInSchema} paymentPageInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaPurchaseWebPaymentPagePurchase(paymentPageInSchema: PaymentPageInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentPageOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaPurchaseWebPaymentPagePurchase(paymentPageInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseApi.paymentsViewsNinjaPurchaseWebPaymentPagePurchase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PurchaseApi - factory interface
 * @export
 */
export const PurchaseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PurchaseApiFp(configuration)
    return {
        /**
         * 
         * @summary Addon Purchase Web
         * @param {PurchaseApiPaymentsViewsNinjaPurchaseAddonPurchaseWebRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseAddonPurchaseWeb(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseAddonPurchaseWebRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentPageOutSchema> {
            return localVarFp.paymentsViewsNinjaPurchaseAddonPurchaseWeb(requestParameters.addonPurchaseInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Addon Purchase Web V2
         * @param {PurchaseApiPaymentsViewsNinjaPurchaseAddonPurchaseWebV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseAddonPurchaseWebV2(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseAddonPurchaseWebV2Request, options?: RawAxiosRequestConfig): AxiosPromise<PaymentPageOutSchema> {
            return localVarFp.paymentsViewsNinjaPurchaseAddonPurchaseWebV2(requestParameters.addonPurchaseInSchemaV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Airtime Topup
         * @param {PurchaseApiPaymentsViewsNinjaPurchaseAdminAirtimeTopupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseAdminAirtimeTopup(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseAdminAirtimeTopupRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.paymentsViewsNinjaPurchaseAdminAirtimeTopup(requestParameters.adminAirtimeTopUpInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Auth Addon Purchase
         * @param {PurchaseApiPaymentsViewsNinjaPurchaseAuthAddonPurchaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseAuthAddonPurchase(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseAuthAddonPurchaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentPageOutSchema> {
            return localVarFp.paymentsViewsNinjaPurchaseAuthAddonPurchase(requestParameters.additionalAddonPurchaseInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Auth Number Purchase
         * @param {PurchaseApiPaymentsViewsNinjaPurchaseAuthNumberPurchaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseAuthNumberPurchase(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseAuthNumberPurchaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentPageOutSchema> {
            return localVarFp.paymentsViewsNinjaPurchaseAuthNumberPurchase(requestParameters.additionalNumberPurchaseInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Campaign Number Purchase
         * @param {PurchaseApiPaymentsViewsNinjaPurchaseCampaignNumberPurchaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseCampaignNumberPurchase(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseCampaignNumberPurchaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.paymentsViewsNinjaPurchaseCampaignNumberPurchase(requestParameters.campaignNumberPurchaseInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate Business Number Extension Payment Link
         * @param {PurchaseApiPaymentsViewsNinjaPurchaseGenerateBusinessNumberExtensionPaymentLinkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseGenerateBusinessNumberExtensionPaymentLink(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseGenerateBusinessNumberExtensionPaymentLinkRequest, options?: RawAxiosRequestConfig): AxiosPromise<RedirectURLResponse> {
            return localVarFp.paymentsViewsNinjaPurchaseGenerateBusinessNumberExtensionPaymentLink(requestParameters.businessNumber, requestParameters.quantity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate Invoice Payment Link
         * @param {PurchaseApiPaymentsViewsNinjaPurchaseGenerateInvoicePaymentLinkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseGenerateInvoicePaymentLink(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseGenerateInvoicePaymentLinkRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.paymentsViewsNinjaPurchaseGenerateInvoicePaymentLink(requestParameters.invoiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate Payment Link
         * @param {PurchaseApiPaymentsViewsNinjaPurchaseGeneratePaymentLinkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseGeneratePaymentLink(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseGeneratePaymentLinkRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.paymentsViewsNinjaPurchaseGeneratePaymentLink(requestParameters.identifier, requestParameters.planId, requestParameters.quantity, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of all Addons.
         * @summary Get Addon Plans
         * @param {PurchaseApiPaymentsViewsNinjaPurchaseGetAddonPlansRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseGetAddonPlans(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseGetAddonPlansRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedSubscriptionPlanOutSchema> {
            return localVarFp.paymentsViewsNinjaPurchaseGetAddonPlans(requestParameters.term, requestParameters.search, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Subscription Plan
         * @param {PurchaseApiPaymentsViewsNinjaPurchaseGetSubscriptionPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseGetSubscriptionPlan(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseGetSubscriptionPlanRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PagedSubscriptionPlanOutSchema> {
            return localVarFp.paymentsViewsNinjaPurchaseGetSubscriptionPlan(requestParameters.search, requestParameters.numberRegion, requestParameters.currency, requestParameters.term, requestParameters.planType, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary New Web Payment Page Purchase
         * @param {PurchaseApiPaymentsViewsNinjaPurchaseNewWebPaymentPagePurchaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseNewWebPaymentPagePurchase(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseNewWebPaymentPagePurchaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentPageOutSchema> {
            return localVarFp.paymentsViewsNinjaPurchaseNewWebPaymentPagePurchase(requestParameters.numberPurchaseInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Number And Addon Purchase Web
         * @param {PurchaseApiPaymentsViewsNinjaPurchaseNumberAndAddonPurchaseWebRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseNumberAndAddonPurchaseWeb(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseNumberAndAddonPurchaseWebRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentPageOutSchema> {
            return localVarFp.paymentsViewsNinjaPurchaseNumberAndAddonPurchaseWeb(requestParameters.numberAndAddonsPurchaseInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send Number Purchase Invoice
         * @param {PurchaseApiPaymentsViewsNinjaPurchaseSendNumberPurchaseInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseSendNumberPurchaseInvoice(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseSendNumberPurchaseInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.paymentsViewsNinjaPurchaseSendNumberPurchaseInvoice(requestParameters.createPaymentInvoiceInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Web Payment Page Purchase
         * @param {PurchaseApiPaymentsViewsNinjaPurchaseWebPaymentPagePurchaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaPurchaseWebPaymentPagePurchase(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseWebPaymentPagePurchaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaymentPageOutSchema> {
            return localVarFp.paymentsViewsNinjaPurchaseWebPaymentPagePurchase(requestParameters.paymentPageInSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for paymentsViewsNinjaPurchaseAddonPurchaseWeb operation in PurchaseApi.
 * @export
 * @interface PurchaseApiPaymentsViewsNinjaPurchaseAddonPurchaseWebRequest
 */
export interface PurchaseApiPaymentsViewsNinjaPurchaseAddonPurchaseWebRequest {
    /**
     * 
     * @type {AddonPurchaseInSchema}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseAddonPurchaseWeb
     */
    readonly addonPurchaseInSchema: AddonPurchaseInSchema
}

/**
 * Request parameters for paymentsViewsNinjaPurchaseAddonPurchaseWebV2 operation in PurchaseApi.
 * @export
 * @interface PurchaseApiPaymentsViewsNinjaPurchaseAddonPurchaseWebV2Request
 */
export interface PurchaseApiPaymentsViewsNinjaPurchaseAddonPurchaseWebV2Request {
    /**
     * 
     * @type {AddonPurchaseInSchemaV2}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseAddonPurchaseWebV2
     */
    readonly addonPurchaseInSchemaV2: AddonPurchaseInSchemaV2
}

/**
 * Request parameters for paymentsViewsNinjaPurchaseAdminAirtimeTopup operation in PurchaseApi.
 * @export
 * @interface PurchaseApiPaymentsViewsNinjaPurchaseAdminAirtimeTopupRequest
 */
export interface PurchaseApiPaymentsViewsNinjaPurchaseAdminAirtimeTopupRequest {
    /**
     * 
     * @type {AdminAirtimeTopUpInSchema}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseAdminAirtimeTopup
     */
    readonly adminAirtimeTopUpInSchema: AdminAirtimeTopUpInSchema
}

/**
 * Request parameters for paymentsViewsNinjaPurchaseAuthAddonPurchase operation in PurchaseApi.
 * @export
 * @interface PurchaseApiPaymentsViewsNinjaPurchaseAuthAddonPurchaseRequest
 */
export interface PurchaseApiPaymentsViewsNinjaPurchaseAuthAddonPurchaseRequest {
    /**
     * 
     * @type {AdditionalAddonPurchaseInSchema}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseAuthAddonPurchase
     */
    readonly additionalAddonPurchaseInSchema: AdditionalAddonPurchaseInSchema
}

/**
 * Request parameters for paymentsViewsNinjaPurchaseAuthNumberPurchase operation in PurchaseApi.
 * @export
 * @interface PurchaseApiPaymentsViewsNinjaPurchaseAuthNumberPurchaseRequest
 */
export interface PurchaseApiPaymentsViewsNinjaPurchaseAuthNumberPurchaseRequest {
    /**
     * 
     * @type {AdditionalNumberPurchaseInSchema}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseAuthNumberPurchase
     */
    readonly additionalNumberPurchaseInSchema: AdditionalNumberPurchaseInSchema
}

/**
 * Request parameters for paymentsViewsNinjaPurchaseCampaignNumberPurchase operation in PurchaseApi.
 * @export
 * @interface PurchaseApiPaymentsViewsNinjaPurchaseCampaignNumberPurchaseRequest
 */
export interface PurchaseApiPaymentsViewsNinjaPurchaseCampaignNumberPurchaseRequest {
    /**
     * 
     * @type {CampaignNumberPurchaseInSchema}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseCampaignNumberPurchase
     */
    readonly campaignNumberPurchaseInSchema: CampaignNumberPurchaseInSchema
}

/**
 * Request parameters for paymentsViewsNinjaPurchaseGenerateBusinessNumberExtensionPaymentLink operation in PurchaseApi.
 * @export
 * @interface PurchaseApiPaymentsViewsNinjaPurchaseGenerateBusinessNumberExtensionPaymentLinkRequest
 */
export interface PurchaseApiPaymentsViewsNinjaPurchaseGenerateBusinessNumberExtensionPaymentLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseGenerateBusinessNumberExtensionPaymentLink
     */
    readonly businessNumber: string

    /**
     * 
     * @type {number}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseGenerateBusinessNumberExtensionPaymentLink
     */
    readonly quantity?: number
}

/**
 * Request parameters for paymentsViewsNinjaPurchaseGenerateInvoicePaymentLink operation in PurchaseApi.
 * @export
 * @interface PurchaseApiPaymentsViewsNinjaPurchaseGenerateInvoicePaymentLinkRequest
 */
export interface PurchaseApiPaymentsViewsNinjaPurchaseGenerateInvoicePaymentLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseGenerateInvoicePaymentLink
     */
    readonly invoiceId: string
}

/**
 * Request parameters for paymentsViewsNinjaPurchaseGeneratePaymentLink operation in PurchaseApi.
 * @export
 * @interface PurchaseApiPaymentsViewsNinjaPurchaseGeneratePaymentLinkRequest
 */
export interface PurchaseApiPaymentsViewsNinjaPurchaseGeneratePaymentLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseGeneratePaymentLink
     */
    readonly identifier: string

    /**
     * 
     * @type {Array<number>}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseGeneratePaymentLink
     */
    readonly planId: Array<number>

    /**
     * 
     * @type {Array<number>}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseGeneratePaymentLink
     */
    readonly quantity?: Array<number> | null
}

/**
 * Request parameters for paymentsViewsNinjaPurchaseGetAddonPlans operation in PurchaseApi.
 * @export
 * @interface PurchaseApiPaymentsViewsNinjaPurchaseGetAddonPlansRequest
 */
export interface PurchaseApiPaymentsViewsNinjaPurchaseGetAddonPlansRequest {
    /**
     * 
     * @type {'monthly' | 'quarterly' | 'yearly'}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseGetAddonPlans
     */
    readonly term: PaymentsViewsNinjaPurchaseGetAddonPlansTermEnum

    /**
     * 
     * @type {string}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseGetAddonPlans
     */
    readonly search?: string | null

    /**
     * 
     * @type {number}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseGetAddonPlans
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseGetAddonPlans
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseGetAddonPlans
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for paymentsViewsNinjaPurchaseGetSubscriptionPlan operation in PurchaseApi.
 * @export
 * @interface PurchaseApiPaymentsViewsNinjaPurchaseGetSubscriptionPlanRequest
 */
export interface PurchaseApiPaymentsViewsNinjaPurchaseGetSubscriptionPlanRequest {
    /**
     * 
     * @type {string}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseGetSubscriptionPlan
     */
    readonly search?: string | null

    /**
     * 
     * @type {string}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseGetSubscriptionPlan
     */
    readonly numberRegion?: string | null

    /**
     * 
     * @type {'AED' | 'AFN' | 'ALL' | 'AMD' | 'ANG' | 'AOA' | 'ARS' | 'AUD' | 'AWG' | 'AZN' | 'BAM' | 'BBD' | 'BDT' | 'BGN' | 'BHD' | 'BIF' | 'BMD' | 'BND' | 'BOB' | 'BOV' | 'BRL' | 'BSD' | 'BTN' | 'BWP' | 'BYN' | 'BZD' | 'CAD' | 'CDF' | 'CHE' | 'CHF' | 'CHW' | 'CLF' | 'CLP' | 'CNY' | 'COP' | 'COU' | 'CRC' | 'CUC' | 'CUP' | 'CVE' | 'CZK' | 'DJF' | 'DKK' | 'DOP' | 'DZD' | 'EGP' | 'ERN' | 'ETB' | 'EUR' | 'FJD' | 'FKP' | 'GBP' | 'GEL' | 'GHS' | 'GIP' | 'GMD' | 'GNF' | 'GTQ' | 'GYD' | 'HKD' | 'HNL' | 'HRK' | 'HTG' | 'HUF' | 'IDR' | 'ILS' | 'INR' | 'IQD' | 'IRR' | 'ISK' | 'JMD' | 'JOD' | 'JPY' | 'KES' | 'KGS' | 'KHR' | 'KMF' | 'KPW' | 'KRW' | 'KWD' | 'KYD' | 'KZT' | 'LAK' | 'LBP' | 'LKR' | 'LRD' | 'LSL' | 'LYD' | 'MAD' | 'MDL' | 'MGA' | 'MKD' | 'MMK' | 'MNT' | 'MOP' | 'MRU' | 'MUR' | 'MVR' | 'MWK' | 'MXN' | 'MXV' | 'MYR' | 'MZN' | 'NAD' | 'NGN' | 'NIO' | 'NOK' | 'NPR' | 'NZD' | 'OMR' | 'PAB' | 'PEN' | 'PGK' | 'PHP' | 'PKR' | 'PLN' | 'PYG' | 'QAR' | 'RON' | 'RSD' | 'RUB' | 'RWF' | 'SAR' | 'SBD' | 'SCR' | 'SDG' | 'SEK' | 'SGD' | 'SHP' | 'SLE' | 'SLL' | 'SOS' | 'SRD' | 'SSP' | 'STN' | 'SVC' | 'SYP' | 'SZL' | 'THB' | 'TJS' | 'TMT' | 'TND' | 'TOP' | 'TRY' | 'TTD' | 'TWD' | 'TZS' | 'UAH' | 'UGX' | 'USD' | 'USN' | 'UYI' | 'UYU' | 'UYW' | 'UZS' | 'VED' | 'VES' | 'VND' | 'VUV' | 'WST' | 'XAF' | 'XCD' | 'XOF' | 'XPF' | 'XSU' | 'XUA' | 'YER' | 'ZAR' | 'ZMW' | 'ZWL'}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseGetSubscriptionPlan
     */
    readonly currency?: PaymentsViewsNinjaPurchaseGetSubscriptionPlanCurrencyEnum

    /**
     * 
     * @type {SubscriptionTerm}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseGetSubscriptionPlan
     */
    readonly term?: SubscriptionTerm | null

    /**
     * 
     * @type {SubscriptionPlanType}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseGetSubscriptionPlan
     */
    readonly planType?: SubscriptionPlanType | null

    /**
     * 
     * @type {number}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseGetSubscriptionPlan
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseGetSubscriptionPlan
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseGetSubscriptionPlan
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for paymentsViewsNinjaPurchaseNewWebPaymentPagePurchase operation in PurchaseApi.
 * @export
 * @interface PurchaseApiPaymentsViewsNinjaPurchaseNewWebPaymentPagePurchaseRequest
 */
export interface PurchaseApiPaymentsViewsNinjaPurchaseNewWebPaymentPagePurchaseRequest {
    /**
     * 
     * @type {NumberPurchaseInSchema}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseNewWebPaymentPagePurchase
     */
    readonly numberPurchaseInSchema: NumberPurchaseInSchema
}

/**
 * Request parameters for paymentsViewsNinjaPurchaseNumberAndAddonPurchaseWeb operation in PurchaseApi.
 * @export
 * @interface PurchaseApiPaymentsViewsNinjaPurchaseNumberAndAddonPurchaseWebRequest
 */
export interface PurchaseApiPaymentsViewsNinjaPurchaseNumberAndAddonPurchaseWebRequest {
    /**
     * 
     * @type {NumberAndAddonsPurchaseInSchema}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseNumberAndAddonPurchaseWeb
     */
    readonly numberAndAddonsPurchaseInSchema: NumberAndAddonsPurchaseInSchema
}

/**
 * Request parameters for paymentsViewsNinjaPurchaseSendNumberPurchaseInvoice operation in PurchaseApi.
 * @export
 * @interface PurchaseApiPaymentsViewsNinjaPurchaseSendNumberPurchaseInvoiceRequest
 */
export interface PurchaseApiPaymentsViewsNinjaPurchaseSendNumberPurchaseInvoiceRequest {
    /**
     * 
     * @type {CreatePaymentInvoiceInSchema}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseSendNumberPurchaseInvoice
     */
    readonly createPaymentInvoiceInSchema: CreatePaymentInvoiceInSchema
}

/**
 * Request parameters for paymentsViewsNinjaPurchaseWebPaymentPagePurchase operation in PurchaseApi.
 * @export
 * @interface PurchaseApiPaymentsViewsNinjaPurchaseWebPaymentPagePurchaseRequest
 */
export interface PurchaseApiPaymentsViewsNinjaPurchaseWebPaymentPagePurchaseRequest {
    /**
     * 
     * @type {PaymentPageInSchema}
     * @memberof PurchaseApiPaymentsViewsNinjaPurchaseWebPaymentPagePurchase
     */
    readonly paymentPageInSchema: PaymentPageInSchema
}

/**
 * PurchaseApi - object-oriented interface
 * @export
 * @class PurchaseApi
 * @extends {BaseAPI}
 */
export class PurchaseApi extends BaseAPI {
    /**
     * 
     * @summary Addon Purchase Web
     * @param {PurchaseApiPaymentsViewsNinjaPurchaseAddonPurchaseWebRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseApi
     */
    public paymentsViewsNinjaPurchaseAddonPurchaseWeb(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseAddonPurchaseWebRequest, options?: RawAxiosRequestConfig) {
        return PurchaseApiFp(this.configuration).paymentsViewsNinjaPurchaseAddonPurchaseWeb(requestParameters.addonPurchaseInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Addon Purchase Web V2
     * @param {PurchaseApiPaymentsViewsNinjaPurchaseAddonPurchaseWebV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseApi
     */
    public paymentsViewsNinjaPurchaseAddonPurchaseWebV2(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseAddonPurchaseWebV2Request, options?: RawAxiosRequestConfig) {
        return PurchaseApiFp(this.configuration).paymentsViewsNinjaPurchaseAddonPurchaseWebV2(requestParameters.addonPurchaseInSchemaV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Airtime Topup
     * @param {PurchaseApiPaymentsViewsNinjaPurchaseAdminAirtimeTopupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseApi
     */
    public paymentsViewsNinjaPurchaseAdminAirtimeTopup(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseAdminAirtimeTopupRequest, options?: RawAxiosRequestConfig) {
        return PurchaseApiFp(this.configuration).paymentsViewsNinjaPurchaseAdminAirtimeTopup(requestParameters.adminAirtimeTopUpInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Auth Addon Purchase
     * @param {PurchaseApiPaymentsViewsNinjaPurchaseAuthAddonPurchaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseApi
     */
    public paymentsViewsNinjaPurchaseAuthAddonPurchase(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseAuthAddonPurchaseRequest, options?: RawAxiosRequestConfig) {
        return PurchaseApiFp(this.configuration).paymentsViewsNinjaPurchaseAuthAddonPurchase(requestParameters.additionalAddonPurchaseInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Auth Number Purchase
     * @param {PurchaseApiPaymentsViewsNinjaPurchaseAuthNumberPurchaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseApi
     */
    public paymentsViewsNinjaPurchaseAuthNumberPurchase(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseAuthNumberPurchaseRequest, options?: RawAxiosRequestConfig) {
        return PurchaseApiFp(this.configuration).paymentsViewsNinjaPurchaseAuthNumberPurchase(requestParameters.additionalNumberPurchaseInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Campaign Number Purchase
     * @param {PurchaseApiPaymentsViewsNinjaPurchaseCampaignNumberPurchaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseApi
     */
    public paymentsViewsNinjaPurchaseCampaignNumberPurchase(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseCampaignNumberPurchaseRequest, options?: RawAxiosRequestConfig) {
        return PurchaseApiFp(this.configuration).paymentsViewsNinjaPurchaseCampaignNumberPurchase(requestParameters.campaignNumberPurchaseInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate Business Number Extension Payment Link
     * @param {PurchaseApiPaymentsViewsNinjaPurchaseGenerateBusinessNumberExtensionPaymentLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseApi
     */
    public paymentsViewsNinjaPurchaseGenerateBusinessNumberExtensionPaymentLink(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseGenerateBusinessNumberExtensionPaymentLinkRequest, options?: RawAxiosRequestConfig) {
        return PurchaseApiFp(this.configuration).paymentsViewsNinjaPurchaseGenerateBusinessNumberExtensionPaymentLink(requestParameters.businessNumber, requestParameters.quantity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate Invoice Payment Link
     * @param {PurchaseApiPaymentsViewsNinjaPurchaseGenerateInvoicePaymentLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseApi
     */
    public paymentsViewsNinjaPurchaseGenerateInvoicePaymentLink(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseGenerateInvoicePaymentLinkRequest, options?: RawAxiosRequestConfig) {
        return PurchaseApiFp(this.configuration).paymentsViewsNinjaPurchaseGenerateInvoicePaymentLink(requestParameters.invoiceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate Payment Link
     * @param {PurchaseApiPaymentsViewsNinjaPurchaseGeneratePaymentLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseApi
     */
    public paymentsViewsNinjaPurchaseGeneratePaymentLink(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseGeneratePaymentLinkRequest, options?: RawAxiosRequestConfig) {
        return PurchaseApiFp(this.configuration).paymentsViewsNinjaPurchaseGeneratePaymentLink(requestParameters.identifier, requestParameters.planId, requestParameters.quantity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of all Addons.
     * @summary Get Addon Plans
     * @param {PurchaseApiPaymentsViewsNinjaPurchaseGetAddonPlansRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseApi
     */
    public paymentsViewsNinjaPurchaseGetAddonPlans(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseGetAddonPlansRequest, options?: RawAxiosRequestConfig) {
        return PurchaseApiFp(this.configuration).paymentsViewsNinjaPurchaseGetAddonPlans(requestParameters.term, requestParameters.search, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Subscription Plan
     * @param {PurchaseApiPaymentsViewsNinjaPurchaseGetSubscriptionPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseApi
     */
    public paymentsViewsNinjaPurchaseGetSubscriptionPlan(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseGetSubscriptionPlanRequest = {}, options?: RawAxiosRequestConfig) {
        return PurchaseApiFp(this.configuration).paymentsViewsNinjaPurchaseGetSubscriptionPlan(requestParameters.search, requestParameters.numberRegion, requestParameters.currency, requestParameters.term, requestParameters.planType, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary New Web Payment Page Purchase
     * @param {PurchaseApiPaymentsViewsNinjaPurchaseNewWebPaymentPagePurchaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseApi
     */
    public paymentsViewsNinjaPurchaseNewWebPaymentPagePurchase(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseNewWebPaymentPagePurchaseRequest, options?: RawAxiosRequestConfig) {
        return PurchaseApiFp(this.configuration).paymentsViewsNinjaPurchaseNewWebPaymentPagePurchase(requestParameters.numberPurchaseInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Number And Addon Purchase Web
     * @param {PurchaseApiPaymentsViewsNinjaPurchaseNumberAndAddonPurchaseWebRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseApi
     */
    public paymentsViewsNinjaPurchaseNumberAndAddonPurchaseWeb(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseNumberAndAddonPurchaseWebRequest, options?: RawAxiosRequestConfig) {
        return PurchaseApiFp(this.configuration).paymentsViewsNinjaPurchaseNumberAndAddonPurchaseWeb(requestParameters.numberAndAddonsPurchaseInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send Number Purchase Invoice
     * @param {PurchaseApiPaymentsViewsNinjaPurchaseSendNumberPurchaseInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseApi
     */
    public paymentsViewsNinjaPurchaseSendNumberPurchaseInvoice(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseSendNumberPurchaseInvoiceRequest, options?: RawAxiosRequestConfig) {
        return PurchaseApiFp(this.configuration).paymentsViewsNinjaPurchaseSendNumberPurchaseInvoice(requestParameters.createPaymentInvoiceInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Web Payment Page Purchase
     * @param {PurchaseApiPaymentsViewsNinjaPurchaseWebPaymentPagePurchaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseApi
     */
    public paymentsViewsNinjaPurchaseWebPaymentPagePurchase(requestParameters: PurchaseApiPaymentsViewsNinjaPurchaseWebPaymentPagePurchaseRequest, options?: RawAxiosRequestConfig) {
        return PurchaseApiFp(this.configuration).paymentsViewsNinjaPurchaseWebPaymentPagePurchase(requestParameters.paymentPageInSchema, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const PaymentsViewsNinjaPurchaseGetAddonPlansTermEnum = {
    Monthly: 'monthly',
    Quarterly: 'quarterly',
    Yearly: 'yearly'
} as const;
export type PaymentsViewsNinjaPurchaseGetAddonPlansTermEnum = typeof PaymentsViewsNinjaPurchaseGetAddonPlansTermEnum[keyof typeof PaymentsViewsNinjaPurchaseGetAddonPlansTermEnum];
/**
 * @export
 */
export const PaymentsViewsNinjaPurchaseGetSubscriptionPlanCurrencyEnum = {
    Aed: 'AED',
    Afn: 'AFN',
    All: 'ALL',
    Amd: 'AMD',
    Ang: 'ANG',
    Aoa: 'AOA',
    Ars: 'ARS',
    Aud: 'AUD',
    Awg: 'AWG',
    Azn: 'AZN',
    Bam: 'BAM',
    Bbd: 'BBD',
    Bdt: 'BDT',
    Bgn: 'BGN',
    Bhd: 'BHD',
    Bif: 'BIF',
    Bmd: 'BMD',
    Bnd: 'BND',
    Bob: 'BOB',
    Bov: 'BOV',
    Brl: 'BRL',
    Bsd: 'BSD',
    Btn: 'BTN',
    Bwp: 'BWP',
    Byn: 'BYN',
    Bzd: 'BZD',
    Cad: 'CAD',
    Cdf: 'CDF',
    Che: 'CHE',
    Chf: 'CHF',
    Chw: 'CHW',
    Clf: 'CLF',
    Clp: 'CLP',
    Cny: 'CNY',
    Cop: 'COP',
    Cou: 'COU',
    Crc: 'CRC',
    Cuc: 'CUC',
    Cup: 'CUP',
    Cve: 'CVE',
    Czk: 'CZK',
    Djf: 'DJF',
    Dkk: 'DKK',
    Dop: 'DOP',
    Dzd: 'DZD',
    Egp: 'EGP',
    Ern: 'ERN',
    Etb: 'ETB',
    Eur: 'EUR',
    Fjd: 'FJD',
    Fkp: 'FKP',
    Gbp: 'GBP',
    Gel: 'GEL',
    Ghs: 'GHS',
    Gip: 'GIP',
    Gmd: 'GMD',
    Gnf: 'GNF',
    Gtq: 'GTQ',
    Gyd: 'GYD',
    Hkd: 'HKD',
    Hnl: 'HNL',
    Hrk: 'HRK',
    Htg: 'HTG',
    Huf: 'HUF',
    Idr: 'IDR',
    Ils: 'ILS',
    Inr: 'INR',
    Iqd: 'IQD',
    Irr: 'IRR',
    Isk: 'ISK',
    Jmd: 'JMD',
    Jod: 'JOD',
    Jpy: 'JPY',
    Kes: 'KES',
    Kgs: 'KGS',
    Khr: 'KHR',
    Kmf: 'KMF',
    Kpw: 'KPW',
    Krw: 'KRW',
    Kwd: 'KWD',
    Kyd: 'KYD',
    Kzt: 'KZT',
    Lak: 'LAK',
    Lbp: 'LBP',
    Lkr: 'LKR',
    Lrd: 'LRD',
    Lsl: 'LSL',
    Lyd: 'LYD',
    Mad: 'MAD',
    Mdl: 'MDL',
    Mga: 'MGA',
    Mkd: 'MKD',
    Mmk: 'MMK',
    Mnt: 'MNT',
    Mop: 'MOP',
    Mru: 'MRU',
    Mur: 'MUR',
    Mvr: 'MVR',
    Mwk: 'MWK',
    Mxn: 'MXN',
    Mxv: 'MXV',
    Myr: 'MYR',
    Mzn: 'MZN',
    Nad: 'NAD',
    Ngn: 'NGN',
    Nio: 'NIO',
    Nok: 'NOK',
    Npr: 'NPR',
    Nzd: 'NZD',
    Omr: 'OMR',
    Pab: 'PAB',
    Pen: 'PEN',
    Pgk: 'PGK',
    Php: 'PHP',
    Pkr: 'PKR',
    Pln: 'PLN',
    Pyg: 'PYG',
    Qar: 'QAR',
    Ron: 'RON',
    Rsd: 'RSD',
    Rub: 'RUB',
    Rwf: 'RWF',
    Sar: 'SAR',
    Sbd: 'SBD',
    Scr: 'SCR',
    Sdg: 'SDG',
    Sek: 'SEK',
    Sgd: 'SGD',
    Shp: 'SHP',
    Sle: 'SLE',
    Sll: 'SLL',
    Sos: 'SOS',
    Srd: 'SRD',
    Ssp: 'SSP',
    Stn: 'STN',
    Svc: 'SVC',
    Syp: 'SYP',
    Szl: 'SZL',
    Thb: 'THB',
    Tjs: 'TJS',
    Tmt: 'TMT',
    Tnd: 'TND',
    Top: 'TOP',
    Try: 'TRY',
    Ttd: 'TTD',
    Twd: 'TWD',
    Tzs: 'TZS',
    Uah: 'UAH',
    Ugx: 'UGX',
    Usd: 'USD',
    Usn: 'USN',
    Uyi: 'UYI',
    Uyu: 'UYU',
    Uyw: 'UYW',
    Uzs: 'UZS',
    Ved: 'VED',
    Ves: 'VES',
    Vnd: 'VND',
    Vuv: 'VUV',
    Wst: 'WST',
    Xaf: 'XAF',
    Xcd: 'XCD',
    Xof: 'XOF',
    Xpf: 'XPF',
    Xsu: 'XSU',
    Xua: 'XUA',
    Yer: 'YER',
    Zar: 'ZAR',
    Zmw: 'ZMW',
    Zwl: 'ZWL'
} as const;
export type PaymentsViewsNinjaPurchaseGetSubscriptionPlanCurrencyEnum = typeof PaymentsViewsNinjaPurchaseGetSubscriptionPlanCurrencyEnum[keyof typeof PaymentsViewsNinjaPurchaseGetSubscriptionPlanCurrencyEnum];


/**
 * ReceiverLineApi - axios parameter creator
 * @export
 */
export const ReceiverLineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List Receiver Extension
         * @param {number} businessId 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberReceiverLineListReceiverExtension: async (businessId: number, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberReceiverLineListReceiverExtension', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/extension/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Receiver Line
         * @param {number} businessId 
         * @param {ReceiverLineInSchema} receiverLineInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberReceiverLineListReceiverLine: async (businessId: number, receiverLineInSchema: ReceiverLineInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberReceiverLineListReceiverLine', 'businessId', businessId)
            // verify required parameter 'receiverLineInSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberReceiverLineListReceiverLine', 'receiverLineInSchema', receiverLineInSchema)
            const localVarPath = `/api/business/{business_id}/receiver-line/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(receiverLineInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReceiverLineApi - functional programming interface
 * @export
 */
export const ReceiverLineApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReceiverLineApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List Receiver Extension
         * @param {number} businessId 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaNumberReceiverLineListReceiverExtension(businessId: number, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedReceiverExtensionOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaNumberReceiverLineListReceiverExtension(businessId, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReceiverLineApi.telephonyViewsNinjaNumberReceiverLineListReceiverExtension']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Receiver Line
         * @param {number} businessId 
         * @param {ReceiverLineInSchema} receiverLineInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaNumberReceiverLineListReceiverLine(businessId: number, receiverLineInSchema: ReceiverLineInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReceiverLineOutSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaNumberReceiverLineListReceiverLine(businessId, receiverLineInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReceiverLineApi.telephonyViewsNinjaNumberReceiverLineListReceiverLine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReceiverLineApi - factory interface
 * @export
 */
export const ReceiverLineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReceiverLineApiFp(configuration)
    return {
        /**
         * 
         * @summary List Receiver Extension
         * @param {ReceiverLineApiTelephonyViewsNinjaNumberReceiverLineListReceiverExtensionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberReceiverLineListReceiverExtension(requestParameters: ReceiverLineApiTelephonyViewsNinjaNumberReceiverLineListReceiverExtensionRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedReceiverExtensionOutSchema> {
            return localVarFp.telephonyViewsNinjaNumberReceiverLineListReceiverExtension(requestParameters.businessId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Receiver Line
         * @param {ReceiverLineApiTelephonyViewsNinjaNumberReceiverLineListReceiverLineRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberReceiverLineListReceiverLine(requestParameters: ReceiverLineApiTelephonyViewsNinjaNumberReceiverLineListReceiverLineRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ReceiverLineOutSchema>> {
            return localVarFp.telephonyViewsNinjaNumberReceiverLineListReceiverLine(requestParameters.businessId, requestParameters.receiverLineInSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for telephonyViewsNinjaNumberReceiverLineListReceiverExtension operation in ReceiverLineApi.
 * @export
 * @interface ReceiverLineApiTelephonyViewsNinjaNumberReceiverLineListReceiverExtensionRequest
 */
export interface ReceiverLineApiTelephonyViewsNinjaNumberReceiverLineListReceiverExtensionRequest {
    /**
     * 
     * @type {number}
     * @memberof ReceiverLineApiTelephonyViewsNinjaNumberReceiverLineListReceiverExtension
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof ReceiverLineApiTelephonyViewsNinjaNumberReceiverLineListReceiverExtension
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof ReceiverLineApiTelephonyViewsNinjaNumberReceiverLineListReceiverExtension
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof ReceiverLineApiTelephonyViewsNinjaNumberReceiverLineListReceiverExtension
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for telephonyViewsNinjaNumberReceiverLineListReceiverLine operation in ReceiverLineApi.
 * @export
 * @interface ReceiverLineApiTelephonyViewsNinjaNumberReceiverLineListReceiverLineRequest
 */
export interface ReceiverLineApiTelephonyViewsNinjaNumberReceiverLineListReceiverLineRequest {
    /**
     * 
     * @type {number}
     * @memberof ReceiverLineApiTelephonyViewsNinjaNumberReceiverLineListReceiverLine
     */
    readonly businessId: number

    /**
     * 
     * @type {ReceiverLineInSchema}
     * @memberof ReceiverLineApiTelephonyViewsNinjaNumberReceiverLineListReceiverLine
     */
    readonly receiverLineInSchema: ReceiverLineInSchema
}

/**
 * ReceiverLineApi - object-oriented interface
 * @export
 * @class ReceiverLineApi
 * @extends {BaseAPI}
 */
export class ReceiverLineApi extends BaseAPI {
    /**
     * 
     * @summary List Receiver Extension
     * @param {ReceiverLineApiTelephonyViewsNinjaNumberReceiverLineListReceiverExtensionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceiverLineApi
     */
    public telephonyViewsNinjaNumberReceiverLineListReceiverExtension(requestParameters: ReceiverLineApiTelephonyViewsNinjaNumberReceiverLineListReceiverExtensionRequest, options?: RawAxiosRequestConfig) {
        return ReceiverLineApiFp(this.configuration).telephonyViewsNinjaNumberReceiverLineListReceiverExtension(requestParameters.businessId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Receiver Line
     * @param {ReceiverLineApiTelephonyViewsNinjaNumberReceiverLineListReceiverLineRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceiverLineApi
     */
    public telephonyViewsNinjaNumberReceiverLineListReceiverLine(requestParameters: ReceiverLineApiTelephonyViewsNinjaNumberReceiverLineListReceiverLineRequest, options?: RawAxiosRequestConfig) {
        return ReceiverLineApiFp(this.configuration).telephonyViewsNinjaNumberReceiverLineListReceiverLine(requestParameters.businessId, requestParameters.receiverLineInSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportApi - axios parameter creator
 * @export
 */
export const ReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Export Leaderboard Report
         * @param {number} numberId 
         * @param {number} businessId 
         * @param {TelephonyViewsNinjaReportTeamExportLeaderboardReportPeriodEnum} period 
         * @param {TelephonyViewsNinjaReportTeamExportLeaderboardReportOrderByEnum} orderBy 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaReportTeamExportLeaderboardReport: async (numberId: number, businessId: number, period: TelephonyViewsNinjaReportTeamExportLeaderboardReportPeriodEnum, orderBy: TelephonyViewsNinjaReportTeamExportLeaderboardReportOrderByEnum, startDate?: string | null, endDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'numberId' is not null or undefined
            assertParamExists('telephonyViewsNinjaReportTeamExportLeaderboardReport', 'numberId', numberId)
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaReportTeamExportLeaderboardReport', 'businessId', businessId)
            // verify required parameter 'period' is not null or undefined
            assertParamExists('telephonyViewsNinjaReportTeamExportLeaderboardReport', 'period', period)
            // verify required parameter 'orderBy' is not null or undefined
            assertParamExists('telephonyViewsNinjaReportTeamExportLeaderboardReport', 'orderBy', orderBy)
            const localVarPath = `/api/business/report/leaderboard/export-csv/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (numberId !== undefined) {
                localVarQueryParameter['number_id'] = numberId;
            }

            if (businessId !== undefined) {
                localVarQueryParameter['business_id'] = businessId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Team Member Report
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaReportTeamExportTeamMemberReport: async (businessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaReportTeamExportTeamMemberReport', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/team-member/export-csv/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Team Report
         * @param {number} numberId 
         * @param {number} businessId 
         * @param {TelephonyViewsNinjaReportTeamExportTeamReportPeriodEnum} period 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {number | null} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaReportTeamExportTeamReport: async (numberId: number, businessId: number, period: TelephonyViewsNinjaReportTeamExportTeamReportPeriodEnum, startDate?: string | null, endDate?: string | null, userId?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'numberId' is not null or undefined
            assertParamExists('telephonyViewsNinjaReportTeamExportTeamReport', 'numberId', numberId)
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaReportTeamExportTeamReport', 'businessId', businessId)
            // verify required parameter 'period' is not null or undefined
            assertParamExists('telephonyViewsNinjaReportTeamExportTeamReport', 'period', period)
            const localVarPath = `/api/business/report/team/export-csv/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (numberId !== undefined) {
                localVarQueryParameter['number_id'] = numberId;
            }

            if (businessId !== undefined) {
                localVarQueryParameter['business_id'] = businessId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Call Log Summary Report
         * @param {number} businessId 
         * @param {TelephonyViewsNinjaReportTeamGetCallLogSummaryReportPeriodEnum} period 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {number | null} [userId] 
         * @param {number | null} [numberId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaReportTeamGetCallLogSummaryReport: async (businessId: number, period: TelephonyViewsNinjaReportTeamGetCallLogSummaryReportPeriodEnum, startDate?: string | null, endDate?: string | null, userId?: number | null, numberId?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaReportTeamGetCallLogSummaryReport', 'businessId', businessId)
            // verify required parameter 'period' is not null or undefined
            assertParamExists('telephonyViewsNinjaReportTeamGetCallLogSummaryReport', 'period', period)
            const localVarPath = `/api/business/report/call-log-summary/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (businessId !== undefined) {
                localVarQueryParameter['business_id'] = businessId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (numberId !== undefined) {
                localVarQueryParameter['number_id'] = numberId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Leaderboard Report
         * @param {number} numberId 
         * @param {number} businessId 
         * @param {TelephonyViewsNinjaReportTeamGetLeaderboardReportPeriodEnum} period 
         * @param {TelephonyViewsNinjaReportTeamGetLeaderboardReportOrderByEnum} orderBy 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaReportTeamGetLeaderboardReport: async (numberId: number, businessId: number, period: TelephonyViewsNinjaReportTeamGetLeaderboardReportPeriodEnum, orderBy: TelephonyViewsNinjaReportTeamGetLeaderboardReportOrderByEnum, startDate?: string | null, endDate?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'numberId' is not null or undefined
            assertParamExists('telephonyViewsNinjaReportTeamGetLeaderboardReport', 'numberId', numberId)
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaReportTeamGetLeaderboardReport', 'businessId', businessId)
            // verify required parameter 'period' is not null or undefined
            assertParamExists('telephonyViewsNinjaReportTeamGetLeaderboardReport', 'period', period)
            // verify required parameter 'orderBy' is not null or undefined
            assertParamExists('telephonyViewsNinjaReportTeamGetLeaderboardReport', 'orderBy', orderBy)
            const localVarPath = `/api/business/report/leaderboard/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (numberId !== undefined) {
                localVarQueryParameter['number_id'] = numberId;
            }

            if (businessId !== undefined) {
                localVarQueryParameter['business_id'] = businessId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Team Report
         * @param {number} numberId 
         * @param {number} businessId 
         * @param {TelephonyViewsNinjaReportTeamGetTeamReportPeriodEnum} period 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {number | null} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaReportTeamGetTeamReport: async (numberId: number, businessId: number, period: TelephonyViewsNinjaReportTeamGetTeamReportPeriodEnum, startDate?: string | null, endDate?: string | null, userId?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'numberId' is not null or undefined
            assertParamExists('telephonyViewsNinjaReportTeamGetTeamReport', 'numberId', numberId)
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaReportTeamGetTeamReport', 'businessId', businessId)
            // verify required parameter 'period' is not null or undefined
            assertParamExists('telephonyViewsNinjaReportTeamGetTeamReport', 'period', period)
            const localVarPath = `/api/business/report/team/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (numberId !== undefined) {
                localVarQueryParameter['number_id'] = numberId;
            }

            if (businessId !== undefined) {
                localVarQueryParameter['business_id'] = businessId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get team report distribution data.
         * @summary Get Team Report Distributions
         * @param {number} numberId 
         * @param {number} businessId 
         * @param {TelephonyViewsNinjaReportTeamGetTeamReportDistributionsPeriodEnum} period 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {number | null} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaReportTeamGetTeamReportDistributions: async (numberId: number, businessId: number, period: TelephonyViewsNinjaReportTeamGetTeamReportDistributionsPeriodEnum, startDate?: string | null, endDate?: string | null, userId?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'numberId' is not null or undefined
            assertParamExists('telephonyViewsNinjaReportTeamGetTeamReportDistributions', 'numberId', numberId)
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaReportTeamGetTeamReportDistributions', 'businessId', businessId)
            // verify required parameter 'period' is not null or undefined
            assertParamExists('telephonyViewsNinjaReportTeamGetTeamReportDistributions', 'period', period)
            const localVarPath = `/api/business/report/team/distributions/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (numberId !== undefined) {
                localVarQueryParameter['number_id'] = numberId;
            }

            if (businessId !== undefined) {
                localVarQueryParameter['business_id'] = businessId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportApi - functional programming interface
 * @export
 */
export const ReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Export Leaderboard Report
         * @param {number} numberId 
         * @param {number} businessId 
         * @param {TelephonyViewsNinjaReportTeamExportLeaderboardReportPeriodEnum} period 
         * @param {TelephonyViewsNinjaReportTeamExportLeaderboardReportOrderByEnum} orderBy 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaReportTeamExportLeaderboardReport(numberId: number, businessId: number, period: TelephonyViewsNinjaReportTeamExportLeaderboardReportPeriodEnum, orderBy: TelephonyViewsNinjaReportTeamExportLeaderboardReportOrderByEnum, startDate?: string | null, endDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaReportTeamExportLeaderboardReport(numberId, businessId, period, orderBy, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.telephonyViewsNinjaReportTeamExportLeaderboardReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Team Member Report
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaReportTeamExportTeamMemberReport(businessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaReportTeamExportTeamMemberReport(businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.telephonyViewsNinjaReportTeamExportTeamMemberReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Team Report
         * @param {number} numberId 
         * @param {number} businessId 
         * @param {TelephonyViewsNinjaReportTeamExportTeamReportPeriodEnum} period 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {number | null} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaReportTeamExportTeamReport(numberId: number, businessId: number, period: TelephonyViewsNinjaReportTeamExportTeamReportPeriodEnum, startDate?: string | null, endDate?: string | null, userId?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaReportTeamExportTeamReport(numberId, businessId, period, startDate, endDate, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.telephonyViewsNinjaReportTeamExportTeamReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Call Log Summary Report
         * @param {number} businessId 
         * @param {TelephonyViewsNinjaReportTeamGetCallLogSummaryReportPeriodEnum} period 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {number | null} [userId] 
         * @param {number | null} [numberId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaReportTeamGetCallLogSummaryReport(businessId: number, period: TelephonyViewsNinjaReportTeamGetCallLogSummaryReportPeriodEnum, startDate?: string | null, endDate?: string | null, userId?: number | null, numberId?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallLogSummaryReportOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaReportTeamGetCallLogSummaryReport(businessId, period, startDate, endDate, userId, numberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.telephonyViewsNinjaReportTeamGetCallLogSummaryReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Leaderboard Report
         * @param {number} numberId 
         * @param {number} businessId 
         * @param {TelephonyViewsNinjaReportTeamGetLeaderboardReportPeriodEnum} period 
         * @param {TelephonyViewsNinjaReportTeamGetLeaderboardReportOrderByEnum} orderBy 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaReportTeamGetLeaderboardReport(numberId: number, businessId: number, period: TelephonyViewsNinjaReportTeamGetLeaderboardReportPeriodEnum, orderBy: TelephonyViewsNinjaReportTeamGetLeaderboardReportOrderByEnum, startDate?: string | null, endDate?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedLeaderBoardReportOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaReportTeamGetLeaderboardReport(numberId, businessId, period, orderBy, startDate, endDate, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.telephonyViewsNinjaReportTeamGetLeaderboardReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Team Report
         * @param {number} numberId 
         * @param {number} businessId 
         * @param {TelephonyViewsNinjaReportTeamGetTeamReportPeriodEnum} period 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {number | null} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaReportTeamGetTeamReport(numberId: number, businessId: number, period: TelephonyViewsNinjaReportTeamGetTeamReportPeriodEnum, startDate?: string | null, endDate?: string | null, userId?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseTeamReportOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaReportTeamGetTeamReport(numberId, businessId, period, startDate, endDate, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.telephonyViewsNinjaReportTeamGetTeamReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get team report distribution data.
         * @summary Get Team Report Distributions
         * @param {number} numberId 
         * @param {number} businessId 
         * @param {TelephonyViewsNinjaReportTeamGetTeamReportDistributionsPeriodEnum} period 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {number | null} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaReportTeamGetTeamReportDistributions(numberId: number, businessId: number, period: TelephonyViewsNinjaReportTeamGetTeamReportDistributionsPeriodEnum, startDate?: string | null, endDate?: string | null, userId?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseTeamReportDistributionOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaReportTeamGetTeamReportDistributions(numberId, businessId, period, startDate, endDate, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.telephonyViewsNinjaReportTeamGetTeamReportDistributions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportApi - factory interface
 * @export
 */
export const ReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportApiFp(configuration)
    return {
        /**
         * 
         * @summary Export Leaderboard Report
         * @param {ReportApiTelephonyViewsNinjaReportTeamExportLeaderboardReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaReportTeamExportLeaderboardReport(requestParameters: ReportApiTelephonyViewsNinjaReportTeamExportLeaderboardReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.telephonyViewsNinjaReportTeamExportLeaderboardReport(requestParameters.numberId, requestParameters.businessId, requestParameters.period, requestParameters.orderBy, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Team Member Report
         * @param {ReportApiTelephonyViewsNinjaReportTeamExportTeamMemberReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaReportTeamExportTeamMemberReport(requestParameters: ReportApiTelephonyViewsNinjaReportTeamExportTeamMemberReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.telephonyViewsNinjaReportTeamExportTeamMemberReport(requestParameters.businessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Team Report
         * @param {ReportApiTelephonyViewsNinjaReportTeamExportTeamReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaReportTeamExportTeamReport(requestParameters: ReportApiTelephonyViewsNinjaReportTeamExportTeamReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.telephonyViewsNinjaReportTeamExportTeamReport(requestParameters.numberId, requestParameters.businessId, requestParameters.period, requestParameters.startDate, requestParameters.endDate, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Call Log Summary Report
         * @param {ReportApiTelephonyViewsNinjaReportTeamGetCallLogSummaryReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaReportTeamGetCallLogSummaryReport(requestParameters: ReportApiTelephonyViewsNinjaReportTeamGetCallLogSummaryReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<CallLogSummaryReportOutSchema> {
            return localVarFp.telephonyViewsNinjaReportTeamGetCallLogSummaryReport(requestParameters.businessId, requestParameters.period, requestParameters.startDate, requestParameters.endDate, requestParameters.userId, requestParameters.numberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Leaderboard Report
         * @param {ReportApiTelephonyViewsNinjaReportTeamGetLeaderboardReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaReportTeamGetLeaderboardReport(requestParameters: ReportApiTelephonyViewsNinjaReportTeamGetLeaderboardReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedLeaderBoardReportOutSchema> {
            return localVarFp.telephonyViewsNinjaReportTeamGetLeaderboardReport(requestParameters.numberId, requestParameters.businessId, requestParameters.period, requestParameters.orderBy, requestParameters.startDate, requestParameters.endDate, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Team Report
         * @param {ReportApiTelephonyViewsNinjaReportTeamGetTeamReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaReportTeamGetTeamReport(requestParameters: ReportApiTelephonyViewsNinjaReportTeamGetTeamReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseTeamReportOutSchema> {
            return localVarFp.telephonyViewsNinjaReportTeamGetTeamReport(requestParameters.numberId, requestParameters.businessId, requestParameters.period, requestParameters.startDate, requestParameters.endDate, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get team report distribution data.
         * @summary Get Team Report Distributions
         * @param {ReportApiTelephonyViewsNinjaReportTeamGetTeamReportDistributionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaReportTeamGetTeamReportDistributions(requestParameters: ReportApiTelephonyViewsNinjaReportTeamGetTeamReportDistributionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseTeamReportDistributionOutSchema> {
            return localVarFp.telephonyViewsNinjaReportTeamGetTeamReportDistributions(requestParameters.numberId, requestParameters.businessId, requestParameters.period, requestParameters.startDate, requestParameters.endDate, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for telephonyViewsNinjaReportTeamExportLeaderboardReport operation in ReportApi.
 * @export
 * @interface ReportApiTelephonyViewsNinjaReportTeamExportLeaderboardReportRequest
 */
export interface ReportApiTelephonyViewsNinjaReportTeamExportLeaderboardReportRequest {
    /**
     * 
     * @type {number}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamExportLeaderboardReport
     */
    readonly numberId: number

    /**
     * 
     * @type {number}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamExportLeaderboardReport
     */
    readonly businessId: number

    /**
     * 
     * @type {'this_week' | 'this_month' | 'this_year' | 'last_thirty_days' | 'last_ninety_days' | 'today' | 'custom'}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamExportLeaderboardReport
     */
    readonly period: TelephonyViewsNinjaReportTeamExportLeaderboardReportPeriodEnum

    /**
     * 
     * @type {'total_call' | 'dialled_call' | 'received_call' | 'time_spent_on_call' | 'full_name' | 'role' | '-role' | '-total_call' | '-dialled_call' | '-received_call' | '-time_spent_on_call' | '-full_name'}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamExportLeaderboardReport
     */
    readonly orderBy: TelephonyViewsNinjaReportTeamExportLeaderboardReportOrderByEnum

    /**
     * 
     * @type {string}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamExportLeaderboardReport
     */
    readonly startDate?: string | null

    /**
     * 
     * @type {string}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamExportLeaderboardReport
     */
    readonly endDate?: string | null
}

/**
 * Request parameters for telephonyViewsNinjaReportTeamExportTeamMemberReport operation in ReportApi.
 * @export
 * @interface ReportApiTelephonyViewsNinjaReportTeamExportTeamMemberReportRequest
 */
export interface ReportApiTelephonyViewsNinjaReportTeamExportTeamMemberReportRequest {
    /**
     * 
     * @type {number}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamExportTeamMemberReport
     */
    readonly businessId: number
}

/**
 * Request parameters for telephonyViewsNinjaReportTeamExportTeamReport operation in ReportApi.
 * @export
 * @interface ReportApiTelephonyViewsNinjaReportTeamExportTeamReportRequest
 */
export interface ReportApiTelephonyViewsNinjaReportTeamExportTeamReportRequest {
    /**
     * 
     * @type {number}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamExportTeamReport
     */
    readonly numberId: number

    /**
     * 
     * @type {number}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamExportTeamReport
     */
    readonly businessId: number

    /**
     * 
     * @type {'this_week' | 'this_month' | 'this_year' | 'last_thirty_days' | 'last_ninety_days' | 'today' | 'custom'}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamExportTeamReport
     */
    readonly period: TelephonyViewsNinjaReportTeamExportTeamReportPeriodEnum

    /**
     * 
     * @type {string}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamExportTeamReport
     */
    readonly startDate?: string | null

    /**
     * 
     * @type {string}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamExportTeamReport
     */
    readonly endDate?: string | null

    /**
     * 
     * @type {number}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamExportTeamReport
     */
    readonly userId?: number | null
}

/**
 * Request parameters for telephonyViewsNinjaReportTeamGetCallLogSummaryReport operation in ReportApi.
 * @export
 * @interface ReportApiTelephonyViewsNinjaReportTeamGetCallLogSummaryReportRequest
 */
export interface ReportApiTelephonyViewsNinjaReportTeamGetCallLogSummaryReportRequest {
    /**
     * 
     * @type {number}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetCallLogSummaryReport
     */
    readonly businessId: number

    /**
     * 
     * @type {'this_week' | 'this_month' | 'this_year' | 'last_thirty_days' | 'last_ninety_days' | 'today' | 'custom'}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetCallLogSummaryReport
     */
    readonly period: TelephonyViewsNinjaReportTeamGetCallLogSummaryReportPeriodEnum

    /**
     * 
     * @type {string}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetCallLogSummaryReport
     */
    readonly startDate?: string | null

    /**
     * 
     * @type {string}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetCallLogSummaryReport
     */
    readonly endDate?: string | null

    /**
     * 
     * @type {number}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetCallLogSummaryReport
     */
    readonly userId?: number | null

    /**
     * 
     * @type {number}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetCallLogSummaryReport
     */
    readonly numberId?: number | null
}

/**
 * Request parameters for telephonyViewsNinjaReportTeamGetLeaderboardReport operation in ReportApi.
 * @export
 * @interface ReportApiTelephonyViewsNinjaReportTeamGetLeaderboardReportRequest
 */
export interface ReportApiTelephonyViewsNinjaReportTeamGetLeaderboardReportRequest {
    /**
     * 
     * @type {number}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetLeaderboardReport
     */
    readonly numberId: number

    /**
     * 
     * @type {number}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetLeaderboardReport
     */
    readonly businessId: number

    /**
     * 
     * @type {'this_week' | 'this_month' | 'this_year' | 'last_thirty_days' | 'last_ninety_days' | 'today' | 'custom'}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetLeaderboardReport
     */
    readonly period: TelephonyViewsNinjaReportTeamGetLeaderboardReportPeriodEnum

    /**
     * 
     * @type {'total_call' | 'dialled_call' | 'received_call' | 'time_spent_on_call' | 'full_name' | 'role' | '-role' | '-total_call' | '-dialled_call' | '-received_call' | '-time_spent_on_call' | '-full_name'}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetLeaderboardReport
     */
    readonly orderBy: TelephonyViewsNinjaReportTeamGetLeaderboardReportOrderByEnum

    /**
     * 
     * @type {string}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetLeaderboardReport
     */
    readonly startDate?: string | null

    /**
     * 
     * @type {string}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetLeaderboardReport
     */
    readonly endDate?: string | null

    /**
     * 
     * @type {number}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetLeaderboardReport
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetLeaderboardReport
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetLeaderboardReport
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for telephonyViewsNinjaReportTeamGetTeamReport operation in ReportApi.
 * @export
 * @interface ReportApiTelephonyViewsNinjaReportTeamGetTeamReportRequest
 */
export interface ReportApiTelephonyViewsNinjaReportTeamGetTeamReportRequest {
    /**
     * 
     * @type {number}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetTeamReport
     */
    readonly numberId: number

    /**
     * 
     * @type {number}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetTeamReport
     */
    readonly businessId: number

    /**
     * 
     * @type {'this_week' | 'this_month' | 'this_year' | 'last_thirty_days' | 'last_ninety_days' | 'today' | 'custom'}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetTeamReport
     */
    readonly period: TelephonyViewsNinjaReportTeamGetTeamReportPeriodEnum

    /**
     * 
     * @type {string}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetTeamReport
     */
    readonly startDate?: string | null

    /**
     * 
     * @type {string}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetTeamReport
     */
    readonly endDate?: string | null

    /**
     * 
     * @type {number}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetTeamReport
     */
    readonly userId?: number | null
}

/**
 * Request parameters for telephonyViewsNinjaReportTeamGetTeamReportDistributions operation in ReportApi.
 * @export
 * @interface ReportApiTelephonyViewsNinjaReportTeamGetTeamReportDistributionsRequest
 */
export interface ReportApiTelephonyViewsNinjaReportTeamGetTeamReportDistributionsRequest {
    /**
     * 
     * @type {number}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetTeamReportDistributions
     */
    readonly numberId: number

    /**
     * 
     * @type {number}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetTeamReportDistributions
     */
    readonly businessId: number

    /**
     * 
     * @type {'this_week' | 'this_month' | 'this_year' | 'last_thirty_days' | 'last_ninety_days' | 'today' | 'custom'}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetTeamReportDistributions
     */
    readonly period: TelephonyViewsNinjaReportTeamGetTeamReportDistributionsPeriodEnum

    /**
     * 
     * @type {string}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetTeamReportDistributions
     */
    readonly startDate?: string | null

    /**
     * 
     * @type {string}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetTeamReportDistributions
     */
    readonly endDate?: string | null

    /**
     * 
     * @type {number}
     * @memberof ReportApiTelephonyViewsNinjaReportTeamGetTeamReportDistributions
     */
    readonly userId?: number | null
}

/**
 * ReportApi - object-oriented interface
 * @export
 * @class ReportApi
 * @extends {BaseAPI}
 */
export class ReportApi extends BaseAPI {
    /**
     * 
     * @summary Export Leaderboard Report
     * @param {ReportApiTelephonyViewsNinjaReportTeamExportLeaderboardReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public telephonyViewsNinjaReportTeamExportLeaderboardReport(requestParameters: ReportApiTelephonyViewsNinjaReportTeamExportLeaderboardReportRequest, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).telephonyViewsNinjaReportTeamExportLeaderboardReport(requestParameters.numberId, requestParameters.businessId, requestParameters.period, requestParameters.orderBy, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Team Member Report
     * @param {ReportApiTelephonyViewsNinjaReportTeamExportTeamMemberReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public telephonyViewsNinjaReportTeamExportTeamMemberReport(requestParameters: ReportApiTelephonyViewsNinjaReportTeamExportTeamMemberReportRequest, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).telephonyViewsNinjaReportTeamExportTeamMemberReport(requestParameters.businessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Team Report
     * @param {ReportApiTelephonyViewsNinjaReportTeamExportTeamReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public telephonyViewsNinjaReportTeamExportTeamReport(requestParameters: ReportApiTelephonyViewsNinjaReportTeamExportTeamReportRequest, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).telephonyViewsNinjaReportTeamExportTeamReport(requestParameters.numberId, requestParameters.businessId, requestParameters.period, requestParameters.startDate, requestParameters.endDate, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Call Log Summary Report
     * @param {ReportApiTelephonyViewsNinjaReportTeamGetCallLogSummaryReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public telephonyViewsNinjaReportTeamGetCallLogSummaryReport(requestParameters: ReportApiTelephonyViewsNinjaReportTeamGetCallLogSummaryReportRequest, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).telephonyViewsNinjaReportTeamGetCallLogSummaryReport(requestParameters.businessId, requestParameters.period, requestParameters.startDate, requestParameters.endDate, requestParameters.userId, requestParameters.numberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Leaderboard Report
     * @param {ReportApiTelephonyViewsNinjaReportTeamGetLeaderboardReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public telephonyViewsNinjaReportTeamGetLeaderboardReport(requestParameters: ReportApiTelephonyViewsNinjaReportTeamGetLeaderboardReportRequest, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).telephonyViewsNinjaReportTeamGetLeaderboardReport(requestParameters.numberId, requestParameters.businessId, requestParameters.period, requestParameters.orderBy, requestParameters.startDate, requestParameters.endDate, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Team Report
     * @param {ReportApiTelephonyViewsNinjaReportTeamGetTeamReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public telephonyViewsNinjaReportTeamGetTeamReport(requestParameters: ReportApiTelephonyViewsNinjaReportTeamGetTeamReportRequest, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).telephonyViewsNinjaReportTeamGetTeamReport(requestParameters.numberId, requestParameters.businessId, requestParameters.period, requestParameters.startDate, requestParameters.endDate, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get team report distribution data.
     * @summary Get Team Report Distributions
     * @param {ReportApiTelephonyViewsNinjaReportTeamGetTeamReportDistributionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public telephonyViewsNinjaReportTeamGetTeamReportDistributions(requestParameters: ReportApiTelephonyViewsNinjaReportTeamGetTeamReportDistributionsRequest, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).telephonyViewsNinjaReportTeamGetTeamReportDistributions(requestParameters.numberId, requestParameters.businessId, requestParameters.period, requestParameters.startDate, requestParameters.endDate, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const TelephonyViewsNinjaReportTeamExportLeaderboardReportPeriodEnum = {
    ThisWeek: 'this_week',
    ThisMonth: 'this_month',
    ThisYear: 'this_year',
    LastThirtyDays: 'last_thirty_days',
    LastNinetyDays: 'last_ninety_days',
    Today: 'today',
    Custom: 'custom'
} as const;
export type TelephonyViewsNinjaReportTeamExportLeaderboardReportPeriodEnum = typeof TelephonyViewsNinjaReportTeamExportLeaderboardReportPeriodEnum[keyof typeof TelephonyViewsNinjaReportTeamExportLeaderboardReportPeriodEnum];
/**
 * @export
 */
export const TelephonyViewsNinjaReportTeamExportLeaderboardReportOrderByEnum = {
    TotalCall: 'total_call',
    DialledCall: 'dialled_call',
    ReceivedCall: 'received_call',
    TimeSpentOnCall: 'time_spent_on_call',
    FullName: 'full_name',
    Role: 'role',
    Role2: '-role',
    TotalCall2: '-total_call',
    DialledCall2: '-dialled_call',
    ReceivedCall2: '-received_call',
    TimeSpentOnCall2: '-time_spent_on_call',
    FullName2: '-full_name'
} as const;
export type TelephonyViewsNinjaReportTeamExportLeaderboardReportOrderByEnum = typeof TelephonyViewsNinjaReportTeamExportLeaderboardReportOrderByEnum[keyof typeof TelephonyViewsNinjaReportTeamExportLeaderboardReportOrderByEnum];
/**
 * @export
 */
export const TelephonyViewsNinjaReportTeamExportTeamReportPeriodEnum = {
    ThisWeek: 'this_week',
    ThisMonth: 'this_month',
    ThisYear: 'this_year',
    LastThirtyDays: 'last_thirty_days',
    LastNinetyDays: 'last_ninety_days',
    Today: 'today',
    Custom: 'custom'
} as const;
export type TelephonyViewsNinjaReportTeamExportTeamReportPeriodEnum = typeof TelephonyViewsNinjaReportTeamExportTeamReportPeriodEnum[keyof typeof TelephonyViewsNinjaReportTeamExportTeamReportPeriodEnum];
/**
 * @export
 */
export const TelephonyViewsNinjaReportTeamGetCallLogSummaryReportPeriodEnum = {
    ThisWeek: 'this_week',
    ThisMonth: 'this_month',
    ThisYear: 'this_year',
    LastThirtyDays: 'last_thirty_days',
    LastNinetyDays: 'last_ninety_days',
    Today: 'today',
    Custom: 'custom'
} as const;
export type TelephonyViewsNinjaReportTeamGetCallLogSummaryReportPeriodEnum = typeof TelephonyViewsNinjaReportTeamGetCallLogSummaryReportPeriodEnum[keyof typeof TelephonyViewsNinjaReportTeamGetCallLogSummaryReportPeriodEnum];
/**
 * @export
 */
export const TelephonyViewsNinjaReportTeamGetLeaderboardReportPeriodEnum = {
    ThisWeek: 'this_week',
    ThisMonth: 'this_month',
    ThisYear: 'this_year',
    LastThirtyDays: 'last_thirty_days',
    LastNinetyDays: 'last_ninety_days',
    Today: 'today',
    Custom: 'custom'
} as const;
export type TelephonyViewsNinjaReportTeamGetLeaderboardReportPeriodEnum = typeof TelephonyViewsNinjaReportTeamGetLeaderboardReportPeriodEnum[keyof typeof TelephonyViewsNinjaReportTeamGetLeaderboardReportPeriodEnum];
/**
 * @export
 */
export const TelephonyViewsNinjaReportTeamGetLeaderboardReportOrderByEnum = {
    TotalCall: 'total_call',
    DialledCall: 'dialled_call',
    ReceivedCall: 'received_call',
    TimeSpentOnCall: 'time_spent_on_call',
    FullName: 'full_name',
    Role: 'role',
    Role2: '-role',
    TotalCall2: '-total_call',
    DialledCall2: '-dialled_call',
    ReceivedCall2: '-received_call',
    TimeSpentOnCall2: '-time_spent_on_call',
    FullName2: '-full_name'
} as const;
export type TelephonyViewsNinjaReportTeamGetLeaderboardReportOrderByEnum = typeof TelephonyViewsNinjaReportTeamGetLeaderboardReportOrderByEnum[keyof typeof TelephonyViewsNinjaReportTeamGetLeaderboardReportOrderByEnum];
/**
 * @export
 */
export const TelephonyViewsNinjaReportTeamGetTeamReportPeriodEnum = {
    ThisWeek: 'this_week',
    ThisMonth: 'this_month',
    ThisYear: 'this_year',
    LastThirtyDays: 'last_thirty_days',
    LastNinetyDays: 'last_ninety_days',
    Today: 'today',
    Custom: 'custom'
} as const;
export type TelephonyViewsNinjaReportTeamGetTeamReportPeriodEnum = typeof TelephonyViewsNinjaReportTeamGetTeamReportPeriodEnum[keyof typeof TelephonyViewsNinjaReportTeamGetTeamReportPeriodEnum];
/**
 * @export
 */
export const TelephonyViewsNinjaReportTeamGetTeamReportDistributionsPeriodEnum = {
    ThisWeek: 'this_week',
    ThisMonth: 'this_month',
    ThisYear: 'this_year',
    LastThirtyDays: 'last_thirty_days',
    LastNinetyDays: 'last_ninety_days',
    Today: 'today',
    Custom: 'custom'
} as const;
export type TelephonyViewsNinjaReportTeamGetTeamReportDistributionsPeriodEnum = typeof TelephonyViewsNinjaReportTeamGetTeamReportDistributionsPeriodEnum[keyof typeof TelephonyViewsNinjaReportTeamGetTeamReportDistributionsPeriodEnum];


/**
 * RequestAssistanceApi - axios parameter creator
 * @export
 */
export const RequestAssistanceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List Request Assistance
         * @param {number} businessId 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaRequestAssistanceListRequestAssistance: async (businessId: number, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaRequestAssistanceListRequestAssistance', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/addons/request-assistance/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send Request Assistance
         * @param {number} businessId 
         * @param {RequestAssistanceInSchema} requestAssistanceInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaRequestAssistanceSendRequestAssistance: async (businessId: number, requestAssistanceInSchema: RequestAssistanceInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaRequestAssistanceSendRequestAssistance', 'businessId', businessId)
            // verify required parameter 'requestAssistanceInSchema' is not null or undefined
            assertParamExists('addonsViewsNinjaRequestAssistanceSendRequestAssistance', 'requestAssistanceInSchema', requestAssistanceInSchema)
            const localVarPath = `/api/business/{business_id}/addons/request-assistance/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestAssistanceInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RequestAssistanceApi - functional programming interface
 * @export
 */
export const RequestAssistanceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RequestAssistanceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List Request Assistance
         * @param {number} businessId 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaRequestAssistanceListRequestAssistance(businessId: number, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedRequestAssistanceOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaRequestAssistanceListRequestAssistance(businessId, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequestAssistanceApi.addonsViewsNinjaRequestAssistanceListRequestAssistance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send Request Assistance
         * @param {number} businessId 
         * @param {RequestAssistanceInSchema} requestAssistanceInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaRequestAssistanceSendRequestAssistance(businessId: number, requestAssistanceInSchema: RequestAssistanceInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RequestAssistanceMinimalOutSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaRequestAssistanceSendRequestAssistance(businessId, requestAssistanceInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequestAssistanceApi.addonsViewsNinjaRequestAssistanceSendRequestAssistance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RequestAssistanceApi - factory interface
 * @export
 */
export const RequestAssistanceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RequestAssistanceApiFp(configuration)
    return {
        /**
         * 
         * @summary List Request Assistance
         * @param {RequestAssistanceApiAddonsViewsNinjaRequestAssistanceListRequestAssistanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaRequestAssistanceListRequestAssistance(requestParameters: RequestAssistanceApiAddonsViewsNinjaRequestAssistanceListRequestAssistanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedRequestAssistanceOutSchema> {
            return localVarFp.addonsViewsNinjaRequestAssistanceListRequestAssistance(requestParameters.businessId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send Request Assistance
         * @param {RequestAssistanceApiAddonsViewsNinjaRequestAssistanceSendRequestAssistanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaRequestAssistanceSendRequestAssistance(requestParameters: RequestAssistanceApiAddonsViewsNinjaRequestAssistanceSendRequestAssistanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<RequestAssistanceMinimalOutSchema>> {
            return localVarFp.addonsViewsNinjaRequestAssistanceSendRequestAssistance(requestParameters.businessId, requestParameters.requestAssistanceInSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addonsViewsNinjaRequestAssistanceListRequestAssistance operation in RequestAssistanceApi.
 * @export
 * @interface RequestAssistanceApiAddonsViewsNinjaRequestAssistanceListRequestAssistanceRequest
 */
export interface RequestAssistanceApiAddonsViewsNinjaRequestAssistanceListRequestAssistanceRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestAssistanceApiAddonsViewsNinjaRequestAssistanceListRequestAssistance
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof RequestAssistanceApiAddonsViewsNinjaRequestAssistanceListRequestAssistance
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof RequestAssistanceApiAddonsViewsNinjaRequestAssistanceListRequestAssistance
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof RequestAssistanceApiAddonsViewsNinjaRequestAssistanceListRequestAssistance
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for addonsViewsNinjaRequestAssistanceSendRequestAssistance operation in RequestAssistanceApi.
 * @export
 * @interface RequestAssistanceApiAddonsViewsNinjaRequestAssistanceSendRequestAssistanceRequest
 */
export interface RequestAssistanceApiAddonsViewsNinjaRequestAssistanceSendRequestAssistanceRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestAssistanceApiAddonsViewsNinjaRequestAssistanceSendRequestAssistance
     */
    readonly businessId: number

    /**
     * 
     * @type {RequestAssistanceInSchema}
     * @memberof RequestAssistanceApiAddonsViewsNinjaRequestAssistanceSendRequestAssistance
     */
    readonly requestAssistanceInSchema: RequestAssistanceInSchema
}

/**
 * RequestAssistanceApi - object-oriented interface
 * @export
 * @class RequestAssistanceApi
 * @extends {BaseAPI}
 */
export class RequestAssistanceApi extends BaseAPI {
    /**
     * 
     * @summary List Request Assistance
     * @param {RequestAssistanceApiAddonsViewsNinjaRequestAssistanceListRequestAssistanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestAssistanceApi
     */
    public addonsViewsNinjaRequestAssistanceListRequestAssistance(requestParameters: RequestAssistanceApiAddonsViewsNinjaRequestAssistanceListRequestAssistanceRequest, options?: RawAxiosRequestConfig) {
        return RequestAssistanceApiFp(this.configuration).addonsViewsNinjaRequestAssistanceListRequestAssistance(requestParameters.businessId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send Request Assistance
     * @param {RequestAssistanceApiAddonsViewsNinjaRequestAssistanceSendRequestAssistanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestAssistanceApi
     */
    public addonsViewsNinjaRequestAssistanceSendRequestAssistance(requestParameters: RequestAssistanceApiAddonsViewsNinjaRequestAssistanceSendRequestAssistanceRequest, options?: RawAxiosRequestConfig) {
        return RequestAssistanceApiFp(this.configuration).addonsViewsNinjaRequestAssistanceSendRequestAssistance(requestParameters.businessId, requestParameters.requestAssistanceInSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SalesCampaignApi - axios parameter creator
 * @export
 */
export const SalesCampaignApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add Existing Contacts To Campaign
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {Array<string | null>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignAddExistingContactsToCampaign: async (businessId: number, campaignId: number, requestBody: Array<string | null>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignAddExistingContactsToCampaign', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignAddExistingContactsToCampaign', 'campaignId', campaignId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignAddExistingContactsToCampaign', 'requestBody', requestBody)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/{campaign_id}/add-existing-contacts/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add Tags To Campaign
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {AddTagsToCampaignSchema} addTagsToCampaignSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignAddTagsToCampaign: async (businessId: number, campaignId: number, addTagsToCampaignSchema: AddTagsToCampaignSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignAddTagsToCampaign', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignAddTagsToCampaign', 'campaignId', campaignId)
            // verify required parameter 'addTagsToCampaignSchema' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignAddTagsToCampaign', 'addTagsToCampaignSchema', addTagsToCampaignSchema)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/{campaign_id}/tags/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addTagsToCampaignSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Assign Agents To Campaign
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {AssignAgentsToCampaignSchema} assignAgentsToCampaignSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignAssignAgentsToCampaign: async (businessId: number, campaignId: number, assignAgentsToCampaignSchema: AssignAgentsToCampaignSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignAssignAgentsToCampaign', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignAssignAgentsToCampaign', 'campaignId', campaignId)
            // verify required parameter 'assignAgentsToCampaignSchema' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignAssignAgentsToCampaign', 'assignAgentsToCampaignSchema', assignAgentsToCampaignSchema)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/{campaign_id}/assign-agents/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignAgentsToCampaignSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Assign Contacts To Agents
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {AssignContactsToAgentsSchema} assignContactsToAgentsSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignAssignContactsToAgents: async (businessId: number, campaignId: number, assignContactsToAgentsSchema: AssignContactsToAgentsSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignAssignContactsToAgents', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignAssignContactsToAgents', 'campaignId', campaignId)
            // verify required parameter 'assignContactsToAgentsSchema' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignAssignContactsToAgents', 'assignContactsToAgentsSchema', assignContactsToAgentsSchema)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/{campaign_id}/assign-contacts/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignContactsToAgentsSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk Create Contacts For Campaign
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {BulkUploadContactSchema} bulkUploadContactSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignBulkCreateContactsForCampaign: async (businessId: number, campaignId: number, bulkUploadContactSchema: BulkUploadContactSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignBulkCreateContactsForCampaign', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignBulkCreateContactsForCampaign', 'campaignId', campaignId)
            // verify required parameter 'bulkUploadContactSchema' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignBulkCreateContactsForCampaign', 'bulkUploadContactSchema', bulkUploadContactSchema)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/{campaign_id}/contacts/bulk-create/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUploadContactSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change Campaign Status
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {SalesCampaignStatusChangeSchema} salesCampaignStatusChangeSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignChangeCampaignStatus: async (businessId: number, campaignId: number, salesCampaignStatusChangeSchema: SalesCampaignStatusChangeSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignChangeCampaignStatus', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignChangeCampaignStatus', 'campaignId', campaignId)
            // verify required parameter 'salesCampaignStatusChangeSchema' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignChangeCampaignStatus', 'salesCampaignStatusChangeSchema', salesCampaignStatusChangeSchema)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/{campaign_id}/change-status/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(salesCampaignStatusChangeSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Call Log Entry
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {SalesCampaignCallLogInSchema} salesCampaignCallLogInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignCreateCallLogEntry: async (businessId: number, campaignId: number, salesCampaignCallLogInSchema: SalesCampaignCallLogInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignCreateCallLogEntry', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignCreateCallLogEntry', 'campaignId', campaignId)
            // verify required parameter 'salesCampaignCallLogInSchema' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignCreateCallLogEntry', 'salesCampaignCallLogInSchema', salesCampaignCallLogInSchema)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/{campaign_id}/call-log-entry/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(salesCampaignCallLogInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Sales Campaign
         * @param {number} businessId 
         * @param {CampaignInSchema} campaignInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignCreateSalesCampaign: async (businessId: number, campaignInSchema: CampaignInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignCreateSalesCampaign', 'businessId', businessId)
            // verify required parameter 'campaignInSchema' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignCreateSalesCampaign', 'campaignInSchema', campaignInSchema)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Sales Campaigns
         * @param {number} businessId 
         * @param {Array<number | null>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignDeleteSalesCampaigns: async (businessId: number, requestBody: Array<number | null>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignDeleteSalesCampaigns', 'businessId', businessId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignDeleteSalesCampaigns', 'requestBody', requestBody)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit Campaign Call Script
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {number} scriptId 
         * @param {CampaignCallScriptUpdateSchema} campaignCallScriptUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignEditCampaignCallScript: async (businessId: number, campaignId: number, scriptId: number, campaignCallScriptUpdateSchema: CampaignCallScriptUpdateSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignEditCampaignCallScript', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignEditCampaignCallScript', 'campaignId', campaignId)
            // verify required parameter 'scriptId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignEditCampaignCallScript', 'scriptId', scriptId)
            // verify required parameter 'campaignCallScriptUpdateSchema' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignEditCampaignCallScript', 'campaignCallScriptUpdateSchema', campaignCallScriptUpdateSchema)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/{campaign_id}/call-script/{script_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)))
                .replace(`{${"script_id"}}`, encodeURIComponent(String(scriptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignCallScriptUpdateSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Campaign Contacts
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignExportCampaignContacts: async (businessId: number, campaignId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignExportCampaignContacts', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignExportCampaignContacts', 'campaignId', campaignId)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/{campaign_id}/contacts/export/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Campaign List
         * @param {number} businessId 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {Period | null} [period] 
         * @param {number | null} [agentId] 
         * @param {string | null} [name] 
         * @param {CampaignStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignExportCampaignList: async (businessId: number, startDate?: string | null, endDate?: string | null, period?: Period | null, agentId?: number | null, name?: string | null, status?: CampaignStatus | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignExportCampaignList', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/export/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Agent Call Queue In Campaign
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {number} agentId 
         * @param {number} queueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaign: async (businessId: number, campaignId: number, agentId: number, queueId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaign', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaign', 'campaignId', campaignId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaign', 'agentId', agentId)
            // verify required parameter 'queueId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaign', 'queueId', queueId)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/{campaign_id}/agent/{agent_id}/call-queues/{queue_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)))
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"queue_id"}}`, encodeURIComponent(String(queueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Agent Call Queue Items In Campaign
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {number} agentId 
         * @param {number} queueId 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaign: async (businessId: number, campaignId: number, agentId: number, queueId: number, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaign', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaign', 'campaignId', campaignId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaign', 'agentId', agentId)
            // verify required parameter 'queueId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaign', 'queueId', queueId)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/{campaign_id}/agent/{agent_id}/call-queues/{queue_id}/items/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)))
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"queue_id"}}`, encodeURIComponent(String(queueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Agent Rankings
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignGetAgentRankings: async (businessId: number, campaignId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignGetAgentRankings', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignGetAgentRankings', 'campaignId', campaignId)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/{campaign_id}/agent-rankings/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Agent Rankings Across Campaigns
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignGetAgentRankingsAcrossCampaigns: async (businessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignGetAgentRankingsAcrossCampaigns', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/agent-rankings/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Campaigns Summary Report
         * @param {number} businessId 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {Period | null} [period] 
         * @param {number | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignGetCampaignsSummaryReport: async (businessId: number, startDate?: string | null, endDate?: string | null, period?: Period | null, agentId?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignGetCampaignsSummaryReport', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaigns/summary/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Conversion Target Data
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {Period | null} [period] 
         * @param {number | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignGetConversionTargetData: async (businessId: number, campaignId: number, startDate?: string | null, endDate?: string | null, period?: Period | null, agentId?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignGetConversionTargetData', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignGetConversionTargetData', 'campaignId', campaignId)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/{campaign_id}/conversion-target/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Customer Interest Levels
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignGetCustomerInterestLevels: async (businessId: number, campaignId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignGetCustomerInterestLevels', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignGetCustomerInterestLevels', 'campaignId', campaignId)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/{campaign_id}/customer-interest-levels/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Revenue Target Data
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {Period | null} [period] 
         * @param {number | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignGetRevenueTargetData: async (businessId: number, campaignId: number, startDate?: string | null, endDate?: string | null, period?: Period | null, agentId?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignGetRevenueTargetData', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignGetRevenueTargetData', 'campaignId', campaignId)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/{campaign_id}/revenue-target/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Specific Campaign Summary Report
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {Period | null} [period] 
         * @param {number | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignGetSpecificCampaignSummaryReport: async (businessId: number, campaignId: number, startDate?: string | null, endDate?: string | null, period?: Period | null, agentId?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignGetSpecificCampaignSummaryReport', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignGetSpecificCampaignSummaryReport', 'campaignId', campaignId)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/{campaign_id}/summary/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Active Agent Campaigns Minimal
         * @param {number} businessId 
         * @param {number} agentId 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimal: async (businessId: number, agentId: number, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimal', 'businessId', businessId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimal', 'agentId', agentId)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaigns/agent/{agent_id}/minimal/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Agent Call Queues Across Campaigns
         * @param {number} businessId 
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignListAgentCallQueuesAcrossCampaigns: async (businessId: number, agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignListAgentCallQueuesAcrossCampaigns', 'businessId', businessId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignListAgentCallQueuesAcrossCampaigns', 'agentId', agentId)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/agent/{agent_id}/call-queues/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Call Scripts In Campaign
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignListCallScriptsInCampaign: async (businessId: number, campaignId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignListCallScriptsInCampaign', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignListCallScriptsInCampaign', 'campaignId', campaignId)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/{campaign_id}/call-scripts/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Campaign Contacts
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {string | null} [search] 
         * @param {string | null} [tags] 
         * @param {boolean | null} [isPrivate] 
         * @param {string | null} [callType] Filter by call type (e.g., \&#39;is_missed_call\&#39;, \&#39;has_voice_mail\&#39;, etc.)
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignListCampaignContacts: async (businessId: number, campaignId: number, search?: string | null, tags?: string | null, isPrivate?: boolean | null, callType?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignListCampaignContacts', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignListCampaignContacts', 'campaignId', campaignId)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/{campaign_id}/contacts/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (tags !== undefined) {
                localVarQueryParameter['tags'] = tags;
            }

            if (isPrivate !== undefined) {
                localVarQueryParameter['is_private'] = isPrivate;
            }

            if (callType !== undefined) {
                localVarQueryParameter['call_type'] = callType;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Sales Campaigns
         * @param {number} businessId 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {Period | null} [period] 
         * @param {number | null} [agentId] 
         * @param {string | null} [name] 
         * @param {CampaignStatus | null} [status] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignListSalesCampaigns: async (businessId: number, startDate?: string | null, endDate?: string | null, period?: Period | null, agentId?: number | null, name?: string | null, status?: CampaignStatus | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignListSalesCampaigns', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Tags In Campaign
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignListTagsInCampaign: async (businessId: number, campaignId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignListTagsInCampaign', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignListTagsInCampaign', 'campaignId', campaignId)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/{campaign_id}/tags/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove Call Queue Item
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {number} callQueueId 
         * @param {number} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignRemoveCallQueueItem: async (businessId: number, campaignId: number, callQueueId: number, itemId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignRemoveCallQueueItem', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignRemoveCallQueueItem', 'campaignId', campaignId)
            // verify required parameter 'callQueueId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignRemoveCallQueueItem', 'callQueueId', callQueueId)
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignRemoveCallQueueItem', 'itemId', itemId)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/{campaign_id}/call-queue-item/remove/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (callQueueId !== undefined) {
                localVarQueryParameter['call_queue_id'] = callQueueId;
            }

            if (itemId !== undefined) {
                localVarQueryParameter['item_id'] = itemId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove Contacts From Campaign
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {RemoveContactsFromCampaignSchema} removeContactsFromCampaignSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignRemoveContactsFromCampaign: async (businessId: number, campaignId: number, removeContactsFromCampaignSchema: RemoveContactsFromCampaignSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignRemoveContactsFromCampaign', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignRemoveContactsFromCampaign', 'campaignId', campaignId)
            // verify required parameter 'removeContactsFromCampaignSchema' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignRemoveContactsFromCampaign', 'removeContactsFromCampaignSchema', removeContactsFromCampaignSchema)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaigns/{campaign_id}/remove-contacts/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeContactsFromCampaignSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint to replace a business number in a sales campaign.
         * @summary Replace Campaign Business Number
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {ReplaceCampaignBusinessNumberSchema} replaceCampaignBusinessNumberSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignReplaceCampaignBusinessNumber: async (businessId: number, campaignId: number, replaceCampaignBusinessNumberSchema: ReplaceCampaignBusinessNumberSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignReplaceCampaignBusinessNumber', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignReplaceCampaignBusinessNumber', 'campaignId', campaignId)
            // verify required parameter 'replaceCampaignBusinessNumberSchema' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignReplaceCampaignBusinessNumber', 'replaceCampaignBusinessNumberSchema', replaceCampaignBusinessNumberSchema)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/{campaign_id}/replace-business-number/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replaceCampaignBusinessNumberSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve Agent Campaign
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignRetrieveAgentCampaign: async (businessId: number, campaignId: number, agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignRetrieveAgentCampaign', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignRetrieveAgentCampaign', 'campaignId', campaignId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignRetrieveAgentCampaign', 'agentId', agentId)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/{campaign_id}/agent/{agent_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)))
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve Sales Campaign
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignRetrieveSalesCampaign: async (businessId: number, campaignId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignRetrieveSalesCampaign', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignRetrieveSalesCampaign', 'campaignId', campaignId)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/{campaign_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Sales Campaign
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {CampaignUpdateSchema} campaignUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignUpdateSalesCampaign: async (businessId: number, campaignId: number, campaignUpdateSchema: CampaignUpdateSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignUpdateSalesCampaign', 'businessId', businessId)
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignUpdateSalesCampaign', 'campaignId', campaignId)
            // verify required parameter 'campaignUpdateSchema' is not null or undefined
            assertParamExists('addonsViewsNinjaSalesCampaignUpdateSalesCampaign', 'campaignUpdateSchema', campaignUpdateSchema)
            const localVarPath = `/api/business/{business_id}/addons/sales-campaign/{campaign_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignUpdateSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalesCampaignApi - functional programming interface
 * @export
 */
export const SalesCampaignApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalesCampaignApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add Existing Contacts To Campaign
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {Array<string | null>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignAddExistingContactsToCampaign(businessId: number, campaignId: number, requestBody: Array<string | null>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignAddExistingContactsToCampaign(businessId, campaignId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignAddExistingContactsToCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add Tags To Campaign
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {AddTagsToCampaignSchema} addTagsToCampaignSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignAddTagsToCampaign(businessId: number, campaignId: number, addTagsToCampaignSchema: AddTagsToCampaignSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignAddTagsToCampaign(businessId, campaignId, addTagsToCampaignSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignAddTagsToCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Assign Agents To Campaign
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {AssignAgentsToCampaignSchema} assignAgentsToCampaignSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignAssignAgentsToCampaign(businessId: number, campaignId: number, assignAgentsToCampaignSchema: AssignAgentsToCampaignSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignAssignAgentsToCampaign(businessId, campaignId, assignAgentsToCampaignSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignAssignAgentsToCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Assign Contacts To Agents
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {AssignContactsToAgentsSchema} assignContactsToAgentsSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignAssignContactsToAgents(businessId: number, campaignId: number, assignContactsToAgentsSchema: AssignContactsToAgentsSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignAssignContactsToAgents(businessId, campaignId, assignContactsToAgentsSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignAssignContactsToAgents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Bulk Create Contacts For Campaign
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {BulkUploadContactSchema} bulkUploadContactSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignBulkCreateContactsForCampaign(businessId: number, campaignId: number, bulkUploadContactSchema: BulkUploadContactSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignBulkCreateContactsForCampaign(businessId, campaignId, bulkUploadContactSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignBulkCreateContactsForCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Change Campaign Status
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {SalesCampaignStatusChangeSchema} salesCampaignStatusChangeSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignChangeCampaignStatus(businessId: number, campaignId: number, salesCampaignStatusChangeSchema: SalesCampaignStatusChangeSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignChangeCampaignStatus(businessId, campaignId, salesCampaignStatusChangeSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignChangeCampaignStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Call Log Entry
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {SalesCampaignCallLogInSchema} salesCampaignCallLogInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignCreateCallLogEntry(businessId: number, campaignId: number, salesCampaignCallLogInSchema: SalesCampaignCallLogInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignCreateCallLogEntry(businessId, campaignId, salesCampaignCallLogInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignCreateCallLogEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Sales Campaign
         * @param {number} businessId 
         * @param {CampaignInSchema} campaignInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignCreateSalesCampaign(businessId: number, campaignInSchema: CampaignInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignCreateSalesCampaign(businessId, campaignInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignCreateSalesCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Sales Campaigns
         * @param {number} businessId 
         * @param {Array<number | null>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignDeleteSalesCampaigns(businessId: number, requestBody: Array<number | null>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignDeleteSalesCampaigns(businessId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignDeleteSalesCampaigns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Edit Campaign Call Script
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {number} scriptId 
         * @param {CampaignCallScriptUpdateSchema} campaignCallScriptUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignEditCampaignCallScript(businessId: number, campaignId: number, scriptId: number, campaignCallScriptUpdateSchema: CampaignCallScriptUpdateSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignCallScriptOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignEditCampaignCallScript(businessId, campaignId, scriptId, campaignCallScriptUpdateSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignEditCampaignCallScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Campaign Contacts
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignExportCampaignContacts(businessId: number, campaignId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignExportCampaignContacts(businessId, campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignExportCampaignContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Campaign List
         * @param {number} businessId 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {Period | null} [period] 
         * @param {number | null} [agentId] 
         * @param {string | null} [name] 
         * @param {CampaignStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignExportCampaignList(businessId: number, startDate?: string | null, endDate?: string | null, period?: Period | null, agentId?: number | null, name?: string | null, status?: CampaignStatus | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignExportCampaignList(businessId, startDate, endDate, period, agentId, name, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignExportCampaignList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Agent Call Queue In Campaign
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {number} agentId 
         * @param {number} queueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaign(businessId: number, campaignId: number, agentId: number, queueId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallQueueInCampaignOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaign(businessId, campaignId, agentId, queueId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Agent Call Queue Items In Campaign
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {number} agentId 
         * @param {number} queueId 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaign(businessId: number, campaignId: number, agentId: number, queueId: number, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedCallQueueContactOutSchema2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaign(businessId, campaignId, agentId, queueId, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Agent Rankings
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignGetAgentRankings(businessId: number, campaignId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgentRankingOutSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignGetAgentRankings(businessId, campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignGetAgentRankings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Agent Rankings Across Campaigns
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignGetAgentRankingsAcrossCampaigns(businessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgentRankingOutSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignGetAgentRankingsAcrossCampaigns(businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignGetAgentRankingsAcrossCampaigns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Campaigns Summary Report
         * @param {number} businessId 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {Period | null} [period] 
         * @param {number | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignGetCampaignsSummaryReport(businessId: number, startDate?: string | null, endDate?: string | null, period?: Period | null, agentId?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllCampaignsSummaryReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignGetCampaignsSummaryReport(businessId, startDate, endDate, period, agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignGetCampaignsSummaryReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Conversion Target Data
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {Period | null} [period] 
         * @param {number | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignGetConversionTargetData(businessId: number, campaignId: number, startDate?: string | null, endDate?: string | null, period?: Period | null, agentId?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConversionTargetSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignGetConversionTargetData(businessId, campaignId, startDate, endDate, period, agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignGetConversionTargetData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Customer Interest Levels
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignGetCustomerInterestLevels(businessId: number, campaignId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContactInterestLevelSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignGetCustomerInterestLevels(businessId, campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignGetCustomerInterestLevels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Revenue Target Data
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {Period | null} [period] 
         * @param {number | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignGetRevenueTargetData(businessId: number, campaignId: number, startDate?: string | null, endDate?: string | null, period?: Period | null, agentId?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RevenueTargetSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignGetRevenueTargetData(businessId, campaignId, startDate, endDate, period, agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignGetRevenueTargetData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Specific Campaign Summary Report
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {Period | null} [period] 
         * @param {number | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignGetSpecificCampaignSummaryReport(businessId: number, campaignId: number, startDate?: string | null, endDate?: string | null, period?: Period | null, agentId?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllCampaignsSummaryReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignGetSpecificCampaignSummaryReport(businessId, campaignId, startDate, endDate, period, agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignGetSpecificCampaignSummaryReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Active Agent Campaigns Minimal
         * @param {number} businessId 
         * @param {number} agentId 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimal(businessId: number, agentId: number, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedAgentCampaignMinimalSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimal(businessId, agentId, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Agent Call Queues Across Campaigns
         * @param {number} businessId 
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignListAgentCallQueuesAcrossCampaigns(businessId: number, agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CallQueueInCampaignOutSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignListAgentCallQueuesAcrossCampaigns(businessId, agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignListAgentCallQueuesAcrossCampaigns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Call Scripts In Campaign
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignListCallScriptsInCampaign(businessId: number, campaignId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CampaignCallScriptOutSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignListCallScriptsInCampaign(businessId, campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignListCallScriptsInCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Campaign Contacts
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {string | null} [search] 
         * @param {string | null} [tags] 
         * @param {boolean | null} [isPrivate] 
         * @param {string | null} [callType] Filter by call type (e.g., \&#39;is_missed_call\&#39;, \&#39;has_voice_mail\&#39;, etc.)
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignListCampaignContacts(businessId: number, campaignId: number, search?: string | null, tags?: string | null, isPrivate?: boolean | null, callType?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedCampaignContactOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignListCampaignContacts(businessId, campaignId, search, tags, isPrivate, callType, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignListCampaignContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Sales Campaigns
         * @param {number} businessId 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {Period | null} [period] 
         * @param {number | null} [agentId] 
         * @param {string | null} [name] 
         * @param {CampaignStatus | null} [status] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignListSalesCampaigns(businessId: number, startDate?: string | null, endDate?: string | null, period?: Period | null, agentId?: number | null, name?: string | null, status?: CampaignStatus | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedCampaignListSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignListSalesCampaigns(businessId, startDate, endDate, period, agentId, name, status, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignListSalesCampaigns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Tags In Campaign
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignListTagsInCampaign(businessId: number, campaignId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignTagsOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignListTagsInCampaign(businessId, campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignListTagsInCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove Call Queue Item
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {number} callQueueId 
         * @param {number} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignRemoveCallQueueItem(businessId: number, campaignId: number, callQueueId: number, itemId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignRemoveCallQueueItem(businessId, campaignId, callQueueId, itemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignRemoveCallQueueItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove Contacts From Campaign
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {RemoveContactsFromCampaignSchema} removeContactsFromCampaignSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignRemoveContactsFromCampaign(businessId: number, campaignId: number, removeContactsFromCampaignSchema: RemoveContactsFromCampaignSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignRemoveContactsFromCampaign(businessId, campaignId, removeContactsFromCampaignSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignRemoveContactsFromCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API endpoint to replace a business number in a sales campaign.
         * @summary Replace Campaign Business Number
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {ReplaceCampaignBusinessNumberSchema} replaceCampaignBusinessNumberSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignReplaceCampaignBusinessNumber(businessId: number, campaignId: number, replaceCampaignBusinessNumberSchema: ReplaceCampaignBusinessNumberSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignReplaceCampaignBusinessNumber(businessId, campaignId, replaceCampaignBusinessNumberSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignReplaceCampaignBusinessNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve Agent Campaign
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignRetrieveAgentCampaign(businessId: number, campaignId: number, agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignRetrieveAgentCampaign(businessId, campaignId, agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignRetrieveAgentCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve Sales Campaign
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignRetrieveSalesCampaign(businessId: number, campaignId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignRetrieveSalesCampaign(businessId, campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignRetrieveSalesCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Sales Campaign
         * @param {number} businessId 
         * @param {number} campaignId 
         * @param {CampaignUpdateSchema} campaignUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsViewsNinjaSalesCampaignUpdateSalesCampaign(businessId: number, campaignId: number, campaignUpdateSchema: CampaignUpdateSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsViewsNinjaSalesCampaignUpdateSalesCampaign(businessId, campaignId, campaignUpdateSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesCampaignApi.addonsViewsNinjaSalesCampaignUpdateSalesCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SalesCampaignApi - factory interface
 * @export
 */
export const SalesCampaignApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalesCampaignApiFp(configuration)
    return {
        /**
         * 
         * @summary Add Existing Contacts To Campaign
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignAddExistingContactsToCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignAddExistingContactsToCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignAddExistingContactsToCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addonsViewsNinjaSalesCampaignAddExistingContactsToCampaign(requestParameters.businessId, requestParameters.campaignId, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add Tags To Campaign
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignAddTagsToCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignAddTagsToCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignAddTagsToCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.addonsViewsNinjaSalesCampaignAddTagsToCampaign(requestParameters.businessId, requestParameters.campaignId, requestParameters.addTagsToCampaignSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Assign Agents To Campaign
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignAssignAgentsToCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignAssignAgentsToCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignAssignAgentsToCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<CampaignOutSchema> {
            return localVarFp.addonsViewsNinjaSalesCampaignAssignAgentsToCampaign(requestParameters.businessId, requestParameters.campaignId, requestParameters.assignAgentsToCampaignSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Assign Contacts To Agents
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignAssignContactsToAgentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignAssignContactsToAgents(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignAssignContactsToAgentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.addonsViewsNinjaSalesCampaignAssignContactsToAgents(requestParameters.businessId, requestParameters.campaignId, requestParameters.assignContactsToAgentsSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk Create Contacts For Campaign
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignBulkCreateContactsForCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignBulkCreateContactsForCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignBulkCreateContactsForCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.addonsViewsNinjaSalesCampaignBulkCreateContactsForCampaign(requestParameters.businessId, requestParameters.campaignId, requestParameters.bulkUploadContactSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change Campaign Status
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignChangeCampaignStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignChangeCampaignStatus(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignChangeCampaignStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.addonsViewsNinjaSalesCampaignChangeCampaignStatus(requestParameters.businessId, requestParameters.campaignId, requestParameters.salesCampaignStatusChangeSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Call Log Entry
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignCreateCallLogEntryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignCreateCallLogEntry(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignCreateCallLogEntryRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.addonsViewsNinjaSalesCampaignCreateCallLogEntry(requestParameters.businessId, requestParameters.campaignId, requestParameters.salesCampaignCallLogInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Sales Campaign
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignCreateSalesCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignCreateSalesCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignCreateSalesCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<CampaignOutSchema> {
            return localVarFp.addonsViewsNinjaSalesCampaignCreateSalesCampaign(requestParameters.businessId, requestParameters.campaignInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Sales Campaigns
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignDeleteSalesCampaignsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignDeleteSalesCampaigns(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignDeleteSalesCampaignsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addonsViewsNinjaSalesCampaignDeleteSalesCampaigns(requestParameters.businessId, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit Campaign Call Script
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignEditCampaignCallScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignEditCampaignCallScript(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignEditCampaignCallScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<CampaignCallScriptOutSchema> {
            return localVarFp.addonsViewsNinjaSalesCampaignEditCampaignCallScript(requestParameters.businessId, requestParameters.campaignId, requestParameters.scriptId, requestParameters.campaignCallScriptUpdateSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Campaign Contacts
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignExportCampaignContactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignExportCampaignContacts(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignExportCampaignContactsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addonsViewsNinjaSalesCampaignExportCampaignContacts(requestParameters.businessId, requestParameters.campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Campaign List
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignExportCampaignListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignExportCampaignList(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignExportCampaignListRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addonsViewsNinjaSalesCampaignExportCampaignList(requestParameters.businessId, requestParameters.startDate, requestParameters.endDate, requestParameters.period, requestParameters.agentId, requestParameters.name, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Agent Call Queue In Campaign
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<CallQueueInCampaignOutSchema> {
            return localVarFp.addonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaign(requestParameters.businessId, requestParameters.campaignId, requestParameters.agentId, requestParameters.queueId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Agent Call Queue Items In Campaign
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedCallQueueContactOutSchema2> {
            return localVarFp.addonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaign(requestParameters.businessId, requestParameters.campaignId, requestParameters.agentId, requestParameters.queueId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Agent Rankings
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentRankingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignGetAgentRankings(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentRankingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AgentRankingOutSchema>> {
            return localVarFp.addonsViewsNinjaSalesCampaignGetAgentRankings(requestParameters.businessId, requestParameters.campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Agent Rankings Across Campaigns
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentRankingsAcrossCampaignsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignGetAgentRankingsAcrossCampaigns(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentRankingsAcrossCampaignsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AgentRankingOutSchema>> {
            return localVarFp.addonsViewsNinjaSalesCampaignGetAgentRankingsAcrossCampaigns(requestParameters.businessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Campaigns Summary Report
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignGetCampaignsSummaryReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignGetCampaignsSummaryReport(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignGetCampaignsSummaryReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<AllCampaignsSummaryReport> {
            return localVarFp.addonsViewsNinjaSalesCampaignGetCampaignsSummaryReport(requestParameters.businessId, requestParameters.startDate, requestParameters.endDate, requestParameters.period, requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Conversion Target Data
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignGetConversionTargetDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignGetConversionTargetData(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignGetConversionTargetDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ConversionTargetSchema>> {
            return localVarFp.addonsViewsNinjaSalesCampaignGetConversionTargetData(requestParameters.businessId, requestParameters.campaignId, requestParameters.startDate, requestParameters.endDate, requestParameters.period, requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Customer Interest Levels
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignGetCustomerInterestLevelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignGetCustomerInterestLevels(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignGetCustomerInterestLevelsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContactInterestLevelSchema>> {
            return localVarFp.addonsViewsNinjaSalesCampaignGetCustomerInterestLevels(requestParameters.businessId, requestParameters.campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Revenue Target Data
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignGetRevenueTargetDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignGetRevenueTargetData(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignGetRevenueTargetDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<RevenueTargetSchema>> {
            return localVarFp.addonsViewsNinjaSalesCampaignGetRevenueTargetData(requestParameters.businessId, requestParameters.campaignId, requestParameters.startDate, requestParameters.endDate, requestParameters.period, requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Specific Campaign Summary Report
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignGetSpecificCampaignSummaryReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignGetSpecificCampaignSummaryReport(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignGetSpecificCampaignSummaryReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<AllCampaignsSummaryReport> {
            return localVarFp.addonsViewsNinjaSalesCampaignGetSpecificCampaignSummaryReport(requestParameters.businessId, requestParameters.campaignId, requestParameters.startDate, requestParameters.endDate, requestParameters.period, requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Active Agent Campaigns Minimal
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimal(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimalRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedAgentCampaignMinimalSchema> {
            return localVarFp.addonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimal(requestParameters.businessId, requestParameters.agentId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Agent Call Queues Across Campaigns
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignListAgentCallQueuesAcrossCampaignsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignListAgentCallQueuesAcrossCampaigns(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignListAgentCallQueuesAcrossCampaignsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CallQueueInCampaignOutSchema>> {
            return localVarFp.addonsViewsNinjaSalesCampaignListAgentCallQueuesAcrossCampaigns(requestParameters.businessId, requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Call Scripts In Campaign
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignListCallScriptsInCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignListCallScriptsInCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignListCallScriptsInCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CampaignCallScriptOutSchema>> {
            return localVarFp.addonsViewsNinjaSalesCampaignListCallScriptsInCampaign(requestParameters.businessId, requestParameters.campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Campaign Contacts
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignListCampaignContactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignListCampaignContacts(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignListCampaignContactsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedCampaignContactOutSchema> {
            return localVarFp.addonsViewsNinjaSalesCampaignListCampaignContacts(requestParameters.businessId, requestParameters.campaignId, requestParameters.search, requestParameters.tags, requestParameters.isPrivate, requestParameters.callType, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Sales Campaigns
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignListSalesCampaignsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignListSalesCampaigns(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignListSalesCampaignsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedCampaignListSchema> {
            return localVarFp.addonsViewsNinjaSalesCampaignListSalesCampaigns(requestParameters.businessId, requestParameters.startDate, requestParameters.endDate, requestParameters.period, requestParameters.agentId, requestParameters.name, requestParameters.status, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Tags In Campaign
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignListTagsInCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignListTagsInCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignListTagsInCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<CampaignTagsOutSchema> {
            return localVarFp.addonsViewsNinjaSalesCampaignListTagsInCampaign(requestParameters.businessId, requestParameters.campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove Call Queue Item
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignRemoveCallQueueItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignRemoveCallQueueItem(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignRemoveCallQueueItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addonsViewsNinjaSalesCampaignRemoveCallQueueItem(requestParameters.businessId, requestParameters.campaignId, requestParameters.callQueueId, requestParameters.itemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove Contacts From Campaign
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignRemoveContactsFromCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignRemoveContactsFromCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignRemoveContactsFromCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.addonsViewsNinjaSalesCampaignRemoveContactsFromCampaign(requestParameters.businessId, requestParameters.campaignId, requestParameters.removeContactsFromCampaignSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint to replace a business number in a sales campaign.
         * @summary Replace Campaign Business Number
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignReplaceCampaignBusinessNumberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignReplaceCampaignBusinessNumber(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignReplaceCampaignBusinessNumberRequest, options?: RawAxiosRequestConfig): AxiosPromise<CampaignOutSchema> {
            return localVarFp.addonsViewsNinjaSalesCampaignReplaceCampaignBusinessNumber(requestParameters.businessId, requestParameters.campaignId, requestParameters.replaceCampaignBusinessNumberSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve Agent Campaign
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignRetrieveAgentCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignRetrieveAgentCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignRetrieveAgentCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<CampaignOutSchema> {
            return localVarFp.addonsViewsNinjaSalesCampaignRetrieveAgentCampaign(requestParameters.businessId, requestParameters.campaignId, requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve Sales Campaign
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignRetrieveSalesCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignRetrieveSalesCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignRetrieveSalesCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<CampaignOutSchema> {
            return localVarFp.addonsViewsNinjaSalesCampaignRetrieveSalesCampaign(requestParameters.businessId, requestParameters.campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Sales Campaign
         * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignUpdateSalesCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsViewsNinjaSalesCampaignUpdateSalesCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignUpdateSalesCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<CampaignOutSchema> {
            return localVarFp.addonsViewsNinjaSalesCampaignUpdateSalesCampaign(requestParameters.businessId, requestParameters.campaignId, requestParameters.campaignUpdateSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addonsViewsNinjaSalesCampaignAddExistingContactsToCampaign operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignAddExistingContactsToCampaignRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignAddExistingContactsToCampaignRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignAddExistingContactsToCampaign
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignAddExistingContactsToCampaign
     */
    readonly campaignId: number

    /**
     * 
     * @type {Array<string | null>}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignAddExistingContactsToCampaign
     */
    readonly requestBody: Array<string | null>
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignAddTagsToCampaign operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignAddTagsToCampaignRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignAddTagsToCampaignRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignAddTagsToCampaign
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignAddTagsToCampaign
     */
    readonly campaignId: number

    /**
     * 
     * @type {AddTagsToCampaignSchema}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignAddTagsToCampaign
     */
    readonly addTagsToCampaignSchema: AddTagsToCampaignSchema
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignAssignAgentsToCampaign operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignAssignAgentsToCampaignRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignAssignAgentsToCampaignRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignAssignAgentsToCampaign
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignAssignAgentsToCampaign
     */
    readonly campaignId: number

    /**
     * 
     * @type {AssignAgentsToCampaignSchema}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignAssignAgentsToCampaign
     */
    readonly assignAgentsToCampaignSchema: AssignAgentsToCampaignSchema
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignAssignContactsToAgents operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignAssignContactsToAgentsRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignAssignContactsToAgentsRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignAssignContactsToAgents
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignAssignContactsToAgents
     */
    readonly campaignId: number

    /**
     * 
     * @type {AssignContactsToAgentsSchema}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignAssignContactsToAgents
     */
    readonly assignContactsToAgentsSchema: AssignContactsToAgentsSchema
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignBulkCreateContactsForCampaign operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignBulkCreateContactsForCampaignRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignBulkCreateContactsForCampaignRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignBulkCreateContactsForCampaign
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignBulkCreateContactsForCampaign
     */
    readonly campaignId: number

    /**
     * 
     * @type {BulkUploadContactSchema}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignBulkCreateContactsForCampaign
     */
    readonly bulkUploadContactSchema: BulkUploadContactSchema
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignChangeCampaignStatus operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignChangeCampaignStatusRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignChangeCampaignStatusRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignChangeCampaignStatus
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignChangeCampaignStatus
     */
    readonly campaignId: number

    /**
     * 
     * @type {SalesCampaignStatusChangeSchema}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignChangeCampaignStatus
     */
    readonly salesCampaignStatusChangeSchema: SalesCampaignStatusChangeSchema
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignCreateCallLogEntry operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignCreateCallLogEntryRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignCreateCallLogEntryRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignCreateCallLogEntry
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignCreateCallLogEntry
     */
    readonly campaignId: number

    /**
     * 
     * @type {SalesCampaignCallLogInSchema}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignCreateCallLogEntry
     */
    readonly salesCampaignCallLogInSchema: SalesCampaignCallLogInSchema
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignCreateSalesCampaign operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignCreateSalesCampaignRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignCreateSalesCampaignRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignCreateSalesCampaign
     */
    readonly businessId: number

    /**
     * 
     * @type {CampaignInSchema}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignCreateSalesCampaign
     */
    readonly campaignInSchema: CampaignInSchema
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignDeleteSalesCampaigns operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignDeleteSalesCampaignsRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignDeleteSalesCampaignsRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignDeleteSalesCampaigns
     */
    readonly businessId: number

    /**
     * 
     * @type {Array<number | null>}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignDeleteSalesCampaigns
     */
    readonly requestBody: Array<number | null>
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignEditCampaignCallScript operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignEditCampaignCallScriptRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignEditCampaignCallScriptRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignEditCampaignCallScript
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignEditCampaignCallScript
     */
    readonly campaignId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignEditCampaignCallScript
     */
    readonly scriptId: number

    /**
     * 
     * @type {CampaignCallScriptUpdateSchema}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignEditCampaignCallScript
     */
    readonly campaignCallScriptUpdateSchema: CampaignCallScriptUpdateSchema
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignExportCampaignContacts operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignExportCampaignContactsRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignExportCampaignContactsRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignExportCampaignContacts
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignExportCampaignContacts
     */
    readonly campaignId: number
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignExportCampaignList operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignExportCampaignListRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignExportCampaignListRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignExportCampaignList
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignExportCampaignList
     */
    readonly startDate?: string | null

    /**
     * 
     * @type {string}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignExportCampaignList
     */
    readonly endDate?: string | null

    /**
     * 
     * @type {Period}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignExportCampaignList
     */
    readonly period?: Period | null

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignExportCampaignList
     */
    readonly agentId?: number | null

    /**
     * 
     * @type {string}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignExportCampaignList
     */
    readonly name?: string | null

    /**
     * 
     * @type {CampaignStatus}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignExportCampaignList
     */
    readonly status?: CampaignStatus | null
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaign operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaignRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaignRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaign
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaign
     */
    readonly campaignId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaign
     */
    readonly agentId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaign
     */
    readonly queueId: number
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaign operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaignRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaignRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaign
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaign
     */
    readonly campaignId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaign
     */
    readonly agentId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaign
     */
    readonly queueId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaign
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaign
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaign
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignGetAgentRankings operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentRankingsRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentRankingsRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentRankings
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentRankings
     */
    readonly campaignId: number
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignGetAgentRankingsAcrossCampaigns operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentRankingsAcrossCampaignsRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentRankingsAcrossCampaignsRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentRankingsAcrossCampaigns
     */
    readonly businessId: number
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignGetCampaignsSummaryReport operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignGetCampaignsSummaryReportRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignGetCampaignsSummaryReportRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetCampaignsSummaryReport
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetCampaignsSummaryReport
     */
    readonly startDate?: string | null

    /**
     * 
     * @type {string}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetCampaignsSummaryReport
     */
    readonly endDate?: string | null

    /**
     * 
     * @type {Period}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetCampaignsSummaryReport
     */
    readonly period?: Period | null

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetCampaignsSummaryReport
     */
    readonly agentId?: number | null
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignGetConversionTargetData operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignGetConversionTargetDataRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignGetConversionTargetDataRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetConversionTargetData
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetConversionTargetData
     */
    readonly campaignId: number

    /**
     * 
     * @type {string}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetConversionTargetData
     */
    readonly startDate?: string | null

    /**
     * 
     * @type {string}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetConversionTargetData
     */
    readonly endDate?: string | null

    /**
     * 
     * @type {Period}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetConversionTargetData
     */
    readonly period?: Period | null

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetConversionTargetData
     */
    readonly agentId?: number | null
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignGetCustomerInterestLevels operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignGetCustomerInterestLevelsRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignGetCustomerInterestLevelsRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetCustomerInterestLevels
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetCustomerInterestLevels
     */
    readonly campaignId: number
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignGetRevenueTargetData operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignGetRevenueTargetDataRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignGetRevenueTargetDataRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetRevenueTargetData
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetRevenueTargetData
     */
    readonly campaignId: number

    /**
     * 
     * @type {string}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetRevenueTargetData
     */
    readonly startDate?: string | null

    /**
     * 
     * @type {string}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetRevenueTargetData
     */
    readonly endDate?: string | null

    /**
     * 
     * @type {Period}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetRevenueTargetData
     */
    readonly period?: Period | null

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetRevenueTargetData
     */
    readonly agentId?: number | null
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignGetSpecificCampaignSummaryReport operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignGetSpecificCampaignSummaryReportRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignGetSpecificCampaignSummaryReportRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetSpecificCampaignSummaryReport
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetSpecificCampaignSummaryReport
     */
    readonly campaignId: number

    /**
     * 
     * @type {string}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetSpecificCampaignSummaryReport
     */
    readonly startDate?: string | null

    /**
     * 
     * @type {string}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetSpecificCampaignSummaryReport
     */
    readonly endDate?: string | null

    /**
     * 
     * @type {Period}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetSpecificCampaignSummaryReport
     */
    readonly period?: Period | null

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignGetSpecificCampaignSummaryReport
     */
    readonly agentId?: number | null
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimal operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimalRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimalRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimal
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimal
     */
    readonly agentId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimal
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimal
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimal
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignListAgentCallQueuesAcrossCampaigns operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignListAgentCallQueuesAcrossCampaignsRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignListAgentCallQueuesAcrossCampaignsRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListAgentCallQueuesAcrossCampaigns
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListAgentCallQueuesAcrossCampaigns
     */
    readonly agentId: number
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignListCallScriptsInCampaign operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignListCallScriptsInCampaignRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignListCallScriptsInCampaignRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListCallScriptsInCampaign
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListCallScriptsInCampaign
     */
    readonly campaignId: number
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignListCampaignContacts operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignListCampaignContactsRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignListCampaignContactsRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListCampaignContacts
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListCampaignContacts
     */
    readonly campaignId: number

    /**
     * 
     * @type {string}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListCampaignContacts
     */
    readonly search?: string | null

    /**
     * 
     * @type {string}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListCampaignContacts
     */
    readonly tags?: string | null

    /**
     * 
     * @type {boolean}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListCampaignContacts
     */
    readonly isPrivate?: boolean | null

    /**
     * Filter by call type (e.g., \&#39;is_missed_call\&#39;, \&#39;has_voice_mail\&#39;, etc.)
     * @type {string}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListCampaignContacts
     */
    readonly callType?: string | null

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListCampaignContacts
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListCampaignContacts
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListCampaignContacts
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignListSalesCampaigns operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignListSalesCampaignsRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignListSalesCampaignsRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListSalesCampaigns
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListSalesCampaigns
     */
    readonly startDate?: string | null

    /**
     * 
     * @type {string}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListSalesCampaigns
     */
    readonly endDate?: string | null

    /**
     * 
     * @type {Period}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListSalesCampaigns
     */
    readonly period?: Period | null

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListSalesCampaigns
     */
    readonly agentId?: number | null

    /**
     * 
     * @type {string}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListSalesCampaigns
     */
    readonly name?: string | null

    /**
     * 
     * @type {CampaignStatus}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListSalesCampaigns
     */
    readonly status?: CampaignStatus | null

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListSalesCampaigns
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListSalesCampaigns
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListSalesCampaigns
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignListTagsInCampaign operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignListTagsInCampaignRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignListTagsInCampaignRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListTagsInCampaign
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignListTagsInCampaign
     */
    readonly campaignId: number
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignRemoveCallQueueItem operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignRemoveCallQueueItemRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignRemoveCallQueueItemRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignRemoveCallQueueItem
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignRemoveCallQueueItem
     */
    readonly campaignId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignRemoveCallQueueItem
     */
    readonly callQueueId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignRemoveCallQueueItem
     */
    readonly itemId: number
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignRemoveContactsFromCampaign operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignRemoveContactsFromCampaignRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignRemoveContactsFromCampaignRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignRemoveContactsFromCampaign
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignRemoveContactsFromCampaign
     */
    readonly campaignId: number

    /**
     * 
     * @type {RemoveContactsFromCampaignSchema}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignRemoveContactsFromCampaign
     */
    readonly removeContactsFromCampaignSchema: RemoveContactsFromCampaignSchema
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignReplaceCampaignBusinessNumber operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignReplaceCampaignBusinessNumberRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignReplaceCampaignBusinessNumberRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignReplaceCampaignBusinessNumber
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignReplaceCampaignBusinessNumber
     */
    readonly campaignId: number

    /**
     * 
     * @type {ReplaceCampaignBusinessNumberSchema}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignReplaceCampaignBusinessNumber
     */
    readonly replaceCampaignBusinessNumberSchema: ReplaceCampaignBusinessNumberSchema
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignRetrieveAgentCampaign operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignRetrieveAgentCampaignRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignRetrieveAgentCampaignRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignRetrieveAgentCampaign
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignRetrieveAgentCampaign
     */
    readonly campaignId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignRetrieveAgentCampaign
     */
    readonly agentId: number
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignRetrieveSalesCampaign operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignRetrieveSalesCampaignRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignRetrieveSalesCampaignRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignRetrieveSalesCampaign
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignRetrieveSalesCampaign
     */
    readonly campaignId: number
}

/**
 * Request parameters for addonsViewsNinjaSalesCampaignUpdateSalesCampaign operation in SalesCampaignApi.
 * @export
 * @interface SalesCampaignApiAddonsViewsNinjaSalesCampaignUpdateSalesCampaignRequest
 */
export interface SalesCampaignApiAddonsViewsNinjaSalesCampaignUpdateSalesCampaignRequest {
    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignUpdateSalesCampaign
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignUpdateSalesCampaign
     */
    readonly campaignId: number

    /**
     * 
     * @type {CampaignUpdateSchema}
     * @memberof SalesCampaignApiAddonsViewsNinjaSalesCampaignUpdateSalesCampaign
     */
    readonly campaignUpdateSchema: CampaignUpdateSchema
}

/**
 * SalesCampaignApi - object-oriented interface
 * @export
 * @class SalesCampaignApi
 * @extends {BaseAPI}
 */
export class SalesCampaignApi extends BaseAPI {
    /**
     * 
     * @summary Add Existing Contacts To Campaign
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignAddExistingContactsToCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignAddExistingContactsToCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignAddExistingContactsToCampaignRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignAddExistingContactsToCampaign(requestParameters.businessId, requestParameters.campaignId, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add Tags To Campaign
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignAddTagsToCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignAddTagsToCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignAddTagsToCampaignRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignAddTagsToCampaign(requestParameters.businessId, requestParameters.campaignId, requestParameters.addTagsToCampaignSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Assign Agents To Campaign
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignAssignAgentsToCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignAssignAgentsToCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignAssignAgentsToCampaignRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignAssignAgentsToCampaign(requestParameters.businessId, requestParameters.campaignId, requestParameters.assignAgentsToCampaignSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Assign Contacts To Agents
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignAssignContactsToAgentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignAssignContactsToAgents(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignAssignContactsToAgentsRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignAssignContactsToAgents(requestParameters.businessId, requestParameters.campaignId, requestParameters.assignContactsToAgentsSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk Create Contacts For Campaign
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignBulkCreateContactsForCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignBulkCreateContactsForCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignBulkCreateContactsForCampaignRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignBulkCreateContactsForCampaign(requestParameters.businessId, requestParameters.campaignId, requestParameters.bulkUploadContactSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change Campaign Status
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignChangeCampaignStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignChangeCampaignStatus(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignChangeCampaignStatusRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignChangeCampaignStatus(requestParameters.businessId, requestParameters.campaignId, requestParameters.salesCampaignStatusChangeSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Call Log Entry
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignCreateCallLogEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignCreateCallLogEntry(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignCreateCallLogEntryRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignCreateCallLogEntry(requestParameters.businessId, requestParameters.campaignId, requestParameters.salesCampaignCallLogInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Sales Campaign
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignCreateSalesCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignCreateSalesCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignCreateSalesCampaignRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignCreateSalesCampaign(requestParameters.businessId, requestParameters.campaignInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Sales Campaigns
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignDeleteSalesCampaignsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignDeleteSalesCampaigns(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignDeleteSalesCampaignsRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignDeleteSalesCampaigns(requestParameters.businessId, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit Campaign Call Script
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignEditCampaignCallScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignEditCampaignCallScript(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignEditCampaignCallScriptRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignEditCampaignCallScript(requestParameters.businessId, requestParameters.campaignId, requestParameters.scriptId, requestParameters.campaignCallScriptUpdateSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Campaign Contacts
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignExportCampaignContactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignExportCampaignContacts(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignExportCampaignContactsRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignExportCampaignContacts(requestParameters.businessId, requestParameters.campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Campaign List
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignExportCampaignListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignExportCampaignList(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignExportCampaignListRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignExportCampaignList(requestParameters.businessId, requestParameters.startDate, requestParameters.endDate, requestParameters.period, requestParameters.agentId, requestParameters.name, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Agent Call Queue In Campaign
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaignRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignGetAgentCallQueueInCampaign(requestParameters.businessId, requestParameters.campaignId, requestParameters.agentId, requestParameters.queueId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Agent Call Queue Items In Campaign
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaignRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignGetAgentCallQueueItemsInCampaign(requestParameters.businessId, requestParameters.campaignId, requestParameters.agentId, requestParameters.queueId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Agent Rankings
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentRankingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignGetAgentRankings(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentRankingsRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignGetAgentRankings(requestParameters.businessId, requestParameters.campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Agent Rankings Across Campaigns
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentRankingsAcrossCampaignsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignGetAgentRankingsAcrossCampaigns(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignGetAgentRankingsAcrossCampaignsRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignGetAgentRankingsAcrossCampaigns(requestParameters.businessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Campaigns Summary Report
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignGetCampaignsSummaryReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignGetCampaignsSummaryReport(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignGetCampaignsSummaryReportRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignGetCampaignsSummaryReport(requestParameters.businessId, requestParameters.startDate, requestParameters.endDate, requestParameters.period, requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Conversion Target Data
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignGetConversionTargetDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignGetConversionTargetData(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignGetConversionTargetDataRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignGetConversionTargetData(requestParameters.businessId, requestParameters.campaignId, requestParameters.startDate, requestParameters.endDate, requestParameters.period, requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Customer Interest Levels
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignGetCustomerInterestLevelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignGetCustomerInterestLevels(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignGetCustomerInterestLevelsRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignGetCustomerInterestLevels(requestParameters.businessId, requestParameters.campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Revenue Target Data
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignGetRevenueTargetDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignGetRevenueTargetData(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignGetRevenueTargetDataRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignGetRevenueTargetData(requestParameters.businessId, requestParameters.campaignId, requestParameters.startDate, requestParameters.endDate, requestParameters.period, requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Specific Campaign Summary Report
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignGetSpecificCampaignSummaryReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignGetSpecificCampaignSummaryReport(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignGetSpecificCampaignSummaryReportRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignGetSpecificCampaignSummaryReport(requestParameters.businessId, requestParameters.campaignId, requestParameters.startDate, requestParameters.endDate, requestParameters.period, requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Active Agent Campaigns Minimal
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimal(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimalRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignListActiveAgentCampaignsMinimal(requestParameters.businessId, requestParameters.agentId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Agent Call Queues Across Campaigns
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignListAgentCallQueuesAcrossCampaignsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignListAgentCallQueuesAcrossCampaigns(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignListAgentCallQueuesAcrossCampaignsRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignListAgentCallQueuesAcrossCampaigns(requestParameters.businessId, requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Call Scripts In Campaign
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignListCallScriptsInCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignListCallScriptsInCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignListCallScriptsInCampaignRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignListCallScriptsInCampaign(requestParameters.businessId, requestParameters.campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Campaign Contacts
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignListCampaignContactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignListCampaignContacts(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignListCampaignContactsRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignListCampaignContacts(requestParameters.businessId, requestParameters.campaignId, requestParameters.search, requestParameters.tags, requestParameters.isPrivate, requestParameters.callType, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Sales Campaigns
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignListSalesCampaignsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignListSalesCampaigns(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignListSalesCampaignsRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignListSalesCampaigns(requestParameters.businessId, requestParameters.startDate, requestParameters.endDate, requestParameters.period, requestParameters.agentId, requestParameters.name, requestParameters.status, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Tags In Campaign
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignListTagsInCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignListTagsInCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignListTagsInCampaignRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignListTagsInCampaign(requestParameters.businessId, requestParameters.campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove Call Queue Item
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignRemoveCallQueueItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignRemoveCallQueueItem(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignRemoveCallQueueItemRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignRemoveCallQueueItem(requestParameters.businessId, requestParameters.campaignId, requestParameters.callQueueId, requestParameters.itemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove Contacts From Campaign
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignRemoveContactsFromCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignRemoveContactsFromCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignRemoveContactsFromCampaignRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignRemoveContactsFromCampaign(requestParameters.businessId, requestParameters.campaignId, requestParameters.removeContactsFromCampaignSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint to replace a business number in a sales campaign.
     * @summary Replace Campaign Business Number
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignReplaceCampaignBusinessNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignReplaceCampaignBusinessNumber(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignReplaceCampaignBusinessNumberRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignReplaceCampaignBusinessNumber(requestParameters.businessId, requestParameters.campaignId, requestParameters.replaceCampaignBusinessNumberSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve Agent Campaign
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignRetrieveAgentCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignRetrieveAgentCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignRetrieveAgentCampaignRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignRetrieveAgentCampaign(requestParameters.businessId, requestParameters.campaignId, requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve Sales Campaign
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignRetrieveSalesCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignRetrieveSalesCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignRetrieveSalesCampaignRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignRetrieveSalesCampaign(requestParameters.businessId, requestParameters.campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Sales Campaign
     * @param {SalesCampaignApiAddonsViewsNinjaSalesCampaignUpdateSalesCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesCampaignApi
     */
    public addonsViewsNinjaSalesCampaignUpdateSalesCampaign(requestParameters: SalesCampaignApiAddonsViewsNinjaSalesCampaignUpdateSalesCampaignRequest, options?: RawAxiosRequestConfig) {
        return SalesCampaignApiFp(this.configuration).addonsViewsNinjaSalesCampaignUpdateSalesCampaign(requestParameters.businessId, requestParameters.campaignId, requestParameters.campaignUpdateSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SubscriptionApi - axios parameter creator
 * @export
 */
export const SubscriptionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Authorize Card
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaSubscriptionAuthorizeCard: async (businessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('paymentsViewsNinjaSubscriptionAuthorizeCard', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/authorize-card/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel Business Subscription
         * @param {number} businessId 
         * @param {CancelSubscriptionInSchema} cancelSubscriptionInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaSubscriptionCancelBusinessSubscription: async (businessId: number, cancelSubscriptionInSchema: CancelSubscriptionInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('paymentsViewsNinjaSubscriptionCancelBusinessSubscription', 'businessId', businessId)
            // verify required parameter 'cancelSubscriptionInSchema' is not null or undefined
            assertParamExists('paymentsViewsNinjaSubscriptionCancelBusinessSubscription', 'cancelSubscriptionInSchema', cancelSubscriptionInSchema)
            const localVarPath = `/api/business/{business_id}/subscription/cancel/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelSubscriptionInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Clear Pending Invoice
         * @param {number} businessId 
         * @param {SubscriptionBillingInSchema} [subscriptionBillingInSchema] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaSubscriptionClearPendingInvoice: async (businessId: number, subscriptionBillingInSchema?: SubscriptionBillingInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('paymentsViewsNinjaSubscriptionClearPendingInvoice', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/invoice/clear-pending/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionBillingInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Business Credit Card
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaSubscriptionGetBusinessCreditCard: async (businessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('paymentsViewsNinjaSubscriptionGetBusinessCreditCard', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/card/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Business Subscription
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaSubscriptionGetBusinessSubscription: async (businessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('paymentsViewsNinjaSubscriptionGetBusinessSubscription', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/subscription/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Card Failure Reason
         * @param {number} businessId 
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaSubscriptionGetCardFailureReason: async (businessId: number, cardId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('paymentsViewsNinjaSubscriptionGetCardFailureReason', 'businessId', businessId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('paymentsViewsNinjaSubscriptionGetCardFailureReason', 'cardId', cardId)
            const localVarPath = `/api/business/{business_id}/card/{card_id}/failure-reason/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"card_id"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Invoice
         * @param {number} businessId 
         * @param {boolean} [paid] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaSubscriptionGetInvoice: async (businessId: number, paid?: boolean, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('paymentsViewsNinjaSubscriptionGetInvoice', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/invoice/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (paid !== undefined) {
                localVarQueryParameter['paid'] = paid;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Subscription Status
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaSubscriptionGetSubscriptionStatus: async (businessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('paymentsViewsNinjaSubscriptionGetSubscriptionStatus', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/subscription/status/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pause Business Subscription
         * @param {number} businessId 
         * @param {SubscriptionBillingInSchema} subscriptionBillingInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaSubscriptionPauseBusinessSubscription: async (businessId: number, subscriptionBillingInSchema: SubscriptionBillingInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('paymentsViewsNinjaSubscriptionPauseBusinessSubscription', 'businessId', businessId)
            // verify required parameter 'subscriptionBillingInSchema' is not null or undefined
            assertParamExists('paymentsViewsNinjaSubscriptionPauseBusinessSubscription', 'subscriptionBillingInSchema', subscriptionBillingInSchema)
            const localVarPath = `/api/business/{business_id}/subscription/pause/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionBillingInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reactivate Business Subscription
         * @param {number} businessId 
         * @param {ReActivateSubscriptionInSchema} reActivateSubscriptionInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaSubscriptionReactivateBusinessSubscription: async (businessId: number, reActivateSubscriptionInSchema: ReActivateSubscriptionInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('paymentsViewsNinjaSubscriptionReactivateBusinessSubscription', 'businessId', businessId)
            // verify required parameter 'reActivateSubscriptionInSchema' is not null or undefined
            assertParamExists('paymentsViewsNinjaSubscriptionReactivateBusinessSubscription', 'reActivateSubscriptionInSchema', reActivateSubscriptionInSchema)
            const localVarPath = `/api/business/{business_id}/subscription/reactivate/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reActivateSubscriptionInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resume Business Subscription
         * @param {number} businessId 
         * @param {SubscriptionBillingInSchema} subscriptionBillingInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaSubscriptionResumeBusinessSubscription: async (businessId: number, subscriptionBillingInSchema: SubscriptionBillingInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('paymentsViewsNinjaSubscriptionResumeBusinessSubscription', 'businessId', businessId)
            // verify required parameter 'subscriptionBillingInSchema' is not null or undefined
            assertParamExists('paymentsViewsNinjaSubscriptionResumeBusinessSubscription', 'subscriptionBillingInSchema', subscriptionBillingInSchema)
            const localVarPath = `/api/business/{business_id}/subscription/resume/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionBillingInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Business Subscription
         * @param {number} businessId 
         * @param {UpdateSubscriptionInSchema} updateSubscriptionInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaSubscriptionUpdateBusinessSubscription: async (businessId: number, updateSubscriptionInSchema: UpdateSubscriptionInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('paymentsViewsNinjaSubscriptionUpdateBusinessSubscription', 'businessId', businessId)
            // verify required parameter 'updateSubscriptionInSchema' is not null or undefined
            assertParamExists('paymentsViewsNinjaSubscriptionUpdateBusinessSubscription', 'updateSubscriptionInSchema', updateSubscriptionInSchema)
            const localVarPath = `/api/business/{business_id}/subscription/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSubscriptionInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubscriptionApi - functional programming interface
 * @export
 */
export const SubscriptionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubscriptionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Authorize Card
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaSubscriptionAuthorizeCard(businessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePaymentPageOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaSubscriptionAuthorizeCard(businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.paymentsViewsNinjaSubscriptionAuthorizeCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cancel Business Subscription
         * @param {number} businessId 
         * @param {CancelSubscriptionInSchema} cancelSubscriptionInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaSubscriptionCancelBusinessSubscription(businessId: number, cancelSubscriptionInSchema: CancelSubscriptionInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaSubscriptionCancelBusinessSubscription(businessId, cancelSubscriptionInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.paymentsViewsNinjaSubscriptionCancelBusinessSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Clear Pending Invoice
         * @param {number} businessId 
         * @param {SubscriptionBillingInSchema} [subscriptionBillingInSchema] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaSubscriptionClearPendingInvoice(businessId: number, subscriptionBillingInSchema?: SubscriptionBillingInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSubscriptionBillingOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaSubscriptionClearPendingInvoice(businessId, subscriptionBillingInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.paymentsViewsNinjaSubscriptionClearPendingInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Business Credit Card
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaSubscriptionGetBusinessCreditCard(businessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCreditCardOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaSubscriptionGetBusinessCreditCard(businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.paymentsViewsNinjaSubscriptionGetBusinessCreditCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Business Subscription
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaSubscriptionGetBusinessSubscription(businessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseBusinessSubscriptionOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaSubscriptionGetBusinessSubscription(businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.paymentsViewsNinjaSubscriptionGetBusinessSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Card Failure Reason
         * @param {number} businessId 
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaSubscriptionGetCardFailureReason(businessId: number, cardId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChargeAuthorizationLogOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaSubscriptionGetCardFailureReason(businessId, cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.paymentsViewsNinjaSubscriptionGetCardFailureReason']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Invoice
         * @param {number} businessId 
         * @param {boolean} [paid] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaSubscriptionGetInvoice(businessId: number, paid?: boolean, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedInvoiceOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaSubscriptionGetInvoice(businessId, paid, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.paymentsViewsNinjaSubscriptionGetInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Subscription Status
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaSubscriptionGetSubscriptionStatus(businessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaSubscriptionGetSubscriptionStatus(businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.paymentsViewsNinjaSubscriptionGetSubscriptionStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Pause Business Subscription
         * @param {number} businessId 
         * @param {SubscriptionBillingInSchema} subscriptionBillingInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaSubscriptionPauseBusinessSubscription(businessId: number, subscriptionBillingInSchema: SubscriptionBillingInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSubscriptionBillingOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaSubscriptionPauseBusinessSubscription(businessId, subscriptionBillingInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.paymentsViewsNinjaSubscriptionPauseBusinessSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reactivate Business Subscription
         * @param {number} businessId 
         * @param {ReActivateSubscriptionInSchema} reActivateSubscriptionInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaSubscriptionReactivateBusinessSubscription(businessId: number, reActivateSubscriptionInSchema: ReActivateSubscriptionInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSubscriptionBillingOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaSubscriptionReactivateBusinessSubscription(businessId, reActivateSubscriptionInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.paymentsViewsNinjaSubscriptionReactivateBusinessSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resume Business Subscription
         * @param {number} businessId 
         * @param {SubscriptionBillingInSchema} subscriptionBillingInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaSubscriptionResumeBusinessSubscription(businessId: number, subscriptionBillingInSchema: SubscriptionBillingInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSubscriptionBillingOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaSubscriptionResumeBusinessSubscription(businessId, subscriptionBillingInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.paymentsViewsNinjaSubscriptionResumeBusinessSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Business Subscription
         * @param {number} businessId 
         * @param {UpdateSubscriptionInSchema} updateSubscriptionInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaSubscriptionUpdateBusinessSubscription(businessId: number, updateSubscriptionInSchema: UpdateSubscriptionInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSubscriptionBillingOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaSubscriptionUpdateBusinessSubscription(businessId, updateSubscriptionInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.paymentsViewsNinjaSubscriptionUpdateBusinessSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SubscriptionApi - factory interface
 * @export
 */
export const SubscriptionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubscriptionApiFp(configuration)
    return {
        /**
         * 
         * @summary Authorize Card
         * @param {SubscriptionApiPaymentsViewsNinjaSubscriptionAuthorizeCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaSubscriptionAuthorizeCard(requestParameters: SubscriptionApiPaymentsViewsNinjaSubscriptionAuthorizeCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponsePaymentPageOutSchema> {
            return localVarFp.paymentsViewsNinjaSubscriptionAuthorizeCard(requestParameters.businessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel Business Subscription
         * @param {SubscriptionApiPaymentsViewsNinjaSubscriptionCancelBusinessSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaSubscriptionCancelBusinessSubscription(requestParameters: SubscriptionApiPaymentsViewsNinjaSubscriptionCancelBusinessSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.paymentsViewsNinjaSubscriptionCancelBusinessSubscription(requestParameters.businessId, requestParameters.cancelSubscriptionInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Clear Pending Invoice
         * @param {SubscriptionApiPaymentsViewsNinjaSubscriptionClearPendingInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaSubscriptionClearPendingInvoice(requestParameters: SubscriptionApiPaymentsViewsNinjaSubscriptionClearPendingInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseSubscriptionBillingOutSchema> {
            return localVarFp.paymentsViewsNinjaSubscriptionClearPendingInvoice(requestParameters.businessId, requestParameters.subscriptionBillingInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Business Credit Card
         * @param {SubscriptionApiPaymentsViewsNinjaSubscriptionGetBusinessCreditCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaSubscriptionGetBusinessCreditCard(requestParameters: SubscriptionApiPaymentsViewsNinjaSubscriptionGetBusinessCreditCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCreditCardOutSchema> {
            return localVarFp.paymentsViewsNinjaSubscriptionGetBusinessCreditCard(requestParameters.businessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Business Subscription
         * @param {SubscriptionApiPaymentsViewsNinjaSubscriptionGetBusinessSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaSubscriptionGetBusinessSubscription(requestParameters: SubscriptionApiPaymentsViewsNinjaSubscriptionGetBusinessSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseBusinessSubscriptionOutSchema> {
            return localVarFp.paymentsViewsNinjaSubscriptionGetBusinessSubscription(requestParameters.businessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Card Failure Reason
         * @param {SubscriptionApiPaymentsViewsNinjaSubscriptionGetCardFailureReasonRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaSubscriptionGetCardFailureReason(requestParameters: SubscriptionApiPaymentsViewsNinjaSubscriptionGetCardFailureReasonRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChargeAuthorizationLogOutSchema> {
            return localVarFp.paymentsViewsNinjaSubscriptionGetCardFailureReason(requestParameters.businessId, requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Invoice
         * @param {SubscriptionApiPaymentsViewsNinjaSubscriptionGetInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaSubscriptionGetInvoice(requestParameters: SubscriptionApiPaymentsViewsNinjaSubscriptionGetInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedInvoiceOutSchema> {
            return localVarFp.paymentsViewsNinjaSubscriptionGetInvoice(requestParameters.businessId, requestParameters.paid, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Subscription Status
         * @param {SubscriptionApiPaymentsViewsNinjaSubscriptionGetSubscriptionStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaSubscriptionGetSubscriptionStatus(requestParameters: SubscriptionApiPaymentsViewsNinjaSubscriptionGetSubscriptionStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.paymentsViewsNinjaSubscriptionGetSubscriptionStatus(requestParameters.businessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Pause Business Subscription
         * @param {SubscriptionApiPaymentsViewsNinjaSubscriptionPauseBusinessSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaSubscriptionPauseBusinessSubscription(requestParameters: SubscriptionApiPaymentsViewsNinjaSubscriptionPauseBusinessSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseSubscriptionBillingOutSchema> {
            return localVarFp.paymentsViewsNinjaSubscriptionPauseBusinessSubscription(requestParameters.businessId, requestParameters.subscriptionBillingInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reactivate Business Subscription
         * @param {SubscriptionApiPaymentsViewsNinjaSubscriptionReactivateBusinessSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaSubscriptionReactivateBusinessSubscription(requestParameters: SubscriptionApiPaymentsViewsNinjaSubscriptionReactivateBusinessSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseSubscriptionBillingOutSchema> {
            return localVarFp.paymentsViewsNinjaSubscriptionReactivateBusinessSubscription(requestParameters.businessId, requestParameters.reActivateSubscriptionInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resume Business Subscription
         * @param {SubscriptionApiPaymentsViewsNinjaSubscriptionResumeBusinessSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaSubscriptionResumeBusinessSubscription(requestParameters: SubscriptionApiPaymentsViewsNinjaSubscriptionResumeBusinessSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseSubscriptionBillingOutSchema> {
            return localVarFp.paymentsViewsNinjaSubscriptionResumeBusinessSubscription(requestParameters.businessId, requestParameters.subscriptionBillingInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Business Subscription
         * @param {SubscriptionApiPaymentsViewsNinjaSubscriptionUpdateBusinessSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaSubscriptionUpdateBusinessSubscription(requestParameters: SubscriptionApiPaymentsViewsNinjaSubscriptionUpdateBusinessSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseSubscriptionBillingOutSchema> {
            return localVarFp.paymentsViewsNinjaSubscriptionUpdateBusinessSubscription(requestParameters.businessId, requestParameters.updateSubscriptionInSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for paymentsViewsNinjaSubscriptionAuthorizeCard operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiPaymentsViewsNinjaSubscriptionAuthorizeCardRequest
 */
export interface SubscriptionApiPaymentsViewsNinjaSubscriptionAuthorizeCardRequest {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionApiPaymentsViewsNinjaSubscriptionAuthorizeCard
     */
    readonly businessId: number
}

/**
 * Request parameters for paymentsViewsNinjaSubscriptionCancelBusinessSubscription operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiPaymentsViewsNinjaSubscriptionCancelBusinessSubscriptionRequest
 */
export interface SubscriptionApiPaymentsViewsNinjaSubscriptionCancelBusinessSubscriptionRequest {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionApiPaymentsViewsNinjaSubscriptionCancelBusinessSubscription
     */
    readonly businessId: number

    /**
     * 
     * @type {CancelSubscriptionInSchema}
     * @memberof SubscriptionApiPaymentsViewsNinjaSubscriptionCancelBusinessSubscription
     */
    readonly cancelSubscriptionInSchema: CancelSubscriptionInSchema
}

/**
 * Request parameters for paymentsViewsNinjaSubscriptionClearPendingInvoice operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiPaymentsViewsNinjaSubscriptionClearPendingInvoiceRequest
 */
export interface SubscriptionApiPaymentsViewsNinjaSubscriptionClearPendingInvoiceRequest {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionApiPaymentsViewsNinjaSubscriptionClearPendingInvoice
     */
    readonly businessId: number

    /**
     * 
     * @type {SubscriptionBillingInSchema}
     * @memberof SubscriptionApiPaymentsViewsNinjaSubscriptionClearPendingInvoice
     */
    readonly subscriptionBillingInSchema?: SubscriptionBillingInSchema
}

/**
 * Request parameters for paymentsViewsNinjaSubscriptionGetBusinessCreditCard operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiPaymentsViewsNinjaSubscriptionGetBusinessCreditCardRequest
 */
export interface SubscriptionApiPaymentsViewsNinjaSubscriptionGetBusinessCreditCardRequest {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionApiPaymentsViewsNinjaSubscriptionGetBusinessCreditCard
     */
    readonly businessId: number
}

/**
 * Request parameters for paymentsViewsNinjaSubscriptionGetBusinessSubscription operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiPaymentsViewsNinjaSubscriptionGetBusinessSubscriptionRequest
 */
export interface SubscriptionApiPaymentsViewsNinjaSubscriptionGetBusinessSubscriptionRequest {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionApiPaymentsViewsNinjaSubscriptionGetBusinessSubscription
     */
    readonly businessId: number
}

/**
 * Request parameters for paymentsViewsNinjaSubscriptionGetCardFailureReason operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiPaymentsViewsNinjaSubscriptionGetCardFailureReasonRequest
 */
export interface SubscriptionApiPaymentsViewsNinjaSubscriptionGetCardFailureReasonRequest {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionApiPaymentsViewsNinjaSubscriptionGetCardFailureReason
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof SubscriptionApiPaymentsViewsNinjaSubscriptionGetCardFailureReason
     */
    readonly cardId: number
}

/**
 * Request parameters for paymentsViewsNinjaSubscriptionGetInvoice operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiPaymentsViewsNinjaSubscriptionGetInvoiceRequest
 */
export interface SubscriptionApiPaymentsViewsNinjaSubscriptionGetInvoiceRequest {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionApiPaymentsViewsNinjaSubscriptionGetInvoice
     */
    readonly businessId: number

    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionApiPaymentsViewsNinjaSubscriptionGetInvoice
     */
    readonly paid?: boolean

    /**
     * 
     * @type {number}
     * @memberof SubscriptionApiPaymentsViewsNinjaSubscriptionGetInvoice
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof SubscriptionApiPaymentsViewsNinjaSubscriptionGetInvoice
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof SubscriptionApiPaymentsViewsNinjaSubscriptionGetInvoice
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for paymentsViewsNinjaSubscriptionGetSubscriptionStatus operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiPaymentsViewsNinjaSubscriptionGetSubscriptionStatusRequest
 */
export interface SubscriptionApiPaymentsViewsNinjaSubscriptionGetSubscriptionStatusRequest {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionApiPaymentsViewsNinjaSubscriptionGetSubscriptionStatus
     */
    readonly businessId: number
}

/**
 * Request parameters for paymentsViewsNinjaSubscriptionPauseBusinessSubscription operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiPaymentsViewsNinjaSubscriptionPauseBusinessSubscriptionRequest
 */
export interface SubscriptionApiPaymentsViewsNinjaSubscriptionPauseBusinessSubscriptionRequest {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionApiPaymentsViewsNinjaSubscriptionPauseBusinessSubscription
     */
    readonly businessId: number

    /**
     * 
     * @type {SubscriptionBillingInSchema}
     * @memberof SubscriptionApiPaymentsViewsNinjaSubscriptionPauseBusinessSubscription
     */
    readonly subscriptionBillingInSchema: SubscriptionBillingInSchema
}

/**
 * Request parameters for paymentsViewsNinjaSubscriptionReactivateBusinessSubscription operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiPaymentsViewsNinjaSubscriptionReactivateBusinessSubscriptionRequest
 */
export interface SubscriptionApiPaymentsViewsNinjaSubscriptionReactivateBusinessSubscriptionRequest {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionApiPaymentsViewsNinjaSubscriptionReactivateBusinessSubscription
     */
    readonly businessId: number

    /**
     * 
     * @type {ReActivateSubscriptionInSchema}
     * @memberof SubscriptionApiPaymentsViewsNinjaSubscriptionReactivateBusinessSubscription
     */
    readonly reActivateSubscriptionInSchema: ReActivateSubscriptionInSchema
}

/**
 * Request parameters for paymentsViewsNinjaSubscriptionResumeBusinessSubscription operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiPaymentsViewsNinjaSubscriptionResumeBusinessSubscriptionRequest
 */
export interface SubscriptionApiPaymentsViewsNinjaSubscriptionResumeBusinessSubscriptionRequest {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionApiPaymentsViewsNinjaSubscriptionResumeBusinessSubscription
     */
    readonly businessId: number

    /**
     * 
     * @type {SubscriptionBillingInSchema}
     * @memberof SubscriptionApiPaymentsViewsNinjaSubscriptionResumeBusinessSubscription
     */
    readonly subscriptionBillingInSchema: SubscriptionBillingInSchema
}

/**
 * Request parameters for paymentsViewsNinjaSubscriptionUpdateBusinessSubscription operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiPaymentsViewsNinjaSubscriptionUpdateBusinessSubscriptionRequest
 */
export interface SubscriptionApiPaymentsViewsNinjaSubscriptionUpdateBusinessSubscriptionRequest {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionApiPaymentsViewsNinjaSubscriptionUpdateBusinessSubscription
     */
    readonly businessId: number

    /**
     * 
     * @type {UpdateSubscriptionInSchema}
     * @memberof SubscriptionApiPaymentsViewsNinjaSubscriptionUpdateBusinessSubscription
     */
    readonly updateSubscriptionInSchema: UpdateSubscriptionInSchema
}

/**
 * SubscriptionApi - object-oriented interface
 * @export
 * @class SubscriptionApi
 * @extends {BaseAPI}
 */
export class SubscriptionApi extends BaseAPI {
    /**
     * 
     * @summary Authorize Card
     * @param {SubscriptionApiPaymentsViewsNinjaSubscriptionAuthorizeCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public paymentsViewsNinjaSubscriptionAuthorizeCard(requestParameters: SubscriptionApiPaymentsViewsNinjaSubscriptionAuthorizeCardRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).paymentsViewsNinjaSubscriptionAuthorizeCard(requestParameters.businessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel Business Subscription
     * @param {SubscriptionApiPaymentsViewsNinjaSubscriptionCancelBusinessSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public paymentsViewsNinjaSubscriptionCancelBusinessSubscription(requestParameters: SubscriptionApiPaymentsViewsNinjaSubscriptionCancelBusinessSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).paymentsViewsNinjaSubscriptionCancelBusinessSubscription(requestParameters.businessId, requestParameters.cancelSubscriptionInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Clear Pending Invoice
     * @param {SubscriptionApiPaymentsViewsNinjaSubscriptionClearPendingInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public paymentsViewsNinjaSubscriptionClearPendingInvoice(requestParameters: SubscriptionApiPaymentsViewsNinjaSubscriptionClearPendingInvoiceRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).paymentsViewsNinjaSubscriptionClearPendingInvoice(requestParameters.businessId, requestParameters.subscriptionBillingInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Business Credit Card
     * @param {SubscriptionApiPaymentsViewsNinjaSubscriptionGetBusinessCreditCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public paymentsViewsNinjaSubscriptionGetBusinessCreditCard(requestParameters: SubscriptionApiPaymentsViewsNinjaSubscriptionGetBusinessCreditCardRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).paymentsViewsNinjaSubscriptionGetBusinessCreditCard(requestParameters.businessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Business Subscription
     * @param {SubscriptionApiPaymentsViewsNinjaSubscriptionGetBusinessSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public paymentsViewsNinjaSubscriptionGetBusinessSubscription(requestParameters: SubscriptionApiPaymentsViewsNinjaSubscriptionGetBusinessSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).paymentsViewsNinjaSubscriptionGetBusinessSubscription(requestParameters.businessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Card Failure Reason
     * @param {SubscriptionApiPaymentsViewsNinjaSubscriptionGetCardFailureReasonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public paymentsViewsNinjaSubscriptionGetCardFailureReason(requestParameters: SubscriptionApiPaymentsViewsNinjaSubscriptionGetCardFailureReasonRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).paymentsViewsNinjaSubscriptionGetCardFailureReason(requestParameters.businessId, requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Invoice
     * @param {SubscriptionApiPaymentsViewsNinjaSubscriptionGetInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public paymentsViewsNinjaSubscriptionGetInvoice(requestParameters: SubscriptionApiPaymentsViewsNinjaSubscriptionGetInvoiceRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).paymentsViewsNinjaSubscriptionGetInvoice(requestParameters.businessId, requestParameters.paid, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Subscription Status
     * @param {SubscriptionApiPaymentsViewsNinjaSubscriptionGetSubscriptionStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public paymentsViewsNinjaSubscriptionGetSubscriptionStatus(requestParameters: SubscriptionApiPaymentsViewsNinjaSubscriptionGetSubscriptionStatusRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).paymentsViewsNinjaSubscriptionGetSubscriptionStatus(requestParameters.businessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Pause Business Subscription
     * @param {SubscriptionApiPaymentsViewsNinjaSubscriptionPauseBusinessSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public paymentsViewsNinjaSubscriptionPauseBusinessSubscription(requestParameters: SubscriptionApiPaymentsViewsNinjaSubscriptionPauseBusinessSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).paymentsViewsNinjaSubscriptionPauseBusinessSubscription(requestParameters.businessId, requestParameters.subscriptionBillingInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reactivate Business Subscription
     * @param {SubscriptionApiPaymentsViewsNinjaSubscriptionReactivateBusinessSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public paymentsViewsNinjaSubscriptionReactivateBusinessSubscription(requestParameters: SubscriptionApiPaymentsViewsNinjaSubscriptionReactivateBusinessSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).paymentsViewsNinjaSubscriptionReactivateBusinessSubscription(requestParameters.businessId, requestParameters.reActivateSubscriptionInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resume Business Subscription
     * @param {SubscriptionApiPaymentsViewsNinjaSubscriptionResumeBusinessSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public paymentsViewsNinjaSubscriptionResumeBusinessSubscription(requestParameters: SubscriptionApiPaymentsViewsNinjaSubscriptionResumeBusinessSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).paymentsViewsNinjaSubscriptionResumeBusinessSubscription(requestParameters.businessId, requestParameters.subscriptionBillingInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Business Subscription
     * @param {SubscriptionApiPaymentsViewsNinjaSubscriptionUpdateBusinessSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public paymentsViewsNinjaSubscriptionUpdateBusinessSubscription(requestParameters: SubscriptionApiPaymentsViewsNinjaSubscriptionUpdateBusinessSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).paymentsViewsNinjaSubscriptionUpdateBusinessSubscription(requestParameters.businessId, requestParameters.updateSubscriptionInSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SupportApi - axios parameter creator
 * @export
 */
export const SupportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel Subscription
         * @param {CancelSubscriptionInSchema} cancelSubscriptionInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsSupportCancelSubscription: async (cancelSubscriptionInSchema: CancelSubscriptionInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cancelSubscriptionInSchema' is not null or undefined
            assertParamExists('managementViewsSupportCancelSubscription', 'cancelSubscriptionInSchema', cancelSubscriptionInSchema)
            const localVarPath = `/api/admin/support/cancel-subscription/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthenticationV2 required
            await setApiKeyToObject(localVarHeaderParameter, "key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelSubscriptionInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change Email
         * @param {ChangeEmailInSchema} changeEmailInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsSupportChangeEmail: async (changeEmailInSchema: ChangeEmailInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changeEmailInSchema' is not null or undefined
            assertParamExists('managementViewsSupportChangeEmail', 'changeEmailInSchema', changeEmailInSchema)
            const localVarPath = `/api/admin/support/change-email/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthenticationV2 required
            await setApiKeyToObject(localVarHeaderParameter, "key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeEmailInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change Phone Number
         * @param {ChangePhoneNumberInSchema} changePhoneNumberInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsSupportChangePhoneNumber: async (changePhoneNumberInSchema: ChangePhoneNumberInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changePhoneNumberInSchema' is not null or undefined
            assertParamExists('managementViewsSupportChangePhoneNumber', 'changePhoneNumberInSchema', changePhoneNumberInSchema)
            const localVarPath = `/api/admin/support/change-phone-number/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthenticationV2 required
            await setApiKeyToObject(localVarHeaderParameter, "key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePhoneNumberInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Credit Airtime
         * @param {CreditAirtimeInSchema} creditAirtimeInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsSupportCreditAirtime: async (creditAirtimeInSchema: CreditAirtimeInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'creditAirtimeInSchema' is not null or undefined
            assertParamExists('managementViewsSupportCreditAirtime', 'creditAirtimeInSchema', creditAirtimeInSchema)
            const localVarPath = `/api/admin/support/credit-airtime/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthenticationV2 required
            await setApiKeyToObject(localVarHeaderParameter, "key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(creditAirtimeInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disable Welcome Greetings
         * @param {DisableWelcomeGreetingInSchema} disableWelcomeGreetingInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsSupportDisableWelcomeGreetings: async (disableWelcomeGreetingInSchema: DisableWelcomeGreetingInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'disableWelcomeGreetingInSchema' is not null or undefined
            assertParamExists('managementViewsSupportDisableWelcomeGreetings', 'disableWelcomeGreetingInSchema', disableWelcomeGreetingInSchema)
            const localVarPath = `/api/admin/support/disable-welcome-greetings/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthenticationV2 required
            await setApiKeyToObject(localVarHeaderParameter, "key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(disableWelcomeGreetingInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Increase Nin Attempts
         * @param {IncreaseNinAttemptsInSchema} increaseNinAttemptsInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsSupportIncreaseNinAttempts: async (increaseNinAttemptsInSchema: IncreaseNinAttemptsInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'increaseNinAttemptsInSchema' is not null or undefined
            assertParamExists('managementViewsSupportIncreaseNinAttempts', 'increaseNinAttemptsInSchema', increaseNinAttemptsInSchema)
            const localVarPath = `/api/admin/support/increase-verification-attempts/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthenticationV2 required
            await setApiKeyToObject(localVarHeaderParameter, "key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(increaseNinAttemptsInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Manage Extensions
         * @param {ManageExtensionsInSchema} manageExtensionsInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsSupportManageExtensions: async (manageExtensionsInSchema: ManageExtensionsInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'manageExtensionsInSchema' is not null or undefined
            assertParamExists('managementViewsSupportManageExtensions', 'manageExtensionsInSchema', manageExtensionsInSchema)
            const localVarPath = `/api/admin/support/manage-extensions/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthenticationV2 required
            await setApiKeyToObject(localVarHeaderParameter, "key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(manageExtensionsInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pause Subscription
         * @param {PauseSubscriptionInSchema} pauseSubscriptionInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsSupportPauseSubscription: async (pauseSubscriptionInSchema: PauseSubscriptionInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pauseSubscriptionInSchema' is not null or undefined
            assertParamExists('managementViewsSupportPauseSubscription', 'pauseSubscriptionInSchema', pauseSubscriptionInSchema)
            const localVarPath = `/api/admin/support/pause-subscription/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthenticationV2 required
            await setApiKeyToObject(localVarHeaderParameter, "key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pauseSubscriptionInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reactivate Account
         * @param {ReactivateAccountInSchema} reactivateAccountInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsSupportReactivateAccount: async (reactivateAccountInSchema: ReactivateAccountInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reactivateAccountInSchema' is not null or undefined
            assertParamExists('managementViewsSupportReactivateAccount', 'reactivateAccountInSchema', reactivateAccountInSchema)
            const localVarPath = `/api/admin/support/reactivate-account/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthenticationV2 required
            await setApiKeyToObject(localVarHeaderParameter, "key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reactivateAccountInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reduce Ring Time
         * @param {ReduceRingTimeInSchema} reduceRingTimeInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsSupportReduceRingTime: async (reduceRingTimeInSchema: ReduceRingTimeInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reduceRingTimeInSchema' is not null or undefined
            assertParamExists('managementViewsSupportReduceRingTime', 'reduceRingTimeInSchema', reduceRingTimeInSchema)
            const localVarPath = `/api/admin/support/reduce-ring-time/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthenticationV2 required
            await setApiKeyToObject(localVarHeaderParameter, "key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reduceRingTimeInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Trigger Password Reset
         * @param {TriggerPasswordResetInSchema} triggerPasswordResetInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsSupportTriggerPasswordReset: async (triggerPasswordResetInSchema: TriggerPasswordResetInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'triggerPasswordResetInSchema' is not null or undefined
            assertParamExists('managementViewsSupportTriggerPasswordReset', 'triggerPasswordResetInSchema', triggerPasswordResetInSchema)
            const localVarPath = `/api/admin/support/trigger-password-reset/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthenticationV2 required
            await setApiKeyToObject(localVarHeaderParameter, "key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(triggerPasswordResetInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupportApi - functional programming interface
 * @export
 */
export const SupportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cancel Subscription
         * @param {CancelSubscriptionInSchema} cancelSubscriptionInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementViewsSupportCancelSubscription(cancelSubscriptionInSchema: CancelSubscriptionInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementViewsSupportCancelSubscription(cancelSubscriptionInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.managementViewsSupportCancelSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Change Email
         * @param {ChangeEmailInSchema} changeEmailInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementViewsSupportChangeEmail(changeEmailInSchema: ChangeEmailInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementViewsSupportChangeEmail(changeEmailInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.managementViewsSupportChangeEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Change Phone Number
         * @param {ChangePhoneNumberInSchema} changePhoneNumberInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementViewsSupportChangePhoneNumber(changePhoneNumberInSchema: ChangePhoneNumberInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementViewsSupportChangePhoneNumber(changePhoneNumberInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.managementViewsSupportChangePhoneNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Credit Airtime
         * @param {CreditAirtimeInSchema} creditAirtimeInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementViewsSupportCreditAirtime(creditAirtimeInSchema: CreditAirtimeInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementViewsSupportCreditAirtime(creditAirtimeInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.managementViewsSupportCreditAirtime']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Disable Welcome Greetings
         * @param {DisableWelcomeGreetingInSchema} disableWelcomeGreetingInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementViewsSupportDisableWelcomeGreetings(disableWelcomeGreetingInSchema: DisableWelcomeGreetingInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementViewsSupportDisableWelcomeGreetings(disableWelcomeGreetingInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.managementViewsSupportDisableWelcomeGreetings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Increase Nin Attempts
         * @param {IncreaseNinAttemptsInSchema} increaseNinAttemptsInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementViewsSupportIncreaseNinAttempts(increaseNinAttemptsInSchema: IncreaseNinAttemptsInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementViewsSupportIncreaseNinAttempts(increaseNinAttemptsInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.managementViewsSupportIncreaseNinAttempts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Manage Extensions
         * @param {ManageExtensionsInSchema} manageExtensionsInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementViewsSupportManageExtensions(manageExtensionsInSchema: ManageExtensionsInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementViewsSupportManageExtensions(manageExtensionsInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.managementViewsSupportManageExtensions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Pause Subscription
         * @param {PauseSubscriptionInSchema} pauseSubscriptionInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementViewsSupportPauseSubscription(pauseSubscriptionInSchema: PauseSubscriptionInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementViewsSupportPauseSubscription(pauseSubscriptionInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.managementViewsSupportPauseSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reactivate Account
         * @param {ReactivateAccountInSchema} reactivateAccountInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementViewsSupportReactivateAccount(reactivateAccountInSchema: ReactivateAccountInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementViewsSupportReactivateAccount(reactivateAccountInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.managementViewsSupportReactivateAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reduce Ring Time
         * @param {ReduceRingTimeInSchema} reduceRingTimeInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementViewsSupportReduceRingTime(reduceRingTimeInSchema: ReduceRingTimeInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementViewsSupportReduceRingTime(reduceRingTimeInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.managementViewsSupportReduceRingTime']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Trigger Password Reset
         * @param {TriggerPasswordResetInSchema} triggerPasswordResetInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementViewsSupportTriggerPasswordReset(triggerPasswordResetInSchema: TriggerPasswordResetInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementViewsSupportTriggerPasswordReset(triggerPasswordResetInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.managementViewsSupportTriggerPasswordReset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SupportApi - factory interface
 * @export
 */
export const SupportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupportApiFp(configuration)
    return {
        /**
         * 
         * @summary Cancel Subscription
         * @param {SupportApiManagementViewsSupportCancelSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsSupportCancelSubscription(requestParameters: SupportApiManagementViewsSupportCancelSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.managementViewsSupportCancelSubscription(requestParameters.cancelSubscriptionInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change Email
         * @param {SupportApiManagementViewsSupportChangeEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsSupportChangeEmail(requestParameters: SupportApiManagementViewsSupportChangeEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.managementViewsSupportChangeEmail(requestParameters.changeEmailInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change Phone Number
         * @param {SupportApiManagementViewsSupportChangePhoneNumberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsSupportChangePhoneNumber(requestParameters: SupportApiManagementViewsSupportChangePhoneNumberRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.managementViewsSupportChangePhoneNumber(requestParameters.changePhoneNumberInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Credit Airtime
         * @param {SupportApiManagementViewsSupportCreditAirtimeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsSupportCreditAirtime(requestParameters: SupportApiManagementViewsSupportCreditAirtimeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.managementViewsSupportCreditAirtime(requestParameters.creditAirtimeInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disable Welcome Greetings
         * @param {SupportApiManagementViewsSupportDisableWelcomeGreetingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsSupportDisableWelcomeGreetings(requestParameters: SupportApiManagementViewsSupportDisableWelcomeGreetingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.managementViewsSupportDisableWelcomeGreetings(requestParameters.disableWelcomeGreetingInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Increase Nin Attempts
         * @param {SupportApiManagementViewsSupportIncreaseNinAttemptsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsSupportIncreaseNinAttempts(requestParameters: SupportApiManagementViewsSupportIncreaseNinAttemptsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.managementViewsSupportIncreaseNinAttempts(requestParameters.increaseNinAttemptsInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Manage Extensions
         * @param {SupportApiManagementViewsSupportManageExtensionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsSupportManageExtensions(requestParameters: SupportApiManagementViewsSupportManageExtensionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.managementViewsSupportManageExtensions(requestParameters.manageExtensionsInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Pause Subscription
         * @param {SupportApiManagementViewsSupportPauseSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsSupportPauseSubscription(requestParameters: SupportApiManagementViewsSupportPauseSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.managementViewsSupportPauseSubscription(requestParameters.pauseSubscriptionInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reactivate Account
         * @param {SupportApiManagementViewsSupportReactivateAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsSupportReactivateAccount(requestParameters: SupportApiManagementViewsSupportReactivateAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.managementViewsSupportReactivateAccount(requestParameters.reactivateAccountInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reduce Ring Time
         * @param {SupportApiManagementViewsSupportReduceRingTimeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsSupportReduceRingTime(requestParameters: SupportApiManagementViewsSupportReduceRingTimeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.managementViewsSupportReduceRingTime(requestParameters.reduceRingTimeInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Trigger Password Reset
         * @param {SupportApiManagementViewsSupportTriggerPasswordResetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementViewsSupportTriggerPasswordReset(requestParameters: SupportApiManagementViewsSupportTriggerPasswordResetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.managementViewsSupportTriggerPasswordReset(requestParameters.triggerPasswordResetInSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for managementViewsSupportCancelSubscription operation in SupportApi.
 * @export
 * @interface SupportApiManagementViewsSupportCancelSubscriptionRequest
 */
export interface SupportApiManagementViewsSupportCancelSubscriptionRequest {
    /**
     * 
     * @type {CancelSubscriptionInSchema}
     * @memberof SupportApiManagementViewsSupportCancelSubscription
     */
    readonly cancelSubscriptionInSchema: CancelSubscriptionInSchema
}

/**
 * Request parameters for managementViewsSupportChangeEmail operation in SupportApi.
 * @export
 * @interface SupportApiManagementViewsSupportChangeEmailRequest
 */
export interface SupportApiManagementViewsSupportChangeEmailRequest {
    /**
     * 
     * @type {ChangeEmailInSchema}
     * @memberof SupportApiManagementViewsSupportChangeEmail
     */
    readonly changeEmailInSchema: ChangeEmailInSchema
}

/**
 * Request parameters for managementViewsSupportChangePhoneNumber operation in SupportApi.
 * @export
 * @interface SupportApiManagementViewsSupportChangePhoneNumberRequest
 */
export interface SupportApiManagementViewsSupportChangePhoneNumberRequest {
    /**
     * 
     * @type {ChangePhoneNumberInSchema}
     * @memberof SupportApiManagementViewsSupportChangePhoneNumber
     */
    readonly changePhoneNumberInSchema: ChangePhoneNumberInSchema
}

/**
 * Request parameters for managementViewsSupportCreditAirtime operation in SupportApi.
 * @export
 * @interface SupportApiManagementViewsSupportCreditAirtimeRequest
 */
export interface SupportApiManagementViewsSupportCreditAirtimeRequest {
    /**
     * 
     * @type {CreditAirtimeInSchema}
     * @memberof SupportApiManagementViewsSupportCreditAirtime
     */
    readonly creditAirtimeInSchema: CreditAirtimeInSchema
}

/**
 * Request parameters for managementViewsSupportDisableWelcomeGreetings operation in SupportApi.
 * @export
 * @interface SupportApiManagementViewsSupportDisableWelcomeGreetingsRequest
 */
export interface SupportApiManagementViewsSupportDisableWelcomeGreetingsRequest {
    /**
     * 
     * @type {DisableWelcomeGreetingInSchema}
     * @memberof SupportApiManagementViewsSupportDisableWelcomeGreetings
     */
    readonly disableWelcomeGreetingInSchema: DisableWelcomeGreetingInSchema
}

/**
 * Request parameters for managementViewsSupportIncreaseNinAttempts operation in SupportApi.
 * @export
 * @interface SupportApiManagementViewsSupportIncreaseNinAttemptsRequest
 */
export interface SupportApiManagementViewsSupportIncreaseNinAttemptsRequest {
    /**
     * 
     * @type {IncreaseNinAttemptsInSchema}
     * @memberof SupportApiManagementViewsSupportIncreaseNinAttempts
     */
    readonly increaseNinAttemptsInSchema: IncreaseNinAttemptsInSchema
}

/**
 * Request parameters for managementViewsSupportManageExtensions operation in SupportApi.
 * @export
 * @interface SupportApiManagementViewsSupportManageExtensionsRequest
 */
export interface SupportApiManagementViewsSupportManageExtensionsRequest {
    /**
     * 
     * @type {ManageExtensionsInSchema}
     * @memberof SupportApiManagementViewsSupportManageExtensions
     */
    readonly manageExtensionsInSchema: ManageExtensionsInSchema
}

/**
 * Request parameters for managementViewsSupportPauseSubscription operation in SupportApi.
 * @export
 * @interface SupportApiManagementViewsSupportPauseSubscriptionRequest
 */
export interface SupportApiManagementViewsSupportPauseSubscriptionRequest {
    /**
     * 
     * @type {PauseSubscriptionInSchema}
     * @memberof SupportApiManagementViewsSupportPauseSubscription
     */
    readonly pauseSubscriptionInSchema: PauseSubscriptionInSchema
}

/**
 * Request parameters for managementViewsSupportReactivateAccount operation in SupportApi.
 * @export
 * @interface SupportApiManagementViewsSupportReactivateAccountRequest
 */
export interface SupportApiManagementViewsSupportReactivateAccountRequest {
    /**
     * 
     * @type {ReactivateAccountInSchema}
     * @memberof SupportApiManagementViewsSupportReactivateAccount
     */
    readonly reactivateAccountInSchema: ReactivateAccountInSchema
}

/**
 * Request parameters for managementViewsSupportReduceRingTime operation in SupportApi.
 * @export
 * @interface SupportApiManagementViewsSupportReduceRingTimeRequest
 */
export interface SupportApiManagementViewsSupportReduceRingTimeRequest {
    /**
     * 
     * @type {ReduceRingTimeInSchema}
     * @memberof SupportApiManagementViewsSupportReduceRingTime
     */
    readonly reduceRingTimeInSchema: ReduceRingTimeInSchema
}

/**
 * Request parameters for managementViewsSupportTriggerPasswordReset operation in SupportApi.
 * @export
 * @interface SupportApiManagementViewsSupportTriggerPasswordResetRequest
 */
export interface SupportApiManagementViewsSupportTriggerPasswordResetRequest {
    /**
     * 
     * @type {TriggerPasswordResetInSchema}
     * @memberof SupportApiManagementViewsSupportTriggerPasswordReset
     */
    readonly triggerPasswordResetInSchema: TriggerPasswordResetInSchema
}

/**
 * SupportApi - object-oriented interface
 * @export
 * @class SupportApi
 * @extends {BaseAPI}
 */
export class SupportApi extends BaseAPI {
    /**
     * 
     * @summary Cancel Subscription
     * @param {SupportApiManagementViewsSupportCancelSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public managementViewsSupportCancelSubscription(requestParameters: SupportApiManagementViewsSupportCancelSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).managementViewsSupportCancelSubscription(requestParameters.cancelSubscriptionInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change Email
     * @param {SupportApiManagementViewsSupportChangeEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public managementViewsSupportChangeEmail(requestParameters: SupportApiManagementViewsSupportChangeEmailRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).managementViewsSupportChangeEmail(requestParameters.changeEmailInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change Phone Number
     * @param {SupportApiManagementViewsSupportChangePhoneNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public managementViewsSupportChangePhoneNumber(requestParameters: SupportApiManagementViewsSupportChangePhoneNumberRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).managementViewsSupportChangePhoneNumber(requestParameters.changePhoneNumberInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Credit Airtime
     * @param {SupportApiManagementViewsSupportCreditAirtimeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public managementViewsSupportCreditAirtime(requestParameters: SupportApiManagementViewsSupportCreditAirtimeRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).managementViewsSupportCreditAirtime(requestParameters.creditAirtimeInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disable Welcome Greetings
     * @param {SupportApiManagementViewsSupportDisableWelcomeGreetingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public managementViewsSupportDisableWelcomeGreetings(requestParameters: SupportApiManagementViewsSupportDisableWelcomeGreetingsRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).managementViewsSupportDisableWelcomeGreetings(requestParameters.disableWelcomeGreetingInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Increase Nin Attempts
     * @param {SupportApiManagementViewsSupportIncreaseNinAttemptsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public managementViewsSupportIncreaseNinAttempts(requestParameters: SupportApiManagementViewsSupportIncreaseNinAttemptsRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).managementViewsSupportIncreaseNinAttempts(requestParameters.increaseNinAttemptsInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Manage Extensions
     * @param {SupportApiManagementViewsSupportManageExtensionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public managementViewsSupportManageExtensions(requestParameters: SupportApiManagementViewsSupportManageExtensionsRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).managementViewsSupportManageExtensions(requestParameters.manageExtensionsInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Pause Subscription
     * @param {SupportApiManagementViewsSupportPauseSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public managementViewsSupportPauseSubscription(requestParameters: SupportApiManagementViewsSupportPauseSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).managementViewsSupportPauseSubscription(requestParameters.pauseSubscriptionInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reactivate Account
     * @param {SupportApiManagementViewsSupportReactivateAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public managementViewsSupportReactivateAccount(requestParameters: SupportApiManagementViewsSupportReactivateAccountRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).managementViewsSupportReactivateAccount(requestParameters.reactivateAccountInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reduce Ring Time
     * @param {SupportApiManagementViewsSupportReduceRingTimeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public managementViewsSupportReduceRingTime(requestParameters: SupportApiManagementViewsSupportReduceRingTimeRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).managementViewsSupportReduceRingTime(requestParameters.reduceRingTimeInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Trigger Password Reset
     * @param {SupportApiManagementViewsSupportTriggerPasswordResetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public managementViewsSupportTriggerPasswordReset(requestParameters: SupportApiManagementViewsSupportTriggerPasswordResetRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).managementViewsSupportTriggerPasswordReset(requestParameters.triggerPasswordResetInSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TagsApi - axios parameter creator
 * @export
 */
export const TagsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Tag For Business
         * @param {number} businessId 
         * @param {TagInSchema} tagInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaTagsCreateTagForBusiness: async (businessId: number, tagInSchema: TagInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaTagsCreateTagForBusiness', 'businessId', businessId)
            // verify required parameter 'tagInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaTagsCreateTagForBusiness', 'tagInSchema', tagInSchema)
            const localVarPath = `/api/business/{business_id}/tags/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tagInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Tag From A Business
         * @param {number} businessId 
         * @param {number} tagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaTagsDeleteTagFromABusiness: async (businessId: number, tagId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaTagsDeleteTagFromABusiness', 'businessId', businessId)
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('usersViewsNinjaTagsDeleteTagFromABusiness', 'tagId', tagId)
            const localVarPath = `/api/business/{business_id}/tags/{tag_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"tag_id"}}`, encodeURIComponent(String(tagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Tags For Business
         * @param {number} businessId 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaTagsListTagsForBusiness: async (businessId: number, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaTagsListTagsForBusiness', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/tags/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Recently Added Tags For Business
         * @param {number} businessId 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaTagsRecentlyAddedTagsForBusiness: async (businessId: number, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaTagsRecentlyAddedTagsForBusiness', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/tags/recently-added/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve Tag
         * @param {number} businessId 
         * @param {number} tagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaTagsRetrieveTag: async (businessId: number, tagId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaTagsRetrieveTag', 'businessId', businessId)
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('usersViewsNinjaTagsRetrieveTag', 'tagId', tagId)
            const localVarPath = `/api/business/{business_id}/tags/{tag_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"tag_id"}}`, encodeURIComponent(String(tagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Tag In A Business
         * @param {number} businessId 
         * @param {number} tagId 
         * @param {TagUpdateSchema} tagUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaTagsUpdateTagInABusiness: async (businessId: number, tagId: number, tagUpdateSchema: TagUpdateSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaTagsUpdateTagInABusiness', 'businessId', businessId)
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('usersViewsNinjaTagsUpdateTagInABusiness', 'tagId', tagId)
            // verify required parameter 'tagUpdateSchema' is not null or undefined
            assertParamExists('usersViewsNinjaTagsUpdateTagInABusiness', 'tagUpdateSchema', tagUpdateSchema)
            const localVarPath = `/api/business/{business_id}/tags/{tag_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"tag_id"}}`, encodeURIComponent(String(tagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tagUpdateSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TagsApi - functional programming interface
 * @export
 */
export const TagsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TagsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Tag For Business
         * @param {number} businessId 
         * @param {TagInSchema} tagInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaTagsCreateTagForBusiness(businessId: number, tagInSchema: TagInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TagOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaTagsCreateTagForBusiness(businessId, tagInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TagsApi.usersViewsNinjaTagsCreateTagForBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Tag From A Business
         * @param {number} businessId 
         * @param {number} tagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaTagsDeleteTagFromABusiness(businessId: number, tagId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaTagsDeleteTagFromABusiness(businessId, tagId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TagsApi.usersViewsNinjaTagsDeleteTagFromABusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Tags For Business
         * @param {number} businessId 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaTagsListTagsForBusiness(businessId: number, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedTagOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaTagsListTagsForBusiness(businessId, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TagsApi.usersViewsNinjaTagsListTagsForBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Recently Added Tags For Business
         * @param {number} businessId 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaTagsRecentlyAddedTagsForBusiness(businessId: number, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedTagOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaTagsRecentlyAddedTagsForBusiness(businessId, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TagsApi.usersViewsNinjaTagsRecentlyAddedTagsForBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve Tag
         * @param {number} businessId 
         * @param {number} tagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaTagsRetrieveTag(businessId: number, tagId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TagOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaTagsRetrieveTag(businessId, tagId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TagsApi.usersViewsNinjaTagsRetrieveTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Tag In A Business
         * @param {number} businessId 
         * @param {number} tagId 
         * @param {TagUpdateSchema} tagUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaTagsUpdateTagInABusiness(businessId: number, tagId: number, tagUpdateSchema: TagUpdateSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TagOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaTagsUpdateTagInABusiness(businessId, tagId, tagUpdateSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TagsApi.usersViewsNinjaTagsUpdateTagInABusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TagsApi - factory interface
 * @export
 */
export const TagsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TagsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Tag For Business
         * @param {TagsApiUsersViewsNinjaTagsCreateTagForBusinessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaTagsCreateTagForBusiness(requestParameters: TagsApiUsersViewsNinjaTagsCreateTagForBusinessRequest, options?: RawAxiosRequestConfig): AxiosPromise<TagOutSchema> {
            return localVarFp.usersViewsNinjaTagsCreateTagForBusiness(requestParameters.businessId, requestParameters.tagInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Tag From A Business
         * @param {TagsApiUsersViewsNinjaTagsDeleteTagFromABusinessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaTagsDeleteTagFromABusiness(requestParameters: TagsApiUsersViewsNinjaTagsDeleteTagFromABusinessRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.usersViewsNinjaTagsDeleteTagFromABusiness(requestParameters.businessId, requestParameters.tagId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Tags For Business
         * @param {TagsApiUsersViewsNinjaTagsListTagsForBusinessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaTagsListTagsForBusiness(requestParameters: TagsApiUsersViewsNinjaTagsListTagsForBusinessRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedTagOutSchema> {
            return localVarFp.usersViewsNinjaTagsListTagsForBusiness(requestParameters.businessId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Recently Added Tags For Business
         * @param {TagsApiUsersViewsNinjaTagsRecentlyAddedTagsForBusinessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaTagsRecentlyAddedTagsForBusiness(requestParameters: TagsApiUsersViewsNinjaTagsRecentlyAddedTagsForBusinessRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedTagOutSchema> {
            return localVarFp.usersViewsNinjaTagsRecentlyAddedTagsForBusiness(requestParameters.businessId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve Tag
         * @param {TagsApiUsersViewsNinjaTagsRetrieveTagRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaTagsRetrieveTag(requestParameters: TagsApiUsersViewsNinjaTagsRetrieveTagRequest, options?: RawAxiosRequestConfig): AxiosPromise<TagOutSchema> {
            return localVarFp.usersViewsNinjaTagsRetrieveTag(requestParameters.businessId, requestParameters.tagId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Tag In A Business
         * @param {TagsApiUsersViewsNinjaTagsUpdateTagInABusinessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaTagsUpdateTagInABusiness(requestParameters: TagsApiUsersViewsNinjaTagsUpdateTagInABusinessRequest, options?: RawAxiosRequestConfig): AxiosPromise<TagOutSchema> {
            return localVarFp.usersViewsNinjaTagsUpdateTagInABusiness(requestParameters.businessId, requestParameters.tagId, requestParameters.tagUpdateSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for usersViewsNinjaTagsCreateTagForBusiness operation in TagsApi.
 * @export
 * @interface TagsApiUsersViewsNinjaTagsCreateTagForBusinessRequest
 */
export interface TagsApiUsersViewsNinjaTagsCreateTagForBusinessRequest {
    /**
     * 
     * @type {number}
     * @memberof TagsApiUsersViewsNinjaTagsCreateTagForBusiness
     */
    readonly businessId: number

    /**
     * 
     * @type {TagInSchema}
     * @memberof TagsApiUsersViewsNinjaTagsCreateTagForBusiness
     */
    readonly tagInSchema: TagInSchema
}

/**
 * Request parameters for usersViewsNinjaTagsDeleteTagFromABusiness operation in TagsApi.
 * @export
 * @interface TagsApiUsersViewsNinjaTagsDeleteTagFromABusinessRequest
 */
export interface TagsApiUsersViewsNinjaTagsDeleteTagFromABusinessRequest {
    /**
     * 
     * @type {number}
     * @memberof TagsApiUsersViewsNinjaTagsDeleteTagFromABusiness
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof TagsApiUsersViewsNinjaTagsDeleteTagFromABusiness
     */
    readonly tagId: number
}

/**
 * Request parameters for usersViewsNinjaTagsListTagsForBusiness operation in TagsApi.
 * @export
 * @interface TagsApiUsersViewsNinjaTagsListTagsForBusinessRequest
 */
export interface TagsApiUsersViewsNinjaTagsListTagsForBusinessRequest {
    /**
     * 
     * @type {number}
     * @memberof TagsApiUsersViewsNinjaTagsListTagsForBusiness
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof TagsApiUsersViewsNinjaTagsListTagsForBusiness
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof TagsApiUsersViewsNinjaTagsListTagsForBusiness
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof TagsApiUsersViewsNinjaTagsListTagsForBusiness
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for usersViewsNinjaTagsRecentlyAddedTagsForBusiness operation in TagsApi.
 * @export
 * @interface TagsApiUsersViewsNinjaTagsRecentlyAddedTagsForBusinessRequest
 */
export interface TagsApiUsersViewsNinjaTagsRecentlyAddedTagsForBusinessRequest {
    /**
     * 
     * @type {number}
     * @memberof TagsApiUsersViewsNinjaTagsRecentlyAddedTagsForBusiness
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof TagsApiUsersViewsNinjaTagsRecentlyAddedTagsForBusiness
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof TagsApiUsersViewsNinjaTagsRecentlyAddedTagsForBusiness
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof TagsApiUsersViewsNinjaTagsRecentlyAddedTagsForBusiness
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for usersViewsNinjaTagsRetrieveTag operation in TagsApi.
 * @export
 * @interface TagsApiUsersViewsNinjaTagsRetrieveTagRequest
 */
export interface TagsApiUsersViewsNinjaTagsRetrieveTagRequest {
    /**
     * 
     * @type {number}
     * @memberof TagsApiUsersViewsNinjaTagsRetrieveTag
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof TagsApiUsersViewsNinjaTagsRetrieveTag
     */
    readonly tagId: number
}

/**
 * Request parameters for usersViewsNinjaTagsUpdateTagInABusiness operation in TagsApi.
 * @export
 * @interface TagsApiUsersViewsNinjaTagsUpdateTagInABusinessRequest
 */
export interface TagsApiUsersViewsNinjaTagsUpdateTagInABusinessRequest {
    /**
     * 
     * @type {number}
     * @memberof TagsApiUsersViewsNinjaTagsUpdateTagInABusiness
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof TagsApiUsersViewsNinjaTagsUpdateTagInABusiness
     */
    readonly tagId: number

    /**
     * 
     * @type {TagUpdateSchema}
     * @memberof TagsApiUsersViewsNinjaTagsUpdateTagInABusiness
     */
    readonly tagUpdateSchema: TagUpdateSchema
}

/**
 * TagsApi - object-oriented interface
 * @export
 * @class TagsApi
 * @extends {BaseAPI}
 */
export class TagsApi extends BaseAPI {
    /**
     * 
     * @summary Create Tag For Business
     * @param {TagsApiUsersViewsNinjaTagsCreateTagForBusinessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    public usersViewsNinjaTagsCreateTagForBusiness(requestParameters: TagsApiUsersViewsNinjaTagsCreateTagForBusinessRequest, options?: RawAxiosRequestConfig) {
        return TagsApiFp(this.configuration).usersViewsNinjaTagsCreateTagForBusiness(requestParameters.businessId, requestParameters.tagInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Tag From A Business
     * @param {TagsApiUsersViewsNinjaTagsDeleteTagFromABusinessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    public usersViewsNinjaTagsDeleteTagFromABusiness(requestParameters: TagsApiUsersViewsNinjaTagsDeleteTagFromABusinessRequest, options?: RawAxiosRequestConfig) {
        return TagsApiFp(this.configuration).usersViewsNinjaTagsDeleteTagFromABusiness(requestParameters.businessId, requestParameters.tagId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Tags For Business
     * @param {TagsApiUsersViewsNinjaTagsListTagsForBusinessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    public usersViewsNinjaTagsListTagsForBusiness(requestParameters: TagsApiUsersViewsNinjaTagsListTagsForBusinessRequest, options?: RawAxiosRequestConfig) {
        return TagsApiFp(this.configuration).usersViewsNinjaTagsListTagsForBusiness(requestParameters.businessId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Recently Added Tags For Business
     * @param {TagsApiUsersViewsNinjaTagsRecentlyAddedTagsForBusinessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    public usersViewsNinjaTagsRecentlyAddedTagsForBusiness(requestParameters: TagsApiUsersViewsNinjaTagsRecentlyAddedTagsForBusinessRequest, options?: RawAxiosRequestConfig) {
        return TagsApiFp(this.configuration).usersViewsNinjaTagsRecentlyAddedTagsForBusiness(requestParameters.businessId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve Tag
     * @param {TagsApiUsersViewsNinjaTagsRetrieveTagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    public usersViewsNinjaTagsRetrieveTag(requestParameters: TagsApiUsersViewsNinjaTagsRetrieveTagRequest, options?: RawAxiosRequestConfig) {
        return TagsApiFp(this.configuration).usersViewsNinjaTagsRetrieveTag(requestParameters.businessId, requestParameters.tagId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Tag In A Business
     * @param {TagsApiUsersViewsNinjaTagsUpdateTagInABusinessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    public usersViewsNinjaTagsUpdateTagInABusiness(requestParameters: TagsApiUsersViewsNinjaTagsUpdateTagInABusinessRequest, options?: RawAxiosRequestConfig) {
        return TagsApiFp(this.configuration).usersViewsNinjaTagsUpdateTagInABusiness(requestParameters.businessId, requestParameters.tagId, requestParameters.tagUpdateSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TeamMembersApi - axios parameter creator
 * @export
 */
export const TeamMembersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Accept team member invitation for new users from onboarding page
         * @summary Accept Team Invitation
         * @param {string} invitationId 
         * @param {TeamMemberInvitationAcceptanceInSchema} teamMemberInvitationAcceptanceInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberAcceptTeamInvitation: async (invitationId: string, teamMemberInvitationAcceptanceInSchema: TeamMemberInvitationAcceptanceInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitationId' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberAcceptTeamInvitation', 'invitationId', invitationId)
            // verify required parameter 'teamMemberInvitationAcceptanceInSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberAcceptTeamInvitation', 'teamMemberInvitationAcceptanceInSchema', teamMemberInvitationAcceptanceInSchema)
            const localVarPath = `/api/business/{invitation_id}/accept-invite/`
                .replace(`{${"invitation_id"}}`, encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamMemberInvitationAcceptanceInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk Create Team Members
         * @param {number} businessId 
         * @param {BulkTeamMemberInSchema} bulkTeamMemberInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberBulkCreateTeamMembers: async (businessId: number, bulkTeamMemberInSchema: BulkTeamMemberInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberBulkCreateTeamMembers', 'businessId', businessId)
            // verify required parameter 'bulkTeamMemberInSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberBulkCreateTeamMembers', 'bulkTeamMemberInSchema', bulkTeamMemberInSchema)
            const localVarPath = `/api/business/{business_id}/user/bulk/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkTeamMemberInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk Team Member Invitation
         * @param {number} businessId 
         * @param {BulkTeamMemberInSchema} bulkTeamMemberInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberBulkTeamMemberInvitation: async (businessId: number, bulkTeamMemberInSchema: BulkTeamMemberInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberBulkTeamMemberInvitation', 'businessId', businessId)
            // verify required parameter 'bulkTeamMemberInSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberBulkTeamMemberInvitation', 'bulkTeamMemberInSchema', bulkTeamMemberInSchema)
            const localVarPath = `/api/business/{business_id}/user/invite/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkTeamMemberInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check Team Member By Email
         * @param {number} businessId 
         * @param {CheckTeamMemberByEmailInSchema} checkTeamMemberByEmailInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberCheckTeamMemberByEmail: async (businessId: number, checkTeamMemberByEmailInSchema: CheckTeamMemberByEmailInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberCheckTeamMemberByEmail', 'businessId', businessId)
            // verify required parameter 'checkTeamMemberByEmailInSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberCheckTeamMemberByEmail', 'checkTeamMemberByEmailInSchema', checkTeamMemberByEmailInSchema)
            const localVarPath = `/api/business/{business_id}/team-members/check-by-email/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkTeamMemberByEmailInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Complete Team Member Onboarding
         * @param {number} businessId 
         * @param {TeamMemberOnboardingInSchema} teamMemberOnboardingInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberCompleteTeamMemberOnboarding: async (businessId: number, teamMemberOnboardingInSchema: TeamMemberOnboardingInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberCompleteTeamMemberOnboarding', 'businessId', businessId)
            // verify required parameter 'teamMemberOnboardingInSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberCompleteTeamMemberOnboarding', 'teamMemberOnboardingInSchema', teamMemberOnboardingInSchema)
            const localVarPath = `/api/business/{business_id}/user/complete-onboarding/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamMemberOnboardingInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Team Member
         * @param {number} businessId 
         * @param {TeamMemberInSchema} teamMemberInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberCreateTeamMember: async (businessId: number, teamMemberInSchema: TeamMemberInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberCreateTeamMember', 'businessId', businessId)
            // verify required parameter 'teamMemberInSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberCreateTeamMember', 'teamMemberInSchema', teamMemberInSchema)
            const localVarPath = `/api/business/{business_id}/user/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamMemberInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Team Member
         * @param {number} businessId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberDeleteTeamMember: async (businessId: number, userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberDeleteTeamMember', 'businessId', businessId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberDeleteTeamMember', 'userId', userId)
            const localVarPath = `/api/business/{business_id}/user/{user_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Team Member
         * @param {number} businessId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberGetTeamMember: async (businessId: number, userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberGetTeamMember', 'businessId', businessId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberGetTeamMember', 'userId', userId)
            const localVarPath = `/api/business/{business_id}/user/{user_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Team Member Invitations
         * @param {number} businessId 
         * @param {ProfileInvitationStatus | null} [invitationStatus] 
         * @param {number | null} [businessId2] 
         * @param {number | null} [businessNumberId] 
         * @param {number | null} [userId] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitations: async (businessId: number, invitationStatus?: ProfileInvitationStatus | null, businessId2?: number | null, businessNumberId?: number | null, userId?: number | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitations', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/invitations/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (invitationStatus !== undefined) {
                localVarQueryParameter['invitation_status'] = invitationStatus;
            }

            if (businessId2 !== undefined) {
                localVarQueryParameter['business_id'] = businessId2;
            }

            if (businessNumberId !== undefined) {
                localVarQueryParameter['business_number_id'] = businessNumberId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Team Member Receiver Numbers
         * @param {number} businessId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberGetTeamMemberReceiverNumbers: async (businessId: number, userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberGetTeamMemberReceiverNumbers', 'businessId', businessId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberGetTeamMemberReceiverNumbers', 'userId', userId)
            const localVarPath = `/api/business/{business_id}/team-member/{user_id}/receiver-numbers/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Team Member V2
         * @param {number} businessId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberGetTeamMemberV2: async (businessId: number, userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberGetTeamMemberV2', 'businessId', businessId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberGetTeamMemberV2', 'userId', userId)
            const localVarPath = `/api/business/{business_id}/team-member/{user_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accept team member invitation for already existing users
         * @summary Join Team
         * @param {string} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberInvitationJoinTeam: async (data: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'data' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberInvitationJoinTeam', 'data', data)
            const localVarPath = `/api/join-team/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (data !== undefined) {
                localVarQueryParameter['data'] = data;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Team Members
         * @param {number} businessId 
         * @param {boolean} [showAll] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberListTeamMembers: async (businessId: number, showAll?: boolean, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberListTeamMembers', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/user/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (showAll !== undefined) {
                localVarQueryParameter['show_all'] = showAll;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Team Members V2
         * @param {number} businessId 
         * @param {boolean} [showAll] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberListTeamMembersV2: async (businessId: number, showAll?: boolean, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberListTeamMembersV2', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/team-member/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (showAll !== undefined) {
                localVarQueryParameter['show_all'] = showAll;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Nudge Team Member
         * @param {number} businessId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberNudgeTeamMember: async (businessId: number, userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberNudgeTeamMember', 'businessId', businessId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberNudgeTeamMember', 'userId', userId)
            const localVarPath = `/api/business/{business_id}/team-member/{user_id}/nudge/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Team Member Permission
         * @param {number} businessId 
         * @param {number} userId 
         * @param {PermissionInSchema} permissionInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberPermission: async (businessId: number, userId: number, permissionInSchema: PermissionInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberPermission', 'businessId', businessId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberPermission', 'userId', userId)
            // verify required parameter 'permissionInSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberPermission', 'permissionInSchema', permissionInSchema)
            const localVarPath = `/api/business/{business_id}/user/{user_id}/permission/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(permissionInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Team Member Profile
         * @param {number} businessId 
         * @param {number} userId 
         * @param {ProfileInSchema} profileInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberProfile: async (businessId: number, userId: number, profileInSchema: ProfileInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberProfile', 'businessId', businessId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberProfile', 'userId', userId)
            // verify required parameter 'profileInSchema' is not null or undefined
            assertParamExists('telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberProfile', 'profileInSchema', profileInSchema)
            const localVarPath = `/api/business/{business_id}/user/{user_id}/profile/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Permission
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaBusinessListPermission: async (businessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('usersViewsNinjaBusinessListPermission', 'businessId', businessId)
            const localVarPath = `/api/business/{business_id}/permission/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamMembersApi - functional programming interface
 * @export
 */
export const TeamMembersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamMembersApiAxiosParamCreator(configuration)
    return {
        /**
         * Accept team member invitation for new users from onboarding page
         * @summary Accept Team Invitation
         * @param {string} invitationId 
         * @param {TeamMemberInvitationAcceptanceInSchema} teamMemberInvitationAcceptanceInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaTeamTeamMemberAcceptTeamInvitation(invitationId: string, teamMemberInvitationAcceptanceInSchema: TeamMemberInvitationAcceptanceInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedirectURLResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaTeamTeamMemberAcceptTeamInvitation(invitationId, teamMemberInvitationAcceptanceInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamMembersApi.telephonyViewsNinjaTeamTeamMemberAcceptTeamInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Bulk Create Team Members
         * @param {number} businessId 
         * @param {BulkTeamMemberInSchema} bulkTeamMemberInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaTeamTeamMemberBulkCreateTeamMembers(businessId: number, bulkTeamMemberInSchema: BulkTeamMemberInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaTeamTeamMemberBulkCreateTeamMembers(businessId, bulkTeamMemberInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamMembersApi.telephonyViewsNinjaTeamTeamMemberBulkCreateTeamMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Bulk Team Member Invitation
         * @param {number} businessId 
         * @param {BulkTeamMemberInSchema} bulkTeamMemberInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaTeamTeamMemberBulkTeamMemberInvitation(businessId: number, bulkTeamMemberInSchema: BulkTeamMemberInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaTeamTeamMemberBulkTeamMemberInvitation(businessId, bulkTeamMemberInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamMembersApi.telephonyViewsNinjaTeamTeamMemberBulkTeamMemberInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check Team Member By Email
         * @param {number} businessId 
         * @param {CheckTeamMemberByEmailInSchema} checkTeamMemberByEmailInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaTeamTeamMemberCheckTeamMemberByEmail(businessId: number, checkTeamMemberByEmailInSchema: CheckTeamMemberByEmailInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckTeamMemberByEmailOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaTeamTeamMemberCheckTeamMemberByEmail(businessId, checkTeamMemberByEmailInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamMembersApi.telephonyViewsNinjaTeamTeamMemberCheckTeamMemberByEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Complete Team Member Onboarding
         * @param {number} businessId 
         * @param {TeamMemberOnboardingInSchema} teamMemberOnboardingInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaTeamTeamMemberCompleteTeamMemberOnboarding(businessId: number, teamMemberOnboardingInSchema: TeamMemberOnboardingInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaTeamTeamMemberCompleteTeamMemberOnboarding(businessId, teamMemberOnboardingInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamMembersApi.telephonyViewsNinjaTeamTeamMemberCompleteTeamMemberOnboarding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Team Member
         * @param {number} businessId 
         * @param {TeamMemberInSchema} teamMemberInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaTeamTeamMemberCreateTeamMember(businessId: number, teamMemberInSchema: TeamMemberInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamMemberOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaTeamTeamMemberCreateTeamMember(businessId, teamMemberInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamMembersApi.telephonyViewsNinjaTeamTeamMemberCreateTeamMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Team Member
         * @param {number} businessId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaTeamTeamMemberDeleteTeamMember(businessId: number, userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaTeamTeamMemberDeleteTeamMember(businessId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamMembersApi.telephonyViewsNinjaTeamTeamMemberDeleteTeamMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Team Member
         * @param {number} businessId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaTeamTeamMemberGetTeamMember(businessId: number, userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamMemberOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaTeamTeamMemberGetTeamMember(businessId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamMembersApi.telephonyViewsNinjaTeamTeamMemberGetTeamMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Team Member Invitations
         * @param {number} businessId 
         * @param {ProfileInvitationStatus | null} [invitationStatus] 
         * @param {number | null} [businessId2] 
         * @param {number | null} [businessNumberId] 
         * @param {number | null} [userId] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitations(businessId: number, invitationStatus?: ProfileInvitationStatus | null, businessId2?: number | null, businessNumberId?: number | null, userId?: number | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedInvitationOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitations(businessId, invitationStatus, businessId2, businessNumberId, userId, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamMembersApi.telephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Team Member Receiver Numbers
         * @param {number} businessId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaTeamTeamMemberGetTeamMemberReceiverNumbers(businessId: number, userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReceiverNumberMinimalOutSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaTeamTeamMemberGetTeamMemberReceiverNumbers(businessId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamMembersApi.telephonyViewsNinjaTeamTeamMemberGetTeamMemberReceiverNumbers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Team Member V2
         * @param {number} businessId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaTeamTeamMemberGetTeamMemberV2(businessId: number, userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamMemberOutSchemaV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaTeamTeamMemberGetTeamMemberV2(businessId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamMembersApi.telephonyViewsNinjaTeamTeamMemberGetTeamMemberV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Accept team member invitation for already existing users
         * @summary Join Team
         * @param {string} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaTeamTeamMemberInvitationJoinTeam(data: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaTeamTeamMemberInvitationJoinTeam(data, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamMembersApi.telephonyViewsNinjaTeamTeamMemberInvitationJoinTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Team Members
         * @param {number} businessId 
         * @param {boolean} [showAll] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaTeamTeamMemberListTeamMembers(businessId: number, showAll?: boolean, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedTeamMemberMinimalOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaTeamTeamMemberListTeamMembers(businessId, showAll, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamMembersApi.telephonyViewsNinjaTeamTeamMemberListTeamMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Team Members V2
         * @param {number} businessId 
         * @param {boolean} [showAll] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaTeamTeamMemberListTeamMembersV2(businessId: number, showAll?: boolean, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedProfileMinimalOutSchemaV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaTeamTeamMemberListTeamMembersV2(businessId, showAll, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamMembersApi.telephonyViewsNinjaTeamTeamMemberListTeamMembersV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Nudge Team Member
         * @param {number} businessId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaTeamTeamMemberNudgeTeamMember(businessId: number, userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaTeamTeamMemberNudgeTeamMember(businessId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamMembersApi.telephonyViewsNinjaTeamTeamMemberNudgeTeamMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Team Member Permission
         * @param {number} businessId 
         * @param {number} userId 
         * @param {PermissionInSchema} permissionInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberPermission(businessId: number, userId: number, permissionInSchema: PermissionInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberPermission(businessId, userId, permissionInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamMembersApi.telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberPermission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Team Member Profile
         * @param {number} businessId 
         * @param {number} userId 
         * @param {ProfileInSchema} profileInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberProfile(businessId: number, userId: number, profileInSchema: ProfileInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberProfile(businessId, userId, profileInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamMembersApi.telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Permission
         * @param {number} businessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaBusinessListPermission(businessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleBasedPermissionsOutSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaBusinessListPermission(businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamMembersApi.usersViewsNinjaBusinessListPermission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamMembersApi - factory interface
 * @export
 */
export const TeamMembersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamMembersApiFp(configuration)
    return {
        /**
         * Accept team member invitation for new users from onboarding page
         * @summary Accept Team Invitation
         * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberAcceptTeamInvitationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberAcceptTeamInvitation(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberAcceptTeamInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<RedirectURLResponse> {
            return localVarFp.telephonyViewsNinjaTeamTeamMemberAcceptTeamInvitation(requestParameters.invitationId, requestParameters.teamMemberInvitationAcceptanceInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk Create Team Members
         * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberBulkCreateTeamMembersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberBulkCreateTeamMembers(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberBulkCreateTeamMembersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.telephonyViewsNinjaTeamTeamMemberBulkCreateTeamMembers(requestParameters.businessId, requestParameters.bulkTeamMemberInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk Team Member Invitation
         * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberBulkTeamMemberInvitationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberBulkTeamMemberInvitation(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberBulkTeamMemberInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.telephonyViewsNinjaTeamTeamMemberBulkTeamMemberInvitation(requestParameters.businessId, requestParameters.bulkTeamMemberInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check Team Member By Email
         * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCheckTeamMemberByEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberCheckTeamMemberByEmail(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCheckTeamMemberByEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<CheckTeamMemberByEmailOutSchema> {
            return localVarFp.telephonyViewsNinjaTeamTeamMemberCheckTeamMemberByEmail(requestParameters.businessId, requestParameters.checkTeamMemberByEmailInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Complete Team Member Onboarding
         * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCompleteTeamMemberOnboardingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberCompleteTeamMemberOnboarding(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCompleteTeamMemberOnboardingRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.telephonyViewsNinjaTeamTeamMemberCompleteTeamMemberOnboarding(requestParameters.businessId, requestParameters.teamMemberOnboardingInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Team Member
         * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCreateTeamMemberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberCreateTeamMember(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCreateTeamMemberRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamMemberOutSchema> {
            return localVarFp.telephonyViewsNinjaTeamTeamMemberCreateTeamMember(requestParameters.businessId, requestParameters.teamMemberInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Team Member
         * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberDeleteTeamMemberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberDeleteTeamMember(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberDeleteTeamMemberRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.telephonyViewsNinjaTeamTeamMemberDeleteTeamMember(requestParameters.businessId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Team Member
         * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberGetTeamMember(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamMemberOutSchema> {
            return localVarFp.telephonyViewsNinjaTeamTeamMemberGetTeamMember(requestParameters.businessId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Team Member Invitations
         * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitations(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedInvitationOutSchema> {
            return localVarFp.telephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitations(requestParameters.businessId, requestParameters.invitationStatus, requestParameters.businessId2, requestParameters.businessNumberId, requestParameters.userId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Team Member Receiver Numbers
         * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberReceiverNumbersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberGetTeamMemberReceiverNumbers(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberReceiverNumbersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ReceiverNumberMinimalOutSchema>> {
            return localVarFp.telephonyViewsNinjaTeamTeamMemberGetTeamMemberReceiverNumbers(requestParameters.businessId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Team Member V2
         * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberGetTeamMemberV2(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberV2Request, options?: RawAxiosRequestConfig): AxiosPromise<TeamMemberOutSchemaV2> {
            return localVarFp.telephonyViewsNinjaTeamTeamMemberGetTeamMemberV2(requestParameters.businessId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Accept team member invitation for already existing users
         * @summary Join Team
         * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberInvitationJoinTeamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberInvitationJoinTeam(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberInvitationJoinTeamRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.telephonyViewsNinjaTeamTeamMemberInvitationJoinTeam(requestParameters.data, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Team Members
         * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberListTeamMembersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberListTeamMembers(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberListTeamMembersRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedTeamMemberMinimalOutSchema> {
            return localVarFp.telephonyViewsNinjaTeamTeamMemberListTeamMembers(requestParameters.businessId, requestParameters.showAll, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Team Members V2
         * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberListTeamMembersV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberListTeamMembersV2(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberListTeamMembersV2Request, options?: RawAxiosRequestConfig): AxiosPromise<PagedProfileMinimalOutSchemaV2> {
            return localVarFp.telephonyViewsNinjaTeamTeamMemberListTeamMembersV2(requestParameters.businessId, requestParameters.showAll, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Nudge Team Member
         * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberNudgeTeamMemberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberNudgeTeamMember(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberNudgeTeamMemberRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.telephonyViewsNinjaTeamTeamMemberNudgeTeamMember(requestParameters.businessId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Team Member Permission
         * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberUpdateTeamMemberPermissionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberPermission(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberUpdateTeamMemberPermissionRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberPermission(requestParameters.businessId, requestParameters.userId, requestParameters.permissionInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Team Member Profile
         * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberUpdateTeamMemberProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberProfile(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberUpdateTeamMemberProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberProfile(requestParameters.businessId, requestParameters.userId, requestParameters.profileInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Permission
         * @param {TeamMembersApiUsersViewsNinjaBusinessListPermissionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaBusinessListPermission(requestParameters: TeamMembersApiUsersViewsNinjaBusinessListPermissionRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<RoleBasedPermissionsOutSchema>> {
            return localVarFp.usersViewsNinjaBusinessListPermission(requestParameters.businessId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for telephonyViewsNinjaTeamTeamMemberAcceptTeamInvitation operation in TeamMembersApi.
 * @export
 * @interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberAcceptTeamInvitationRequest
 */
export interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberAcceptTeamInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberAcceptTeamInvitation
     */
    readonly invitationId: string

    /**
     * 
     * @type {TeamMemberInvitationAcceptanceInSchema}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberAcceptTeamInvitation
     */
    readonly teamMemberInvitationAcceptanceInSchema: TeamMemberInvitationAcceptanceInSchema
}

/**
 * Request parameters for telephonyViewsNinjaTeamTeamMemberBulkCreateTeamMembers operation in TeamMembersApi.
 * @export
 * @interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberBulkCreateTeamMembersRequest
 */
export interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberBulkCreateTeamMembersRequest {
    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberBulkCreateTeamMembers
     */
    readonly businessId: number

    /**
     * 
     * @type {BulkTeamMemberInSchema}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberBulkCreateTeamMembers
     */
    readonly bulkTeamMemberInSchema: BulkTeamMemberInSchema
}

/**
 * Request parameters for telephonyViewsNinjaTeamTeamMemberBulkTeamMemberInvitation operation in TeamMembersApi.
 * @export
 * @interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberBulkTeamMemberInvitationRequest
 */
export interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberBulkTeamMemberInvitationRequest {
    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberBulkTeamMemberInvitation
     */
    readonly businessId: number

    /**
     * 
     * @type {BulkTeamMemberInSchema}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberBulkTeamMemberInvitation
     */
    readonly bulkTeamMemberInSchema: BulkTeamMemberInSchema
}

/**
 * Request parameters for telephonyViewsNinjaTeamTeamMemberCheckTeamMemberByEmail operation in TeamMembersApi.
 * @export
 * @interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCheckTeamMemberByEmailRequest
 */
export interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCheckTeamMemberByEmailRequest {
    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCheckTeamMemberByEmail
     */
    readonly businessId: number

    /**
     * 
     * @type {CheckTeamMemberByEmailInSchema}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCheckTeamMemberByEmail
     */
    readonly checkTeamMemberByEmailInSchema: CheckTeamMemberByEmailInSchema
}

/**
 * Request parameters for telephonyViewsNinjaTeamTeamMemberCompleteTeamMemberOnboarding operation in TeamMembersApi.
 * @export
 * @interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCompleteTeamMemberOnboardingRequest
 */
export interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCompleteTeamMemberOnboardingRequest {
    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCompleteTeamMemberOnboarding
     */
    readonly businessId: number

    /**
     * 
     * @type {TeamMemberOnboardingInSchema}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCompleteTeamMemberOnboarding
     */
    readonly teamMemberOnboardingInSchema: TeamMemberOnboardingInSchema
}

/**
 * Request parameters for telephonyViewsNinjaTeamTeamMemberCreateTeamMember operation in TeamMembersApi.
 * @export
 * @interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCreateTeamMemberRequest
 */
export interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCreateTeamMemberRequest {
    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCreateTeamMember
     */
    readonly businessId: number

    /**
     * 
     * @type {TeamMemberInSchema}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCreateTeamMember
     */
    readonly teamMemberInSchema: TeamMemberInSchema
}

/**
 * Request parameters for telephonyViewsNinjaTeamTeamMemberDeleteTeamMember operation in TeamMembersApi.
 * @export
 * @interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberDeleteTeamMemberRequest
 */
export interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberDeleteTeamMemberRequest {
    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberDeleteTeamMember
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberDeleteTeamMember
     */
    readonly userId: number
}

/**
 * Request parameters for telephonyViewsNinjaTeamTeamMemberGetTeamMember operation in TeamMembersApi.
 * @export
 * @interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberRequest
 */
export interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberRequest {
    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMember
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMember
     */
    readonly userId: number
}

/**
 * Request parameters for telephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitations operation in TeamMembersApi.
 * @export
 * @interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitationsRequest
 */
export interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitationsRequest {
    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitations
     */
    readonly businessId: number

    /**
     * 
     * @type {ProfileInvitationStatus}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitations
     */
    readonly invitationStatus?: ProfileInvitationStatus | null

    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitations
     */
    readonly businessId2?: number | null

    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitations
     */
    readonly businessNumberId?: number | null

    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitations
     */
    readonly userId?: number | null

    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitations
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitations
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitations
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for telephonyViewsNinjaTeamTeamMemberGetTeamMemberReceiverNumbers operation in TeamMembersApi.
 * @export
 * @interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberReceiverNumbersRequest
 */
export interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberReceiverNumbersRequest {
    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberReceiverNumbers
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberReceiverNumbers
     */
    readonly userId: number
}

/**
 * Request parameters for telephonyViewsNinjaTeamTeamMemberGetTeamMemberV2 operation in TeamMembersApi.
 * @export
 * @interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberV2Request
 */
export interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberV2Request {
    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberV2
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberV2
     */
    readonly userId: number
}

/**
 * Request parameters for telephonyViewsNinjaTeamTeamMemberInvitationJoinTeam operation in TeamMembersApi.
 * @export
 * @interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberInvitationJoinTeamRequest
 */
export interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberInvitationJoinTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberInvitationJoinTeam
     */
    readonly data: string
}

/**
 * Request parameters for telephonyViewsNinjaTeamTeamMemberListTeamMembers operation in TeamMembersApi.
 * @export
 * @interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberListTeamMembersRequest
 */
export interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberListTeamMembersRequest {
    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberListTeamMembers
     */
    readonly businessId: number

    /**
     * 
     * @type {boolean}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberListTeamMembers
     */
    readonly showAll?: boolean

    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberListTeamMembers
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberListTeamMembers
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberListTeamMembers
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for telephonyViewsNinjaTeamTeamMemberListTeamMembersV2 operation in TeamMembersApi.
 * @export
 * @interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberListTeamMembersV2Request
 */
export interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberListTeamMembersV2Request {
    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberListTeamMembersV2
     */
    readonly businessId: number

    /**
     * 
     * @type {boolean}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberListTeamMembersV2
     */
    readonly showAll?: boolean

    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberListTeamMembersV2
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberListTeamMembersV2
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberListTeamMembersV2
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for telephonyViewsNinjaTeamTeamMemberNudgeTeamMember operation in TeamMembersApi.
 * @export
 * @interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberNudgeTeamMemberRequest
 */
export interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberNudgeTeamMemberRequest {
    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberNudgeTeamMember
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberNudgeTeamMember
     */
    readonly userId: number
}

/**
 * Request parameters for telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberPermission operation in TeamMembersApi.
 * @export
 * @interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberUpdateTeamMemberPermissionRequest
 */
export interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberUpdateTeamMemberPermissionRequest {
    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberUpdateTeamMemberPermission
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberUpdateTeamMemberPermission
     */
    readonly userId: number

    /**
     * 
     * @type {PermissionInSchema}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberUpdateTeamMemberPermission
     */
    readonly permissionInSchema: PermissionInSchema
}

/**
 * Request parameters for telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberProfile operation in TeamMembersApi.
 * @export
 * @interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberUpdateTeamMemberProfileRequest
 */
export interface TeamMembersApiTelephonyViewsNinjaTeamTeamMemberUpdateTeamMemberProfileRequest {
    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberUpdateTeamMemberProfile
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberUpdateTeamMemberProfile
     */
    readonly userId: number

    /**
     * 
     * @type {ProfileInSchema}
     * @memberof TeamMembersApiTelephonyViewsNinjaTeamTeamMemberUpdateTeamMemberProfile
     */
    readonly profileInSchema: ProfileInSchema
}

/**
 * Request parameters for usersViewsNinjaBusinessListPermission operation in TeamMembersApi.
 * @export
 * @interface TeamMembersApiUsersViewsNinjaBusinessListPermissionRequest
 */
export interface TeamMembersApiUsersViewsNinjaBusinessListPermissionRequest {
    /**
     * 
     * @type {number}
     * @memberof TeamMembersApiUsersViewsNinjaBusinessListPermission
     */
    readonly businessId: number
}

/**
 * TeamMembersApi - object-oriented interface
 * @export
 * @class TeamMembersApi
 * @extends {BaseAPI}
 */
export class TeamMembersApi extends BaseAPI {
    /**
     * Accept team member invitation for new users from onboarding page
     * @summary Accept Team Invitation
     * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberAcceptTeamInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamMembersApi
     */
    public telephonyViewsNinjaTeamTeamMemberAcceptTeamInvitation(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberAcceptTeamInvitationRequest, options?: RawAxiosRequestConfig) {
        return TeamMembersApiFp(this.configuration).telephonyViewsNinjaTeamTeamMemberAcceptTeamInvitation(requestParameters.invitationId, requestParameters.teamMemberInvitationAcceptanceInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk Create Team Members
     * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberBulkCreateTeamMembersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamMembersApi
     */
    public telephonyViewsNinjaTeamTeamMemberBulkCreateTeamMembers(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberBulkCreateTeamMembersRequest, options?: RawAxiosRequestConfig) {
        return TeamMembersApiFp(this.configuration).telephonyViewsNinjaTeamTeamMemberBulkCreateTeamMembers(requestParameters.businessId, requestParameters.bulkTeamMemberInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk Team Member Invitation
     * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberBulkTeamMemberInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamMembersApi
     */
    public telephonyViewsNinjaTeamTeamMemberBulkTeamMemberInvitation(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberBulkTeamMemberInvitationRequest, options?: RawAxiosRequestConfig) {
        return TeamMembersApiFp(this.configuration).telephonyViewsNinjaTeamTeamMemberBulkTeamMemberInvitation(requestParameters.businessId, requestParameters.bulkTeamMemberInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check Team Member By Email
     * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCheckTeamMemberByEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamMembersApi
     */
    public telephonyViewsNinjaTeamTeamMemberCheckTeamMemberByEmail(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCheckTeamMemberByEmailRequest, options?: RawAxiosRequestConfig) {
        return TeamMembersApiFp(this.configuration).telephonyViewsNinjaTeamTeamMemberCheckTeamMemberByEmail(requestParameters.businessId, requestParameters.checkTeamMemberByEmailInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Complete Team Member Onboarding
     * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCompleteTeamMemberOnboardingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamMembersApi
     */
    public telephonyViewsNinjaTeamTeamMemberCompleteTeamMemberOnboarding(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCompleteTeamMemberOnboardingRequest, options?: RawAxiosRequestConfig) {
        return TeamMembersApiFp(this.configuration).telephonyViewsNinjaTeamTeamMemberCompleteTeamMemberOnboarding(requestParameters.businessId, requestParameters.teamMemberOnboardingInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Team Member
     * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCreateTeamMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamMembersApi
     */
    public telephonyViewsNinjaTeamTeamMemberCreateTeamMember(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberCreateTeamMemberRequest, options?: RawAxiosRequestConfig) {
        return TeamMembersApiFp(this.configuration).telephonyViewsNinjaTeamTeamMemberCreateTeamMember(requestParameters.businessId, requestParameters.teamMemberInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Team Member
     * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberDeleteTeamMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamMembersApi
     */
    public telephonyViewsNinjaTeamTeamMemberDeleteTeamMember(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberDeleteTeamMemberRequest, options?: RawAxiosRequestConfig) {
        return TeamMembersApiFp(this.configuration).telephonyViewsNinjaTeamTeamMemberDeleteTeamMember(requestParameters.businessId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Team Member
     * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof TeamMembersApi
     */
    public telephonyViewsNinjaTeamTeamMemberGetTeamMember(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberRequest, options?: RawAxiosRequestConfig) {
        return TeamMembersApiFp(this.configuration).telephonyViewsNinjaTeamTeamMemberGetTeamMember(requestParameters.businessId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Team Member Invitations
     * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamMembersApi
     */
    public telephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitations(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitationsRequest, options?: RawAxiosRequestConfig) {
        return TeamMembersApiFp(this.configuration).telephonyViewsNinjaTeamTeamMemberGetTeamMemberInvitations(requestParameters.businessId, requestParameters.invitationStatus, requestParameters.businessId2, requestParameters.businessNumberId, requestParameters.userId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Team Member Receiver Numbers
     * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberReceiverNumbersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamMembersApi
     */
    public telephonyViewsNinjaTeamTeamMemberGetTeamMemberReceiverNumbers(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberReceiverNumbersRequest, options?: RawAxiosRequestConfig) {
        return TeamMembersApiFp(this.configuration).telephonyViewsNinjaTeamTeamMemberGetTeamMemberReceiverNumbers(requestParameters.businessId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Team Member V2
     * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamMembersApi
     */
    public telephonyViewsNinjaTeamTeamMemberGetTeamMemberV2(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberGetTeamMemberV2Request, options?: RawAxiosRequestConfig) {
        return TeamMembersApiFp(this.configuration).telephonyViewsNinjaTeamTeamMemberGetTeamMemberV2(requestParameters.businessId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accept team member invitation for already existing users
     * @summary Join Team
     * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberInvitationJoinTeamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamMembersApi
     */
    public telephonyViewsNinjaTeamTeamMemberInvitationJoinTeam(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberInvitationJoinTeamRequest, options?: RawAxiosRequestConfig) {
        return TeamMembersApiFp(this.configuration).telephonyViewsNinjaTeamTeamMemberInvitationJoinTeam(requestParameters.data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Team Members
     * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberListTeamMembersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamMembersApi
     */
    public telephonyViewsNinjaTeamTeamMemberListTeamMembers(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberListTeamMembersRequest, options?: RawAxiosRequestConfig) {
        return TeamMembersApiFp(this.configuration).telephonyViewsNinjaTeamTeamMemberListTeamMembers(requestParameters.businessId, requestParameters.showAll, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Team Members V2
     * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberListTeamMembersV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamMembersApi
     */
    public telephonyViewsNinjaTeamTeamMemberListTeamMembersV2(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberListTeamMembersV2Request, options?: RawAxiosRequestConfig) {
        return TeamMembersApiFp(this.configuration).telephonyViewsNinjaTeamTeamMemberListTeamMembersV2(requestParameters.businessId, requestParameters.showAll, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Nudge Team Member
     * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberNudgeTeamMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamMembersApi
     */
    public telephonyViewsNinjaTeamTeamMemberNudgeTeamMember(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberNudgeTeamMemberRequest, options?: RawAxiosRequestConfig) {
        return TeamMembersApiFp(this.configuration).telephonyViewsNinjaTeamTeamMemberNudgeTeamMember(requestParameters.businessId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Team Member Permission
     * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberUpdateTeamMemberPermissionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamMembersApi
     */
    public telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberPermission(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberUpdateTeamMemberPermissionRequest, options?: RawAxiosRequestConfig) {
        return TeamMembersApiFp(this.configuration).telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberPermission(requestParameters.businessId, requestParameters.userId, requestParameters.permissionInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Team Member Profile
     * @param {TeamMembersApiTelephonyViewsNinjaTeamTeamMemberUpdateTeamMemberProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamMembersApi
     */
    public telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberProfile(requestParameters: TeamMembersApiTelephonyViewsNinjaTeamTeamMemberUpdateTeamMemberProfileRequest, options?: RawAxiosRequestConfig) {
        return TeamMembersApiFp(this.configuration).telephonyViewsNinjaTeamTeamMemberUpdateTeamMemberProfile(requestParameters.businessId, requestParameters.userId, requestParameters.profileInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Permission
     * @param {TeamMembersApiUsersViewsNinjaBusinessListPermissionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamMembersApi
     */
    public usersViewsNinjaBusinessListPermission(requestParameters: TeamMembersApiUsersViewsNinjaBusinessListPermissionRequest, options?: RawAxiosRequestConfig) {
        return TeamMembersApiFp(this.configuration).usersViewsNinjaBusinessListPermission(requestParameters.businessId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TelephonyApi - axios parameter creator
 * @export
 */
export const TelephonyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Provision Number
         * @param {ProvisionNumberInSchemaV2} provisionNumberInSchemaV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberProvisionProvisionNumber: async (provisionNumberInSchemaV2: ProvisionNumberInSchemaV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'provisionNumberInSchemaV2' is not null or undefined
            assertParamExists('telephonyViewsNinjaNumberProvisionProvisionNumber', 'provisionNumberInSchemaV2', provisionNumberInSchemaV2)
            const localVarPath = `/api/telephony/provision-number/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(provisionNumberInSchemaV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TelephonyApi - functional programming interface
 * @export
 */
export const TelephonyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TelephonyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Provision Number
         * @param {ProvisionNumberInSchemaV2} provisionNumberInSchemaV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaNumberProvisionProvisionNumber(provisionNumberInSchemaV2: ProvisionNumberInSchemaV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaNumberProvisionProvisionNumber(provisionNumberInSchemaV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TelephonyApi.telephonyViewsNinjaNumberProvisionProvisionNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TelephonyApi - factory interface
 * @export
 */
export const TelephonyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TelephonyApiFp(configuration)
    return {
        /**
         * 
         * @summary Provision Number
         * @param {TelephonyApiTelephonyViewsNinjaNumberProvisionProvisionNumberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaNumberProvisionProvisionNumber(requestParameters: TelephonyApiTelephonyViewsNinjaNumberProvisionProvisionNumberRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.telephonyViewsNinjaNumberProvisionProvisionNumber(requestParameters.provisionNumberInSchemaV2, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for telephonyViewsNinjaNumberProvisionProvisionNumber operation in TelephonyApi.
 * @export
 * @interface TelephonyApiTelephonyViewsNinjaNumberProvisionProvisionNumberRequest
 */
export interface TelephonyApiTelephonyViewsNinjaNumberProvisionProvisionNumberRequest {
    /**
     * 
     * @type {ProvisionNumberInSchemaV2}
     * @memberof TelephonyApiTelephonyViewsNinjaNumberProvisionProvisionNumber
     */
    readonly provisionNumberInSchemaV2: ProvisionNumberInSchemaV2
}

/**
 * TelephonyApi - object-oriented interface
 * @export
 * @class TelephonyApi
 * @extends {BaseAPI}
 */
export class TelephonyApi extends BaseAPI {
    /**
     * 
     * @summary Provision Number
     * @param {TelephonyApiTelephonyViewsNinjaNumberProvisionProvisionNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TelephonyApi
     */
    public telephonyViewsNinjaNumberProvisionProvisionNumber(requestParameters: TelephonyApiTelephonyViewsNinjaNumberProvisionProvisionNumberRequest, options?: RawAxiosRequestConfig) {
        return TelephonyApiFp(this.configuration).telephonyViewsNinjaNumberProvisionProvisionNumber(requestParameters.provisionNumberInSchemaV2, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ThirdPartyChatterwaveApi - axios parameter creator
 * @export
 */
export const ThirdPartyChatterwaveApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Third Party List Text To Speech
         * @param {string | null} [search] 
         * @param {number | null} [businessNumberId] 
         * @param {string | null} [status] 
         * @param {string | null} [dateCreatedBefore] 
         * @param {string | null} [dateCreatedAfter] 
         * @param {string | null} [sessionId] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartyChatterwaveThirdPartyListTextToSpeech: async (search?: string | null, businessNumberId?: number | null, status?: string | null, dateCreatedBefore?: string | null, dateCreatedAfter?: string | null, sessionId?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/third-party/chatterwave/text-to-speech/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (businessNumberId !== undefined) {
                localVarQueryParameter['business_number_id'] = businessNumberId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (dateCreatedBefore !== undefined) {
                localVarQueryParameter['date_created_before'] = dateCreatedBefore;
            }

            if (dateCreatedAfter !== undefined) {
                localVarQueryParameter['date_created_after'] = dateCreatedAfter;
            }

            if (sessionId !== undefined) {
                localVarQueryParameter['session_id'] = sessionId;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Third Party List Voice Otp
         * @param {string | null} [search] 
         * @param {number | null} [businessNumberId] 
         * @param {string | null} [status] 
         * @param {string | null} [dateCreatedBefore] 
         * @param {string | null} [dateCreatedAfter] 
         * @param {string | null} [sessionId] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartyChatterwaveThirdPartyListVoiceOtp: async (search?: string | null, businessNumberId?: number | null, status?: string | null, dateCreatedBefore?: string | null, dateCreatedAfter?: string | null, sessionId?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/third-party/chatterwave/voice-otp/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (businessNumberId !== undefined) {
                localVarQueryParameter['business_number_id'] = businessNumberId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (dateCreatedBefore !== undefined) {
                localVarQueryParameter['date_created_before'] = dateCreatedBefore;
            }

            if (dateCreatedAfter !== undefined) {
                localVarQueryParameter['date_created_after'] = dateCreatedAfter;
            }

            if (sessionId !== undefined) {
                localVarQueryParameter['session_id'] = sessionId;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Third Party Send Text To Speech Otp
         * @param {TextToSpeechInSchema} textToSpeechInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartyChatterwaveThirdPartySendTextToSpeechOtp: async (textToSpeechInSchema: TextToSpeechInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'textToSpeechInSchema' is not null or undefined
            assertParamExists('developerViewsThirdPartyChatterwaveThirdPartySendTextToSpeechOtp', 'textToSpeechInSchema', textToSpeechInSchema)
            const localVarPath = `/api/third-party/chatterwave/text-to-speech/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(textToSpeechInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Third Party Send Voice Otp
         * @param {VoiceOtpInSchema} voiceOtpInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartyChatterwaveThirdPartySendVoiceOtp: async (voiceOtpInSchema: VoiceOtpInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voiceOtpInSchema' is not null or undefined
            assertParamExists('developerViewsThirdPartyChatterwaveThirdPartySendVoiceOtp', 'voiceOtpInSchema', voiceOtpInSchema)
            const localVarPath = `/api/third-party/chatterwave/voice-otp/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voiceOtpInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ThirdPartyChatterwaveApi - functional programming interface
 * @export
 */
export const ThirdPartyChatterwaveApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ThirdPartyChatterwaveApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Third Party List Text To Speech
         * @param {string | null} [search] 
         * @param {number | null} [businessNumberId] 
         * @param {string | null} [status] 
         * @param {string | null} [dateCreatedBefore] 
         * @param {string | null} [dateCreatedAfter] 
         * @param {string | null} [sessionId] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerViewsThirdPartyChatterwaveThirdPartyListTextToSpeech(search?: string | null, businessNumberId?: number | null, status?: string | null, dateCreatedBefore?: string | null, dateCreatedAfter?: string | null, sessionId?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedChatterWaveOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerViewsThirdPartyChatterwaveThirdPartyListTextToSpeech(search, businessNumberId, status, dateCreatedBefore, dateCreatedAfter, sessionId, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThirdPartyChatterwaveApi.developerViewsThirdPartyChatterwaveThirdPartyListTextToSpeech']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Third Party List Voice Otp
         * @param {string | null} [search] 
         * @param {number | null} [businessNumberId] 
         * @param {string | null} [status] 
         * @param {string | null} [dateCreatedBefore] 
         * @param {string | null} [dateCreatedAfter] 
         * @param {string | null} [sessionId] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerViewsThirdPartyChatterwaveThirdPartyListVoiceOtp(search?: string | null, businessNumberId?: number | null, status?: string | null, dateCreatedBefore?: string | null, dateCreatedAfter?: string | null, sessionId?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedChatterWaveOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerViewsThirdPartyChatterwaveThirdPartyListVoiceOtp(search, businessNumberId, status, dateCreatedBefore, dateCreatedAfter, sessionId, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThirdPartyChatterwaveApi.developerViewsThirdPartyChatterwaveThirdPartyListVoiceOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Third Party Send Text To Speech Otp
         * @param {TextToSpeechInSchema} textToSpeechInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerViewsThirdPartyChatterwaveThirdPartySendTextToSpeechOtp(textToSpeechInSchema: TextToSpeechInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerViewsThirdPartyChatterwaveThirdPartySendTextToSpeechOtp(textToSpeechInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThirdPartyChatterwaveApi.developerViewsThirdPartyChatterwaveThirdPartySendTextToSpeechOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Third Party Send Voice Otp
         * @param {VoiceOtpInSchema} voiceOtpInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerViewsThirdPartyChatterwaveThirdPartySendVoiceOtp(voiceOtpInSchema: VoiceOtpInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerViewsThirdPartyChatterwaveThirdPartySendVoiceOtp(voiceOtpInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThirdPartyChatterwaveApi.developerViewsThirdPartyChatterwaveThirdPartySendVoiceOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ThirdPartyChatterwaveApi - factory interface
 * @export
 */
export const ThirdPartyChatterwaveApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ThirdPartyChatterwaveApiFp(configuration)
    return {
        /**
         * 
         * @summary Third Party List Text To Speech
         * @param {ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListTextToSpeechRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartyChatterwaveThirdPartyListTextToSpeech(requestParameters: ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListTextToSpeechRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PagedChatterWaveOutSchema> {
            return localVarFp.developerViewsThirdPartyChatterwaveThirdPartyListTextToSpeech(requestParameters.search, requestParameters.businessNumberId, requestParameters.status, requestParameters.dateCreatedBefore, requestParameters.dateCreatedAfter, requestParameters.sessionId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Third Party List Voice Otp
         * @param {ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListVoiceOtpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartyChatterwaveThirdPartyListVoiceOtp(requestParameters: ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListVoiceOtpRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PagedChatterWaveOutSchema> {
            return localVarFp.developerViewsThirdPartyChatterwaveThirdPartyListVoiceOtp(requestParameters.search, requestParameters.businessNumberId, requestParameters.status, requestParameters.dateCreatedBefore, requestParameters.dateCreatedAfter, requestParameters.sessionId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Third Party Send Text To Speech Otp
         * @param {ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartySendTextToSpeechOtpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartyChatterwaveThirdPartySendTextToSpeechOtp(requestParameters: ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartySendTextToSpeechOtpRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.developerViewsThirdPartyChatterwaveThirdPartySendTextToSpeechOtp(requestParameters.textToSpeechInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Third Party Send Voice Otp
         * @param {ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartySendVoiceOtpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartyChatterwaveThirdPartySendVoiceOtp(requestParameters: ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartySendVoiceOtpRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.developerViewsThirdPartyChatterwaveThirdPartySendVoiceOtp(requestParameters.voiceOtpInSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for developerViewsThirdPartyChatterwaveThirdPartyListTextToSpeech operation in ThirdPartyChatterwaveApi.
 * @export
 * @interface ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListTextToSpeechRequest
 */
export interface ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListTextToSpeechRequest {
    /**
     * 
     * @type {string}
     * @memberof ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListTextToSpeech
     */
    readonly search?: string | null

    /**
     * 
     * @type {number}
     * @memberof ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListTextToSpeech
     */
    readonly businessNumberId?: number | null

    /**
     * 
     * @type {string}
     * @memberof ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListTextToSpeech
     */
    readonly status?: string | null

    /**
     * 
     * @type {string}
     * @memberof ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListTextToSpeech
     */
    readonly dateCreatedBefore?: string | null

    /**
     * 
     * @type {string}
     * @memberof ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListTextToSpeech
     */
    readonly dateCreatedAfter?: string | null

    /**
     * 
     * @type {string}
     * @memberof ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListTextToSpeech
     */
    readonly sessionId?: string | null

    /**
     * 
     * @type {number}
     * @memberof ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListTextToSpeech
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListTextToSpeech
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListTextToSpeech
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for developerViewsThirdPartyChatterwaveThirdPartyListVoiceOtp operation in ThirdPartyChatterwaveApi.
 * @export
 * @interface ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListVoiceOtpRequest
 */
export interface ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListVoiceOtpRequest {
    /**
     * 
     * @type {string}
     * @memberof ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListVoiceOtp
     */
    readonly search?: string | null

    /**
     * 
     * @type {number}
     * @memberof ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListVoiceOtp
     */
    readonly businessNumberId?: number | null

    /**
     * 
     * @type {string}
     * @memberof ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListVoiceOtp
     */
    readonly status?: string | null

    /**
     * 
     * @type {string}
     * @memberof ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListVoiceOtp
     */
    readonly dateCreatedBefore?: string | null

    /**
     * 
     * @type {string}
     * @memberof ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListVoiceOtp
     */
    readonly dateCreatedAfter?: string | null

    /**
     * 
     * @type {string}
     * @memberof ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListVoiceOtp
     */
    readonly sessionId?: string | null

    /**
     * 
     * @type {number}
     * @memberof ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListVoiceOtp
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListVoiceOtp
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListVoiceOtp
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for developerViewsThirdPartyChatterwaveThirdPartySendTextToSpeechOtp operation in ThirdPartyChatterwaveApi.
 * @export
 * @interface ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartySendTextToSpeechOtpRequest
 */
export interface ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartySendTextToSpeechOtpRequest {
    /**
     * 
     * @type {TextToSpeechInSchema}
     * @memberof ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartySendTextToSpeechOtp
     */
    readonly textToSpeechInSchema: TextToSpeechInSchema
}

/**
 * Request parameters for developerViewsThirdPartyChatterwaveThirdPartySendVoiceOtp operation in ThirdPartyChatterwaveApi.
 * @export
 * @interface ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartySendVoiceOtpRequest
 */
export interface ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartySendVoiceOtpRequest {
    /**
     * 
     * @type {VoiceOtpInSchema}
     * @memberof ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartySendVoiceOtp
     */
    readonly voiceOtpInSchema: VoiceOtpInSchema
}

/**
 * ThirdPartyChatterwaveApi - object-oriented interface
 * @export
 * @class ThirdPartyChatterwaveApi
 * @extends {BaseAPI}
 */
export class ThirdPartyChatterwaveApi extends BaseAPI {
    /**
     * 
     * @summary Third Party List Text To Speech
     * @param {ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListTextToSpeechRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdPartyChatterwaveApi
     */
    public developerViewsThirdPartyChatterwaveThirdPartyListTextToSpeech(requestParameters: ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListTextToSpeechRequest = {}, options?: RawAxiosRequestConfig) {
        return ThirdPartyChatterwaveApiFp(this.configuration).developerViewsThirdPartyChatterwaveThirdPartyListTextToSpeech(requestParameters.search, requestParameters.businessNumberId, requestParameters.status, requestParameters.dateCreatedBefore, requestParameters.dateCreatedAfter, requestParameters.sessionId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Third Party List Voice Otp
     * @param {ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListVoiceOtpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdPartyChatterwaveApi
     */
    public developerViewsThirdPartyChatterwaveThirdPartyListVoiceOtp(requestParameters: ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartyListVoiceOtpRequest = {}, options?: RawAxiosRequestConfig) {
        return ThirdPartyChatterwaveApiFp(this.configuration).developerViewsThirdPartyChatterwaveThirdPartyListVoiceOtp(requestParameters.search, requestParameters.businessNumberId, requestParameters.status, requestParameters.dateCreatedBefore, requestParameters.dateCreatedAfter, requestParameters.sessionId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Third Party Send Text To Speech Otp
     * @param {ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartySendTextToSpeechOtpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdPartyChatterwaveApi
     */
    public developerViewsThirdPartyChatterwaveThirdPartySendTextToSpeechOtp(requestParameters: ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartySendTextToSpeechOtpRequest, options?: RawAxiosRequestConfig) {
        return ThirdPartyChatterwaveApiFp(this.configuration).developerViewsThirdPartyChatterwaveThirdPartySendTextToSpeechOtp(requestParameters.textToSpeechInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Third Party Send Voice Otp
     * @param {ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartySendVoiceOtpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdPartyChatterwaveApi
     */
    public developerViewsThirdPartyChatterwaveThirdPartySendVoiceOtp(requestParameters: ThirdPartyChatterwaveApiDeveloperViewsThirdPartyChatterwaveThirdPartySendVoiceOtpRequest, options?: RawAxiosRequestConfig) {
        return ThirdPartyChatterwaveApiFp(this.configuration).developerViewsThirdPartyChatterwaveThirdPartySendVoiceOtp(requestParameters.voiceOtpInSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ThirdPartyPartnerApi - axios parameter creator
 * @export
 */
export const ThirdPartyPartnerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List Users
         * @param {string | null} [mobile] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartyPartnerListUsers: async (mobile?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/third-party/partner/user/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (mobile !== undefined) {
                localVarQueryParameter['mobile'] = mobile;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register Third Party Partner User
         * @param {OnboardPartnerUserInSchema} onboardPartnerUserInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartyPartnerRegisterThirdPartyPartnerUser: async (onboardPartnerUserInSchema: OnboardPartnerUserInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardPartnerUserInSchema' is not null or undefined
            assertParamExists('developerViewsThirdPartyPartnerRegisterThirdPartyPartnerUser', 'onboardPartnerUserInSchema', onboardPartnerUserInSchema)
            const localVarPath = `/api/third-party/partner/register-user/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(onboardPartnerUserInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Trigger Subscription Renewal For Partner User
         * @param {BasePartnerUserInSchema} basePartnerUserInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartyPartnerTriggerSubscriptionRenewalForPartnerUser: async (basePartnerUserInSchema: BasePartnerUserInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'basePartnerUserInSchema' is not null or undefined
            assertParamExists('developerViewsThirdPartyPartnerTriggerSubscriptionRenewalForPartnerUser', 'basePartnerUserInSchema', basePartnerUserInSchema)
            const localVarPath = `/api/third-party/partner/trigger-renewal/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(basePartnerUserInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unregister Third Party Partner User
         * @param {BasePartnerUserInSchema} basePartnerUserInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartyPartnerUnregisterThirdPartyPartnerUser: async (basePartnerUserInSchema: BasePartnerUserInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'basePartnerUserInSchema' is not null or undefined
            assertParamExists('developerViewsThirdPartyPartnerUnregisterThirdPartyPartnerUser', 'basePartnerUserInSchema', basePartnerUserInSchema)
            const localVarPath = `/api/third-party/partner/unregister-user/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(basePartnerUserInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ThirdPartyPartnerApi - functional programming interface
 * @export
 */
export const ThirdPartyPartnerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ThirdPartyPartnerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List Users
         * @param {string | null} [mobile] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerViewsThirdPartyPartnerListUsers(mobile?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedPartnerUserOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerViewsThirdPartyPartnerListUsers(mobile, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThirdPartyPartnerApi.developerViewsThirdPartyPartnerListUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Register Third Party Partner User
         * @param {OnboardPartnerUserInSchema} onboardPartnerUserInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerViewsThirdPartyPartnerRegisterThirdPartyPartnerUser(onboardPartnerUserInSchema: OnboardPartnerUserInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerViewsThirdPartyPartnerRegisterThirdPartyPartnerUser(onboardPartnerUserInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThirdPartyPartnerApi.developerViewsThirdPartyPartnerRegisterThirdPartyPartnerUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Trigger Subscription Renewal For Partner User
         * @param {BasePartnerUserInSchema} basePartnerUserInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerViewsThirdPartyPartnerTriggerSubscriptionRenewalForPartnerUser(basePartnerUserInSchema: BasePartnerUserInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerViewsThirdPartyPartnerTriggerSubscriptionRenewalForPartnerUser(basePartnerUserInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThirdPartyPartnerApi.developerViewsThirdPartyPartnerTriggerSubscriptionRenewalForPartnerUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Unregister Third Party Partner User
         * @param {BasePartnerUserInSchema} basePartnerUserInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerViewsThirdPartyPartnerUnregisterThirdPartyPartnerUser(basePartnerUserInSchema: BasePartnerUserInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerViewsThirdPartyPartnerUnregisterThirdPartyPartnerUser(basePartnerUserInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThirdPartyPartnerApi.developerViewsThirdPartyPartnerUnregisterThirdPartyPartnerUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ThirdPartyPartnerApi - factory interface
 * @export
 */
export const ThirdPartyPartnerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ThirdPartyPartnerApiFp(configuration)
    return {
        /**
         * 
         * @summary List Users
         * @param {ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerListUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartyPartnerListUsers(requestParameters: ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerListUsersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PagedPartnerUserOutSchema> {
            return localVarFp.developerViewsThirdPartyPartnerListUsers(requestParameters.mobile, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register Third Party Partner User
         * @param {ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerRegisterThirdPartyPartnerUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartyPartnerRegisterThirdPartyPartnerUser(requestParameters: ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerRegisterThirdPartyPartnerUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.developerViewsThirdPartyPartnerRegisterThirdPartyPartnerUser(requestParameters.onboardPartnerUserInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Trigger Subscription Renewal For Partner User
         * @param {ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerTriggerSubscriptionRenewalForPartnerUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartyPartnerTriggerSubscriptionRenewalForPartnerUser(requestParameters: ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerTriggerSubscriptionRenewalForPartnerUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.developerViewsThirdPartyPartnerTriggerSubscriptionRenewalForPartnerUser(requestParameters.basePartnerUserInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unregister Third Party Partner User
         * @param {ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerUnregisterThirdPartyPartnerUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartyPartnerUnregisterThirdPartyPartnerUser(requestParameters: ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerUnregisterThirdPartyPartnerUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.developerViewsThirdPartyPartnerUnregisterThirdPartyPartnerUser(requestParameters.basePartnerUserInSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for developerViewsThirdPartyPartnerListUsers operation in ThirdPartyPartnerApi.
 * @export
 * @interface ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerListUsersRequest
 */
export interface ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerListUsersRequest {
    /**
     * 
     * @type {string}
     * @memberof ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerListUsers
     */
    readonly mobile?: string | null

    /**
     * 
     * @type {number}
     * @memberof ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerListUsers
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerListUsers
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerListUsers
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for developerViewsThirdPartyPartnerRegisterThirdPartyPartnerUser operation in ThirdPartyPartnerApi.
 * @export
 * @interface ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerRegisterThirdPartyPartnerUserRequest
 */
export interface ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerRegisterThirdPartyPartnerUserRequest {
    /**
     * 
     * @type {OnboardPartnerUserInSchema}
     * @memberof ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerRegisterThirdPartyPartnerUser
     */
    readonly onboardPartnerUserInSchema: OnboardPartnerUserInSchema
}

/**
 * Request parameters for developerViewsThirdPartyPartnerTriggerSubscriptionRenewalForPartnerUser operation in ThirdPartyPartnerApi.
 * @export
 * @interface ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerTriggerSubscriptionRenewalForPartnerUserRequest
 */
export interface ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerTriggerSubscriptionRenewalForPartnerUserRequest {
    /**
     * 
     * @type {BasePartnerUserInSchema}
     * @memberof ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerTriggerSubscriptionRenewalForPartnerUser
     */
    readonly basePartnerUserInSchema: BasePartnerUserInSchema
}

/**
 * Request parameters for developerViewsThirdPartyPartnerUnregisterThirdPartyPartnerUser operation in ThirdPartyPartnerApi.
 * @export
 * @interface ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerUnregisterThirdPartyPartnerUserRequest
 */
export interface ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerUnregisterThirdPartyPartnerUserRequest {
    /**
     * 
     * @type {BasePartnerUserInSchema}
     * @memberof ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerUnregisterThirdPartyPartnerUser
     */
    readonly basePartnerUserInSchema: BasePartnerUserInSchema
}

/**
 * ThirdPartyPartnerApi - object-oriented interface
 * @export
 * @class ThirdPartyPartnerApi
 * @extends {BaseAPI}
 */
export class ThirdPartyPartnerApi extends BaseAPI {
    /**
     * 
     * @summary List Users
     * @param {ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerListUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdPartyPartnerApi
     */
    public developerViewsThirdPartyPartnerListUsers(requestParameters: ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerListUsersRequest = {}, options?: RawAxiosRequestConfig) {
        return ThirdPartyPartnerApiFp(this.configuration).developerViewsThirdPartyPartnerListUsers(requestParameters.mobile, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register Third Party Partner User
     * @param {ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerRegisterThirdPartyPartnerUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdPartyPartnerApi
     */
    public developerViewsThirdPartyPartnerRegisterThirdPartyPartnerUser(requestParameters: ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerRegisterThirdPartyPartnerUserRequest, options?: RawAxiosRequestConfig) {
        return ThirdPartyPartnerApiFp(this.configuration).developerViewsThirdPartyPartnerRegisterThirdPartyPartnerUser(requestParameters.onboardPartnerUserInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Trigger Subscription Renewal For Partner User
     * @param {ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerTriggerSubscriptionRenewalForPartnerUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdPartyPartnerApi
     */
    public developerViewsThirdPartyPartnerTriggerSubscriptionRenewalForPartnerUser(requestParameters: ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerTriggerSubscriptionRenewalForPartnerUserRequest, options?: RawAxiosRequestConfig) {
        return ThirdPartyPartnerApiFp(this.configuration).developerViewsThirdPartyPartnerTriggerSubscriptionRenewalForPartnerUser(requestParameters.basePartnerUserInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unregister Third Party Partner User
     * @param {ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerUnregisterThirdPartyPartnerUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdPartyPartnerApi
     */
    public developerViewsThirdPartyPartnerUnregisterThirdPartyPartnerUser(requestParameters: ThirdPartyPartnerApiDeveloperViewsThirdPartyPartnerUnregisterThirdPartyPartnerUserRequest, options?: RawAxiosRequestConfig) {
        return ThirdPartyPartnerApiFp(this.configuration).developerViewsThirdPartyPartnerUnregisterThirdPartyPartnerUser(requestParameters.basePartnerUserInSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ThirdPartySdkApi - axios parameter creator
 * @export
 */
export const ThirdPartySdkApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Third Party Create Contact
         * @param {number} businessId 
         * @param {UserContactInSchema} userContactInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartySdkContactThirdPartyCreateContact: async (businessId: number, userContactInSchema: UserContactInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('developerViewsThirdPartySdkContactThirdPartyCreateContact', 'businessId', businessId)
            // verify required parameter 'userContactInSchema' is not null or undefined
            assertParamExists('developerViewsThirdPartySdkContactThirdPartyCreateContact', 'userContactInSchema', userContactInSchema)
            const localVarPath = `/api/third-party/sdk/contacts/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (businessId !== undefined) {
                localVarQueryParameter['business_id'] = businessId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userContactInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Third Party List Contacts
         * @param {number} businessId 
         * @param {string | null} [search] 
         * @param {string | null} [tags] 
         * @param {boolean | null} [isPrivate] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartySdkContactThirdPartyListContacts: async (businessId: number, search?: string | null, tags?: string | null, isPrivate?: boolean | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('developerViewsThirdPartySdkContactThirdPartyListContacts', 'businessId', businessId)
            const localVarPath = `/api/third-party/sdk/contacts/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (businessId !== undefined) {
                localVarQueryParameter['business_id'] = businessId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (tags !== undefined) {
                localVarQueryParameter['tags'] = tags;
            }

            if (isPrivate !== undefined) {
                localVarQueryParameter['is_private'] = isPrivate;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve sip credentials for a given 999 receiver
         * @summary Third Party No Trunk Receiver Line
         * @param {ReceiverLineInSchema} receiverLineInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartySdkLiveWidgetThirdPartyNoTrunkReceiverLine: async (receiverLineInSchema: ReceiverLineInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'receiverLineInSchema' is not null or undefined
            assertParamExists('developerViewsThirdPartySdkLiveWidgetThirdPartyNoTrunkReceiverLine', 'receiverLineInSchema', receiverLineInSchema)
            const localVarPath = `/api/third-party/sdk/live-widget/receiver-line/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication PublicAPIKeyAuthentication required
            await setApiKeyToObject(localVarHeaderParameter, "Pressone-X-Pub-Key", configuration)

            // authentication APIKeyAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication APIKeyAuthenticationV2 required
            await setApiKeyToObject(localVarHeaderParameter, "key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(receiverLineInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Third Party Send Feeback
         * @param {LiveWidgetFeedbackSchema} liveWidgetFeedbackSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartySdkLiveWidgetThirdPartySendFeeback: async (liveWidgetFeedbackSchema: LiveWidgetFeedbackSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'liveWidgetFeedbackSchema' is not null or undefined
            assertParamExists('developerViewsThirdPartySdkLiveWidgetThirdPartySendFeeback', 'liveWidgetFeedbackSchema', liveWidgetFeedbackSchema)
            const localVarPath = `/api/third-party/sdk/live-widget/feedback/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication PublicAPIKeyAuthentication required
            await setApiKeyToObject(localVarHeaderParameter, "Pressone-X-Pub-Key", configuration)

            // authentication APIKeyAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication APIKeyAuthenticationV2 required
            await setApiKeyToObject(localVarHeaderParameter, "key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(liveWidgetFeedbackSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Third Party Widget Settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartySdkLiveWidgetThirdPartyWidgetSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/third-party/sdk/live-widget/setting/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication PublicAPIKeyAuthentication required
            await setApiKeyToObject(localVarHeaderParameter, "Pressone-X-Pub-Key", configuration)

            // authentication APIKeyAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication APIKeyAuthenticationV2 required
            await setApiKeyToObject(localVarHeaderParameter, "key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Third Party List Business Numbers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartySdkNumberThirdPartyListBusinessNumbers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/third-party/sdk/number/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requires ONLY API key authentication.
         * @summary Third Party Receiver Line
         * @param {ReceiverLineInSchema} receiverLineInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartySdkReceiverLineThirdPartyReceiverLine: async (receiverLineInSchema: ReceiverLineInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'receiverLineInSchema' is not null or undefined
            assertParamExists('developerViewsThirdPartySdkReceiverLineThirdPartyReceiverLine', 'receiverLineInSchema', receiverLineInSchema)
            const localVarPath = `/api/third-party/sdk/receiver-line/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(receiverLineInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Third Party Create Team Member
         * @param {TeamMemberInSchema} teamMemberInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartySdkTeamMemberThirdPartyCreateTeamMember: async (teamMemberInSchema: TeamMemberInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamMemberInSchema' is not null or undefined
            assertParamExists('developerViewsThirdPartySdkTeamMemberThirdPartyCreateTeamMember', 'teamMemberInSchema', teamMemberInSchema)
            const localVarPath = `/api/third-party/sdk/team-member/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamMemberInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Third Party List Team Members
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartySdkTeamMemberThirdPartyListTeamMembers: async (pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/third-party/sdk/team-member/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Third Party Team Member Login
         * @param {SDKTeamMemberTokenInSchema} sDKTeamMemberTokenInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartySdkTeamMemberThirdPartyTeamMemberLogin: async (sDKTeamMemberTokenInSchema: SDKTeamMemberTokenInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sDKTeamMemberTokenInSchema' is not null or undefined
            assertParamExists('developerViewsThirdPartySdkTeamMemberThirdPartyTeamMemberLogin', 'sDKTeamMemberTokenInSchema', sDKTeamMemberTokenInSchema)
            const localVarPath = `/api/third-party/sdk/team-member/login/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sDKTeamMemberTokenInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ThirdPartySdkApi - functional programming interface
 * @export
 */
export const ThirdPartySdkApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ThirdPartySdkApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Third Party Create Contact
         * @param {number} businessId 
         * @param {UserContactInSchema} userContactInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerViewsThirdPartySdkContactThirdPartyCreateContact(businessId: number, userContactInSchema: UserContactInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserContactOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerViewsThirdPartySdkContactThirdPartyCreateContact(businessId, userContactInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThirdPartySdkApi.developerViewsThirdPartySdkContactThirdPartyCreateContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Third Party List Contacts
         * @param {number} businessId 
         * @param {string | null} [search] 
         * @param {string | null} [tags] 
         * @param {boolean | null} [isPrivate] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerViewsThirdPartySdkContactThirdPartyListContacts(businessId: number, search?: string | null, tags?: string | null, isPrivate?: boolean | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedMinimalUserContactSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerViewsThirdPartySdkContactThirdPartyListContacts(businessId, search, tags, isPrivate, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThirdPartySdkApi.developerViewsThirdPartySdkContactThirdPartyListContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve sip credentials for a given 999 receiver
         * @summary Third Party No Trunk Receiver Line
         * @param {ReceiverLineInSchema} receiverLineInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerViewsThirdPartySdkLiveWidgetThirdPartyNoTrunkReceiverLine(receiverLineInSchema: ReceiverLineInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReceiverLineOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerViewsThirdPartySdkLiveWidgetThirdPartyNoTrunkReceiverLine(receiverLineInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThirdPartySdkApi.developerViewsThirdPartySdkLiveWidgetThirdPartyNoTrunkReceiverLine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Third Party Send Feeback
         * @param {LiveWidgetFeedbackSchema} liveWidgetFeedbackSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerViewsThirdPartySdkLiveWidgetThirdPartySendFeeback(liveWidgetFeedbackSchema: LiveWidgetFeedbackSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerViewsThirdPartySdkLiveWidgetThirdPartySendFeeback(liveWidgetFeedbackSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThirdPartySdkApi.developerViewsThirdPartySdkLiveWidgetThirdPartySendFeeback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Third Party Widget Settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerViewsThirdPartySdkLiveWidgetThirdPartyWidgetSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveCallWidgetOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerViewsThirdPartySdkLiveWidgetThirdPartyWidgetSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThirdPartySdkApi.developerViewsThirdPartySdkLiveWidgetThirdPartyWidgetSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Third Party List Business Numbers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerViewsThirdPartySdkNumberThirdPartyListBusinessNumbers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BusinessNumberOutSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerViewsThirdPartySdkNumberThirdPartyListBusinessNumbers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThirdPartySdkApi.developerViewsThirdPartySdkNumberThirdPartyListBusinessNumbers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Requires ONLY API key authentication.
         * @summary Third Party Receiver Line
         * @param {ReceiverLineInSchema} receiverLineInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerViewsThirdPartySdkReceiverLineThirdPartyReceiverLine(receiverLineInSchema: ReceiverLineInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReceiverLineOutSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerViewsThirdPartySdkReceiverLineThirdPartyReceiverLine(receiverLineInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThirdPartySdkApi.developerViewsThirdPartySdkReceiverLineThirdPartyReceiverLine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Third Party Create Team Member
         * @param {TeamMemberInSchema} teamMemberInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerViewsThirdPartySdkTeamMemberThirdPartyCreateTeamMember(teamMemberInSchema: TeamMemberInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamMemberOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerViewsThirdPartySdkTeamMemberThirdPartyCreateTeamMember(teamMemberInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThirdPartySdkApi.developerViewsThirdPartySdkTeamMemberThirdPartyCreateTeamMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Third Party List Team Members
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerViewsThirdPartySdkTeamMemberThirdPartyListTeamMembers(pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedTeamMemberMinimalOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerViewsThirdPartySdkTeamMemberThirdPartyListTeamMembers(pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThirdPartySdkApi.developerViewsThirdPartySdkTeamMemberThirdPartyListTeamMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Third Party Team Member Login
         * @param {SDKTeamMemberTokenInSchema} sDKTeamMemberTokenInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerViewsThirdPartySdkTeamMemberThirdPartyTeamMemberLogin(sDKTeamMemberTokenInSchema: SDKTeamMemberTokenInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SDKTeamMemberTokenOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerViewsThirdPartySdkTeamMemberThirdPartyTeamMemberLogin(sDKTeamMemberTokenInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThirdPartySdkApi.developerViewsThirdPartySdkTeamMemberThirdPartyTeamMemberLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ThirdPartySdkApi - factory interface
 * @export
 */
export const ThirdPartySdkApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ThirdPartySdkApiFp(configuration)
    return {
        /**
         * 
         * @summary Third Party Create Contact
         * @param {ThirdPartySdkApiDeveloperViewsThirdPartySdkContactThirdPartyCreateContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartySdkContactThirdPartyCreateContact(requestParameters: ThirdPartySdkApiDeveloperViewsThirdPartySdkContactThirdPartyCreateContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserContactOutSchema> {
            return localVarFp.developerViewsThirdPartySdkContactThirdPartyCreateContact(requestParameters.businessId, requestParameters.userContactInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Third Party List Contacts
         * @param {ThirdPartySdkApiDeveloperViewsThirdPartySdkContactThirdPartyListContactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartySdkContactThirdPartyListContacts(requestParameters: ThirdPartySdkApiDeveloperViewsThirdPartySdkContactThirdPartyListContactsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedMinimalUserContactSchema> {
            return localVarFp.developerViewsThirdPartySdkContactThirdPartyListContacts(requestParameters.businessId, requestParameters.search, requestParameters.tags, requestParameters.isPrivate, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve sip credentials for a given 999 receiver
         * @summary Third Party No Trunk Receiver Line
         * @param {ThirdPartySdkApiDeveloperViewsThirdPartySdkLiveWidgetThirdPartyNoTrunkReceiverLineRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartySdkLiveWidgetThirdPartyNoTrunkReceiverLine(requestParameters: ThirdPartySdkApiDeveloperViewsThirdPartySdkLiveWidgetThirdPartyNoTrunkReceiverLineRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReceiverLineOutSchema> {
            return localVarFp.developerViewsThirdPartySdkLiveWidgetThirdPartyNoTrunkReceiverLine(requestParameters.receiverLineInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Third Party Send Feeback
         * @param {ThirdPartySdkApiDeveloperViewsThirdPartySdkLiveWidgetThirdPartySendFeebackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartySdkLiveWidgetThirdPartySendFeeback(requestParameters: ThirdPartySdkApiDeveloperViewsThirdPartySdkLiveWidgetThirdPartySendFeebackRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.developerViewsThirdPartySdkLiveWidgetThirdPartySendFeeback(requestParameters.liveWidgetFeedbackSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Third Party Widget Settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartySdkLiveWidgetThirdPartyWidgetSettings(options?: RawAxiosRequestConfig): AxiosPromise<LiveCallWidgetOutSchema> {
            return localVarFp.developerViewsThirdPartySdkLiveWidgetThirdPartyWidgetSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Third Party List Business Numbers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartySdkNumberThirdPartyListBusinessNumbers(options?: RawAxiosRequestConfig): AxiosPromise<Array<BusinessNumberOutSchema>> {
            return localVarFp.developerViewsThirdPartySdkNumberThirdPartyListBusinessNumbers(options).then((request) => request(axios, basePath));
        },
        /**
         * Requires ONLY API key authentication.
         * @summary Third Party Receiver Line
         * @param {ThirdPartySdkApiDeveloperViewsThirdPartySdkReceiverLineThirdPartyReceiverLineRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartySdkReceiverLineThirdPartyReceiverLine(requestParameters: ThirdPartySdkApiDeveloperViewsThirdPartySdkReceiverLineThirdPartyReceiverLineRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ReceiverLineOutSchema>> {
            return localVarFp.developerViewsThirdPartySdkReceiverLineThirdPartyReceiverLine(requestParameters.receiverLineInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Third Party Create Team Member
         * @param {ThirdPartySdkApiDeveloperViewsThirdPartySdkTeamMemberThirdPartyCreateTeamMemberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartySdkTeamMemberThirdPartyCreateTeamMember(requestParameters: ThirdPartySdkApiDeveloperViewsThirdPartySdkTeamMemberThirdPartyCreateTeamMemberRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamMemberOutSchema> {
            return localVarFp.developerViewsThirdPartySdkTeamMemberThirdPartyCreateTeamMember(requestParameters.teamMemberInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Third Party List Team Members
         * @param {ThirdPartySdkApiDeveloperViewsThirdPartySdkTeamMemberThirdPartyListTeamMembersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartySdkTeamMemberThirdPartyListTeamMembers(requestParameters: ThirdPartySdkApiDeveloperViewsThirdPartySdkTeamMemberThirdPartyListTeamMembersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PagedTeamMemberMinimalOutSchema> {
            return localVarFp.developerViewsThirdPartySdkTeamMemberThirdPartyListTeamMembers(requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Third Party Team Member Login
         * @param {ThirdPartySdkApiDeveloperViewsThirdPartySdkTeamMemberThirdPartyTeamMemberLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerViewsThirdPartySdkTeamMemberThirdPartyTeamMemberLogin(requestParameters: ThirdPartySdkApiDeveloperViewsThirdPartySdkTeamMemberThirdPartyTeamMemberLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<SDKTeamMemberTokenOutSchema> {
            return localVarFp.developerViewsThirdPartySdkTeamMemberThirdPartyTeamMemberLogin(requestParameters.sDKTeamMemberTokenInSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for developerViewsThirdPartySdkContactThirdPartyCreateContact operation in ThirdPartySdkApi.
 * @export
 * @interface ThirdPartySdkApiDeveloperViewsThirdPartySdkContactThirdPartyCreateContactRequest
 */
export interface ThirdPartySdkApiDeveloperViewsThirdPartySdkContactThirdPartyCreateContactRequest {
    /**
     * 
     * @type {number}
     * @memberof ThirdPartySdkApiDeveloperViewsThirdPartySdkContactThirdPartyCreateContact
     */
    readonly businessId: number

    /**
     * 
     * @type {UserContactInSchema}
     * @memberof ThirdPartySdkApiDeveloperViewsThirdPartySdkContactThirdPartyCreateContact
     */
    readonly userContactInSchema: UserContactInSchema
}

/**
 * Request parameters for developerViewsThirdPartySdkContactThirdPartyListContacts operation in ThirdPartySdkApi.
 * @export
 * @interface ThirdPartySdkApiDeveloperViewsThirdPartySdkContactThirdPartyListContactsRequest
 */
export interface ThirdPartySdkApiDeveloperViewsThirdPartySdkContactThirdPartyListContactsRequest {
    /**
     * 
     * @type {number}
     * @memberof ThirdPartySdkApiDeveloperViewsThirdPartySdkContactThirdPartyListContacts
     */
    readonly businessId: number

    /**
     * 
     * @type {string}
     * @memberof ThirdPartySdkApiDeveloperViewsThirdPartySdkContactThirdPartyListContacts
     */
    readonly search?: string | null

    /**
     * 
     * @type {string}
     * @memberof ThirdPartySdkApiDeveloperViewsThirdPartySdkContactThirdPartyListContacts
     */
    readonly tags?: string | null

    /**
     * 
     * @type {boolean}
     * @memberof ThirdPartySdkApiDeveloperViewsThirdPartySdkContactThirdPartyListContacts
     */
    readonly isPrivate?: boolean | null

    /**
     * 
     * @type {number}
     * @memberof ThirdPartySdkApiDeveloperViewsThirdPartySdkContactThirdPartyListContacts
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof ThirdPartySdkApiDeveloperViewsThirdPartySdkContactThirdPartyListContacts
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof ThirdPartySdkApiDeveloperViewsThirdPartySdkContactThirdPartyListContacts
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for developerViewsThirdPartySdkLiveWidgetThirdPartyNoTrunkReceiverLine operation in ThirdPartySdkApi.
 * @export
 * @interface ThirdPartySdkApiDeveloperViewsThirdPartySdkLiveWidgetThirdPartyNoTrunkReceiverLineRequest
 */
export interface ThirdPartySdkApiDeveloperViewsThirdPartySdkLiveWidgetThirdPartyNoTrunkReceiverLineRequest {
    /**
     * 
     * @type {ReceiverLineInSchema}
     * @memberof ThirdPartySdkApiDeveloperViewsThirdPartySdkLiveWidgetThirdPartyNoTrunkReceiverLine
     */
    readonly receiverLineInSchema: ReceiverLineInSchema
}

/**
 * Request parameters for developerViewsThirdPartySdkLiveWidgetThirdPartySendFeeback operation in ThirdPartySdkApi.
 * @export
 * @interface ThirdPartySdkApiDeveloperViewsThirdPartySdkLiveWidgetThirdPartySendFeebackRequest
 */
export interface ThirdPartySdkApiDeveloperViewsThirdPartySdkLiveWidgetThirdPartySendFeebackRequest {
    /**
     * 
     * @type {LiveWidgetFeedbackSchema}
     * @memberof ThirdPartySdkApiDeveloperViewsThirdPartySdkLiveWidgetThirdPartySendFeeback
     */
    readonly liveWidgetFeedbackSchema: LiveWidgetFeedbackSchema
}

/**
 * Request parameters for developerViewsThirdPartySdkReceiverLineThirdPartyReceiverLine operation in ThirdPartySdkApi.
 * @export
 * @interface ThirdPartySdkApiDeveloperViewsThirdPartySdkReceiverLineThirdPartyReceiverLineRequest
 */
export interface ThirdPartySdkApiDeveloperViewsThirdPartySdkReceiverLineThirdPartyReceiverLineRequest {
    /**
     * 
     * @type {ReceiverLineInSchema}
     * @memberof ThirdPartySdkApiDeveloperViewsThirdPartySdkReceiverLineThirdPartyReceiverLine
     */
    readonly receiverLineInSchema: ReceiverLineInSchema
}

/**
 * Request parameters for developerViewsThirdPartySdkTeamMemberThirdPartyCreateTeamMember operation in ThirdPartySdkApi.
 * @export
 * @interface ThirdPartySdkApiDeveloperViewsThirdPartySdkTeamMemberThirdPartyCreateTeamMemberRequest
 */
export interface ThirdPartySdkApiDeveloperViewsThirdPartySdkTeamMemberThirdPartyCreateTeamMemberRequest {
    /**
     * 
     * @type {TeamMemberInSchema}
     * @memberof ThirdPartySdkApiDeveloperViewsThirdPartySdkTeamMemberThirdPartyCreateTeamMember
     */
    readonly teamMemberInSchema: TeamMemberInSchema
}

/**
 * Request parameters for developerViewsThirdPartySdkTeamMemberThirdPartyListTeamMembers operation in ThirdPartySdkApi.
 * @export
 * @interface ThirdPartySdkApiDeveloperViewsThirdPartySdkTeamMemberThirdPartyListTeamMembersRequest
 */
export interface ThirdPartySdkApiDeveloperViewsThirdPartySdkTeamMemberThirdPartyListTeamMembersRequest {
    /**
     * 
     * @type {number}
     * @memberof ThirdPartySdkApiDeveloperViewsThirdPartySdkTeamMemberThirdPartyListTeamMembers
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof ThirdPartySdkApiDeveloperViewsThirdPartySdkTeamMemberThirdPartyListTeamMembers
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof ThirdPartySdkApiDeveloperViewsThirdPartySdkTeamMemberThirdPartyListTeamMembers
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for developerViewsThirdPartySdkTeamMemberThirdPartyTeamMemberLogin operation in ThirdPartySdkApi.
 * @export
 * @interface ThirdPartySdkApiDeveloperViewsThirdPartySdkTeamMemberThirdPartyTeamMemberLoginRequest
 */
export interface ThirdPartySdkApiDeveloperViewsThirdPartySdkTeamMemberThirdPartyTeamMemberLoginRequest {
    /**
     * 
     * @type {SDKTeamMemberTokenInSchema}
     * @memberof ThirdPartySdkApiDeveloperViewsThirdPartySdkTeamMemberThirdPartyTeamMemberLogin
     */
    readonly sDKTeamMemberTokenInSchema: SDKTeamMemberTokenInSchema
}

/**
 * ThirdPartySdkApi - object-oriented interface
 * @export
 * @class ThirdPartySdkApi
 * @extends {BaseAPI}
 */
export class ThirdPartySdkApi extends BaseAPI {
    /**
     * 
     * @summary Third Party Create Contact
     * @param {ThirdPartySdkApiDeveloperViewsThirdPartySdkContactThirdPartyCreateContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdPartySdkApi
     */
    public developerViewsThirdPartySdkContactThirdPartyCreateContact(requestParameters: ThirdPartySdkApiDeveloperViewsThirdPartySdkContactThirdPartyCreateContactRequest, options?: RawAxiosRequestConfig) {
        return ThirdPartySdkApiFp(this.configuration).developerViewsThirdPartySdkContactThirdPartyCreateContact(requestParameters.businessId, requestParameters.userContactInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Third Party List Contacts
     * @param {ThirdPartySdkApiDeveloperViewsThirdPartySdkContactThirdPartyListContactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdPartySdkApi
     */
    public developerViewsThirdPartySdkContactThirdPartyListContacts(requestParameters: ThirdPartySdkApiDeveloperViewsThirdPartySdkContactThirdPartyListContactsRequest, options?: RawAxiosRequestConfig) {
        return ThirdPartySdkApiFp(this.configuration).developerViewsThirdPartySdkContactThirdPartyListContacts(requestParameters.businessId, requestParameters.search, requestParameters.tags, requestParameters.isPrivate, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve sip credentials for a given 999 receiver
     * @summary Third Party No Trunk Receiver Line
     * @param {ThirdPartySdkApiDeveloperViewsThirdPartySdkLiveWidgetThirdPartyNoTrunkReceiverLineRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdPartySdkApi
     */
    public developerViewsThirdPartySdkLiveWidgetThirdPartyNoTrunkReceiverLine(requestParameters: ThirdPartySdkApiDeveloperViewsThirdPartySdkLiveWidgetThirdPartyNoTrunkReceiverLineRequest, options?: RawAxiosRequestConfig) {
        return ThirdPartySdkApiFp(this.configuration).developerViewsThirdPartySdkLiveWidgetThirdPartyNoTrunkReceiverLine(requestParameters.receiverLineInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Third Party Send Feeback
     * @param {ThirdPartySdkApiDeveloperViewsThirdPartySdkLiveWidgetThirdPartySendFeebackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdPartySdkApi
     */
    public developerViewsThirdPartySdkLiveWidgetThirdPartySendFeeback(requestParameters: ThirdPartySdkApiDeveloperViewsThirdPartySdkLiveWidgetThirdPartySendFeebackRequest, options?: RawAxiosRequestConfig) {
        return ThirdPartySdkApiFp(this.configuration).developerViewsThirdPartySdkLiveWidgetThirdPartySendFeeback(requestParameters.liveWidgetFeedbackSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Third Party Widget Settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdPartySdkApi
     */
    public developerViewsThirdPartySdkLiveWidgetThirdPartyWidgetSettings(options?: RawAxiosRequestConfig) {
        return ThirdPartySdkApiFp(this.configuration).developerViewsThirdPartySdkLiveWidgetThirdPartyWidgetSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Third Party List Business Numbers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdPartySdkApi
     */
    public developerViewsThirdPartySdkNumberThirdPartyListBusinessNumbers(options?: RawAxiosRequestConfig) {
        return ThirdPartySdkApiFp(this.configuration).developerViewsThirdPartySdkNumberThirdPartyListBusinessNumbers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requires ONLY API key authentication.
     * @summary Third Party Receiver Line
     * @param {ThirdPartySdkApiDeveloperViewsThirdPartySdkReceiverLineThirdPartyReceiverLineRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdPartySdkApi
     */
    public developerViewsThirdPartySdkReceiverLineThirdPartyReceiverLine(requestParameters: ThirdPartySdkApiDeveloperViewsThirdPartySdkReceiverLineThirdPartyReceiverLineRequest, options?: RawAxiosRequestConfig) {
        return ThirdPartySdkApiFp(this.configuration).developerViewsThirdPartySdkReceiverLineThirdPartyReceiverLine(requestParameters.receiverLineInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Third Party Create Team Member
     * @param {ThirdPartySdkApiDeveloperViewsThirdPartySdkTeamMemberThirdPartyCreateTeamMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdPartySdkApi
     */
    public developerViewsThirdPartySdkTeamMemberThirdPartyCreateTeamMember(requestParameters: ThirdPartySdkApiDeveloperViewsThirdPartySdkTeamMemberThirdPartyCreateTeamMemberRequest, options?: RawAxiosRequestConfig) {
        return ThirdPartySdkApiFp(this.configuration).developerViewsThirdPartySdkTeamMemberThirdPartyCreateTeamMember(requestParameters.teamMemberInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Third Party List Team Members
     * @param {ThirdPartySdkApiDeveloperViewsThirdPartySdkTeamMemberThirdPartyListTeamMembersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdPartySdkApi
     */
    public developerViewsThirdPartySdkTeamMemberThirdPartyListTeamMembers(requestParameters: ThirdPartySdkApiDeveloperViewsThirdPartySdkTeamMemberThirdPartyListTeamMembersRequest = {}, options?: RawAxiosRequestConfig) {
        return ThirdPartySdkApiFp(this.configuration).developerViewsThirdPartySdkTeamMemberThirdPartyListTeamMembers(requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Third Party Team Member Login
     * @param {ThirdPartySdkApiDeveloperViewsThirdPartySdkTeamMemberThirdPartyTeamMemberLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdPartySdkApi
     */
    public developerViewsThirdPartySdkTeamMemberThirdPartyTeamMemberLogin(requestParameters: ThirdPartySdkApiDeveloperViewsThirdPartySdkTeamMemberThirdPartyTeamMemberLoginRequest, options?: RawAxiosRequestConfig) {
        return ThirdPartySdkApiFp(this.configuration).developerViewsThirdPartySdkTeamMemberThirdPartyTeamMemberLogin(requestParameters.sDKTeamMemberTokenInSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserVerificationApi - axios parameter creator
 * @export
 */
export const UserVerificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Completes verification process by the delegated user
         * @summary Complete Verification By Third Party
         * @param {CompleteVerificationInSchema} completeVerificationInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUserVerificationCompleteVerificationByThirdParty: async (completeVerificationInSchema: CompleteVerificationInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'completeVerificationInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaUserVerificationCompleteVerificationByThirdParty', 'completeVerificationInSchema', completeVerificationInSchema)
            const localVarPath = `/api/business/verification/delegate/verify/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeVerificationInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Confirm Verification Otp
         * @param {VerificationOTPInSchema} verificationOTPInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUserVerificationConfirmVerificationOtp: async (verificationOTPInSchema: VerificationOTPInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verificationOTPInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaUserVerificationConfirmVerificationOtp', 'verificationOTPInSchema', verificationOTPInSchema)
            const localVarPath = `/api/business/verification/otp/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verificationOTPInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends notifications to the delegated user to initiate verification process.
         * @summary Delegate verification
         * @param {DelegateVerificationInSchema} delegateVerificationInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUserVerificationDelegateVerificationToThirdParty: async (delegateVerificationInSchema: DelegateVerificationInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'delegateVerificationInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaUserVerificationDelegateVerificationToThirdParty', 'delegateVerificationInSchema', delegateVerificationInSchema)
            const localVarPath = `/api/business/verification/delegate/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(delegateVerificationInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate Presigned Upload Url For Verification Document
         * @param {PresignedURLInSchema} presignedURLInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUserVerificationGeneratePresignedUploadUrlForVerificationDocument: async (presignedURLInSchema: PresignedURLInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'presignedURLInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaUserVerificationGeneratePresignedUploadUrlForVerificationDocument', 'presignedURLInSchema', presignedURLInSchema)
            const localVarPath = `/api/business/document/presigned-url/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(presignedURLInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get User Verification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUserVerificationGetUserVerification: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/business/verification/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Remaining Verification Documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUserVerificationListRemainingVerificationDocuments: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/business/remaining-documents/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Submitted Verification Documents
         * @param {boolean | null} [verified] 
         * @param {VerificationDocumentStatus | null} [status] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUserVerificationListSubmittedVerificationDocuments: async (verified?: boolean | null, status?: VerificationDocumentStatus | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/business/documents/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (verified !== undefined) {
                localVarQueryParameter['verified'] = verified;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Triggers the user verification process.
         * @summary Request user verification
         * @param {RequestVerificationInSchema} requestVerificationInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUserVerificationRequestUserVerification: async (requestVerificationInSchema: RequestVerificationInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestVerificationInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaUserVerificationRequestUserVerification', 'requestVerificationInSchema', requestVerificationInSchema)
            const localVarPath = `/api/business/verification/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestVerificationInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request Verification Otp
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUserVerificationRequestVerificationOtp: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('usersViewsNinjaUserVerificationRequestVerificationOtp', 'token', token)
            const localVarPath = `/api/business/verification/otp/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload Verification Document
         * @param {VerificationDocumentInSchema} verificationDocumentInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUserVerificationUploadVerificationDocument: async (verificationDocumentInSchema: VerificationDocumentInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verificationDocumentInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaUserVerificationUploadVerificationDocument', 'verificationDocumentInSchema', verificationDocumentInSchema)
            const localVarPath = `/api/business/document/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verificationDocumentInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload Verification Document By Third Party
         * @param {VerificationDocumentThirdPartyInSchema} verificationDocumentThirdPartyInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUserVerificationUploadVerificationDocumentByThirdParty: async (verificationDocumentThirdPartyInSchema: VerificationDocumentThirdPartyInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verificationDocumentThirdPartyInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaUserVerificationUploadVerificationDocumentByThirdParty', 'verificationDocumentThirdPartyInSchema', verificationDocumentThirdPartyInSchema)
            const localVarPath = `/api/business/document/third-party/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verificationDocumentThirdPartyInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify Verification Token
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUserVerificationVerifyVerificationToken: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('usersViewsNinjaUserVerificationVerifyVerificationToken', 'token', token)
            const localVarPath = `/api/business/verification/token/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserVerificationApi - functional programming interface
 * @export
 */
export const UserVerificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserVerificationApiAxiosParamCreator(configuration)
    return {
        /**
         * Completes verification process by the delegated user
         * @summary Complete Verification By Third Party
         * @param {CompleteVerificationInSchema} completeVerificationInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUserVerificationCompleteVerificationByThirdParty(completeVerificationInSchema: CompleteVerificationInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUserVerificationCompleteVerificationByThirdParty(completeVerificationInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserVerificationApi.usersViewsNinjaUserVerificationCompleteVerificationByThirdParty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Confirm Verification Otp
         * @param {VerificationOTPInSchema} verificationOTPInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUserVerificationConfirmVerificationOtp(verificationOTPInSchema: VerificationOTPInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUserVerificationConfirmVerificationOtp(verificationOTPInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserVerificationApi.usersViewsNinjaUserVerificationConfirmVerificationOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sends notifications to the delegated user to initiate verification process.
         * @summary Delegate verification
         * @param {DelegateVerificationInSchema} delegateVerificationInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUserVerificationDelegateVerificationToThirdParty(delegateVerificationInSchema: DelegateVerificationInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUserVerificationDelegateVerificationToThirdParty(delegateVerificationInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserVerificationApi.usersViewsNinjaUserVerificationDelegateVerificationToThirdParty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generate Presigned Upload Url For Verification Document
         * @param {PresignedURLInSchema} presignedURLInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUserVerificationGeneratePresignedUploadUrlForVerificationDocument(presignedURLInSchema: PresignedURLInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUserVerificationGeneratePresignedUploadUrlForVerificationDocument(presignedURLInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserVerificationApi.usersViewsNinjaUserVerificationGeneratePresignedUploadUrlForVerificationDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get User Verification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUserVerificationGetUserVerification(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerificationOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUserVerificationGetUserVerification(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserVerificationApi.usersViewsNinjaUserVerificationGetUserVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Remaining Verification Documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUserVerificationListRemainingVerificationDocuments(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUserVerificationListRemainingVerificationDocuments(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserVerificationApi.usersViewsNinjaUserVerificationListRemainingVerificationDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Submitted Verification Documents
         * @param {boolean | null} [verified] 
         * @param {VerificationDocumentStatus | null} [status] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUserVerificationListSubmittedVerificationDocuments(verified?: boolean | null, status?: VerificationDocumentStatus | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedVerificationDocumentOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUserVerificationListSubmittedVerificationDocuments(verified, status, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserVerificationApi.usersViewsNinjaUserVerificationListSubmittedVerificationDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Triggers the user verification process.
         * @summary Request user verification
         * @param {RequestVerificationInSchema} requestVerificationInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUserVerificationRequestUserVerification(requestVerificationInSchema: RequestVerificationInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUserVerificationRequestUserVerification(requestVerificationInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserVerificationApi.usersViewsNinjaUserVerificationRequestUserVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Request Verification Otp
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUserVerificationRequestVerificationOtp(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUserVerificationRequestVerificationOtp(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserVerificationApi.usersViewsNinjaUserVerificationRequestVerificationOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload Verification Document
         * @param {VerificationDocumentInSchema} verificationDocumentInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUserVerificationUploadVerificationDocument(verificationDocumentInSchema: VerificationDocumentInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerificationDocumentOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUserVerificationUploadVerificationDocument(verificationDocumentInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserVerificationApi.usersViewsNinjaUserVerificationUploadVerificationDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload Verification Document By Third Party
         * @param {VerificationDocumentThirdPartyInSchema} verificationDocumentThirdPartyInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUserVerificationUploadVerificationDocumentByThirdParty(verificationDocumentThirdPartyInSchema: VerificationDocumentThirdPartyInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerificationDocumentOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUserVerificationUploadVerificationDocumentByThirdParty(verificationDocumentThirdPartyInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserVerificationApi.usersViewsNinjaUserVerificationUploadVerificationDocumentByThirdParty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify Verification Token
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUserVerificationVerifyVerificationToken(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUserVerificationVerifyVerificationToken(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserVerificationApi.usersViewsNinjaUserVerificationVerifyVerificationToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserVerificationApi - factory interface
 * @export
 */
export const UserVerificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserVerificationApiFp(configuration)
    return {
        /**
         * Completes verification process by the delegated user
         * @summary Complete Verification By Third Party
         * @param {UserVerificationApiUsersViewsNinjaUserVerificationCompleteVerificationByThirdPartyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUserVerificationCompleteVerificationByThirdParty(requestParameters: UserVerificationApiUsersViewsNinjaUserVerificationCompleteVerificationByThirdPartyRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaUserVerificationCompleteVerificationByThirdParty(requestParameters.completeVerificationInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Confirm Verification Otp
         * @param {UserVerificationApiUsersViewsNinjaUserVerificationConfirmVerificationOtpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUserVerificationConfirmVerificationOtp(requestParameters: UserVerificationApiUsersViewsNinjaUserVerificationConfirmVerificationOtpRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaUserVerificationConfirmVerificationOtp(requestParameters.verificationOTPInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends notifications to the delegated user to initiate verification process.
         * @summary Delegate verification
         * @param {UserVerificationApiUsersViewsNinjaUserVerificationDelegateVerificationToThirdPartyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUserVerificationDelegateVerificationToThirdParty(requestParameters: UserVerificationApiUsersViewsNinjaUserVerificationDelegateVerificationToThirdPartyRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaUserVerificationDelegateVerificationToThirdParty(requestParameters.delegateVerificationInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate Presigned Upload Url For Verification Document
         * @param {UserVerificationApiUsersViewsNinjaUserVerificationGeneratePresignedUploadUrlForVerificationDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUserVerificationGeneratePresignedUploadUrlForVerificationDocument(requestParameters: UserVerificationApiUsersViewsNinjaUserVerificationGeneratePresignedUploadUrlForVerificationDocumentRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaUserVerificationGeneratePresignedUploadUrlForVerificationDocument(requestParameters.presignedURLInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get User Verification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUserVerificationGetUserVerification(options?: RawAxiosRequestConfig): AxiosPromise<VerificationOutSchema> {
            return localVarFp.usersViewsNinjaUserVerificationGetUserVerification(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Remaining Verification Documents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUserVerificationListRemainingVerificationDocuments(options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaUserVerificationListRemainingVerificationDocuments(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Submitted Verification Documents
         * @param {UserVerificationApiUsersViewsNinjaUserVerificationListSubmittedVerificationDocumentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUserVerificationListSubmittedVerificationDocuments(requestParameters: UserVerificationApiUsersViewsNinjaUserVerificationListSubmittedVerificationDocumentsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PagedVerificationDocumentOutSchema> {
            return localVarFp.usersViewsNinjaUserVerificationListSubmittedVerificationDocuments(requestParameters.verified, requestParameters.status, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * Triggers the user verification process.
         * @summary Request user verification
         * @param {UserVerificationApiUsersViewsNinjaUserVerificationRequestUserVerificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUserVerificationRequestUserVerification(requestParameters: UserVerificationApiUsersViewsNinjaUserVerificationRequestUserVerificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaUserVerificationRequestUserVerification(requestParameters.requestVerificationInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request Verification Otp
         * @param {UserVerificationApiUsersViewsNinjaUserVerificationRequestVerificationOtpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUserVerificationRequestVerificationOtp(requestParameters: UserVerificationApiUsersViewsNinjaUserVerificationRequestVerificationOtpRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaUserVerificationRequestVerificationOtp(requestParameters.token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload Verification Document
         * @param {UserVerificationApiUsersViewsNinjaUserVerificationUploadVerificationDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUserVerificationUploadVerificationDocument(requestParameters: UserVerificationApiUsersViewsNinjaUserVerificationUploadVerificationDocumentRequest, options?: RawAxiosRequestConfig): AxiosPromise<VerificationDocumentOutSchema> {
            return localVarFp.usersViewsNinjaUserVerificationUploadVerificationDocument(requestParameters.verificationDocumentInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload Verification Document By Third Party
         * @param {UserVerificationApiUsersViewsNinjaUserVerificationUploadVerificationDocumentByThirdPartyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUserVerificationUploadVerificationDocumentByThirdParty(requestParameters: UserVerificationApiUsersViewsNinjaUserVerificationUploadVerificationDocumentByThirdPartyRequest, options?: RawAxiosRequestConfig): AxiosPromise<VerificationDocumentOutSchema> {
            return localVarFp.usersViewsNinjaUserVerificationUploadVerificationDocumentByThirdParty(requestParameters.verificationDocumentThirdPartyInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify Verification Token
         * @param {UserVerificationApiUsersViewsNinjaUserVerificationVerifyVerificationTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUserVerificationVerifyVerificationToken(requestParameters: UserVerificationApiUsersViewsNinjaUserVerificationVerifyVerificationTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaUserVerificationVerifyVerificationToken(requestParameters.token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for usersViewsNinjaUserVerificationCompleteVerificationByThirdParty operation in UserVerificationApi.
 * @export
 * @interface UserVerificationApiUsersViewsNinjaUserVerificationCompleteVerificationByThirdPartyRequest
 */
export interface UserVerificationApiUsersViewsNinjaUserVerificationCompleteVerificationByThirdPartyRequest {
    /**
     * 
     * @type {CompleteVerificationInSchema}
     * @memberof UserVerificationApiUsersViewsNinjaUserVerificationCompleteVerificationByThirdParty
     */
    readonly completeVerificationInSchema: CompleteVerificationInSchema
}

/**
 * Request parameters for usersViewsNinjaUserVerificationConfirmVerificationOtp operation in UserVerificationApi.
 * @export
 * @interface UserVerificationApiUsersViewsNinjaUserVerificationConfirmVerificationOtpRequest
 */
export interface UserVerificationApiUsersViewsNinjaUserVerificationConfirmVerificationOtpRequest {
    /**
     * 
     * @type {VerificationOTPInSchema}
     * @memberof UserVerificationApiUsersViewsNinjaUserVerificationConfirmVerificationOtp
     */
    readonly verificationOTPInSchema: VerificationOTPInSchema
}

/**
 * Request parameters for usersViewsNinjaUserVerificationDelegateVerificationToThirdParty operation in UserVerificationApi.
 * @export
 * @interface UserVerificationApiUsersViewsNinjaUserVerificationDelegateVerificationToThirdPartyRequest
 */
export interface UserVerificationApiUsersViewsNinjaUserVerificationDelegateVerificationToThirdPartyRequest {
    /**
     * 
     * @type {DelegateVerificationInSchema}
     * @memberof UserVerificationApiUsersViewsNinjaUserVerificationDelegateVerificationToThirdParty
     */
    readonly delegateVerificationInSchema: DelegateVerificationInSchema
}

/**
 * Request parameters for usersViewsNinjaUserVerificationGeneratePresignedUploadUrlForVerificationDocument operation in UserVerificationApi.
 * @export
 * @interface UserVerificationApiUsersViewsNinjaUserVerificationGeneratePresignedUploadUrlForVerificationDocumentRequest
 */
export interface UserVerificationApiUsersViewsNinjaUserVerificationGeneratePresignedUploadUrlForVerificationDocumentRequest {
    /**
     * 
     * @type {PresignedURLInSchema}
     * @memberof UserVerificationApiUsersViewsNinjaUserVerificationGeneratePresignedUploadUrlForVerificationDocument
     */
    readonly presignedURLInSchema: PresignedURLInSchema
}

/**
 * Request parameters for usersViewsNinjaUserVerificationListSubmittedVerificationDocuments operation in UserVerificationApi.
 * @export
 * @interface UserVerificationApiUsersViewsNinjaUserVerificationListSubmittedVerificationDocumentsRequest
 */
export interface UserVerificationApiUsersViewsNinjaUserVerificationListSubmittedVerificationDocumentsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UserVerificationApiUsersViewsNinjaUserVerificationListSubmittedVerificationDocuments
     */
    readonly verified?: boolean | null

    /**
     * 
     * @type {VerificationDocumentStatus}
     * @memberof UserVerificationApiUsersViewsNinjaUserVerificationListSubmittedVerificationDocuments
     */
    readonly status?: VerificationDocumentStatus | null

    /**
     * 
     * @type {number}
     * @memberof UserVerificationApiUsersViewsNinjaUserVerificationListSubmittedVerificationDocuments
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof UserVerificationApiUsersViewsNinjaUserVerificationListSubmittedVerificationDocuments
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof UserVerificationApiUsersViewsNinjaUserVerificationListSubmittedVerificationDocuments
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for usersViewsNinjaUserVerificationRequestUserVerification operation in UserVerificationApi.
 * @export
 * @interface UserVerificationApiUsersViewsNinjaUserVerificationRequestUserVerificationRequest
 */
export interface UserVerificationApiUsersViewsNinjaUserVerificationRequestUserVerificationRequest {
    /**
     * 
     * @type {RequestVerificationInSchema}
     * @memberof UserVerificationApiUsersViewsNinjaUserVerificationRequestUserVerification
     */
    readonly requestVerificationInSchema: RequestVerificationInSchema
}

/**
 * Request parameters for usersViewsNinjaUserVerificationRequestVerificationOtp operation in UserVerificationApi.
 * @export
 * @interface UserVerificationApiUsersViewsNinjaUserVerificationRequestVerificationOtpRequest
 */
export interface UserVerificationApiUsersViewsNinjaUserVerificationRequestVerificationOtpRequest {
    /**
     * 
     * @type {string}
     * @memberof UserVerificationApiUsersViewsNinjaUserVerificationRequestVerificationOtp
     */
    readonly token: string
}

/**
 * Request parameters for usersViewsNinjaUserVerificationUploadVerificationDocument operation in UserVerificationApi.
 * @export
 * @interface UserVerificationApiUsersViewsNinjaUserVerificationUploadVerificationDocumentRequest
 */
export interface UserVerificationApiUsersViewsNinjaUserVerificationUploadVerificationDocumentRequest {
    /**
     * 
     * @type {VerificationDocumentInSchema}
     * @memberof UserVerificationApiUsersViewsNinjaUserVerificationUploadVerificationDocument
     */
    readonly verificationDocumentInSchema: VerificationDocumentInSchema
}

/**
 * Request parameters for usersViewsNinjaUserVerificationUploadVerificationDocumentByThirdParty operation in UserVerificationApi.
 * @export
 * @interface UserVerificationApiUsersViewsNinjaUserVerificationUploadVerificationDocumentByThirdPartyRequest
 */
export interface UserVerificationApiUsersViewsNinjaUserVerificationUploadVerificationDocumentByThirdPartyRequest {
    /**
     * 
     * @type {VerificationDocumentThirdPartyInSchema}
     * @memberof UserVerificationApiUsersViewsNinjaUserVerificationUploadVerificationDocumentByThirdParty
     */
    readonly verificationDocumentThirdPartyInSchema: VerificationDocumentThirdPartyInSchema
}

/**
 * Request parameters for usersViewsNinjaUserVerificationVerifyVerificationToken operation in UserVerificationApi.
 * @export
 * @interface UserVerificationApiUsersViewsNinjaUserVerificationVerifyVerificationTokenRequest
 */
export interface UserVerificationApiUsersViewsNinjaUserVerificationVerifyVerificationTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof UserVerificationApiUsersViewsNinjaUserVerificationVerifyVerificationToken
     */
    readonly token: string
}

/**
 * UserVerificationApi - object-oriented interface
 * @export
 * @class UserVerificationApi
 * @extends {BaseAPI}
 */
export class UserVerificationApi extends BaseAPI {
    /**
     * Completes verification process by the delegated user
     * @summary Complete Verification By Third Party
     * @param {UserVerificationApiUsersViewsNinjaUserVerificationCompleteVerificationByThirdPartyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserVerificationApi
     */
    public usersViewsNinjaUserVerificationCompleteVerificationByThirdParty(requestParameters: UserVerificationApiUsersViewsNinjaUserVerificationCompleteVerificationByThirdPartyRequest, options?: RawAxiosRequestConfig) {
        return UserVerificationApiFp(this.configuration).usersViewsNinjaUserVerificationCompleteVerificationByThirdParty(requestParameters.completeVerificationInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Confirm Verification Otp
     * @param {UserVerificationApiUsersViewsNinjaUserVerificationConfirmVerificationOtpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserVerificationApi
     */
    public usersViewsNinjaUserVerificationConfirmVerificationOtp(requestParameters: UserVerificationApiUsersViewsNinjaUserVerificationConfirmVerificationOtpRequest, options?: RawAxiosRequestConfig) {
        return UserVerificationApiFp(this.configuration).usersViewsNinjaUserVerificationConfirmVerificationOtp(requestParameters.verificationOTPInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends notifications to the delegated user to initiate verification process.
     * @summary Delegate verification
     * @param {UserVerificationApiUsersViewsNinjaUserVerificationDelegateVerificationToThirdPartyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserVerificationApi
     */
    public usersViewsNinjaUserVerificationDelegateVerificationToThirdParty(requestParameters: UserVerificationApiUsersViewsNinjaUserVerificationDelegateVerificationToThirdPartyRequest, options?: RawAxiosRequestConfig) {
        return UserVerificationApiFp(this.configuration).usersViewsNinjaUserVerificationDelegateVerificationToThirdParty(requestParameters.delegateVerificationInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate Presigned Upload Url For Verification Document
     * @param {UserVerificationApiUsersViewsNinjaUserVerificationGeneratePresignedUploadUrlForVerificationDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserVerificationApi
     */
    public usersViewsNinjaUserVerificationGeneratePresignedUploadUrlForVerificationDocument(requestParameters: UserVerificationApiUsersViewsNinjaUserVerificationGeneratePresignedUploadUrlForVerificationDocumentRequest, options?: RawAxiosRequestConfig) {
        return UserVerificationApiFp(this.configuration).usersViewsNinjaUserVerificationGeneratePresignedUploadUrlForVerificationDocument(requestParameters.presignedURLInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get User Verification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserVerificationApi
     */
    public usersViewsNinjaUserVerificationGetUserVerification(options?: RawAxiosRequestConfig) {
        return UserVerificationApiFp(this.configuration).usersViewsNinjaUserVerificationGetUserVerification(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Remaining Verification Documents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserVerificationApi
     */
    public usersViewsNinjaUserVerificationListRemainingVerificationDocuments(options?: RawAxiosRequestConfig) {
        return UserVerificationApiFp(this.configuration).usersViewsNinjaUserVerificationListRemainingVerificationDocuments(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Submitted Verification Documents
     * @param {UserVerificationApiUsersViewsNinjaUserVerificationListSubmittedVerificationDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserVerificationApi
     */
    public usersViewsNinjaUserVerificationListSubmittedVerificationDocuments(requestParameters: UserVerificationApiUsersViewsNinjaUserVerificationListSubmittedVerificationDocumentsRequest = {}, options?: RawAxiosRequestConfig) {
        return UserVerificationApiFp(this.configuration).usersViewsNinjaUserVerificationListSubmittedVerificationDocuments(requestParameters.verified, requestParameters.status, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Triggers the user verification process.
     * @summary Request user verification
     * @param {UserVerificationApiUsersViewsNinjaUserVerificationRequestUserVerificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserVerificationApi
     */
    public usersViewsNinjaUserVerificationRequestUserVerification(requestParameters: UserVerificationApiUsersViewsNinjaUserVerificationRequestUserVerificationRequest, options?: RawAxiosRequestConfig) {
        return UserVerificationApiFp(this.configuration).usersViewsNinjaUserVerificationRequestUserVerification(requestParameters.requestVerificationInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request Verification Otp
     * @param {UserVerificationApiUsersViewsNinjaUserVerificationRequestVerificationOtpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserVerificationApi
     */
    public usersViewsNinjaUserVerificationRequestVerificationOtp(requestParameters: UserVerificationApiUsersViewsNinjaUserVerificationRequestVerificationOtpRequest, options?: RawAxiosRequestConfig) {
        return UserVerificationApiFp(this.configuration).usersViewsNinjaUserVerificationRequestVerificationOtp(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload Verification Document
     * @param {UserVerificationApiUsersViewsNinjaUserVerificationUploadVerificationDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserVerificationApi
     */
    public usersViewsNinjaUserVerificationUploadVerificationDocument(requestParameters: UserVerificationApiUsersViewsNinjaUserVerificationUploadVerificationDocumentRequest, options?: RawAxiosRequestConfig) {
        return UserVerificationApiFp(this.configuration).usersViewsNinjaUserVerificationUploadVerificationDocument(requestParameters.verificationDocumentInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload Verification Document By Third Party
     * @param {UserVerificationApiUsersViewsNinjaUserVerificationUploadVerificationDocumentByThirdPartyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserVerificationApi
     */
    public usersViewsNinjaUserVerificationUploadVerificationDocumentByThirdParty(requestParameters: UserVerificationApiUsersViewsNinjaUserVerificationUploadVerificationDocumentByThirdPartyRequest, options?: RawAxiosRequestConfig) {
        return UserVerificationApiFp(this.configuration).usersViewsNinjaUserVerificationUploadVerificationDocumentByThirdParty(requestParameters.verificationDocumentThirdPartyInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify Verification Token
     * @param {UserVerificationApiUsersViewsNinjaUserVerificationVerifyVerificationTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserVerificationApi
     */
    public usersViewsNinjaUserVerificationVerifyVerificationToken(requestParameters: UserVerificationApiUsersViewsNinjaUserVerificationVerifyVerificationTokenRequest, options?: RawAxiosRequestConfig) {
        return UserVerificationApiFp(this.configuration).usersViewsNinjaUserVerificationVerifyVerificationToken(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check User Exist
         * @param {string} mobile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersCheckUserExist: async (mobile: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mobile' is not null or undefined
            assertParamExists('usersViewsNinjaUsersCheckUserExist', 'mobile', mobile)
            const localVarPath = `/api/user/check/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mobile !== undefined) {
                localVarQueryParameter['mobile'] = mobile;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Free Trial Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersGetFreeTrialData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/free-trial/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Invitations
         * @param {ProfileInvitationStatus | null} [invitationStatus] 
         * @param {number | null} [businessId] 
         * @param {number | null} [businessNumberId] 
         * @param {number | null} [userId] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersGetInvitations: async (invitationStatus?: ProfileInvitationStatus | null, businessId?: number | null, businessNumberId?: number | null, userId?: number | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/me/invitations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (invitationStatus !== undefined) {
                localVarQueryParameter['invitation_status'] = invitationStatus;
            }

            if (businessId !== undefined) {
                localVarQueryParameter['business_id'] = businessId;
            }

            if (businessNumberId !== undefined) {
                localVarQueryParameter['business_number_id'] = businessNumberId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Minimal User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersGetMinimalUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/me/minimal/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Notifications
         * @param {string | null} [description] 
         * @param {NotificationType | null} [type] 
         * @param {string | null} [dateCreatedRange] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersGetNotifications: async (description?: string | null, type?: NotificationType | null, dateCreatedRange?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/me/notifications/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (dateCreatedRange !== undefined) {
                localVarQueryParameter['date_created_range'] = dateCreatedRange;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Personal Channel Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersGetPersonalChannelToken: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/me/token/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersGetUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/me/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get User Business
         * @param {string | null} [name] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersGetUserBusiness: async (name?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/me/business/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get User V2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersGetUserV2: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/me/v2/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Demo Videos
         * @param {string | null} [title] 
         * @param {string | null} [visibility] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersListDemoVideos: async (title?: string | null, visibility?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/demo-video/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (visibility !== undefined) {
                localVarQueryParameter['visibility'] = visibility;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List User Business Numbers
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersListUserBusinessNumbers: async (pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/me/business-number/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register User
         * @param {UserInSchema} userInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersRegisterUser: async (userInSchema: UserInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userInSchema' is not null or undefined
            assertParamExists('usersViewsNinjaUsersRegisterUser', 'userInSchema', userInSchema)
            const localVarPath = `/api/user/register/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Feedback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersUpdateFeedback: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/feedback/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Session Activity
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersUpdateSessionActivity: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/session-activity/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update User
         * @param {UserUpdateSchema} userUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersUpdateUser: async (userUpdateSchema: UserUpdateSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userUpdateSchema' is not null or undefined
            assertParamExists('usersViewsNinjaUsersUpdateUser', 'userUpdateSchema', userUpdateSchema)
            const localVarPath = `/api/user/me/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userUpdateSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check User Exist
         * @param {string} mobile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUsersCheckUserExist(mobile: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUsersCheckUserExist(mobile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersViewsNinjaUsersCheckUserExist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Free Trial Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUsersGetFreeTrialData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FreeTrialDataOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUsersGetFreeTrialData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersViewsNinjaUsersGetFreeTrialData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Invitations
         * @param {ProfileInvitationStatus | null} [invitationStatus] 
         * @param {number | null} [businessId] 
         * @param {number | null} [businessNumberId] 
         * @param {number | null} [userId] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUsersGetInvitations(invitationStatus?: ProfileInvitationStatus | null, businessId?: number | null, businessNumberId?: number | null, userId?: number | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedInvitationOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUsersGetInvitations(invitationStatus, businessId, businessNumberId, userId, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersViewsNinjaUsersGetInvitations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Minimal User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUsersGetMinimalUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MinimalUserOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUsersGetMinimalUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersViewsNinjaUsersGetMinimalUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Notifications
         * @param {string | null} [description] 
         * @param {NotificationType | null} [type] 
         * @param {string | null} [dateCreatedRange] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUsersGetNotifications(description?: string | null, type?: NotificationType | null, dateCreatedRange?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedNotificationOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUsersGetNotifications(description, type, dateCreatedRange, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersViewsNinjaUsersGetNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Personal Channel Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUsersGetPersonalChannelToken(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChannelTokenOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUsersGetPersonalChannelToken(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersViewsNinjaUsersGetPersonalChannelToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUsersGetUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUsersGetUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersViewsNinjaUsersGetUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get User Business
         * @param {string | null} [name] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUsersGetUserBusiness(name?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedBusinessMinimalOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUsersGetUserBusiness(name, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersViewsNinjaUsersGetUserBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get User V2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUsersGetUserV2(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserOutSchemaV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUsersGetUserV2(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersViewsNinjaUsersGetUserV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Demo Videos
         * @param {string | null} [title] 
         * @param {string | null} [visibility] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUsersListDemoVideos(title?: string | null, visibility?: string | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedDemoVideoOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUsersListDemoVideos(title, visibility, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersViewsNinjaUsersListDemoVideos']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List User Business Numbers
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUsersListUserBusinessNumbers(pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedBusinessNumberBusinessOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUsersListUserBusinessNumbers(pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersViewsNinjaUsersListUserBusinessNumbers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Register User
         * @param {UserInSchema} userInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUsersRegisterUser(userInSchema: UserInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MinimalUserOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUsersRegisterUser(userInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersViewsNinjaUsersRegisterUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Feedback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUsersUpdateFeedback(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUsersUpdateFeedback(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersViewsNinjaUsersUpdateFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Session Activity
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async usersViewsNinjaUsersUpdateSessionActivity(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUsersUpdateSessionActivity(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersViewsNinjaUsersUpdateSessionActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update User
         * @param {UserUpdateSchema} userUpdateSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersViewsNinjaUsersUpdateUser(userUpdateSchema: UserUpdateSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersViewsNinjaUsersUpdateUser(userUpdateSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersViewsNinjaUsersUpdateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @summary Check User Exist
         * @param {UsersApiUsersViewsNinjaUsersCheckUserExistRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersCheckUserExist(requestParameters: UsersApiUsersViewsNinjaUsersCheckUserExistRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaUsersCheckUserExist(requestParameters.mobile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Free Trial Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersGetFreeTrialData(options?: RawAxiosRequestConfig): AxiosPromise<FreeTrialDataOutSchema> {
            return localVarFp.usersViewsNinjaUsersGetFreeTrialData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Invitations
         * @param {UsersApiUsersViewsNinjaUsersGetInvitationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersGetInvitations(requestParameters: UsersApiUsersViewsNinjaUsersGetInvitationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PagedInvitationOutSchema> {
            return localVarFp.usersViewsNinjaUsersGetInvitations(requestParameters.invitationStatus, requestParameters.businessId, requestParameters.businessNumberId, requestParameters.userId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Minimal User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersGetMinimalUser(options?: RawAxiosRequestConfig): AxiosPromise<MinimalUserOutSchema> {
            return localVarFp.usersViewsNinjaUsersGetMinimalUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Notifications
         * @param {UsersApiUsersViewsNinjaUsersGetNotificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersGetNotifications(requestParameters: UsersApiUsersViewsNinjaUsersGetNotificationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PagedNotificationOutSchema> {
            return localVarFp.usersViewsNinjaUsersGetNotifications(requestParameters.description, requestParameters.type, requestParameters.dateCreatedRange, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Personal Channel Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersGetPersonalChannelToken(options?: RawAxiosRequestConfig): AxiosPromise<ChannelTokenOutSchema> {
            return localVarFp.usersViewsNinjaUsersGetPersonalChannelToken(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersGetUser(options?: RawAxiosRequestConfig): AxiosPromise<UserOutSchema> {
            return localVarFp.usersViewsNinjaUsersGetUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get User Business
         * @param {UsersApiUsersViewsNinjaUsersGetUserBusinessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersGetUserBusiness(requestParameters: UsersApiUsersViewsNinjaUsersGetUserBusinessRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PagedBusinessMinimalOutSchema> {
            return localVarFp.usersViewsNinjaUsersGetUserBusiness(requestParameters.name, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get User V2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersGetUserV2(options?: RawAxiosRequestConfig): AxiosPromise<UserOutSchemaV2> {
            return localVarFp.usersViewsNinjaUsersGetUserV2(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Demo Videos
         * @param {UsersApiUsersViewsNinjaUsersListDemoVideosRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersListDemoVideos(requestParameters: UsersApiUsersViewsNinjaUsersListDemoVideosRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PagedDemoVideoOutSchema> {
            return localVarFp.usersViewsNinjaUsersListDemoVideos(requestParameters.title, requestParameters.visibility, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List User Business Numbers
         * @param {UsersApiUsersViewsNinjaUsersListUserBusinessNumbersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersListUserBusinessNumbers(requestParameters: UsersApiUsersViewsNinjaUsersListUserBusinessNumbersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PagedBusinessNumberBusinessOutSchema> {
            return localVarFp.usersViewsNinjaUsersListUserBusinessNumbers(requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register User
         * @param {UsersApiUsersViewsNinjaUsersRegisterUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersRegisterUser(requestParameters: UsersApiUsersViewsNinjaUsersRegisterUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<MinimalUserOutSchema> {
            return localVarFp.usersViewsNinjaUsersRegisterUser(requestParameters.userInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Feedback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersUpdateFeedback(options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaUsersUpdateFeedback(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Session Activity
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersUpdateSessionActivity(options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaUsersUpdateSessionActivity(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update User
         * @param {UsersApiUsersViewsNinjaUsersUpdateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersViewsNinjaUsersUpdateUser(requestParameters: UsersApiUsersViewsNinjaUsersUpdateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.usersViewsNinjaUsersUpdateUser(requestParameters.userUpdateSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for usersViewsNinjaUsersCheckUserExist operation in UsersApi.
 * @export
 * @interface UsersApiUsersViewsNinjaUsersCheckUserExistRequest
 */
export interface UsersApiUsersViewsNinjaUsersCheckUserExistRequest {
    /**
     * 
     * @type {string}
     * @memberof UsersApiUsersViewsNinjaUsersCheckUserExist
     */
    readonly mobile: string
}

/**
 * Request parameters for usersViewsNinjaUsersGetInvitations operation in UsersApi.
 * @export
 * @interface UsersApiUsersViewsNinjaUsersGetInvitationsRequest
 */
export interface UsersApiUsersViewsNinjaUsersGetInvitationsRequest {
    /**
     * 
     * @type {ProfileInvitationStatus}
     * @memberof UsersApiUsersViewsNinjaUsersGetInvitations
     */
    readonly invitationStatus?: ProfileInvitationStatus | null

    /**
     * 
     * @type {number}
     * @memberof UsersApiUsersViewsNinjaUsersGetInvitations
     */
    readonly businessId?: number | null

    /**
     * 
     * @type {number}
     * @memberof UsersApiUsersViewsNinjaUsersGetInvitations
     */
    readonly businessNumberId?: number | null

    /**
     * 
     * @type {number}
     * @memberof UsersApiUsersViewsNinjaUsersGetInvitations
     */
    readonly userId?: number | null

    /**
     * 
     * @type {number}
     * @memberof UsersApiUsersViewsNinjaUsersGetInvitations
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof UsersApiUsersViewsNinjaUsersGetInvitations
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof UsersApiUsersViewsNinjaUsersGetInvitations
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for usersViewsNinjaUsersGetNotifications operation in UsersApi.
 * @export
 * @interface UsersApiUsersViewsNinjaUsersGetNotificationsRequest
 */
export interface UsersApiUsersViewsNinjaUsersGetNotificationsRequest {
    /**
     * 
     * @type {string}
     * @memberof UsersApiUsersViewsNinjaUsersGetNotifications
     */
    readonly description?: string | null

    /**
     * 
     * @type {NotificationType}
     * @memberof UsersApiUsersViewsNinjaUsersGetNotifications
     */
    readonly type?: NotificationType | null

    /**
     * 
     * @type {string}
     * @memberof UsersApiUsersViewsNinjaUsersGetNotifications
     */
    readonly dateCreatedRange?: string | null

    /**
     * 
     * @type {number}
     * @memberof UsersApiUsersViewsNinjaUsersGetNotifications
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof UsersApiUsersViewsNinjaUsersGetNotifications
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof UsersApiUsersViewsNinjaUsersGetNotifications
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for usersViewsNinjaUsersGetUserBusiness operation in UsersApi.
 * @export
 * @interface UsersApiUsersViewsNinjaUsersGetUserBusinessRequest
 */
export interface UsersApiUsersViewsNinjaUsersGetUserBusinessRequest {
    /**
     * 
     * @type {string}
     * @memberof UsersApiUsersViewsNinjaUsersGetUserBusiness
     */
    readonly name?: string | null

    /**
     * 
     * @type {number}
     * @memberof UsersApiUsersViewsNinjaUsersGetUserBusiness
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof UsersApiUsersViewsNinjaUsersGetUserBusiness
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof UsersApiUsersViewsNinjaUsersGetUserBusiness
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for usersViewsNinjaUsersListDemoVideos operation in UsersApi.
 * @export
 * @interface UsersApiUsersViewsNinjaUsersListDemoVideosRequest
 */
export interface UsersApiUsersViewsNinjaUsersListDemoVideosRequest {
    /**
     * 
     * @type {string}
     * @memberof UsersApiUsersViewsNinjaUsersListDemoVideos
     */
    readonly title?: string | null

    /**
     * 
     * @type {string}
     * @memberof UsersApiUsersViewsNinjaUsersListDemoVideos
     */
    readonly visibility?: string | null

    /**
     * 
     * @type {number}
     * @memberof UsersApiUsersViewsNinjaUsersListDemoVideos
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof UsersApiUsersViewsNinjaUsersListDemoVideos
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof UsersApiUsersViewsNinjaUsersListDemoVideos
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for usersViewsNinjaUsersListUserBusinessNumbers operation in UsersApi.
 * @export
 * @interface UsersApiUsersViewsNinjaUsersListUserBusinessNumbersRequest
 */
export interface UsersApiUsersViewsNinjaUsersListUserBusinessNumbersRequest {
    /**
     * 
     * @type {number}
     * @memberof UsersApiUsersViewsNinjaUsersListUserBusinessNumbers
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof UsersApiUsersViewsNinjaUsersListUserBusinessNumbers
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof UsersApiUsersViewsNinjaUsersListUserBusinessNumbers
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for usersViewsNinjaUsersRegisterUser operation in UsersApi.
 * @export
 * @interface UsersApiUsersViewsNinjaUsersRegisterUserRequest
 */
export interface UsersApiUsersViewsNinjaUsersRegisterUserRequest {
    /**
     * 
     * @type {UserInSchema}
     * @memberof UsersApiUsersViewsNinjaUsersRegisterUser
     */
    readonly userInSchema: UserInSchema
}

/**
 * Request parameters for usersViewsNinjaUsersUpdateUser operation in UsersApi.
 * @export
 * @interface UsersApiUsersViewsNinjaUsersUpdateUserRequest
 */
export interface UsersApiUsersViewsNinjaUsersUpdateUserRequest {
    /**
     * 
     * @type {UserUpdateSchema}
     * @memberof UsersApiUsersViewsNinjaUsersUpdateUser
     */
    readonly userUpdateSchema: UserUpdateSchema
}

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @summary Check User Exist
     * @param {UsersApiUsersViewsNinjaUsersCheckUserExistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersViewsNinjaUsersCheckUserExist(requestParameters: UsersApiUsersViewsNinjaUsersCheckUserExistRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersViewsNinjaUsersCheckUserExist(requestParameters.mobile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Free Trial Data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersViewsNinjaUsersGetFreeTrialData(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersViewsNinjaUsersGetFreeTrialData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Invitations
     * @param {UsersApiUsersViewsNinjaUsersGetInvitationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersViewsNinjaUsersGetInvitations(requestParameters: UsersApiUsersViewsNinjaUsersGetInvitationsRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersViewsNinjaUsersGetInvitations(requestParameters.invitationStatus, requestParameters.businessId, requestParameters.businessNumberId, requestParameters.userId, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Minimal User
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersViewsNinjaUsersGetMinimalUser(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersViewsNinjaUsersGetMinimalUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Notifications
     * @param {UsersApiUsersViewsNinjaUsersGetNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersViewsNinjaUsersGetNotifications(requestParameters: UsersApiUsersViewsNinjaUsersGetNotificationsRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersViewsNinjaUsersGetNotifications(requestParameters.description, requestParameters.type, requestParameters.dateCreatedRange, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Personal Channel Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersViewsNinjaUsersGetPersonalChannelToken(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersViewsNinjaUsersGetPersonalChannelToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get User
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersViewsNinjaUsersGetUser(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersViewsNinjaUsersGetUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get User Business
     * @param {UsersApiUsersViewsNinjaUsersGetUserBusinessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersViewsNinjaUsersGetUserBusiness(requestParameters: UsersApiUsersViewsNinjaUsersGetUserBusinessRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersViewsNinjaUsersGetUserBusiness(requestParameters.name, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get User V2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersViewsNinjaUsersGetUserV2(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersViewsNinjaUsersGetUserV2(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Demo Videos
     * @param {UsersApiUsersViewsNinjaUsersListDemoVideosRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersViewsNinjaUsersListDemoVideos(requestParameters: UsersApiUsersViewsNinjaUsersListDemoVideosRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersViewsNinjaUsersListDemoVideos(requestParameters.title, requestParameters.visibility, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List User Business Numbers
     * @param {UsersApiUsersViewsNinjaUsersListUserBusinessNumbersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersViewsNinjaUsersListUserBusinessNumbers(requestParameters: UsersApiUsersViewsNinjaUsersListUserBusinessNumbersRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersViewsNinjaUsersListUserBusinessNumbers(requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register User
     * @param {UsersApiUsersViewsNinjaUsersRegisterUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersViewsNinjaUsersRegisterUser(requestParameters: UsersApiUsersViewsNinjaUsersRegisterUserRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersViewsNinjaUsersRegisterUser(requestParameters.userInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Feedback
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersViewsNinjaUsersUpdateFeedback(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersViewsNinjaUsersUpdateFeedback(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Session Activity
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersViewsNinjaUsersUpdateSessionActivity(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersViewsNinjaUsersUpdateSessionActivity(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update User
     * @param {UsersApiUsersViewsNinjaUsersUpdateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersViewsNinjaUsersUpdateUser(requestParameters: UsersApiUsersViewsNinjaUsersUpdateUserRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersViewsNinjaUsersUpdateUser(requestParameters.userUpdateSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VoicemailMessageApi - axios parameter creator
 * @export
 */
export const VoicemailMessageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Voicemail Message
         * @param {number} businessId 
         * @param {number} voiceMessageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallVoicemailMessageGetVoicemailMessage: async (businessId: number, voiceMessageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallVoicemailMessageGetVoicemailMessage', 'businessId', businessId)
            // verify required parameter 'voiceMessageId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallVoicemailMessageGetVoicemailMessage', 'voiceMessageId', voiceMessageId)
            const localVarPath = `/api/business/{business_id}/voicemail-message/{voice_message_id}/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"voice_message_id"}}`, encodeURIComponent(String(voiceMessageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Voicemail Message
         * @param {number} businessId 
         * @param {number} numberId 
         * @param {string | null} [dateCreatedRange] 
         * @param {string | null} [phoneNumber] 
         * @param {boolean | null} [isPlayed] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallVoicemailMessageListVoicemailMessage: async (businessId: number, numberId: number, dateCreatedRange?: string | null, phoneNumber?: string | null, isPlayed?: boolean | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallVoicemailMessageListVoicemailMessage', 'businessId', businessId)
            // verify required parameter 'numberId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallVoicemailMessageListVoicemailMessage', 'numberId', numberId)
            const localVarPath = `/api/business/{business_id}/voicemail-message/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (numberId !== undefined) {
                localVarQueryParameter['number_id'] = numberId;
            }

            if (dateCreatedRange !== undefined) {
                localVarQueryParameter['date_created_range'] = dateCreatedRange;
            }

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phone_number'] = phoneNumber;
            }

            if (isPlayed !== undefined) {
                localVarQueryParameter['is_played'] = isPlayed;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['page_index'] = pageIndex;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Voicemail Audio Status
         * @param {number} businessId 
         * @param {number} voiceMessageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallVoicemailMessageUpdateVoicemailAudioStatus: async (businessId: number, voiceMessageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallVoicemailMessageUpdateVoicemailAudioStatus', 'businessId', businessId)
            // verify required parameter 'voiceMessageId' is not null or undefined
            assertParamExists('telephonyViewsNinjaCallVoicemailMessageUpdateVoicemailAudioStatus', 'voiceMessageId', voiceMessageId)
            const localVarPath = `/api/business/{business_id}/voicemail-message/{voice_message_id}/played/`
                .replace(`{${"business_id"}}`, encodeURIComponent(String(businessId)))
                .replace(`{${"voice_message_id"}}`, encodeURIComponent(String(voiceMessageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VoicemailMessageApi - functional programming interface
 * @export
 */
export const VoicemailMessageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VoicemailMessageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Voicemail Message
         * @param {number} businessId 
         * @param {number} voiceMessageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallVoicemailMessageGetVoicemailMessage(businessId: number, voiceMessageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoicemailMessageOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallVoicemailMessageGetVoicemailMessage(businessId, voiceMessageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoicemailMessageApi.telephonyViewsNinjaCallVoicemailMessageGetVoicemailMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Voicemail Message
         * @param {number} businessId 
         * @param {number} numberId 
         * @param {string | null} [dateCreatedRange] 
         * @param {string | null} [phoneNumber] 
         * @param {boolean | null} [isPlayed] 
         * @param {number} [pageIndex] 
         * @param {number} [pageSize] 
         * @param {string | null} [ordering] Ordering of the results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallVoicemailMessageListVoicemailMessage(businessId: number, numberId: number, dateCreatedRange?: string | null, phoneNumber?: string | null, isPlayed?: boolean | null, pageIndex?: number, pageSize?: number, ordering?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedVoicemailMessageOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallVoicemailMessageListVoicemailMessage(businessId, numberId, dateCreatedRange, phoneNumber, isPlayed, pageIndex, pageSize, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoicemailMessageApi.telephonyViewsNinjaCallVoicemailMessageListVoicemailMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Voicemail Audio Status
         * @param {number} businessId 
         * @param {number} voiceMessageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telephonyViewsNinjaCallVoicemailMessageUpdateVoicemailAudioStatus(businessId: number, voiceMessageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telephonyViewsNinjaCallVoicemailMessageUpdateVoicemailAudioStatus(businessId, voiceMessageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoicemailMessageApi.telephonyViewsNinjaCallVoicemailMessageUpdateVoicemailAudioStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VoicemailMessageApi - factory interface
 * @export
 */
export const VoicemailMessageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VoicemailMessageApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Voicemail Message
         * @param {VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageGetVoicemailMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallVoicemailMessageGetVoicemailMessage(requestParameters: VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageGetVoicemailMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<VoicemailMessageOutSchema> {
            return localVarFp.telephonyViewsNinjaCallVoicemailMessageGetVoicemailMessage(requestParameters.businessId, requestParameters.voiceMessageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Voicemail Message
         * @param {VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageListVoicemailMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallVoicemailMessageListVoicemailMessage(requestParameters: VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageListVoicemailMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<PagedVoicemailMessageOutSchema> {
            return localVarFp.telephonyViewsNinjaCallVoicemailMessageListVoicemailMessage(requestParameters.businessId, requestParameters.numberId, requestParameters.dateCreatedRange, requestParameters.phoneNumber, requestParameters.isPlayed, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Voicemail Audio Status
         * @param {VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageUpdateVoicemailAudioStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telephonyViewsNinjaCallVoicemailMessageUpdateVoicemailAudioStatus(requestParameters: VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageUpdateVoicemailAudioStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.telephonyViewsNinjaCallVoicemailMessageUpdateVoicemailAudioStatus(requestParameters.businessId, requestParameters.voiceMessageId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for telephonyViewsNinjaCallVoicemailMessageGetVoicemailMessage operation in VoicemailMessageApi.
 * @export
 * @interface VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageGetVoicemailMessageRequest
 */
export interface VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageGetVoicemailMessageRequest {
    /**
     * 
     * @type {number}
     * @memberof VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageGetVoicemailMessage
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageGetVoicemailMessage
     */
    readonly voiceMessageId: number
}

/**
 * Request parameters for telephonyViewsNinjaCallVoicemailMessageListVoicemailMessage operation in VoicemailMessageApi.
 * @export
 * @interface VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageListVoicemailMessageRequest
 */
export interface VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageListVoicemailMessageRequest {
    /**
     * 
     * @type {number}
     * @memberof VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageListVoicemailMessage
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageListVoicemailMessage
     */
    readonly numberId: number

    /**
     * 
     * @type {string}
     * @memberof VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageListVoicemailMessage
     */
    readonly dateCreatedRange?: string | null

    /**
     * 
     * @type {string}
     * @memberof VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageListVoicemailMessage
     */
    readonly phoneNumber?: string | null

    /**
     * 
     * @type {boolean}
     * @memberof VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageListVoicemailMessage
     */
    readonly isPlayed?: boolean | null

    /**
     * 
     * @type {number}
     * @memberof VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageListVoicemailMessage
     */
    readonly pageIndex?: number

    /**
     * 
     * @type {number}
     * @memberof VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageListVoicemailMessage
     */
    readonly pageSize?: number

    /**
     * Ordering of the results
     * @type {string}
     * @memberof VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageListVoicemailMessage
     */
    readonly ordering?: string | null
}

/**
 * Request parameters for telephonyViewsNinjaCallVoicemailMessageUpdateVoicemailAudioStatus operation in VoicemailMessageApi.
 * @export
 * @interface VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageUpdateVoicemailAudioStatusRequest
 */
export interface VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageUpdateVoicemailAudioStatusRequest {
    /**
     * 
     * @type {number}
     * @memberof VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageUpdateVoicemailAudioStatus
     */
    readonly businessId: number

    /**
     * 
     * @type {number}
     * @memberof VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageUpdateVoicemailAudioStatus
     */
    readonly voiceMessageId: number
}

/**
 * VoicemailMessageApi - object-oriented interface
 * @export
 * @class VoicemailMessageApi
 * @extends {BaseAPI}
 */
export class VoicemailMessageApi extends BaseAPI {
    /**
     * 
     * @summary Get Voicemail Message
     * @param {VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageGetVoicemailMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicemailMessageApi
     */
    public telephonyViewsNinjaCallVoicemailMessageGetVoicemailMessage(requestParameters: VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageGetVoicemailMessageRequest, options?: RawAxiosRequestConfig) {
        return VoicemailMessageApiFp(this.configuration).telephonyViewsNinjaCallVoicemailMessageGetVoicemailMessage(requestParameters.businessId, requestParameters.voiceMessageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Voicemail Message
     * @param {VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageListVoicemailMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicemailMessageApi
     */
    public telephonyViewsNinjaCallVoicemailMessageListVoicemailMessage(requestParameters: VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageListVoicemailMessageRequest, options?: RawAxiosRequestConfig) {
        return VoicemailMessageApiFp(this.configuration).telephonyViewsNinjaCallVoicemailMessageListVoicemailMessage(requestParameters.businessId, requestParameters.numberId, requestParameters.dateCreatedRange, requestParameters.phoneNumber, requestParameters.isPlayed, requestParameters.pageIndex, requestParameters.pageSize, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Voicemail Audio Status
     * @param {VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageUpdateVoicemailAudioStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicemailMessageApi
     */
    public telephonyViewsNinjaCallVoicemailMessageUpdateVoicemailAudioStatus(requestParameters: VoicemailMessageApiTelephonyViewsNinjaCallVoicemailMessageUpdateVoicemailAudioStatusRequest, options?: RawAxiosRequestConfig) {
        return VoicemailMessageApiFp(this.configuration).telephonyViewsNinjaCallVoicemailMessageUpdateVoicemailAudioStatus(requestParameters.businessId, requestParameters.voiceMessageId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WalletsApi - axios parameter creator
 * @export
 */
export const WalletsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Wallet
         * @param {CreateWalletInSchema} createWalletInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaAccountsCreateWallet: async (createWalletInSchema: CreateWalletInSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createWalletInSchema' is not null or undefined
            assertParamExists('paymentsViewsNinjaAccountsCreateWallet', 'createWalletInSchema', createWalletInSchema)
            const localVarPath = `/api/accounts/wallet/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWalletInSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Wallets
         * @param {number | null} [businessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaAccountsGetWallets: async (businessId?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/accounts/wallet/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (businessId !== undefined) {
                localVarQueryParameter['business_id'] = businessId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WalletsApi - functional programming interface
 * @export
 */
export const WalletsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WalletsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Wallet
         * @param {CreateWalletInSchema} createWalletInSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaAccountsCreateWallet(createWalletInSchema: CreateWalletInSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseWalletOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaAccountsCreateWallet(createWalletInSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WalletsApi.paymentsViewsNinjaAccountsCreateWallet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Wallets
         * @param {number | null} [businessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsViewsNinjaAccountsGetWallets(businessId?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseListWalletOutSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsViewsNinjaAccountsGetWallets(businessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WalletsApi.paymentsViewsNinjaAccountsGetWallets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WalletsApi - factory interface
 * @export
 */
export const WalletsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WalletsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Wallet
         * @param {WalletsApiPaymentsViewsNinjaAccountsCreateWalletRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaAccountsCreateWallet(requestParameters: WalletsApiPaymentsViewsNinjaAccountsCreateWalletRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseWalletOutSchema> {
            return localVarFp.paymentsViewsNinjaAccountsCreateWallet(requestParameters.createWalletInSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Wallets
         * @param {WalletsApiPaymentsViewsNinjaAccountsGetWalletsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsViewsNinjaAccountsGetWallets(requestParameters: WalletsApiPaymentsViewsNinjaAccountsGetWalletsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ResponseListWalletOutSchema> {
            return localVarFp.paymentsViewsNinjaAccountsGetWallets(requestParameters.businessId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for paymentsViewsNinjaAccountsCreateWallet operation in WalletsApi.
 * @export
 * @interface WalletsApiPaymentsViewsNinjaAccountsCreateWalletRequest
 */
export interface WalletsApiPaymentsViewsNinjaAccountsCreateWalletRequest {
    /**
     * 
     * @type {CreateWalletInSchema}
     * @memberof WalletsApiPaymentsViewsNinjaAccountsCreateWallet
     */
    readonly createWalletInSchema: CreateWalletInSchema
}

/**
 * Request parameters for paymentsViewsNinjaAccountsGetWallets operation in WalletsApi.
 * @export
 * @interface WalletsApiPaymentsViewsNinjaAccountsGetWalletsRequest
 */
export interface WalletsApiPaymentsViewsNinjaAccountsGetWalletsRequest {
    /**
     * 
     * @type {number}
     * @memberof WalletsApiPaymentsViewsNinjaAccountsGetWallets
     */
    readonly businessId?: number | null
}

/**
 * WalletsApi - object-oriented interface
 * @export
 * @class WalletsApi
 * @extends {BaseAPI}
 */
export class WalletsApi extends BaseAPI {
    /**
     * 
     * @summary Create Wallet
     * @param {WalletsApiPaymentsViewsNinjaAccountsCreateWalletRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsApi
     */
    public paymentsViewsNinjaAccountsCreateWallet(requestParameters: WalletsApiPaymentsViewsNinjaAccountsCreateWalletRequest, options?: RawAxiosRequestConfig) {
        return WalletsApiFp(this.configuration).paymentsViewsNinjaAccountsCreateWallet(requestParameters.createWalletInSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Wallets
     * @param {WalletsApiPaymentsViewsNinjaAccountsGetWalletsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsApi
     */
    public paymentsViewsNinjaAccountsGetWallets(requestParameters: WalletsApiPaymentsViewsNinjaAccountsGetWalletsRequest = {}, options?: RawAxiosRequestConfig) {
        return WalletsApiFp(this.configuration).paymentsViewsNinjaAccountsGetWallets(requestParameters.businessId, options).then((request) => request(this.axios, this.basePath));
    }
}



